webpackJsonp([0],{

/***/ "+1/X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_share_url_service__ = __webpack_require__("yUUB");


var state = {
  turnPotSize: 100,
  turnBetSize: 100,
  numberOfOuts: 0,
  percentageOfPotWonOnRiverWhenYouHitAnOut: 50,
  numRiverCardsYoullBluff: 0,
  riverBluffSize: 100,
  probabilityOfGettingFoldOnRiver: 60,
  position: 'in position',
  probabilityThatOpponentBetsWhenYouCheck: 50,
  checkCall: false,
  opponentsTurnBetSize: 100,
  percentageOfPotWonAfterCheckCall: 50,
  percentageOfPotWonAfterTurnChecksThrough: 50
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_0__services_share_url_service__["a" /* default */].setBreakevenPercentageForBluffingTheTurnStoreState(stateFromServer, state);
  },

  setTurnPotSize: function setTurnPotSize(state, turnPotSize) {
    state.turnPotSize = turnPotSize;
  },
  setTurnBetSize: function setTurnBetSize(state, turnBetSize) {
    state.turnBetSize = turnBetSize;
  },
  setNumberOfOuts: function setNumberOfOuts(state, numberOfOuts) {
    state.numberOfOuts = numberOfOuts;
  },
  setPercentageOfPotWonOnRiverWhenYouHitAnOut: function setPercentageOfPotWonOnRiverWhenYouHitAnOut(state, percentageOfPotWonOnRiverWhenYouHitAnOut) {
    state.percentageOfPotWonOnRiverWhenYouHitAnOut = percentageOfPotWonOnRiverWhenYouHitAnOut;
  },
  setNumRiverCardsYoullBluff: function setNumRiverCardsYoullBluff(state, numRiverCardsYoullBluff) {
    state.numRiverCardsYoullBluff = numRiverCardsYoullBluff;
  },
  setRiverBluffSize: function setRiverBluffSize(state, riverBluffSize) {
    state.riverBluffSize = riverBluffSize;
  },
  setProbabilityOfGettingFoldOnRiver: function setProbabilityOfGettingFoldOnRiver(state, probabilityOfGettingFoldOnRiver) {
    state.probabilityOfGettingFoldOnRiver = probabilityOfGettingFoldOnRiver;
  },
  setPosition: function setPosition(state, position) {
    state.position = position;
  },
  setProbabilityThatOpponentBetsWhenYouCheck: function setProbabilityThatOpponentBetsWhenYouCheck(state, probabilityThatOpponentBetsWhenYouCheck) {
    state.probabilityThatOpponentBetsWhenYouCheck = probabilityThatOpponentBetsWhenYouCheck;
  },
  setCheckCall: function setCheckCall(state, checkCall) {
    state.checkCall = checkCall;
  },
  setOpponentsTurnBetSize: function setOpponentsTurnBetSize(state, opponentsTurnBetSize) {
    state.opponentsTurnBetSize = opponentsTurnBetSize;
  },
  setPercentageOfPotWonAfterCheckCall: function setPercentageOfPotWonAfterCheckCall(state, percentageOfPotWonAfterCheckCall) {
    state.percentageOfPotWonAfterCheckCall = percentageOfPotWonAfterCheckCall;
  },
  setPercentageOfPotWonAfterTurnChecksThrough: function setPercentageOfPotWonAfterTurnChecksThrough(state, percentageOfPotWonAfterTurnChecksThrough) {
    state.percentageOfPotWonAfterTurnChecksThrough = percentageOfPotWonAfterTurnChecksThrough;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations
});



/***/ }),

/***/ "+3eH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+5ZU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Czk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+D9E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+Gii":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_five_card_hands_section_vue__ = __webpack_require__("2t51");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae2df88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_five_card_hands_section_vue__ = __webpack_require__("pbkT");
function injectStyle (ssrContext) {
  __webpack_require__("bRpf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ae2df88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_five_card_hands_section_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae2df88_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_five_card_hands_section_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+UiU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+c+z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+doo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+rnN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bluff_size_selector_vue__ = __webpack_require__("8p/r");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26c15fb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bluff_size_selector_vue__ = __webpack_require__("n+VG");
function injectStyle (ssrContext) {
  __webpack_require__("cRPJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26c15fb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bluff_size_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26c15fb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bluff_size_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+uKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('errors-alert',{attrs:{"errors":_vm.errorsFromBackend},on:{"clear":function($event){return _vm.clearAlert()}}}),_vm._v(" "),(_vm.keepMeSignedIn && _vm.isSafari)?_c('section',{staticClass:"alert alert-info"},[_vm._v("\n    You are using Safari. If you want to remain logged in after closing the tab, you'll have to enable cross-site tracking: Safari > Preferences > Privacy > Website tracking.\n  ")]):_vm._e(),_vm._v(" "),(_vm.previousSignInType)?_c('section',{staticClass:"alert alert-info"},[_vm._v("\n    Last time you were here you used "),_c('strong',[_vm._v(_vm._s(_vm.previousSignInType))]),_vm._v(" to sign in"),(_vm.previousSignInType === 'email')?_c('span',[_vm._v(" (as opposed to google, twitter or linkedin)")]):_vm._e(),_vm._v(".\n  ")]):_vm._e(),_vm._v(" "),_c('form',[_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n        Email\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control input-lg",attrs:{"type":"email","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})])]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n        Password\n        "),((_vm.passwordFieldType)==='checkbox')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-lg",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.password)?_vm._i(_vm.password,null)>-1:(_vm.password)},on:{"change":function($event){var $$a=_vm.password,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.password=$$a.concat([$$v]))}else{$$i>-1&&(_vm.password=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.password=$$c}}}}):((_vm.passwordFieldType)==='radio')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-lg",attrs:{"type":"radio"},domProps:{"checked":_vm._q(_vm.password,null)},on:{"change":function($event){_vm.password=null}}}):_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-lg",attrs:{"type":_vm.passwordFieldType},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('span',{staticClass:"help-block"},[(_vm.daysSincePasswordChange)?_c('p',[_vm._v(_vm._s(_vm.daysSincePasswordChangeText))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showPassword),expression:"showPassword"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showPassword)?_vm._i(_vm.showPassword,null)>-1:(_vm.showPassword)},on:{"change":function($event){var $$a=_vm.showPassword,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showPassword=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showPassword=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showPassword=$$c}}}}),_vm._v(" Show password\n          ")])])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"disabled":_vm.signingIn},on:{"click":function($event){$event.preventDefault();return _vm.submit()}}},[_vm._v("\n      "+_vm._s(_vm.signInText)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.keepMeSignedIn),expression:"keepMeSignedIn"}],staticClass:"keep-me-signed-in",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.keepMeSignedIn)?_vm._i(_vm.keepMeSignedIn,null)>-1:(_vm.keepMeSignedIn)},on:{"change":function($event){var $$a=_vm.keepMeSignedIn,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.keepMeSignedIn=$$a.concat([$$v]))}else{$$i>-1&&(_vm.keepMeSignedIn=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.keepMeSignedIn=$$c}}}}),_vm._v(" Keep me signed in on this computer\n      ")])])]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/forgot-password"}},[_vm._v("Forgot your password?")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-social btn-google btn-lg btn-block",attrs:{"href":_vm.googleSignInUrl,"disabled":_vm.signingIn}},[_c('i',{staticClass:"fab fa-google"}),_vm._v("\n      Sign in with Google\n    ")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-social btn-twitter btn-lg btn-block",attrs:{"href":_vm.twitterSignInUrl,"disabled":_vm.signingIn}},[_c('i',{staticClass:"fab fa-twitter"}),_vm._v("\n      Sign in with Twitter\n    ")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-social btn-linkedin btn-lg btn-block",attrs:{"href":_vm.linkedinSignInUrl,"disabled":_vm.signingIn}},[_c('i',{staticClass:"fab fa-linkedin"}),_vm._v("\n      Sign in with LinkedIn\n    ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Don't have an account? "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("Register here")]),_vm._v(".")],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Sign In")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+uV/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hit_calculator_help_vue__ = __webpack_require__("N8VK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141dda55_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hit_calculator_help_vue__ = __webpack_require__("m5V8");
function injectStyle (ssrContext) {
  __webpack_require__("DGRh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-141dda55"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hit_calculator_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_141dda55_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hit_calculator_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+usQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "//i3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"num-opponents-selector"},[_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.numOpponents === 1 || !_vm.authorized},on:{"click":function($event){return _vm.$emit('removeOpponent')}}},[_vm._v("\n    -\n  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.numOpponents))]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.numOpponents === 9 || !_vm.authorized},on:{"click":function($event){return _vm.$emit('addOpponent')}}},[_vm._v("\n    +\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/1uN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insights_vue__ = __webpack_require__("2qDg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ac4864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insights_vue__ = __webpack_require__("n2DV");
function injectStyle (ssrContext) {
  __webpack_require__("shJE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73ac4864"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insights_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73ac4864_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insights_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/3LZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/A07":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/AJA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_preset_community_cards_selector_vue__ = __webpack_require__("XfhI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0be5e332_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_preset_community_cards_selector_vue__ = __webpack_require__("DESx");
function injectStyle (ssrContext) {
  __webpack_require__("RTxP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0be5e332"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_preset_community_cards_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0be5e332_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_preset_community_cards_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/C/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"equity-calculator"},[_c('div',{staticClass:"simulation-progress"}),_vm._v(" "),(!_vm.authorized)?_c('readonly-alert'):_vm._e(),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_c('equity-calculator-controls',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"hasSimulationBeenRun":_vm.state.hasSimulationBeenRun,"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized,"loggedIn":_vm.loggedIn},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"addPlayer":function($event){return _vm.addPlayer()},"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
      method: 'createSharableEquityCalculatorURL',
      state: _vm.state,
    })},"saveScenario":function($event){return _vm.$emit('saveScenario', {
      method: 'createSharableEquityCalculatorURL',
      savedScenarioPropertyName: 'equityCalculator',
      state: _vm.state,
    })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
      method: '_constructEquityCalculatorData',
      state: _vm.state,
    })},"simulate":function($event){return _vm.simulate()}}}),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('div',{key:player.id,class:_vm.columnClass},[_c('hand-range',{ref:'player' + playerIndex,refInFor:true,class:{
          'insights-visible': _vm.insightsVisible,
          'second-player': playerIndex === 1,
          'third-player': playerIndex === 2,
          'two-or-four-players': _vm.state.players.numPlayers === 2 || _vm.state.players.numPlayers === 4,
          'three-five-or-more-players': _vm.state.players.numPlayers === 3 || _vm.state.players.numPlayers >= 5,
        },attrs:{"generalHands":player.states[0].generalHands,"weightToApplyToAddedHands":player.weightToApplyToAddedHands,"combosToAdd":player.combosToAdd,"disableAllButGridSelector":false,"disableAllSelectors":!_vm.authorized,"canBeRemoved":playerIndex > 1},on:{"removePlayer":function($event){return player.handleRemovePlayerEvent('equityCalculator', _vm.$store, playerIndex)},"clearRange":function($event){return player.handleClearPlayerEvent('equityCalculator', _vm.$store, playerIndex, 0)},"addComboToCombosToAdd":function($event){return player.handleAddComboToCombosToAddEvent('equityCalculator', _vm.$store, $event, playerIndex)},"removeComboFromCombosToAdd":function($event){return player.handleRemoveComboFromCombosToAddEvent('equityCalculator', _vm.$store, $event, playerIndex)},"applyExactWeightToGeneralHands":function($event){return player.handleApplyExactWeightToGeneralHandsEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"selectGeneralHand":function($event){return player.handleSelectGeneralHandEvent('equityCalculator', _vm.$store, $event.generalHandString, $event.triggeredByMouseover, playerIndex, 0)},"deselectGeneralHand":function($event){return player.handleDeselectGeneralHandEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"selectGeneralHands":function($event){return player.handleSelectGeneralHandsEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"deselectGeneralHands":function($event){return player.handleDeselectGeneralHandsEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"selectSpecificHand":function($event){return player.handleSelectSpecificHandEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"deselectSpecificHand":function($event){return player.handleDeselectSpecificHandEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"setRangeToMatchGeneralHands":function($event){return player.handleSetRangeToMatchGeneralHandsEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"setRangeToMatchDoubleSlider":function($event){return player.handleSetRangeToMatchDoubleSliderEvent('equityCalculator', _vm.$store, $event, playerIndex, 0, _vm.handRankings)},"setRangeToMatchSpecificHandStrings":function($event){return player.handleSetRangeToMatchSpecificHandStringsEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"applyExactWeightToGeneralHand":function($event){return player.handleApplyExactWeightToGeneralHandEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"setWeightOfSpecificHand":function($event){return player.handleSetWeightOfSpecificHandEvent('equityCalculator', _vm.$store, $event, playerIndex, 0)},"setWeightToApplyToAddedHands":function($event){return player.handleSetWeightToApplyToAddedHandsEvent('equityCalculator', _vm.$store, $event, playerIndex)}}},[_c('equity-results',{attrs:{"slot":"left-header","equity":player.states[0].equity,"equityString":player.states[0].equityString,"winPercentageString":player.states[0].winPercentageString,"tiePercentageString":player.states[0].tiePercentageString,"hasSimulationBeenRun":_vm.state.hasSimulationBeenRun},slot:"left-header"}),_vm._v(" "),(_vm.state.presetCommunityCards.flopSet)?_c('li',{attrs:{"slot":"extra-dropdown-item-1"},on:{"click":function($event){return _vm.expandNarrowRangeModal(playerIndex)}},slot:"extra-dropdown-item-1"},[_c('a',[_vm._v("Narrow range "),_c('span',{staticClass:"glyphicon glyphicon-new-window"})])]):_vm._e()],1)],1)}),0),_vm._v(" "),_c('narrow-range-modal',{staticClass:"narrow-range-modal",on:{"narrowRange":function($event){return _vm.narrowRange($event)}}}),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"equity calculator","urlPath":"equity-calculator"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/HhM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/XeG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/cQn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/isP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-modal',
  props: ['modalLg']
});

/***/ }),

/***/ "/qcN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'five-card-hands-section-header',
  props: ['hitPercentageBeingComputed', 'hitPercentageUpToDate', 'hitPercentage', 'stateName', 'authorized'],
  computed: {
    userDefinedFilters: function userDefinedFilters() {
      return this.$store.state.account.user.settings.hitCalculator.userDefinedFilters;
    },
    street: function street() {
      if (this.stateName === 'afterFlop') {
        return 'flop';
      } else if (this.stateName === 'afterTurn') {
        return 'turn';
      } else if (this.stateName === 'afterRiver') {
        return 'river';
      } else {
        return '';
      }
    }
  }
});

/***/ }),

/***/ "/xcZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "05oy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_range_for_street__ = __webpack_require__("I523");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_help_toggle_help_button__ = __webpack_require__("T8TE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'set-range-step',
  components: {
    'range-for-street': __WEBPACK_IMPORTED_MODULE_0__components_utilities_range_for_street__["a" /* default */],
    'toggle-help-button': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_help_toggle_help_button__["a" /* default */]
  },
  props: ['textForStep', 'player', 'playerIndex', 'playerStateIndex', 'presetCommunityCards', 'presetHoleCards', 'textWhenFiveCardHandPercentagesArentUpToDate', 'storeModuleName', 'authorized'],
  data: function data() {
    return {
      helpAreaVisible: false
    };
  },
  computed: {
    handRankings: function handRankings() {
      return this.$store.getters['account/handRankings'];
    }
  },
  methods: {
    toggleHelp: function toggleHelp() {
      this.helpAreaVisible = !this.helpAreaVisible;
    },
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$refs['player-' + playerIndex + '-0']) {
        this.$refs['player-' + playerIndex + '-0'].resetDoubleSlider();
      }
    }
  }
});

/***/ }),

/***/ "07Up":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_constants__ = __webpack_require__("vjYN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'individual-card-selector',
  props: ['cardString', 'presetCards', 'popoverDirectionClass', 'hideDeselect', 'disabled'],
  computed: {
    cardImageSrc: function cardImageSrc() {
      var src = '/static/cards/';
      var cardRank = this.cardString[0];
      var cardSuit = this.cardString[1];

      if (cardRank === 'a') {
        src += 'ace-of-';
      } else if (cardRank === 'k') {
        src += 'king-of-';
      } else if (cardRank === 'q') {
        src += 'queen-of-';
      } else if (cardRank === 'j') {
        src += 'jack-of-';
      } else if (cardRank === 't') {
        src += 'ten-of-';
      } else if (cardRank === '9') {
        src += 'nine-of-';
      } else if (cardRank === '8') {
        src += 'eight-of-';
      } else if (cardRank === '7') {
        src += 'seven-of-';
      } else if (cardRank === '6') {
        src += 'six-of-';
      } else if (cardRank === '5') {
        src += 'five-of-';
      } else if (cardRank === '4') {
        src += 'four-of-';
      } else if (cardRank === '3') {
        src += 'three-of-';
      } else if (cardRank === '2') {
        src += 'two-of-';
      } else {
        throw new Error('Invalid value for cardRank: ', cardRank);
      }

      if (cardSuit === 'h') {
        src += 'hearts';
      } else if (cardSuit === 'd') {
        src += 'diamonds';
      } else if (cardSuit === 's') {
        src += 'spades';
      } else if (cardSuit === 'c') {
        src += 'clubs';
      } else {
        throw new Error('Invalid value for cardSuit: ', cardSuit);
      }

      src += '.png';
      return src;
    }
  },
  methods: {
    isCardAvailable: function isCardAvailable(cardString) {
      return !this.presetCards.includes(cardString);
    },
    select: function select(cardString, e) {
      this.$emit('select', {
        card: cardString,
        e: e
      });
    },
    selectRandomCard: function selectRandomCard(e) {
      var randomCard = void 0;

      while (!randomCard) {
        randomCard = this._getRandomCard();

        if (!this.isCardAvailable(randomCard)) {
          randomCard = null;
        }
      }

      this.$emit('select', {
        card: randomCard,
        e: e
      });
    },
    _getRandomCard: function _getRandomCard() {
      var rank = _.sample(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks);
      var suit = _.sample(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].suits);

      return rank + suit;
    },
    toggle: function toggle() {
      $(this.$el).find('.dropdown-toggle').dropdown('toggle');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "0D1j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"simulate-button-container",attrs:{"data-title":_vm.tooltipValue,"data-toggle":"tooltip","data-placement":"top"}},[_c('button',{staticClass:"simulate-button btn btn-primary btn-block",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('simulate')}}}),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v("Simulate")]),_vm._v(" "),_c('div',{staticClass:"progress-box"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0Dwz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0Gzd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_equity_calculator_vue__ = __webpack_require__("5mhN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d6548c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_equity_calculator_vue__ = __webpack_require__("AmK+");
function injectStyle (ssrContext) {
  __webpack_require__("SL8U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d6548c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_equity_calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d6548c2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_equity_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0HTX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__ = __webpack_require__("T8TE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-final-conclusion',
  components: {
    'toggle-help-button': __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__["a" /* default */]
  },
  props: ['equity', 'potOdds', 'realOddsLHS', 'breakevenPercentageViaRealOdds'],
  data: function data() {
    return {
      helpAreaVisible: {
        futureStreets: [false, false, false, false, false]
      }
    };
  },
  computed: {
    isCallProfitableBasedOnRealOdds: function isCallProfitableBasedOnRealOdds() {
      return this.equity > this.breakevenPercentageViaRealOdds;
    }
  },
  watch: {
    potOdds: function potOdds(newPotOdds, oldPotOdds) {
      var split = newPotOdds.split(':');
      var lhs = Number(split[0]);
      var rhs = Number(split[1]);

      this.$emit('setRealOddsLHS', lhs / rhs);
    }
  },
  methods: {
    toggleHelp: function toggleHelp(type, index) {
      if (type === 'futureStreets') {
        this.helpAreaVisible.futureStreets[index] = !this.helpAreaVisible.futureStreets[index];
      }

      this.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "0Kpk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_flop_info_helpers__ = __webpack_require__("HdM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_constants__ = __webpack_require__("vjYN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-random-board-selector',
  props: ['presetHoleCards', 'popoverDirectionClass', 'disableTurnAndRiver', 'disabled'],
  methods: {
    setRandomFlop: function setRandomFlop() {
      var boardCards = void 0;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);

        if (!this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) && !__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(boardCards)) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    setRandomTurn: function setRandomTurn() {
      var boardCards = void 0;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
        boardCards.push(this._getRandomCard());

        if (!this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) && !__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(boardCards)) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    setRandomRiver: function setRandomRiver() {
      var boardCards = void 0;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());

        if (!this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) && !__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(boardCards)) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    _getRandomCard: function _getRandomCard() {
      var rank = __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].ranks[_.random(0, 8)]; // because we eliminate 5-2 in short deck
      var suit = __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].suits[_.random(0, 3)];

      return rank + suit;
    },
    // setRandomFlopAccordingToTexture: function (textureType, toneType) {
    //   let texture;
    //   let tone;
    //   let flopCards;
    //
    //   while (true) {
    //     texture = flopInfoHelpers.getSampleTexture(textureType);
    //     tone = flopInfoHelpers.getSampleTone(toneType);
    //     flopCards = [
    //       texture[0] + tone[0],
    //       texture[1] + tone[1],
    //       texture[2] + tone[2],
    //     ];
    //
    //     if (
    //       !this._checkIfTryingToUseAPresetHoleCard(flopCards, this.presetHoleCards) &&
    //       !utilities.general.checkForDuplicates(flopCards)
    //     ) {
    //       break;
    //     }
    //   }
    //
    //   this.$emit('setBoard', flopCards);
    // },
    _checkIfTryingToUseAPresetHoleCard: function _checkIfTryingToUseAPresetHoleCard(boardCards, presetHoleCards) {
      var tryingToUseAPresetHoleCard = false;

      boardCards.forEach(function (flopCard) {
        if (presetHoleCards.includes(flopCard)) {
          tryingToUseAPresetHoleCard = true;
        }
      });

      return tryingToUseAPresetHoleCard;
    }
  }
});

/***/ }),

/***/ "0V+e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'street-selector',
  props: ['street', 'authorized']
});

/***/ }),

/***/ "0VI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"equity-calculator-controls"},[(!_vm.shortDeck)?_c('preset-community-cards-selector',{attrs:{"presetHoleCards":this.presetHoleCards,"presetCommunityCards":_vm.presetCommunityCards,"popoverDirectionClass":'dropdown',"disabled":_vm.disabled},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"setBoard":function($event){return _vm.$emit('setBoard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}}}):(_vm.shortDeck)?_c('short-deck-preset-community-cards-selector',{attrs:{"presetHoleCards":this.presetHoleCards,"presetCommunityCards":_vm.presetCommunityCards,"popoverDirectionClass":'dropdown',"disabled":_vm.disabled},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"setBoard":function($event){return _vm.$emit('setBoard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}}}):_vm._e(),_vm._v(" "),_c('add-player-button',{attrs:{"disabled":_vm.disabled},on:{"addPlayer":function($event){return _vm.$emit('addPlayer')}}}),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":_vm.disabled || !_vm.hasSimulationBeenRun},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl')}}}),_vm._v(" "),_c('simulate-button',{attrs:{"disabled":_vm.disabled},on:{"simulate":function($event){return _vm.$emit('simulate')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0XZA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0pPF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__ = __webpack_require__("Ywgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_five_card_hands_FiveCardHands__ = __webpack_require__("JKDa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-register',
  components: {
    'errors-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__["a" /* default */]
  },
  data: function data() {
    return {
      email: '',
      password: '',
      emailOptIn: false,
      xkcdVisible: false,
      submitAttempted: false,
      errorsFromBackend: [],
      registering: false
    };
  },
  computed: {
    anyErrors: function anyErrors() {
      return !!(this.emailErrorMessage || this.passwordErrorMessage);
    },
    emailErrorMessage: function emailErrorMessage() {
      if (this.email === '') {
        return 'An email is required';
      } else if (!this.emailValid) {
        return 'Invalid email';
      } else {
        return false;
      }
    },
    emailValid: function emailValid() {
      var regex = /\S+@\S+\.\S+/;
      return regex.test(this.email);
    },
    passwordErrorMessage: function passwordErrorMessage() {
      if (this.password === '') {
        return 'A password is required';
      } else if (this.password.length < 8) {
        return 'Must be at least eight characters';
      } else {
        return false;
      }
    },
    googleRegistrationUrl: function googleRegistrationUrl() {
      return "https://oddscalc.sixplusholdem.com/api" + '/user/google';
    },
    twitterRegistrationUrl: function twitterRegistrationUrl() {
      return "https://oddscalc.sixplusholdem.com/api" + '/user/twitter';
    },
    linkedinRegistrationUrl: function linkedinRegistrationUrl() {
      return "https://oddscalc.sixplusholdem.com/api" + '/user/linkedin';
    },
    registerText: function registerText() {
      if (this.registering) {
        return 'Registering...';
      }

      return 'Register';
    },
    defaultIncludedByDefault: function defaultIncludedByDefault() {
      var fiveCardHands = new __WEBPACK_IMPORTED_MODULE_1__services_five_card_hands_FiveCardHands__["a" /* default */]();

      return fiveCardHands.defaultIncludedByDefault;
    },
    defaultCollapsedByDefault: function defaultCollapsedByDefault() {
      var fiveCardHands = new __WEBPACK_IMPORTED_MODULE_1__services_five_card_hands_FiveCardHands__["a" /* default */]();

      return fiveCardHands.defaultCollapsedByDefault;
    }
  },
  methods: {
    registerWithEmail: function registerWithEmail() {
      var self = this;

      if (self.anyErrors) {
        self.submitAttempted = true;
        return;
      }

      self.registering = true;
      self.$http.post("https://oddscalc.sixplusholdem.com/api" + '/user', {
        user: {
          email: self.email,
          password: self.password,
          emailOptIn: self.emailOptIn
        },
        defaultIncludedByDefault: self.defaultIncludedByDefault,
        defaultCollapsedByDefault: self.defaultCollapsedByDefault
      }).then(function (res) {
        self.registering = false;
        self.$store.commit('account/setUser', res.data.user);
        self.$router.push({ path: '/account' });
        alert('Successfully registered!');
      }).catch(function (err) {
        self.registering = false;
        self.errorsFromBackend.splice(0, self.errorsFromBackend.length);
        err.response.data.errors.forEach(function (errorFromBackend) {
          self.errorsFromBackend.push(errorFromBackend);
        });
      });
    },
    clearAlert: function clearAlert() {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    }
  }
});

/***/ }),

/***/ "0pfp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_blog_subscribe_to_blog__ = __webpack_require__("bnhV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog_spaced-repetition-and-poker',
  components: {
    'subscribe-to-blog': __WEBPACK_IMPORTED_MODULE_0__components_blog_subscribe_to_blog__["a" /* default */]
  }
});

/***/ }),

/***/ "0qOH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__ = __webpack_require__("2EOj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_get_draw_info__ = __webpack_require__("l9ti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_set_specific_hand_info__ = __webpack_require__("XL0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);








var SpecificHand = function () {
  function SpecificHand(specificHandString) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SpecificHand);

    this.string = specificHandString;
    this.displayString = specificHandString[0].toUpperCase() + specificHandString[1] + specificHandString[2].toUpperCase() + specificHandString[3];
    this.firstCard = this.string[0] + this.string[1];
    this.secondCard = this.string[2] + this.string[3];
    this.combo = this.string[1] + this.string[3];
    this._weight = 0;
    this._maxPossibleWeight = 100;
    this._manuallySet = null;
    this.generalHand = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SpecificHand, [{
    key: 'availableToSelect',
    value: function availableToSelect(combosToAdd) {
      return this.possible && !this.inRange && this._includedInCombosToAdd(combosToAdd);
    }
  }, {
    key: '_includedInCombosToAdd',
    value: function _includedInCombosToAdd(combosToAdd) {
      return combosToAdd.includes(this.combo);
    }
  }, {
    key: '_includesPresetHoleCard',
    value: function _includesPresetHoleCard(presetHoleCards) {
      return this.__includesCard(presetHoleCards.holeCardOne) || this.__includesCard(presetHoleCards.holeCardTwo);
    }
  }, {
    key: '_includesPresetCommunityCard',
    value: function _includesPresetCommunityCard(presetCommunityCards) {
      return this.__includesCard(presetCommunityCards.flop1) || this.__includesCard(presetCommunityCards.flop2) || this.__includesCard(presetCommunityCards.flop3) || this.__includesCard(presetCommunityCards.turn) || this.__includesCard(presetCommunityCards.river);
    }
  }, {
    key: '__includesCard',
    value: function __includesCard(card) {
      return card === this.firstCard || card === this.secondCard;
    }
  }, {
    key: 'updateManuallySetValue',
    value: function updateManuallySetValue(initialWeight, newWeight, playerState, presetCommunityCards, shortDeck) {
      // for 3bet-cbet explorer
      if (!presetCommunityCards.flopSet) {
        return;
      }

      var passesThroughFiveCardHandFilter = this.passesThroughFiveCardHandFilter(playerState.fiveCardHands.checkedHands, presetCommunityCards.getArrayForState(playerState.name), shortDeck);

      if (initialWeight === 0) {
        if (newWeight > 0) {
          if (passesThroughFiveCardHandFilter) {
            if (this.manuallySet === 'removed') {
              this.manuallySet = false;
            }
          } else if (!passesThroughFiveCardHandFilter) {
            if (this.manuallySet === 'removed' || this.manuallySet === false) {
              this.manuallySet = 'added';
            }
          }
        } else if (newWeight === 0) {
          // don't change this.manuallySet
        }
      } else if (initialWeight > 0) {
        if (newWeight > 0) {
          this.manuallySet = 'added';
        } else if (newWeight === 0) {
          if (passesThroughFiveCardHandFilter) {
            if (this.manuallySet === false || this.manuallySet === 'added') {
              this.manuallySet = 'removed';
            }
          } else if (!passesThroughFiveCardHandFilter) {
            if (this.manuallySet === 'added') {
              this.manuallySet = false;
            }
          }
        }
      }

      /*
       previously not in range
        set to be in range
          passes through five card hand filter
            manually set to be removed --> false
          doesn't pass through five card hand filter
            manually set to be removed --> added
            manually set is false --> added
        set to be not in range
          passes through five card hand filter
            manually set to be removed --> removed
          doesn't pass through five card hand filter
            manually set to be removed --> removed
            manually set is false --> false
      previously in range
        set to be in range
          passes through five card hand filter
            manually set is false --> added
            manually set is added --> added
          doesn't pass through five card hand filter
            manually set is added --> added
        set to be not in range
          passes through five card hand filter
            manually set is false --> removed
            manually set is added --> removed
          doesn't pass through five card hand filter
            manually set is added --> false
       */
    }
  }, {
    key: 'passesThroughFiveCardHandFilter',
    value: function passesThroughFiveCardHandFilter(checkedHands, presetCommunityCardsArray, shortDeck) {
      var holeCards = void 0;
      var handInfo = void 0;
      var drawInfo = void 0;

      if (!this.possible) {
        throw new Error('Trying check if a specific hand that isn\'t possible passes through a filter.');
      }

      holeCards = [this.firstCard, this.secondCard];

      if (shortDeck) {
        handInfo = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].runForShortDeck(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.union(holeCards, presetCommunityCardsArray));
        __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, presetCommunityCardsArray, true);
        drawInfo = __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_get_draw_info__["a" /* default */].run(holeCards, presetCommunityCardsArray, handInfo, true, true);
      } else {
        handInfo = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].run(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.union(holeCards, presetCommunityCardsArray));
        __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, presetCommunityCardsArray);
        drawInfo = __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_get_draw_info__["a" /* default */].run(holeCards, presetCommunityCardsArray, handInfo, true);
      }

      return __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].results.isHandInCheckedHands(handInfo, drawInfo, checkedHands);
    }
  }, {
    key: 'getWeightOfPassageThroughFiveCardHandFilters',
    value: function getWeightOfPassageThroughFiveCardHandFilters(playerState, presetCommunityCards, shortDeck) {
      var holeCards = void 0;
      var handInfo = void 0;
      var drawInfo = void 0;
      var presetCommunityCardsArray = void 0;

      if (!this.possible) {
        throw new Error('Trying to get the weight of passage through filter on a specific hand that isn\'t possible.');
      }

      if (playerState.name === 'afterFlop' && !presetCommunityCards.flopSet) {
        return 0;
      } else if (playerState.name === 'afterTurn' && !presetCommunityCards.turnSet) {
        return 0;
      } else if (playerState.name === 'afterRiver' && !presetCommunityCards.riverSet) {
        return 0;
      }

      holeCards = [this.firstCard, this.secondCard];
      presetCommunityCardsArray = presetCommunityCards.getArrayForState(playerState.name);

      if (shortDeck) {
        handInfo = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].runForShortDeck(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.union(holeCards, presetCommunityCardsArray));
        __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, presetCommunityCardsArray, true);
      } else {
        handInfo = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].run(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.union(holeCards, presetCommunityCardsArray));
        __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, presetCommunityCardsArray);
      }

      if (!playerState.fiveCardHands.anyCheckedDraws && !playerState.fiveCardHands.anyCheckedCombos) {
        return __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].results.getWeightOfLargestMatchingFiveCardHand(handInfo, null, playerState.fiveCardHands.checkedMadeHands);
      } else {
        drawInfo = __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_get_draw_info__["a" /* default */].run(holeCards, presetCommunityCardsArray, handInfo, true, shortDeck);

        return __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].results.getWeightOfLargestMatchingFiveCardHand(handInfo, drawInfo, playerState.fiveCardHands.checkedHands);
      }
    }
  }, {
    key: 'getWeightToApply',
    value: function getWeightToApply(playerState, presetCommunityCards, weightOfPreviousStatesSpecificHand, shortDeck) {
      if (!this.possible) {
        return 0;
      }

      if (typeof this.weightOfPassageThroughManuallySetFilter === 'number') {
        return this.weightOfPassageThroughManuallySetFilter;
      }

      var weightOfPassageThroughFiveCardHandFilters = this.getWeightOfPassageThroughFiveCardHandFilters(playerState, presetCommunityCards, shortDeck);

      return (weightOfPreviousStatesSpecificHand * (weightOfPassageThroughFiveCardHandFilters / 100)).roundToNearestFive();
    }
  }, {
    key: 'matchesFiveCardHand',
    value: function matchesFiveCardHand(fiveCardHand, presetCommunityCardsArray, shortDeck) {
      var holeCards = void 0;
      var handInfo = void 0;
      var drawInfo = void 0;

      if (!this.possible) {
        return false;
      }

      holeCards = [this.firstCard, this.secondCard];

      if (shortDeck) {
        handInfo = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].runForShortDeck(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.union(holeCards, presetCommunityCardsArray));
        __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, presetCommunityCardsArray, true);
        drawInfo = __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_get_draw_info__["a" /* default */].run(holeCards, presetCommunityCardsArray, handInfo, true, true);
      } else {
        handInfo = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].run(__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.union(holeCards, presetCommunityCardsArray));
        __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, presetCommunityCardsArray);
        drawInfo = __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_get_draw_info__["a" /* default */].run(holeCards, presetCommunityCardsArray, handInfo, true);
      }

      return fiveCardHand.isAHit(handInfo, drawInfo);
    }
  }, {
    key: 'clearManuallySetIfPassesThroughFilter',
    value: function clearManuallySetIfPassesThroughFilter(fiveCardHand, presetCommunityCardsArray, shortDeck) {
      if (this.matchesFiveCardHand(fiveCardHand, presetCommunityCardsArray, shortDeck)) {
        this.manuallySet = false;
      }
    }
  }, {
    key: 'possible',
    get: function get() {
      return this.maxPossibleWeight > 0;
    }
  }, {
    key: 'inRange',
    get: function get() {
      if (!this.possible) {
        throw new Error('Trying to check if a specific hand that isn\'t possible is in range.');
      }

      return this.weight > 0;
    }
  }, {
    key: 'weight',
    get: function get() {
      return this._weight;
    },
    set: function set(newWeight) {
      if (typeof newWeight !== 'number' && newWeight !== null) {
        throw new Error('Invalid value for newWeight.');
      }

      if (typeof newWeight === 'number') {
        if (newWeight < 0 || newWeight > 100 || newWeight % 5 !== 0) {
          throw new Error('Invalid value for newWeight.');
        }
      }

      if (newWeight > this.maxPossibleWeight) {
        throw new Error('Trying to set a weight that is greater than the max possible weight.');
      }

      this._weight = newWeight;
    }
  }, {
    key: 'maxPossibleWeight',
    get: function get() {
      return this._maxPossibleWeight;
    },
    set: function set(newMaxPossibleWeight) {
      if (typeof newMaxPossibleWeight !== 'number' || newMaxPossibleWeight < 0 || newMaxPossibleWeight > 100 || newMaxPossibleWeight % 5 !== 0) {
        throw new Error('Invalid value for newMaxPossibleWeight.');
      }

      this._maxPossibleWeight = newMaxPossibleWeight;
    }
  }, {
    key: 'manuallySet',
    get: function get() {
      return this._manuallySet;
    },
    set: function set(value) {
      if (value !== 'added' && value !== 'removed' && value !== false) {
        throw new Error('manuallySet needs to have a value of added, removed or false.');
      }

      if (value === 'added' && !this.inRange) {
        throw new Error('Can\'t set manuallySet to added for a specific hand that isn\'t in range.');
      }

      if (value === 'removed' && this.inRange) {
        throw new Error('Can\'t set manuallySet to removed for a specific hand that is in range.');
      }

      this._manuallySet = value;
    }
  }, {
    key: 'manuallyAdded',
    get: function get() {
      return this.possible && this.inRange && this.manuallySet;
    }
  }, {
    key: 'manuallyRemoved',
    get: function get() {
      return this.possible && !this.inRange && this.manuallySet;
    }
  }, {
    key: 'firstRank',
    get: function get() {
      return this.string[0];
    }
  }, {
    key: 'secondRank',
    get: function get() {
      return this.string[2];
    }
  }, {
    key: 'hasFiveFourThreeOrTwo',
    get: function get() {
      return ['5', '4', '3', '2'].includes(this.firstRank) || ['5', '4', '3', '2'].includes(this.secondRank);
    }
  }, {
    key: 'weightOfPassageThroughManuallySetFilter',
    get: function get() {
      if (this.manuallySet === 'added' || this.manuallySet === 'removed') {
        return this.weight;
      }

      return null;
    }
  }]);

  return SpecificHand;
}();

/* harmony default export */ __webpack_exports__["a"] = (SpecificHand);
;

/***/ }),

/***/ "1AmU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Cc/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-future-streets-help-section-2'
});

/***/ }),

/***/ "1Cqg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h4',[_vm._v("\n    Step "+_vm._s(_vm.step)+": What pot odds do you have facing the "+_vm._s(_vm.streetToCall)+" bet?\n    "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible},on:{"toggleHelp":function($event){return _vm.toggleHelp()}}})],1),_vm._v(" "),(_vm.helpAreaVisible)?_c('div',{staticClass:"well help-section"},[_c('h3',[_vm._v("What are pot odds?")]),_vm._v(" "),_c('p',[_vm._v("The ratio of the pot size to the size of the bet you need to call.")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h3',[_vm._v("But what about when the numbers aren't clean like they are in your example?")]),_vm._v(" "),_c('p',[_vm._v("You estimate.")]),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.potOdds === '4:1'},on:{"change":function($event){return _vm.$emit('setPotOdds', '4:1')}}}),_vm._v("\n      4:1\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.potOdds === '3:1'},on:{"change":function($event){return _vm.$emit('setPotOdds', '3:1')}}}),_vm._v("\n      3:1\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.potOdds === '2:1'},on:{"change":function($event){return _vm.$emit('setPotOdds', '2:1')}}}),_vm._v("\n      2:1\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.potOdds === '3:2'},on:{"change":function($event){return _vm.$emit('setPotOdds', '3:2')}}}),_vm._v("\n      3:2\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.potOdds === '1:1'},on:{"change":function($event){return _vm.$emit('setPotOdds', '1:1')}}}),_vm._v("\n      1:1\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":!['4:1', '3:1', '2:1', '3:2', '1:1'].includes(_vm.potOdds)},on:{"input":function($event){return _vm.$emit('setPotOdds', _vm.customPotOddsLHS + ':1')}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customPotOddsLHS),expression:"customPotOddsLHS"}],attrs:{"type":"number","disabled":!_vm.authorized,"min":"1","step":"0.1"},domProps:{"value":(_vm.customPotOddsLHS)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customPotOddsLHS=$event.target.value},function($event){return _vm.$emit('setPotOdds', _vm.customPotOddsLHS + ':1')}]}}),_vm._v("-to-1\n    ")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("For example, suppose the pot is $10 and your opponent bets $10. Now the pot is $20 and you need to call $10. So the ratio is "),_c('code',[_vm._v("20:10")]),_vm._v(", or "),_c('code',[_vm._v("2:1")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If the pot is $18 and you need to call $10, round up to "),_c('code',[_vm._v("2:1")]),_vm._v(". If it's $12, round down to "),_c('code',[_vm._v("1:1")]),_vm._v(". Exact numbers would be nice, but it's impractical to figure them out when you're at the tables.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1MGM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1U/Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"result-grid panel panel-default"},[_c('section',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_c('span',{staticClass:"required-equity"},[_vm._v("Required equity:")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","max":"100","min":"1"},domProps:{"value":_vm.requiredEquity},on:{"input":function($event){return _vm.setRequiredEquityAfterManuallyChanged($event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])]),_vm._v(" "),_c('span',{staticClass:"pot-odds"},[_vm._v("\n        Pot odds:\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.potOddsLHS),expression:"potOddsLHS"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.potOddsLHS)},on:{"input":function($event){if($event.target.composing){ return; }_vm.potOddsLHS=$event.target.value}}}),_vm._v("\n        -to-\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.potOddsRHS),expression:"potOddsRHS"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.potOddsRHS)},on:{"input":function($event){if($event.target.composing){ return; }_vm.potOddsRHS=$event.target.value}}})])])]),_vm._v(" "),_c('section',{staticClass:"panel-body"},[_c('div',{staticClass:"flexbox-container"},[_c('grid-selector',{attrs:{"generalHands":_vm.generalHands,"equityMatrix":true,"requiredEquity":_vm.requiredEquity,"specificHandsNotAllowed":true}}),_vm._v(" "),_c('result-table',{attrs:{"generalHands":_vm.generalHands}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1W+u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  checkForDuplicates: function checkForDuplicates(array) {
    // https://stackoverflow.com/a/28461122/1927876
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.uniq(array).length !== array.length;
  },
  getHoleCardsArrayFromObj: function getHoleCardsArrayFromObj(obj) {
    var arr = [];

    if (obj.holeCardOne) {
      arr.push(obj.holeCardOne);
    }

    if (obj.holeCardTwo) {
      arr.push(obj.holeCardTwo);
    }

    return arr;
  },
  getBoardCardsArrayFromObj: function getBoardCardsArrayFromObj(obj) {
    var arr = [];

    if (obj.flop1) {
      arr.push(obj.flop1);
    }

    if (obj.flop2) {
      arr.push(obj.flop2);
    }

    if (obj.flop3) {
      arr.push(obj.flop3);
    }

    if (obj.turn) {
      arr.push(obj.turn);
    }

    if (obj.river) {
      arr.push(obj.river);
    }

    return arr;
  },
  includes: function includes(arr, predicate) {
    for (var i = 0; i < arr.length; i++) {
      if (predicate(arr[i])) {
        return true;
      }
    }

    return false;
  },
  getArrayItemFromArrayOfIndexes: function getArrayItemFromArrayOfIndexes(fullArray, arrayOfIndexes) {
    var curr = fullArray[arrayOfIndexes[0]];

    for (var i = 1; i < arrayOfIndexes.length; i++) {
      curr = curr.children[arrayOfIndexes[i]];
    }

    return curr;
  },
  getArrayFromNextToLastArrayIndex: function getArrayFromNextToLastArrayIndex(fullArray, arrayOfIndexes) {
    var curr = fullArray;

    for (var i = 0; i < arrayOfIndexes.length - 1; i++) {
      curr = curr[arrayOfIndexes[i]].children;
    }

    return curr;
  },
  forEachLeaf: function forEachLeaf(arr, callback) {
    var indexesList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    arr.forEach(function (el, i) {
      var newIndexesList = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(indexesList);
      newIndexesList.push(i);

      if (!el.children) {
        callback(el, newIndexesList);
      } else {
        this.forEachLeaf(el.children, callback, newIndexesList);
      }
    }, this);
  },
  forEachParent: function forEachParent(arr, callback) {
    var indexesList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    arr.forEach(function (el, i) {
      var newIndexesList = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(indexesList);
      newIndexesList.push(i);

      if (el.children) {
        this.forEachParent(el.children, callback, newIndexesList);
        callback(el, newIndexesList);
      }
    }, this);
  },
  forEachNode: function forEachNode(arr, callback) {
    var indexesList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    arr.forEach(function (el, i) {
      var newIndexesList = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(indexesList);
      newIndexesList.push(i);
      callback(el, newIndexesList);

      if (el.children) {
        this.forEachNode(el.children, callback, newIndexesList);
      }
    }, this);
  },
  getHTMLForSuitIcons: function getHTMLForSuitIcons(suits) {
    if (suits === 'hh') {
      return '<span style="color: red;">&hearts;&hearts;</span>';
    } else if (suits === 'dd') {
      return '<span style="color: red;">&diams;&diams;</span>';
    } else if (suits === 'ss') {
      return '<span>&spades;&spades;</span>';
    } else if (suits === 'cc') {
      return '<span>&clubs;&clubs;</span>';
    }

    // offsuit + pairs
    else if (suits === 'hd') {
        return '<span style="color: red;">&hearts;</span><span style="color: red;">&diams;</span>';
      } else if (suits === 'hs') {
        return '<span style="color: red;">&hearts;</span>&spades;';
      } else if (suits === 'hc') {
        return '<span style="color: red;">&hearts;</span>&clubs;';
      } else if (suits === 'dh') {
        return '<span style="color: red;">&diams;</span><span style="color: red;">&hearts;</span>';
      } else if (suits === 'ds') {
        return '<span style="color: red;">&diams;</span>&spades;';
      } else if (suits === 'dc') {
        return '<span style="color: red;">&diams;</span>&clubs;';
      } else if (suits === 'sh') {
        return '&spades;<span style="color: red;">&hearts;</span>';
      } else if (suits === 'sd') {
        return '&spades;<span style="color: red;">&diams;</span>';
      } else if (suits === 'sc') {
        return '&spades;&clubs;';
      } else if (suits === 'ch') {
        return '&clubs;<span style="color: red;">&hearts;</span>';
      } else if (suits === 'cd') {
        return '&clubs;<span style="color: red;">&diams;</span>';
      } else if (suits === 'cs') {
        return '&clubs;&spades;';
      } else {
        throw new Error('Invalid value of suits.');
      }
  },
  doArraysContainSameElements: function doArraysContainSameElements(array1, array2) {
    return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.isEmpty(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.xor(array1, array2));
  },
  getPlayerStateIndexFromStreet: function getPlayerStateIndexFromStreet(street) {
    if (street === 'flop') {
      return 1;
    } else if (street === 'turn') {
      return 2;
    } else if (street === 'river') {
      return 3;
    }
  },
  getDaysBetweenDates: function getDaysBetweenDates(startDate, endDate) {
    var millisecondsPerDay = 24 * 60 * 60 * 1000;

    return (this._treatDateAsUTC(endDate) - this._treatDateAsUTC(startDate)) / millisecondsPerDay;
  },
  _treatDateAsUTC: function _treatDateAsUTC(date) {
    var result = new Date(date);

    result.setMinutes(result.getMinutes() - result.getTimezoneOffset());

    return result;
  },
  handleNetworkError: function handleNetworkError(e) {
    var error = e && e.response && e.response.data && e.response.data.err ? e.response.data.err : 'Unknown error. Email contact@sixplusholdem.com for help.';

    alert(error);
  }
});

/***/ }),

/***/ "1WQg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"fold-equity-table well"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("The immediately profitable breakeven percentage for a "+_vm._s(_vm.state.bluffSize)+" pot bluff is "),_c('strong',[_vm._v(_vm._s(_vm.immediatelyProfitableBreakevenPercentage)+"%")]),_vm._v(". However, you probably don't need the full "+_vm._s(_vm.immediatelyProfitableBreakevenPercentage)+"%. You can drop it down by about 5-15% or so depending on things like how many outs you have ("),_c('a',{attrs:{"href":"#should-you-bluff-final-conclusion"}},[_vm._v("see further down")]),_vm._v("). What breakeven percentage do you want to use?")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n      True breakeven percentage:\n      "),_c('input',{staticClass:"form-control input-lg",attrs:{"type":"number","min":"1","max":_vm.immediatelyProfitableBreakevenPercentage},domProps:{"value":_vm.state.profitableBreakevenPercentage},on:{"input":function($event){return _vm.$emit('setProfitableBreakevenPercentage', $event.target.valueAsNumber)}}})])]),_vm._v(" "),(_vm.cutoffHand)?_c('p',[_vm._v("The \"flipping point\" occurs with "),_c('strong',[_vm._v(_vm._s(_vm.cutoffHand.inlineText))]),_vm._v(". If you think that you can get folds from "+_vm._s(_vm.cutoffHand.inlineText)+" and worse, your bluff will be profitable. If you don't, your bluff won't be profitable.")]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-striped"},[_vm._m(1),_vm._v(" "),(_vm.tableExpanded)?_c('tbody',_vm._l((_vm.foldEquityAgainstDifferentRanges),function(ref){
var rangeTheyreFolding = ref.rangeTheyreFolding;
var foldEquity = ref.foldEquity;
var diff = ref.diff;
return _c('tr',[_c('td',[_vm._v(_vm._s(rangeTheyreFolding))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(foldEquity)+"%")]),_vm._v(" "),_c('td',{class:_vm.getDiffClass(diff)},[_vm._v(_vm._s(diff)+"%")])])}),0):_c('tbody',_vm._l((_vm.condensedFoldEquityAgainstDifferentRanges),function(ref){
var rangeTheyreFolding = ref.rangeTheyreFolding;
var foldEquity = ref.foldEquity;
var diff = ref.diff;
return _c('tr',[_c('td',[_vm._v(_vm._s(rangeTheyreFolding))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(foldEquity)+"%")]),_vm._v(" "),_c('td',{class:_vm.getDiffClass(diff)},[_vm._v(_vm._s(diff)+"%")])])}),0)]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){_vm.tableExpanded = !_vm.tableExpanded}}},[(_vm.tableExpanded)?_c('span',[_vm._v("Collapse "),_c('span',{staticClass:"glyphicon glyphicon-minus"})]):_c('span',[_vm._v("Expand "),_c('span',{staticClass:"glyphicon glyphicon-plus"})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Fold equity vs. various ranges")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Range they're folding")]),_vm._v(" "),_c('th',[_vm._v("Fold equity")]),_vm._v(" "),_c('th',[_vm._v("Required fold equity - fold equity")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1XY+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__ = __webpack_require__("RBWx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'turn-selector',
  components: {
    'individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__["a" /* default */]
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'turn') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function _toggleNextDropdown(previousPosition) {
      var nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function __getNextPosition(previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else if (previousPosition === 'flop3') {
        return 'turn';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    }
  }
});

/***/ }),

/***/ "1aQk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_five_card_hands_section_five_card_hand_bar__ = __webpack_require__("sNuG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_five_card_hand_weight_modal__ = __webpack_require__("AUOD");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'five-card-hands-for-category',
  components: {
    'five-card-hand-bar': __WEBPACK_IMPORTED_MODULE_0__components_five_card_hands_section_five_card_hand_bar__["a" /* default */],
    'five-card-hand-weight-modal': __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_five_card_hand_weight_modal__["a" /* default */]
  },
  props: ['type', 'playerState', 'percentagesOrCombos', 'hideRightContainer', 'shortDeck', 'authorized'],
  data: function data() {
    return {
      fiveCardHandThatTriggeredTheFiveCardHandWeightModal: null,
      random: Math.random()
    };
  },
  computed: {
    visibleFiveCardHands: function visibleFiveCardHands() {
      if (this.type === 'made-hands') {
        if (this.shortDeck) {
          return this.playerState.fiveCardHands.shortDeckVisibleMadeHands;
        } else {
          return this.playerState.fiveCardHands.visibleMadeHands;
        }
      } else if (this.type === 'draws') {
        return this.playerState.fiveCardHands.visibleDraws;
      } else if (this.type === 'combos') {
        return this.playerState.fiveCardHands.visibleCombos;
      }
    }
  },
  methods: {
    getFiveCardHandText: function getFiveCardHandText(fiveCardHand) {
      // fiveCardHand.text + ': <small><em>(' + fiveCardHand.weight + '%)</em></small>

      if (fiveCardHand.hasExplicitWeight) {
        return fiveCardHand.text + ' <small title="Weight" style="color: gray;"><em>(' + fiveCardHand.weight + '%):</em></small>';
      }

      return fiveCardHand.text + ':';
    },
    expandFiveCardHandWeightModal: function expandFiveCardHandWeightModal(fiveCardHand) {
      if (!this.authorized) {
        return;
      }

      this.fiveCardHandThatTriggeredTheFiveCardHandWeightModal = fiveCardHand;
      $(this.$el).find('.five-card-hand-weight-modal').modal();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "1cU7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1e3e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-bluff-preflop-steps"},_vm._l((_vm.players._players),function(player,playerIndex){return _c('set-range-step',{key:player.id,ref:'setRangeStep-' + playerIndex,refInFor:true,attrs:{"textForStep":_vm.getTextForPlayerRangeStep(playerIndex),"player":player,"playerIndex":playerIndex,"playerStateIndex":0,"presetCommunityCards":_vm.presetCommunityCards,"storeModuleName":'guidedAnalysesBluffing',"authorized":_vm.authorized}},[_c('range-help-section',{attrs:{"slot":"rangeHelpSection","playerStateIndex":0,"streetToBluff":_vm.streetToBluff},slot:"rangeHelpSection"})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1niS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'set-weight-to-apply-to-added-hands-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */],
    'vue-slider': __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },
  props: ['weightToApplyToAddedHands'],
  data: function data() {
    return {
      sliderOptions: {
        min: 5,
        interval: 5
      },
      weightToApplyToAddedHandsVModel: 100
    };
  },
  mounted: function mounted() {
    var self = this;

    $(this.$el).on('shown.bs.modal', function () {
      self.weightToApplyToAddedHandsVModel = self.weightToApplyToAddedHands;
      self.$nextTick(function () {
        if (self.$refs.slider) {
          self.$refs.slider.refresh();
        }
      });
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "1q6q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grid-square-suits',
  props: ['generalHand'],
  computed: {
    suitsOfSpecificHandInRange: function suitsOfSpecificHandInRange() {
      var suitsOfSpecificHandInRange = null;

      this.generalHand.forEachPossibleSpecificHand(function (specificHand, specificHandSuits) {
        if (specificHand.inRange) {
          suitsOfSpecificHandInRange = specificHandSuits;
        }
      });

      return suitsOfSpecificHandInRange;
    },
    firstSuitOfSpecificHandInRange: function firstSuitOfSpecificHandInRange() {
      if (this.suitsOfSpecificHandInRange) {
        return this.suitsOfSpecificHandInRange[0];
      }

      return null;
    },
    secondSuitOfSpecificHandInRange: function secondSuitOfSpecificHandInRange() {
      if (this.suitsOfSpecificHandInRange) {
        return this.suitsOfSpecificHandInRange[1];
      }

      return null;
    },
    numSpecificHandsInRangeVisbile: function numSpecificHandsInRangeVisbile() {
      return this.$store.state.account.user.settings.general.visual.areNumCombosInRangeVisible === true;
    }
  }
});

/***/ }),

/***/ "1uLK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-settings'
});

/***/ }),

/***/ "245k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'saved-scenarios-for-tool',
  props: ['savedScenarios', 'tool'],
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */]
  },
  data: function data() {
    return {
      indexForEditNameModal: 0,
      newName: ''
    };
  },
  methods: {
    expandEditNameModal: function expandEditNameModal(index) {
      this.indexForEditNameModal = index;
      this.newName = this.savedScenarios[this.tool][index].title;
      $(this.$el).find('.edit-name-modal').modal();
    },
    collapseEditNameModal: function collapseEditNameModal() {
      $(this.$el).find('.edit-name-modal').modal('hide');
    },
    updateName: function updateName() {
      var self = this;
      var user = _.cloneDeep(self.$store.state.account.user);
      var newSavedScenarios = _.cloneDeep(self.$store.state.account.user.savedScenarios);

      newSavedScenarios[self.tool][self.indexForEditNameModal].title = self.newName;
      user.savedScenarios = newSavedScenarios;

      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', {
        user: user
      }).then(function (res) {
        self.newName = '';
        self.$store.commit('account/setUser', res.data.user);
        self.collapseEditNameModal();
      }).catch(function (err) {
        alert('Problem trying to move the scenario.');
      });
    },
    deleteScenario: function deleteScenario(index) {
      var self = this;
      var user = _.cloneDeep(self.$store.state.account.user);
      var newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios[this.tool].splice(index, 1);
      user.savedScenarios = newSavedScenarios;

      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', {
        user: user
      }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Successfully removed the scenario.');
      }).catch(function (err) {
        alert('Problem trying to remove the scenario.');
      });
    },
    moveScenarioUp: function moveScenarioUp(index) {
      var self = this;
      var user = _.cloneDeep(self.$store.state.account.user);
      var newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios[this.tool].move(index, index - 1);
      user.savedScenarios = newSavedScenarios;

      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', {
        user: user
      }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
      }).catch(function (err) {
        alert('Problem trying to move the scenario.');
      });
    },
    moveScenarioDown: function moveScenarioDown(index) {
      var self = this;
      var user = _.cloneDeep(self.$store.state.account.user);
      var newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios[this.tool].move(index, index + 1);
      user.savedScenarios = newSavedScenarios;

      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', {
        user: user
      }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
      }).catch(function (err) {
        alert('Problem trying to move the scenario.');
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "25wl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__ = __webpack_require__("Ywgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_pricing_table__ = __webpack_require__("89NH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-upgrade',
  components: {
    'errors-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__["a" /* default */],
    'pricing-table': __WEBPACK_IMPORTED_MODULE_1__components_utilities_pricing_table__["a" /* default */],
    'card-number': __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["CardNumber"],
    'card-expiry': __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["CardExpiry"],
    'card-cvc': __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["CardCvc"]
  },
  data: function data() {
    return {
      stripeConsumerKey: "",
      options: {},
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      upgrading: false,
      errorsFromBackend: []
    };
  },
  computed: {
    upgradeText: function upgradeText() {
      if (this.upgrading) {
        return 'Upgrading...';
      }

      return 'Upgrade to the premium version for for $50';
    }
  },
  watch: {
    number: function number() {
      this.update();
    },
    expiry: function expiry() {
      this.update();
    },
    cvc: function cvc() {
      this.update();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$destroy(); // because of stripe issue
    next();
  },
  methods: {
    update: function update() {
      this.complete = this.number && this.expiry && this.cvc;

      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    upgrade: function upgrade() {
      var self = this;

      self.upgrading = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["createToken"])().then(function (result) {
        if (result.error) {
          self.upgrading = false;
          self.errorsFromBackend.push(result.error.message);
        } else {
          self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/upgrade-to-premium', {
            token: result.token.id
          }).then(function () {
            self.$store.commit('account/upgradeToPremiumVersion');
            self.upgrading = false;
            alert('Successfully upgraded to the premium version of Six Plus Hold\u2019em!');
            self.$router.push({ path: '/account' });
          }).catch(function (e) {
            self.upgrading = false;
            __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.handleNetworkError(e);
          });
        }
      }).catch(function (e) {
        self.upgrading = false;
        __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.handleNetworkError(e);
      });
    },
    clearAlert: function clearAlert() {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    }
  }
});

/***/ }),

/***/ "26cs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2EOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_helpers__ = __webpack_require__("Ngfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_constants__ = __webpack_require__("vjYN");





/* harmony default export */ __webpack_exports__["a"] = ({
  run: function run(cards) {
    var handInfo = {
      id: null,
      name: null,
      value: null,
      handCards: null
    };
    var cardsByRank = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_helpers__["a" /* default */].getCardsByRank(cards);
    var fiveOrMoreCardsInARowResult = this._checkForFiveOrMoreCardsInARow(cards);
    var fiveOrMoreCardsOfSameSuitResult = this._checkForFiveOrMoreCardsOfSameSuit(cards);

    this._checkForRoyalFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);
    if (!handInfo.name) {
      this._checkForStraightFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFourOfAKind(cardsByRank, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFullHouse(cardsByRank, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);
    }
    if (!handInfo.name) {
      this._checkForStraight(fiveOrMoreCardsInARowResult, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForThreeOfAKind(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForTwoPair(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForPair(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForHighCard(cards, handInfo);
    }

    return handInfo;
  },
  _checkForFiveOrMoreCardsOfSameSuit: function _checkForFiveOrMoreCardsOfSameSuit(cards) {
    if (cards.length < 5) {
      return false;
    }

    var toReturn = false;
    var cardsBySuit = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_helpers__["a" /* default */].getCardsBySuit(cards);

    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(cardsBySuit, function (cardsOfSuit, suit) {
      if (cardsOfSuit.length >= 5) {
        toReturn = {
          suit: suit,
          cards: cardsOfSuit
        };
      }
    });

    return toReturn;
  },
  _checkForFiveOrMoreCardsInARow: function _checkForFiveOrMoreCardsInARow(cards) {
    var ranks = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRanksFromCards(cards);
    return this._checkForFiveOrMoreRanksInARow(ranks);
  },
  _checkForFiveOrMoreRanksInARow: function _checkForFiveOrMoreRanksInARow(ranks) {
    if (ranks.length < 5) {
      return false;
    }

    var fiveRankIndexes = void 0;
    var rankIndexes = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankIndexesFromRanks(ranks, true);

    for (var i = 0; i <= rankIndexes.length - 5; i++) {
      fiveRankIndexes = rankIndexes.slice(i, i + 5);

      if (__WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_helpers__["a" /* default */].checkIfRankIndexesAreSequential(fiveRankIndexes)) {
        return {
          highCardRank: __WEBPACK_IMPORTED_MODULE_3__services_constants__["a" /* default */].ranks[fiveRankIndexes[0]]
        };
      }
    }

    return false;
  },
  _checkForRoyalFlush: function _checkForRoyalFlush(fiveOrMoreCardsOfSameSuitResult, handInfo) {
    var straightWithFlushCardsResult = void 0;

    if (fiveOrMoreCardsOfSameSuitResult) {
      straightWithFlushCardsResult = this._checkForFiveOrMoreCardsInARow(fiveOrMoreCardsOfSameSuitResult.cards);

      if (straightWithFlushCardsResult && straightWithFlushCardsResult.highCardRank === 'a') {
        handInfo.id = 'fourOfAKindPlus:royalFlush';
        handInfo.name = 'royal flush';
        handInfo.value = 10;
        handInfo.suit = fiveOrMoreCardsOfSameSuitResult.suit;
        handInfo.handCards = ['a' + handInfo.suit, 'k' + handInfo.suit, 'q' + handInfo.suit, 'j' + handInfo.suit, 't' + handInfo.suit];
      }
    }
  },
  _checkForStraightFlush: function _checkForStraightFlush(fiveOrMoreCardsOfSameSuitResult, handInfo) {
    var straightWithFlushCardsResult = void 0;

    if (fiveOrMoreCardsOfSameSuitResult) {
      straightWithFlushCardsResult = this._checkForFiveOrMoreCardsInARow(fiveOrMoreCardsOfSameSuitResult.cards);

      if (straightWithFlushCardsResult && straightWithFlushCardsResult.highCardRank !== 'a') {
        handInfo.id = 'fourOfAKindPlus:straightFlush';
        handInfo.name = 'straight flush';
        handInfo.value = 9;
        handInfo.highCardRank = straightWithFlushCardsResult.highCardRank;
        handInfo.suit = fiveOrMoreCardsOfSameSuitResult.suit;
        handInfo.handCards = [handInfo.highCardRank + handInfo.suit, __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(handInfo.highCardRank, 1) + handInfo.suit, __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(handInfo.highCardRank, 2) + handInfo.suit, __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(handInfo.highCardRank, 3) + handInfo.suit, __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(handInfo.highCardRank, 4) + handInfo.suit];
      }
    }
  },
  _checkForFourOfAKind: function _checkForFourOfAKind(cardsByRank, handInfo) {
    var nonFourOfAKindCards = [];

    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(cardsByRank, function (cardsOfRank, rank) {
      if (cardsOfRank.length === 4) {
        handInfo.id = 'fourOfAKindPlus:fourOfAKind';
        handInfo.name = 'four of a kind';
        handInfo.value = 8;
        handInfo.rank = rank;
      } else {
        cardsOfRank.forEach(function (card) {
          nonFourOfAKindCards.push(card);
        });
      }
    });

    if (handInfo.name === 'four of a kind') {
      handInfo.kicker = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getHighestCardFromCards(nonFourOfAKindCards);
      handInfo.handCards = [handInfo.rank + 'c', handInfo.rank + 's', handInfo.rank + 'h', handInfo.rank + 'd', handInfo.kicker];
    }
  },
  _checkForFullHouse: function _checkForFullHouse(cardsByRank, handInfo) {
    var tripsCardGroups = [];
    var pairCardGroups = [];

    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(cardsByRank, function (cardsOfRank, rank) {
      if (cardsOfRank.length === 3) {
        tripsCardGroups.push(cardsOfRank);
      } else if (cardsOfRank.length === 2) {
        pairCardGroups.push(cardsOfRank);
      }
    });

    tripsCardGroups.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardGroupsDescendingByRankCompareFunction);
    pairCardGroups.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardGroupsDescendingByRankCompareFunction);

    if (tripsCardGroups.length === 2) {
      handInfo.id = 'fullHouse';
      handInfo.name = 'full house';
      handInfo.value = 7;
      handInfo.tripsRank = tripsCardGroups[0][0][0];
      handInfo.pairRank = tripsCardGroups[1][0][0];
      handInfo.handCards = [tripsCardGroups[0][0], tripsCardGroups[0][1], tripsCardGroups[0][2], tripsCardGroups[1][0], tripsCardGroups[1][1]];
    } else if (tripsCardGroups.length === 1 && pairCardGroups.length >= 1) {
      handInfo.id = 'fullHouse';
      handInfo.name = 'full house';
      handInfo.value = 7;
      handInfo.tripsRank = tripsCardGroups[0][0][0];
      handInfo.pairRank = pairCardGroups[0][0][0];
      handInfo.handCards = [tripsCardGroups[0][0], tripsCardGroups[0][1], tripsCardGroups[0][2], pairCardGroups[0][0], pairCardGroups[0][1]];
    }
  },
  _checkForFlush: function _checkForFlush(fiveOrMoreCardsOfSameSuitResult, handInfo) {
    if (fiveOrMoreCardsOfSameSuitResult) {
      handInfo.name = 'flush';
      handInfo.value = 6;
      handInfo.suit = fiveOrMoreCardsOfSameSuitResult.suit;

      fiveOrMoreCardsOfSameSuitResult.cards.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
      handInfo.ranks = [fiveOrMoreCardsOfSameSuitResult.cards[0][0], fiveOrMoreCardsOfSameSuitResult.cards[1][0], fiveOrMoreCardsOfSameSuitResult.cards[2][0], fiveOrMoreCardsOfSameSuitResult.cards[3][0], fiveOrMoreCardsOfSameSuitResult.cards[4][0]];
      handInfo.handCards = [fiveOrMoreCardsOfSameSuitResult.cards[0], fiveOrMoreCardsOfSameSuitResult.cards[1], fiveOrMoreCardsOfSameSuitResult.cards[2], fiveOrMoreCardsOfSameSuitResult.cards[3], fiveOrMoreCardsOfSameSuitResult.cards[4]];
    }
  },
  _checkForStraight: function _checkForStraight(fiveOrMoreCardsInARowResult, rawCards, handInfo) {
    var handCardHash = void 0;

    if (fiveOrMoreCardsInARowResult) {
      handInfo.id = 'straight';
      handInfo.name = 'straight';
      handInfo.value = 5;
      handInfo.highCardRank = fiveOrMoreCardsInARowResult.highCardRank;
      handCardHash = {};
      rawCards.forEach(function (card) {
        var cardRank = card[0];
        handCardHash[cardRank] = card;
      });
      handInfo.handCards = [handCardHash[handInfo.highCardRank], handCardHash[__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(handInfo.highCardRank, 1)], handCardHash[__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(handInfo.highCardRank, 2)], handCardHash[__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(handInfo.highCardRank, 3)], handCardHash[__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(handInfo.highCardRank, 4)]];
    }
  },
  _checkForThreeOfAKind: function _checkForThreeOfAKind(cardsByRank, rawCards, handInfo) {
    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(cardsByRank, function (cardsOfRank, rank) {
      var sortedNonTripCards = void 0;

      if (cardsOfRank.length === 3) {
        handInfo.name = 'three of a kind';
        handInfo.value = 4;
        handInfo.rank = rank;
        handInfo.handCards = [];

        // get handCards
        cardsOfRank.forEach(function (card) {
          handInfo.handCards.push(card);
        });
        rawCards.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
        sortedNonTripCards = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(rawCards, function (card) {
          var cardRank = card[0];
          return cardRank !== rank;
        });
        handInfo.kickers = [sortedNonTripCards[0], sortedNonTripCards[1]];
        handInfo.handCards.push(handInfo.kickers[0]);
        handInfo.handCards.push(handInfo.kickers[1]);
      }
    });
  },
  _checkForTwoPair: function _checkForTwoPair(cardsByRank, rawCards, handInfo) {
    var pairCardGroups = [];
    var nonHandCards = void 0;

    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(cardsByRank, function (cardsOfRank, rank) {
      if (cardsOfRank.length === 2) {
        pairCardGroups.push(cardsOfRank);
      }
    });
    pairCardGroups.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardGroupsDescendingByRankCompareFunction);

    if (pairCardGroups.length >= 2) {
      handInfo.name = 'two pair';
      handInfo.value = 3;
      handInfo.higherPairRank = pairCardGroups[0][0][0];
      handInfo.lowerPairRank = pairCardGroups[1][0][0];
      handInfo.handCards = [];
      handInfo.handCards.push(pairCardGroups[0][0]);
      handInfo.handCards.push(pairCardGroups[0][1]);
      handInfo.handCards.push(pairCardGroups[1][0]);
      handInfo.handCards.push(pairCardGroups[1][1]);

      // get kicker
      nonHandCards = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(rawCards, function (card) {
        return !handInfo.handCards.includes(card);
      });
      nonHandCards.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
      handInfo.kicker = nonHandCards[0];
      handInfo.handCards.push(handInfo.kicker);
    }
  },
  _checkForPair: function _checkForPair(cardsByRank, rawCards, handInfo) {
    var nonHandCards = void 0;

    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(cardsByRank, function (cardsOfRank, rank) {
      if (cardsOfRank.length === 2) {
        handInfo.name = 'pair';
        handInfo.value = 2;
        handInfo.rank = rank;
        handInfo.handCards = [];
        handInfo.handCards.push(cardsOfRank[0]);
        handInfo.handCards.push(cardsOfRank[1]);

        // get kickers
        nonHandCards = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(rawCards, function (card) {
          return !handInfo.handCards.includes(card);
        });
        nonHandCards.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
        handInfo.kickers = [nonHandCards[0], nonHandCards[1], nonHandCards[2]];
        handInfo.handCards.push(handInfo.kickers[0]);
        handInfo.handCards.push(handInfo.kickers[1]);
        handInfo.handCards.push(handInfo.kickers[2]);
      }
    });
  },
  _checkForHighCard: function _checkForHighCard(rawCards, handInfo) {
    handInfo.name = 'high card';
    handInfo.value = 1;
    rawCards.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
    handInfo.kickers = [rawCards[0], rawCards[1], rawCards[2], rawCards[3], rawCards[4]];
    handInfo.handCards = [rawCards[0], rawCards[1], rawCards[2], rawCards[3], rawCards[4]];
  },

  runForShortDeck: function runForShortDeck(cards) {
    var handInfo = {
      id: null,
      name: null,
      value: null,
      handCards: null
    };
    var cardsByRank = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_helpers__["a" /* default */].getCardsByRank(cards);
    var fiveOrMoreCardsInARowResult = this._checkForFiveOrMoreCardsInARowShortDeck(cards);
    var fiveOrMoreCardsOfSameSuitResult = this._checkForFiveOrMoreCardsOfSameSuit(cards);

    this._checkForRoyalFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);
    if (!handInfo.name) {
      this._checkForStraightFlushShortDeck(fiveOrMoreCardsOfSameSuitResult, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFourOfAKind(cardsByRank, handInfo);
    }
    if (!handInfo.name) {
      this._checkForFlush(fiveOrMoreCardsOfSameSuitResult, handInfo);

      if (handInfo.name) {
        handInfo.value = 7;
      }
    }
    if (!handInfo.name) {
      this._checkForFullHouse(cardsByRank, handInfo);

      if (handInfo.name) {
        handInfo.value = 6;
      }
    }
    if (!handInfo.name) {
      this._checkForStraightShortDeck(fiveOrMoreCardsInARowResult, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForThreeOfAKind(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForTwoPair(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForPair(cardsByRank, cards, handInfo);
    }
    if (!handInfo.name) {
      this._checkForHighCard(cards, handInfo);
    }

    return handInfo;
  },
  _checkForFiveOrMoreCardsInARowShortDeck: function _checkForFiveOrMoreCardsInARowShortDeck(cards) {
    var ranks = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRanksFromCards(cards);
    return this._checkForFiveOrMoreRanksInARowShortDeck(ranks);
  },
  _checkForFiveOrMoreRanksInARowShortDeck: function _checkForFiveOrMoreRanksInARowShortDeck(ranks) {
    if (ranks.length < 5) {
      return false;
    }

    var fiveRankIndexes = void 0;
    var rankIndexes = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankIndexesFromRanksShortDeck(ranks, true);

    for (var i = 0; i <= rankIndexes.length - 5; i++) {
      fiveRankIndexes = rankIndexes.slice(i, i + 5);

      if (__WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_helpers__["a" /* default */].checkIfRankIndexesAreSequential(fiveRankIndexes)) {
        return {
          highCardRank: __WEBPACK_IMPORTED_MODULE_3__services_constants__["a" /* default */].ranks[fiveRankIndexes[0]]
        };
      }
    }

    return false;
  },
  _checkForStraightFlushShortDeck: function _checkForStraightFlushShortDeck(fiveOrMoreCardsOfSameSuitResult, handInfo) {
    var straightWithFlushCardsResult = void 0;

    if (fiveOrMoreCardsOfSameSuitResult) {
      straightWithFlushCardsResult = this._checkForFiveOrMoreCardsInARowShortDeck(fiveOrMoreCardsOfSameSuitResult.cards);

      if (straightWithFlushCardsResult && straightWithFlushCardsResult.highCardRank !== 'a') {
        handInfo.id = 'fourOfAKindPlus:straightFlush';
        handInfo.name = 'straight flush';
        handInfo.value = 9;
        handInfo.highCardRank = straightWithFlushCardsResult.highCardRank;
        handInfo.suit = fiveOrMoreCardsOfSameSuitResult.suit;
        handInfo.handCards = [handInfo.highCardRank + handInfo.suit, __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 1) + handInfo.suit, __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 2) + handInfo.suit, __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 3) + handInfo.suit, __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 4) + handInfo.suit];
      }
    }
  },
  _checkForStraightShortDeck: function _checkForStraightShortDeck(fiveOrMoreCardsInARowResult, rawCards, handInfo) {
    var handCardHash = void 0;

    if (fiveOrMoreCardsInARowResult) {
      handInfo.id = 'straight';
      handInfo.name = 'straight';
      handInfo.value = 5;
      handInfo.highCardRank = fiveOrMoreCardsInARowResult.highCardRank;
      handCardHash = {};
      rawCards.forEach(function (card) {
        var cardRank = card[0];
        handCardHash[cardRank] = card;
      });
      handInfo.handCards = [handCardHash[handInfo.highCardRank], handCardHash[__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 1)], handCardHash[__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 2)], handCardHash[__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 3)], handCardHash[__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLowerShortDeck(handInfo.highCardRank, 4)]];
    }
  }
});

/***/ }),

/***/ "2Ewd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_calculator_help_vue__ = __webpack_require__("Ta4e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c94ac0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_calculator_help_vue__ = __webpack_require__("NcAl");
function injectStyle (ssrContext) {
  __webpack_require__("+c+z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63c94ac0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_calculator_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63c94ac0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_calculator_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2OhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__ = __webpack_require__("b4By");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__ = __webpack_require__("8TxB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_five_card_hands_categories_FiveCardHandsCategory__ = __webpack_require__("siI+");









var MadeHands = function (_FiveCardHandsCategor) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MadeHands, _FiveCardHandsCategor);

  function MadeHands() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MadeHands);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MadeHands.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MadeHands)).call(this));

    _this.data = [new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__["a" /* default */]({
      id: 'fourOfAKindPlus',
      text: 'Four of a kind+',
      fullText: 'Four of a kind+',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id.split(':')[0] === 'fourOfAKindPlus';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'fourOfAKindPlus:royalFlush',
        text: 'Royal flush',
        fullText: 'Royal flush',
        inlineText: 'a royal flush',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'fourOfAKindPlus:royalFlush';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'fourOfAKindPlus:straightFlush',
        text: 'Straight flush',
        fullText: 'Straight flush',
        inlineText: 'a straight flush',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'fourOfAKindPlus:straightFlush';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'fourOfAKindPlus:fourOfAKind',
        text: 'Four of a kind',
        fullText: 'Four of a kind',
        inlineText: 'four of a kind',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'fourOfAKindPlus:fourOfAKind';
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
      id: 'fullHouse',
      text: 'Full house',
      fullText: 'Full house',
      inlineText: 'a full house',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id === 'fullHouse';
      }
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__["a" /* default */]({
      id: 'flush',
      text: 'Flush',
      fullText: 'Flush',
      inlineText: 'a flush',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id.split(':')[0] === 'flush';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'flush:nut',
        text: 'Nut',
        fullText: 'Nut flush',
        inlineText: 'a nut flush',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'flush:nut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'flush:secondNut',
        text: 'Second nut',
        fullText: 'Second nut flush',
        inlineText: 'a second nut flush',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'flush:secondNut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'flush:thirdNut',
        text: 'Third nut',
        fullText: 'Third nut flush',
        inlineText: 'a third nut flush',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'flush:thirdNut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'flush:weak',
        text: 'Weak',
        fullText: 'Weak flush',
        inlineText: 'a weak flush',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'flush:weak';
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
      id: 'straight',
      text: 'Straight',
      fullText: 'Straight',
      inlineText: 'a straight',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id === 'straight';
      }
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__["a" /* default */]({
      id: 'threeOfAKind',
      text: 'Three of a kind',
      fullText: 'Three of a kind',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id.split(':')[0] === 'threeOfAKind';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'threeOfAKind:topSet',
        text: 'Top set',
        fullText: 'Top set',
        inlineText: 'top set',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'threeOfAKind:topSet';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'threeOfAKind:secondSet',
        text: 'Second set',
        fullText: 'Second set',
        inlineText: 'second set',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'threeOfAKind:secondSet';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'threeOfAKind:thirdSet',
        text: 'Third set',
        fullText: 'Third set',
        inlineText: 'third set',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'threeOfAKind:thirdSet';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'threeOfAKind:fourthSet',
        text: 'Fourth set',
        fullText: 'Fourth set',
        inlineText: 'fourth set',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'threeOfAKind:fourthSet';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'threeOfAKind:middleSet',
        text: 'Middle set',
        fullText: 'Middle set',
        inlineText: 'middle set',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'threeOfAKind:middleSet';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'threeOfAKind:bottomSet',
        text: 'Bottom set',
        fullText: 'Bottom set',
        inlineText: 'bottom set',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'threeOfAKind:bottomSet';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'threeOfAKind:trips',
        text: 'Trips',
        fullText: 'Trips',
        inlineText: 'trips',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'threeOfAKind:trips';
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__["a" /* default */]({
      id: 'twoPair',
      text: 'Two pair',
      fullText: 'Two pair',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id.split(':')[0] === 'twoPair';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'twoPair:usingTopBoardCard',
        text: '<abbr title="Using top board card">Strong</abbr>',
        fullText: 'Two pair using top board card',
        inlineText: 'two pair using the top board card',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'twoPair:usingTopBoardCard';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'twoPair:weak',
        text: 'Weak',
        fullText: 'Weak two pair',
        inlineText: 'a weak two pair',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'twoPair:weak';
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__["a" /* default */]({
      id: 'pair',
      text: 'Pair',
      fullText: 'Pair',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id.split(':')[0] === 'pair';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'pair:overpair',
        text: 'Overpair',
        fullText: 'Overpair',
        inlineText: 'an overpair',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'pair:overpair';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'pair:tptk',
        text: '<abbr title="Top pair top kicker">TPTK</abbr>',
        fullText: 'TPTK',
        inlineText: 'TPTK',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'pair:tptk';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'pair:tpgk',
        text: '<abbr title="Top pair good kicker">TPGK</abbr>',
        fullText: 'TPGK',
        inlineText: 'TPGK',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'pair:tpgk';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'pair:tpwk',
        text: '<abbr title="Top pair weak kicker">TPWK</abbr>',
        fullText: 'TPWK',
        inlineText: 'TPWK',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'pair:tpwk';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'pair:ppUnderTp',
        text: '<abbr title="Pocket pair under top pair">PP under TP</abbr>',
        fullText: 'PP under TP',
        inlineText: 'a pocket pair under top pair',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'pair:ppUnderTp';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'pair:secondPair',
        text: 'Second pair',
        fullText: 'Second pair',
        inlineText: 'second pair',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'pair:secondPair';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'pair:middlePair',
        text: 'Middle pair',
        fullText: 'Middle pair',
        inlineText: 'middle pair',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'pair:middlePair';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'pair:weakPair',
        text: 'Weak',
        fullText: 'Weak pair',
        inlineText: 'a weak pair',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'pair:weakPair';
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__["a" /* default */]({
      id: 'usingABoardCard',
      text: 'Using a board card',
      fullText: 'Using a board card',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id.split(':')[0] === 'usingABoardCard';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__["a" /* default */]({
        id: 'usingABoardCard:flushUsingOneHoleCard',
        text: 'Flush using one hole card',
        fullText: 'Flush using one hole card',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id.split(':')[0] === 'usingABoardCard' && handInfo.id.split(':')[1] === 'flushUsingOneHoleCard';
        },
        children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
          id: 'usingABoardCard:flushUsingOneHoleCard:nut',
          text: 'Nut',
          fullText: 'Nut flush using one hole card',
          isAHit: function isAHit(handInfo, drawInfo) {
            return handInfo.id === 'usingABoardCard:flushUsingOneHoleCard:nut';
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
          id: 'usingABoardCard:flushUsingOneHoleCard:secondNut',
          text: 'Second nut',
          fullText: 'Second nut flush using one hole card',
          isAHit: function isAHit(handInfo, drawInfo) {
            return handInfo.id === 'usingABoardCard:flushUsingOneHoleCard:secondNut';
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
          id: 'usingABoardCard:flushUsingOneHoleCard:thirdNut',
          text: 'Third nut',
          fullText: 'Third nut flush using one hole card',
          isAHit: function isAHit(handInfo, drawInfo) {
            return handInfo.id === 'usingABoardCard:flushUsingOneHoleCard:thirdNut';
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
          id: 'usingABoardCard:flushUsingOneHoleCard:weak',
          text: 'Weak',
          fullText: 'Weak flush using one hole card',
          isAHit: function isAHit(handInfo, drawInfo) {
            return handInfo.id === 'usingABoardCard:flushUsingOneHoleCard:weak';
          }
        })]
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'usingABoardCard:flushOnBoard',
        text: 'Flush on board',
        fullText: 'Flush on board',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'usingABoardCard:flushOnBoard';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'usingABoardCard:threeOfAKindOnBoard',
        text: 'Three of a kind on board',
        fullText: 'Three of a kind on board',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'usingABoardCard:threeOfAKindOnBoard';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'usingABoardCard:twoPairWithPairOnBoard',
        text: 'Two pair w/ pair on board',
        fullText: 'Two pair w/ pair on board',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'usingABoardCard:twoPairWithPairOnBoard';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'usingABoardCard:twoPairOnBoard',
        text: 'Two pair on board',
        fullText: 'Two pair on board',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'usingABoardCard:twoPairOnBoard';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'usingABoardCard:pairOnBoard',
        text: 'Pair on board',
        fullText: 'Pair on board',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'usingABoardCard:pairOnBoard';
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_MadeHandParent__["a" /* default */]({
      id: 'highCard',
      text: 'High card',
      fullText: 'High card',
      isAHit: function isAHit(handInfo, drawInfo) {
        return handInfo.id.split(':')[0] === 'highCard';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'highCard:aceHigh',
        text: 'Ace high',
        fullText: 'Ace high',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'highCard:aceHigh';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'highCard:kingHigh',
        text: 'King high',
        fullText: 'King high',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'highCard:kingHigh';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_MadeHandLeaf__["a" /* default */]({
        id: 'highCard:weak',
        text: 'Weak',
        fullText: 'Weak high card',
        isAHit: function isAHit(handInfo, drawInfo) {
          return handInfo.id === 'highCard:weak';
        }
      })]
    })];
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(MadeHands.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MadeHands.prototype), 'setBreadcrumbText', _this).call(_this);
    return _this;
  }

  return MadeHands;
}(__WEBPACK_IMPORTED_MODULE_7__services_five_card_hands_categories_FiveCardHandsCategory__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MadeHands);
;

/***/ }),

/***/ "2QjM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cumulative-hit-percentages',
  props: ['cumulativeHitPercentages', 'moreThanTwoPlayers', 'streetsToDisplay'],
  computed: {
    displayFlop: function displayFlop() {
      return this.streetsToDisplay.includes('flop');
    },
    displayTurn: function displayTurn() {
      return this.streetsToDisplay.includes('turn');
    },
    displayRiver: function displayRiver() {
      return this.streetsToDisplay.includes('river');
    }
  }
});

/***/ }),

/***/ "2Y/5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchase_vue__ = __webpack_require__("Akib");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c8f0bde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_vue__ = __webpack_require__("HDsU");
function injectStyle (ssrContext) {
  __webpack_require__("xfiN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c8f0bde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_purchase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c8f0bde_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_purchase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2c+o":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2ny4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_hole_cards_selector_vue__ = __webpack_require__("5CCh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d95ecdce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_hole_cards_selector_vue__ = __webpack_require__("5cB/");
function injectStyle (ssrContext) {
  __webpack_require__("RuDn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d95ecdce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_hole_cards_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d95ecdce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_hole_cards_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2qDg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-calculator-insights-settings',
  data: function data() {
    return {
      equityCalculatorInsightsVisible: this.$store.state.account.user.settings.equityCalculator.insightsVisible.toString()
    };
  },
  methods: {
    save: function save() {
      var newValue = this.equityCalculatorInsightsVisible === 'true' ? true : false;
      var user = _.cloneDeep(this.$store.state.account.user);
      var self = this;

      user.settings.equityCalculator.insightsVisible = newValue;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "2t51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_five_card_hands_section_header__ = __webpack_require__("3lPZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_percentages_or_combos__ = __webpack_require__("cyqG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_five_card_hands_section_five_card_hands_for_category__ = __webpack_require__("qANK");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'five-card-hands-section',
  components: {
    'five-card-hands-section-header': __WEBPACK_IMPORTED_MODULE_0__components_five_card_hands_section_header__["a" /* default */],
    'percentages-or-combos': __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_percentages_or_combos__["a" /* default */],
    'five-card-hands-for-category': __WEBPACK_IMPORTED_MODULE_2__components_five_card_hands_section_five_card_hands_for_category__["a" /* default */]
  },
  props: ['playerState', 'hitPercentageUpToDate', 'hideHeader', 'showPercentagesOrCombos', 'hideRightContainer', 'shortDeck', 'authorized'],
  data: function data() {
    return {
      percentagesOrCombos: 'percentages'
    };
  },
  computed: {
    insightsVisible: function insightsVisible() {
      return this.$store.state.account.user.settings.hitCalculator.insightsVisible;
    }
  },
  methods: {
    setCheckedValueOfFiveCardHand: function setCheckedValueOfFiveCardHand(payload) {
      this.$emit('setCheckedValueOfFiveCardHand', payload);
    }
  }
});

/***/ }),

/***/ "2xqV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "32Qs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_calculator_vue__ = __webpack_require__("l0rM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff3d82f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_calculator_vue__ = __webpack_require__("/C/p");
function injectStyle (ssrContext) {
  __webpack_require__("GLQb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ff3d82f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ff3d82f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "36Uc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"saved-ranges-selector"},[_vm._l((_vm.visibleSavedRanges),function(visibleSavedRange){return _c('div',{key:visibleSavedRange.id,class:'level-' + visibleSavedRange.level + ' indexes-' + visibleSavedRange.indexes.toString().replace(/,/g, '-')},[_c('div',{staticClass:"radio"},[(visibleSavedRange.children)?_c('span',{staticClass:"glyphicon",class:{
          'glyphicon-triangle-bottom': !visibleSavedRange.collapsed,
          'glyphicon-triangle-right': visibleSavedRange.collapsed
        },on:{"click":function($event){return _vm.toggleCollapse(visibleSavedRange)}}}):_vm._e(),_vm._v(" "),(!visibleSavedRange.children)?_c('label',{class:{ disabled: _vm.disabled }},[_c('input',{attrs:{"type":"radio","value":"","disabled":_vm.disabled},domProps:{"checked":visibleSavedRange.checked},on:{"change":function($event){return _vm.setRangeToMatchGeneralHands(visibleSavedRange, $event)}}}),_vm._v(" "),_vm._v("\n\n        "+_vm._s(visibleSavedRange.name)+"\n      ")]):_c('span',{on:{"click":function($event){return _vm.toggleCollapse(visibleSavedRange)}}},[_vm._v(_vm._s(visibleSavedRange.name))])])])}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.loggedIn)?_c('p',{staticClass:"customize"},[_c('router-link',{attrs:{"to":"/settings/general/saved-ranges"}},[_c('small',[_vm._v("Customize saved ranges")])])],1):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3FI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"individual-card-selector",attrs:{"disabled":_vm.disabled}},[_c('div',{class:_vm.popoverDirectionClass},[_c('span',{staticClass:"dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[(_vm.cardString)?_c('img',{attrs:{"src":_vm.cardImageSrc}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('section',{staticClass:"non-mobile"},[_c('table',[_c('tr',[_c('td',[(_vm.isCardAvailable('ah'))?_c('img',{attrs:{"src":"/static/cards/ace-of-hearts.png"},on:{"click":function($event){return _vm.select('ah', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kh'))?_c('img',{attrs:{"src":"/static/cards/king-of-hearts.png"},on:{"click":function($event){return _vm.select('kh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qh'))?_c('img',{attrs:{"src":"/static/cards/queen-of-hearts.png"},on:{"click":function($event){return _vm.select('qh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jh'))?_c('img',{attrs:{"src":"/static/cards/jack-of-hearts.png"},on:{"click":function($event){return _vm.select('jh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('th'))?_c('img',{attrs:{"src":"/static/cards/ten-of-hearts.png"},on:{"click":function($event){return _vm.select('th', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9h'))?_c('img',{attrs:{"src":"/static/cards/nine-of-hearts.png"},on:{"click":function($event){return _vm.select('9h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8h'))?_c('img',{attrs:{"src":"/static/cards/eight-of-hearts.png"},on:{"click":function($event){return _vm.select('8h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7h'))?_c('img',{attrs:{"src":"/static/cards/seven-of-hearts.png"},on:{"click":function($event){return _vm.select('7h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6h'))?_c('img',{attrs:{"src":"/static/cards/six-of-hearts.png"},on:{"click":function($event){return _vm.select('6h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('5h'))?_c('img',{attrs:{"src":"/static/cards/five-of-hearts.png"},on:{"click":function($event){return _vm.select('5h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('4h'))?_c('img',{attrs:{"src":"/static/cards/four-of-hearts.png"},on:{"click":function($event){return _vm.select('4h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('3h'))?_c('img',{attrs:{"src":"/static/cards/three-of-hearts.png"},on:{"click":function($event){return _vm.select('3h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('2h'))?_c('img',{attrs:{"src":"/static/cards/two-of-hearts.png"},on:{"click":function($event){return _vm.select('2h', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('as'))?_c('img',{attrs:{"src":"/static/cards/ace-of-spades.png"},on:{"click":function($event){return _vm.select('as', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ks'))?_c('img',{attrs:{"src":"/static/cards/king-of-spades.png"},on:{"click":function($event){return _vm.select('ks', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qs'))?_c('img',{attrs:{"src":"/static/cards/queen-of-spades.png"},on:{"click":function($event){return _vm.select('qs', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('js'))?_c('img',{attrs:{"src":"/static/cards/jack-of-spades.png"},on:{"click":function($event){return _vm.select('js', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ts'))?_c('img',{attrs:{"src":"/static/cards/ten-of-spades.png"},on:{"click":function($event){return _vm.select('ts', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9s'))?_c('img',{attrs:{"src":"/static/cards/nine-of-spades.png"},on:{"click":function($event){return _vm.select('9s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8s'))?_c('img',{attrs:{"src":"/static/cards/eight-of-spades.png"},on:{"click":function($event){return _vm.select('8s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7s'))?_c('img',{attrs:{"src":"/static/cards/seven-of-spades.png"},on:{"click":function($event){return _vm.select('7s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6s'))?_c('img',{attrs:{"src":"/static/cards/six-of-spades.png"},on:{"click":function($event){return _vm.select('6s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('5s'))?_c('img',{attrs:{"src":"/static/cards/five-of-spades.png"},on:{"click":function($event){return _vm.select('5s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('4s'))?_c('img',{attrs:{"src":"/static/cards/four-of-spades.png"},on:{"click":function($event){return _vm.select('4s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('3s'))?_c('img',{attrs:{"src":"/static/cards/three-of-spades.png"},on:{"click":function($event){return _vm.select('3s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('2s'))?_c('img',{attrs:{"src":"/static/cards/two-of-spades.png"},on:{"click":function($event){return _vm.select('2s', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('ad'))?_c('img',{attrs:{"src":"/static/cards/ace-of-diamonds.png"},on:{"click":function($event){return _vm.select('ad', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kd'))?_c('img',{attrs:{"src":"/static/cards/king-of-diamonds.png"},on:{"click":function($event){return _vm.select('kd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qd'))?_c('img',{attrs:{"src":"/static/cards/queen-of-diamonds.png"},on:{"click":function($event){return _vm.select('qd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jd'))?_c('img',{attrs:{"src":"/static/cards/jack-of-diamonds.png"},on:{"click":function($event){return _vm.select('jd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('td'))?_c('img',{attrs:{"src":"/static/cards/ten-of-diamonds.png"},on:{"click":function($event){return _vm.select('td', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9d'))?_c('img',{attrs:{"src":"/static/cards/nine-of-diamonds.png"},on:{"click":function($event){return _vm.select('9d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8d'))?_c('img',{attrs:{"src":"/static/cards/eight-of-diamonds.png"},on:{"click":function($event){return _vm.select('8d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7d'))?_c('img',{attrs:{"src":"/static/cards/seven-of-diamonds.png"},on:{"click":function($event){return _vm.select('7d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6d'))?_c('img',{attrs:{"src":"/static/cards/six-of-diamonds.png"},on:{"click":function($event){return _vm.select('6d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('5d'))?_c('img',{attrs:{"src":"/static/cards/five-of-diamonds.png"},on:{"click":function($event){return _vm.select('5d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('4d'))?_c('img',{attrs:{"src":"/static/cards/four-of-diamonds.png"},on:{"click":function($event){return _vm.select('4d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('3d'))?_c('img',{attrs:{"src":"/static/cards/three-of-diamonds.png"},on:{"click":function($event){return _vm.select('3d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('2d'))?_c('img',{attrs:{"src":"/static/cards/two-of-diamonds.png"},on:{"click":function($event){return _vm.select('2d', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('ac'))?_c('img',{attrs:{"src":"/static/cards/ace-of-clubs.png"},on:{"click":function($event){return _vm.select('ac', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kc'))?_c('img',{attrs:{"src":"/static/cards/king-of-clubs.png"},on:{"click":function($event){return _vm.select('kc', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qc'))?_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"},on:{"click":function($event){return _vm.select('qc', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jc'))?_c('img',{attrs:{"src":"/static/cards/jack-of-clubs.png"},on:{"click":function($event){return _vm.select('jc', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('tc'))?_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"},on:{"click":function($event){return _vm.select('tc', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9c'))?_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"},on:{"click":function($event){return _vm.select('9c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8c'))?_c('img',{attrs:{"src":"/static/cards/eight-of-clubs.png"},on:{"click":function($event){return _vm.select('8c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7c'))?_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"},on:{"click":function($event){return _vm.select('7c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6c'))?_c('img',{attrs:{"src":"/static/cards/six-of-clubs.png"},on:{"click":function($event){return _vm.select('6c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('5c'))?_c('img',{attrs:{"src":"/static/cards/five-of-clubs.png"},on:{"click":function($event){return _vm.select('5c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('4c'))?_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"},on:{"click":function($event){return _vm.select('4c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('3c'))?_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"},on:{"click":function($event){return _vm.select('3c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('2c'))?_c('img',{attrs:{"src":"/static/cards/two-of-clubs.png"},on:{"click":function($event){return _vm.select('2c', $event)}}}):_vm._e()])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.selectRandomCard($event)}}},[_vm._v("\n          Random\n        ")])]),_vm._v(" "),_c('section',{staticClass:"mobile"},[(_vm.popoverDirectionClass === 'dropdown')?_c('button',{staticClass:"btn btn-default btn-block btn-lg",on:{"click":function($event){return _vm.selectRandomCard($event)}}},[_vm._v("\n          Random\n        ")]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('ah'))?_c('img',{attrs:{"src":"/static/cards/ace-of-hearts.png"},on:{"click":function($event){return _vm.select('ah', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('as'))?_c('img',{attrs:{"src":"/static/cards/ace-of-spades.png"},on:{"click":function($event){return _vm.select('as', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ad'))?_c('img',{attrs:{"src":"/static/cards/ace-of-diamonds.png"},on:{"click":function($event){return _vm.select('ad', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ac'))?_c('img',{attrs:{"src":"/static/cards/ace-of-clubs.png"},on:{"click":function($event){return _vm.select('ac', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('kh'))?_c('img',{attrs:{"src":"/static/cards/king-of-hearts.png"},on:{"click":function($event){return _vm.select('kh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ks'))?_c('img',{attrs:{"src":"/static/cards/king-of-spades.png"},on:{"click":function($event){return _vm.select('ks', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kd'))?_c('img',{attrs:{"src":"/static/cards/king-of-diamonds.png"},on:{"click":function($event){return _vm.select('kd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kc'))?_c('img',{attrs:{"src":"/static/cards/king-of-clubs.png"},on:{"click":function($event){return _vm.select('kc', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('qh'))?_c('img',{attrs:{"src":"/static/cards/queen-of-hearts.png"},on:{"click":function($event){return _vm.select('qh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qs'))?_c('img',{attrs:{"src":"/static/cards/queen-of-spades.png"},on:{"click":function($event){return _vm.select('qs', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qd'))?_c('img',{attrs:{"src":"/static/cards/queen-of-diamonds.png"},on:{"click":function($event){return _vm.select('qd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qc'))?_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"},on:{"click":function($event){return _vm.select('qc', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('jh'))?_c('img',{attrs:{"src":"/static/cards/jack-of-hearts.png"},on:{"click":function($event){return _vm.select('jh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('js'))?_c('img',{attrs:{"src":"/static/cards/jack-of-spades.png"},on:{"click":function($event){return _vm.select('js', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jd'))?_c('img',{attrs:{"src":"/static/cards/jack-of-diamonds.png"},on:{"click":function($event){return _vm.select('jd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jc'))?_c('img',{attrs:{"src":"/static/cards/jack-of-clubs.png"},on:{"click":function($event){return _vm.select('jc', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('th'))?_c('img',{attrs:{"src":"/static/cards/ten-of-hearts.png"},on:{"click":function($event){return _vm.select('th', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ts'))?_c('img',{attrs:{"src":"/static/cards/ten-of-spades.png"},on:{"click":function($event){return _vm.select('ts', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('td'))?_c('img',{attrs:{"src":"/static/cards/ten-of-diamonds.png"},on:{"click":function($event){return _vm.select('td', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('tc'))?_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"},on:{"click":function($event){return _vm.select('tc', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('9h'))?_c('img',{attrs:{"src":"/static/cards/nine-of-hearts.png"},on:{"click":function($event){return _vm.select('9h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9s'))?_c('img',{attrs:{"src":"/static/cards/nine-of-spades.png"},on:{"click":function($event){return _vm.select('9s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9d'))?_c('img',{attrs:{"src":"/static/cards/nine-of-diamonds.png"},on:{"click":function($event){return _vm.select('9d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9c'))?_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"},on:{"click":function($event){return _vm.select('9c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('8h'))?_c('img',{attrs:{"src":"/static/cards/eight-of-hearts.png"},on:{"click":function($event){return _vm.select('8h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8s'))?_c('img',{attrs:{"src":"/static/cards/eight-of-spades.png"},on:{"click":function($event){return _vm.select('8s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8d'))?_c('img',{attrs:{"src":"/static/cards/eight-of-diamonds.png"},on:{"click":function($event){return _vm.select('8d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8c'))?_c('img',{attrs:{"src":"/static/cards/eight-of-clubs.png"},on:{"click":function($event){return _vm.select('8c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('7h'))?_c('img',{attrs:{"src":"/static/cards/seven-of-hearts.png"},on:{"click":function($event){return _vm.select('7h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7s'))?_c('img',{attrs:{"src":"/static/cards/seven-of-spades.png"},on:{"click":function($event){return _vm.select('7s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7d'))?_c('img',{attrs:{"src":"/static/cards/seven-of-diamonds.png"},on:{"click":function($event){return _vm.select('7d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7c'))?_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"},on:{"click":function($event){return _vm.select('7c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('6h'))?_c('img',{attrs:{"src":"/static/cards/six-of-hearts.png"},on:{"click":function($event){return _vm.select('6h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6s'))?_c('img',{attrs:{"src":"/static/cards/six-of-spades.png"},on:{"click":function($event){return _vm.select('6s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6d'))?_c('img',{attrs:{"src":"/static/cards/six-of-diamonds.png"},on:{"click":function($event){return _vm.select('6d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6c'))?_c('img',{attrs:{"src":"/static/cards/six-of-clubs.png"},on:{"click":function($event){return _vm.select('6c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('5h'))?_c('img',{attrs:{"src":"/static/cards/five-of-hearts.png"},on:{"click":function($event){return _vm.select('5h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('5s'))?_c('img',{attrs:{"src":"/static/cards/five-of-spades.png"},on:{"click":function($event){return _vm.select('5s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('5d'))?_c('img',{attrs:{"src":"/static/cards/five-of-diamonds.png"},on:{"click":function($event){return _vm.select('5d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('5c'))?_c('img',{attrs:{"src":"/static/cards/five-of-clubs.png"},on:{"click":function($event){return _vm.select('5c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('4h'))?_c('img',{attrs:{"src":"/static/cards/four-of-hearts.png"},on:{"click":function($event){return _vm.select('4h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('4s'))?_c('img',{attrs:{"src":"/static/cards/four-of-spades.png"},on:{"click":function($event){return _vm.select('4s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('4d'))?_c('img',{attrs:{"src":"/static/cards/four-of-diamonds.png"},on:{"click":function($event){return _vm.select('4d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('4c'))?_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"},on:{"click":function($event){return _vm.select('4c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('3h'))?_c('img',{attrs:{"src":"/static/cards/three-of-hearts.png"},on:{"click":function($event){return _vm.select('3h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('3s'))?_c('img',{attrs:{"src":"/static/cards/three-of-spades.png"},on:{"click":function($event){return _vm.select('3s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('3d'))?_c('img',{attrs:{"src":"/static/cards/three-of-diamonds.png"},on:{"click":function($event){return _vm.select('3d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('3c'))?_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"},on:{"click":function($event){return _vm.select('3c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('2h'))?_c('img',{attrs:{"src":"/static/cards/two-of-hearts.png"},on:{"click":function($event){return _vm.select('2h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('2s'))?_c('img',{attrs:{"src":"/static/cards/two-of-spades.png"},on:{"click":function($event){return _vm.select('2s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('2d'))?_c('img',{attrs:{"src":"/static/cards/two-of-diamonds.png"},on:{"click":function($event){return _vm.select('2d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('2c'))?_c('img',{attrs:{"src":"/static/cards/two-of-clubs.png"},on:{"click":function($event){return _vm.select('2c', $event)}}}):_vm._e()])]),_vm._v(" "),(_vm.popoverDirectionClass === 'dropup')?_c('button',{staticClass:"btn btn-default btn-block btn-lg",on:{"click":function($event){return _vm.selectRandomCard($event)}}},[_vm._v("\n          Random\n        ")]):_vm._e()])])]),_vm._v(" "),_c('span',{staticClass:"deselect",on:{"click":function($event){return _vm.$emit('deselect')}}},[(_vm.cardString && !_vm.hideDeselect && !_vm.disabled)?_c('span',[_vm._v("×")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3LcH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Sc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"three-bet-cbet-explorer"},[(!_vm.authorized)?_c('readonly-alert'):_vm._e(),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("\n      3bet-cbet explorer\n      "),_c('router-link',{attrs:{"to":"/help/three-bet-cbet-explorer"}},[_c('img',{attrs:{"src":"/static/help.png","width":"50"}})])],1)]),_vm._v(" "),_c('section',{staticClass:"row"},[_c('section',{staticClass:"col-sm-6"},[_c('three-bet-cbet-explorer-inputs',{attrs:{"state":_vm.state,"authorized":_vm.authorized}}),_vm._v(" "),_c('section',{staticClass:"hidden-xs"},[_c('hr'),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
            method: 'createSharableThreeBetCbetExplorerURL',
            state: _vm.state,
          })}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized},on:{"saveScenario":function($event){return _vm.$emit('saveScenario', {
            method: 'createSharableThreeBetCbetExplorerURL',
            savedScenarioPropertyName: 'threeBetCbetExplorer',
            state: _vm.state,
          })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
            method: '_constructThreeBetCbetExplorerData',
            state: _vm.state,
          })}}})],1)],1),_vm._v(" "),_c('section',{staticClass:"col-sm-6"},[_c('p',{staticClass:"breakeven-percentage"},[_vm._v("Breakeven percentage: "+_vm._s(_vm.getBreakevenPercentage())+"%")]),_vm._v(" "),_c('three-bet-cbet-explorer-graph',{attrs:{"chartData":_vm.chartData}}),_vm._v(" "),_c('three-bet-cbet-explorer-table',{attrs:{"selectedContinueVs3betPercentage":_vm.selectedContinueVs3betPercentage,"evForSelected":_vm.getEV(_vm.state, _vm.selectedContinueVs3betPercentage / 100),"evForZeroPercent":_vm.getEV(_vm.state, 0),"evForTwentyPercent":_vm.getEV(_vm.state, 0.2),"evForFourtyPercent":_vm.getEV(_vm.state, 0.4),"evForSixtyPercent":_vm.getEV(_vm.state, 0.6),"evForEightyPercent":_vm.getEV(_vm.state, 0.8),"evForOneHundredPercent":_vm.getEV(_vm.state, 1)}})],1)]),_vm._v(" "),_c('section',{staticClass:"visible-xs"},[_c('hr'),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
        method: 'createSharableThreeBetCbetExplorerURL',
        state: _vm.state,
      })}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized},on:{"saveScenario":function($event){return _vm.$emit('saveScenario', {
        method: 'createSharableThreeBetCbetExplorerURL',
        savedScenarioPropertyName: 'threeBetCbetExplorer',
        state: _vm.state,
      })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
        method: '_constructThreeBetCbetExplorerData',
        state: _vm.state,
      })}}})],1),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"3bet-cbet explorer","urlPath":"three-bet-cbet-explorer"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3Vhb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_Players__ = __webpack_require__("IPbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__ = __webpack_require__("XRwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_PresetHoleCards__ = __webpack_require__("oC4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_service__ = __webpack_require__("JBFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__ = __webpack_require__("g8te");







var state = {
  totalNumberOfSimulations: null,
  presetHoleCards: new __WEBPACK_IMPORTED_MODULE_2__services_PresetHoleCards__["a" /* default */](),
  presetCommunityCards: new __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__["a" /* default */](),
  players: new __WEBPACK_IMPORTED_MODULE_0__services_player_Players__["a" /* default */]()
};

var getters = {
  percentageOfTimeEveryoneMissesTheBoard: function percentageOfTimeEveryoneMissesTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeEveryoneMissesTheBoard(state, street);
    };
  },
  percentageOfTimeExactlyOnePlayerHitsTheBoard: function percentageOfTimeExactlyOnePlayerHitsTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, street);
    };
  },
  percentageOfTimeTwoOrMorePlayersHitTheBoard: function percentageOfTimeTwoOrMorePlayersHitTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, street);
    };
  },
  cumulativeHitPercentages: function cumulativeHitPercentages(state) {
    return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getCumulativeHitPercentages(state);
  }
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_3__services_share_url_service__["a" /* default */].setHitCalculatorStoreState(stateFromServer, state);
  },

  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHand(state, payload);
  },
  manuallySelectGeneralHand: function manuallySelectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySelectGeneralHand(state, payload);
  },
  manuallyDeselectGeneralHand: function manuallyDeselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectGeneralHand(state, payload);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHands(state, payload);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectAllGeneralHands(state, payload);
  },
  selectSpecificHand: function selectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function deselectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectSpecificHand(state, payload);
  },
  manuallySelectSpecificHand: function manuallySelectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySelectSpecificHand(state, payload);
  },
  manuallyDeselectSpecificHand: function manuallyDeselectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectSpecificHand(state, payload);
  },
  manuallyDeselectAllGeneralHands: function manuallyDeselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectAllGeneralHands(state, payload);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHands(state, payload);
  },
  setSpecificHandAsManuallySet: function setSpecificHandAsManuallySet(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setSpecificHandAsManuallySet(state, payload);
  },
  setSpecificHandAsNotManuallySet: function setSpecificHandAsNotManuallySet(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setSpecificHandAsNotManuallySet(state, payload);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function setWeightOfSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightOfSpecificHand(state, payload);
  },
  manuallyApplyExactWeightToGeneralHand: function manuallyApplyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyApplyExactWeightToGeneralHand(state, payload);
  },
  manuallySetWeightOfSpecificHand: function manuallySetWeightOfSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySetWeightOfSpecificHand(state, payload);
  },
  clearManuallyAddedHands: function clearManuallyAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
  },
  clearManuallyRemovedHands: function clearManuallyRemovedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  setRangesAccordingToFilters: function setRangesAccordingToFilters(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setRangesAccordingToFilters(state, playerIndex);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function addComboToCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function removeComboFromCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeComboFromCombosToAdd(state, payload);
  },
  highlightGeneralHandsThatMatchFiveCardHand: function highlightGeneralHandsThatMatchFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].highlightGeneralHandsThatMatchFiveCardHand(state, payload);
  },
  removeFiveCardHandHighlights: function removeFiveCardHandHighlights(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeFiveCardHandHighlights(state, payload);
  },

  // controls
  setPresetHoleCard: function setPresetHoleCard(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setPresetHoleCard(state, payload);
  },
  removePresetHoleCard: function removePresetHoleCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetHoleCard(state, position);
  },
  setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function setBoard(state, boardCards) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setBoard(state, boardCards);
  },
  removePresetCommunityCard: function removePresetCommunityCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetCommunityCard(state, position);
  },
  addPlayer: function addPlayer(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addPlayer(state, payload);
  },
  removePlayer: function removePlayer(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePlayer(state, playerIndex);
  },

  // five card hands section checkboxes
  setCheckedValueOfFiveCardHand: function setCheckedValueOfFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setCheckedValueOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newCheckedValue: payload.newCheckedValue
    });

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallySetHandsThatPassThroughFilter(state, {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        fiveCardHandId: payload.fiveCardHandId
      });
    }
  },
  applyExactWeightToFiveCardHand: function applyExactWeightToFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToFiveCardHand(state, payload);
  },
  uncheckAllFiveCardHandsForGivenState: function uncheckAllFiveCardHandsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].uncheckAllFiveCardHandsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  checkAllFiveCardHandsForGivenState: function checkAllFiveCardHandsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].checkAllFiveCardHandsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  setChecksToDefaultsForGivenState: function setChecksToDefaultsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setChecksToDefaultsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  setChecksAccordingToUserDefinedFilterForGivenState: function setChecksAccordingToUserDefinedFilterForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setChecksAccordingToUserDefinedFilterForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  setFiveCardHandValuesToDefaults: function setFiveCardHandValuesToDefaults(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setFiveCardHandValuesToDefaults(state, payload);
  },
  updateWeightOfFiveCardHand: function updateWeightOfFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].updateWeightOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newWeight: payload.newWeight
    });

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallySetHandsThatPassThroughFilter(state, {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        fiveCardHandId: payload.fiveCardHandId
      });
    }
  },

  // five card hands section other
  toggleCollapsedValueOfFiveCardHandParent: function toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent);
  },
  setProbabilitiesOfFiveCardHands: function setProbabilitiesOfFiveCardHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setProbabilitiesOfFiveCardHands(state, payload);
  },
  setHandAndDrawInfo: function setHandAndDrawInfo(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setHandAndDrawInfo(state, payload);
  },
  setHitPercentage: function setHitPercentage(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex]._hitPercentage = payload.hitPercentage;
  },
  setPercentagesOfSpecificHandsThatAreSelected: function setPercentagesOfSpecificHandsThatAreSelected(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setPercentagesOfSpecificHandsThatAreSelected(state, payload);
  },

  // simulations
  setLastSimulationInfo: function setLastSimulationInfo(state, playerStateIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setLastSimulationInfo(state, playerStateIndex);
  },
  setHitPercentageBeingComputed: function setHitPercentageBeingComputed(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].hitPercentageBeingComputed = payload.value;
  },
  updateEquityResults: function updateEquityResults(state, payload) {
    var equity = void 0;
    var wins = void 0;
    var ties = void 0;
    var winFractions = void 0;
    var numberOfSimulations = payload.numberOfSimulations;
    var playerStateIndex = payload.playerStateIndex;

    state.players.forEach(function (player, playerIndex) {
      wins = payload.simulationResults[playerIndex + 1].wins;
      ties = payload.simulationResults[playerIndex + 1].ties;
      winFractions = payload.simulationResults[playerIndex + 1].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = (wins + winFractions) / numberOfSimulations * 100;
      equity -= equity * (payload.rakePercentage / 100) + equity * (payload.tipPercentage / 100);
      player.states[playerStateIndex].equity = equity.roundToTwoDecimalPlaces();
      player.states[playerStateIndex].winPercentage = wins / numberOfSimulations * 100;
      player.states[playerStateIndex].tiePercentage = ties / numberOfSimulations * 100;
    });
  },
  clearMatchingSpecificHands: function clearMatchingSpecificHands(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.clearMatchingSpecificHands();
  }
};

var actions = {
  setHitPercentage: function setHitPercentage(context, payload) {
    // doing this as an action rather than a mutation so that I could update the UI with "Computing hit percentage..."
    var hitPercentage = void 0;
    var hits = 0;
    var playerState = context.state.players.find(payload.playerIndex).states[payload.playerStateIndex];
    var weightOfLargestMatchingFiveCardHand = void 0;

    context.commit('setHitPercentageBeingComputed', {
      playerIndex: payload.playerIndex,
      playerStateIndex: payload.playerStateIndex,
      value: true
    });
    setTimeout(function () {
      // using setTimeout so UI updates
      playerState.handAndDrawInfo.forEach(function (_ref) {
        var handInfo = _ref.handInfo,
            drawInfo = _ref.drawInfo;

        weightOfLargestMatchingFiveCardHand = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].results.getWeightOfLargestMatchingFiveCardHand(handInfo, drawInfo, playerState.fiveCardHands.checkedHands);
        hits += weightOfLargestMatchingFiveCardHand / 100;
      });
      hitPercentage = (hits / playerState.handAndDrawInfo.length * 100).roundToTwoDecimalPlaces();
      context.commit('setHitPercentage', {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        hitPercentage: hitPercentage
      });
      context.commit('setHitPercentageBeingComputed', {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        value: false
      });
    }, 100);
  }
};

function _getSavedScenarios() {
  if (localStorage.getItem('hitCalculatorSavedScenarios')) {
    return JSON.parse(localStorage.getItem('hitCalculatorSavedScenarios'));
  }

  return [];
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "3Z9w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('errors-alert',{attrs:{"errors":_vm.errorsFromBackend},on:{"clear":function($event){return _vm.clearAlert()}}}),_vm._v(" "),_c('form',[_c('section',{staticClass:"form-group",class:{ 'has-error': (_vm.submitAttempted && _vm.oldPasswordErrorMessage) }},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Old password\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.oldPassword),expression:"oldPassword"}],staticClass:"form-control input-lg",attrs:{"required":"","type":"text"},domProps:{"value":(_vm.oldPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.oldPassword=$event.target.value}}})]),_vm._v(" "),(_vm.submitAttempted && _vm.oldPasswordErrorMessage)?_c('p',{staticClass:"help-block"},[_vm._v("\n        "+_vm._s(_vm.oldPasswordErrorMessage)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"form-group",class:{ 'has-error': (_vm.submitAttempted && _vm.newPasswordErrorMessage) }},[_c('label',{staticClass:"control-label"},[_vm._v("\n        New password\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"form-control input-lg",attrs:{"required":"","type":"text"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v("\n        Must be at least eight characters "),(_vm.newPassword.length < 8)?_c('span',[_vm._v("ℹ️")]):_c('span',[_vm._v("✅")]),_vm._v(".\n        "),_c('span',{staticClass:"xkcd-toggle",on:{"click":function($event){$event.preventDefault();_vm.xkcdVisible = !_vm.xkcdVisible}}},[_vm._v("\n          Inspiration "),(!_vm.xkcdVisible)?_c('span',[_vm._v("▾")]):_c('span',[_vm._v("▴")])])]),_vm._v(" "),(_vm.submitAttempted && _vm.newPasswordErrorMessage)?_c('p',{staticClass:"help-block"},[_vm._v("\n        "+_vm._s(_vm.newPasswordErrorMessage)+"\n      ")]):_vm._e()]),_vm._v(" "),(_vm.xkcdVisible)?_c('img',{attrs:{"src":"/static/xkcd-password-strength.png"}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":function($event){$event.preventDefault();return _vm.changePassword()}}},[_vm._v("\n      Change password\n    ")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Change password")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3fsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-hover"},[_vm._m(0),_vm._v(" "),_c('tbody',[_vm._m(1),_vm._v(" "),_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/help/equity-calculator","target":"_blank"}},[_vm._v("Equity Calculator")])],1),_vm._v(" "),_c('td',[_vm._v("14 days")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")])]),_vm._v(" "),_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/help/hit-calculator","target":"_blank"}},[_vm._v("Hit Calculator")])],1),_vm._v(" "),_c('td',[_vm._v("14 days")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")])]),_vm._v(" "),_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/help/should-you-bluff","target":"_blank"}},[_vm._v("Should You Bluff?")])],1),_vm._v(" "),_c('td',[_vm._v("14 days")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")])]),_vm._v(" "),_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/help/should-you-call","target":"_blank"}},[_vm._v("Should You Call?")])],1),_vm._v(" "),_c('td',[_vm._v("14 days")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")])]),_vm._v(" "),_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/help/equity-matrix","target":"_blank"}},[_vm._v("Equity Matrix")])],1),_vm._v(" "),_c('td',[_vm._v("14 days")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("✅")])]),_vm._v(" "),_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/help/range-constructor","target":"_blank"}},[_vm._v("Range Constructor")])],1),_vm._v(" "),_c('td',[_vm._v("14 days")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("✅")])]),_vm._v(" "),_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/help/three-bet-cbet-explorer","target":"_blank"}},[_vm._v("Threebet-Cbet Explorer")])],1),_vm._v(" "),_c('td',[_vm._v("14 days")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("✅")])]),_vm._v(" "),_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/help/breakeven-percentage-for-bluffing-the-turn","target":"_blank"}},[_vm._v("Breakeven Percentage For Bluffing The Turn")])],1),_vm._v(" "),_c('td',[_vm._v("14 days")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("✅")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Free trial")]),_vm._v(" "),_c('th',[_vm._v("Basic")]),_vm._v(" "),_c('th',[_vm._v("Premium")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Price")]),_vm._v(" "),_c('td',[_vm._v("-")]),_vm._v(" "),_c('td',[_vm._v("$25 for lifetime access")]),_vm._v(" "),_c('td',[_vm._v("$75 for lifetime access")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3hq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-navbar',
  computed: {
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    },
    onBasicPlan: function onBasicPlan() {
      return this.$store.state.account.user.auth.includes('basic');
    },
    basicOrPremium: function basicOrPremium() {
      return this.$store.getters['account/basicOrPremium'];
    },
    purchasedShortDeck: function purchasedShortDeck() {
      return this.$store.getters['account/purchasedShortDeck'];
    },
    homeActive: function homeActive() {
      return this.$route.name === 'home';
    }
  },
  methods: {
    logOut: function logOut() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/user/logout').then(function (res) {
        self.$store.dispatch('account/clearUser');
        self.$router.push({ path: '/' });
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),

/***/ "3lPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("/qcN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e22e67e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("BJ9z");
function injectStyle (ssrContext) {
  __webpack_require__("YAIz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e22e67e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e22e67e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3se9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_square__ = __webpack_require__("ZHcg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_constants__ = __webpack_require__("vjYN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grid-selector',
  components: {
    'grid-square': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_square__["a" /* default */]
  },
  props: ['generalHands', 'disabled', 'specificHandsNotAllowed', 'equityMatrix', 'requiredEquity', 'rangeConstructor'],
  data: function data() {
    var self = this;
    var data = {
      clickAndDragContext: null,
      altKeyPressed: false
    };

    $('body').on('mouseup', function () {
      if (self.$data && (self.$data.clickAndDragContext === 'adding' || self.$data.clickAndDragContext === 'removing')) {
        self.$emit('finishedClickAndDrag');
        self.$set(data, 'clickAndDragContext', null);
      }
    });

    $('body').keydown(function (event) {
      if (event.altKey) {
        self.$set(data, 'altKeyPressed', true);
      }
    }).keyup(function (event) {
      self.$set(data, 'altKeyPressed', false);
    });

    return data;
  },
  computed: {
    gridOfGeneralHands: function gridOfGeneralHands() {
      return __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].gridOfGeneralHandStrings.map(function (rowOfGeneralHandStrings) {
        return this._getRowOfGeneralHands(rowOfGeneralHandStrings, this.generalHands);
      }, this);
    }
  },
  methods: {
    _getRowOfGeneralHands: function _getRowOfGeneralHands(rowOfGeneralHandStrings, generalHands) {
      return rowOfGeneralHandStrings.map(function (generalHandString) {
        return generalHands.find(generalHandString);
      });
    },
    selectGeneralHand: function selectGeneralHand(generalHandString) {
      this.$emit('selectGeneralHand', generalHandString);
      this.clickAndDragContext = 'adding';
    },
    deselectGeneralHand: function deselectGeneralHand(generalHandString) {
      this.$emit('deselectGeneralHand', generalHandString);
      this.clickAndDragContext = 'removing';
    },
    selectAscendingGeneralHands: function selectAscendingGeneralHands(generalHandStringOfGridSquareThatWasClicked) {
      var ascendingGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].hands.getAscendingGeneralHandStrings(generalHandStringOfGridSquareThatWasClicked);

      this.$emit('selectGeneralHands', ascendingGeneralHandStrings);
    },
    deselectAscendingGeneralHands: function deselectAscendingGeneralHands(generalHandStringOfGridSquareThatWasClicked) {
      var ascendingGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].hands.getAscendingGeneralHandStrings(generalHandStringOfGridSquareThatWasClicked);

      this.$emit('deselectGeneralHands', ascendingGeneralHandStrings);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "3wfu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "5c4ec3028558d3ce6ba3.worker.js");
};

/***/ }),

/***/ "4/gO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_selector__ = __webpack_require__("G1lD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_grid_selector__ = __webpack_require__("9N94");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_hands_GeneralHands__ = __webpack_require__("udlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_settings_validators__ = __webpack_require__("F892");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tiers-settings',
  components: {
    'grid-selector': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_selector__["a" /* default */],
    'short-deck-grid-selector': __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_grid_selector__["a" /* default */]
  },
  data: function data() {
    return {
      tiers: null,
      isHelpVisible: false
    };
  },
  computed: {
    shortDeck: function shortDeck() {
      return this.$store.getters['account/purchasedShortDeck'];
    }
  },
  mounted: function mounted() {
    this.initialize();
  },
  methods: {
    // initialize
    initialize: function initialize() {
      var tiers = this._constructTiers();

      this._setHandsInRangeForTiers(tiers);
      this.tiers = tiers;
    },
    _constructTiers: function _constructTiers() {
      var tiers = [];

      __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.times(8, function () {
        tiers.push({
          generalHands: new __WEBPACK_IMPORTED_MODULE_2__services_hands_GeneralHands__["a" /* default */]()
        });
      });

      return tiers;
    },
    _setHandsInRangeForTiers: function _setHandsInRangeForTiers(tiers) {
      tiers.forEach(function (tier, i) {
        this.__setHandsInRangeForTier(tier, i);
      }, this);
    },
    __setHandsInRangeForTier: function __setHandsInRangeForTier(tier, i) {
      tier.generalHands.forEach(function (generalHand) {
        generalHand.forEachSpecificHandInRange(function (specificHand) {
          specificHand.weight = 0;
        });
      });
      this.$store.state.account.user.settings.general.tiers[i].forEach(function (generalHandString) {
        this.selectGeneralHand(generalHandString, tier.generalHands);
      }, this);
    },

    // range
    selectGeneralHand: function selectGeneralHand(generalHandString, generalHands) {
      var generalHand = generalHands.find(generalHandString);

      generalHand.forEachPossibleSpecificHand(function (specificHand) {
        if (!specificHand.inRange) {
          specificHand.weight = 100;
        }
      });
    },
    deselectGeneralHand: function deselectGeneralHand(generalHandString, generalHands) {
      var generalHand = generalHands.find(generalHandString);

      generalHand.forEachSpecificHandInRange(function (specificHand) {
        specificHand.weight = 0;
      });
    },
    selectGeneralHands: function selectGeneralHands(generalHandStrings, generalHands) {
      generalHandStrings.forEach(function (generalHandString) {
        this.selectGeneralHand(generalHandString, generalHands);
      }, this);
    },
    deselectGeneralHands: function deselectGeneralHands(generalHandStrings, generalHands) {
      generalHandStrings.forEach(function (generalHandString) {
        this.deselectGeneralHand(generalHandString, generalHands);
      }, this);
    },

    // buttons
    save: function save() {
      var self = this;
      var user = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.$store.state.account.user);
      var tiersGeneralHandsInRangeArray = this._getTiersGeneralHandsInRangeArray();

      if (!__WEBPACK_IMPORTED_MODULE_3__services_settings_validators__["a" /* default */].areTiersValid(tiersGeneralHandsInRangeArray)) {
        alert('Make sure that you didn\'t leave any of the ranges empty.');
        return;
      }

      user.settings.general.tiers = tiersGeneralHandsInRangeArray;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    _getTiersGeneralHandsInRangeArray: function _getTiersGeneralHandsInRangeArray() {
      var tiersGeneralHandsInRangeArray = [];

      this.tiers.forEach(function (tier, i) {
        tiersGeneralHandsInRangeArray[i] = [];
        tier.generalHands.forEach(function (generalHand) {
          if (generalHand.inRange) {
            tiersGeneralHandsInRangeArray[i].push(generalHand.string);
          }
        });
      });

      return tiersGeneralHandsInRangeArray;
    },
    reset: function reset() {
      var self = this;
      var user = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(this.$store.state.account.user);
      var defaultTiersGeneralHandsInRangeArray = [['aa', 'kk', 'qq', 'jj', 'aks'], ['tt', 'aqs', 'ajs', 'kqs', 'ako'], ['99', 'ats', 'kjs', 'qjs', 'jts', 'aqo'], ['88', 'kts', 'qts', 'j9s', 't9s', '98s', 'ajo', 'kqo'], ['77', 'a9s', 'a8s', 'a7s', 'a6s', 'a5s', 'a4s', 'a3s', 'a2s', 'q9s', 't8s', '97s', '87s', '76s', 'kjo', 'qjo', 'jto'], ['66', '55', 'k9s', 'j8s', '86s', '75s', '54s', 'ato', 'kto', 'qto'], ['44', '33', '22', 'k8s', 'k7s', 'k6s', 'k5s', 'k4s', 'k3s', 'k2s', 'q8s', 't7s', '65s', '64s', '53s', '43s', 'j9o', 't9o', '98o'], ['j7s', '96s', '85s', '74s', '42s', '32s', 'a9o', 'k9o', 'q9o', 'j8o', 't8o', '87o', '76o', '65o', '54o']];

      user.settings.general.tiers = defaultTiersGeneralHandsInRangeArray;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        self._setHandsInRangeForTiers(self.tiers);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "4678":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4CCR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_number_of_simulations_vue__ = __webpack_require__("n79P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7fe6f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_number_of_simulations_vue__ = __webpack_require__("BKMn");
function injectStyle (ssrContext) {
  __webpack_require__("lw+r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c7fe6f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_number_of_simulations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7fe6f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_number_of_simulations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4Gme":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'horizontal-set-weight-to-apply-to-added-hands-basic',
  components: {
    'vue-slider': __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  },
  props: ['weightToApplyToAddedHands', 'disabled', 'shortDeck'],
  data: function data() {
    var width = this.shortDeck ? 350 : 415;

    return {
      weightToApplyToAddedHandsVModel: this.weightToApplyToAddedHands,
      sliderOptions: {
        min: 5,
        interval: 5,
        width: width,
        height: 4,
        tooltip: 'hover'
      }
    };
  },
  watch: {
    weightToApplyToAddedHands: function weightToApplyToAddedHands(newVal) {
      this.weightToApplyToAddedHandsVModel = newVal;
    }
  },
  methods: {
    refreshVueSlider: function refreshVueSlider() {
      var self = this;

      setTimeout(function () {
        // needs a setTimeout for some reason
        self.$refs.vueSlider.refresh();
      }, 0);
    }
  }
});

/***/ }),

/***/ "4L6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blog_vue__ = __webpack_require__("XlcI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5914b7f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blog_vue__ = __webpack_require__("5uS2");
function injectStyle (ssrContext) {
  __webpack_require__("Yudz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5914b7f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5914b7f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4P0h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_blog_subscribe_to_blog__ = __webpack_require__("bnhV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog_prior-probability-and-estimating-your-winrate',
  components: {
    'subscribe-to-blog': __WEBPACK_IMPORTED_MODULE_0__components_blog_subscribe_to_blog__["a" /* default */]
  }
});

/***/ }),

/***/ "4Tse":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-selector-help-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */]
  }
});

/***/ }),

/***/ "4Ypn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_set_hand_weights_modal_vue__ = __webpack_require__("XP0q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da79868_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_set_hand_weights_modal_vue__ = __webpack_require__("tEHc");
function injectStyle (ssrContext) {
  __webpack_require__("+3eH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6da79868"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_set_hand_weights_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da79868_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_set_hand_weights_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4mCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'percentages-or-combos',
  props: ['percentagesOrCombos', 'numberOfSpecificHandsInRange', 'numberOfPossibleSpecificHands']
});

/***/ }),

/***/ "4o60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"vertical-set-weight-to-apply-to-added-hands"},[(_vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic')?_c('vertical-set-weight-to-apply-to-added-hands-basic',{ref:"basicSlider",attrs:{"weightToApplyToAddedHands":_vm.weightToApplyToAddedHands,"disabled":_vm.disabled,"shortDeck":_vm.shortDeck},on:{"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}}):_vm._e(),_vm._v(" "),(_vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings')?_c('vertical-set-weight-to-apply-to-added-hands-with-settings',{ref:"sliderWithSettings",attrs:{"disabled":_vm.disabled},on:{"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "50vp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_togglable_section__ = __webpack_require__("mXeB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breakeven-percentage-for-bluffing-the-turn-inputs',
  props: ['state', 'authorized'],
  components: {
    'togglable-section': __WEBPACK_IMPORTED_MODULE_0__components_utilities_togglable_section__["a" /* default */]
  }
});

/***/ }),

/***/ "5A+w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_log_double_slider_selector_vue__ = __webpack_require__("9hHK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2358ed35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_log_double_slider_selector_vue__ = __webpack_require__("B/5w");
function injectStyle (ssrContext) {
  __webpack_require__("2c+o")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2358ed35"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_log_double_slider_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2358ed35_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_log_double_slider_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5Au4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bluff-size-selection-help-section well help-section"},[_c('h3',[_vm._v("Why am I being asked this?")]),_vm._v(" "),_c('p',[_vm._v("The goal of this guided analysis is to determine whether bluffing is a profitable play. But that is misleading. \"Is bluffing profitable?\" isn't really the question. There are really several different questions:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Is bluffing 1/3 pot profitable?")]),_vm._v(" "),_c('li',[_vm._v("Is bluffing 1/2 pot profitable?")]),_vm._v(" "),_c('li',[_vm._v("Is bluffing 2/3 pot profitable?")]),_vm._v(" "),_c('li',[_vm._v("Is bluffing 3/4 pot profitable?")]),_vm._v(" "),_c('li',[_vm._v("Is bluffing full pot profitable?")]),_vm._v(" "),_c('li',[_vm._v("Is bluffing 1.5x pot profitable?")]),_vm._v(" "),_c('li',[_vm._v("Is bluffing 2x pot profitable?")])]),_vm._v(" "),_c('p',[_vm._v("The answers to those questions very well may be different, so we need to be clear on which specific question you're asking. Which bluff size you're exploring? Are you exploring whether a 1/2 pot bluff is profitable, or whether a 1.5x pot overbet bluff is profitable?")]),_vm._v(" "),_c('p',[_vm._v("In reality, you should probably be asking yourself all of these questions, not just one. Don't settle for "),_c('em',[_vm._v("a")]),_vm._v(" profitable play. Seek out "),_c('em',[_vm._v("the most")]),_vm._v(" profitable play.")]),_vm._v(" "),_c('h3',[_vm._v("How do I know which size I should explore? What do you mean by \"immediately profitable\"?")]),_vm._v(" "),_c('p',[_vm._v("It'll make more sense when you scroll down to the conclusion section and read through it.")]),_vm._v(" "),_c('p',[_vm._v("Note that when you try a bigger bluff size, say, 1.5x pot instead of 3/4 pot, you're going to get more folds - you're going to succeed more often - but the cost of failure is also larger, because you're risking more chips. If the pot is $100, you lose $150 when your 1.5x pot bluff fails, but you only lose $75 when your 3/4 pot bluff fails. So you need to ask yourself whether the trade off of going bigger is worth it. Maybe if you bump it up from 1/2 pot to 3/4 pot you'll get "),_c('em',[_vm._v("a ton")]),_vm._v(" more folds, enough to justify the added cost of failure. Or  maybe not.")]),_vm._v(" "),_c('p',[_vm._v("The question is similar to the question a businessperson needs to ask themselves when considering whether it is worth investing in a new product. Say, if you're Google and you want to decide whether or not to invest in Google Fiber. Maybe the investment pays off, maybe it doesn't. If you throw more money into the investment, it's more likely that it'll succeed, but you also lose more money if you fail. Does spending another $25M increase the probability of success enough to justify the cost? Or does it not \"move the needle\" enough? That's the same question you have to ask yourself when you're thinking about how much to bluff. Does bumping it up to 3/4 pot \"move the needle\" enough to justify the cost?")]),_vm._v(" "),_c('h3',[_vm._v("Where do these \"immediately profitable\" breakeven percentages come from?")]),_vm._v(" "),_c('p',[_vm._v("The overarching formula is "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Here's an example. If the pot is $2 and you want to try a 1/2 pot bluff, your bluff would be $1. You're risking $1 to win $2.")]),_vm._v(" "),_c('pre',[_vm._v("risk = $1\nreward = $2\nbreakeven percentage = risk / (risk + reward)\nbreakeven percentage = 1 / (1 + 2)\nbreakeven percentage = 1 / 3\nbreakeven percentage = 33.3%\n")]),_vm._v(" "),_c('p',[_vm._v("This formula actually isn't specific to poker at all. Suppose that the Steelers and Saints are in the Super Bowl and if you bet on the Steelers, the casino will give you $2 for every $1 you bet if you win, plus your money back. So if you bet $100, you'd get your $100 back, plus another $200. How often do you need to win this bet to break even? It's the same thing: "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(".")]),_vm._v(" "),_c('pre',[_vm._v("risk = $100\nreward = $200\nbreakeven percentage = risk / (risk + reward)\nbreakeven percentage = 100 / (100 + 200)\nbreakeven percentage = 100 / 300\nbreakeven percentage = 33.3%\n")]),_vm._v(" "),_c('p',[_vm._v("As a sanity check, ask yourself what happens if you win the bet once and lose it twice. First you win, and you're up $200. Then you lose, and you're up $100. Then you lose again, and you're even. When you win 33.3% of the time, you break even.")]),_vm._v(" "),_c('p',[_vm._v("And for those of you interested in the math, here is the derivation. We start off with "),_c('code',[_vm._v("(reward)(% success) = (risk)(1 - %success)")]),_vm._v(" because we're interested in knowing what "),_c('code',[_vm._v("% success")]),_vm._v(" leads to the risk balancing out the reward. From there it's just a little algebra.")]),_vm._v(" "),_c('pre',[_vm._v("(reward)(%success) = (risk)(1 - %success)\n(reward)(%success) = risk - (risk)(%success)\n(reward)(%success) + (risk)(%success) = risk\n%success(reward + risk) = risk\n%success = risk / (risk + reward)\n")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5CCh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__ = __webpack_require__("oox5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-hole-cards-selector',
  components: {
    'short-deck-individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__["a" /* default */]
  },
  props: ['presetHoleCards', 'presetCommunityCards', 'popoverDirectionClass', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setPresetHoleCard: function setPresetHoleCard(payload, position) {
      this.$emit('setPresetHoleCard', {
        card: payload.card,
        position: position
      });

      if (position === 'holeCardOne') {
        this.$refs.holeCardTwo.toggle();
        payload.e.stopPropagation();
      }
    }
  }
});

/***/ }),

/***/ "5D18":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Ec5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_river_steps_vue__ = __webpack_require__("xlOY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa40e46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_river_steps_vue__ = __webpack_require__("w7C2");
function injectStyle (ssrContext) {
  __webpack_require__("SMyf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_river_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fa40e46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_river_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5IUT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5Tjn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bluff-size-selection-help-section'
});

/***/ }),

/***/ "5cB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"short-deck-preset-hole-cards-selector"},[_c('span',{staticClass:"short-deck-preset-hole-cards-text"},[_vm._v("Your cards:")]),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"holeCardOne",attrs:{"cardString":_vm.presetHoleCards.holeCardOne,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setPresetHoleCard($event, 'holeCardOne')},"deselect":function($event){return _vm.$emit('removePresetHoleCard', 'holeCardOne')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"holeCardTwo",attrs:{"cardString":_vm.presetHoleCards.holeCardTwo,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setPresetHoleCard($event, 'holeCardTwo')},"deselect":function($event){return _vm.$emit('removePresetHoleCard', 'holeCardTwo')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5iEU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"made-hands-and-draws"},[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Made hands and draws")])]),_vm._v(" "),_c('div',{staticClass:"well"},[_c('a',{attrs:{"href":"#made-hands"}},[_vm._v("Made hands:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#flush"}},[_vm._v("Flush:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#flush-1"}},[_vm._v("Nut, second nut, third nut, and weak flush")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#flush-2"}},[_vm._v("Using two hole cards vs. using one hole card")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#three-of-a-kind"}},[_vm._v("Three of a kind:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#three-of-a-kind-1"}},[_vm._v("Set vs. trips")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#three-of-a-kind-2"}},[_vm._v("Top vs. second vs. third vs. fourth vs. middle vs. bottom set")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#two-pair"}},[_vm._v("Two pair:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#two-pair-1"}},[_vm._v("Using top board card")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#two-pair-2"}},[_vm._v("Weak")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#two-pair-3"}},[_vm._v("Two pair with a pair on board")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#two-pair-4"}},[_vm._v("Two pair on board")])])])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#pair"}},[_vm._v("Pair:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#pair-1"}},[_vm._v("Overpair")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#pair-2"}},[_vm._v("Top pair, top kicker")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#pair-3"}},[_vm._v("Good kicker vs. weak kicker")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#pair-4"}},[_vm._v("Pocket pair under top pair")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#pair-5"}},[_vm._v("Second pair vs. middle pair vs. weak pair")])])])])]),_vm._v(" "),_c('a',{attrs:{"href":"#draws"}},[_vm._v("Draws:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#draws-1"}},[_vm._v("Using at least one hole card")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#draws-2"}},[_vm._v("Flush draw")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#draws-3"}},[_vm._v("Open ended straight draw (OESD)")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#draws-4"}},[_vm._v("Double gutshot")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#draws-5"}},[_vm._v("Gutshot")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#draws-6"}},[_vm._v("Overcards")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#draws-7"}},[_vm._v("Backdoor draws")])])])]),_vm._v(" "),_c('h1',{attrs:{"id":"made-hands"}},[_vm._v("Made hands")]),_vm._v(" "),_c('h2',{attrs:{"id":"flush"}},[_vm._v("Flush")]),_vm._v(" "),_c('h3',{attrs:{"id":"flush-1"}},[_vm._v("Nut, second nut, third nut, and weak flush")]),_vm._v(" "),_c('p',[_vm._v("There is a difference between an ace high flush and the nut flush. On Ac7c6c3h1d, if you have JcTc, you have an ace high flush because the best five card hand you can make is AcJcTc7c6c, but you don't have the nut flush. If you had the Kc, you'd have the nut flush. The Qc would thus be the second nut flush, Jc is the third nut flush, and anything less would just be considered a \"weak flush\".")]),_vm._v(" "),_c('p',[_vm._v("Note that the nut flush could range all the way down to an eight high flush. On KcQcJcTc2h, the 8c is the highest card you can have that makes a flush. Ac makes a royal flush and 9c makes a straight flush. Similarly, the second nut flush can range all the way down to a seven high, and the third nut flush can range all the way down to a six high.")]),_vm._v(" "),_c('p',[_vm._v("As you can see from the above example, potential royal and straight flushes will \"push down\" the nut levels.")]),_vm._v(" "),_c('h3',{attrs:{"id":"flush-2"}},[_vm._v("Using two hole cards vs. using one hole card")]),_vm._v(" "),_c('p',[_vm._v("Basic examples:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Using two hole cards: Ac4c on Kc9c3s7cJh")]),_vm._v(" "),_c('li',[_vm._v("Using one hole card: Ac4d on Kc9c3s7cJc")])]),_vm._v(" "),_c('p',[_vm._v("Edge cases:")]),_vm._v(" "),_c('p',[_vm._v("Suppose you have AcKc on JcTc7c6c5h. It wouldn't be considered \"using two hole cards\" even though the best 5 card hand (AcKcJcTc7c) uses two of your hole cards (AcKc). Why? Well, imagine that you had Ac2c instead of AcKc. Now you don't have the Kc as your second kicker anymore. But does that matter? No, it doesn't matter. Since you have the Ac, no one else can have an \"ace high flush\", and so you'll never move on to using the second kicker as a tiebreaker. Which means that you're "),_c('em',[_vm._v("effectively")]),_vm._v(" only using one of your hole cards in making your best five card hand.")]),_vm._v(" "),_c('p',[_vm._v("Suppose the board is QcJc9c7c5c:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("If you have Ac2h, it's considered \"using one hole card\". Even though there is a flush already on the board, you have the top kicker.")]),_vm._v(" "),_c('li',[_vm._v("If you have AcKc, it's considered \"using one hole card\" rather than \"using two hole cards\" because the second kicker never comes in to play, as eplained above.")]),_vm._v(" "),_c('li',[_vm._v("If you have 6c4c, it's considered \"using one hole card\" because your 6c can potentially come in to play as the fifth kicker. For example, you'd beat 3c2c.")]),_vm._v(" "),_c('li',[_vm._v("If you have 4c2c, it's considered \"on board\" because your hand is the same hand as the five card hand on the board. Your 4c never comes in to play because there is no such thing as a sixth kicker.")])]),_vm._v(" "),_c('h2',{attrs:{"id":"three-of-a-kind"}},[_vm._v("Three of a kind")]),_vm._v(" "),_c('h3',{attrs:{"id":"three-of-a-kind-1"}},[_vm._v("Set vs. trips")]),_vm._v(" "),_c('p',[_vm._v("A set is when you make three of a kind with a pocket pair. Eg. 55 on JT5 would make a set. That's why they call it \"set mining\" when you call with a pocket pair looking to make three of a kind.")]),_vm._v(" "),_c('p',[_vm._v("Trips is when you make three of a kind when the board is paired (and thus you don't have a pocket pair). Eg. 65 on J55 would make trips.")]),_vm._v(" "),_c('p',[_vm._v("A set is generally "),_c('a',{attrs:{"href":"http://www.thepokerbank.com/articles/questions/sets-and-trips/"}},[_vm._v("considered to be a stronger hand than trips")]),_vm._v(" because it is more concealed. For example, imagine that you flat call the preflop raiser, and the flop comes 997. Since you (most likely) have a lot of hands with nines in your flat calling range, the opponent will be worried that you made three of a kind. But if you have 44 on A94, well, your hand is much more \"hidden\".")]),_vm._v(" "),_c('h3',{attrs:{"id":"three-of-a-kind-2"}},[_vm._v("Top vs. second vs. third vs. fourth vs. middle vs. bottom set")]),_vm._v(" "),_c('p',[_vm._v("Consider a flop of QT8:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("QQ = top set")]),_vm._v(" "),_c('li',[_vm._v("TT = middle set (not second set)")]),_vm._v(" "),_c('li',[_vm._v("88 = bottom set (not third set)")])]),_vm._v(" "),_c('p',[_vm._v("Consider a board of QT86:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("QQ = top set")]),_vm._v(" "),_c('li',[_vm._v("TT = second set (not middle set)")]),_vm._v(" "),_c('li',[_vm._v("88 = third set (not middle set)")]),_vm._v(" "),_c('li',[_vm._v("66 = bottom set (not fourth set)")])]),_vm._v(" "),_c('p',[_vm._v("Consider a board of QT864:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("QQ = top set")]),_vm._v(" "),_c('li',[_vm._v("TT = second set (not middle set)")]),_vm._v(" "),_c('li',[_vm._v("88 = third set (not middle set)")]),_vm._v(" "),_c('li',[_vm._v("66 = fourth set (not middle set)")]),_vm._v(" "),_c('li',[_vm._v("44 = bottom set")])]),_vm._v(" "),_c('h2',{attrs:{"id":"two-pair"}},[_vm._v("Two pair")]),_vm._v(" "),_c('h3',{attrs:{"id":"two-pair-1"}},[_vm._v("Using top board card")]),_vm._v(" "),_c('p',[_vm._v("Examples:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("AT on AT872")]),_vm._v(" "),_c('li',[_vm._v("A8 on AT872")]),_vm._v(" "),_c('li',[_vm._v("A7 on AT872")]),_vm._v(" "),_c('li',[_vm._v("A2 on AT872")]),_vm._v(" "),_c('li',[_vm._v("AT on AT882 because your two pair is aces and tens, not aces and eights")])]),_vm._v(" "),_c('h3',{attrs:{"id":"two-pair-2"}},[_vm._v("Weak")]),_vm._v(" "),_c('p',[_vm._v("Examples:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("T8 on AT872")]),_vm._v(" "),_c('li',[_vm._v("T7 on AT872")]),_vm._v(" "),_c('li',[_vm._v("T2 on AT872")]),_vm._v(" "),_c('li',[_vm._v("87 on AT872")]),_vm._v(" "),_c('li',[_vm._v("82 on AT872")]),_vm._v(" "),_c('li',[_vm._v("72 on AT872")]),_vm._v(" "),_c('li',[_vm._v("T8 on AT822 because your two pair is tens and eights, not tens and twos")])]),_vm._v(" "),_c('h3',{attrs:{"id":"two-pair-3"}},[_vm._v("Two pair with a pair on board (subcategory of \"Using board card\")")]),_vm._v(" "),_c('p',[_vm._v("Examples:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("AK on ATT87")]),_vm._v(" "),_c('li',[_vm._v("KK on ATT87")]),_vm._v(" "),_c('li',[_vm._v("A8 on ATT87, because your two pair is aces and tens, not aces and eights")]),_vm._v(" "),_c('li',[_vm._v("AK on KTT88, because your two pair is kings and tens, not tens and eights")]),_vm._v(" "),_c('li',[_vm._v("A9 on TT988, because your two pair is tens and nines, not tens and eights")]),_vm._v(" "),_c('li',[_vm._v("AA on TT883, because your two pair is aces and tens, not tens and eights")]),_vm._v(" "),_c('li',[_vm._v("99 on TT883, because your two pair is tens and nines, not tens and eights")])]),_vm._v(" "),_c('h3',{attrs:{"id":"two-pair-4"}},[_vm._v("Two pair on board (subcategory of \"Using board card\")")]),_vm._v(" "),_c('p',[_vm._v("Examples:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("AK on JTT88")]),_vm._v(" "),_c('li',[_vm._v("A3 on TT883, because your two pair is tens and eights, not tens and threes")]),_vm._v(" "),_c('li',[_vm._v("44 on TT883, because your two pair is tens and eights, not tens and fours")])]),_vm._v(" "),_c('h2',{attrs:{"id":"pair"}},[_vm._v("Pair")]),_vm._v(" "),_c('h3',{attrs:{"id":"pair-1"}},[_vm._v("Overpair")]),_vm._v(" "),_c('p',[_vm._v("When pocket pair rank is larger than the top board card rank. Eg. QQ on J76.")]),_vm._v(" "),_c('h3',{attrs:{"id":"pair-2"}},[_vm._v("Top pair, top kicker")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Eg. AK on K72")]),_vm._v(" "),_c('li',[_vm._v("Note that the top kicker can get \"pushed down\". Eg. on AKQ72, the top kicker gets \"pushed down\" to be a jack, so top pair top kicker is AJ.")]),_vm._v(" "),_c('li',[_vm._v("Note that when the kicker would complete a straight, it gets \"pushed down\" even more. Eg. on AKQJ7, a ten would make a straight, so the top kicker is a nine, and top pair top kicker is thus A9.")])]),_vm._v(" "),_c('h3',{attrs:{"id":"pair-3"}},[_vm._v("Good kicker vs. weak kicker")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\"Good kicker\" refers to the second or third best kicker. \"Weak kicker\" refers to a kicker that is fourth best or worse.")]),_vm._v(" "),_c('li',[_vm._v("Note that good and weak kickers can get \"pushed down\", as explained in the top pair, top kicker section.")])]),_vm._v(" "),_c('h3',{attrs:{"id":"pair-4"}},[_vm._v("Pocket pair under top pair")]),_vm._v(" "),_c('p',[_vm._v("This refers to a pocket pair between the highest and second highest ranks on the board. Eg. on Q72, JJ, TT, 99, and 88 would all be considered pocket pairs under top pair.")]),_vm._v(" "),_c('p',[_vm._v("Note that on QJ2, there is no available pocket pair under top pair hands (because there is nothing in between a queen and a jack).")]),_vm._v(" "),_c('h3',{attrs:{"id":"pair-5"}},[_vm._v("Second pair vs. middle pair vs. weak pair")]),_vm._v(" "),_c('p',[_vm._v("Consider a flop of QT8:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("AT = middle pair (not second pair)")]),_vm._v(" "),_c('li',[_vm._v("99 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("A8 = weak pair")]),_vm._v(" "),_c('li',[_vm._v("77 = weak pair")])]),_vm._v(" "),_c('p',[_vm._v("Consider a board of QT86:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("AT = second pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("99 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("A8 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("77 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("A6 = weak pair")]),_vm._v(" "),_c('li',[_vm._v("55 = weak pair")])]),_vm._v(" "),_c('p',[_vm._v("Consider a board of QT864:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("AT = second pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("99 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("A8 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("77 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("A6 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("55 = weak pair (not middle pair)")]),_vm._v(" "),_c('li',[_vm._v("A4 = weak pair")]),_vm._v(" "),_c('li',[_vm._v("33 = weak pair")])]),_vm._v(" "),_c('h1',{attrs:{"id":"draws"}},[_vm._v("Draws")]),_vm._v(" "),_c('p',[_vm._v("Also see "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/Draw_(poker)"}},[_vm._v("https://en.wikipedia.org/wiki/Draw_(poker)")]),_vm._v(".")]),_vm._v(" "),_c('h3',{attrs:{"id":"draws-1"}},[_vm._v("Using at least one hole card")]),_vm._v(" "),_c('p',[_vm._v("Draws don't count unless you make the draw using at least one of your hole cards. For example, if you have KcJs on Qd8d7d2d, you technically do have a flush draw, but since the flush draw is on the board, so does everyone else, and thus it doesn't count as "),_c('em',[_vm._v("you")]),_vm._v(" having a flush draw.")]),_vm._v(" "),_c('h3',{attrs:{"id":"draws-2"}},[_vm._v("Flush draw")]),_vm._v(" "),_c('p',[_vm._v("This refers to a four card flush draw. Eg. Ac4c on QcJc7h.")]),_vm._v(" "),_c('p',[_vm._v("See "),_c('a',{attrs:{"href":"#flush-1"}},[_vm._v("Made hands / Flush / Nut, second nut, third nut, and weak flush")]),_vm._v(" for the difference between nut, second nut, third nut, and weak flush draws.")]),_vm._v(" "),_c('h3',{attrs:{"id":"draws-3"}},[_vm._v("Open ended straight draw")]),_vm._v(" "),_c('p',[_vm._v("Eg. T9 on 872. You can make a straight in each direction - with a jack or a six.")]),_vm._v(" "),_c('h3',{attrs:{"id":"draws-4"}},[_vm._v("Double gutshot")]),_vm._v(" "),_c('p',[_vm._v("Eg. J5 on 987. You can make a straight with a ten or a six.")]),_vm._v(" "),_c('p',[_vm._v("Note that you have eight outs to a straight, just like you do with an open ended straight draw.")]),_vm._v(" "),_c('p',[_vm._v("Also note that double gut shots are stronger hands than open ended straight draws because they are "),_c('a',{attrs:{"href":"http://pokerterms.com/double-belly-buster.html"}},[_vm._v("more concealed")]),_vm._v(".")]),_vm._v(" "),_c('h3',{attrs:{"id":"draws-5"}},[_vm._v("Gutshot")]),_vm._v(" "),_c('p',[_vm._v("When you are one card away from a straight (not two). For example:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("T9 on 762 (an 8 is your only out to a straight)")]),_vm._v(" "),_c('li',[_vm._v("A5 on J32 (a 4 is your only out to a straight)")])]),_vm._v(" "),_c('h3',{attrs:{"id":"draws-6"}},[_vm._v("Overcards")]),_vm._v(" "),_c('p',[_vm._v("Cards that are higher than the top board card. For example:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Two overcards: AK on J73")]),_vm._v(" "),_c('li',[_vm._v("One overcard: AT on J73")])]),_vm._v(" "),_c('p',[_vm._v("Overcards are a draw in the sense that you are drawing to the made hand of top pair, rather than to a made hand like a flush or straight.")]),_vm._v(" "),_c('h3',{attrs:{"id":"draws-7"}},[_vm._v("Backdoor draws")]),_vm._v(" "),_c('p',[_vm._v("A draw where you are two outs away from your made hand. Of course, it is a lot harder to hit two outs than it is to hit one, so backdoor draws are significantly weaker than regular draws.")]),_vm._v(" "),_c('p',[_vm._v("Examples:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Backdoor flush draw: Ac4c on Qc9h4d (you need two clubs to make a flush)")]),_vm._v(" "),_c('li',[_vm._v("Backdoor straight draw KQ on J32 (you need two cards to make a straight; AT or T9 will do)")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ihg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_result_table_vue__ = __webpack_require__("hf1u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18040f68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_result_table_vue__ = __webpack_require__("VKLz");
function injectStyle (ssrContext) {
  __webpack_require__("kR7L")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18040f68"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_result_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18040f68_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_result_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5mhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_equity_calculator_insights__ = __webpack_require__("X/7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_short_deck_short_deck_hand_range__ = __webpack_require__("9xGn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hand_range_equity_results__ = __webpack_require__("KFpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_equity_calculator_narrow_range_modal__ = __webpack_require__("h/CU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_equity_calculator_controls__ = __webpack_require__("zMxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sharable_url_modal__ = __webpack_require__("hu4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_save_scenario_modal__ = __webpack_require__("Nr+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_onboarding_modal__ = __webpack_require__("iexb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_help_icon__ = __webpack_require__("FmIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_simulator_validator__ = __webpack_require__("qY6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_simulator_simulator__ = __webpack_require__("pihl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-equity-calculator',
  components: {
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_saved_scenario_alert__["a" /* default */],
    'equity-calculator-insights': __WEBPACK_IMPORTED_MODULE_1__components_equity_calculator_insights__["a" /* default */],
    'short-deck-hand-range': __WEBPACK_IMPORTED_MODULE_2__components_short_deck_short_deck_hand_range__["a" /* default */],
    'equity-results': __WEBPACK_IMPORTED_MODULE_3__components_hand_range_equity_results__["a" /* default */],
    'narrow-range-modal': __WEBPACK_IMPORTED_MODULE_4__components_equity_calculator_narrow_range_modal__["a" /* default */],
    'equity-calculator-controls': __WEBPACK_IMPORTED_MODULE_5__components_equity_calculator_controls__["a" /* default */],
    'sharable-url-modal': __WEBPACK_IMPORTED_MODULE_6__components_sharable_url_modal__["a" /* default */],
    'save-scenario-modal': __WEBPACK_IMPORTED_MODULE_8__components_save_scenario_modal__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_9__components_onboarding_modal__["a" /* default */],
    'help-icon': __WEBPACK_IMPORTED_MODULE_10__components_help_icon__["a" /* default */]
  },
  data: function data() {
    return {
      playerIndexThatExpandedTheNarrowRangeModal: null,
      sharableUrl: {
        url: null,
        approximateWaitTime: null
      }
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.shortDeckEquityCalculator;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      var user = this.$store.state.account.user;

      if (!user.savedScenarios.shortDeckEquityCalculator || !this.authorized) {
        return false;
      }
      return user.savedScenarios.shortDeckEquityCalculator.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    insightsVisible: function insightsVisible() {
      return this.$store.state.account.user.settings.equityCalculator.insightsVisible;
    },
    columnClass: function columnClass() {
      if (this.state.players.numPlayers === 2 || this.state.players.numPlayers === 4) {
        return 'col-md-6';
      }

      return 'col-lg-4';
    },
    handRankings: function handRankings() {
      return this.$store.getters['account/handRankings'];
    },
    authorized: function authorized() {
      return true; // short deck equity calculator is free
    },
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    },
    authorizedForShortDeck: function authorizedForShortDeck() {
      return this.$store.getters['account/authorizedForShortDeck'];
    }
  },
  mounted: function mounted() {

    if (this.state.players.numPlayers === 1) {
      this.addPlayer();
    }

    if (this.$route.params.id) {
      this.load();
    }

    this.handleOnboard();
  },
  methods: {
    // mounted
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default short deck equity calculator page.');
          self.$router.push('/short-deck/equity-calculator');
        } else {
          self.$store.commit('shortDeckEquityCalculator/setState', response.data.storeState);
          self.$store.commit('shortDeckEquityCalculator/setHasSimulationBeenRun', true);
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default short deck equity calculator page.');
        self.$router.push('/short-deck/equity-calculator');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.loggedIn || !self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.shortDeckEquityCalculator) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'shortDeckEquityCalculator' }).then(function () {
        self.$store.commit('account/onboard', 'shortDeckEquityCalculator');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },

    // range
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$store.state.account.user.settings.general.includedSelectors.slider === 'log double' || this.$store.state.account.useer.settings.general.includedSelectors.slider === 'double') {
        this.$refs['player' + playerIndex][0].resetDoubleSlider();
      }
    },
    resetDoubleSliders: function resetDoubleSliders() {
      this.state.players.forEach(function (player, playerIndex) {
        this.resetDoubleSlider(playerIndex);
      }, this);
    },

    // hamburger
    expandNarrowRangeModal: function expandNarrowRangeModal(playerIndexThatExpandedTheNarrowRangeModal) {
      $(this.$el).find('.narrow-range-modal').modal();
      this.playerIndexThatExpandedTheNarrowRangeModal = playerIndexThatExpandedTheNarrowRangeModal;
    },
    narrowRange: function narrowRange(checkedHands) {
      this.$store.commit('shortDeckEquityCalculator/narrowRange', {
        checkedHands: checkedHands,
        playerIndex: this.playerIndexThatExpandedTheNarrowRangeModal
      });
      this.resetDoubleSlider(this.playerIndexThatExpandedTheNarrowRangeModal);
    },

    // controls
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(params) {
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', params.position);
      this.$store.commit('shortDeckEquityCalculator/setIndividualPresetCommunityCard', {
        card: params.card,
        position: params.position
      });
      this.resetDoubleSliders();
    },
    setBoard: function setBoard(boardCards) {
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'flop1');
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'flop2');
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'flop3');
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'turn');
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', 'river');
      this.$store.commit('shortDeckEquityCalculator/setBoard', boardCards);
      this.resetDoubleSliders();
    },
    removePresetCommunityCard: function removePresetCommunityCard(position) {
      this.$store.commit('shortDeckEquityCalculator/removePresetCommunityCard', position);
    },
    addPlayer: function addPlayer() {
      this.$store.commit('shortDeckEquityCalculator/addPlayer');
    },
    createSharableUrl: function createSharableUrl() {
      var self = this;

      $(self.$el).find('.sharable-url-modal').modal();
      self.sharableUrl.url = '';

      __WEBPACK_IMPORTED_MODULE_7__services_share_url_service__["a" /* default */].createSharableEquityCalculatorURL(self.state).then(function (response) {
        if (response.data.url) {
          self.sharableUrl.url = response.data.url.replace('/equity-calculator', '/short-deck/equity-calculator');
        } else {
          alert('Didn\'t get url back from server.');
          throw new Error('Didn\'t get url back from server.');
        }
      }).catch(function () {
        alert('Problem trying to create the sharable URL.');
        throw new Error('Problem trying to create the sharable URL.');
      });
    },
    expandSaveScenarioModal: function expandSaveScenarioModal() {
      $(this.$el).find('.save-scenario-modal').modal();
    },
    saveScenario: function saveScenario(title) {
      var self = this;
      var savedScenarioUrl = void 0;

      __WEBPACK_IMPORTED_MODULE_7__services_share_url_service__["a" /* default */].createSharableEquityCalculatorURL(self.state).then(function getUrlForSavedScenario(response) {
        if (response.data.url) {
          return response.data.url.replace('/equity-calculator', '/short-deck/equity-calculator');
        } else {
          alert('Problem trying to save the scenario.');
          throw new Error('Didn\'t get url back from server.');
        }
      }).then(function updateUserOnServer(url) {
        var newSavedScenarios = self._getNewSavedScenarios(title, url);
        var user = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.cloneDeep(self.$store.state.account.user);

        savedScenarioUrl = url;
        user.savedScenarios = newSavedScenarios;

        return self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user });
      }).then(function updateUserOnClient(res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
        window.location.href = savedScenarioUrl;
      }).catch(function () {
        alert('Problem trying to save the scenario.');
        throw new Error('Problem trying to save the scenario.');
      });
    },
    _getNewSavedScenarios: function _getNewSavedScenarios(title, url) {
      var newSavedScenarios = __WEBPACK_IMPORTED_MODULE_13_lodash___default.a.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios.shortDeckEquityCalculator.push({
        title: title,
        url: url
      });

      return newSavedScenarios;
    },
    updateScenario: function updateScenario() {
      var storeState = __WEBPACK_IMPORTED_MODULE_7__services_share_url_service__["a" /* default */]._constructEquityCalculatorData(this.state);

      this.$http.put("https://oddscalc.sixplusholdem.com/api" + '/update-sharable-url/' + this.$route.params.id, storeState).then(function () {
        alert('Successfully updated scenario.');
      }).catch(function () {
        alert('Error: unable to update scenario. Email contact@sixplusholdem.com for assistance.');
      });
    },
    simulate: function simulate() {
      var self = this;
      var validateResult = __WEBPACK_IMPORTED_MODULE_11__services_simulator_validator__["a" /* default */].validateBeforeEquityCalculatorSimulation(self.state.players, self.state.presetCommunityCards);
      var numberOfSimulations = self.$store.state.account.user.settings.equityCalculator.numberOfSimulations;
      var $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      var weightedRanges = void 0;

      if (!self.authorized) {
        return;
      }

      if (validateResult.error) {
        alert(validateResult.errorMessage);
        return;
      }

      $simulationButtonText.text('Simulating...');
      weightedRanges = self._getWeightedRanges();
      __WEBPACK_IMPORTED_MODULE_12__services_simulator_simulator__["a" /* default */].getShortDeckEquities(weightedRanges, self.state.presetCommunityCards.array, numberOfSimulations, self._incrementSimulationProgress).then(function (simulationResults) {
        self._resetSimulationProgress();
        self.$store.commit('shortDeckEquityCalculator/updateEquityResults', {
          simulationResults: simulationResults,
          numberOfSimulations: numberOfSimulations,
          rakePercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.rakePercentage,
          tipPercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.tipPercentage
        });
      }).catch(function (e) {
        console.error(e);
        self._resetSimulationProgress();
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    _getWeightedRanges: function _getWeightedRanges() {
      var weightedRanges = [];

      this.state.players.forEach(function (player) {
        weightedRanges.push(player.states[0].generalHands.weightedRange);
      });

      return weightedRanges;
    },
    _incrementSimulationProgress: function _incrementSimulationProgress(value) {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      var $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', value + '%');
      $simulationButton.prop('disabled', true);
      $simulationButtonProgressBox.css('z-index', '1');
      $simulationButtonProgressBox.css('width', value + '%');
      $simulationButtonProgressBox.css('cursor', 'not-allowed');
    },
    _resetSimulationProgress: function _resetSimulationProgress() {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      var $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      var $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', '0%');
      $simulationButton.prop('disabled', false);
      $simulationButtonText.text('Simulate');
      $simulationButtonProgressBox.css('z-index', '-1');
      $simulationButtonProgressBox.css('cursor', 'auto');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "5uS2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ppt-blog"},[_vm._m(0),_vm._v(" "),_c('blog-post-link',{attrs:{"title":"Prior probability and estimating your winrate","date":"10/1/19","path":"/blog/prior-probability-and-estimating-your-winrate"}}),_vm._v(" "),_c('blog-post-link',{attrs:{"title":"Summary of Pokers 1% by Ed Miller","date":"10/1/19","path":"/blog/summary-of-pokers-one-percent"}}),_vm._v(" "),_c('blog-post-link',{attrs:{"title":"Zoom out","date":"9/24/19","path":"/blog/zoom-out"}}),_vm._v(" "),_c('blog-post-link',{attrs:{"title":"Spaced repetition and poker","date":"9/24/19","path":"/blog/spaced-repetition-and-poker"}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('subscribe-to-blog')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Blog")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ukL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5wz1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"breakeven-percentage-for-bluffing-the-turn-inputs"},[_c('togglable-section',{attrs:{"title":"Basics"}},[_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Turn pot size:")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.turnPotSize},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setTurnPotSize', $event.target.valueAsNumber)}}})])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Turn bet size (% of pot):")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.turnBetSize},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setTurnBetSize', $event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])])]),_vm._v(" "),_c('togglable-section',{attrs:{"title":"Hitting an out"}},[_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Number of outs:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"46","step":"1","disabled":!_vm.authorized},domProps:{"value":_vm.state.numberOfOuts},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setNumberOfOuts', $event.target.valueAsNumber)}}})]),_vm._v(" "),(_vm.state.numberOfOuts > 0)?_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Extra money won on river when you hit an out (% of river pot):")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.percentageOfPotWonOnRiverWhenYouHitAnOut},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setPercentageOfPotWonOnRiverWhenYouHitAnOut', $event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e()]),_vm._v(" "),_c('togglable-section',{attrs:{"title":"Following up with a river bluff"}},[_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Number of river cards you'll bluff:")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"46","step":"1","disabled":!_vm.authorized},domProps:{"value":_vm.state.numRiverCardsYoullBluff},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setNumRiverCardsYoullBluff', $event.target.valueAsNumber)}}})]),_vm._v(" "),(_vm.state.numRiverCardsYoullBluff > 0)?_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("River bluff size (% of river pot):")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.riverBluffSize},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setRiverBluffSize', $event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e(),_vm._v(" "),(_vm.state.numRiverCardsYoullBluff > 0)?_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Probability of getting a fold on the river:")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.probabilityOfGettingFoldOnRiver},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setProbabilityOfGettingFoldOnRiver', $event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e()]),_vm._v(" "),_c('togglable-section',{attrs:{"title":"EV of checking"}},[(_vm.state.numberOfOuts > 0)?_c('section',[_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Are you in position or out of position:")]),_c('br'),_vm._v(" "),_c('section',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",class:{ 'active': _vm.state.position === 'in position' },attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setPosition', 'in position')}}},[_vm._v("\n            In position\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'active': _vm.state.position === 'out of position' },attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setPosition', 'out of position')}}},[_vm._v("\n            Out of position\n          ")])])]),_vm._v(" "),(_vm.state.position === 'out of position')?_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Probability that your opponent bets when you check:")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.probabilityThatOpponentBetsWhenYouCheck},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setProbabilityThatOpponentBetsWhenYouCheck', $event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e(),_vm._v(" "),(_vm.state.position === 'out of position' && _vm.state.probabilityThatOpponentBetsWhenYouCheck > 0)?_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Are you calling when your opponent bets:")]),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",class:{ 'active': _vm.state.checkCall },attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setCheckCall', true)}}},[_vm._v("\n            Call\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'active': !_vm.state.checkCall },attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setCheckCall', false)}}},[_vm._v("\n            Fold\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.state.position === 'out of position' && _vm.state.probabilityThatOpponentBetsWhenYouCheck > 0 && _vm.state.checkCall)?_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Opponent's turn bet size (% of pot):")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.opponentsTurnBetSize},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setOpponentsTurnBetSize', $event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e(),_vm._v(" "),(_vm.state.position === 'out of position' && _vm.state.probabilityThatOpponentBetsWhenYouCheck > 0 && _vm.state.checkCall)?_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Extra money won when you hit an out after you check/call (% of river pot):")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.percentageOfPotWonAfterCheckCall},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setPercentageOfPotWonAfterCheckCall', $event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e(),_vm._v(" "),(_vm.state.position === 'in position' || (_vm.state.position === 'out of position' && (_vm.state.probabilityThatOpponentBetsWhenYouCheck < 100)))?_c('li',{staticClass:"list-group-item"},[_c('span',[_vm._v("Extra money won when you hit an out after the turn checks through (% of river pot):")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.percentageOfPotWonAfterTurnChecksThrough},on:{"input":function($event){return _vm.$store.commit('breakevenPercentageForBluffingTheTurn/setPercentageOfPotWonAfterTurnChecksThrough', $event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.state.numberOfOuts === 0)?_c('p',[_c('em',[_vm._v("The EV of checking is 0 because you have 0 outs. When you have 1 or more outs, the EV of checking will depend on some state.")])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6/Xz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'add-player-button',
  props: ['overrideText', 'disabled'],
  computed: {
    text: function text() {
      if (this.overrideText) {
        return this.overrideText;
      }

      return 'Add player';
    },
    tooltipValue: function tooltipValue() {
      // if (this.disabled) {
      //   return 'Disabled.';
      // }

      return ''; // disables the tooltip
    }
  },
  mounted: function mounted() {
    if (true) {
      $(this.$el).tooltip();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "6Nur":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"five-card-hands-for-category"},[_vm._l((_vm.visibleFiveCardHands),function(fiveCardHand){return _c('div',{key:fiveCardHand.id + '-' + _vm.playerState.name,staticClass:"five-card-hand-container",on:{"mouseover":function($event){return _vm.$emit('fiveCardHandMouseover', fiveCardHand.matchingSpecificHands)},"mouseleave":function($event){return _vm.$emit('fiveCardHandMouseleave')}}},[_c('span',{staticClass:"left-container",class:'level-' + fiveCardHand.level},[_c('span',{staticClass:"glyphicon",class:{
          'visibility-hidden': !fiveCardHand.children,
          'glyphicon-triangle-bottom': !fiveCardHand.collapsed,
          'glyphicon-triangle-right': fiveCardHand.collapsed,
        },on:{"click":function($event){return _vm.$emit('toggleCollapsedValueOfFiveCardHandParent', fiveCardHand)}}}),_vm._v(" "),_c('input',{attrs:{"type":"checkbox","id":_vm.playerState.name + '-' + fiveCardHand.id + '-checkbox-' + _vm.random,"disabled":!_vm.playerState.hasSimulationBeenRun || !_vm.authorized},domProps:{"checked":fiveCardHand.checked,"indeterminate":fiveCardHand.checked === 'partially'},on:{"change":function($event){return _vm.$emit('setCheckedValueOfFiveCardHand', {
          fiveCardHandId: fiveCardHand.id,
          newCheckedValue: $event.target.checked,
        })}}}),_vm._v(" "),_c('label',{staticClass:"text",attrs:{"for":_vm.playerState.name + '-' + fiveCardHand.id + '-checkbox-' + _vm.random},domProps:{"innerHTML":_vm._s(_vm.getFiveCardHandText(fiveCardHand))}})]),_vm._v(" "),(_vm.playerState.hasSimulationBeenRun && !_vm.hideRightContainer)?_c('span',{staticClass:"right-container",on:{"click":function($event){return _vm.expandFiveCardHandWeightModal(fiveCardHand)}}},[_c('five-card-hand-bar',{attrs:{"type":_vm.type,"probability":fiveCardHand.probability.roundToOneDecimalPlace(),"numCombos":fiveCardHand.getNumCombos(_vm.playerState.generalHands.numberOfPossibleSpecificHands),"percentagesOrCombos":_vm.percentagesOrCombos,"percentageOfSpecificHandsThatAreSelected":fiveCardHand.percentageOfSpecificHandsThatAreSelected}}),_vm._v(" "),(_vm.percentagesOrCombos === 'percentages' && fiveCardHand.probability < 20)?_c('span',{staticClass:"probability"},[_vm._v("\n        "+_vm._s(fiveCardHand.probability.roundToOneDecimalPlace())+"%\n      ")]):_vm._e(),_vm._v(" "),(_vm.percentagesOrCombos === 'combos' && fiveCardHand.probability < 15)?_c('span',{staticClass:"num-combos"},[_vm._v("\n        "+_vm._s(fiveCardHand.getNumCombos(_vm.playerState.generalHands.numberOfPossibleSpecificHands))+"\n      ")]):_vm._e()],1):_vm._e()])}),_vm._v(" "),_c('five-card-hand-weight-modal',{attrs:{"fiveCardHand":_vm.fiveCardHandThatTriggeredTheFiveCardHandWeightModal},on:{"updateWeightOfFiveCardHand":function($event){return _vm.$emit('updateWeightOfFiveCardHand', $event)},"applyExactWeightToFiveCardHand":function($event){return _vm.$emit('applyExactWeightToFiveCardHand', $event)}}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6vFa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',[(_vm.profitable === null)?_c('span',[_vm._t("default")],2):(_vm.profitable === true)?_c('span',{staticClass:"text-success"},[_vm._t("default"),_vm._v(" ✅\n  ")],2):(_vm.profitable === false)?_c('span',{staticClass:"text-danger"},[_vm._t("default"),_vm._v(" ❌\n  ")],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "70sL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_num_opponents_selector__ = __webpack_require__("Cesf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_short_deck_short_deck_hole_cards_selector__ = __webpack_require__("2ny4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_short_deck_short_deck_preset_community_cards_selector__ = __webpack_require__("/AJA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_short_deck_short_deck_range_for_street__ = __webpack_require__("N8HT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_hand_range_equity_results__ = __webpack_require__("KFpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_hit_calculator_five_card_hands_section_insights_insights__ = __webpack_require__("Q3DD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_short_deck_short_deck_flop_selector__ = __webpack_require__("mjyE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_short_deck_short_deck_turn_selector__ = __webpack_require__("pXto");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_short_deck_short_deck_river_selector__ = __webpack_require__("kAUi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_cumulative_hit_percentages__ = __webpack_require__("cNwD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_controls_create_sharable_url_button__ = __webpack_require__("zMC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_controls_save_scenario_button__ = __webpack_require__("A/Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sharable_url_modal__ = __webpack_require__("hu4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_save_scenario_modal__ = __webpack_require__("Nr+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_onboarding_modal__ = __webpack_require__("iexb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_simulator_simulator__ = __webpack_require__("pihl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_simulator_validator__ = __webpack_require__("qY6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//























/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-hit-calculator',
  components: {
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_saved_scenario_alert__["a" /* default */],
    'num-opponents-selector': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_num_opponents_selector__["a" /* default */],
    'short-deck-hole-cards-selector': __WEBPACK_IMPORTED_MODULE_3__components_short_deck_short_deck_hole_cards_selector__["a" /* default */],
    'short-deck-preset-community-cards-selector': __WEBPACK_IMPORTED_MODULE_4__components_short_deck_short_deck_preset_community_cards_selector__["a" /* default */],
    'short-deck-range-for-street': __WEBPACK_IMPORTED_MODULE_5__components_short_deck_short_deck_range_for_street__["a" /* default */],
    'equity-results': __WEBPACK_IMPORTED_MODULE_6__components_hand_range_equity_results__["a" /* default */],
    'hit-calculator-insights': __WEBPACK_IMPORTED_MODULE_7__components_hit_calculator_five_card_hands_section_insights_insights__["a" /* default */],
    'short-deck-flop-selector': __WEBPACK_IMPORTED_MODULE_8__components_short_deck_short_deck_flop_selector__["a" /* default */],
    'short-deck-turn-selector': __WEBPACK_IMPORTED_MODULE_9__components_short_deck_short_deck_turn_selector__["a" /* default */],
    'short-deck-river-selector': __WEBPACK_IMPORTED_MODULE_10__components_short_deck_short_deck_river_selector__["a" /* default */],
    'cumulative-hit-percentages': __WEBPACK_IMPORTED_MODULE_11__components_cumulative_hit_percentages__["a" /* default */],
    'create-sharable-url-button': __WEBPACK_IMPORTED_MODULE_12__components_controls_create_sharable_url_button__["a" /* default */],
    'save-scenario-button': __WEBPACK_IMPORTED_MODULE_13__components_controls_save_scenario_button__["a" /* default */],
    'sharable-url-modal': __WEBPACK_IMPORTED_MODULE_14__components_sharable_url_modal__["a" /* default */],
    'save-scenario-modal': __WEBPACK_IMPORTED_MODULE_16__components_save_scenario_modal__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_17__components_onboarding_modal__["a" /* default */]
  },
  data: function data() {
    return {
      sharableUrl: {
        url: null,
        approximateWaitTime: null
      }
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.shortDeckHitCalculator;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      if (this.$store.state.account.user.savedScenarios.length === 0) return false;

      return this.$store.state.account.user.savedScenarios.shortDeckHitCalculator.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    multiplePlayers: function multiplePlayers() {
      return this.state.players.numPlayers > 1;
    },
    insightsVisible: function insightsVisible() {
      return this.$store.state.account.user.settings.shortDeckHitCalculator.insightsVisible;
    },
    isHitPercentageUpToDate: function isHitPercentageUpToDate() {
      var results = [];

      this.state.players.forEach(function (player) {
        results.push([player.states[1].isHitPercentageUpToDate(player, this.state.presetCommunityCards, this.state.presetHoleCards), player.states[2].isHitPercentageUpToDate(player, this.state.presetCommunityCards, this.state.presetHoleCards), player.states[3].isHitPercentageUpToDate(player, this.state.presetCommunityCards, this.state.presetHoleCards)]);
      }, this);

      return results;
    },
    cumulativeHitPercentages: function cumulativeHitPercentages() {
      return this.$store.getters['shortDeckHitCalculator/cumulativeHitPercentages'];
    },
    authorized: function authorized() {
      //return this.$store.getters['account/authorizedForShortDeck'];
      return true;
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.load();
    } else {
      this.$store.commit('shortDeckHitCalculator/setFiveCardHandValuesToDefaults', {
        settings: this.$store.state.account.user.settings,
        opponentTightness: 'straightforward'
      });
    }

    this.handleOnboard();

    // five card hand simulations
    this.$watch(this.flopExhaustiveFiveCardHandSimulationsWatcher, __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.debounce(this.runExhaustiveFiveCardHandPercentagesSimulationsForFlop, 1000));
    this.$watch(this.turnExhaustiveFiveCardHandSimulationsWatcher, __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.debounce(this.runExhaustiveFiveCardHandPercentagesSimulationsForTurn, 1000));
    this.$watch(this.riverExhaustiveFiveCardHandSimulationsWatcher, __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.debounce(this.runExhaustiveFiveCardHandPercentagesSimulationsForRiver, 1000));

    // equity simulations
    this.$watch(this.preflopEquitySimulationsWatcher, __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.debounce(this.setPreflopEquities, 1000));
    this.$watch(this.flopEquitySimulationsWatcher, __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.debounce(this.setFlopEquities, 1000));
    this.$watch(this.turnEquitySimulationsWatcher, __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.debounce(this.setTurnEquities, 1000));
    this.$watch(this.riverEquitySimulationsWatcher, __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.debounce(this.setRiverEquities, 1000));
  },
  methods: {
    // mounted
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default short deck hit calculator page.');
          self.$router.push('/short-deck/hit-calculator');
        } else {
          self.$store.commit('shortDeckHitCalculator/setState', response.data.storeState);
          self.simulate();
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default short deck hit calculator page.');
        self.$router.push('/short-deck/hit-calculator');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.shortDeckHitCalculator) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'shortDeckHitCalculator' }).then(function () {
        self.$store.commit('account/onboard', 'shortDeckHitCalculator');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },

    // controls
    addPlayer: function addPlayer() {
      this.$store.commit('shortDeckHitCalculator/addPlayer', {
        settings: this.$store.state.account.user.settings,
        opponentTightness: 'straightforward'
      });
    },
    removePlayer: function removePlayer() {
      this.$store.commit('shortDeckHitCalculator/removePlayer', this.state.players.numPlayers - 1);
      this.simulate();
    },
    setPresetHoleCard: function setPresetHoleCard(params) {
      this.$store.commit('shortDeckHitCalculator/removePresetHoleCard', params.position);
      this.$store.commit('shortDeckHitCalculator/setPresetHoleCard', {
        card: params.card,
        position: params.position
      });
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    removePresetHoleCard: function removePresetHoleCard(position) {
      this.$store.commit('shortDeckHitCalculator/removePresetHoleCard', position);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(params) {
      this.$store.commit('shortDeckHitCalculator/removePresetCommunityCard', params.position);
      this.$store.commit('shortDeckHitCalculator/setIndividualPresetCommunityCard', {
        card: params.card,
        position: params.position
      });
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    setBoard: function setBoard(boardCards) {
      this.$store.commit('shortDeckHitCalculator/removePresetCommunityCard', 'flop1');
      this.$store.commit('shortDeckHitCalculator/removePresetCommunityCard', 'flop2');
      this.$store.commit('shortDeckHitCalculator/removePresetCommunityCard', 'flop3');
      this.$store.commit('shortDeckHitCalculator/removePresetCommunityCard', 'turn');
      this.$store.commit('shortDeckHitCalculator/removePresetCommunityCard', 'river');
      this.$store.commit('shortDeckHitCalculator/setBoard', boardCards);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    removePresetCommunityCard: function removePresetCommunityCard(position) {
      this.$store.commit('shortDeckHitCalculator/removePresetCommunityCard', position);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    createSharableUrl: function createSharableUrl() {
      var self = this;

      $(self.$el).find('.sharable-url-modal').modal();
      self.sharableUrl.url = '';
      self.sharableUrl.approximateWaitTime = 5;

      __WEBPACK_IMPORTED_MODULE_15__services_share_url_service__["a" /* default */].createSharableHitCalculatorURL(self.state).then(function (response) {
        if (response.data.url) {
          self.sharableUrl.url = response.data.url.replace('/hit-calculator', '/short-deck/hit-calculator');
        } else {
          alert('Didn\'t get url back from server.');
          throw new Error('Didn\'t get url back from server.');
        }
      }).catch(function () {
        alert('Problem trying to create the sharable URL.');
        throw new Error('Problem trying to create the sharable URL.');
      });
    },
    expandSaveScenarioModal: function expandSaveScenarioModal() {
      $(this.$el).find('.save-scenario-modal').modal();
    },
    saveScenario: function saveScenario(title) {
      var self = this;
      var savedScenarioUrl = void 0;

      __WEBPACK_IMPORTED_MODULE_15__services_share_url_service__["a" /* default */].createSharableHitCalculatorURL(self.state).then(function getUrlForSavedScenario(response) {
        if (response.data.url) {
          return response.data.url.replace('/hit-calculator', '/short-deck/hit-calculator');
        } else {
          alert('Problem trying to save the scenario.');
          throw new Error('Didn\'t get url back from server.');
        }
      }).then(function updateUserOnServer(url) {
        var newSavedScenarios = self._getNewSavedScenarios(title, url);
        var user = __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.cloneDeep(self.$store.state.account.user);

        savedScenarioUrl = url;
        user.savedScenarios = newSavedScenarios;

        return self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user });
      }).then(function updateUserOnClient(res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
        window.location.href = savedScenarioUrl;
      }).catch(function () {
        alert('Problem trying to save the scenario.');
        throw new Error('Problem trying to save the scenario.');
      });
    },
    _getNewSavedScenarios: function _getNewSavedScenarios(title, url) {
      var newSavedScenarios = __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios.shortDeckHitCalculator.push({
        title: title,
        url: url
      });

      return newSavedScenarios;
    },
    updateScenario: function updateScenario() {
      var storeState = __WEBPACK_IMPORTED_MODULE_15__services_share_url_service__["a" /* default */]._constructHitCalculatorData(this.state);

      this.$http.put("https://oddscalc.sixplusholdem.com/api" + '/update-sharable-url/' + this.$route.params.id, storeState).then(function () {
        alert('Successfully updated scenario.');
      }).catch(function () {
        alert('Error: unable to update scenario. Email contact@sixplusholdem.com for assistance.');
      });
    },

    // player
    setRangesAccordingToFiltersForPlayer: function setRangesAccordingToFiltersForPlayer(playerIndex) {
      this.$store.commit('shortDeckHitCalculator/setRangesAccordingToFilters', playerIndex);
    },
    setRangesAccordingToFiltersForAllPlayers: function setRangesAccordingToFiltersForAllPlayers() {
      this.state.players.forEach(function (player, playerIndex) {
        this.setRangesAccordingToFiltersForPlayer(playerIndex);
      }, this);
    },
    resetDoubleSliderForPlayer: function resetDoubleSliderForPlayer(playerIndex) {
      if (this.$refs['preflop-' + playerIndex]) {
        this.$refs['preflop-' + playerIndex][0].resetDoubleSlider(playerIndex);
      }
    },
    resetAllDoubleSliders: function resetAllDoubleSliders() {
      this.state.players.forEach(function (player, index) {
        this.resetDoubleSliderForPlayer(index);
      }, this);
    },

    // simulation
    flopExhaustiveFiveCardHandSimulationsWatcher: function flopExhaustiveFiveCardHandSimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[0].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    turnExhaustiveFiveCardHandSimulationsWatcher: function turnExhaustiveFiveCardHandSimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[1].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    riverExhaustiveFiveCardHandSimulationsWatcher: function riverExhaustiveFiveCardHandSimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[2].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },

    preflopEquitySimulationsWatcher: function preflopEquitySimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[0].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    flopEquitySimulationsWatcher: function flopEquitySimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[1].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    turnEquitySimulationsWatcher: function turnEquitySimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[2].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    riverEquitySimulationsWatcher: function riverEquitySimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[3].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },

    simulate: function simulate() {
      this.setPreflopEquities().then(this.setFlopEquities).then(this.setTurnEquities).then(this.setRiverEquities).then(this.runExhaustiveFiveCardHandPercentagesSimulationsForFlop).then(this.runExhaustiveFiveCardHandPercentagesSimulationsForTurn).then(this.runExhaustiveFiveCardHandPercentagesSimulationsForRiver);
    },

    ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop: function ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop() {
      var returnValue = true;

      // not sure if commenting this out introduces a bug or not, but I don't think it does
      // if (this.state.players.numPlayers > 1) {
      //   returnValue = false;
      // }

      if (!this.state.presetCommunityCards.flopSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('preflop')) {
        returnValue = false;
      }

      return returnValue;
    },
    ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn: function ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn() {
      var returnValue = true;

      // not sure if commenting this out introduces a bug or not, but I don't think it does
      // if (this.state.players.numPlayers > 1) {
      //   returnValue = false;
      // }

      if (!this.state.presetCommunityCards.turnSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('flop')) {
        returnValue = false;
      }

      return returnValue;
    },
    ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver: function ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver() {
      var returnValue = true;

      // not sure if commenting this out introduces a bug or not, but I don't think it does
      // if (this.state.players.numPlayers > 1) {
      //   returnValue = false;
      // }

      if (!this.state.presetCommunityCards.riverSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('turn')) {
        returnValue = false;
      }

      return returnValue;
    },
    runExhaustiveFiveCardHandPercentagesSimulationsForFlop: function runExhaustiveFiveCardHandPercentagesSimulationsForFlop() {
      var self = this;

      if (!self.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_18__services_simulator_simulator__["a" /* default */].getFlopFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards, true).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('shortDeckHitCalculator/setLastSimulationInfo', 1);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    runExhaustiveFiveCardHandPercentagesSimulationsForTurn: function runExhaustiveFiveCardHandPercentagesSimulationsForTurn() {
      var self = this;

      if (!self.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_18__services_simulator_simulator__["a" /* default */].getTurnFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards, true).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('shortDeckHitCalculator/setLastSimulationInfo', 2);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    runExhaustiveFiveCardHandPercentagesSimulationsForRiver: function runExhaustiveFiveCardHandPercentagesSimulationsForRiver() {
      var self = this;

      if (!self.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_18__services_simulator_simulator__["a" /* default */].getRiverFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards, true).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('shortDeckHitCalculator/setLastSimulationInfo', 3);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },

    showNonexhaustiveSimulationButton: function showNonexhaustiveSimulationButton(playerIndex, street) {
      if (!this.ableToRunNonexhaustiveFiveCardHandPercentageSimulationsForPlayer(playerIndex)) {
        return false;
      } else if (street === 'flop' && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop()) {
        return false;
      } else if (street === 'turn' && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn()) {
        return false;
      } else if (street === 'river' && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver()) {
        return false;
      }

      return true;
    },
    ableToRunNonexhaustiveFiveCardHandPercentageSimulationsForPlayer: function ableToRunNonexhaustiveFiveCardHandPercentageSimulationsForPlayer(playerIndex) {
      return !this.state.players.find(playerIndex).hasEmptyRange('preflop');
    },
    runNonexhaustiveFiveCardHandPercentagesSimulationsForFlop: function runNonexhaustiveFiveCardHandPercentagesSimulationsForFlop(playerIndex) {
      return this._runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet(playerIndex, 'flop', 1);
    },
    runNonexhaustiveFiveCardHandPercentagesSimulationsForTurn: function runNonexhaustiveFiveCardHandPercentagesSimulationsForTurn(playerIndex) {
      return this._runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet(playerIndex, 'turn', 2);
    },
    runNonexhaustiveFiveCardHandPercentagesSimulationsForRiver: function runNonexhaustiveFiveCardHandPercentagesSimulationsForRiver(playerIndex) {
      return this._runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet(playerIndex, 'river', 3);
    },
    _runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet: function _runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet(playerIndex, streetName, streetIndex) {
      var self = this;

      return self.__runNonexhaustiveSimulationsForPlayer(playerIndex, streetName, streetIndex).then(function () {
        self.setRangesAccordingToFiltersForPlayer(playerIndex);
        self.$store.commit('shortDeckHitCalculator/setLastSimulationInfo', streetIndex);
        self.$store.commit('shortDeckHitCalculator/setHitPercentageBeingComputed', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex,
          value: true
        });
        self.$store.dispatch('shortDeckHitCalculator/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex
        });
        self.$store.commit('shortDeckHitCalculator/clearMatchingSpecificHands', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex
        });
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    __runNonexhaustiveSimulationsForPlayer: function __runNonexhaustiveSimulationsForPlayer(playerIndex, streetName, streetIndex) {
      var self = this;
      var player = self.state.players.find(playerIndex);
      var simulatorMethod = self.___getNonexhaustiveSimulatorMethod(streetName);
      var numberOfSimulations = self.$store.state.account.user.settings.hitCalculator.numberOfSimulations;

      return __WEBPACK_IMPORTED_MODULE_18__services_simulator_simulator__["a" /* default */][simulatorMethod](player.getWeightedRangeToUseForSimulation(self.state.presetCommunityCards, streetName), self.state.presetCommunityCards.getArrayForStateViaStreet(streetName), numberOfSimulations, function (value) {
        self.incrementSimulationProgress(value, playerIndex, streetName);
      }).then(function (handAndDrawInfo) {
        self.$store.commit('shortDeckHitCalculator/setHandAndDrawInfo', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex,
          handAndDrawInfoFromSimulationResults: handAndDrawInfo
        });
        self.$store.commit('shortDeckHitCalculator/setProbabilitiesOfFiveCardHands', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex,
          handAndDrawInfo: handAndDrawInfo,
          numberOfSimulations: numberOfSimulations
        });
        self.resetSimulationProgress(playerIndex, streetName);
      });
    },
    ___getNonexhaustiveSimulatorMethod: function ___getNonexhaustiveSimulatorMethod(streetName) {
      var capitalizedStreetName = __WEBPACK_IMPORTED_MODULE_21_lodash___default.a.capitalize(streetName);
      var simulatorMethod = 'get' + capitalizedStreetName + 'FiveCardHandPercentagesViaShortDeckSimulations';

      return simulatorMethod;
    },

    ableToGetPreflopEquities: function ableToGetPreflopEquities() {
      return this.state.presetHoleCards.bothSet && !this.state.players.hasEmptyRange('preflop');
    },
    ableToGetFlopEquities: function ableToGetFlopEquities() {
      return this.state.presetHoleCards.bothSet && this.state.presetCommunityCards.flopSet && !this.state.players.hasEmptyRange('flop');
    },
    ableToGetTurnEquities: function ableToGetTurnEquities() {
      return this.state.presetHoleCards.bothSet && this.state.presetCommunityCards.turnSet && !this.state.players.hasEmptyRange('turn');
    },
    ableToGetRiverEquities: function ableToGetRiverEquities() {
      return this.state.presetHoleCards.bothSet && this.state.presetCommunityCards.riverSet && !this.state.players.hasEmptyRange('river');
    },
    setPreflopEquities: function setPreflopEquities() {
      if (!this.ableToGetPreflopEquities()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this._setEquitiesForStreet(0);
    },
    setFlopEquities: function setFlopEquities() {
      if (!this.ableToGetFlopEquities()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this._setEquitiesForStreet(1);
    },
    setTurnEquities: function setTurnEquities() {
      if (!this.ableToGetTurnEquities()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this._setEquitiesForStreet(2);
    },
    setRiverEquities: function setRiverEquities() {
      if (!this.ableToGetRiverEquities()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this._setEquitiesForStreet(3);
    },
    _setEquitiesForStreet: function _setEquitiesForStreet(playerStateIndex) {
      var self = this;
      var weightedRanges = self.__getWeightedRanges(playerStateIndex);
      var numberOfSimulations = self.$store.state.account.user.settings.equityCalculator.numberOfSimulations;
      var presetCommunityCardsArray = self.state.presetCommunityCards.getArrayForStateViaIndex(playerStateIndex);

      return __WEBPACK_IMPORTED_MODULE_18__services_simulator_simulator__["a" /* default */].getShortDeckEquities(weightedRanges, presetCommunityCardsArray, numberOfSimulations, function () {}).then(function (simulationResults) {
        self.$store.commit('shortDeckHitCalculator/updateEquityResults', {
          playerStateIndex: playerStateIndex,
          simulationResults: simulationResults,
          numberOfSimulations: numberOfSimulations,
          rakePercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.rakePercentage,
          tipPercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.tipPercentage
        });

        if (true) {
          $(self.$el).find('[data-toggle="tooltip"]').tooltip();
        }
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the equity simulations.');
      });
    },
    __getWeightedRanges: function __getWeightedRanges(playerStateIndex) {
      var weightedRanges = [];
      var heroWeightedRange = [[this.state.presetHoleCards.holeCardOne, this.state.presetHoleCards.holeCardTwo]];

      weightedRanges.push(heroWeightedRange);
      this.state.players.forEach(function (player) {
        weightedRanges.push(player.states[playerStateIndex].generalHands.weightedRange);
      }, this);

      return weightedRanges;
    },

    getTextWhenFiveCardHandPercentagesArentUpToDate: function getTextWhenFiveCardHandPercentagesArentUpToDate(playerStateIndex) {
      if (playerStateIndex === 1 && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop() || playerStateIndex === 2 && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn() || playerStateIndex === 3 && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver()) {
        return 'Running simulations...';
      } else {
        return 'Not up to date. Run simulations to update.';
      }
    },
    incrementSimulationProgress: function incrementSimulationProgress(value, playerIndex, streetName) {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButtonContainer = $(this.$refs[streetName + '-' + playerIndex][0].$el).find('.simulate-button-container');
      var $simulationButton = $simulationButtonContainer.find('.simulate-button');
      var $simulationButtonProgressBox = $simulationButtonContainer.find('.progress-box');

      $simulationProgress.css('width', value + '%');
      $simulationButton.prop('disabled', true);
      $simulationButtonProgressBox.css('z-index', '1');
      $simulationButtonProgressBox.css('width', value + '%');
      $simulationButtonProgressBox.css('cursor', 'not-allowed');
    },
    resetSimulationProgress: function resetSimulationProgress(playerIndex, streetName) {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButtonContainer = $(this.$refs[streetName + '-' + playerIndex][0].$el).find('.simulate-button-container');
      var $simulationButton = $simulationButtonContainer.find('.simulate-button');
      var $simulationButtonText = $simulationButtonContainer.find('.text');
      var $simulationButtonProgressBox = $simulationButtonContainer.find('.progress-box');

      $simulationProgress.css('width', '0%');
      $simulationButton.prop('disabled', false);
      $simulationButtonText.text('Simulate');
      $simulationButtonProgressBox.css('z-index', '-1');
      $simulationButtonProgressBox.css('cursor', 'auto');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "73EF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_hand_range__ = __webpack_require__("9xGn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_five_card_hands_section__ = __webpack_require__("+Gii");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_controls_simulate_button__ = __webpack_require__("PQAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_five_card_hands_section_alerts__ = __webpack_require__("hmzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_hand_range_value_to_bluff_ratio__ = __webpack_require__("qfrL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-range-for-street',
  components: {
    'short-deck-hand-range': __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_hand_range__["a" /* default */],
    'five-card-hands-section': __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_five_card_hands_section__["a" /* default */],
    'simulate-button': __WEBPACK_IMPORTED_MODULE_2__components_controls_simulate_button__["a" /* default */],
    'five-card-hands-section-alerts': __WEBPACK_IMPORTED_MODULE_3__components_five_card_hands_section_alerts__["a" /* default */],
    'value-to-bluff-ratio': __WEBPACK_IMPORTED_MODULE_4__components_hand_range_value_to_bluff_ratio__["a" /* default */]
  },
  props: ['player', 'playerIndex', 'playerStateIndex', 'presetCommunityCards', 'presetHoleCards', 'textWhenFiveCardHandPercentagesArentUpToDate', 'storeModuleName', 'simulateButton', 'authorized'],
  computed: {
    handRankings: function handRankings() {
      return this.$store.getters['account/handRankings'];
    },
    disableAllSelectors: function disableAllSelectors() {
      if (!this.authorized) {
        return true;
      }

      if (this.playerStateIndex === 0) {
        return false;
      }

      return !this.presetCommunityCards.areAllCardsSet(this.playerStateIndex);
    }
  },
  methods: {
    handleFiveCardHandMouseover: function handleFiveCardHandMouseover(storeModuleName, $store, playerIndex, playerStateIndex, e) {
      if (!this.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        return;
      }

      this.player.handleFiveCardHandMouseover(storeModuleName, $store, playerIndex, playerStateIndex, e);
    },
    handleFiveCardHandMouseleave: function handleFiveCardHandMouseleave(storeModuleName, $store, playerIndex, playerStateIndex) {
      if (!this.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        return;
      }

      this.player.handleFiveCardHandMouseleave(storeModuleName, $store, playerIndex, playerStateIndex);
    },
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$refs['player-' + playerIndex + '-0']) {
        this.$refs['player-' + playerIndex + '-0'].resetDoubleSlider();
      }
    }
  }
});

/***/ }),

/***/ "7EEe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7JaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:_vm.tdClassObj,attrs:{"title":_vm.title},on:{"mousedown":function($event){if($event.ctrlKey||$event.shiftKey||$event.altKey||$event.metaKey){ return null; }return _vm.toggleGridSquare()},"click":[function($event){if(!$event.altKey){ return null; }if($event.ctrlKey||$event.shiftKey||$event.metaKey){ return null; }return _vm.toggleAscendingGeneralHands()},function($event){if(!$event.shiftKey){ return null; }if($event.ctrlKey||$event.altKey||$event.metaKey){ return null; }return _vm.expandGridSquareModal()}],"mouseover":function($event){return _vm.handleMouseover()}}},[(_vm.equityMatrix)?_c('span',{staticClass:"display-string",attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.generalHand.equity === null ? 'Simulate to compute equity' : ((_vm.generalHand.equity) + "% equity")}},[_vm._v(_vm._s(_vm.generalHand.displayString))]):_c('span',{staticClass:"display-string"},[_vm._v(_vm._s(_vm.generalHand.displayString))]),_vm._v(" "),(_vm.suitsDisplayVisible)?_c('grid-square-suits',{attrs:{"generalHand":_vm.generalHand}}):_vm._e(),_vm._v(" "),(_vm.weightVisible)?_c('weight-bar',{attrs:{"weight":_vm.generalHand.averageWeight,"shortDeck":_vm.shortDeck}}):_vm._e(),_vm._v(" "),(_vm.numSpecificHandsInRangeVisbile && !_vm.equityMatrix)?_c('span',{staticClass:"num-specific-hands-in-range"},[_vm._v("\n    "+_vm._s(_vm.generalHand.numSpecificHandsInRange)+"\n  ")]):_vm._e(),_vm._v(" "),(_vm.modalVisible)?_c('grid-square-modal',{staticClass:"grid-square-modal",attrs:{"generalHand":_vm.generalHand},on:{"selectSpecificHand":function($event){return _vm.$emit('selectSpecificHand', $event)},"deselectSpecificHand":function($event){return _vm.$emit('deselectSpecificHand', $event)},"setSpecificHandAsManuallySet":function($event){return _vm.$emit('setSpecificHandAsManuallySet', $event)},"setSpecificHandAsNotManuallySet":function($event){return _vm.$emit('setSpecificHandAsNotManuallySet', $event)},"applyExactWeightToGeneralHand":function($event){return _vm.$emit('applyExactWeightToGeneralHand', $event)},"setWeightOfSpecificHand":function($event){return _vm.$emit('setWeightOfSpecificHand', $event)},"modalHidden":function($event){_vm.modalVisible = false}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7blJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-long-run-disclaimer'
});

/***/ }),

/***/ "7gy8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_selector_vue__ = __webpack_require__("jev9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23872ca0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_selector_vue__ = __webpack_require__("ZBHL");
function injectStyle (ssrContext) {
  __webpack_require__("YiON")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23872ca0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_action_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23872ca0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_action_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7nko":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blog_post_link_vue__ = __webpack_require__("qx2/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0133328_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blog_post_link_vue__ = __webpack_require__("aJ+Y");
function injectStyle (ssrContext) {
  __webpack_require__("HUDt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c0133328"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_blog_post_link_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c0133328_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_blog_post_link_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8/zq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_cell_vue__ = __webpack_require__("ytjU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3f418da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_cell_vue__ = __webpack_require__("Go0A");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_table_cell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3f418da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_table_cell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "87tY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"saved-ranges-settings settings"},[_vm._m(0),_vm._v(" "),(_vm.noSavedRanges)?_c('p',[_vm._v("No saved ranges.")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('section',{staticClass:"saved-ranges"},_vm._l((_vm.savedRanges),function(savedRange,index){return _c('saved-range',{key:savedRange.id,attrs:{"savedRange":savedRange,"indexes":[index],"savedRanges":_vm.savedRanges,"indexesOfSelectedSavedRange":_vm.indexesOfSelectedSavedRange},on:{"showRange":function($event){return _vm.showRange($event)},"remove":function($event){return _vm.remove($event)},"addChild":function($event){return _vm.addChild($event)},"addSibling":function($event){return _vm.addSibling($event)},"moveUp":function($event){return _vm.moveUp($event)},"moveDown":function($event){return _vm.moveDown($event)},"indentRight":function($event){return _vm.indentRight($event)},"indentLeft":function($event){return _vm.indentLeft($event)}}})}),1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.selectedSavedRange)?_c('section',{staticClass:"selected-saved-range"},[_c('h3',[_vm._v(_vm._s(_vm.selectedRangeName))]),_vm._v(" "),(!_vm.shortDeck)?_c('grid-selector',{attrs:{"generalHands":_vm.selectedSavedRange.generalHands,"specificHandsNotAllowed":true},on:{"selectGeneralHand":function($event){return _vm.selectGeneralHand($event.generalHandString, _vm.selectedSavedRange.generalHands)},"deselectGeneralHand":function($event){return _vm.deselectGeneralHand($event, _vm.selectedSavedRange.generalHands)},"selectGeneralHands":function($event){return _vm.selectGeneralHands($event, _vm.selectedSavedRange.generalHands)},"deselectGeneralHands":function($event){return _vm.deselectGeneralHands($event, _vm.selectedSavedRange.generalHands)}}}):_vm._e(),_vm._v(" "),(_vm.shortDeck)?_c('short-deck-grid-selector',{attrs:{"generalHands":_vm.selectedSavedRange.generalHands,"specificHandsNotAllowed":true},on:{"selectGeneralHand":function($event){return _vm.selectGeneralHand($event.generalHandString, _vm.selectedSavedRange.generalHands)},"deselectGeneralHand":function($event){return _vm.deselectGeneralHand($event, _vm.selectedSavedRange.generalHands)},"selectGeneralHands":function($event){return _vm.selectGeneralHands($event, _vm.selectedSavedRange.generalHands)},"deselectGeneralHands":function($event){return _vm.deselectGeneralHands($event, _vm.selectedSavedRange.generalHands)}}}):_vm._e(),_vm._v(" "),_c('slider-selector',{ref:"sliderSelector",attrs:{"percentOfHandsInRangeNumberForDisplay":_vm.percentOfHandsInRangeNumberForDisplay,"numberOfSpecificHandsInRange":_vm.numberOfSpecificHandsInSelectedSavedRange,"numberOfPossibleSpecificHands":_vm.numberOfPossibleSpecificHands,"disabled":false},on:{"setRangeToMatchDoubleSlider":function($event){return _vm.setRangeToMatchDoubleSlider($event)}}}),_vm._v(" "),_c('text-selector',{attrs:{"generalHands":_vm.selectedSavedRange.generalHands},on:{"setRangeToMatchSpecificHandStrings":function($event){return _vm.setRangeToMatchSpecificHandStrings($event)}}})],1):_vm._e()])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_vm._m(1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h3',[_vm._v("1. Set a range")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/saved-ranges-1.png"}}),_vm._v(" "),_c('h3',[_vm._v("2. Click save")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/saved-ranges-2.png"}}),_vm._v(" "),_c('h3',[_vm._v("3. Click to add the range")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/saved-ranges-3.png"}}),_vm._v(" "),_c('h3',[_vm._v("4. The range that you set in step 1 will be added")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/saved-ranges-4.png"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Saved ranges")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/mbm1unyFNMQ?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Note: The default ranges come from "),_c('a',{attrs:{"href":"https://redchippoker.com/infographic-pre-flop-ranges/"}},[_vm._v("Ed Miller's recommendations")]),_vm._v(". If you want to create your own ranges but need help, I'd highly recommend reading "),_c('a',{attrs:{"href":"https://edmillerpoker.com/product/how-to-read-hands-at-no-limit-holdem/"}},[_vm._v("How To Read Hands At No-Limit Hold’em")]),_vm._v(". Or for a quicker read, check out "),_c('a',{attrs:{"href":"https://splitsuit.com/range-building-open-raises-preflop"}},[_vm._v("Range Building - What Did They Open-Raise Preflop")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "89NH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pricing_table_vue__ = __webpack_require__("meTV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64757d40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pricing_table_vue__ = __webpack_require__("3fsa");
function injectStyle (ssrContext) {
  __webpack_require__("SoMB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64757d40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pricing_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64757d40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pricing_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8DYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8NDo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'onboarding-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */]
  },
  props: ['toolName', 'urlPath'],
  methods: {
    navigate: function navigate(e) {
      e.preventDefault();
      $(this.$el).modal('hide');
      this.$router.push('/help/' + this.urlPath);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "8TW+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_Players__ = __webpack_require__("IPbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__ = __webpack_require__("XRwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_service__ = __webpack_require__("JBFI");






var state = {
  hasSimulationBeenRun: false,
  presetCommunityCards: new __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__["a" /* default */](),
  players: new __WEBPACK_IMPORTED_MODULE_0__services_player_Players__["a" /* default */]()
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_2__services_share_url_service__["a" /* default */].setEquityCalculatorStoreState(stateFromServer, state);
  },
  setHasSimulationBeenRun: function setHasSimulationBeenRun(state, value) {
    state.hasSimulationBeenRun = value;
  },

  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHand(state, payload);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHands(state, payload);
  },
  selectSpecificHand: function selectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function deselectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectSpecificHand(state, payload);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHands(state, payload);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectAllGeneralHands(state, payload);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function setWeightOfSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightOfSpecificHand(state, payload);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function addComboToCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function removeComboFromCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeComboFromCombosToAdd(state, payload);
  },
  narrowRange: function narrowRange(state, payload) {
    state.players.find(payload.playerIndex).narrowRange(payload.checkedHands, state.presetCommunityCards);
  },

  // controls
  setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function setBoard(state, boardCards) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setBoard(state, boardCards);
  },
  removePresetCommunityCard: function removePresetCommunityCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetCommunityCard(state, position);
  },
  addPlayer: function addPlayer(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addPlayer(state, payload);
  },
  removePlayer: function removePlayer(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePlayer(state, playerIndex);
  },
  updateEquityResults: function updateEquityResults(state, payload) {
    var player = void 0;
    var equity = void 0;
    var wins = void 0;
    var ties = void 0;
    var winFractions = void 0;
    var numberOfSimulations = payload.numberOfSimulations;
    var numPlayers = payload.simulationResults.length;

    for (var i = 0; i < numPlayers; i++) {
      player = state.players.find(i);
      wins = payload.simulationResults[i].wins;
      ties = payload.simulationResults[i].ties;
      winFractions = payload.simulationResults[i].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = (wins + winFractions) / numberOfSimulations * 100;
      equity -= equity * (payload.rakePercentage / 100) + equity * (payload.tipPercentage / 100);

      player.states[0].equity = equity;
      player.states[0].winPercentage = wins / numberOfSimulations * 100;
      player.states[0].tiePercentage = ties / numberOfSimulations * 100;
    }

    state.hasSimulationBeenRun = true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations
});



/***/ }),

/***/ "8TxB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_parent_FiveCardHandParent__ = __webpack_require__("Y/UK");






var MadeHandParent = function (_FiveCardHandParent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MadeHandParent, _FiveCardHandParent);

  function MadeHandParent(argsObj) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MadeHandParent);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MadeHandParent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MadeHandParent)).call(this, argsObj));
  }

  return MadeHandParent;
}(__WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_parent_FiveCardHandParent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MadeHandParent);
;

/***/ }),

/***/ "8Wfc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hand-range panel panel-default"},[_c('hand-range-header',{attrs:{"generalHands":_vm.generalHands,"weightToApplyToAddedHands":_vm.weightToApplyToAddedHands,"combosToAdd":_vm.combosToAdd,"canBeRemoved":_vm.canBeRemoved,"specificHandsNotAllowed":_vm.specificHandsNotAllowed,"disabled":_vm.disableAllSelectors},on:{"removePlayer":function($event){return _vm.$emit('removePlayer')},"clearRange":function($event){return _vm.emitAndResetDoubleSlider('clearRange')},"addComboToCombosToAdd":function($event){return _vm.$emit('addComboToCombosToAdd', $event)},"removeComboFromCombosToAdd":function($event){return _vm.$emit('removeComboFromCombosToAdd', $event)},"applyExactWeightToGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('applyExactWeightToGeneralHands', $event)},"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}},[_vm._t("left-header",null,{"slot":"left-header"}),_vm._v(" "),_vm._t("extra-dropdown-item-1",null,{"slot":"extra-dropdown-item-1"})],2),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('section',{staticClass:"left-or-top"},[_c('grid-selector',{attrs:{"generalHands":_vm.generalHands,"disabled":_vm.disableAllSelectors,"specificHandsNotAllowed":_vm.specificHandsNotAllowed},on:{"selectGeneralHand":function($event){return _vm.emitAndResetDoubleSlider('selectGeneralHand', $event)},"deselectGeneralHand":function($event){return _vm.emitAndResetDoubleSlider('deselectGeneralHand', $event)},"selectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('selectGeneralHands', $event)},"deselectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('deselectGeneralHands', $event)},"selectSpecificHand":function($event){return _vm.emitAndResetDoubleSlider('selectSpecificHand', $event)},"deselectSpecificHand":function($event){return _vm.emitAndResetDoubleSlider('deselectSpecificHand', $event)},"setSpecificHandAsManuallySet":function($event){return _vm.emitAndResetDoubleSlider('setSpecificHandAsManuallySet', $event)},"setSpecificHandAsNotManuallySet":function($event){return _vm.emitAndResetDoubleSlider('setSpecificHandAsNotManuallySet', $event)},"applyExactWeightToGeneralHand":function($event){return _vm.emitAndResetDoubleSlider('applyExactWeightToGeneralHand', $event)},"setWeightOfSpecificHand":function($event){return _vm.emitAndResetDoubleSlider('setWeightOfSpecificHand', $event)},"finishedClickAndDrag":function($event){return _vm.$emit('finishedClickAndDrag')}}}),_vm._v(" "),_c('slider-selector',{ref:"sliderSelector",attrs:{"percentOfHandsInRangeNumberForDisplay":_vm.generalHands.percentOfHandsInRangeNumberForDisplay,"numberOfSpecificHandsInRange":_vm.generalHands.numberOfSpecificHandsInRange.roundToTwoDecimalPlaces(),"numberOfPossibleSpecificHands":_vm.generalHands.numberOfPossibleSpecificHands.roundToTwoDecimalPlaces(),"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors},on:{"setRangeToMatchDoubleSlider":function($event){return _vm.$emit('setRangeToMatchDoubleSlider', $event)}}}),_vm._v(" "),(_vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || _vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings')?_c('horizontal-set-weight-to-apply-to-added-hands-basic',{ref:"horizontalSetWeightToApplyToAddedHandsSlider",attrs:{"weightToApplyToAddedHands":_vm.weightToApplyToAddedHands,"disabled":_vm.disableAllSelectors},on:{"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}}):_vm._e(),_vm._v(" "),_c('text-selector',{attrs:{"generalHands":_vm.generalHands,"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors},on:{"setRangeToMatchSpecificHandStrings":function($event){return _vm.emitAndResetDoubleSlider('setRangeToMatchSpecificHandStrings', $event)}}})],1),_vm._v(" "),(_vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || _vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings')?_c('vertical-set-weight-to-apply-to-added-hands',{ref:"verticalSetWeightToApplyToAddedHandsSlider",attrs:{"weightToApplyToAddedHands":_vm.weightToApplyToAddedHands,"disabled":_vm.disableAllSelectors},on:{"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}}):_vm._e(),_vm._v(" "),(!_vm.disableAllSelectors && !_vm.disableAllButGridSelector)?_c('section',{staticClass:"right-or-bottom"},[_c('ul',{staticClass:"nav nav-pills nav-stacked"},[_c('li',{class:{ 'active': _vm.activeTab === 'saved-ranges' }},[_c('a',{on:{"click":function($event){_vm.activeTab = 'saved-ranges'}}},[_vm._v("Saved ranges")])]),_vm._v(" "),_c('li',{class:{ 'active': _vm.activeTab === 'tiers' }},[_c('a',{on:{"click":function($event){_vm.activeTab = 'tiers'}}},[_vm._v("Tiers")])]),_vm._v(" "),_c('li',{class:{ 'active': _vm.activeTab === 'categories' }},[_c('a',{on:{"click":function($event){_vm.activeTab = 'categories'}}},[_vm._v("Categories")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('hr'),_vm._v(" "),(_vm.activeTab === 'saved-ranges')?_c('div',{class:{ 'active': _vm.activeTab === 'saved-ranges', 'tab-pane': true }},[_c('saved-ranges-selector',{attrs:{"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors,"generalHands":_vm.generalHands},on:{"setRangeToMatchGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('setRangeToMatchGeneralHands', $event)}}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'tiers')?_c('div',{class:{ 'active': _vm.activeTab === 'tiers', 'tab-pane': true }},[_c('tier-selector',{attrs:{"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors,"generalHands":_vm.generalHands},on:{"selectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('selectGeneralHands', $event)},"deselectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('deselectGeneralHands', $event)}}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'categories')?_c('div',{class:{ 'active': _vm.activeTab === 'categories', 'tab-pane': true }},[_c('category-selector',{attrs:{"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors,"generalHands":_vm.generalHands},on:{"selectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('selectGeneralHands', $event)},"deselectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('deselectGeneralHands', $event)}}})],1):_vm._e()])]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8jNq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_flop_selector__ = __webpack_require__("d+yY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_bluff_size_selector__ = __webpack_require__("+rnN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_conclusions_fold_equity_table__ = __webpack_require__("zFKT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__ = __webpack_require__("unvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_bluff_help_range__ = __webpack_require__("PrIL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-flop-steps',
  components: {
    'flop-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_flop_selector__["a" /* default */],
    'bluff-size-selector': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_bluff_size_selector__["a" /* default */],
    'fold-equity-table': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_conclusions_fold_equity_table__["a" /* default */],
    'set-range-step': __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__["a" /* default */],
    'range-help-section': __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_bluff_help_range__["a" /* default */]
  },
  props: ['state', 'textWhenFiveCardHandPercentagesArentUpToDate', 'authorized'],
  computed: {
    showFoldEquityTable: function showFoldEquityTable() {
      return this.state.players.numPlayers === 1 && this.state.players.find(0).states[1].foldEquityAgainstDifferentRanges.length > 0 && this.state.streetToBluff === 'flop' && this.state.presetCommunityCards.flopSet && !this.state.presetCommunityCards.pairedBoard;
    }
  },
  methods: {
    getTextForPlayerRangeStep: function getTextForPlayerRangeStep(playerIndex) {
      var numOpponents = this.state.players.numPlayers;

      if (this.state.streetToBluff === 'flop') {
        if (numOpponents === 1) {
          return 'Step ' + (6 + numOpponents + playerIndex) + ': What do you think your opponent would continue with versus your ' + this.state.bluffSize + ' pot flop bluff?';
        } else {
          return 'Step ' + (6 + numOpponents + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + ' would continue with versus your ' + this.state.bluffSize + ' pot flop bluff?';
        }
      } else {
        if (numOpponents === 1) {
          return 'Step ' + (5 + numOpponents + playerIndex) + ': What do you think your opponents range is after the flop action is finished (eg. heading in to the turn)?';
        } else {
          return 'Step ' + (5 + numOpponents + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is after the flop action is finished (eg. heading in to the turn)?';
        }
      }
    }
  }
});

/***/ }),

/***/ "8p/r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__ = __webpack_require__("T8TE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_help_bluff_size_selection__ = __webpack_require__("VAax");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'bluff-size-selector',
  components: {
    'toggle-help-button': __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__["a" /* default */],
    'help-section': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_help_bluff_size_selection__["a" /* default */]
  },
  props: ['step', 'bluffSize', 'authorized'],
  data: function data() {
    return {
      helpAreaVisible: false,
      customBluffSize: 1
    };
  },
  watch: {
    bluffSize: function bluffSize() {
      if (!['1/3', '1/2', '2/3', '3/4', 'full', '1.5x', '2x'].includes(this.bluffSize)) {
        this.customBluffSize = this.bluffSize.split('x')[0];
      }
    }
  },
  methods: {
    toggleHelp: function toggleHelp() {
      this.helpAreaVisible = !this.helpAreaVisible;
    }
  }
});

/***/ }),

/***/ "8r4B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"beginners-guide"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("If you are unfamiliar with equity calculators and poker software like Flopzilla, then you are in the right place. Even if you are an experienced poker player.")]),_vm._v(" "),_c('p',[_vm._v("If you are familiar with that sort of stuff, then head over to the "),_c('router-link',{attrs:{"to":"/quick-guide"}},[_vm._v("quick guide")]),_vm._v(" for an overview of Six Plus Hold’em that isn't nearly as lengthy.")],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h2',{attrs:{"id":"beginners-guide-equity-calculator"}},[_vm._v("Equity calculator")]),_vm._v(" "),_c('p',[_vm._v("To explain how the "),_c('router-link',{attrs:{"to":"/equity-calculator"}},[_vm._v("equity calculator")]),_vm._v(" works, let's explore a common scenario. You are playing $1/$2 No Limit Texas Hold’em at your local casino. You look down at your cards to find that you have an ace of clubs and a king of spades, which is abbreviated AcKs in the poker world. Pretty good! So you raise to $8. It folds around to the player in the big blind. This guy raises all in to $200! What do you do? Call, or fold?")],1),_vm._v(" "),_c('p',[_vm._v("I play $1/$2 No Limit Hold’em (NLHE) in Vegas, and my impression is that most players happily get it in (call) in this scenario. Presumably, they think to themselves that AKo (ace king offsuit) is one of the best starting hands in the game - perhaps third or fourth best - and so it is worth a call.")]),_vm._v(" "),_c('p',[_vm._v("Makes some sense. But let's take the time to explore this question in more depth.")]),_vm._v(" "),_c('p',[_vm._v("To know whether or not it is worth a call, we're going to have to dive in to the numbers and do a little math. I promise, it won't be intimidating.")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',[_vm._v("A simplified version of that statement would be, \"if you win 47.9% of the time or more, it is worth calling\". But let's dive in to what that term \"equity\" really means.")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("Returning to the question of whether we should call the all in bet with our AcKs, we know that we need 47.9% equity to justify calling, but that just begs the question of how we know how much equity we have. Equity calculators help us answer that question.")]),_vm._v(" "),_c('p',[_vm._v("This is Premium Poker Tool's equity calculator:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/1.png"}}),_vm._v(" "),_c('p',[_vm._v("The box to the left represents you; the box to the right represents your opponent:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/2.png"}}),_vm._v(" "),_c('p',[_vm._v("You know what your cards are, so why don't we go ahead and click the AKo grid square.")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("That just set \"ace king offsuit\" (AKo) as your hand. But there are twelve combinations of AKo - AcKs, AcKh, AcKd, AsKc, etc. If we want to be even more precise and enter AcKs specifically, we can either:")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("This is one part of poker that requires judgement - determining your opponent's range. When you are at the table, be sure to pay careful attention and observe your opponents. Have they gone all in for $200 with 66 in the past? If so, we can probably assume that they'd also go all in with 77. And 88. And 99, TT, JJ, QQ, KK and AA. It also probably means that they would go all in with AK, because AK is, in most peoples minds, a stronger hand than 66. But what about AQ? Probably. AJ? Maybe.")]),_vm._v(" "),_c('p',[_vm._v("Determining your opponent's range is certainly not an exact science. Even if you had a record of every hand your opponent played, we are still dealing with human beings here, and humans don't always behave like they did in the past. Sometimes someone who normally folds 33 will feel like gambling. Sometimes someone who normally plays TT isn't feeling lucky. Sometimes someone studies the game and changes their strategy. (Hint: that's you!)")]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',[_vm._v("Six Plus Hold’em offers you a variety of shortcuts that you can use to set ranges. Note that they all stay in sync with each other.")]),_vm._v(" "),_c('h4',[_vm._v("Tier selector:")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',[_vm._v("Note: you can configure the default tiers at "),_c('router-link',{attrs:{"to":"/settings/general/tiers"}},[_vm._v("Settings / General / Tiers")]),_vm._v(".")],1),_vm._v(" "),_c('h4',[_vm._v("Category selector:")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('h4',[_vm._v("Saved ranges selector:")]),_vm._v(" "),_c('p',[_vm._v("Note: To use the saved ranges selector, set it at "),_c('router-link',{attrs:{"to":"/settings/general/included-selectors"}},[_vm._v("Settings / General / Included selectors")]),_vm._v(". To customize the saved ranges, go to "),_c('router-link',{attrs:{"to":"/settings/general/saved-ranges"}},[_vm._v("Settings / General / Saved ranges")]),_vm._v(".")],1),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('h4',[_vm._v("Slider selector:")]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('h4',[_vm._v("Text selector:")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('p',[_vm._v("Now let's put our opponent on a range, and run a simulation to see how much equity we have. Let's first suppose that our opponent is relatively tight, and that he only goes all in like this with AA, KK, QQ, and AKs.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/3.png"}}),_vm._v(" "),_c('p',[_vm._v("Woah! Even though we have one of the best hands in the game, versus this range in particular, we actually only have about 33.21% equity, which is way less than the 47.9% we would need to justify calling.")]),_vm._v(" "),_c('p',[_vm._v("Take note of the insights section:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/4.png"}}),_vm._v(" "),_c('p',[_vm._v("Here is what it is saying:")]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('p',[_vm._v("Let's continue to explore whether it is worth calling your opponent off with AKo. Maybe your opponent isn't as tight as we initially assumed. Maybe he would make that all in bet with JJ+, AKs, and AKo.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/5.png"}}),_vm._v(" "),_c('p',[_vm._v("Even against that range, we still only have about 39.84% equity, which of course is way less than the 47.9% we would need to justify calling.")]),_vm._v(" "),_c('p',[_vm._v("Would our opponent make this all in bet with an even wider range? Let's suppose that our opponent is a little crazy and makes this bet with 99+ and AQ+.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/6.png"}}),_vm._v(" "),_c('p',[_vm._v("Now it finally seems that it may be worth a call with our 48.67% equity against this range. But it's still really, really close.")]),_vm._v(" "),_c('p',[_vm._v("What if our opponent is just wild? What if our opponent is blasting all in with the top 20% of his hands?")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/7.png"}}),_vm._v(" "),_c('p',[_vm._v("Ok, this time we have a pretty clear call with 61.2% equity.")]),_vm._v(" "),_c('p',[_vm._v("As you can see, Six Plus Hold’em can't actually tell you what the right play is. But when combined with you're judgement as a poker player, it is a tool that can really give you some useful insights.")]),_vm._v(" "),_c('p',[_vm._v("Now, let's explore some of the slightly more advanced features of Six Plus Hold’em' equity calculator.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-multiway"}},[_vm._v("Multiway")]),_vm._v(" "),_c('p',[_vm._v("Suppose that we have the same situation as above, except that there is one more player in the hand. Suppose that the player in the small blind (SB) is the one who raised all in, and that the player in the big blind (BB) called. Now, you face a different situation. Fortunately, Six Plus Hold’em can help you analyze this situation too.")]),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',[_vm._v("Now let's use the equity calculator to put our opponents on some ranges, and see how our AcKs does against those ranges.")]),_vm._v(" "),_c('p',[_vm._v("But before we start doing that, let's add a third player to the hand. To add a third player to the hand, click the \"Add player\" button towards the bottom left of the screen:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/8.png"}}),_vm._v(" "),_c('p',[_vm._v("Let's start off by entering our hand:")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('p',[_vm._v("Next, let's think about the range that the SB might be on. Let's start off supposing that the initial raiser is tight and has a range of AA, KK, QQ, and AKs, like we did before:")]),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('p',[_vm._v("Now let's think about the range that the caller from the BB might be on. Let's also start off supposing that he is on a tight AA, KK, QQ and AKs range:")]),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('p',[_vm._v("Before clicking \"Simulate\" and seeing how much equity we have, I have a question for you: which scenario do you think you'll be better off in - AKo versus one tight range, or AKo versus two tight ranges? Think about it before continuing.")]),_vm._v(" "),_c('p',[_vm._v("After clicking \"Simulate\", you'll see that you only have about 15.64% equity. This is objectively a worse situation to be in. The expected value of having 15.64% equity in a $600 pot is $93.84, whereas the expected value of having 33.21% equity in a $401 pot is $133.17.")]),_vm._v(" "),_c('p',[_vm._v("So it seems that versus two opponents, we're going to have an even harder time justifying call. It seems that both opponents are going to have to be relatively loose.")]),_vm._v(" "),_c('p',[_vm._v("But don't trust the way it seems. Play around with different ranges until you are comfortable knowing how loose your opponents have to be for you to justify calling.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-postflop"}},[_vm._v("Postflop + narrowing your opponents range")]),_vm._v(" "),_c('p',[_vm._v("Let's consider a new situation. Suppose that you raise $8 from the button with AcKs, and the BB calls. The flop comes AhTd9d. The BB checks to you. You bet $15 into the $17 pot. The BB re-raises all in to $200. Do you call, or fold?")]),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('p',[_vm._v("Next, as we did before, let's enter our AcKs:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/10.png"}}),_vm._v(" "),_c('p',[_vm._v("Now, we're going to do things slightly differently. Instead of setting our opponents range, we're going to set the flop cards to AhTd9d. Here's how:")]),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('p',[_vm._v("Now, when we run simulations, the flop is always going to start off as AhTd9d, and then the turn and river will be dealt from the deck.")]),_vm._v(" "),_c('p',[_vm._v("Next, we are going to want to set our opponent's range, but the way we're going to do so is going to be slightly different. Well, we could just ask ourselves what our opponent would make this play with and click those grid squares, but the way I'm going to show you will be easier.")]),_vm._v(" "),_c('p',[_vm._v("Let's first ask ourselves what our opponent would call our $8 raise with from the BB preflop. Perhaps the answer to that is something like... the top 30% of hands except AA, KK, QQ and AKs (because we assume he would raise with those rather than calling). Let's start off by setting that as our opponent's range:")]),_vm._v(" "),_vm._m(24),_vm._v(" "),_c('p',[_vm._v("Now, let's click the \"Narrow range\" button:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/11.png"}}),_vm._v(" "),_c('p',[_vm._v("What do we think our opponent would check-raise us with on this board? Perhaps two pair or better, and flush draws. Let's check that stuff off and click \"Narrow range\" inside the modal. When we do, it will eliminate all holdings from our opponents range that don't make two pair or better or a flush draw on this flop:")]),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('p',[_vm._v("That was easier then manually inputting all of the two pair and better + flush draws, right?")]),_vm._v(" "),_c('p',[_vm._v("Now that we have our hand, our opponent's range, and the flop set, we can simulate and see how much equity we have:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/12.png"}}),_vm._v(" "),_c('p',[_vm._v("Looks like we only have about 35.90% equity. We need 44.14% equity, and so, despite the fact that it appears to be a great hand, our AcKs should actually be folded in this situation.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-hand-weights"}},[_vm._v("Hand weights")]),_vm._v(" "),_c('p',[_vm._v("Let's consider that situation we had in the previous section. We initially removed AA, KK, QQ and AKs from our opponents range because we assumed that they would have raised with those hands rather than just calling:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/13.png"}}),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('p',[_vm._v("Anyway, what does this mean for Six Plus Hold’em? AA can either be in your opponent's range, or not be in your opponents range, right? So how can we tell the app that our opponent only has this in his range 25% of the time?")]),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_c('p',[_vm._v("If you want to apply the same weight to multiple hands at the same time, you can use the \"Set hand weights\" button like so:")]),_vm._v(" "),_vm._m(30),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-future-streets"}},[_vm._v("Future streets")]),_vm._v(" "),_c('p',[_vm._v("So far we've only examined all in situations. This kept things simple. In these situations, once you decide to call, there are no more decisions left to make for anyone. You just wait for the dealer to deal until the river, and then you see who wins.")]),_vm._v(" "),_c('p',[_vm._v("In reality, for most situations you're in, if you decide to call, the hand will not be over and you'll be faced with more decisions to make on future streets (eg. after the dealer deals the next board card(s)). There are various implications of this, and these implications mean that pot odds and equity are just the starting point of your analysis, not the end.")]),_vm._v(" "),_vm._m(31),_vm._v(" "),_c('p',[_vm._v("Imagine that you are playing against an aggressive opponent. You flop a flush draw. With a flush draw, you will make a flush about 36% of the time by the river. Suppose that your opponent bets the flop, you have 2:1 pot odds, and that you only \"need\" 33.3% equity to justify calling.")]),_vm._v(" "),_c('p',[_vm._v("Given that your opponent is aggressive, even if he was bluffing on the flop, he is likely to continue bluffing on the turn. This may mean that you'll have to fold. Which means you won't get to see the river. Which means you aren't fully getting a chance to see if you make your flush. That really changes things. The equity stuff we've been talking about is referring to the chance that you win the pot assuming that everything just stops and we deal to the river right now and see who wins. In reality, sometimes you get bluffed before you get a chance to see the river. That's something to consider.")]),_vm._v(" "),_vm._m(32),_vm._v(" "),_c('p',[_vm._v("On the other hand, what if you have something like top pair. Top pair seems like a great hand, but this can be a blessing in disguise, because when your opponent makes a straight or a flush, you're likely to put a bunch of money in the pot and lose. This is called reverse implied odds. The idea that you're at risk of losing a bunch of money on future streets. The opposite of implied odds.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-other-things-to-consider"}},[_vm._v("Other things to consider")]),_vm._v(" "),_vm._m(33),_vm._v(" "),_c('p',[_vm._v("I totally agree (with the first statement, not the second one in parentheses). There are other factors to consider other than the ones I've mentioned in the scenarios above. Here are some:")]),_vm._v(" "),_vm._m(34),_vm._v(" "),_c('h2',{attrs:{"id":"beginners-guide-hit-calculator"}},[_vm._v("Hit calculator")]),_vm._v(" "),_c('p',[_vm._v("There is kind of a lot going on with the "),_c('router-link',{attrs:{"to":"/hit-calculator"}},[_vm._v("hit calculator")]),_vm._v(", so let me explain it in steps.")],1),_vm._v(" "),_c('p',[_vm._v("Suppose that you want to know how often 76s flops a straight, a flush, a flush draw, etc. The hit calculator will answer all of those questions:")]),_vm._v(" "),_vm._m(35),_vm._v(" "),_c('p',[_vm._v("The results section (with all of the checkboxes) shows you that you'll flop a straight about 1.2% of the time, a flush 0.76% of the time, and a flush draw 10.96% of the time.")]),_vm._v(" "),_c('p',[_vm._v("Suppose that you want to see how often 76s makes a straight by the turn, rather than on the flop. Easy:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/14.png"}}),_vm._v(" "),_c('p',[_vm._v("Suppose that you want to see how often 7c6c makes a flush by the river when the flop comes Ac7h4d. Easy:")]),_vm._v(" "),_vm._m(36),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-analyzing-whether-to-bluff-the-flop"}},[_vm._v("Analyzing whether to bluff the flop")]),_vm._v(" "),_c('p',[_vm._v("Ok, that stuff was just a warm up. Now let's get in to the meat of the hit calculator.")]),_vm._v(" "),_c('p',[_vm._v("Suppose that you have Qc3c. You raise preflop, and the BB calls. The flop comes 9d4s2h. The BB checks to you.")]),_vm._v(" "),_c('p',[_vm._v("You could easily just check behind. You totally missed the flop. You have no made hands, and no draws. May as well check, right?")]),_vm._v(" "),_c('p',[_vm._v("Well, what about bluffing? Let's explore whether that would be a good idea in this scenario.")]),_vm._v(" "),_vm._m(37),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_c('p',[_vm._v("The insights section shows you how often various bluff sizes need to work so that you don't always have to be doing the math yourself, although you should get familiar with these numbers so that it is second nature to you when you're at the table.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/15.png"}}),_vm._v(" "),_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_vm._m(42),_vm._v(" "),_c('p',[_vm._v("A good approach is usually to start off figuring out what the immediately profitable equation says, and then adjusting for other things. For example, we don't have too many outs with our Qc3c in this situation, but if we had a flush draw, we would have a much larger chance of getting lucky and outdrawing our opponent, and so our bluff might only need to work 20% of the time for it to be profitable in the long run, rather than the 33.3% that the immediately profitable equation told us. Also make sure that you adjust for things like implied odds and position.")]),_vm._v(" "),_c('p',[_vm._v("Now let's return back to the question at hand of whether we should attempt a bluff with our Qc3c against our opponent who called our preflop bet and checked to us on the flop. Let's be a little bit conservative and say that a half pot bluff of $5 needs to work 30% of the time against our opponent. In reality, we have position on our opponent so I may go down to 25% personally, but let's play it safe for now. The obvious next question is how we can know how often this bluff will work.")]),_vm._v(" "),_c('p',[_vm._v("First, let's set our opponents range. For someone who called preflop and checked the flop, I'd say something like the top 30% of hands except AA, KK, QQ and AKs (assuming they'd raise with those) is reasonable (if we wanted to be more precise, we could set some hand weights, but let's leave that for another day).")]),_vm._v(" "),_vm._m(43),_vm._v(" "),_c('p',[_vm._v("Next, let's set our cards (Qc3c):")]),_vm._v(" "),_vm._m(44),_vm._v(" "),_c('p',[_vm._v("Next, let's set the flop to 9d4s2h:")]),_vm._v(" "),_vm._m(45),_vm._v(" "),_c('p',[_vm._v("Now let's run a simulation and see how often our opponent's range flops various hands:")]),_vm._v(" "),_vm._m(46),_vm._v(" "),_c('p',[_vm._v("We're getting somewhere...")]),_vm._v(" "),_c('p',[_vm._v("Next, let's ask ourselves what our opponent would call our $5 bet with. Middle pair? Top pair? Flush draws? Open ended straight draws? Gutshots? Overcards?")]),_vm._v(" "),_c('p',[_vm._v("Alternatively, we can ask Six Plus Hold’em what it thinks our opponent would call the bet with. Clicking \"Set checkboxes to default\" and then \"Tight\" is basically saying \"Hey Six Plus Hold’em, what do you think a tight opponent would call a bet with on this 9d4s2h flop?\".")]),_vm._v(" "),_vm._m(47),_vm._v(" "),_c('p',[_vm._v("Six Plus Hold’em is telling us that our opponent would \"hit\" this flop 79.01% of the time.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/16.png"}}),_vm._v(" "),_c('p',[_vm._v("In other words, this is saying that our opponent would call or raise our bet 79.01% of the time. Which means that he'd only be folding 20.99% of the time, which really doesn't seem like enough to justify a bluff.")]),_vm._v(" "),_c('p',[_vm._v("But maybe we don't agree with Six Plus Hold’em' assumption that a tight player would call with two overcards on this board. If so, we can uncheck that checkbox and see that now the hit percentage is just 36.69%.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/17.png"}}),_vm._v(" "),_vm._m(48),_vm._v(" "),_vm._m(49),_vm._v(" "),_c('p',[_vm._v("You also need to take other things in to consideration. For example, some players have a leak in their game where they call a lot of flop bets (called a cbet when the preflop raiser bets the flop when checked to), but fold on a lot of turn bets (betting the flop and then the turn is called \"two barelling\"). In that case, you're happy to see them call you on the flop. That's just more money in the pot for you to win when they give up frequently on the turn.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-analyzing-whether-to-bluff-the-turn"}},[_vm._v("Analyzing whether to bluff the turn")]),_vm._v(" "),_c('p',[_vm._v("Speaking of which, let's suppose that our opponent calls our flop bet and the turn comes Kd. Let's analyze whether we should try bluffing our opponent on this turn.")]),_vm._v(" "),_c('p',[_vm._v("If our opponent calls the flop bet, that is information that we can use to narrow his range. For example, if we say that he wouldn't call flop bets with two overcards we can eliminate the hands like KTo from his range.")]),_vm._v(" "),_c('p',[_vm._v("Doing so is really, really easy - just click the \"Narrow range\" button!")]),_vm._v(" "),_vm._m(50),_vm._v(" "),_c('p',[_vm._v("Next, let's set Kd as the turn card and simulate to the turn.")]),_vm._v(" "),_vm._m(51),_vm._v(" "),_c('p',[_vm._v("And let's redo the checkboxes now. We can't assume that he will continue with exactly the same stuff as he would on the flop.")]),_vm._v(" "),_c('p',[_vm._v("Again, we can check off the checkboxes ourselves, or we can just ask Six Plus Hold’em. Let's start off asking Six Plus Hold’em what a tight opponent would continue with on the turn:")]),_vm._v(" "),_vm._m(52),_vm._v(" "),_c('p',[_vm._v("Wow, looks like only 17.86% of hands would continue. That would make bluffing immensely profitable. But what if our opponent isn't so tight, what if he is more straightforward. Let's ask Six Plus Hold’em how that changes things:")]),_vm._v(" "),_vm._m(53),_vm._v(" "),_c('p',[_vm._v("Now 54.3% of hands hit. That's a big difference. So this is a scenario that really requires some skill to make a good educated guess as to what our opponent would continue with on this turn.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-analyzing-whether-to-bluff-the-river"}},[_vm._v("Analyzing whether to bluff the river")]),_vm._v(" "),_c('p',[_vm._v("Let's suppose that we bet the turn, our opponent calls, and the river comes Jc. Should we try bluffing a third time on the river?")]),_vm._v(" "),_c('p',[_vm._v("To analyze that question, we're going to take the same steps as before. First, let's narrow our opponents range. Since our opponent called the turn, we know that he doesn't have any hands that would have folded the turn.")]),_vm._v(" "),_vm._m(54),_vm._v(" "),_c('p',[_vm._v("Next, let's set Jc as the river card, and simulate to the river:")]),_vm._v(" "),_vm._m(55),_vm._v(" "),_c('p',[_vm._v("Now let's ask ourselves what we think our opponent would call, say, a half pot bet with. We can start off by asking Six Plus Hold’em, and then adjusting it using our judgement if necessary.")]),_vm._v(" "),_vm._m(56),_vm._v(" "),_c('p',[_vm._v("This time the checks happened to have been already set to what Six Plus Hold’em wanted to set them to.")]),_vm._v(" "),_c('p',[_vm._v("Alright, so it looks like our opponent will only be calling or raising about 37.29% of the time, which means that he'll be folding 72.71% of the time, which is more than enough for bluffs to be immediately profitable.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-bluff-raising"}},[_vm._v("Bluff raising")]),_vm._v(" "),_c('p',[_vm._v("We have been analyzing \"vanilla\" situations where our opponent checks to us and we are considering whether or not to bluff. But what about situations where our opponent bets and we want to consider a reraising them as a bluff?")]),_vm._v(" "),_c('p',[_vm._v("The math is the same. Let's go through an example. Suppose that the pot is $20. Your opponent bets $10. You are considering reraising to $40 as a bluff. How often would that bluff raise need to work?")]),_vm._v(" "),_vm._m(57),_vm._v(" "),_c('p',[_vm._v("Instead of doing this math yourself, you can just check out the \"Bluff raising\" tab in the insights section:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/18.png"}}),_vm._v(" "),_c('p',[_vm._v("Again, you won't have this at the table with you so you should familiarize yourself with these numbers so that when you are at the table you can consider various bluff sizes and know how often they need to work to be immediately profitable.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-setting-the-flop-texture"}},[_vm._v("Setting the flop according to a texture")]),_vm._v(" "),_c('p',[_vm._v("If you have a hand that you played in real life, you can set the board cards and analyze the situation. But what if you are just studying poker, rather than analyzing a particular hand? The \"Set flop\" button is really useful for that.")]),_vm._v(" "),_c('p',[_vm._v("This is what the set flop button and selector look like:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/19.png"}}),_vm._v(" "),_c('p',[_vm._v("Let's take an example. By clicking the rainbow triple broadway option, it will set the flop to some random combination of three broadway cards (A, K, Q, J, and T in this case) that are all different suits. It won't set it to AsQdJh specifically every time, AsQdJh is just an example of a rainbow triple broadway board.")]),_vm._v(" "),_c('p',[_vm._v("Suppose that you want to know how often to cbet a tight opponent. Well, your opponents play will vary a lot based on what the flop is, and so whether or not you should cbet will depend a lot on the flop. For example, coordinated middle boards tend to hit the preflop callers range pretty hard.")]),_vm._v(" "),_c('p',[_vm._v("In studying the game, you can use the set flop button to quickly experiment with different flop textures.")]),_vm._v(" "),_c('h3',{attrs:{"id":"beginners-guide-analyzing-whether-to-call-the-river"}},[_vm._v("Analyzing whether to call the river")]),_vm._v(" "),_c('p',[_vm._v("Consider the following scenario. Your opponent raises from the button. You call from the BB with JhTd. Your opponent opens really widely from the button, so you put him on a range of the top 80% of hands.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/20.png"}}),_vm._v(" "),_c('p',[_vm._v("The flop comes AcTs9s.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/beginners-guide/21.png"}}),_vm._v(" "),_c('p',[_vm._v("You check the flop, your opponent bets, and you call. Since this particular opponent would cbet almost anything, this only allows us to narrow his range slightly.")]),_vm._v(" "),_vm._m(58),_vm._v(" "),_c('p',[_vm._v("Next, the turn comes 3c.")]),_vm._v(" "),_vm._m(59),_vm._v(" "),_c('p',[_vm._v("You check, your opponent bets again, and you call. This particular opponent likes to two barell a lot, so we again can only narrow his range slightly.")]),_vm._v(" "),_vm._m(60),_vm._v(" "),_c('p',[_vm._v("Finally, the river comes 4d.")]),_vm._v(" "),_vm._m(61),_vm._v(" "),_c('p',[_vm._v("We check, and our opponent bets a third time. What do we do?")]),_vm._v(" "),_c('p',[_vm._v("Well, the fact that he bet rather than checked is information that we can use to further narrow his range. Suppose that this opponent would only bet the river with top pair or better, and weak pairs as a bluff. With that assumption, we narrow his range, click simuate again, and see that 49.67% of the time he chooses to bet this river, he has us beat.")]),_vm._v(" "),_vm._m(62),_vm._v(" "),_c('p',[_vm._v("In this case, there aren't any ties to consider so the fact that our opponent has us beat 49.67% of the time means that we have about 50.33% equity against him, and we can use that knowledge along with the pot odds to determine whether we should call.")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Beginners guide")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_c('p',[_vm._v("The app has changed a bit since I created this. The gist of this guide is still accurate, but the current version of the app will look somewhat different.")]),_vm._v(" "),_c('p',[_vm._v("Updating this guide is time consuming and there will be a lot of changes to the app in the near future, so I am going to wait until after that batch of changes before I update this guide.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Note: These tools are meant for studying the game "),_c('em',[_vm._v("away")]),_vm._v(" from the table. The reason for this is because it'd just take too long to sit there analyzing things with Six Plus Hold’em (or any similar software) while you're at the table.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well"},[_c('a',{attrs:{"href":"#beginners-guide-equity-calculator"}},[_vm._v("Equity calculator:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#beginners-guide-multiway"}},[_vm._v("Multiway")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-postflop"}},[_vm._v("Postflop + narrowing your opponents range")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-hand-weights"}},[_vm._v("Hand weights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-future-streets"}},[_vm._v("Future streets")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-other-things-to-consider"}},[_vm._v("Other things to consider")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#beginners-guide-hit-calculator"}},[_vm._v("Hit calculator:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#beginners-guide-analyzing-whether-to-bluff-the-flop"}},[_vm._v("Analyzing whether to bluff the flop")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-analyzing-whether-to-bluff-the-turn"}},[_vm._v("Analyzing whether to bluff the turn")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-analyzing-whether-to-bluff-the-river"}},[_vm._v("Analyzing whether to bluff the river")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-bluff-raising"}},[_vm._v("Bluff raising")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-setting-the-flop-texture"}},[_vm._v("Setting the flop texture")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#beginners-guide-analyzing-whether-to-call-the-river"}},[_vm._v("Analyzing whether to call the river")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The first thing that we'll want to know is called the "),_c('strong',[_vm._v("pot odds")]),_vm._v(". This is the ratio of the pot size to the size of the bet you have to call. In this case, the pot is the big blind's $200 + your $8 + the small blind's $1 = $209. And you need to call another $192. So the pot odds are "),_c('code',[_vm._v("209:192")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The second thing we'll want to know is how much "),_c('strong',[_vm._v("equity")]),_vm._v(" we need for it to be worth calling the bet. (For now, just think of equity as your win percentage.) To determine this, we just do "),_c('code',[_vm._v("192 / (192 + 209)")]),_vm._v(" and get about 47.9%, which means that you need "),_c('strong',[_vm._v("47.9% equity in order to justify calling")]),_vm._v(". (In practice, we usually just approxmiate the pot odds as "),_c('code',[_vm._v("1:1")]),_vm._v(" and say that we need "),_c('code',[_vm._v("1 / (1 + 1) = 50%")]),_vm._v(" equity to justify calling.)")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Basically, equity is win percentage that takes ties into account. Suppose that you only win 45% of the time, but that you also tie 30% of the time. Note that when you tie, you split the pot. 45% is less than 47.9%, so does that mean that you should fold? No. In this scenario, you would have "),_c('code',[_vm._v("45 + (30 / 2) = 60% equity")]),_vm._v(", which is more than enough to justify calling.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/IWJFwTQr5ds?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_c('kbd',[_vm._v("command (⌘) + click")]),_vm._v(" or "),_c('kbd',[_vm._v("windows key (⊞) + click")]),_vm._v(" (depending on whether you're on a Mac or Windows computer)")]),_vm._v(" "),_c('li',[_vm._v("Use the text selector")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/gJPL60UJhQY?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Now how do we set our opponent's hand? Well, we don't know what our opponent is holding, so we can't set his "),_c('em',[_vm._v("hand")]),_vm._v(", per se. But we have an idea of what "),_c('strong',[_vm._v("range")]),_vm._v(" of hands our opponent would make this play with. Our opponent wouldn't go all with with 72o, for example, so we can eliminate that from the potential range of hands that he has. He probably wouldn't even go all in with T9s, or KJo.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("But this doesn't mean that all is lost. Just because someone "),_c('em',[_vm._v("could")]),_vm._v(" go all in with 72o doesn't mean that them doing so is "),_c('em',[_vm._v("likely")]),_vm._v(". All we can do is use our judgement, make educated guesses, and play the percentages. Fortunately, if you are good at using your judgement and playing the percentages, you're going to make a lot of money.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/rxn0HYmQljQ?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/BdPhG0u3fYM?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/BGI2l2FY0h0?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/nEP7XvyiMC8?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/ymOg7yVUfAU?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("If the pot odds are 4:1, you need 20% equity to justify calling. You have more than that, so it would be worth calling with those pot odds.")]),_vm._v(" "),_c('li',[_vm._v("If the pot odds are 3:1, you need 25% equity to justify calling. You have more than that, so it would be worth calling with those pot odds.")]),_vm._v(" "),_c('li',[_vm._v("If the pot odds are 2:1, you need 33.3% equity to justify calling. You have less than that, so it would not be worth calling with those pot odds.")]),_vm._v(" "),_c('li',[_vm._v("If the pot odds are 3:2, you need 40% equity to justify calling. You have less than that, so it would not be worth calling with those pot odds.")]),_vm._v(" "),_c('li',[_vm._v("If the pot odds are 1:1, you need 50% equity to justify calling. You have less than that, so it would not be worth calling with those pot odds.")]),_vm._v(" "),_c('li',[_vm._v("If the pot odds are 2:3, you need 60% equity to justify calling. You have less than that, so it would not be worth calling with those pot odds.")]),_vm._v(" "),_c('li',[_vm._v("If the pot odds are 1:2, you need 66.6% equity to justify calling. You have less than that, so it would not be worth calling with those pot odds.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("First, let's figure out how much equity we need to justify calling. In order to do that, we need to know what the pot odds are. The size of the pot is your $8 + $200 from the SB + $200 from the BB = $408. You need to call $192. So the pot odds are "),_c('code',[_vm._v("408:192")]),_vm._v(". Which means that you need "),_c('code',[_vm._v("192 / (192 + 408) = 32%")]),_vm._v(" equity to justify calling. (Note: in the real world, we would approximate the pot odds as "),_c('code',[_vm._v("2:1")]),_vm._v(" and say that you need "),_c('code',[_vm._v("1 / (1 + 2) = 33.3%")]),_vm._v(" equity to continue.)")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/Rylxw3PlVRA?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/Ok2zS1Q3Hrg?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/WJ2RZErqyDE?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("As always, let's start by thinking about the pot odds and how much equity we need. The pot odds are "),_c('code',[_vm._v("224:177")]),_vm._v(", so we need "),_c('code',[_vm._v("177 / (177 + 224) = 44.14%")]),_vm._v(" equity to justify calling.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/eNpm-iWWBrw?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/6SwpGsGElp4?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/ze9ERCyiTlI?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("But would they "),_c('em',[_vm._v("alawys")]),_vm._v(" raise with those hands?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("A lot of players call with AA, KK, QQ and AKs maybe 25% of the time. Doing this makes you a lot less predictable. Suppose the flop comes J74. If someone "),_c('em',[_vm._v("always")]),_vm._v(" raises AA, KK, QQ and AKs, you "),_c('em',[_vm._v("know")]),_vm._v(" that they won't have an overpair on J74, because they would have raised preflop with the starting hands that make an overpair. But if they mix in a few calls with those hands, well, it's a lot more difficult for you to narrow their range and deduce what possible hands they may have.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can use the hand weight selector to do exactly that! If you "),_c('kbd',[_vm._v("command + click")]),_vm._v(" AA, you will see a slider. Sliding the slider tells the app how often that hand is actually in your opponents range.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/mycsCvtF_5M?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/LXqbiIZkaFo?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("But even with that said, equity is still a great starting point. You usually won't deviate "),_c('em',[_vm._v("too")]),_vm._v(" much from what the equity analysis says. You usually start off with what the equity analysis says and then adjust slightly - perhaps 5% or so - based on other considerations. But sometimes other considerations will be strong enough to require a larger than 5% adjustment.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Another thing to consider is called implied odds. Suppose that you do make your flush. If so, you're likely make a lot of money on future streets. So even if you don't \"have enough\" equity right now, once you take in to consideration that you'll win a ton "),_c('em',[_vm._v("more")]),_vm._v(" money on "),_c('em',[_vm._v("future")]),_vm._v(" streets, perhaps it becomes worth calling anyway.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Somehow, when I'm playing live poker and I mention that I'm developing this app, there never fails to be someone at the table who starts lecturing me about the fact that there's more to poker than math and numbers. (Often times the person will even make a stronger claim that poker is "),_c('em',[_vm._v("all")]),_vm._v(" about \"feel\" and that math and numbers mean "),_c('em',[_vm._v("nothing")]),_vm._v(".)")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('strong',[_vm._v("Position.")]),_vm._v(" If you are first to act, you are at a significant disadvantage. If you are last to act, you are at a significant advantage. Adjust how much equity you \"need\" to justify calling accordingly.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Skill.")]),_vm._v(" If you know you can outplay your opponent postflop, you may want to call with a slight equity disadvantage preflop. Maybe you know that you could float your opponent and win a high percentage of the time. Maybe you know your opponent overvalues mediocre hands and that you'll be able to extract a ton of value if you make a strong made hand. Maybe you know that your opponent folds to re-raises on the river too often.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Your table image.")]),_vm._v(" Perhaps you want to call even when you mathematically \"shouldn't\" so that your opponents don't start to think that they could bully you around. Or perhaps you want to "),_c('em',[_vm._v("avoid")]),_vm._v(" calling when you mathematically \"should\" so that your opponents get greedy, try to bully you, and lose a ton of money when you do make a strong hand.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("If you're in a tournament")]),_vm._v(", you have to think about how close you are to cashing out. If you're one away from being \"in the money\", maybe you shouldn't call if you have 55% equity but only \"need\" 50% equity.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Live reads.")]),_vm._v(" Did your opponent start tapping his foot? Does that mean that he's bluffing? If so, that is certainly something to consider. Although, I would say that you should use that tell as information to help you narrow your opponents range, and then base your decision on the numbers, as opposed to just \"going with your gut\" and calling with anything.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Fun!")]),_vm._v(" Maximizing my win rate and challenging myself to make the best decision every chance I get is my definition of fun, but not everyone is like that. Perhaps you find it boring to fold. In that case, if you want to call with some hands even when the math says you should fold, I won't judge you.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/wP_VGEYWl40?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/5c2HyjYjTwY?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The formula for figuring out how often a bluff needs to work for it to be immediately profitable is "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(". That was a big sentence, let me explain what it means.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Suppose the pot is $10. If you bet $5 into the pot, you're risking $5 in order to win $10, so the formula to see how often a bluff needs to work is "),_c('code',[_vm._v("$5 / ($5 + $10) = 33.3%")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Suppose you want to bluff $10 into the $10 pot. Now you're risking $10 to win $10, so the forumla becomes "),_c('code',[_vm._v("$10 / ($10 + $10) = 50%")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[_vm._v("Wait - what do you mean by "),_c('em',[_vm._v("immediately")]),_vm._v(" profitable? What's the difference between that and just regular profitable?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Great question. Let's go back to the situation we started with where we have Qc3c and are considering whether or not to make a $5 bluff into the $10 pot. If our bluff worked 34% of the time, it would be profitable play in the long run, "),_c('em',[_vm._v("even if we never got lucky on future streets")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Sometimes we may make our bluff and get called when we're losing to someone with, say, A9 for top pair top kicker. When that happens, we may sometimes get lucky and catch a queen on the turn or river, giving us a higher pair than the guy with A9. The immediately profitable calculation is saying, \"Dude, even if you "),_c('em',[_vm._v("never")]),_vm._v(" got lucky, this bluff would "),_c('em',[_vm._v("still")]),_vm._v(" be profitable if it works just 33.3% of the time.\" Of course, you will get lucky sometimes, so in reality the bluff probably only needs to work like 25-30% of the time or so.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/kLvyGhvtc8w?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/jdg0fsbqAoI?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/B_8ksCAALeI?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/ZIKb9pFClf8?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/GNHRIK6_3Rs?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("That means that our opponent would be folding 63.31% of the time, making a bluff "),_c('em',[_vm._v("totally")]),_vm._v(" worth it.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("This is a great example of the fact that the hit calculator can't actually tell you what to do, and that it is just a tool to help you "),_c('em',[_vm._v("figure out")]),_vm._v(" what to do. "),_c('em',[_vm._v("You")]),_vm._v(" need to observe your opponents carefully and make educated guesses as to what they would be calling/raising with in different scenarios.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/OXm0tQPA3ow?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/y8MZOqVcM7Q?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/JMxPkJE5-js?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/z-UijMNUOM4?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/lUi_HWlWiVU?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/xE_tygZSzrg?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/WdLelBwx4fc?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Think about it like this: reraising to $40 is kinda the same thing as calling the $10 and then betting another $30 into what is now a $40 pot. Framed this way, we can use the "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(" equation to see that this bluff needs to work "),_c('code',[_vm._v("$30 / ($30 + $40) = 42.9%")]),_vm._v(" of the time in order to be immediately profitable.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/bGrb9d5fyeo?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/ogy7Oie68lo?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/8GBclj3H4O8?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/nI04W54Sxw4?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/DaIfINVKLpc?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8tdp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8tiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"quick-guide"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Note: Please excuse the fact that there may be some minor inconsistencies between the images/videos in this guide and what the actual app looks like.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h2',{attrs:{"id":"quick-guide-general"}},[_vm._v("General")]),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-sharable-simulation-link"}},[_vm._v("Sharable simulation link")]),_vm._v(" "),_c('p',[_vm._v("If you want to share a simulation with a friend, you can! You just generate a link, give the link to your friend, and when they visit the link they see the same screen that you do, and can play around by tweaking ranges and assumptions.")]),_vm._v(" "),_c('p',[_vm._v("This is great for studying with friends, and for discussion on poker forums.")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-save-scenarios"}},[_vm._v("Save scenarios")]),_vm._v(" "),_c('p',[_vm._v("You can also save scenarios so that you can return to them later to study. You'll need to be signed in to do this though.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/quick-guide/save-scenario.png"}}),_vm._v(" "),_c('p',[_vm._v("To access your saved scenarios, go to your "),_c('router-link',{attrs:{"to":"/account"}},[_vm._v("account page")]),_vm._v(".")],1),_vm._v(" "),_c('h2',{attrs:{"id":"quick-guide-range"}},[_vm._v("Range")]),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-add-ascending-hands"}},[_vm._v("99+ with one click")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-setting-the-combos-and-weights-for-a-grid-square"}},[_vm._v("Setting the combos and weights for a grid square")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('p',[_vm._v("Regarding the weights:")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-selecting-specific-suits"}},[_vm._v("Selecting specific suits")]),_vm._v(" "),_c('p',[_vm._v("There are four ways to select specific suits:")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('p',[_vm._v("2) By using the \"Select specific suits button\":")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("3) By typing the specific suits into the text selector, eg. \"7c6c\".")]),_vm._v(" "),_c('p',[_vm._v("4) When a range is filtered, it'll usually end up only including some combos.")]),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-setting-hand-weights"}},[_vm._v("Setting hand weights")]),_vm._v(" "),_c('p',[_vm._v("There are three ways to set the weight of a hand:")]),_vm._v(" "),_c('p',[_vm._v("1) When you add a hand, it will have the weight indicated by the vertical weight slider. In the example below, the slider is set to 25, and so when you click to add AA, it adds AA with a weight of 25.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/quick-guide/9.png"}}),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('p',[_vm._v("3) If you want to apply a weight to multiple hands at once, use the \"Set hand weights\" modal like so:")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_c('h2',{attrs:{"id":"quick-guide-equity-calculator"}},[_vm._v("Equity calculator")]),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-equity-calculator-insights"}},[_vm._v("Insights")]),_vm._v(" "),_c('p',[_vm._v("This is the insights section for the equity calculator:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/quick-guide/1.png"}}),_vm._v(" "),_c('p',[_vm._v("It is (implicitly) saying things like:")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-rake-and-tip"}},[_vm._v("Rake and tip")]),_vm._v(" "),_c('p',[_vm._v("You can set the rake and tip in "),_c('router-link',{attrs:{"to":"/settings/equity-calculator/rake-and-tip"}},[_vm._v("Settings / Equity calculator / Rake and tip")]),_vm._v(". If you do, when you run simulations with the equity calculator, the resulting equity will reflect the fact that there is a rake being taken and a tip being given to the dealer.")],1),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-equity-calculator-filtering-a-range"}},[_vm._v("Filtering a range")]),_vm._v(" "),_c('p',[_vm._v("You can filter ranges in the equity calculator in a similar way to how it's done in the hit calculator.")]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('h2',{attrs:{"id":"quick-guide-hit-calculator"}},[_vm._v("Hit calculator")]),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-simulations-vs-exhaustive-computations"}},[_vm._v("Simulations vs. exhaustive computations")]),_vm._v(" "),_c('p',[_vm._v("Sometimes it is easy to compute the exact value of the percentages. Other times it would be too computationally expensive, and computing exact values would slow down the app too much, and often times crash your browser.")]),_vm._v(" "),_c('p',[_vm._v("When it is easy to compute exactly, Six Plus Hold’em will do so automatically. When it isn't, you'll have to hit the \"Simulate\" button yourself.")]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-hit-calculator-insights"}},[_vm._v("Insights")]),_vm._v(" "),_c('p',[_vm._v("This is the insights section for the hit calculator:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/quick-guide/2.png"}}),_vm._v(" "),_c('p',[_vm._v("It is (implicitly) saying things like:")]),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('p',[_vm._v("Note that your opponent will probably fold more often to bigger bluffs, and less often to smaller ones, and so in considering different bluff sizes, you'll need to adjust the checkboxes according to what you think your opponent will fold out to the bluff size you're interested in exploring.")]),_vm._v(" "),_c('p',[_vm._v("Also note that the term \"immediately profitable\" doesn't take into account the fact that you may hit one of your outs on a future street. For example, suppose you have 33 on AK9, bluff the flop, and get called by AJ. Then suppose you hit a set on the turn. This possibility means that your bluffs don't need to work quite as often as the immediately profitable percentages.")]),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-set-checks-to-default"}},[_vm._v("Set checkboxes to default")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/quick-guide/4.png"}}),_vm._v(" "),_c('p',[_vm._v("This will check off the checkboxes that a tight/straightforward/loose opponent would continue with (call or raise a bet) depending on what the board cards are.")]),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',[_vm._v("\"Set checkboxes to default\" is \"smart\" and takes both of these things into account.")]),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-set-checks-to-saved-state"}},[_vm._v("Set checkboxes to saved state")]),_vm._v(" "),_c('p',[_vm._v("If you want to create your own \"set checks to\" option, you can do that:")]),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-set-checkbox-weights"}},[_vm._v("Set checkbox weights")]),_vm._v(" "),_vm._m(20),_vm._v(" "),_c('p',[_vm._v("Now, if you click, you'll see the following modal will appear that you can use to set the weight.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/quick-guide/6.png"}}),_vm._v(" "),_c('h3',{attrs:{"id":"quick-guide-nut-second-nut-third-nut-and-weak"}},[_vm._v("Nut, second nut, third nut, and weak flushes/flush draws")]),_vm._v(" "),_c('p',[_vm._v("Note that flushes and flush draws are broken down into nut, second nut, third nut, and weak subcategories:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/quick-guide/3.png"}}),_vm._v(" "),_c('p',[_vm._v("On first thought, one may think that the nut flush is the ace high flush, and that that's the end of the story. But what about on a board like AcKcQc? In that case, the Jc is what makes the nut flush, Tc the second nut, etc.")]),_vm._v(" "),_c('p',[_vm._v("One more caveat: on a board like AcKcQcJc, the Tc actually makes a royal flush, so the 9c would make the nut flush in that case.")]),_vm._v(" "),_c('p',[_vm._v("See the "),_c('router-link',{attrs:{"to":"/made-hands-and-draws"}},[_vm._v("made hands and draws guide")]),_vm._v(" for more information.")],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Quick guide")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/3-DcZLIhwYo?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well"},[_c('a',{attrs:{"href":"#quick-guide-general"}},[_vm._v("General:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#quick-guide-sharable-simulation-link"}},[_vm._v("Sharable simulation link")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-save-scenarios"}},[_vm._v("Save scenarios")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#quick-guide-range"}},[_vm._v("Range:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#quick-guide-add-ascending-hands"}},[_vm._v("99+ with one click")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-setting-the-combos-and-weights-for-a-grid-square"}},[_vm._v("Setting the combos and weights for a grid square")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-selecting-specific-suits"}},[_vm._v("Selecting specific suits")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-setting-hand-weights"}},[_vm._v("Setting hand weights")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#quick-guide-equity-calculator"}},[_vm._v("Equity calculator:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#quick-guide-equity-calculator-insights"}},[_vm._v("Insights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-rake-and-tip"}},[_vm._v("Rake and tip")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-equity-calculator-filtering-a-range"}},[_vm._v("Filtering a range")])])]),_vm._v(" "),_c('a',{attrs:{"href":"#quick-guide-hit-calculator"}},[_vm._v("Hit calculator:")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#quick-guide-simulations-vs-exhaustive-computations"}},[_vm._v("Simulations vs. exhaustive computations")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-hit-calculator-insights"}},[_vm._v("Insights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-set-checks-to-default"}},[_vm._v("Set checkboxes to default")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-set-checks-to-saved-state"}},[_vm._v("Set checkboxes to saved state")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-set-checkbox-weights"}},[_vm._v("Set checkbox weights")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#quick-guide-nut-second-nut-third-nut-and-weak"}},[_vm._v("Nut, second nut, third nut, and weak flushes/flush draws")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/ZEtmiw7upmI?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/8QQFth0Dv1M?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('kbd',[_vm._v("option + click")]),_vm._v(" 99 and it will add 99, TT, JJ, QQ, KK and AA.")]),_vm._v(" "),_c('li',[_vm._v("For connectors and one-gappers, it will add hands in the \"up and to the left\" direction like you'd expect.")]),_vm._v(" "),_c('li',[_vm._v("For something like A4s, it will add A4s, A5s, A6s... AKs.")]),_vm._v(" "),_c('li',[_vm._v("If you hold down "),_c('kbd',[_vm._v("option")]),_vm._v(" and move your mouse, the cursor will change and show you what direction it will add hands (↖, ← or ↑).")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('kbd',[_vm._v("shift + click")]),_vm._v(" a grid square and a modal will pop up that lets you set 1) which combos are in range, and 2) the weights for each combo.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/7E2heIDkrmU?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Each combo has it's own weight. Eg. on AcJc4d, you may want to assign a weight of 25% to 5h4h and a weight of 75% to 5c4c, because the latter has a flush draw in addition to the pair.")]),_vm._v(" "),_c('li',[_vm._v("The average reflects the average weight of combos that are in range. It excludes the weight of combos that aren't in range.")]),_vm._v(" "),_c('li',[_vm._v("By clicking and dragging the slider for the average weight, it will set the weight of each combo that is in range.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("1) By "),_c('kbd',[_vm._v("shift + clicking")]),_vm._v(" a grid square (see the "),_c('a',{attrs:{"href":"#quick-guide-setting-the-combos-and-weights-for-a-grid-square"}},[_vm._v("section above")]),_vm._v(").")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/PT7ArCc6Ex0?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("2) You can set the weight of an individual hand by "),_c('a',{attrs:{"href":"#quick-guide-setting-the-combos-and-weights-for-a-grid-square"}},[_vm._v("shift-clicking a grid square")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/PU5ePnYT5r0?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The only way to set the weight of a specific combo (eg. Ac5c instead of A5s) is to "),_c('a',{attrs:{"href":"#quick-guide-setting-the-combos-and-weights-for-a-grid-square"}},[_vm._v("shift-click the grid square")]),_vm._v(".\n  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("If the pot odds are 4:1, you need 20% equity for a call to be immediately profitable. You have 46.26% equity. Therefore, a call will be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("If the pot odds are 1:1, you need 50% equity for a call to be immediately profitable. You have 46.26% equity. Therefore, a call will not be immediately profitable.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/QDlxv9_Z1HA?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Which board cards are set")]),_vm._v(" "),_c('th',[_vm._v("Computes exact values for flop")]),_vm._v(" "),_c('th',[_vm._v("Computes exact values for turn")]),_vm._v(" "),_c('th',[_vm._v("Computes exact values for river")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Flop isn't set")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("❌")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Flop set")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("❌")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Turn set")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("❌")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("River set")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("A half pot bluff needs to work 33.3% of the time to be immediately profitable. Your opponent hits the board 48.34% of the time, and thus misses the board 51.66% of the time, which means (by definition) that he will fold 51.66% of the time, which means that a half pot bluff will be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("If your opponent initially bets full pot and you bluff raise 4x the initial bet, the bluff needs to work 50% of the time to be immediately profitable. Your opponent hits the board 48.34% of the time, and thus misses the board 51.66% of the time, which means (by definition) that he will fold 51.66% of the time, which means that a 4x initial bet bluff raise will be immediately profitable.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("Note that people are much more willing to call on a rainbow raggedy board like 9c4h2d than on a monotone triple broadway board like AcQcJc, because the person who bet is much more likely to have hit the latter than the former.")]),_vm._v(" "),_c('li',[_vm._v("Also note that it depends what street you're on. People usually tighten up as you progress to the turn and the river.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/65Qg8GAlSlo?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Suppose that you think that your opponent will continue with middle pair 75% of the time rather than 100% of the time. To specify this, first hover your cursor over the weight bar or the percentage/number of combos. You should see the cursor change to this: "),_c('img',{attrs:{"src":"https://i.stack.imgur.com/ygtZg.png"}}),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "8uf7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_random_board_selector_vue__ = __webpack_require__("0Kpk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32dc5e3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_random_board_selector_vue__ = __webpack_require__("F9KK");
function injectStyle (ssrContext) {
  __webpack_require__("FBk2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-32dc5e3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_random_board_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32dc5e3e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_random_board_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9584":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"short-deck-hand-range panel panel-default"},[_c('hand-range-header',{attrs:{"generalHands":_vm.generalHands,"weightToApplyToAddedHands":_vm.weightToApplyToAddedHands,"combosToAdd":_vm.combosToAdd,"canBeRemoved":_vm.canBeRemoved,"specificHandsNotAllowed":_vm.specificHandsNotAllowed,"disabled":_vm.disableAllSelectors},on:{"removePlayer":function($event){return _vm.$emit('removePlayer')},"clearRange":function($event){return _vm.emitAndResetDoubleSlider('clearRange')},"addComboToCombosToAdd":function($event){return _vm.$emit('addComboToCombosToAdd', $event)},"removeComboFromCombosToAdd":function($event){return _vm.$emit('removeComboFromCombosToAdd', $event)},"applyExactWeightToGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('applyExactWeightToGeneralHands', $event)},"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}},[_vm._t("left-header",null,{"slot":"left-header"}),_vm._v(" "),_vm._t("extra-dropdown-item-1",null,{"slot":"extra-dropdown-item-1"})],2),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('section',{staticClass:"left-or-top"},[_c('short-deck-grid-selector',{attrs:{"generalHands":_vm.generalHands,"disabled":_vm.disableAllSelectors,"specificHandsNotAllowed":_vm.specificHandsNotAllowed},on:{"selectGeneralHand":function($event){return _vm.emitAndResetDoubleSlider('selectGeneralHand', $event)},"deselectGeneralHand":function($event){return _vm.emitAndResetDoubleSlider('deselectGeneralHand', $event)},"selectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('selectGeneralHands', $event)},"deselectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('deselectGeneralHands', $event)},"selectSpecificHand":function($event){return _vm.emitAndResetDoubleSlider('selectSpecificHand', $event)},"deselectSpecificHand":function($event){return _vm.emitAndResetDoubleSlider('deselectSpecificHand', $event)},"setSpecificHandAsManuallySet":function($event){return _vm.emitAndResetDoubleSlider('setSpecificHandAsManuallySet', $event)},"setSpecificHandAsNotManuallySet":function($event){return _vm.emitAndResetDoubleSlider('setSpecificHandAsNotManuallySet', $event)},"applyExactWeightToGeneralHand":function($event){return _vm.emitAndResetDoubleSlider('applyExactWeightToGeneralHand', $event)},"setWeightOfSpecificHand":function($event){return _vm.emitAndResetDoubleSlider('setWeightOfSpecificHand', $event)},"finishedClickAndDrag":function($event){return _vm.$emit('finishedClickAndDrag')}}}),_vm._v(" "),_c('slider-selector',{ref:"sliderSelector",attrs:{"percentOfHandsInRangeNumberForDisplay":_vm.generalHands.percentOfHandsInRangeNumberForDisplay,"numberOfSpecificHandsInRange":_vm.generalHands.numberOfSpecificHandsInRange.roundToTwoDecimalPlaces(),"numberOfPossibleSpecificHands":_vm.generalHands.numberOfPossibleSpecificHands.roundToTwoDecimalPlaces(),"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors},on:{"setRangeToMatchDoubleSlider":function($event){return _vm.$emit('setRangeToMatchDoubleSlider', $event)}}}),_vm._v(" "),(_vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || _vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings')?_c('horizontal-set-weight-to-apply-to-added-hands-basic',{ref:"horizontalSetWeightToApplyToAddedHandsSlider",attrs:{"weightToApplyToAddedHands":_vm.weightToApplyToAddedHands,"disabled":_vm.disableAllSelectors,"shortDeck":true},on:{"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}}):_vm._e(),_vm._v(" "),_c('text-selector',{attrs:{"generalHands":_vm.generalHands,"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors},on:{"setRangeToMatchSpecificHandStrings":function($event){return _vm.emitAndResetDoubleSlider('setRangeToMatchSpecificHandStrings', $event)}}})],1),_vm._v(" "),(_vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || _vm.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings')?_c('vertical-set-weight-to-apply-to-added-hands',{ref:"verticalSetWeightToApplyToAddedHandsSlider",attrs:{"weightToApplyToAddedHands":_vm.weightToApplyToAddedHands,"disabled":_vm.disableAllSelectors,"shortDeck":true},on:{"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"right-or-bottom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{class:{ 'active': _vm.activeTab === 'saved-ranges' }},[_c('a',{on:{"click":function($event){_vm.activeTab = 'saved-ranges'}}},[_vm._v("Saved ranges")])]),_vm._v(" "),_c('li',{class:{ 'active': _vm.activeTab === 'tiers' }},[_c('a',{on:{"click":function($event){_vm.activeTab = 'tiers'}}},[_vm._v("Tiers")])]),_vm._v(" "),_c('li',{class:{ 'active': _vm.activeTab === 'categories' }},[_c('a',{on:{"click":function($event){_vm.activeTab = 'categories'}}},[_vm._v("Categories")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[(_vm.activeTab === 'saved-ranges')?_c('div',{class:{ 'active': _vm.activeTab === 'saved-ranges', 'tab-pane': true }},[_c('saved-ranges-selector',{attrs:{"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors,"generalHands":_vm.generalHands},on:{"setRangeToMatchGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('setRangeToMatchGeneralHands', $event)}}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'tiers')?_c('div',{class:{ 'active': _vm.activeTab === 'tiers', 'tab-pane': true }},[_c('tier-selector',{attrs:{"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors,"generalHands":_vm.generalHands},on:{"selectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('selectGeneralHands', $event)},"deselectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('deselectGeneralHands', $event)}}})],1):_vm._e(),_vm._v(" "),(_vm.activeTab === 'categories')?_c('div',{class:{ 'active': _vm.activeTab === 'categories', 'tab-pane': true }},[_c('category-selector',{attrs:{"disabled":_vm.disableAllButGridSelector || _vm.disableAllSelectors,"generalHands":_vm.generalHands,"shortDeck":true},on:{"selectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('selectGeneralHands', $event)},"deselectGeneralHands":function($event){return _vm.emitAndResetDoubleSlider('deselectGeneralHands', $event)}}})],1):_vm._e()])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9F12":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9HlT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_hit_calculator_vue__ = __webpack_require__("70sL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a6486fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_hit_calculator_vue__ = __webpack_require__("aBsY");
function injectStyle (ssrContext) {
  __webpack_require__("0Dwz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a6486fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_hit_calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a6486fc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_hit_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9N94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_grid_selector_vue__ = __webpack_require__("xlmv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36eec0da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_grid_selector_vue__ = __webpack_require__("J8Sm");
function injectStyle (ssrContext) {
  __webpack_require__("YNdZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36eec0da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_grid_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36eec0da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_grid_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9WJy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_password_vue__ = __webpack_require__("dsZ5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe8e6436_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_password_vue__ = __webpack_require__("3Z9w");
function injectStyle (ssrContext) {
  __webpack_require__("uJvH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe8e6436"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_change_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe8e6436_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_change_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9ZDO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"random-board-selector",class:_vm.popoverDirectionClass,attrs:{"disabled":_vm.disabled}},[_c('button',{staticClass:"btn btn-default dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","disabled":_vm.disabled}},[_vm._v("\n    Random\n    "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[(_vm.popoverDirectionClass === 'dropdown')?_c('div',{staticClass:"row hidden-xs",staticStyle:{"margin-bottom":"-17px"}},[_c('div',{staticClass:"col-sm-4"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.setRandomFlop()}}},[_vm._v("Random flop: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('ul',[(!_vm.disableTurnAndRiver)?_c('li',{on:{"click":function($event){return _vm.setRandomTurn()}}},[_vm._v("Random turn: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('ul',[(!_vm.disableTurnAndRiver)?_c('li',{on:{"click":function($event){return _vm.setRandomRiver()}}},[_vm._v("Random river: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.popoverDirectionClass === 'dropdown')?_c('hr',{staticClass:"hidden-xs"}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row hidden-xs"},[_c('div',{staticClass:"col-sm-4"},[_c('ul',[_c('li',{staticClass:"dropdown-header"},[_vm._v("Rainbow (all different suits)")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('triple broadway', 'rainbow')}}},[_vm._v("Triple broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/ace-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/queen-of-diamonds.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/jack-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('double broadway', 'rainbow')}}},[_vm._v("Double broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/king-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-diamonds.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('single broadway', 'rainbow')}}},[_vm._v("Single broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/queen-of-hearts.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-spades.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('paired', 'rainbow')}}},[_vm._v("Paired - eg. "),_c('img',{attrs:{"src":"/static/cards/eight-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/five-of-diamonds.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/five-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('raggedy', 'rainbow')}}},[_vm._v("Raggedy - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-diamonds.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated middle', 'rainbow')}}},[_vm._v("Coordinated middle - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/six-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated small', 'rainbow')}}},[_vm._v("Coordinated small - eg. "),_c('img',{attrs:{"src":"/static/cards/four-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-diamonds.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('bingo', 'rainbow')}}},[_vm._v("Bingo - eg. "),_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-hearts.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-spades.png"}})]),_vm._v(" "),_c('li',{staticClass:"divider visible-xs"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('ul',[_c('li',{staticClass:"dropdown-header"},[_vm._v("Two-toned (two of same suit)")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('triple broadway', 'two-toned')}}},[_vm._v("Triple broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/ace-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/jack-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('double broadway', 'two-toned')}}},[_vm._v("Double broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/king-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('single broadway', 'two-toned')}}},[_vm._v("Single broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('paired', 'two-toned')}}},[_vm._v("Paired - eg. "),_c('img',{attrs:{"src":"/static/cards/eight-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/five-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/five-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('raggedy', 'two-toned')}}},[_vm._v("Raggedy - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated middle', 'two-toned')}}},[_vm._v("Coordinated middle - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/six-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated small', 'two-toned')}}},[_vm._v("Coordinated small - eg. "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-hearts.png"}})]),_vm._v(" "),_c('li',{staticClass:"divider visible-xs"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('ul',[_c('li',{staticClass:"dropdown-header"},[_vm._v("Monotone (all same suit)")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('triple broadway', 'monotone')}}},[_vm._v("Triple broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/ace-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/jack-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('double broadway', 'monotone')}}},[_vm._v("Double broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/king-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('single broadway', 'monotone')}}},[_vm._v("Single broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('raggedy', 'monotone')}}},[_vm._v("Raggedy - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated middle', 'monotone')}}},[_vm._v("Coordinated middle - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/six-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated small', 'monotone')}}},[_vm._v("Coordinated small - eg. "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-clubs.png"}})])])])]),_vm._v(" "),(_vm.popoverDirectionClass === 'dropdown')?_c('div',{staticClass:"row visible-xs"},[_c('div',{staticClass:"col-xs-12"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.setRandomFlop()}}},[_vm._v("Random flop: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]),_vm._v(" "),(!_vm.disableTurnAndRiver)?_c('li',{on:{"click":function($event){return _vm.setRandomTurn()}}},[_vm._v("Random turn: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]):_vm._e(),_vm._v(" "),(!_vm.disableTurnAndRiver)?_c('li',{on:{"click":function($event){return _vm.setRandomRiver()}}},[_vm._v("Random river: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"divider visible-xs"})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row visible-xs"},[_c('div',{staticClass:"col-sm-4"},[_c('ul',[_c('li',{staticClass:"dropdown-header"},[_vm._v("Monotone (all same suit)")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('triple broadway', 'monotone')}}},[_vm._v("Triple broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/ace-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/jack-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('double broadway', 'monotone')}}},[_vm._v("Double broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/king-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('single broadway', 'monotone')}}},[_vm._v("Single broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('raggedy', 'monotone')}}},[_vm._v("Raggedy - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated middle', 'monotone')}}},[_vm._v("Coordinated middle - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/six-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated small', 'monotone')}}},[_vm._v("Coordinated small - eg. "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-clubs.png"}})]),_vm._v(" "),_c('li',{staticClass:"divider visible-xs"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('ul',[_c('li',{staticClass:"dropdown-header"},[_vm._v("Two-toned (two of same suit)")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('triple broadway', 'two-toned')}}},[_vm._v("Triple broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/ace-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/jack-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('double broadway', 'two-toned')}}},[_vm._v("Double broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/king-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('single broadway', 'two-toned')}}},[_vm._v("Single broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('paired', 'two-toned')}}},[_vm._v("Paired - eg. "),_c('img',{attrs:{"src":"/static/cards/eight-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/five-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/five-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('raggedy', 'two-toned')}}},[_vm._v("Raggedy - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated middle', 'two-toned')}}},[_vm._v("Coordinated middle - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/six-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated small', 'two-toned')}}},[_vm._v("Coordinated small - eg. "),_c('img',{attrs:{"src":"/static/cards/four-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-hearts.png"}})]),_vm._v(" "),_c('li',{staticClass:"divider visible-xs"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('ul',[_c('li',{staticClass:"dropdown-header"},[_vm._v("Rainbow (all different suits)")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('triple broadway', 'rainbow')}}},[_vm._v("Triple broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/ace-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/queen-of-diamonds.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/jack-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('double broadway', 'rainbow')}}},[_vm._v("Double broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/king-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-diamonds.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('single broadway', 'rainbow')}}},[_vm._v("Single broadway - eg. "),_c('img',{attrs:{"src":"/static/cards/queen-of-hearts.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-spades.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('paired', 'rainbow')}}},[_vm._v("Paired - eg. "),_c('img',{attrs:{"src":"/static/cards/eight-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/five-of-diamonds.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/five-of-clubs.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('raggedy', 'rainbow')}}},[_vm._v("Raggedy - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/four-of-diamonds.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated middle', 'rainbow')}}},[_vm._v("Coordinated middle - eg. "),_c('img',{attrs:{"src":"/static/cards/nine-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/six-of-hearts.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('coordinated small', 'rainbow')}}},[_vm._v("Coordinated small - eg. "),_c('img',{attrs:{"src":"/static/cards/four-of-spades.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/three-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/two-of-diamonds.png"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomFlopAccordingToTexture('bingo', 'rainbow')}}},[_vm._v("Bingo - eg. "),_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-hearts.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/cards/ten-of-spades.png"}})]),_vm._v(" "),_c('li',{staticClass:"divider visible-xs"})])])]),_vm._v(" "),(_vm.popoverDirectionClass === 'dropup')?_c('div',{staticClass:"row visible-xs"},[_c('div',{staticClass:"col-xs-12"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.setRandomFlop()}}},[_vm._v("Random flop: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]),_vm._v(" "),(!_vm.disableTurnAndRiver)?_c('li',{on:{"click":function($event){return _vm.setRandomTurn()}}},[_vm._v("Random turn: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]):_vm._e(),_vm._v(" "),(!_vm.disableTurnAndRiver)?_c('li',{on:{"click":function($event){return _vm.setRandomRiver()}}},[_vm._v("Random river: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.popoverDirectionClass === 'dropup')?_c('hr',{staticClass:"hidden-xs"}):_vm._e(),_vm._v(" "),(_vm.popoverDirectionClass === 'dropup')?_c('div',{staticClass:"row hidden-xs"},[_c('div',{staticClass:"col-sm-4"},[_c('ul',[_c('li',{on:{"click":function($event){return _vm.setRandomFlop()}}},[_vm._v("Random flop: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('ul',[(!_vm.disableTurnAndRiver)?_c('li',{on:{"click":function($event){return _vm.setRandomTurn()}}},[_vm._v("Random turn: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('ul',[(!_vm.disableTurnAndRiver)?_c('li',{on:{"click":function($event){return _vm.setRandomRiver()}}},[_vm._v("Random river: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]):_vm._e()])])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Zp6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tier-selector',
  props: ['generalHands', 'disabled'],
  computed: {
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    }
  },
  methods: {
    isTierInRange: function isTierInRange(tierNumber) {
      return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.areGeneralHandsInRange(this._getGeneralHandStringsFromTier(tierNumber), this.generalHands);
    },
    _getGeneralHandStringsFromTier: function _getGeneralHandStringsFromTier(tierNumber) {
      return this.$store.state.account.user.settings.general.tiers[tierNumber - 1];
    },
    selectOrDeselectGeneralHandsFromTier: function selectOrDeselectGeneralHandsFromTier(tierNumber) {
      var generalHandStringsFromTier = this._getGeneralHandStringsFromTier(tierNumber);

      if (this.isTierInRange(tierNumber)) {
        this.$emit('deselectGeneralHands', generalHandStringsFromTier);
      } else {
        this.$emit('selectGeneralHands', generalHandStringsFromTier);
      }
    }
  }
});

/***/ }),

/***/ "9dXV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-calculator-number-of-simulations-settings',
  data: function data() {
    return {
      numberOfSimulations: this.$store.state.account.user.settings.equityCalculator.numberOfSimulations,
      isHelpVisible: false
    };
  },
  methods: {
    reset: function reset() {
      var self = this;

      self.$refs.numberOfSimulations.value = 25000;
      setTimeout(function () {
        self.save();
      }, 50);
    },
    save: function save() {
      if (Number(this.$refs.numberOfSimulations.value) > 250000) {
        alert("That's too much. It'd probably crash your browser. Try 250,000 or less.");
        return;
      }

      var user = _.cloneDeep(this.$store.state.account.user);
      var self = this;

      user.settings.equityCalculator.numberOfSimulations = this.$refs.numberOfSimulations.value;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "9hHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'log-double-slider-selector',
  components: {
    'vue-slider': __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  },
  props: ['percentOfHandsInRangeNumberForDisplay', 'numberOfSpecificHandsInRange', 'numberOfPossibleSpecificHands', 'disabled'],
  data: function data() {
    var dotSize = 16; // non-mobile

    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      dotSize = 25; // mobile
    }

    return {
      percentiles: [0, 0],
      sliderOptions: {
        tooltip: 'hover',
        dotSize: dotSize,
        data: [0, 1, 2, 3, 4, 5, 7.5, 10, 12.5, 15, 17.5, 20, 22.5, 25, 27.5, 30, 35, 40, 45, 50, 75, 100],
        piecewise: true,
        tooltipMerge: false
      }
    };
  },
  mounted: function mounted() {
    if (true) {
      $(this.$el).find('[data-toggle="tooltip"]').tooltip();
    }
  },
  methods: {
    setRangeToMatchDoubleSlider: function setRangeToMatchDoubleSlider(percentiles) {
      this.$emit('setRangeToMatchDoubleSlider', {
        bottomPercentile: percentiles[0],
        topPercentile: percentiles[1]
      });
    },
    reset: function reset() {
      this.$refs.slider.setValue([0, 0], function () {
        // for some reason this callback fixes the issue of the range being cleared when you click something else like tier 1
      });
    },
    refresh: function refresh() {
      this.$refs.slider.refresh();
    },
    showLabel: function showLabel(label) {
      return [0, 5, 10, 20, 30, 40, 50, 100].includes(label);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "9htL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vertical_set_weight_to_apply_to_added_hands_basic_vue__ = __webpack_require__("twMY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b4aaa12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vertical_set_weight_to_apply_to_added_hands_basic_vue__ = __webpack_require__("XbSQ");
function injectStyle (ssrContext) {
  __webpack_require__("F4Fq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b4aaa12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vertical_set_weight_to_apply_to_added_hands_basic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b4aaa12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vertical_set_weight_to_apply_to_added_hands_basic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9kXV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hit-calculator-checkboxes-collapsed-by-default-settings settings"},[_vm._m(0),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.madeHandParents),function(madeHandParent){return _c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(madeHandParent.breadcrumbText)}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.collapsedByDefault[madeHandParent.id]),expression:"collapsedByDefault[madeHandParent.id]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.collapsedByDefault[madeHandParent.id])?_vm._i(_vm.collapsedByDefault[madeHandParent.id],null)>-1:(_vm.collapsedByDefault[madeHandParent.id])},on:{"change":function($event){var $$a=_vm.collapsedByDefault[madeHandParent.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.collapsedByDefault, madeHandParent.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.collapsedByDefault, madeHandParent.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.collapsedByDefault, madeHandParent.id, $$c)}}}})])])}),0)]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.drawParents),function(drawParent){return _c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(drawParent.breadcrumbText)}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.collapsedByDefault[drawParent.id]),expression:"collapsedByDefault[drawParent.id]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.collapsedByDefault[drawParent.id])?_vm._i(_vm.collapsedByDefault[drawParent.id],null)>-1:(_vm.collapsedByDefault[drawParent.id])},on:{"change":function($event){var $$a=_vm.collapsedByDefault[drawParent.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.collapsedByDefault, drawParent.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.collapsedByDefault, drawParent.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.collapsedByDefault, drawParent.id, $$c)}}}})])])}),0)]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.comboParents),function(comboParent){return _c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(comboParent.breadcrumbText)}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.collapsedByDefault[comboParent.id]),expression:"collapsedByDefault[comboParent.id]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.collapsedByDefault[comboParent.id])?_vm._i(_vm.collapsedByDefault[comboParent.id],null)>-1:(_vm.collapsedByDefault[comboParent.id])},on:{"change":function($event){var $$a=_vm.collapsedByDefault[comboParent.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.collapsedByDefault, comboParent.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.collapsedByDefault, comboParent.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.collapsedByDefault, comboParent.id, $$c)}}}})])])}),0)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("\n      Save\n    ")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_vm._v("\n    Example use case:\n    "),_vm._m(4),_vm._v(" "),_c('hr'),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/hit-calculator-checkboxes-collapsed-1.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/hit-calculator-checkboxes-collapsed-2.png"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Hit calculator checkboxes collapsed by default")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"col-xs-10 col-sm-3"},[_vm._v("Made hand")]),_vm._v(" "),_c('th',{staticClass:"col-xs-2 col-sm-3"},[_vm._v("Collapsed by default")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"col-xs-10 col-sm-3"},[_vm._v("Draw")]),_vm._v(" "),_c('th',{staticClass:"col-xs-2 col-sm-3"},[_vm._v("Collapsed by default")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"col-xs-10 col-sm-3"},[_vm._v("Combo")]),_vm._v(" "),_c('th',{staticClass:"col-xs-2 col-sm-3"},[_vm._v("Collapsed by default")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("If you find yourself usually checking all flush draws or checking no flush draws, you may want to have flush draws collapsed by default so that the specific types of flush draws (nut, second nut, third nut and weak) don't crowd the screen.")]),_vm._v(" "),_c('li',[_vm._v("If you find yourself usually distinguishing between, say, nut flush draws and weak flush draws, you may not want to have flush draws collapsed by default.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9sL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue__ = __webpack_require__("eDaQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd72092_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_vue__ = __webpack_require__("m71c");
function injectStyle (ssrContext) {
  __webpack_require__("yEoP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0fd72092"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd72092_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9wNP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well should-you-call-final-conclusion",attrs:{"id":"should-you-call-final-conclusion"}},[_vm._m(0),_vm._v(" "),_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/N7y0QRlt1dg?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}}),_vm._v(" "),_c('p',[_vm._v("The initial analysis above should just be preliminary. Factoring in the possibility of betting on future streets is really important!")]),_vm._v(" "),_c('p',[_vm._v("What you really want to do when deciding whether or not to call is to estimate your real odds using ideas like implied odds, reverse implied odds, and effective odds. See the video above and the list below for help with that.")]),_vm._v(" "),_c('p',[_vm._v("Real odds:")]),_vm._v(" "),_c('p',[_c('input',{attrs:{"type":"number","min":"0.1","step":"0.1"},domProps:{"value":_vm.realOddsLHS},on:{"input":function($event){return _vm.$emit('setRealOddsLHS', $event.target.valueAsNumber)}}}),_vm._v("\n    -to-1\n  ")]),_vm._v(" "),_c('p',[_vm._v("Breakeven percentage according to real odds: "+_vm._s(_vm.breakevenPercentageViaRealOdds.toFixed(2))+"%")]),_vm._v(" "),(_vm.isCallProfitableBasedOnRealOdds)?_c('div',{staticClass:"alert alert-success"},[_vm._v("\n    According to the real odds that you estimated, your call "),_c('em',[_vm._v("will")]),_vm._v(" be profitable. ✅\n  ")]):_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n    According to the real odds that you estimated, your call "),_c('em',[_vm._v("will not")]),_vm._v(" be profitable. ❌\n  ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Reasons why it is important to factor in betting on future streets:")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Subsequent analysis that factors in future streets")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_c('p',[_vm._v("Effective odds: Suppose you have 30% equity with a flush draw and have "),_c('code',[_vm._v("4:1")]),_vm._v(" pot odds. The initial analysis says that you only need 25% equity to justify calling, and that it is worth calling because you have 30%. But what happens when you miss your flush on the turn and your opponent bets again?")]),_vm._v(" "),_c('p',[_vm._v("That 30% equity lied to you! It assumes that you deal to the river. But if you throw away your hand on the turn, you don't actually get to see the river.")]),_vm._v(" "),_c('p',[_vm._v("\n        The "),_c('code',[_vm._v("4:1")]),_vm._v(" pot odds also lied to you. Suppose the pot is $40 and you had to call $10 on the flop. You can't say, \"when I win, I win $40, and when I lose, I lose the $10\". Your opponent is probably going to fire another $25 into the pot on the turn, so you have to think, \"when I win I'm going to win the initial $40 plus the $25 my opponent throws in there on the turn, but when I lose I'm going to lose the initial $10 plus the $25 on the turn\". When you think like that, you realize that your "),_c('em',[_vm._v("effective odds")]),_vm._v(" are approximately "),_c('code',[_vm._v("13:7")]),_vm._v(", a hair less than "),_c('code',[_vm._v("2:1")]),_vm._v(".\n      ")])]),_vm._v(" "),_c('li',[_vm._v("\n      Implied odds: Taking the above example further, when you hit your flush, you don't just win your opponents normal flop and turn bets. You'll probably get another street of value from them, maybe by raising the turn, maybe by betting the river. So it is incorrect to think, \"when I win, I win the inital $40 plus the $25 turn bet\". You should think, \"when I win, I'll win the initial $40, plus the $25 turn bet, "),_c('em',[_vm._v("plus another $50 or so")]),_vm._v("\". Which means that the "),_c('em',[_vm._v("implied odds")]),_vm._v(" you're getting are about "),_c('code',[_vm._v("115:35")]),_vm._v(", or "),_c('code',[_vm._v("3.3:1")]),_vm._v(".\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      Reverse implied odds: What if you hit a hand that you think is good, like a weak flush, and your opponent has something better, like the nut flush? In that case you are going to lose future bets instead of win them.\n    ")]),_vm._v(" "),_c('li',[_vm._v("\n      Having to fold: In the analysis of effective odds, we said that your opponent would be continuing on the turn and you'd be calling. but you probably aren't "),_c('em',[_vm._v("always")]),_vm._v(" going to be calling. Some turn cards are too scary to be continuing on. The fact that you are going to have to fold some times needs to be considered.\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The video further above expands on these ideas. So does the book "),_c('a',{attrs:{"href":"https://www.twoplustwo.com/books/poker/theory-of-poker/"}},[_vm._v("The Theory of Poker by David Sklansky")]),_vm._v(" (a classic and a must-read).")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9xGn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_hand_range_vue__ = __webpack_require__("hVKk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e87f037_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_hand_range_vue__ = __webpack_require__("9584");
function injectStyle (ssrContext) {
  __webpack_require__("2xqV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e87f037"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_hand_range_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e87f037_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_hand_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "A/Yl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_save_scenario_button_vue__ = __webpack_require__("SoyC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb8bc140_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_save_scenario_button_vue__ = __webpack_require__("F4UU");
function injectStyle (ssrContext) {
  __webpack_require__("p42r")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb8bc140"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_save_scenario_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb8bc140_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_save_scenario_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AAJ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_initial_conclusion_vue__ = __webpack_require__("zyuQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7debd081_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_initial_conclusion_vue__ = __webpack_require__("jw7l");
function injectStyle (ssrContext) {
  __webpack_require__("UQBd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7debd081"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_initial_conclusion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7debd081_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_initial_conclusion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AFoN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_constants__ = __webpack_require__("vjYN");




/* harmony default export */ __webpack_exports__["a"] = ({
  checkTextValidity: function checkTextValidity(text) {
    var textParts = text.split(','); // 'aa, jj-99' --> ['aa', 'jj-99']
    var invalidParts = [];

    if (text === '') {
      return {
        valid: true
      };
    }

    textParts.forEach(function (textPart) {
      if (!this._isTextPartValid(textPart)) {
        invalidParts.push(textPart);
      }
    }, this);

    return {
      valid: invalidParts.length === 0,
      invalidParts: invalidParts
    };
  },
  /*
    valid text parts:
      [singleHand]
      [singleHand]+
        except aa+, aks+, 87s+, etc.
      [singleHand]-
        except 22-, a2s-, 82s-, etc.
      [singleHand]-[singleHand]
        except pair-suited, offsuit-suit, etc.
  */
  _isTextPartValid: function _isTextPartValid(textPart) {
    textPart = textPart.toLowerCase();
    var textPartType = this.__getTextPartType(textPart);

    // [handPart]+
    if (textPartType === 'plus') {
      return this.__isTextPartPlusValid(textPart);
    }

    // [handPart]-
    else if (textPartType === 'minus') {
        return this.__isTextPartMinusValid(textPart);
      }

      // [handPart]-[handPart]
      else if (textPartType === 'range') {
          return this.__isTextPartRangeValid(textPart);
        }

        // [handPart]
        else if (textPartType === 'individual hand') {
            return this.__isHandValid(textPart) || this.__isSpecificHandValid(textPart);
          }
  },
  __getTextPartType: function __getTextPartType(textPart) {
    var plusSplit = textPart.split('+');
    var dashSplit = textPart.split('-');
    var hasPlus = plusSplit.length > 1;
    var hasMinus = false;
    var hasDash = false;

    // there's one dash
    if (dashSplit.length === 2) {
      // ends in a dash
      if (textPart[textPart.length - 1] === '-') {
        hasMinus = true;
      } else {
        hasDash = true;
      }
    }

    if (hasPlus) {
      return 'plus';
    } else if (hasMinus) {
      return 'minus';
    } else if (hasDash) {
      return 'range';
    } else {
      return 'individual hand';
    }
  },
  __isTextPartPlusValid: function __isTextPartPlusValid(textPart) {
    var plusSplit = textPart.split('+');

    // + needs to be at the end
    if (plusSplit[1].length > 0) {
      return false;
    }

    // in [handPart]+, [handPart] needs to be valid
    if (!this.__isHandValid(plusSplit[0])) {
      return false;
    }

    // + not applicable for these
    if (['aa+', 'aks+', 'ako+', 'ak+'].includes(textPart)) {
      return false;
    }

    // otherwise, [handPart]+ is valid
    return true;
  },
  __isTextPartMinusValid: function __isTextPartMinusValid(textPart) {
    var dashSplit = textPart.split('-');

    // - needs to be at the end
    if (dashSplit[1].length > 0) {
      return false;
    }

    // in [handPart]-, [handPart] needs to be valid
    if (!this.__isHandValid(dashSplit[0])) {
      return false;
    }

    // - not applicable for these
    if (['22-', 'a2s-', 'k2s-', 'q2s-', 'j2s-', 't2s-', '92s-', '82s-', '72s-', '62s-', '52s-', '42s-', '32s-', 'a2o-', 'k2o-', 'q2o-', 'j2o-', 't2o-', '92o-', '82o-', '72o-', '62o-', '52o-', '42o-', '32o-', 'a2-', 'k2-', 'q2-', 'j2-', 't2-', '92-', '82-', '72-', '62-', '52-', '42-', '32-'].includes(textPart)) {
      return false;
    }

    // otherwise, [handPart]- is valid
    return true;
  },
  __isTextPartRangeValid: function __isTextPartRangeValid(textPart) {
    var dashSplit = textPart.split('-');
    var rangeLeftType = void 0;
    var rangeRightType = void 0;

    // should only be one dash in [handPart]-[handPart]
    if (dashSplit.length > 2) {
      return false;
    }

    if (textPart.length === 7) {
      // K7s-KJs should be invalid
      if (__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.isFirstRankLargerThanSecond(textPart[5], textPart[1])) {
        return false;
      }
    }

    if (textPart.length === 5) {
      // 55-99 should be invalid
      if (__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.isFirstRankLargerThanSecond(textPart[3], textPart[0])) {
        return false;
      }
    }

    // in [handPart]-[handPart], both handParts need to be valid
    if (!this.__isHandValid(dashSplit[0])) {
      return false;
    }
    if (!this.__isHandValid(dashSplit[1])) {
      return false;
    }

    if (dashSplit[0].includes('s')) {
      rangeLeftType = 'suited';
    } else if (dashSplit[0].includes('o')) {
      rangeLeftType = 'offsuit';
    } else {
      rangeLeftType = 'pair';
    }

    if (dashSplit[1].includes('s')) {
      rangeRightType = 'suited';
    } else if (dashSplit[1].includes('o')) {
      rangeRightType = 'offsuit';
    } else {
      rangeRightType = 'pair';
    }

    if (rangeLeftType === rangeRightType) {
      return true;
    } else {
      return false;
    }
  },
  __isHandValid: function __isHandValid(handString) {
    handString = handString.toLowerCase();

    if (handString.length === 2 && handString[0] !== handString[1] && __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].ranks.includes(handString[0]) && __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].ranks.includes(handString[1])) {
      return true;
    }

    return __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].handRankings['ten-handed-evolutionary'].includes(handString);
  },
  __isSpecificHandValid: function __isSpecificHandValid(handString) {
    if (handString.length !== 4) {
      return false;
    }

    handString = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getNormalizedSpecificHandString(handString);
    return __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].specificHandStrings.includes(handString);
  }
});

/***/ }),

/***/ "AGWH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AUOD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_five_card_hand_weight_modal_vue__ = __webpack_require__("vw0i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fdc7e6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_five_card_hand_weight_modal_vue__ = __webpack_require__("W5Ra");
function injectStyle (ssrContext) {
  __webpack_require__("UZvK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fdc7e6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_five_card_hand_weight_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fdc7e6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_five_card_hand_weight_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AaE9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reasoning_1_vue__ = __webpack_require__("DMG2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a39c808_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reasoning_1_vue__ = __webpack_require__("v5/C");
function injectStyle (ssrContext) {
  __webpack_require__("e91s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a39c808"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reasoning_1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a39c808_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reasoning_1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Akib":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__ = __webpack_require__("Ywgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_pricing_table__ = __webpack_require__("89NH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-purchase',
  components: {
    'errors-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__["a" /* default */],
    'pricing-table': __WEBPACK_IMPORTED_MODULE_1__components_utilities_pricing_table__["a" /* default */],
    'card-number': __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["CardNumber"],
    'card-expiry': __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["CardExpiry"],
    'card-cvc': __WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["CardCvc"]
  },
  data: function data() {
    return {
      stripeConsumerKey: "",
      options: {},
      complete: false,
      version: 'basic',
      number: false,
      expiry: false,
      cvc: false,
      purchasing: false,
      errorsFromBackend: []
    };
  },
  computed: {
    daysLeftOnFreeTrial: function daysLeftOnFreeTrial() {
      return this.$store.getters['account/daysLeftOnFreeTrial'];
    },
    purchaseText: function purchaseText() {
      if (this.purchasing) {
        return 'Purchasing...';
      }

      var price = this.version === 'basic' ? '$25' : '$75';

      return 'Purchase the ' + this.version + ' version for ' + price;
    },
    purchasedShortDeck: function purchasedShortDeck() {
      return this.$store.getters['account/purchasedShortDeck'];
    }
  },
  watch: {
    number: function number() {
      this.update();
    },
    expiry: function expiry() {
      this.update();
    },
    cvc: function cvc() {
      this.update();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$destroy(); // because of stripe issue
    next();
  },
  methods: {
    update: function update() {
      this.complete = this.number && this.expiry && this.cvc;

      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    purchase: function purchase() {
      var self = this;

      self.purchasing = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vue_stripe_elements_plus__["createToken"])().then(function (result) {
        if (result.error) {
          self.purchasing = false;
          self.errorsFromBackend.push(result.error.message);
        } else {
          self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/purchase-' + self.version, {
            token: result.token.id
          }).then(function () {
            self.$store.commit('account/purchasePPT', self.version);
            self.purchasing = false;
            alert('Successfully purchased the ' + self.version + ' version of Six Plus Hold\u2019em!');
            self.$router.push({ path: '/account' });
          }).catch(function (e) {
            self.purchasing = false;
            __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.handleNetworkError(e);
          }).then(function () {
            if (true) {
              $FPROM.trackSignup({
                email: self.$store.state.account.user.email
              }, function () {
                console.log('Callback received!');
              });
              rdt('track', 'Purchase');
              // self.gtagReportConversion();
              self.microsoftReportConversion();
            }
          }).catch(function () {
            console.log('Error with the conversion tracking for ads.');
          });
          ;
        }
      }).catch(function (e) {
        self.purchasing = false;
        __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.handleNetworkError(e);
      });
    },
    gtagReportConversion: function gtagReportConversion(url) {
      var callback = function callback() {
        if (typeof url != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
        'send_to': 'AW-714944788/w5PhCJ3ozqgBEJTi9NQC',
        'transaction_id': '',
        'event_callback': callback
      });
      return false;
    },
    microsoftReportConversion: function microsoftReportConversion() {
      var eventValue = this.version === 'basic' ? 25 : 75;

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'Subscribe', { event_value: eventValue });
    },
    clearAlert: function clearAlert() {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    }
  }
});

/***/ }),

/***/ "AmK+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"short-deck-equity-calculator"},[_c('div',{staticClass:"simulation-progress"}),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_c('equity-calculator-controls',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"hasSimulationBeenRun":_vm.state.hasSimulationBeenRun,"savedScenario":_vm.savedScenario,"shortDeck":true,"disabled":!_vm.authorized,"loggedIn":_vm.loggedIn},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"addPlayer":function($event){return _vm.addPlayer()},"createSharableUrl":function($event){return _vm.createSharableUrl()},"saveScenario":function($event){return _vm.expandSaveScenarioModal()},"updateScenario":function($event){return _vm.updateScenario()},"simulate":function($event){return _vm.simulate()}}}),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('div',{key:player.id,class:_vm.columnClass},[_c('short-deck-hand-range',{ref:'player' + playerIndex,refInFor:true,class:{
          'insights-visible': _vm.insightsVisible,
          'second-player': playerIndex === 1,
          'third-player': playerIndex === 2,
          'two-or-four-players': _vm.state.players.numPlayers === 2 || _vm.state.players.numPlayers === 4,
          'three-five-or-more-players': _vm.state.players.numPlayers === 3 || _vm.state.players.numPlayers >= 5,
        },attrs:{"generalHands":player.states[0].generalHands,"weightToApplyToAddedHands":player.weightToApplyToAddedHands,"combosToAdd":player.combosToAdd,"disableAllButGridSelector":false,"disableAllSelectors":!_vm.authorized,"canBeRemoved":playerIndex > 1},on:{"removePlayer":function($event){return player.handleRemovePlayerEvent('shortDeckEquityCalculator', _vm.$store, playerIndex)},"clearRange":function($event){return player.handleClearPlayerEvent('shortDeckEquityCalculator', _vm.$store, playerIndex, 0)},"addComboToCombosToAdd":function($event){return player.handleAddComboToCombosToAddEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex)},"removeComboFromCombosToAdd":function($event){return player.handleRemoveComboFromCombosToAddEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex)},"applyExactWeightToGeneralHands":function($event){return player.handleApplyExactWeightToGeneralHandsEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"selectGeneralHand":function($event){return player.handleSelectGeneralHandEvent('shortDeckEquityCalculator', _vm.$store, $event.generalHandString, $event.triggeredByMouseover, playerIndex, 0)},"deselectGeneralHand":function($event){return player.handleDeselectGeneralHandEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"selectGeneralHands":function($event){return player.handleSelectGeneralHandsEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"deselectGeneralHands":function($event){return player.handleDeselectGeneralHandsEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"selectSpecificHand":function($event){return player.handleSelectSpecificHandEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"deselectSpecificHand":function($event){return player.handleDeselectSpecificHandEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"setRangeToMatchGeneralHands":function($event){return player.handleSetRangeToMatchGeneralHandsEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"setRangeToMatchDoubleSlider":function($event){return player.handleSetRangeToMatchDoubleSliderEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0, _vm.handRankings)},"setRangeToMatchSpecificHandStrings":function($event){return player.handleSetRangeToMatchSpecificHandStringsEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"applyExactWeightToGeneralHand":function($event){return player.handleApplyExactWeightToGeneralHandEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"setWeightOfSpecificHand":function($event){return player.handleSetWeightOfSpecificHandEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex, 0)},"setWeightToApplyToAddedHands":function($event){return player.handleSetWeightToApplyToAddedHandsEvent('shortDeckEquityCalculator', _vm.$store, $event, playerIndex)}}},[_c('equity-results',{attrs:{"slot":"left-header","equity":player.states[0].equity,"equityString":player.states[0].equityString,"winPercentageString":player.states[0].winPercentageString,"tiePercentageString":player.states[0].tiePercentageString,"hasSimulationBeenRun":_vm.state.hasSimulationBeenRun},slot:"left-header"}),_vm._v(" "),(_vm.state.presetCommunityCards.flopSet)?_c('li',{attrs:{"slot":"extra-dropdown-item-1"},on:{"click":function($event){return _vm.expandNarrowRangeModal(playerIndex)}},slot:"extra-dropdown-item-1"},[_c('a',[_vm._v("Narrow range "),_c('span',{staticClass:"glyphicon glyphicon-new-window"})])]):_vm._e()],1)],1)}),0),_vm._v(" "),_c('narrow-range-modal',{staticClass:"narrow-range-modal",on:{"narrowRange":function($event){return _vm.narrowRange($event)}}}),_vm._v(" "),_c('sharable-url-modal',{attrs:{"url":_vm.sharableUrl.url,"approximateWaitTime":_vm.sharableUrl.approximateWaitTime}}),_vm._v(" "),_c('save-scenario-modal',{on:{"save":function($event){return _vm.saveScenario($event)}}}),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"equity calculator","urlPath":"equity-calculator"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "AsmH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-call-river-steps"},[_c('div',[_c('h4',[_vm._v("Step "+_vm._s(6 + (_vm.state.players.numPlayers * 3))+": What is the river card?")]),_vm._v(" "),_c('river-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}}})],1),_vm._v(" "),(_vm.state.streetToCall === 'river' && _vm.state.presetCommunityCards.riverSet)?_c('section',[_c('pot-odds-selector',{attrs:{"numOpponents":_vm.state.players.numPlayers,"streetToCall":_vm.state.streetToCall,"potOdds":_vm.state.potOdds,"authorized":_vm.authorized},on:{"setPotOdds":function($event){return _vm.$emit('setPotOdds', $event)}}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.riverSet)?_c('div',_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('set-range-step',{key:player.id,attrs:{"textForStep":_vm.getTextForPlayerRangeStep(playerIndex),"player":player,"playerIndex":playerIndex,"playerStateIndex":3,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"storeModuleName":'guidedAnalysesCalling',"authorized":_vm.authorized}},[(_vm.state.streetToCall === 'river')?_c('river-selector',{attrs:{"slot":"boardCardsSelector","presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}},slot:"boardCardsSelector"}):_vm._e(),_vm._v(" "),_c('range-help-section',{attrs:{"slot":"rangeHelpSection","playerStateIndex":3,"streetToCall":_vm.state.streetToCall},slot:"rangeHelpSection"})],1)}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B/5w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"log-double-slider-selector"},[_c('vue-slider',_vm._b({ref:"slider",attrs:{"disabled":_vm.disabled},on:{"callback":function($event){return _vm.setRangeToMatchDoubleSlider($event)}},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var label = ref.label;
return (_vm.showLabel(label))?_c('div',{staticClass:"diy-tooltip"},[_vm._v("\n      "+_vm._s(label)+"\n    ")]):_vm._e()}}],null,true),model:{value:(_vm.percentiles),callback:function ($$v) {_vm.percentiles=$$v},expression:"percentiles"}},'vue-slider',_vm.sliderOptions,false)),_vm._v(" "),_c('span',{staticClass:"badge percent-of-hands-in-range",attrs:{"data-toggle":"tooltip","title":"Percent of hands in range","data-placement":"top"}},[_vm._v("\n    "+_vm._s(_vm.percentOfHandsInRangeNumberForDisplay)+"%\n  ")]),_vm._v(" "),_c('span',{staticClass:"badge number-of-combos-in-range",attrs:{"data-toggle":"tooltip","title":"Number of combos in range","data-placement":"top"}},[_vm._v("\n    "+_vm._s(_vm.numberOfSpecificHandsInRange)+"/"+_vm._s(_vm.numberOfPossibleSpecificHands)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "B/JW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B6WE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B9N6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BCbh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__ = __webpack_require__("RBWx");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'river-selector',
  components: {
    'individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__["a" /* default */]
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'river') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function _toggleNextDropdown(previousPosition) {
      var nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function __getNextPosition(previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else if (previousPosition === 'flop3') {
        return 'turn';
      } else if (previousPosition === 'turn') {
        return 'river';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    }
  }
});

/***/ }),

/***/ "BH2Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BJ9z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"panel-heading clearfix"},[_c('h3',{staticClass:"panel-title"},[(_vm.hitPercentageBeingComputed)?_c('span',[_c('em',[_vm._v("Computing hit percentage...")])]):(_vm.hitPercentageUpToDate)?_c('span',[_c('span',[_vm._v(_vm._s(_vm.hitPercentage)+"%")]),_c('span',[_vm._v(" of hands hit")]),_c('span',[_vm._v(" the "+_vm._s(_vm.street))])]):_c('span',[_c('em',[_vm._v("Run simulation to update hit percentage for the "+_vm._s(_vm.street))])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default clear-checks",attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$emit('clearAllChecks')}}},[_c('span',{staticClass:"full-text"},[_vm._v("Clear checkboxes")]),_vm._v(" "),_c('span',{staticClass:"partial-text"},[_vm._v("Clear")])]),_vm._v(" "),_c('div',{staticClass:"dropdown set-checks-to-default"},[_c('button',{staticClass:"btn btn-default dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","disabled":!_vm.authorized}},[_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{on:{"click":function($event){return _vm.$emit('selectAllChecks')}}},[_c('a',[_vm._v("Select all")])]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),_c('li',{staticClass:"dropdown-header"},[_vm._v("Continuing range (call or raise)")]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.$emit('setChecksToDefault', 'tight')}}},[_c('a',[_vm._v("Tight")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.$emit('setChecksToDefault', 'straightforward')}}},[_c('a',[_vm._v("Straightforward")])]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.$emit('setChecksToDefault', 'loose')}}},[_c('a',[_vm._v("Loose")])]),_vm._v(" "),(_vm.userDefinedFilters.length > 0)?_c('li',{staticClass:"dropdown-header"},[_vm._v("User defined filters")]):_vm._e(),_vm._v(" "),_vm._l((_vm.userDefinedFilters),function(userDefinedFilter,index){return _c('li',{key:userDefinedFilter.name + '-' + index,on:{"click":function($event){return _vm.$emit('setChecksBasedOnUserDefinedFilter', userDefinedFilter.name)}}},[_c('a',[_vm._v(_vm._s(userDefinedFilter.name))])])})],2)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"full-text"},[_vm._v("Set checkboxes "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"partial-text"},[_vm._v("Checkboxes "),_c('span',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BKMn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hit-calculator-number-of-simulations-settings settings"},[_vm._m(0),_vm._v(" "),_c('input',{ref:"numberOfSimulations",staticClass:"form-control input-lg",attrs:{"type":"number","step":"1000"},domProps:{"value":_vm.numberOfSimulations}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){return _vm.reset()}}},[_vm._v("\n      Set to default (25,000)\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("\n      Save\n    ")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_c('p',[_vm._v("By running more simulations, you'll get more accurate results, but it'll take longer. By running fewer simulations, it'll run more quickly, but the results won't be as accurate.")]),_vm._v(" "),_c('p',[_vm._v("How long the simulations take depend on the processing speed of the device you're using.")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Number of simulations (hit calculator)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BNXB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filters_vue__ = __webpack_require__("OIE4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2a989c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filters_vue__ = __webpack_require__("db5n");
function injectStyle (ssrContext) {
  __webpack_require__("IphQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e2a989c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e2a989c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BPqd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'forgot-password',
  data: function data() {
    return {
      email: '',
      submitAttempted: false
    };
  },
  computed: {
    emailErrorMessage: function emailErrorMessage() {
      if (this.email === '') {
        return 'An email is required';
      } else if (!this.emailValid) {
        return 'Invalid email';
      } else {
        return false;
      }
    },
    emailValid: function emailValid() {
      var regex = /\S+@\S+\.\S+/;
      return regex.test(this.email);
    }
  },
  methods: {
    submit: function submit() {
      if (this.emailErrorMessage) {
        this.submitAttempted = true;
        return;
      }

      this.$http.post("https://oddscalc.sixplusholdem.com/api" + '/user/reset-password', { email: this.email }).then(function (res) {
        alert('An email was sent. Please check your email and follow the instructions there to finish resetting your password.');
      }).catch(function () {
        alert('An email was sent. Please check your email and follow the instructions there to finish resetting your password.');
      });
    }
  }
});

/***/ }),

/***/ "BTn5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_hands_GeneralHands__ = __webpack_require__("udlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_FiveCardHands__ = __webpack_require__("JKDa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_flop_info_helpers__ = __webpack_require__("HdM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);










var PlayerState = function () {
  function PlayerState(stateName) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PlayerState);

    this.name = stateName;
    this.generalHands = new __WEBPACK_IMPORTED_MODULE_3__services_hands_GeneralHands__["a" /* default */]();
    this.equity = 0;
    this.winPercentage = 0;
    this.tiePercentage = 0;

    if (stateName !== 'afterPreflop') {
      this.generalHands.initializeAsBelongingToPlayerStateOtherThanFirstPlayerState();
      this._hitPercentage = 0;
      this.fiveCardHands = new __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_FiveCardHands__["a" /* default */]();
      this.handAndDrawInfo = [];
      this.lastSimulation = {
        generalHands: null,
        nameOfStateUsedForSimulation: null,
        presetCommunityCards: null,
        presetHoleCards: null,
        exhaustive: null
      };
      this.hitPercentageBeingComputed = null;
      this.nextState = null;
    }
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PlayerState, [{
    key: 'forCurrStateAndFutureStates',


    // iterators
    value: function forCurrStateAndFutureStates(cb) {
      var state = this;

      do {
        cb(state);
        state = state.nextState;
      } while (state);
    }
  }, {
    key: 'forEachFutureState',
    value: function forEachFutureState(cb) {
      var state = this.nextState;

      while (state) {
        cb(state);
        state = state.nextState;
      }
    }
  }, {
    key: 'getFiveCardHandsThatAreCheckedByDefault',


    // five card hands
    value: function getFiveCardHandsThatAreCheckedByDefault(presetCommunityCards, opponentTightness, settings) {
      var defaultChecksObjFromSettings = settings.hitCalculator.defaultChecks;

      if (this.name === 'afterFlop') {
        if (presetCommunityCards.flopSet) {
          return this._getFiveCardHandsThatAreCheckedByDefaultForPresetFlop(presetCommunityCards, defaultChecksObjFromSettings, opponentTightness);
        } else {
          return defaultChecksObjFromSettings.afterFlop.default[opponentTightness];
        }
      } else {
        return defaultChecksObjFromSettings[this.name][opponentTightness];
      }
    }
  }, {
    key: '_getFiveCardHandsThatAreCheckedByDefaultForPresetFlop',
    value: function _getFiveCardHandsThatAreCheckedByDefaultForPresetFlop(presetCommunityCards, defaultChecksObjFromSettings, opponentTightness) {
      var flopCards = presetCommunityCards.flopArray;
      var flopTone = __WEBPACK_IMPORTED_MODULE_5__services_flop_info_helpers__["a" /* default */].getFlopTone(flopCards);
      var flopTexture = __WEBPACK_IMPORTED_MODULE_5__services_flop_info_helpers__["a" /* default */].getFlopTexture(flopCards);
      return defaultChecksObjFromSettings.afterFlop[flopTone][flopTexture][opponentTightness];
    }
  }, {
    key: 'areFiveCardHandPercentagesUpToDate',
    value: function areFiveCardHandPercentagesUpToDate(player, currentPresetCommunityCards, currentPresetHoleCards) {
      if (this.lastSimulation.generalHands === null) {
        return true;
      }

      var presetCommunityCardsSameAsPresetCommunityCardsUsedForLastSimulation = this._arePresetCommunityCardsSameAsPresetCommunityCardsUsedForLastSimulation(currentPresetCommunityCards);
      var presetHoleCardsSameAsPresetHoleCardsUsedForLastSimulation = this._arePresetHoleCardsSameAsPresetHoleCardsUsedForLastSimulation(currentPresetHoleCards);

      if (this.lastSimulation.exhaustive) {
        return presetCommunityCardsSameAsPresetCommunityCardsUsedForLastSimulation && this._isRangeSameAsRangeUsedForLastSimulation(player, currentPresetCommunityCards, true);
      } else if (!this.lastSimulation.exhaustive) {
        return presetCommunityCardsSameAsPresetCommunityCardsUsedForLastSimulation && presetHoleCardsSameAsPresetHoleCardsUsedForLastSimulation && this._isRangeSameAsRangeUsedForLastSimulation(player, currentPresetCommunityCards);
      }
    }
  }, {
    key: '_arePresetCommunityCardsSameAsPresetCommunityCardsUsedForLastSimulation',
    value: function _arePresetCommunityCardsSameAsPresetCommunityCardsUsedForLastSimulation(currentPresetCommunityCards) {
      if (this.name === 'afterFlop') {
        return currentPresetCommunityCards.flop1 === this.lastSimulation.presetCommunityCards.flop1 && currentPresetCommunityCards.flop2 === this.lastSimulation.presetCommunityCards.flop2 && currentPresetCommunityCards.flop3 === this.lastSimulation.presetCommunityCards.flop3;
      } else if (this.name === 'afterTurn') {
        return currentPresetCommunityCards.flop1 === this.lastSimulation.presetCommunityCards.flop1 && currentPresetCommunityCards.flop2 === this.lastSimulation.presetCommunityCards.flop2 && currentPresetCommunityCards.flop3 === this.lastSimulation.presetCommunityCards.flop3 && currentPresetCommunityCards.turn === this.lastSimulation.presetCommunityCards.turn;
      } else if (this.name === 'afterRiver') {
        return currentPresetCommunityCards.flop1 === this.lastSimulation.presetCommunityCards.flop1 && currentPresetCommunityCards.flop2 === this.lastSimulation.presetCommunityCards.flop2 && currentPresetCommunityCards.flop3 === this.lastSimulation.presetCommunityCards.flop3 && currentPresetCommunityCards.turn === this.lastSimulation.presetCommunityCards.turn && currentPresetCommunityCards.river === this.lastSimulation.presetCommunityCards.river;
      }
    }
  }, {
    key: '_arePresetHoleCardsSameAsPresetHoleCardsUsedForLastSimulation',
    value: function _arePresetHoleCardsSameAsPresetHoleCardsUsedForLastSimulation(currentPresetHoleCards) {
      return currentPresetHoleCards.holeCardOne === this.lastSimulation.presetHoleCards.holeCardOne && currentPresetHoleCards.holeCardTwo === this.lastSimulation.presetHoleCards.holeCardTwo;
    }
  }, {
    key: '_isRangeSameAsRangeUsedForLastSimulation',
    value: function _isRangeSameAsRangeUsedForLastSimulation(player, presetCommunityCards, hack) {
      var generalHandsThatWouldBeUsedForThisSimulation = __WEBPACK_IMPORTED_MODULE_7__services_utilities_utilities__["a" /* default */].hands.getGeneralHandsToUseForSimulation(player, presetCommunityCards, this.simulateTo);
      return generalHandsThatWouldBeUsedForThisSimulation.matchesOtherRange(this.lastSimulation.generalHands, hack);
    }
  }, {
    key: 'isHitPercentageUpToDate',
    value: function isHitPercentageUpToDate(player, currentPresetCommunityCards, currentPresetHoleCards) {
      return this._canHitPercentageBeComputedWithPresetCommunityCards(currentPresetCommunityCards) || this.areFiveCardHandPercentagesUpToDate(player, currentPresetCommunityCards, currentPresetHoleCards);
    }
  }, {
    key: '_canHitPercentageBeComputedWithPresetCommunityCards',
    value: function _canHitPercentageBeComputedWithPresetCommunityCards(presetCommunityCards) {
      if (this.simulateTo === 'flop') {
        return presetCommunityCards.flopSet;
      } else if (this.simulateTo === 'turn') {
        return presetCommunityCards.turnSet;
      } else if (this.simulateTo === 'river') {
        return presetCommunityCards.riverSet;
      }
    }
  }, {
    key: 'setWeightOfSpecificHand',


    // hands
    value: function setWeightOfSpecificHand(specificHandString, newWeight) {
      var specificHandOfCurrentState = this.generalHands.find(specificHandString);
      var specificHandOfNextState = void 0;

      if (newWeight > specificHandOfCurrentState.maxPossibleWeight) {
        newWeight = specificHandOfCurrentState.maxPossibleWeight;
      }

      this.generalHands.numberOfSpecificHandsInRange -= specificHandOfCurrentState.weight / 100;
      this.generalHands.numberOfSpecificHandsInRange += newWeight / 100;
      specificHandOfCurrentState.weight = newWeight;

      if (this.nextState) {
        specificHandOfNextState = this.nextState.generalHands.find(specificHandString);

        if (specificHandOfNextState.manuallySet && newWeight === 0) {
          specificHandOfNextState.manuallySet = false;
        }

        this.nextState.generalHands.numberOfPossibleSpecificHands -= specificHandOfNextState.maxPossibleWeight / 100;
        this.nextState.generalHands.numberOfPossibleSpecificHands += newWeight / 100;
        specificHandOfNextState.maxPossibleWeight = newWeight;
      }
    }
  }, {
    key: 'setRangeAccordingToFilters',
    value: function setRangeAccordingToFilters(previousRange, presetCommunityCards, shortDeck) {
      var currSpecificHand = void 0;
      var weightToApply = void 0;

      if (this.name === 'afterPreflop') {
        throw new Error('Trying to set the afterPreflop range according to the filters.');
      }

      previousRange.forEachSpecificHand(function (previousSpecificHand, specificHandString) {
        currSpecificHand = this.generalHands.find(specificHandString);

        if (!previousSpecificHand.possible || previousSpecificHand.weight === 0) {
          this.setWeightOfSpecificHand(specificHandString, 0);
          this.generalHands.numberOfPossibleSpecificHands -= currSpecificHand.maxPossibleWeight / 100;
          currSpecificHand.maxPossibleWeight = 0;
          currSpecificHand.manuallySet = false;
        } else {
          weightToApply = currSpecificHand.getWeightToApply(this, presetCommunityCards, previousSpecificHand.weight, shortDeck);
          this.setWeightOfSpecificHand(specificHandString, weightToApply);
        }
      }, this);
    }
  }, {
    key: 'isRangePossible',


    // other
    value: function isRangePossible(presetCommunityCards) {
      if (this.name === 'afterFlop') {
        if (presetCommunityCards.flopSet) {
          return true;
        }
      }

      if (this.name === 'afterTurn') {
        if (presetCommunityCards.turnSet) {
          return true;
        }
      }

      if (this.name === 'afterRiver') {
        if (presetCommunityCards.riverSet) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: '_getHitPercentageForRange',
    value: function _getHitPercentageForRange(cutoffHand) {
      var fiveCardHandIdsInRange = __WEBPACK_IMPORTED_MODULE_6__services_constants__["a" /* default */].orderedFiveCardHandIds.getElementsUpToAndIncluding(cutoffHand);
      var specificHandStringsInRange = this.__getSpecificHandStringsInRange(fiveCardHandIdsInRange);
      var numberOfSpecificHandsInRange = this.__getNumberOfSpecificHandsInRange(specificHandStringsInRange);

      return numberOfSpecificHandsInRange / this.generalHands.numberOfPossibleSpecificHands;
    }
  }, {
    key: '__getSpecificHandStringsInRange',
    value: function __getSpecificHandStringsInRange(fiveCardHandIdsInRange) {
      var specificHandStringsInRange = [];

      this.fiveCardHands.forEachVisibleNodeInList(fiveCardHandIdsInRange, function (fiveCardHand) {
        specificHandStringsInRange = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(specificHandStringsInRange), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(fiveCardHand.matchingSpecificHands));
      });
      specificHandStringsInRange = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniq(specificHandStringsInRange);

      return specificHandStringsInRange;
    }
  }, {
    key: '__getNumberOfSpecificHandsInRange',
    value: function __getNumberOfSpecificHandsInRange(specificHandStringsInRange) {
      return specificHandStringsInRange.map(function (specificHandString) {
        return this.generalHands.find(specificHandString);
      }, this).reduce(function (numberOfSpecificHandsInRange, specificHand) {
        return numberOfSpecificHandsInRange + specificHand.maxPossibleWeight;
      }, 0);
    }
  }, {
    key: 'getIndexOfCutoffHandForBluffing',
    value: function getIndexOfCutoffHandForBluffing(breakevenPercentage) {
      return this.foldEquityAgainstDifferentRanges.reduce(function (indexOfCutoffHandForBluffing, _ref, index) {
        var cutoffHand = _ref.cutoffHand,
            foldEquity = _ref.foldEquity;

        if (foldEquity > breakevenPercentage) {
          return index;
        } else {
          return indexOfCutoffHandForBluffing;
        }
      }, null);
    }
  }, {
    key: 'getCutoffHandForBluffing',
    value: function getCutoffHandForBluffing(breakevenPercentage) {
      var indexOfCutoffHandForBluffing = this.getIndexOfCutoffHandForBluffing(breakevenPercentage);

      return this.foldEquityAgainstDifferentRanges[indexOfCutoffHandForBluffing].cutoffHand;
    }
  }, {
    key: 'getCondensedFoldEquityAgainstDifferentRanges',
    value: function getCondensedFoldEquityAgainstDifferentRanges(breakevenPercentage) {
      var indexes = [];
      var indexOfCutoffHandForBluffing = this.getIndexOfCutoffHandForBluffing(breakevenPercentage);
      var lastPossibleIndex = this.foldEquityAgainstDifferentRanges.length - 1;

      indexes.push(indexOfCutoffHandForBluffing - 3);
      indexes.push(indexOfCutoffHandForBluffing - 2);
      indexes.push(indexOfCutoffHandForBluffing - 1);
      indexes.push(indexOfCutoffHandForBluffing);
      indexes.push(indexOfCutoffHandForBluffing + 1);
      indexes.push(indexOfCutoffHandForBluffing + 2);
      indexes.push(indexOfCutoffHandForBluffing + 3);
      indexes = indexes.filter(function (index) {
        return index >= 0 && index <= lastPossibleIndex;
      });

      return indexes.map(function (index) {
        return this.foldEquityAgainstDifferentRanges[index];
      }, this);
    }
  }, {
    key: 'hitPercentage',


    // getters
    get: function get() {
      if (this.lastSimulation.exhaustive) {
        return (this.generalHands.numberOfSpecificHandsInRange / this.generalHands.numberOfPossibleSpecificHands * 100).roundToTwoDecimalPlaces();
      }

      return this._hitPercentage;
    }
  }, {
    key: 'displayName',
    get: function get() {
      if (this.name === 'afterPreflop') {
        return 'Preflop';
      } else if (this.name === 'afterFlop') {
        return 'Flop';
      } else if (this.name === 'afterTurn') {
        return 'Turn';
      } else if (this.name === 'afterRiver') {
        return 'River';
      }
    }
  }, {
    key: 'anyVisibleDraws',
    get: function get() {
      var retVal = false;

      this.fiveCardHands.forEachVisibleLeaf(function () {
        retVal = true;
      });

      return retVal;
    }
  }, {
    key: 'simulateTo',
    get: function get() {
      if (this.name === 'afterFlop') {
        return 'flop';
      } else if (this.name === 'afterTurn') {
        return 'turn';
      } else if (this.name === 'afterRiver') {
        return 'river';
      }
    }
  }, {
    key: 'equityString',
    get: function get() {
      return this.equity.toFixed(2);
    }
  }, {
    key: 'winPercentageString',
    get: function get() {
      return this.winPercentage.toFixed(2);
    }
  }, {
    key: 'tiePercentageString',
    get: function get() {
      return this.tiePercentage.toFixed(2);
    }
  }, {
    key: 'hasSimulationBeenRun',
    get: function get() {
      var hasSimulationBeenRun = true;

      this.fiveCardHands.forEachLeaf(function (leaf) {
        if (leaf._probability === null) {
          hasSimulationBeenRun = false;
        }
      });

      return hasSimulationBeenRun;
    }
  }, {
    key: 'hitPercentageForDifferentRanges',


    // hit percentage for different ranges
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_6__services_constants__["a" /* default */].orderedFiveCardHandIds.filter(function (fiveCardHandId) {
        return this.fiveCardHands.find(fiveCardHandId).matchingSpecificHands.length > 0;
      }, this).map(function (fiveCardHandId) {
        return {
          cutoffHand: this.fiveCardHands.find(fiveCardHandId),
          hitPercentage: this._getHitPercentageForRange(fiveCardHandId)
        };
      }, this);
    }
  }, {
    key: 'foldEquityAgainstDifferentRanges',
    get: function get() {
      return this.hitPercentageForDifferentRanges.map(function (_ref2) {
        var cutoffHand = _ref2.cutoffHand,
            hitPercentage = _ref2.hitPercentage;

        return {
          cutoffHand: cutoffHand,
          foldEquity: (100 - hitPercentage).roundToTwoDecimalPlaces()
        };
      });
    }
  }]);

  return PlayerState;
}();

/* harmony default export */ __webpack_exports__["a"] = (PlayerState);
;

/***/ }),

/***/ "Bjry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"single-slider-selector"},[_vm._m(0),_vm._v(" "),_c('input',{attrs:{"type":"range","min":"0","max":"100","step":"1","list":"percent-of-hands","disabled":_vm.disabled},domProps:{"value":_vm.percentOfHandsInRangeNumberForDisplay},on:{"input":function($event){return _vm.setRangeToMatchSingleSlider($event.target.value)}}}),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"labels"},[_c('span',{staticClass:"zero"},[_vm._v("0%")]),_c('span',{staticClass:"ten"},[_vm._v("10%")]),_c('span',{staticClass:"twenty"},[_vm._v("20%")]),_c('span',{staticClass:"thirty"},[_vm._v("30%")]),_c('span',{staticClass:"fourty"},[_vm._v("40%")]),_c('span',{staticClass:"fifty"},[_vm._v("50%")]),_c('span',{staticClass:"sixty"},[_vm._v("60%")]),_c('span',{staticClass:"seventy"},[_vm._v("70%")]),_c('span',{staticClass:"eighty"},[_vm._v("80%")]),_c('span',{staticClass:"ninty"},[_vm._v("90%")]),_c('span',{staticClass:"one-hundred"},[_vm._v("100%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('datalist',{attrs:{"id":"percent-of-hands"}},[_c('option',[_vm._v("0")]),_vm._v(" "),_c('option',[_vm._v("10")]),_vm._v(" "),_c('option',[_vm._v("20")]),_vm._v(" "),_c('option',[_vm._v("30")]),_vm._v(" "),_c('option',[_vm._v("40")]),_vm._v(" "),_c('option',[_vm._v("50")]),_vm._v(" "),_c('option',[_vm._v("60")]),_vm._v(" "),_c('option',[_vm._v("70")]),_vm._v(" "),_c('option',[_vm._v("80")]),_vm._v(" "),_c('option',[_vm._v("90")]),_vm._v(" "),_c('option',[_vm._v("100")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Bmu5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.path}},[_c('img',{staticClass:"help-icon",class:{ 'top-right': _vm.position === 'top-right' },attrs:{"src":"/static/help.png"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BvQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'double-slider-selector',
  components: {
    'vue-slider': __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  },
  props: ['percentOfHandsInRangeNumberForDisplay', 'numberOfSpecificHandsInRange', 'numberOfPossibleSpecificHands', 'disabled'],
  data: function data() {
    var dotSize = 16; // non-mobile

    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
      dotSize = 25; // mobile
    }

    return {
      percentiles: [0, 0],
      sliderOptions: {
        piecewiseLabel: true,
        tooltip: false,
        dotSize: dotSize,
        labelStyle: {
          'display': 'none'
        }
      }
    };
  },
  mounted: function mounted() {
    if (true) {
      $(this.$el).find('[data-toggle="tooltip"]').tooltip();
    }
  },
  methods: {
    setRangeToMatchDoubleSlider: function setRangeToMatchDoubleSlider(percentiles) {
      this.$emit('setRangeToMatchDoubleSlider', {
        bottomPercentile: percentiles[0],
        topPercentile: percentiles[1]
      });
    },
    reset: function reset() {
      this.$refs.slider.setValue([0, 0], function () {
        // for some reason this callback fixes the issue of the range being cleared when you click something else like tier 1
      });
    },
    refresh: function refresh() {
      this.$refs.slider.refresh();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "C2BC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_square_weight_bar_vue__ = __webpack_require__("H/6w");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5f66630_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_square_weight_bar_vue__ = __webpack_require__("z+K9");
function injectStyle (ssrContext) {
  __webpack_require__("Se0g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f5f66630"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_square_weight_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f5f66630_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_square_weight_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "C4LL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'visual-settings',
  data: function data() {
    var settingsState = this.$store.state.account.user.settings;

    return {
      gridSquareColors: settingsState.general.visual.gridSquareColors,
      areNumCombosInRangeVisible: settingsState.general.visual.areNumCombosInRangeVisible,
      settingHandWeights: settingsState.general.visual.settingHandWeights
    };
  },
  methods: {
    save: function save() {
      var self = this;
      var user = _.cloneDeep(this.$store.state.account.user);

      user.settings.general.visual = {
        gridSquareColors: this.gridSquareColors,
        areNumCombosInRangeVisible: this._getAreNumCombosInRangeVisibleValue(),
        settingHandWeights: this.settingHandWeights
      };
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    _getAreNumCombosInRangeVisibleValue: function _getAreNumCombosInRangeVisibleValue() {
      var areNumCombosInRangeVisible = this.areNumCombosInRangeVisible;

      if (areNumCombosInRangeVisible === 'true') {
        areNumCombosInRangeVisible = true;
      } else if (areNumCombosInRangeVisible === 'false') {
        areNumCombosInRangeVisible = false;
      } else if (typeof areNumCombosInRangeVisible !== 'boolean') {
        throw new Error('Unexpected type for areNumCombosInRangeVisible: ', areNumCombosInRangeVisible);
      }

      return areNumCombosInRangeVisible;
    }
  }
});

/***/ }),

/***/ "CEnT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-pricing',
  computed: {
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    }
  }
});

/***/ }),

/***/ "CK9H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__ = __webpack_require__("T8TE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pod-odds-selector',
  components: {
    'toggle-help-button': __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__["a" /* default */]
  },
  props: ['streetToCall', 'potOdds', 'numOpponents', 'authorized'],
  data: function data() {
    return {
      helpAreaVisible: false,
      customPotOddsLHS: 1
    };
  },
  mounted: function mounted() {
    if (!['4:1', '3:1', '2:1', '3:2', '1:1'].includes(this.potOdds)) {
      this.customPotOddsLHS = this.potOdds.split(':')[0];
    }
  },
  computed: {
    step: function step() {
      if (this.streetToCall === 'flop') {
        return 5 + this.numOpponents;
      } else if (this.streetToCall === 'turn') {
        return 6 + this.numOpponents * 2;
      } else if (this.streetToCall === 'river') {
        return 7 + this.numOpponents * 3;
      }
    }
  },
  methods: {
    toggleHelp: function toggleHelp() {
      this.helpAreaVisible = !this.helpAreaVisible;
    }
  }
});

/***/ }),

/***/ "CYY8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgot_password_vue__ = __webpack_require__("BPqd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9147b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgot_password_vue__ = __webpack_require__("ySRE");
function injectStyle (ssrContext) {
  __webpack_require__("IxtF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a9147b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_forgot_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a9147b4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_forgot_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CaVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__ = __webpack_require__("lDlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_num_opponents_selector__ = __webpack_require__("Cesf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_controls_card_selection_hole_cards_selector__ = __webpack_require__("Sl4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_controls_card_selection_preset_community_cards_selector__ = __webpack_require__("m4dX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utilities_range_for_street__ = __webpack_require__("I523");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_hand_range_equity_results__ = __webpack_require__("KFpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_hit_calculator_five_card_hands_section_insights_insights__ = __webpack_require__("Q3DD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_controls_card_selection_flop_selector__ = __webpack_require__("d+yY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_controls_card_selection_turn_selector__ = __webpack_require__("SOcV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_controls_card_selection_river_selector__ = __webpack_require__("alaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_cumulative_hit_percentages__ = __webpack_require__("cNwD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_controls_create_sharable_url_button__ = __webpack_require__("zMC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_controls_save_scenario_button__ = __webpack_require__("A/Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_onboarding_modal__ = __webpack_require__("iexb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_help_icon__ = __webpack_require__("FmIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__ = __webpack_require__("pihl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_simulator_validator__ = __webpack_require__("qY6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator',
  components: {
    'readonly-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__["a" /* default */],
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__["a" /* default */],
    'num-opponents-selector': __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_num_opponents_selector__["a" /* default */],
    'hole-cards-selector': __WEBPACK_IMPORTED_MODULE_4__components_controls_card_selection_hole_cards_selector__["a" /* default */],
    'preset-community-cards-selector': __WEBPACK_IMPORTED_MODULE_5__components_controls_card_selection_preset_community_cards_selector__["a" /* default */],
    'range-for-street': __WEBPACK_IMPORTED_MODULE_6__components_utilities_range_for_street__["a" /* default */],
    'equity-results': __WEBPACK_IMPORTED_MODULE_7__components_hand_range_equity_results__["a" /* default */],
    'hit-calculator-insights': __WEBPACK_IMPORTED_MODULE_8__components_hit_calculator_five_card_hands_section_insights_insights__["a" /* default */],
    'flop-selector': __WEBPACK_IMPORTED_MODULE_9__components_controls_card_selection_flop_selector__["a" /* default */],
    'turn-selector': __WEBPACK_IMPORTED_MODULE_10__components_controls_card_selection_turn_selector__["a" /* default */],
    'river-selector': __WEBPACK_IMPORTED_MODULE_11__components_controls_card_selection_river_selector__["a" /* default */],
    'cumulative-hit-percentages': __WEBPACK_IMPORTED_MODULE_12__components_cumulative_hit_percentages__["a" /* default */],
    'create-sharable-url-button': __WEBPACK_IMPORTED_MODULE_13__components_controls_create_sharable_url_button__["a" /* default */],
    'save-scenario-button': __WEBPACK_IMPORTED_MODULE_14__components_controls_save_scenario_button__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_15__components_onboarding_modal__["a" /* default */],
    'help-icon': __WEBPACK_IMPORTED_MODULE_16__components_help_icon__["a" /* default */]
  },
  data: function data() {
    return {
      canRunUnauthorizedSimulation: true
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.hitCalculator;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.hitCalculator.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    multiplePlayers: function multiplePlayers() {
      return this.state.players.numPlayers > 1;
    },
    insightsVisible: function insightsVisible() {
      return this.$store.state.account.user.settings.hitCalculator.insightsVisible;
    },
    isHitPercentageUpToDate: function isHitPercentageUpToDate() {
      var results = [];

      this.state.players.forEach(function (player) {
        results.push([player.states[1].isHitPercentageUpToDate(player, this.state.presetCommunityCards, this.state.presetHoleCards), player.states[2].isHitPercentageUpToDate(player, this.state.presetCommunityCards, this.state.presetHoleCards), player.states[3].isHitPercentageUpToDate(player, this.state.presetCommunityCards, this.state.presetHoleCards)]);
      }, this);

      return results;
    },
    cumulativeHitPercentages: function cumulativeHitPercentages() {
      return this.$store.getters['hitCalculator/cumulativeHitPercentages'];
    },
    authorized: function authorized() {
      return this.$store.getters['account/authorizedForBasic'];
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.load();
    } else {
      this.$store.commit('hitCalculator/setFiveCardHandValuesToDefaults', {
        settings: this.$store.state.account.user.settings,
        opponentTightness: 'straightforward'
      });
    }

    this.handleOnboard();

    // five card hand simulations
    this.$watch(this.flopExhaustiveFiveCardHandSimulationsWatcher, __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(this.runExhaustiveFiveCardHandPercentagesSimulationsForFlop, 1000));
    this.$watch(this.turnExhaustiveFiveCardHandSimulationsWatcher, __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(this.runExhaustiveFiveCardHandPercentagesSimulationsForTurn, 1000));
    this.$watch(this.riverExhaustiveFiveCardHandSimulationsWatcher, __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(this.runExhaustiveFiveCardHandPercentagesSimulationsForRiver, 1000));

    // equity simulations
    this.$watch(this.preflopEquitySimulationsWatcher, __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(this.setPreflopEquities, 1000));
    this.$watch(this.flopEquitySimulationsWatcher, __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(this.setFlopEquities, 1000));
    this.$watch(this.turnEquitySimulationsWatcher, __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(this.setTurnEquities, 1000));
    this.$watch(this.riverEquitySimulationsWatcher, __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.debounce(this.setRiverEquities, 1000));
  },
  methods: {
    // mounted
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default hit calculator page.');
          self.$router.push('/hit-calculator');
        } else {
          self.$store.commit('hitCalculator/setState', response.data.storeState);
          self.simulate();
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default hit calculator page.');
        self.$router.push('/hit-calculator');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.hitCalculator) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'hitCalculator' }).then(function () {
        self.$store.commit('account/onboard', 'hitCalculator');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },

    // controls
    addPlayer: function addPlayer() {
      this.$store.commit('hitCalculator/addPlayer', {
        settings: this.$store.state.account.user.settings,
        opponentTightness: 'straightforward'
      });
    },
    removePlayer: function removePlayer() {
      this.$store.commit('hitCalculator/removePlayer', this.state.players.numPlayers - 1);
      this.simulate();
    },
    setPresetHoleCard: function setPresetHoleCard(params) {
      this.$store.commit('hitCalculator/removePresetHoleCard', params.position);
      this.$store.commit('hitCalculator/setPresetHoleCard', {
        card: params.card,
        position: params.position
      });
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    removePresetHoleCard: function removePresetHoleCard(position) {
      this.$store.commit('hitCalculator/removePresetHoleCard', position);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(params) {
      this.$store.commit('hitCalculator/removePresetCommunityCard', params.position);
      this.$store.commit('hitCalculator/setIndividualPresetCommunityCard', {
        card: params.card,
        position: params.position
      });
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    setBoard: function setBoard(boardCards) {
      this.$store.commit('hitCalculator/removePresetCommunityCard', 'flop1');
      this.$store.commit('hitCalculator/removePresetCommunityCard', 'flop2');
      this.$store.commit('hitCalculator/removePresetCommunityCard', 'flop3');
      this.$store.commit('hitCalculator/removePresetCommunityCard', 'turn');
      this.$store.commit('hitCalculator/removePresetCommunityCard', 'river');
      this.$store.commit('hitCalculator/setBoard', boardCards);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },
    removePresetCommunityCard: function removePresetCommunityCard(position) {
      this.$store.commit('hitCalculator/removePresetCommunityCard', position);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
      this.resetAllDoubleSliders();
    },

    // player
    setRangesAccordingToFiltersForPlayer: function setRangesAccordingToFiltersForPlayer(playerIndex) {
      this.$store.commit('hitCalculator/setRangesAccordingToFilters', playerIndex);
    },
    setRangesAccordingToFiltersForAllPlayers: function setRangesAccordingToFiltersForAllPlayers() {
      this.state.players.forEach(function (player, playerIndex) {
        this.setRangesAccordingToFiltersForPlayer(playerIndex);
      }, this);
    },
    resetDoubleSliderForPlayer: function resetDoubleSliderForPlayer(playerIndex) {
      if (this.$refs['preflop-' + playerIndex]) {
        this.$refs['preflop-' + playerIndex][0].resetDoubleSlider(playerIndex);
      }
    },
    resetAllDoubleSliders: function resetAllDoubleSliders() {
      this.state.players.forEach(function (player, index) {
        this.resetDoubleSliderForPlayer(index);
      }, this);
    },

    // simulation
    flopExhaustiveFiveCardHandSimulationsWatcher: function flopExhaustiveFiveCardHandSimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[0].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    turnExhaustiveFiveCardHandSimulationsWatcher: function turnExhaustiveFiveCardHandSimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[1].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    riverExhaustiveFiveCardHandSimulationsWatcher: function riverExhaustiveFiveCardHandSimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[2].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },

    preflopEquitySimulationsWatcher: function preflopEquitySimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[0].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    flopEquitySimulationsWatcher: function flopEquitySimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[1].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    turnEquitySimulationsWatcher: function turnEquitySimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[2].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },
    riverEquitySimulationsWatcher: function riverEquitySimulationsWatcher() {
      var sum = 0;

      this.state.players.forEach(function (player) {
        sum += player.states[3].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    },

    simulate: function simulate() {
      var self = this;

      self.setPreflopEquities().then(self.setFlopEquities).then(self.setTurnEquities).then(self.setRiverEquities).then(self.runExhaustiveFiveCardHandPercentagesSimulationsForFlop).then(self.runExhaustiveFiveCardHandPercentagesSimulationsForTurn).then(self.runExhaustiveFiveCardHandPercentagesSimulationsForRiver).then(function () {
        self.canRunUnauthorizedSimulation = false;
      });
    },

    ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop: function ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop() {
      var returnValue = true;

      // not sure if commenting this out introduces a bug or not, but I don't think it does
      // if (this.state.players.numPlayers > 1) {
      //   returnValue = false;
      // }

      if (!this.authorized && !this.canRunUnauthorizedSimulation) {
        returnValue = false;
      }

      if (!this.state.presetCommunityCards.flopSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('preflop')) {
        returnValue = false;
      }

      return returnValue;
    },
    ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn: function ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn() {
      var returnValue = true;

      // not sure if commenting this out introduces a bug or not, but I don't think it does
      // if (this.state.players.numPlayers > 1) {
      //   returnValue = false;
      // }

      if (!this.authorized && !this.canRunUnauthorizedSimulation) {
        returnValue = false;
      }

      if (!this.state.presetCommunityCards.turnSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('flop')) {
        returnValue = false;
      }

      return returnValue;
    },
    ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver: function ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver() {
      var returnValue = true;

      // not sure if commenting this out introduces a bug or not, but I don't think it does
      // if (this.state.players.numPlayers > 1) {
      //   returnValue = false;
      // }

      if (!this.authorized && !this.canRunUnauthorizedSimulation) {
        returnValue = false;
      }

      if (!this.state.presetCommunityCards.riverSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('turn')) {
        returnValue = false;
      }

      return returnValue;
    },
    runExhaustiveFiveCardHandPercentagesSimulationsForFlop: function runExhaustiveFiveCardHandPercentagesSimulationsForFlop() {
      var self = this;

      if (!self.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getFlopFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('hitCalculator/setLastSimulationInfo', 1);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    runExhaustiveFiveCardHandPercentagesSimulationsForTurn: function runExhaustiveFiveCardHandPercentagesSimulationsForTurn() {
      var self = this;

      if (!self.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getTurnFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('hitCalculator/setLastSimulationInfo', 2);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    runExhaustiveFiveCardHandPercentagesSimulationsForRiver: function runExhaustiveFiveCardHandPercentagesSimulationsForRiver() {
      var self = this;

      if (!self.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getRiverFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('hitCalculator/setLastSimulationInfo', 3);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },

    showNonexhaustiveSimulationButton: function showNonexhaustiveSimulationButton(playerIndex, street) {
      if (!this.authorized) {
        return false;
      }

      if (!this.ableToRunNonexhaustiveFiveCardHandPercentageSimulationsForPlayer(playerIndex)) {
        return false;
      } else if (street === 'flop' && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop()) {
        return false;
      } else if (street === 'turn' && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn()) {
        return false;
      } else if (street === 'river' && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver()) {
        return false;
      }

      return true;
    },
    ableToRunNonexhaustiveFiveCardHandPercentageSimulationsForPlayer: function ableToRunNonexhaustiveFiveCardHandPercentageSimulationsForPlayer(playerIndex) {
      return !this.state.players.find(playerIndex).hasEmptyRange('preflop');
    },
    runNonexhaustiveFiveCardHandPercentagesSimulationsForFlop: function runNonexhaustiveFiveCardHandPercentagesSimulationsForFlop(playerIndex) {
      return this._runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet(playerIndex, 'flop', 1);
    },
    runNonexhaustiveFiveCardHandPercentagesSimulationsForTurn: function runNonexhaustiveFiveCardHandPercentagesSimulationsForTurn(playerIndex) {
      return this._runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet(playerIndex, 'turn', 2);
    },
    runNonexhaustiveFiveCardHandPercentagesSimulationsForRiver: function runNonexhaustiveFiveCardHandPercentagesSimulationsForRiver(playerIndex) {
      return this._runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet(playerIndex, 'river', 3);
    },
    _runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet: function _runNonexhaustiveFiveCardHandPercentagesSimulationsForStreet(playerIndex, streetName, streetIndex) {
      var self = this;

      if (!this.authorized && !this.canRunUnauthorizedSimulation) {
        return;
      }

      return self.__runNonexhaustiveSimulationsForPlayer(playerIndex, streetName, streetIndex).then(function () {
        self.setRangesAccordingToFiltersForPlayer(playerIndex);
        self.$store.commit('hitCalculator/setLastSimulationInfo', streetIndex);
        self.$store.commit('hitCalculator/setHitPercentageBeingComputed', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex,
          value: true
        });
        self.$store.dispatch('hitCalculator/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex
        });
        self.$store.commit('hitCalculator/clearMatchingSpecificHands', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex
        });
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    __runNonexhaustiveSimulationsForPlayer: function __runNonexhaustiveSimulationsForPlayer(playerIndex, streetName, streetIndex) {
      var self = this;
      var player = self.state.players.find(playerIndex);
      var simulatorMethod = self.___getNonexhaustiveSimulatorMethod(streetName);
      var numberOfSimulations = self.$store.state.account.user.settings.hitCalculator.numberOfSimulations;

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */][simulatorMethod](player.getWeightedRangeToUseForSimulation(self.state.presetCommunityCards, streetName), self.state.presetCommunityCards.getArrayForStateViaStreet(streetName), numberOfSimulations, function (value) {
        self.incrementSimulationProgress(value, playerIndex, streetName);
      }).then(function (handAndDrawInfo) {
        self.$store.commit('hitCalculator/setHandAndDrawInfo', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex,
          handAndDrawInfoFromSimulationResults: handAndDrawInfo
        });
        self.$store.commit('hitCalculator/setProbabilitiesOfFiveCardHands', {
          playerIndex: playerIndex,
          playerStateIndex: streetIndex,
          handAndDrawInfo: handAndDrawInfo,
          numberOfSimulations: numberOfSimulations
        });
        self.resetSimulationProgress(playerIndex, streetName);
      });
    },
    ___getNonexhaustiveSimulatorMethod: function ___getNonexhaustiveSimulatorMethod(streetName) {
      var capitalizedStreetName = __WEBPACK_IMPORTED_MODULE_20_lodash___default.a.capitalize(streetName);
      var simulatorMethod = 'get' + capitalizedStreetName + 'FiveCardHandPercentagesViaSimulations';

      return simulatorMethod;
    },

    ableToGetPreflopEquities: function ableToGetPreflopEquities() {
      if (!this.authorized && !this.canRunUnauthorizedSimulation) {
        return false;
      }

      return this.state.presetHoleCards.bothSet && !this.state.players.hasEmptyRange('preflop');
    },
    ableToGetFlopEquities: function ableToGetFlopEquities() {
      if (!this.authorized && !this.canRunUnauthorizedSimulation) {
        return false;
      }

      return this.state.presetHoleCards.bothSet && this.state.presetCommunityCards.flopSet && !this.state.players.hasEmptyRange('flop');
    },
    ableToGetTurnEquities: function ableToGetTurnEquities() {
      if (!this.authorized && !this.canRunUnauthorizedSimulation) {
        return false;
      }

      return this.state.presetHoleCards.bothSet && this.state.presetCommunityCards.turnSet && !this.state.players.hasEmptyRange('turn');
    },
    ableToGetRiverEquities: function ableToGetRiverEquities() {
      if (!this.authorized && !this.canRunUnauthorizedSimulation) {
        return false;
      }

      return this.state.presetHoleCards.bothSet && this.state.presetCommunityCards.riverSet && !this.state.players.hasEmptyRange('river');
    },
    setPreflopEquities: function setPreflopEquities() {
      if (!this.ableToGetPreflopEquities()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this._setEquitiesForStreet(0);
    },
    setFlopEquities: function setFlopEquities() {
      if (!this.ableToGetFlopEquities()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this._setEquitiesForStreet(1);
    },
    setTurnEquities: function setTurnEquities() {
      if (!this.ableToGetTurnEquities()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this._setEquitiesForStreet(2);
    },
    setRiverEquities: function setRiverEquities() {
      if (!this.ableToGetRiverEquities()) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return this._setEquitiesForStreet(3);
    },
    _setEquitiesForStreet: function _setEquitiesForStreet(playerStateIndex) {
      var self = this;
      var weightedRanges = self.__getWeightedRanges(playerStateIndex);
      var numberOfSimulations = self.$store.state.account.user.settings.equityCalculator.numberOfSimulations;
      var presetCommunityCardsArray = self.state.presetCommunityCards.getArrayForStateViaIndex(playerStateIndex);

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getEquities(weightedRanges, presetCommunityCardsArray, numberOfSimulations, function () {}).then(function (simulationResults) {
        self.$store.commit('hitCalculator/updateEquityResults', {
          playerStateIndex: playerStateIndex,
          simulationResults: simulationResults,
          numberOfSimulations: numberOfSimulations,
          rakePercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.rakePercentage,
          tipPercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.tipPercentage
        });

        if (true) {
          $(self.$el).find('[data-toggle="tooltip"]').tooltip();
        }
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the equity simulations.');
      });
    },
    __getWeightedRanges: function __getWeightedRanges(playerStateIndex) {
      var weightedRanges = [];
      var heroWeightedRange = [[this.state.presetHoleCards.holeCardOne, this.state.presetHoleCards.holeCardTwo]];

      weightedRanges.push(heroWeightedRange);
      this.state.players.forEach(function (player) {
        weightedRanges.push(player.states[playerStateIndex].generalHands.weightedRange);
      }, this);

      return weightedRanges;
    },

    getTextWhenFiveCardHandPercentagesArentUpToDate: function getTextWhenFiveCardHandPercentagesArentUpToDate(playerStateIndex) {
      if (playerStateIndex === 1 && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheFlop() || playerStateIndex === 2 && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheTurn() || playerStateIndex === 3 && this.ableToRunExhaustiveFiveCardHandPercentageSimulationsForTheRiver()) {
        return 'Running simulations...';
      } else {
        return 'Not up to date. Run simulations to update.';
      }
    },
    incrementSimulationProgress: function incrementSimulationProgress(value, playerIndex, streetName) {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButtonContainer = $(this.$refs[streetName + '-' + playerIndex][0].$el).find('.simulate-button-container');
      var $simulationButton = $simulationButtonContainer.find('.simulate-button');
      var $simulationButtonProgressBox = $simulationButtonContainer.find('.progress-box');

      $simulationProgress.css('width', value + '%');
      $simulationButton.prop('disabled', true);
      $simulationButtonProgressBox.css('z-index', '1');
      $simulationButtonProgressBox.css('width', value + '%');
      $simulationButtonProgressBox.css('cursor', 'not-allowed');
    },
    resetSimulationProgress: function resetSimulationProgress(playerIndex, streetName) {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButtonContainer = $(this.$refs[streetName + '-' + playerIndex][0].$el).find('.simulate-button-container');
      var $simulationButton = $simulationButtonContainer.find('.simulate-button');
      var $simulationButtonText = $simulationButtonContainer.find('.text');
      var $simulationButtonProgressBox = $simulationButtonContainer.find('.progress-box');

      $simulationProgress.css('width', '0%');
      $simulationButton.prop('disabled', false);
      $simulationButtonText.text('Simulate');
      $simulationButtonProgressBox.css('z-index', '-1');
      $simulationButtonProgressBox.css('cursor', 'auto');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "CcOp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator-checkboxes-checked-by-default-settings'
});

/***/ }),

/***/ "Ced7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_number_of_simulations_vue__ = __webpack_require__("9dXV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79950c1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_number_of_simulations_vue__ = __webpack_require__("oGBU");
function injectStyle (ssrContext) {
  __webpack_require__("8DYu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79950c1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_number_of_simulations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79950c1c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_number_of_simulations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cesf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_num_opponents_selector_vue__ = __webpack_require__("QQQk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c81d37e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_num_opponents_selector_vue__ = __webpack_require__("//i3");
function injectStyle (ssrContext) {
  __webpack_require__("q00v")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9c81d37e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_num_opponents_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c81d37e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_num_opponents_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CvKd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DESx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"short-deck-preset-community-cards-selector"},[_c('short-deck-individual-card-selector',{ref:"flop1",attrs:{"cardString":_vm.presetCommunityCards.flop1,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop1')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop1')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"flop2",attrs:{"cardString":_vm.presetCommunityCards.flop2,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop2')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop2')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"flop3",attrs:{"cardString":_vm.presetCommunityCards.flop3,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop3')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop3')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"turn",attrs:{"cardString":_vm.presetCommunityCards.turn,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'turn')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'turn')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"river",attrs:{"cardString":_vm.presetCommunityCards.river,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'river')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'river')}}}),_vm._v(" "),_c('short-deck-random-board-selector',{attrs:{"presetHoleCards":this.presetHoleCards.array,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"setBoard":function($event){return _vm.$emit('setBoard', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DGRh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DMG2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-reasoning-help-section-1'
});

/***/ }),

/***/ "Dj9F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__ = __webpack_require__("0pPF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed4d361_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__ = __webpack_require__("gqru");
function injectStyle (ssrContext) {
  __webpack_require__("oPMm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ed4d361"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ed4d361_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ds5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"faq"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h2',[_vm._v("Money")]),_vm._v(" "),_c('h3',{attrs:{"id":"money-qghJr"}},[_vm._v("How much does Six Plus Hold’em cost?")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('pricing-table'),_vm._v(" "),_c('h3',{attrs:{"id":"money-9wq9y"}},[_vm._v("How does the free trial work?")]),_vm._v(" "),_c('p',[_vm._v("When you "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(", you will automatically be entered in to a 14 day free trial. This will give you full access to everything that Six Plus Hold’em has to offer. You can see how much time is left on your free trial on your "),_c('router-link',{attrs:{"to":"/account"}},[_vm._v("account page")]),_vm._v(".")],1),_vm._v(" "),_c('h3',{attrs:{"id":"money-iuosd"}},[_vm._v("How doess it work if I purchase the basic version now, and want to upgrade to the premium version later?")]),_vm._v(" "),_c('p',[_vm._v("You'll only have to pay the $50 difference, not the full $75.")]),_vm._v(" "),_c('h3',{attrs:{"id":"money-Ze31i"}},[_vm._v("Will Six Plus Hold’em really pay for itself?")]),_vm._v(" "),_c('p',[_vm._v("Nothing is 100%, but I believe that the answer will almost certainly be \"yes\".")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('section',{staticClass:"well"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n        How many hours of poker do you play each month?\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hoursPerMonth),expression:"hoursPerMonth"}],staticClass:"form-control input-lg",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.hoursPerMonth)},on:{"input":function($event){if($event.target.composing){ return; }_vm.hoursPerMonth=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n        What is the big blind in the games that you play?\n        "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-addon"},[_vm._v("$")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bigBlind),expression:"bigBlind"}],staticClass:"form-control input-lg",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.bigBlind)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bigBlind=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n        If Six Plus Hold’em wins you this many big blinds per hour:\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bigBlindsPerHour),expression:"bigBlindsPerHour"}],staticClass:"form-control input-lg",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.bigBlindsPerHour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.bigBlindsPerHour=$event.target.value}}}),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('p',[_vm._v("Then you will win "),_c('strong',[_vm._v("$"+_vm._s(_vm.extraWinningsPerMonth)+" more each month")]),_vm._v(".")])]),_vm._v(" "),_c('p',[_vm._v("Also, consider the value that you place on your time. If Six Plus Hold’em saves you just one hour per month of time, and you value your time at $10/hour, it is already paying for itself.")]),_vm._v(" "),_c('h3',{attrs:{"id":"money-B8jDB"}},[_vm._v("Does Six Plus Hold’em have an affiliate program?")]),_vm._v(" "),_vm._m(6),_c('p',[_vm._v("Yes, yes, and yes. Six Plus Hold’em is a web app, so as long as you can use a web browser like Chrome, Firefox or Safari, you can use Six Plus Hold’em.")]),_vm._v(" "),_c('h3',{attrs:{"id":"general-Osl9f"}},[_vm._v("Is there a mobile app? Can I use it on my phone?")]),_vm._v(" "),_c('p',[_vm._v("There is no mobile app, but you can absolutely still use it on your phone. Just open up your web browser (eg. Chrome or Safari) and go to "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("premiumpokertools.com")]),_vm._v(". It is designed to be mobile friendly, so you won't have any issues with fat fingers or squinting.")],1),_vm._v(" "),_c('h3',{attrs:{"id":"general-iQ5yS"}},[_vm._v("I'm a beginner. Will Six Plus Hold’em still be useful to me?")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('h3',{attrs:{"id":"general-MnYmx"}},[_vm._v("I'm an expert. Will Six Plus Hold’em still be useful to me? I feel like I only need to study GTO and solvers.")]),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("3) Even if you primarily study with a solver, you still want to have an equity calculator and hit calculator at times too right? And if you're playing high stakes, investing $25 or $75 is certainly going to have a positive ROI right?")]),_vm._v(" "),_c('h3',{attrs:{"id":"general-LqjMO"}},[_vm._v("I only play casually in home games. Would it be worth it for me to get Six Plus Hold’em?")]),_vm._v(" "),_c('p',[_vm._v("Eh, probably not. It's a tool for studying, and if you're not putting in the time to study it probably isn't worth having. Unless you just want to use the equity calculator to see how lucky your friend got when they hit that straight on the river against you.")]),_vm._v(" "),_c('h3',{attrs:{"id":"general-uSFON"}},[_vm._v("I'm a beginner. Can you help me?")]),_vm._v(" "),_c('p',[_vm._v("Absolutely! I'd love to Skype to walk you through the app and help you grow as a poker player. I currently do this with a variety of other PPT users.")]),_vm._v(" "),_c('p',[_vm._v("If it makes you feel any better, there's something in it for me as well: user research. It's super helpful for me to see how real people use the app. What they like, what is confusing, etc.")]),_vm._v(" "),_c('h3',{attrs:{"id":"general-0CJvj"}},[_vm._v("I mostly play cash/tourneys/short-stacked/deep-stacked/heads-up/whatever. Will Six Plus Hold’em be useful to me?")]),_vm._v(" "),_c('p',[_vm._v("Yes, absolutely! Poker is poker.")]),_vm._v(" "),_c('h3',{attrs:{"id":"general-2EWuS"}},[_vm._v("Why are you so eager to talk/Skype with users?")]),_vm._v(" "),_c('p',[_vm._v("Well, first of all I really enjoy teaching, learning, studying, and meeting new people.")]),_vm._v(" "),_c('p',[_vm._v("But there's another more selfish reason. Any entrepreneur - or product person for that matter - if you want to be successful, you have to talk to your users. That is something that I really believe, and something that is pretty well accepted actually.")]),_vm._v(" "),_c('tweet',{attrs:{"id":"898476047263518720"}}),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('h3',{attrs:{"id":"general-G9yAY"}},[_vm._v("What are some good reasons for me to get in touch?")]),_vm._v(" "),_c('p',[_vm._v("Here are some (but not all!) good reasons to get in touch:")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('h2',[_vm._v("App")]),_vm._v(" "),_c('h3',{attrs:{"id":"app-zWcoc"}},[_vm._v("I'm confused and don't really know what to do.")]),_vm._v(" "),_c('p',[_vm._v("I try my best to make things user friendly, but ultimately, PPT is a powerful piece of software and does require an initial investment of time to learn how things work. Check out the \"Specific tools\" sections on the "),_c('router-link',{attrs:{"to":"/help"}},[_vm._v("help page")]),_vm._v(", and please take the time to watch the videos.")],1),_vm._v(" "),_vm._m(13),_c('p',[_vm._v("See the "),_c('router-link',{attrs:{"to":"/quick-guide#quick-guide-selecting-specific-suits"}},[_vm._v("\"Selecting specific suits\" section")]),_vm._v(" of the quick guide.")],1),_vm._v(" "),_c('h3',{attrs:{"id":"app-8bnJ2"}},[_vm._v("How do I do X? What is Y?")]),_vm._v(" "),_c('p',[_vm._v("Check out the "),_c('router-link',{attrs:{"to":"/quick-guide"}},[_vm._v("quick guide")]),_vm._v(", the answer is probably there.")],1),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('h3',{attrs:{"id":"app-AmHjH"}},[_vm._v("What are those tables with two rows that light up green and red with ✅ and ❌ emojis after I run a simulation?")]),_vm._v(" "),_c('p',[_vm._v("I call them the insights sections.")]),_vm._v(" "),_c('p',[_vm._v("Here is the insights section in the equity calculator:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/insights/1.png"}}),_vm._v(" "),_c('p',[_vm._v("And here it is in the hit calculator:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/insights/2.png"}}),_vm._v(" "),_c('p',[_vm._v("Here is what the insights section in the equity calculator is saying:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/insights/3.png"}}),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('p',[_vm._v("Consider an example. Imagine that the pot is $15 and you need to call $5 to stay in the hand.")]),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_c('p',[_vm._v("Here is what the bluffing section of the hit calculator insights section is saying:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/insights/4.png"}}),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('p',[_vm._v("When the initial bet size is 1/2 pot (ie. your opponent bets half pot), here is what the numbers in the bluff raising section of the hit calculator insights section mean:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/insights/5.png"}}),_vm._v(" "),_vm._m(22),_vm._v(" "),_c('p',[_vm._v("When the initial bet size is 3/4 pot (ie. your opponent bets 3/4 pot), here is what the numbers in the bluff raising section of the hit calculator insights section mean:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/insights/6.png"}}),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('p',[_vm._v("When the initial bet size is full pot (ie. your opponent bets full pot), here is what the numbers in the bluff raising section of the hit calculator insights section mean:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/insights/7.png"}}),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('p',[_vm._v("Consider an example. The pot is $10. Your opponent bets $5. You want to know how often a raise to $15 needs to work in order to be immediately profitable.")]),_vm._v(" "),_vm._m(26),_vm._v(" "),_c('h3',{attrs:{"id":"app-zYHhW"}},[_vm._v("What do the ✅ and ❌ symbols mean?")]),_vm._v(" "),_c('p',[_vm._v("✅ means that it's an immediately profitable play, and ❌ means that it is not an immediately profitable play.")]),_vm._v(" "),_c('p',[_vm._v("Consider an example.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/insights/8.png"}}),_vm._v(" "),_c('p',[_vm._v("For a full pot bluff to be immediately profitable, it needs to work more than 50% of the time. In this case, your opponent will hit the board 54.95% of the time, which means that he will miss the board 45.05%, which means that the bluff will only work 45.05% of the time, which is less than 50%, so a full pot bluff will not be immediately profitable, and an ❌ will appear.")]),_vm._v(" "),_c('p',[_vm._v("On the other hand, a 3/4 pot bluff only needs to work 42.9% of the time to be immediately profitable. In this case your opponent will miss the board 45.05% of the time, which is more than 42.9%, so a 3/4 pot bluff will be immediately profitable, and a ✅ will appear.")]),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('h3',{attrs:{"id":"app-Lm7xW"}},[_vm._v("What does immediately profitable mean?")]),_vm._v(" "),_c('p',[_vm._v("Imagine that you have, say, 33 on an AJ7 flop. Suppose that we know for some reason that our opponent has A9 and we would like to bluff him off of his top pair and win the pot.")]),_vm._v(" "),_c('p',[_vm._v("A half pot bet needs to work 1/3 of the time to be immediately profitable. Basically, saying \"immediately profitable\" means that it doesn't take in to account the fact that we could hit another three on the turn or river and make a set. It doesn't take in to account that even if our bluff gets called, we still may win anyway.")]),_vm._v(" "),_c('p',[_vm._v("\"Immediately profitable\" is saying:")]),_vm._v(" "),_vm._m(28),_vm._v(" "),_c('p',[_vm._v("Note that with 33, we only have 2 outs, so when our bluff gets called, it's very unlikely that we end up hitting one of our outs and winning the pot. But with a flush draw, we have 9 outs, and so the difference between a \"profitable\" and \"immediately profitable\" starts to become notable. Hence why we call a bluff with a flush draw a semi-bluff rather than an outright bluff.")]),_vm._v(" "),_c('h2',[_vm._v("Equity calculator")]),_vm._v(" "),_c('h3',{attrs:{"id":"equity-calculator-TOMMq"}},[_vm._v("Why isn't the equity the same every time?")]),_vm._v(" "),_c('p',[_vm._v("Because Six Plus Hold’em runs simulations, rather than computing the equity exactly. Computing it exactly would take too long.")]),_vm._v(" "),_c('p',[_vm._v("It runs 25,000 simulations by default, but "),_c('router-link',{attrs:{"to":"/settings/equity-calculator/number-of-simulations"}},[_vm._v("you can change this in the settings")]),_vm._v(". With the default number of simulations, the equity will only vary by 1% or so, which will never really end up influencing your decisions as a poker player.")],1),_vm._v(" "),_c('h2',[_vm._v("Hit calculator")]),_vm._v(" "),_c('h3',{attrs:{"id":"hit-calculator-6LPY7"}},[_vm._v("Why aren't the hit percentages the same every time?")]),_vm._v(" "),_vm._m(29),_vm._v(" "),_vm._m(30),_vm._v(" "),_c('h3',{attrs:{"id":"hit-calculator-hCpGX"}},[_vm._v("What does the \"Set checkboxes\" dropdown button do?")]),_vm._v(" "),_c('p',[_vm._v("Here is the button that the question is referring to:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/set-checkboxes/1.png"}}),_vm._v(" "),_c('p',[_vm._v("Suppose that you want to know whether you should bluff an opponent after he checks to you on a Tc8c4s flop. In analyzing this question, you're going to have to make an educated guess about what your opponent would call or raise with. Weak pairs? Middle pair? Gutshots? The \"Set checkboxes\" button basically lets you ask Six Plus Hold’em what it thinks a tight, straightforward or loose opponent would continue with in the given situation.")]),_vm._v(" "),_c('p',[_vm._v("Six Plus Hold’em gives a different answer depending on whether you're on the flop, turn, or river, because most opponents will continue with different hands on the turn than they would on the flop, and would continue with differnet hands on the river than they would on the turn. Namely, they tighten up as the hand progresses to future streets.")]),_vm._v(" "),_c('p',[_vm._v("Six Plus Hold’em also gives a different answer depending on the flop texture (when only the flop is set). On a scary board like a monotone triple broadway (eg. AcQcJs), no one is going to call with just a gutshot. But on a something dry like a raggedy rainbow board (eg. 9c6s2c), a gutshot would be enough for many players to continue with.")]),_vm._v(" "),_c('p',[_vm._v("On the turn and river, Six Plus Hold’em isn't smart enough to understand board texture and gives you the same answer regardless of what the board looks like. In the future I will make it smart enough to understand board texture on the turn and river.")]),_vm._v(" "),_c('h3',{attrs:{"id":"hit-calculator-59cd5"}},[_vm._v("Why is a bar for 40% the same length as one for 60%?")]),_vm._v(" "),_c('p',[_vm._v("Check this out:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/hit-calculator-59cd5.png"}}),_vm._v(" "),_c('p',[_vm._v("If the probability is over 40%, the bar will always be 85 pixels long. That way we can \"zoom in\" and better distinguish between probabilities of, say, 5% and 10%. If 100% was 2.5x bigger than 40%, a 5% bar and 10% bar would both be really small and hard to distinguish between. Most of the time we're more interested in the smaller probabilities.")]),_vm._v(" "),_c('h2',[_vm._v("Short deck")]),_vm._v(" "),_c('h3',{attrs:{"id":"short-deck-ee033"}},[_vm._v("Do you offer any options for short deck?")]),_vm._v(" "),_c('p',[_vm._v("Yes! The equity calculator and hit calculator. The "),_c('router-link',{attrs:{"to":"/short-deck/equity-calculator"}},[_vm._v("equity calculator")]),_vm._v(" is free (but please use my affiliate links!). The hit calculator is $150.")],1),_vm._v(" "),_c('h3',{attrs:{"id":"short-deck-83cb8"}},[_vm._v("How do the hand rankings for short deck work?")]),_vm._v(" "),_c('p',[_vm._v("Flush beats a full house. 9876A is a straight. Otherwise, same as regular long deck poker.")]),_vm._v(" "),_c('h2',[_vm._v("Rarely asked questions")]),_vm._v(" "),_vm._m(31),_vm._v(" "),_vm._m(32),_vm._v(" "),_c('p',[_vm._v("Eg. if two players have trip nines with the same kicker, and the third player only has a pair of kings, the pot will be split by the first two players with the trip nines, and the guy with the pair of kings doesn't get anything.")]),_vm._v(" "),_c('h3',{attrs:{"id":"raq-sjnNm"}},[_vm._v("The hit percentage is greater than if you add up the percentages of all the checked items. Is that a bug?")]),_vm._v(" "),_c('p',[_vm._v("No, it's not a bug.")]),_vm._v(" "),_c('p',[_vm._v("Imagine that you only have the made hand of overpairs, and the combo of overpairs and flush draws checked.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/hit-percentage-calculation/1.png"}}),_vm._v(" "),_c('p',[_vm._v("Suppose that after running the simulations, it shows that you get the made hand of overpairs 30% of the time and the combo of overpair and flush draw 10% of the time.")]),_vm._v(" "),_c('p',[_vm._v("Then you look up at the hit percentage, and it says that only 30% of the hands hit. Huh? Shouldn't it be 40%? 30% + 10% = 40%, right?")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/hit-percentage-calculation/2.png"}}),_vm._v(" "),_c('p',[_vm._v("To understand why the true hit percentage is 30%, not 40%, imagine that ten simulations were run with the following results:")]),_vm._v(" "),_vm._m(33),_vm._v(" "),_c('p',[_vm._v("What percentage of the time did we get an overpair? Well, 3 out of 10 times, so 30% of the time.")]),_vm._v(" "),_c('p',[_vm._v("What percentage of the time did we get an overpair + flush draw? Well, 1 out of 10 times, so 10% of the time.")]),_vm._v(" "),_c('p',[_vm._v("What percentage of the time did we hit the board? Well, we hit on the first, second and third simulations, but missed the remaining seven, so we hit 3 out of 10 times. 30% of the time. Not 40% of the time.")]),_vm._v(" "),_c('p',[_vm._v("The following pie chart should clarify things further:")]),_vm._v(" "),_c('img',{staticClass:"venn-diagram",attrs:{"src":"/static/guides/faq/hit-percentage-calculation/3.png"}}),_vm._v(" "),_c('p',[_vm._v("Consider what we're doing when we add 30% (overpairs) to 10% (overpairs + flush draws). The 30% consists of the left/red + middle/purple sections. The 10% consists of the middle/purple section. If we added 30% to 10%, we'd be counting the middle/purple section twice.")]),_vm._v(" "),_c('h3',{attrs:{"id":"raq-JK15r"}},[_vm._v("The sum of all the percentages is greater than 100%. Is that a bug?")]),_vm._v(" "),_c('p',[_vm._v("No, it's not a bug.")]),_vm._v(" "),_c('p',[_vm._v("Imagine that you have TcTs on 9c8c7c.")]),_vm._v(" "),_vm._m(34),_vm._v(" "),_c('p',[_vm._v("This example demonstrates that:")]),_vm._v(" "),_vm._m(35),_vm._v(" "),_c('p',[_vm._v("In other words, these things aren't mutually exclusive.")]),_vm._v(" "),_c('p',[_vm._v("Here are the results of running that simulation:")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/guides/faq/double-counting/1.png"}}),_vm._v(" "),_c('p',[_vm._v("Note that:")]),_vm._v(" "),_vm._m(36),_vm._v(" "),_c('p',[_vm._v("The reason why both of these facts are possible is because some things aren't mutually exclusive.")]),_vm._v(" "),_c('p',[_vm._v("To be more specific:")]),_vm._v(" "),_vm._m(37)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("FAQ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well"},[_vm._v("\n    Money:\n    "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#money-qghJr"}},[_vm._v("How much does Six Plus Hold’em cost?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#money-9wq9y"}},[_vm._v("How does the free trial work?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#money-iuosd"}},[_vm._v("How doess it work if I purchase the basic version now, and want to upgrade to the premium version later?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#money-Ze31i"}},[_vm._v("Will Six Plus Hold’em really pay for itself?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#money-B8jDB"}},[_vm._v("Does Six Plus Hold’em have an affiliate program?")])])]),_vm._v("\n    General:\n    "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#general-LH0gP"}},[_vm._v("Will Six Plus Hold’em work on a Mac? Windows? Linux?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#general-Osl9f"}},[_vm._v("Is there a mobile app? Can I use it on my phone?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#general-iQ5yS"}},[_vm._v("I'm a beginner. Will Six Plus Hold’em still be useful to me?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#general-MnYmx"}},[_vm._v("I'm an expert. Will Six Plus Hold’em still be useful to me? I feel like I only need to study GTO and solvers.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#general-LqjMO"}},[_vm._v("I only play casually in home games. Would it be worth it for me to get Six Plus Hold’em?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#general-uSFON"}},[_vm._v("I'm a beginner. Can you help me?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#general-0CJvj"}},[_vm._v("I mostly play cash/tourneys/short-stacked/deep-stacked/heads-up/whatever. Will Six Plus Hold’em be useful to me?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#general-2EWuS"}},[_vm._v("Why are you so eager to talk/Skype with users?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#general-G9yAY"}},[_vm._v("What are some good reasons for me to get in touch?")])])]),_vm._v("\n    App:\n    "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#app-zWcoc"}},[_vm._v("I'm confused and don't really know what to do.")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#app-S2YHf"}},[_vm._v("How do I select specific suits?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#app-8bnJ2"}},[_vm._v("How do I do X? What is Y?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#app-AmHjH"}},[_vm._v("What are those tables with two rows that light up green and red with ✅ and ❌ emojis after I run a simulation?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#app-zYHhW"}},[_vm._v("What do the ✅ and ❌ symbols mean?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#app-Lm7xW"}},[_vm._v("What does immediately profitable mean?")])])]),_vm._v("\n    Equity calculator:\n    "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#equity-calculator-TOMMq"}},[_vm._v("Why isn't the equity the same every time?")])])]),_vm._v("\n    Hit calculator:\n    "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#hit-calculator-6LPY7"}},[_vm._v("Why aren't the hit percentages the same every time?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#hit-calculator-hCpGX"}},[_vm._v("What does the \"Set checkboxes\" dropdown button do?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#hit-calculator-59cd5"}},[_vm._v("Why is a bar for 40% the same length as one for 60%?")])])]),_vm._v("\n    Short Deck:\n    "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#short-deck-ee033"}},[_vm._v("Do you offer any options for short deck?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#short-deck-83cb8"}},[_vm._v("How do the hand rankings for short deck work?")])])]),_vm._v("\n    Rarely asked questions:\n    "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"#raq-RqPik"}},[_vm._v("When I run simulations with three players, the equity does not equal "),_c('code',[_vm._v("win percentage + (tie percentage / 3)")]),_vm._v(". Why is that? Don't ties get split three ways between the players?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#raq-sjnNm"}},[_vm._v("The hit percentage is greater than if you add up the percentages of all the checked items. Is that a bug?")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#raq-JK15r"}},[_vm._v("The sum of all the percentages is greater than 100%. Is that a bug?")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("$25 for the basic version, or $75 for the premium version. If you purchase the basic version and "),_c('a',{attrs:{"href":"#money-iuosd"}},[_vm._v("want to upgrade later")]),_vm._v(", you'll only have to pay the $50 difference. See the table below:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("There are two main reasons for this: 1) Six Plus Hold’em will "),_c('strong',[_vm._v("make you money")]),_vm._v(" by improving your winrate, and 2) Six Plus Hold’em will "),_c('strong',[_vm._v("save you "),_c('em',[_vm._v("time")])]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.splitsuit.com/poker-time-money-and-roi"}},[_vm._v("which really is pretty interchangable with money")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("See the widget below to get a feel for how much money Six Plus Hold’em will make you. And keep in mind that it not only improves your current earnings, but also improves your "),_c('em',[_vm._v("future")]),_vm._v(" earnings as well. For example, if you're playing NL10 online right now, it might not make you that much money, but it will bring you closer to the point where you are playing NL50 or NL100 or NL200 where you "),_c('em',[_vm._v("will")]),_vm._v(" be earning more money.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',[_c('a',{attrs:{"href":"http://www.thepokerbank.com/strategy/other/winrate/"}},[_vm._v("More information on winrates")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Email "),_vm._v("\">Will Six Plus Hold’em work on a Mac? Windows? Linux?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Absolutely! In fact, you'll probably get more value out of it than anyone else. Psychologists have this idea of a "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/Learning_curve"}},[_vm._v("learning curve")]),_vm._v(" that says how progress is usually fast at first and harder to come by as you progress. Think about someone who has never lifted weights before. Initially they're going to make great progress, then slower progress, and then at some point they'll plateau.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Depending on how early on you are, you might have to spend a little bit of time learning how to use poker software like Six Plus Hold’em to study. This will be easy though. My "),_c('a',{attrs:{"href":"https://www.youtube.com/channel/UCNrKf4FUAN6E8NoSDKV20Ng"}},[_vm._v("YouTube channel")]),_vm._v(" has a bunch of videos to help you with this, and there are so many books, blog posts and other videos that teach you this as well (I'd recommend "),_c('a',{attrs:{"href":"https://www.amazon.com/Course-Serious-Strategy-Smart-Players/dp/1511768320"}},[_vm._v("The Course")]),_vm._v(", "),_c('a',{attrs:{"href":"https://www.amazon.com/Grinders-Manual-Complete-Course-Online-ebook/dp/B01GBFF890/ref=sr_1_1?keywords=the+grinders+manual&qid=1563139900&s=books&sr=1-1"}},[_vm._v("The Grinders Manual")]),_vm._v(", and "),_c('a',{attrs:{"href":"https://www.twoplustwo.com/books/poker/theory-of-poker/"}},[_vm._v("The Theory of Poker")]),_vm._v(" if you're just getting started). And if you ever run into any trouble, I'm always here to help!")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("1) This depends on how big the game is that you play, but even at a game like 5/10, people are still regularly making mistakes that you can use an exploitative style to take advantage of. See Ed Miller's article "),_c('a',{attrs:{"href":"https://web.archive.org/web/20170314052927/http://edmillerpoker.com/2014/11/04/mistakes-5-10-players-make/"}},[_vm._v("Mistakes $5-$10 Players Make")]),_vm._v(". This applies even moreso at 2/5. See "),_c('a',{attrs:{"href":"https://web.archive.org/web/20181001164249/http://edmillerpoker.com/2014/10/28/mistakes-2-5-players-make/"}},[_vm._v("Mistakes $2-$5 Players Make")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("2) Six Plus Hold’em doesn't \"give you the answers\" in the same way that a solver would, but it does something that I believe is even more important. It helps you "),_c('em',[_vm._v("understand")]),_vm._v(" the answers that the solver gives you. If you don't actually understand the answers, how is that going to help you in the middle of a real game? Are you going to memorize them? I don't believe that that is realistic.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Product sense and design sense a la Steve Jobs "),_c('a',{attrs:{"href":"https://ux.stackexchange.com/questions/53828/people-don-t-know-what-they-want-until-you-show-it-to-them"}},[_vm._v("can only get you so far")]),_vm._v(". Feedback and iteration is necessary for anyone who wants to build a good product.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('strong',[_vm._v("You're willing to Skype with me and let me watch you use the app.")]),_vm._v(" This would be very useful to me and I'd really appreciate it. They call it \"user research\". I've never done a user research session and not learned something new.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You don't understand how something works.")]),_vm._v(" If you don't understand how something works, you're probably not alone. Don't think \"I'm just being stupid\". It's one of those things like when you're in a big lecture and have a question. You think \"It's probably a stupid question, I don't want to ask it\" when in reality, 90% of the lecture hall is probably thinking the same thing you are. If you have a question, others probably do too, so please let me know so that I can address it.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You have a feature idea.")]),_vm._v(" I'd love to hear it! Similar to the above point, if there's something that you think would be useful, chances are other people will find it useful as well.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You like something about the app.")]),_vm._v(" It's important for me to get feedback about what does and doesn't work. Smart people have bad ideas all the time. You can't just assume that your ideas are good. You have to get feedback and confirm this with users. (This is the whole idea behind the Lean Startup approach.)")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You don't like something about the app.")]),_vm._v(" Also very important. I promise, you won't hurt my feelings.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You're new to poker and want some guidance.")]),_vm._v(" I'd be happy to get you started with the basics and answer any questions.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You're more experienced with poker and want a study buddy.")]),_vm._v(" This would be super useful to me! Especially if we can study with Six Plus Hold’em.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You have advice for me.")]),_vm._v(" I'm all ears! I know that there are a lot of smart people out there, and I'm always eager to take advantage of an opportunity to learn something new.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You found a bug.")]),_vm._v(" I spend a lot of time testing my code thoroughly to prevent bugs, so hopefully this doesn't happen. But if it does, definitely let me know.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You're in Vegas and think it'd be fun to hang out.")]),_vm._v(" I've been able to hang out with a bunch of people I've met through Six Plus Hold’em and it's always a blast!")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("You want to talk about entrepreneurship or programming (or anything else!)")]),_vm._v(" I'm always down to talk! If you're interested in getting started programming, I can definitely point you in the right direction and answer any questions you have.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Also, I'm "),_c('a',{attrs:{"href":"#general-2EWuS"}},[_vm._v("always here")]),_vm._v(" to help: "),_vm._v("\">How do I select specific suits?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If it isn't, email "),_c('a',{attrs:{"href":"mailto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("If you have 4:1 pot odds, your call needs to work more than 20% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("If you have 3:1 pot odds, your call needs to work more than 25% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("If you have 2:1 pot odds, your call needs to work more than 33.3% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("If you have 3:2 pot odds, your call needs to work more than 40% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("If you have 1:1 pot odds, your call needs to work more than 50% of the time to be immediately profitable.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To calculate how often a call needs to work by yourself, the formula is "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(". Or, stated differently, "),_c('code',[_vm._v("right side of ratio / (right side of ratio / left side of ratio)")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("One way to think about it is that you need to risk $5 to win $15. We can use the "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(" formula. "),_c('code',[_vm._v("5 / (5 + 15) = 5/20 = 1/4")]),_vm._v(", so calling needs to work more than 1/4 of the time to be immediately profitable.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Another way to think about it is that the pot odds are 3:1. We can use the pot odds formula of "),_c('code',[_vm._v("right side of ratio / (right side of ratio / left side of ratio)")]),_vm._v(". The left side is 3 and the right side is 1. "),_c('code',[_vm._v("1 / (1 + 3) = 1/4")]),_vm._v(", so calling needs to work more than 1/4 of the time to be immediately profitable.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("A 1/3 pot bet needs to work more than 25% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A 1/2 pot bet needs to work more than 33.3% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A 2/3 pot bet needs to work more than 40% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A 3/4 pot bet needs to work more than 42.9% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A full pot bet needs to work more than 50% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A 1.5x pot bet needs to work more than 60% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A 2x pot bet needs to work more than 66.6% of the time to be immediately profitable.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To calculate how often a bluff needs to work by yourself, the formula is "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Consider an example. Imagine that you bet $5 into a $10 pot as a bluff. You are risking $5 in order to win $10. "),_c('code',[_vm._v("5 / (5 + 10) = 5/15 = 1/3")]),_vm._v(", so that bluff needs to work more than 1/3 of the time in order to be immediately profitable.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("A bluff raise that is 2x the initial bet needs to work 20% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 3x the initial bet needs to work 33.3% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 4x the initial bet needs to work 43% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 5x the initial bet needs to work 50% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 6x the initial bet needs to work 56% of the time to be immediately profitable.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("A bluff raise that is 2x the initial bet needs to work 23% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 3x the initial bet needs to work 38% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 4x the initial bet needs to work 47% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 5x the initial bet needs to work 55% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 6x the initial bet needs to work 60% of the time to be immediately profitable.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("A bluff raise that is 2x the initial bet needs to work 25% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 3x the initial bet needs to work 40% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 4x the initial bet needs to work 50% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 5x the initial bet needs to work 57% of the time to be immediately profitable.")]),_vm._v(" "),_c('li',[_vm._v("A bluff raise that is 6x the initial bet needs to work 63% of the time to be immediately profitable.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you'd like to calculate how often a bluff raise needs to work yourself, the same "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(" formula that was used for bluffing and calling still applies.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Well, raising to $15 can be thought of as calling the $5 bet and then, "),_c('em',[_vm._v("subsequently")]),_vm._v(", betting $10 into the pot. After you call the $5, the pot is $20 - the original $10, plus $5 from each of you. Now you want to know how often betting $10 into the $20 pot needs to work. Well, you are risking $10 to win $20. "),_c('code',[_vm._v("10 / (10 + 20) = 10/30 = 1/3")]),_vm._v(", so your bluff raise to $15 needs to work more than 1/3 of the time to be immediately profitable.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Of course, be sure to remember that your opponent will most likely adjust his play based on the size of your bet. In this case, your opponent will probably call a 3/4 pot bet more often than a full pot bet due to the better pot odds, "),_c('em',[_vm._v("so when considering different bluff sizes, always remember to adjust the check boxes")]),_vm._v(". Perhaps your opponent would call with weak pairs to a 3/4 pot bet, which would bump his hit percentage up to 64.79%, making a 3/4 pot bluff not immediately profitable anymore.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('blockquote',[_vm._v("Dude, even if you "),_c('em',[_vm._v("never")]),_vm._v(" hit one of your outs, this bluff would "),_c('em',[_vm._v("still")]),_vm._v(" only need to work 1/3 of the time for us to show a profit. In reality, when our bluff gets called, we will get lucky and win some percentage of the time, so our bluff really only needs to work, say, 30% of the time or so instead of 33.3%.\"")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("When possible, Six Plus Hold’em "),_c('em',[_vm._v("will")]),_vm._v(" compute the exact value of the hit percentages, so they'll be the same every time. But computing exact values in other scenarios would slow down the app too much, and often times crash your browser.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Which board cards are set")]),_vm._v(" "),_c('th',[_vm._v("Computes exact values for flop")]),_vm._v(" "),_c('th',[_vm._v("Computes exact values for turn")]),_vm._v(" "),_c('th',[_vm._v("Computes exact values for river")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Flop isn't set")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("❌")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Flop set")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("❌")]),_vm._v(" "),_c('td',[_vm._v("❌")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Turn set")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("❌")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("River set")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")]),_vm._v(" "),_c('td',[_vm._v("✅")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{attrs:{"id":"raq-RqPik"}},[_vm._v("When I run simulations with three players, the equity does not equal "),_c('code',[_vm._v("win percentage + (tie percentage / 3)")]),_vm._v(". Why is that? Don't ties get split three ways between the players?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('em',[_vm._v("Sometimes")]),_vm._v(" there are three-way ties and the ties get split three ways. But other times, despite three people being in the pot, there may only be a two-way tie.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("Overpair")]),_vm._v(" "),_c('li',[_vm._v("Overpair")]),_vm._v(" "),_c('li',[_vm._v("Overpair + flush draw")]),_vm._v(" "),_c('li',[_vm._v("Flush draw")]),_vm._v(" "),_c('li',[_vm._v("Ace high")]),_vm._v(" "),_c('li',[_vm._v("Ace high")]),_vm._v(" "),_c('li',[_vm._v("Ace high")]),_vm._v(" "),_c('li',[_vm._v("Ace high")]),_vm._v(" "),_c('li',[_vm._v("Ace high")]),_vm._v(" "),_c('li',[_vm._v("Ace high")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("You have the made hand of an overpair.")]),_vm._v(" "),_c('li',[_vm._v("You have a flush draw.")]),_vm._v(" "),_c('li',[_vm._v("You have an open ended straight draw.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("You can have an overpair and a flush draw at the same time.")]),_vm._v(" "),_c('li',[_vm._v("You can have an overpair and an open ended straight draw at the same time.")]),_vm._v(" "),_c('li',[_vm._v("You can have a flush draw and an open ended straight draw at the same time.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("The sum of the draws is 200%, and thus exceeds 100%.")]),_vm._v(" "),_c('li',[_vm._v("The sum of the made hands, draws and combos is 500%, and thus exceeds 100%.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Made hands "),_c('em',[_vm._v("are")]),_vm._v(" mutually exclusive with one another. Ie. you can't have a flush and a straight at the same time. You can only have one or the other.")]),_vm._v(" "),_c('li',[_vm._v("Made hands are "),_c('em',[_vm._v("not")]),_vm._v(" mutually exclusive with draws. Ie. you can have an overpair and a flush draw at the same time.")]),_vm._v(" "),_c('li',[_vm._v("Made hands are "),_c('em',[_vm._v("not")]),_vm._v(" mutually exclusive with combos. Ie. you can have an overpair made hand and an overpair + flush draw combo at the same time.")]),_vm._v(" "),_c('li',[_vm._v("A flush draw "),_c('em',[_vm._v("is")]),_vm._v(" mutually exclusive with a backdoor flush draw. Ie. you can't have a flush draw and a backdoor flush draw at the same time.")]),_vm._v(" "),_c('li',[_vm._v("Straight draws "),_c('em',[_vm._v("are")]),_vm._v(" mutually exclusive with one another. Ie. you can't have an open ended straight draw and a gutshot at the same time.")]),_vm._v(" "),_c('li',[_vm._v("Having the draw of \"two overcards\" "),_c('em',[_vm._v("is")]),_vm._v(" mutually exclusive with having the draw of \"one overcard\". Of course, when you have two overcards, it is also true that you have one overcard, but it only "),_c('em',[_vm._v("counts")]),_vm._v(" as having two overcards, not as having one overcard.")]),_vm._v(" "),_c('li',[_vm._v("Flush draws are "),_c('em',[_vm._v("not")]),_vm._v(" mutually exclusive with straight draws. Ie. you can have a flush draw and an open ended straight draw at the same time.")]),_vm._v(" "),_c('li',[_vm._v("Flush draws are "),_c('em',[_vm._v("not")]),_vm._v(" mutually exclusvie with overcard draws. Ie. you can have a flush draw and a \"one overcard\" draw at the same time.")]),_vm._v(" "),_c('li',[_vm._v("Straight draws are "),_c('em',[_vm._v("not")]),_vm._v(" mutually exclusive with overcard draws. Ie. you can have a straight draw and a \"one overcard\" draw at the same time.")]),_vm._v(" "),_c('li',[_vm._v("Draws are "),_c('em',[_vm._v("not")]),_vm._v(" mutually exclusive with combos. Ie. you can have a flush draw and a flush draw + gutshot combo at the same time.")]),_vm._v(" "),_c('li',[_vm._v("Combos are "),_c('em',[_vm._v("not")]),_vm._v(" mutually exclusive with one another. Ie. you can have an overpair + flush draw combo and a gutshot + one overcard combo at the same time.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DvC0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',[_c('expand-collapse',{attrs:{"expanded":_vm.expanded},on:{"toggle":function($event){return _vm.$emit('toggle')}}}),_vm._v("\n  "+_vm._s(_vm.title)+"\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DydF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__ = __webpack_require__("lDlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_equity_matrix_result_grid__ = __webpack_require__("qM3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_hand_range_hand_range__ = __webpack_require__("cOfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_equity_calculator_narrow_range_modal__ = __webpack_require__("h/CU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_equity_calculator_controls__ = __webpack_require__("zMxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_onboarding_modal__ = __webpack_require__("iexb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_help_icon__ = __webpack_require__("FmIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_simulator_validator__ = __webpack_require__("qY6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_simulator_simulator__ = __webpack_require__("pihl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_constants__ = __webpack_require__("vjYN");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-matrix',
  components: {
    'readonly-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__["a" /* default */],
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__["a" /* default */],
    'result-grid': __WEBPACK_IMPORTED_MODULE_3__components_equity_matrix_result_grid__["a" /* default */],
    'hand-range': __WEBPACK_IMPORTED_MODULE_4__components_hand_range_hand_range__["a" /* default */],
    'narrow-range-modal': __WEBPACK_IMPORTED_MODULE_5__components_equity_calculator_narrow_range_modal__["a" /* default */],
    'equity-calculator-controls': __WEBPACK_IMPORTED_MODULE_6__components_equity_calculator_controls__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_7__components_onboarding_modal__["a" /* default */],
    'help-icon': __WEBPACK_IMPORTED_MODULE_8__components_help_icon__["a" /* default */]
  },
  data: function data() {
    return {
      playerIndexThatExpandedTheNarrowRangeModal: null
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.equityMatrix;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.equityMatrix.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    columnClass: function columnClass() {
      if (this.state.players.numPlayers === 1 || this.state.players.numPlayers === 3) {
        return 'col-md-6';
      }

      return 'col-lg-4';
    },
    handRankings: function handRankings() {
      return this.$store.getters['account/handRankings'];
    },
    authorized: function authorized() {
      return this.$store.getters['account/authorizedForPremium'];
    },
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.load();
    }

    this.handleOnboard();

    $('html, body').animate({
      scrollTop: '55px'
    }, 2000);
  },
  methods: {
    // mounted
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default equity matrix page.');
          self.$router.push('/equity-matrix');
        } else {
          self.$store.commit('equityMatrix/setState', response.data.storeState);
          setTimeout(function () {
            self.$refs.resultGrid.setPotOddsBasedOnRequiredEquity();
          }, 100);
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default equity matrix page.');
        self.$router.push('/equity-matrix');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.equityMatrix) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'equityMatrix' }).then(function () {
        self.$store.commit('account/onboard', 'equityMatrix');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },

    // range
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$store.state.account.user.settings.general.includedSelectors.slider === 'log double' || this.$store.state.account.user.settings.general.includedSelectors.slider === 'double') {
        this.$refs['player' + playerIndex][0].resetDoubleSlider();
      }
    },
    resetDoubleSliders: function resetDoubleSliders() {
      this.state.players.forEach(function (player, playerIndex) {
        this.resetDoubleSlider(playerIndex);
      }, this);
    },

    // hamburger
    expandNarrowRangeModal: function expandNarrowRangeModal(playerIndexThatExpandedTheNarrowRangeModal) {
      $(this.$el).find('.narrow-range-modal').modal();
      this.playerIndexThatExpandedTheNarrowRangeModal = playerIndexThatExpandedTheNarrowRangeModal;
    },
    narrowRange: function narrowRange(checkedHands) {
      this.$store.commit('equityMatrix/narrowRange', {
        checkedHands: checkedHands,
        playerIndex: this.playerIndexThatExpandedTheNarrowRangeModal
      });
      this.resetDoubleSlider(this.playerIndexThatExpandedTheNarrowRangeModal);
    },

    // controls
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(params) {
      this.$store.commit('equityMatrix/removePresetCommunityCard', params.position);
      this.$store.commit('equityMatrix/setIndividualPresetCommunityCard', {
        card: params.card,
        position: params.position
      });
      this.resetDoubleSliders();
    },
    setBoard: function setBoard(boardCards) {
      this.$store.commit('equityMatrix/removePresetCommunityCard', 'flop1');
      this.$store.commit('equityMatrix/removePresetCommunityCard', 'flop2');
      this.$store.commit('equityMatrix/removePresetCommunityCard', 'flop3');
      this.$store.commit('equityMatrix/removePresetCommunityCard', 'turn');
      this.$store.commit('equityMatrix/removePresetCommunityCard', 'river');
      this.$store.commit('equityMatrix/setBoard', boardCards);
      this.resetDoubleSliders();
    },
    removePresetCommunityCard: function removePresetCommunityCard(position) {
      this.$store.commit('equityMatrix/removePresetCommunityCard', position);
    },
    addPlayer: function addPlayer() {
      this.$store.commit('equityMatrix/addPlayer');
    },
    simulate: function simulate() {
      var self = this;
      var validateResult = __WEBPACK_IMPORTED_MODULE_9__services_simulator_validator__["a" /* default */].validateBeforeEquityCalculatorSimulation(this.state.players, this.state.presetCommunityCards);
      var generalHandStrings = __WEBPACK_IMPORTED_MODULE_12__services_constants__["a" /* default */].handRankings[this.$store.state.account.user.settings.general.handRankings.type];
      var $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      var simulateSingleHandFunctions = [];

      if (!self.authorized) {
        return;
      }

      if (validateResult.error) {
        alert(validateResult.errorMessage);
        return;
      }

      $simulationButtonText.text('Simulating...');

      // https://stackoverflow.com/questions/30853265
      // run simulations for each general hand

      var _loop = function _loop(i) {
        simulateSingleHandFunctions.push(function () {
          return self._simulateSingleHand(generalHandStrings[i]).then(function () {
            self._incrementSimulationProgress(i / generalHandStrings.length * 100);
          });
        });
      };

      for (var i = 0; i < generalHandStrings.length; i++) {
        _loop(i);
      }

      simulateSingleHandFunctions.reduce(function (prev, curr) {
        return prev.then(curr);
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve()).then(function () {
        self.$store.commit('equityMatrix/setHasSimulationBeenRun', true);
        self._resetSimulationProgress();
      });
    },
    _simulateSingleHand: function _simulateSingleHand(generalHandString) {
      var self = this;
      var numberOfSimulations = this.$store.state.account.user.settings.equityCalculator.numberOfSimulations / 10; // avg distance to mean is about 0.3, takes about 38 seconds; cutting it in half means the avg distance is about 1.01, and it takes 27 seconds; I like the extra precision, but you don't really need more accuracy than a 0.3 avg distance, so this is a good number I think
      var weightedRanges = void 0;

      weightedRanges = self.__getWeightedRanges(generalHandString);
      return __WEBPACK_IMPORTED_MODULE_10__services_simulator_simulator__["a" /* default */].getEquities(weightedRanges, self.state.presetCommunityCards.array, numberOfSimulations, function () {}).then(function (simulationResults) {
        self.state.resultGeneralHands.find(generalHandString).equity = ((simulationResults[0].wins + simulationResults[0].winFractions) / numberOfSimulations * 100).roundToTwoDecimalPlaces();
      }).catch(function (e) {
        console.error(e);
        self._resetSimulationProgress();
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    __getWeightedRanges: function __getWeightedRanges(generalHandString) {
      var weightedRanges = [];
      var weightedRangeFromGeneralHandString = __WEBPACK_IMPORTED_MODULE_11__services_utilities_utilities__["a" /* default */].hands.getWeightedRangeFromGeneralHandString(generalHandString, this.state.presetCommunityCards.array);

      weightedRanges.push(weightedRangeFromGeneralHandString);
      this.state.players.forEach(function (player) {
        weightedRanges.push(player.states[0].generalHands.weightedRange);
      });

      return weightedRanges;
    },
    _incrementSimulationProgress: function _incrementSimulationProgress(value) {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      var $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', value + '%');
      $simulationButton.prop('disabled', true);
      $simulationButtonProgressBox.css('z-index', '1');
      $simulationButtonProgressBox.css('width', value + '%');
      $simulationButtonProgressBox.css('cursor', 'not-allowed');
    },
    _resetSimulationProgress: function _resetSimulationProgress() {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      var $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      var $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', '0%');
      $simulationButton.prop('disabled', false);
      $simulationButtonText.text('Simulate');
      $simulationButtonProgressBox.css('z-index', '-1');
      $simulationButtonProgressBox.css('cursor', 'auto');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "E+KM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_betting_criteria_table_vue__ = __webpack_require__("LxOj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e81571bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_betting_criteria_table_vue__ = __webpack_require__("fQpx");
function injectStyle (ssrContext) {
  __webpack_require__("fFIt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e81571bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_betting_criteria_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e81571bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_betting_criteria_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "E2CI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E5VU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_scenarios_for_tool_vue__ = __webpack_require__("245k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfae694_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_scenarios_for_tool_vue__ = __webpack_require__("Q+19");
function injectStyle (ssrContext) {
  __webpack_require__("Fj+R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dfae694"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_scenarios_for_tool_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dfae694_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_scenarios_for_tool_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EDRA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-bluff-turn-steps"},[_c('div',[_c('h4',[_vm._v("Step "+_vm._s(5 + (_vm.state.players.numPlayers * 2))+": What is the turn card?")]),_vm._v(" "),_c('turn-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}}})],1),_vm._v(" "),(_vm.state.streetToBluff === 'turn')?_c('bluff-size-selector',{attrs:{"step":6 + (_vm.state.players.numPlayers * 2),"bluffSize":_vm.state.bluffSize,"authorized":_vm.authorized},on:{"setBluffSize":function($event){return _vm.$emit('setBluffSize', $event)}}}):_vm._e(),_vm._v(" "),(_vm.showFoldEquityTable)?_c('fold-equity-table',{attrs:{"state":_vm.state,"playerStateIndex":2,"immediatelyProfitableBreakevenPercentage":_vm.$store.getters['guidedAnalysesBluffing/immediatelyProfitableBreakevenPercentage']},on:{"setProfitableBreakevenPercentage":function($event){return _vm.$emit('setProfitableBreakevenPercentage', $event)}}}):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.turnSet)?_c('div',_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('set-range-step',{key:player.id,attrs:{"textForStep":_vm.getTextForPlayerRangeStep(playerIndex),"player":player,"playerIndex":playerIndex,"playerStateIndex":2,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"storeModuleName":'guidedAnalysesBluffing',"authorized":_vm.authorized}},[(_vm.state.streetToBluff === 'turn')?_c('turn-selector',{attrs:{"slot":"boardCardsSelector","presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}},slot:"boardCardsSelector"}):_vm._e(),_vm._v(" "),_c('range-help-section',{attrs:{"slot":"rangeHelpSection","playerStateIndex":2,"streetToBluff":_vm.state.streetToBluff},slot:"rangeHelpSection"})],1)}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EZ1g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"range-for-street"},[_c('section',{staticClass:"hand-range-container"},[_c('hand-range',{ref:'player-' + _vm.playerIndex + '-' + _vm.playerStateIndex,attrs:{"generalHands":_vm.player.states[_vm.playerStateIndex].generalHands,"weightToApplyToAddedHands":_vm.player.weightToApplyToAddedHands,"combosToAdd":_vm.player.combosToAdd,"disableAllSelectors":_vm.disableAllSelectors,"disableAllButGridSelector":_vm.playerStateIndex > 0,"canBeRemoved":false},on:{"clearRange":function($event){return _vm.player.handleClearPlayerEvent(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)},"addComboToCombosToAdd":function($event){return _vm.player.handleAddComboToCombosToAddEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex)},"removeComboFromCombosToAdd":function($event){return _vm.player.handleRemoveComboFromCombosToAddEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex)},"applyExactWeightToGeneralHands":function($event){return _vm.player.handleApplyExactWeightToGeneralHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"selectGeneralHand":function($event){return _vm.player.handleSelectGeneralHandEvent(_vm.storeModuleName, _vm.$store, $event.generalHandString, $event.triggeredByMouseover, _vm.playerIndex, _vm.playerStateIndex)},"deselectGeneralHand":function($event){return _vm.player.handleDeselectGeneralHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"selectGeneralHands":function($event){return _vm.player.handleSelectGeneralHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"deselectGeneralHands":function($event){return _vm.player.handleDeselectGeneralHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"selectSpecificHand":function($event){return _vm.player.handleSelectSpecificHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"deselectSpecificHand":function($event){return _vm.player.handleDeselectSpecificHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setRangeToMatchGeneralHands":function($event){return _vm.player.handleSetRangeToMatchGeneralHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setRangeToMatchDoubleSlider":function($event){return _vm.player.handleSetRangeToMatchDoubleSliderEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex, _vm.handRankings)},"setRangeToMatchSpecificHandStrings":function($event){return _vm.player.handleSetRangeToMatchSpecificHandStringsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setSpecificHandAsManuallySet":function($event){return _vm.player.handleSetSpecificHandAsManuallySetEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setSpecificHandAsNotManuallySet":function($event){return _vm.player.handleSetSpecificHandAsNotManuallySetEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"applyExactWeightToGeneralHand":function($event){return _vm.player.handleApplyExactWeightToGeneralHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setWeightOfSpecificHand":function($event){return _vm.player.handleSetWeightOfSpecificHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setWeightToApplyToAddedHands":function($event){return _vm.player.handleSetWeightToApplyToAddedHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"finishedClickAndDrag":function($event){return _vm.player.handleFinishedClickAndDrag(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)}}},[_vm._t("left-header",null,{"slot":"left-header"}),_vm._v(" "),(_vm.storeModuleName === 'guidedAnalysesCalling' && _vm.playerStateIndex > 0)?_c('value-to-bluff-ratio',{attrs:{"slot":"left-header","generalHands":_vm.player.states[_vm.playerStateIndex].generalHands,"communityCards":_vm.presetCommunityCards.getArrayForState(_vm.player.states[_vm.playerStateIndex].name)},slot:"left-header"}):_vm._e()],2)],1),_vm._v(" "),_c('section',{staticClass:"five-card-hands-section-container"},[(_vm.playerStateIndex > 0)?_c('five-card-hands-section',{attrs:{"playerState":_vm.player.states[_vm.playerStateIndex],"hitPercentageUpToDate":_vm.player.states[_vm.playerStateIndex].isHitPercentageUpToDate(_vm.player, _vm.presetCommunityCards, _vm.presetHoleCards),"showPercentagesOrCombos":true,"authorized":_vm.authorized},on:{"setCheckedValueOfFiveCardHand":function($event){return _vm.player.handleSetCheckedValueOfFiveCardHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"applyExactWeightToFiveCardHand":function($event){return _vm.player.handleApplyExactWeightToFiveCardHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"toggleCollapsedValueOfFiveCardHandParent":function($event){return _vm.player.handleToggleCollapsedValueOfFiveCardHandParentEvent(_vm.storeModuleName, _vm.$store, $event)},"updateWeightOfFiveCardHand":function($event){return _vm.player.handleUpdateWeightOfFiveCardHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"clearAllChecks":function($event){return _vm.player.handleClearAllChecksEvent(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)},"selectAllChecks":function($event){return _vm.player.handleSelectAllChecksEvent(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)},"setChecksToDefault":function($event){return _vm.player.handleSetChecksToDefaultEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setChecksBasedOnUserDefinedFilter":function($event){return _vm.player.handleSetChecksBasedOnUserDefinedFilterEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"fiveCardHandMouseover":function($event){return _vm.handleFiveCardHandMouseover(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex, $event)},"fiveCardHandMouseleave":function($event){return _vm.handleFiveCardHandMouseleave(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)}}},[(_vm.simulateButton)?_c('section',{staticClass:"panel-footer",attrs:{"slot":"simulate-button"},slot:"simulate-button"},[_c('simulate-button',{on:{"simulate":function($event){return _vm.$emit('simulate')}}})],1):_vm._e(),_vm._v(" "),_c('five-card-hands-section-alerts',{attrs:{"slot":"alerts","textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"areFiveCardHandPercentagesUpToDate":_vm.player.states[_vm.playerStateIndex].areFiveCardHandPercentagesUpToDate(_vm.player, _vm.presetCommunityCards, _vm.presetHoleCards)},slot:"alerts"}),_vm._v(" "),_vm._t("insights",null,{"slot":"insights"})],2):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EbCy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EbGa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ed9P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EkWo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_constructor_help_vue__ = __webpack_require__("LAeg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d99d0998_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_constructor_help_vue__ = __webpack_require__("YPLg");
function injectStyle (ssrContext) {
  __webpack_require__("e63H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d99d0998"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_constructor_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d99d0998_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_constructor_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Er0k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator-checkboxes-included-settings',
  data: function data() {
    return {
      includedByDefault: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.$store.state.account.user.settings.hitCalculator.includedByDefault),
      isHelpVisible: false
    };
  },
  computed: {
    madeHandLeaves: function madeHandLeaves() {
      var fiveCardHands = new FiveCardHands();

      return fiveCardHands.madeHands.flatArrayOfLeaves;
    },
    drawLeaves: function drawLeaves() {
      var fiveCardHands = new FiveCardHands();

      return fiveCardHands.draws.flatArrayOfLeaves;
    },
    comboLeaves: function comboLeaves() {
      var fiveCardHands = new FiveCardHands();

      return fiveCardHands.combos.flatArrayOfLeaves;
    },
    defaultIncludedByDefault: function defaultIncludedByDefault() {
      var defaultIncludedByDefault = {};

      this.madeHandLeaves.forEach(function (madeHandLeaf) {
        defaultIncludedByDefault[madeHandLeaf.id] = true;
      });
      this.drawLeaves.forEach(function (drawLeaf) {
        defaultIncludedByDefault[drawLeaf.id] = true;
      });
      this.comboLeaves.forEach(function (comboLeaf) {
        defaultIncludedByDefault[comboLeaf.id] = true;
      });

      return defaultIncludedByDefault;
    }
  },
  methods: {
    save: function save() {
      var self = this;
      var user = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.includedByDefault = this.includedByDefault;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    reset: function reset() {
      var self = this;
      var user = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.includedByDefault = this.defaultIncludedByDefault;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        self.madeHandLeaves.forEach(function (madeHandLeaf) {
          self.includedByDefault[madeHandLeaf.id] = true;
        });
        self.drawLeaves.forEach(function (drawLeaf) {
          self.includedByDefault[drawLeaf.id] = true;
        });
        self.comboLeaves.forEach(function (comboLeaf) {
          self.includedByDefault[comboLeaf.id] = true;
        });
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "EwWu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F3ao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_included_selectors_vue__ = __webpack_require__("Qs3N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae7b1ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_included_selectors_vue__ = __webpack_require__("ycsu");
function injectStyle (ssrContext) {
  __webpack_require__("8tdp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ae7b1ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_included_selectors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ae7b1ea_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_included_selectors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "F4Fq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "F4UU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"save-scenario-button-container",attrs:{"data-title":_vm.tooltipValue,"data-toggle":"tooltip","data-placement":"top"}},[_c('button',{staticClass:"btn btn-default save-scenario-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.handleClick()}}},[_vm._v("\n    "+_vm._s(_vm.text)+" "),_c('span',{staticClass:"glyphicon glyphicon-save"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F7ui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"text-selector"},[_c('div',{staticClass:"input-group"},[_c('input',{ref:"text-input",staticClass:"form-control",attrs:{"type":"text","autocomplete":"false","spellcheck":"false","disabled":_vm.disabled},domProps:{"value":_vm.getTextFromGeneralHands()},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.setRangeToMatchText()}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#text-selector-help-modal","disabled":_vm.disabled}},[_vm._v("\n        ?\n      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"title":"Set range according to text","disabled":_vm.disabled},on:{"click":function($event){return _vm.setRangeToMatchText()}}},[_vm._v("\n        Update\n      ")])])]),_vm._v(" "),_c('help-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F892":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_text_validate__ = __webpack_require__("AFoN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");



/* harmony default export */ __webpack_exports__["a"] = ({
  areCustomHandRankingsValid: function areCustomHandRankingsValid(customHandRankingsString) {
    customHandRankingsString = customHandRankingsString.toLowerCase();
    customHandRankingsString = customHandRankingsString.replace(/, /g, ',');

    var customHandRankingsArray = customHandRankingsString.split(',');

    if (customHandRankingsArray.length !== 169) {
      return false;
    }

    if (__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(customHandRankingsArray)) {
      return false;
    }

    for (var i = 0; i < 169; i++) {
      if (__WEBPACK_IMPORTED_MODULE_0__services_text_validate__["a" /* default */].__isHandValid(customHandRankingsArray[i]) === false) {
        return false;
      }
    }

    return true;
  },
  areTiersValid: function areTiersValid(tiersHandsInRangeArray) {
    for (var i = 0; i < tiersHandsInRangeArray.length; i++) {
      if (tiersHandsInRangeArray[i].length === 0) {
        return false;
      }
    }

    return true;
  },
  areSavedRangesValid: function areSavedRangesValid(savedRangesArr) {
    var isValid = true;

    __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].general.forEachNode(savedRangesArr, function (node) {
      if (!node.name) {
        isValid = false;
      }
    });

    __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].general.forEachLeaf(savedRangesArr, function (leaf) {
      if (leaf.handsInRange.length === 0) {
        isValid = false;
      }
    });

    return isValid;
  }
});

/***/ }),

/***/ "F9KK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"short-deck-random-board-selector",class:_vm.popoverDirectionClass,attrs:{"disabled":_vm.disabled}},[_c('button',{staticClass:"btn btn-default dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","disabled":_vm.disabled}},[_vm._v("\n    Random\n    "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('li',{on:{"click":function($event){return _vm.setRandomFlop()}}},[_vm._v("Random flop: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomTurn()}}},[_vm._v("Random turn: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.setRandomRiver()}}},[_vm._v("Random river: "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}}),_vm._v(" "),_c('img',{attrs:{"height":"32"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FBk2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FGQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__ = __webpack_require__("Ywgb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-home',
  components: {
    'errors-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__["a" /* default */]
  },
  data: function data() {
    return {
      errorsFromBackend: [],
      questions: [{
        selection: null,
        answer: 3
      }, {
        selection: null,
        answer: 1
      }, {
        selection: null,
        answer: 3
      }, {
        selection: null,
        answer: 0
      }, {
        selection: null,
        answer: 2
      }, {
        selection: null,
        answer: 0
      }, {
        selection: null,
        answer: 0
      }, {
        selection: null,
        answer: 1
      }]
    };
  },
  computed: {
    currentScoreText: function currentScoreText() {
      if (this.totalAnswers < this.questions.length) {
        return 'You\'re ' + this.correctAnswers + ' for ' + this.totalAnswers + ' so far.';
      }

      return 'You finished ' + this.correctAnswers + ' for ' + this.totalAnswers + '.';
    },
    correctAnswers: function correctAnswers() {
      var correctAnswers = 0;

      this.questions.forEach(function (question) {
        if (question.selection === question.answer) {
          correctAnswers++;
        }
      });

      return correctAnswers;
    },
    totalAnswers: function totalAnswers() {
      var totalAnswers = 0;

      this.questions.forEach(function (question) {
        if (question.selection !== null) {
          totalAnswers++;
        }
      });

      return totalAnswers;
    }
  },
  created: function created() {
    if (this.$route.query.error) {
      this.updateErrorsAlert();
    }
  },
  watch: {
    '$route': function $route(to, from) {
      if (this.$route.query.error) {
        this.updateErrorsAlert();
      }
    }
  },
  methods: {
    submitAnswer: function submitAnswer(question, answer) {
      if (question.selection !== null) {
        return; // only get one shot at answering
      }

      question.selection = answer;
    },
    clearAlert: function clearAlert() {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
      this.$router.replace('/');
    },
    updateErrorsAlert: function updateErrorsAlert() {
      if (this.$route.query.error === 'requires-basic-auth') {
        this.errorsFromBackend.push('This requires you to have purchased at least the basic version of the app, or be on your free trial.');
      } else if (this.$route.query.error === 'requires-premium-auth') {
        this.errorsFromBackend.push('This requires you to have purchased the premium version of the app, or be on your free trial.');
      } else if (this.$route.query.error === 'already-paid') {
        this.errorsFromBackend.push('You have already purchased the app.');
      } else if (this.$route.query.error === 'iff-basic-auth') {
        this.errorsFromBackend.push('This page is only accessible to those who purchased the basic version of the app and haven\'t upgraded to premium.');
      }
    }
  }
});

/***/ }),

/***/ "FIkw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_pricing_table__ = __webpack_require__("89NH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tweet_embed__ = __webpack_require__("2Fkr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_tweet_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_tweet_embed__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-faq',
  components: {
    'pricing-table': __WEBPACK_IMPORTED_MODULE_0__components_utilities_pricing_table__["a" /* default */],
    'tweet': __WEBPACK_IMPORTED_MODULE_1_vue_tweet_embed__["Tweet"]
  },
  data: function data() {
    return {
      hoursPerMonth: 10,
      bigBlind: 2,
      bigBlindsPerHour: 1
    };
  },
  computed: {
    extraWinningsPerMonth: function extraWinningsPerMonth() {
      var bigBlindsPerMonth = this.bigBlindsPerHour * this.hoursPerMonth;

      return (this.bigBlind * bigBlindsPerMonth).roundToTwoDecimalPlaces();
    }
  }
});

/***/ }),

/***/ "FQBA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_constants__ = __webpack_require__("vjYN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'combos-to-add-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */]
  },
  props: ['combosToAdd'],
  data: function data() {
    return {
      suitsGrid: [['cc', 'cs', 'ch', 'cd'], ['sc', 'ss', 'sh', 'sd'], ['hc', 'hs', 'hh', 'hd'], ['dc', 'ds', 'dh', 'dd']]
    };
  },
  methods: {
    getHTMLForSuitIcons: function getHTMLForSuitIcons(suits) {
      return __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].general.getHTMLForSuitIcons(suits);
    },
    isComboInCombosToAdd: function isComboInCombosToAdd(combo) {
      return this.combosToAdd.includes(combo);
    },
    toggleCombo: function toggleCombo(combo) {
      if (this.isComboInCombosToAdd(combo)) {
        this.$emit('removeComboFromCombosToAdd', combo);
      } else {
        this.$emit('addComboToCombosToAdd', combo);
      }
    },
    selectAll: function selectAll() {
      this.clear();
      __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].combos.forEach(function (combo) {
        this.$emit('addComboToCombosToAdd', combo);
      }, this);
    },
    clear: function clear() {
      __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].combos.forEach(function (combo) {
        this.$emit('removeComboFromCombosToAdd', combo);
      }, this);
    }
  }
});

/***/ }),

/***/ "Fj+R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FmIh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_icon_vue__ = __webpack_require__("hZMi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0cd902_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_icon_vue__ = __webpack_require__("Bmu5");
function injectStyle (ssrContext) {
  __webpack_require__("bHtG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c0cd902"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c0cd902_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Fwnt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_pricing_vue__ = __webpack_require__("CEnT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b678bb5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_pricing_vue__ = __webpack_require__("mi9E");
function injectStyle (ssrContext) {
  __webpack_require__("pOqy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b678bb5a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_pricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b678bb5a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_pricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G1lD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_selector_vue__ = __webpack_require__("3se9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05131776_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_selector_vue__ = __webpack_require__("rDiH");
function injectStyle (ssrContext) {
  __webpack_require__("0XZA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05131776"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05131776_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GLQb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GMrd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well should-you-bluff-long-run-disclaimer"},[_c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("The long run")])]),_vm._v(" "),_c('p',[_vm._v("Even after factoring in what might happen on future streets, there are still longer run game dynamic type things to consider, such as:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Bluffing to gather information about your opponent.")]),_vm._v(" "),_c('li',[_vm._v("Bluffing to establish a certain table image.")]),_vm._v(" "),_c('li',[_vm._v("Bluffing to put your opponent on tilt.")])]),_vm._v(" "),_c('p',[_vm._v("Maybe the bluff is profitable in the long run for one of the reasons listed above, even if it isn't profitable right now.")]),_vm._v(" "),_c('p',[_vm._v("Factoring in these sorts of things is beyond the scope of Six Plus Hold’em right now, but perhaps there will be tools to do so in the future.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GNZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'three-bet-cbet-explorer-help'
});

/***/ }),

/***/ "GjlZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_cell_vue__ = __webpack_require__("xaqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_325eed96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_cell_vue__ = __webpack_require__("6vFa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_cell_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_325eed96_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_cell_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Go0A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{class:{
    'text-success': _vm.profitable === true,
    'text-danger': _vm.profitable === false
  }},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GqVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_help_vue__ = __webpack_require__("rwHF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaed8c82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breakeven_percentage_for_bluffing_the_turn_help_vue__ = __webpack_require__("oIc1");
function injectStyle (ssrContext) {
  __webpack_require__("kpFp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aaed8c82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaed8c82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breakeven_percentage_for_bluffing_the_turn_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "H+hc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/6w":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grid-square-weight-bar',
  props: ['weight', 'shortDeck'],
  computed: {
    width: function width() {
      if (!this.shortDeck) {
        return 25 * (this.weight / 100);
      }

      return this.weight * (30 / 100);
    }
  }
});

/***/ }),

/***/ "H1q8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"double-slider-selector"},[_c('vue-slider',_vm._b({ref:"slider",attrs:{"disabled":_vm.disabled},on:{"callback":function($event){return _vm.setRangeToMatchDoubleSlider($event)}},scopedSlots:_vm._u([{key:"label",fn:function(ref){
var label = ref.label;
return (label % 10 === 0)?_c('div',{staticClass:"diy-tooltip"},[_vm._v("\n      "+_vm._s(label)+"\n    ")]):_vm._e()}}],null,true),model:{value:(_vm.percentiles),callback:function ($$v) {_vm.percentiles=$$v},expression:"percentiles"}},'vue-slider',_vm.sliderOptions,false)),_vm._v(" "),_c('span',{staticClass:"badge percent-of-hands-in-range",attrs:{"data-toggle":"tooltip","title":"Percent of hands in range","data-placement":"top"}},[_vm._v("\n    "+_vm._s(_vm.percentOfHandsInRangeNumberForDisplay)+"%\n  ")]),_vm._v(" "),_c('span',{staticClass:"badge number-of-combos-in-range",attrs:{"data-toggle":"tooltip","title":"Number of combos in range","data-placement":"top"}},[_vm._v("\n    "+_vm._s(_vm.numberOfSpecificHandsInRange)+"/"+_vm._s(_vm.numberOfPossibleSpecificHands)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H9xH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_selector_vue__ = __webpack_require__("qjMD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42597c0d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_category_selector_vue__ = __webpack_require__("QTl4");
function injectStyle (ssrContext) {
  __webpack_require__("sXJ1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42597c0d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_category_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42597c0d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_category_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HDsU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ppt-purchase"},[_vm._m(0),_vm._v(" "),_c('errors-alert',{attrs:{"errors":_vm.errorsFromBackend},on:{"clear":function($event){return _vm.clearAlert()}}}),_vm._v(" "),_c('section',{staticClass:"alert alert-info"},[(_vm.daysLeftOnFreeTrial > 0)?_c('section',[_c('p',[_vm._v("You have "),_c('strong',[_vm._v(_vm._s(_vm.daysLeftOnFreeTrial)+" days left")]),_vm._v(" on your 14 day free trial. You can certainly wait for your free trial to end before purchasing, but if you'd like to purchase now, fill out and submit the form below.")])]):_c('section',[_c('p',[_vm._v("Your 14 day free trial has ended. Purchase either the basic or the premium version to continue using Six Plus Hold’em.")])]),_vm._v(" "),_c('p',[_vm._v("Note: If you purchase the basic version and later want to upgrade to the premium version, you'll only have to pay the $50 difference, not the full $75.")]),_vm._v(" "),_c('p',[_vm._v("Any questions? Check out the "),_c('router-link',{attrs:{"to":"/faq"}},[_vm._v("FAQ")]),_vm._v(", or "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("get in touch")]),_vm._v(".")],1)]),_vm._v(" "),(!_vm.purchasedShortDeck)?_c('section',{staticClass:"alert alert-info"},[_vm._v("\n    Interested in short deck? Head over to the "),_c('router-link',{attrs:{"to":"/purchase-short-deck"}},[_vm._v("short deck purchase page")]),_vm._v(".\n  ")],1):_vm._e(),_vm._v(" "),_c('pricing-table'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('label',[_vm._v("Version")]),_vm._v(" "),_c('section',{staticClass:"btn-group btn-group-lg btn-group-justified"},[_c('a',{staticClass:"btn btn-default",class:{ active: _vm.version === 'basic' },attrs:{"disabled":_vm.purchasing},on:{"click":function($event){_vm.version = 'basic'}}},[_vm._v("\n      Basic ($25)\n    ")]),_vm._v(" "),_c('a',{staticClass:"btn btn-default",class:{ active: _vm.version === 'premium' },attrs:{"disabled":_vm.purchasing},on:{"click":function($event){_vm.version = 'premium'}}},[_vm._v("\n      Premium ($75)\n    ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      Credit card number\n      "),_c('card-number',{ref:"cardNumber",staticClass:"stripe-element card-number form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.number = $event.complete}}})],1)]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      Expiration date\n      "),_c('card-expiry',{ref:"cardExpiry",staticClass:"stripe-element card-expiry form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.expiry = $event.complete}}})],1)]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      CVC\n      "),_c('card-cvc',{ref:"cardCvc",staticClass:"stripe-element card-cvc form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.cvc = $event.complete}}})],1)]),_vm._v(" "),_c('button',{staticClass:"pay-with-stripe btn btn-primary btn-block btn-lg",attrs:{"disabled":!_vm.complete || _vm.purchasing},on:{"click":function($event){return _vm.purchase()}}},[_vm._v("\n    "+_vm._s(_vm.purchaseText)+"\n  ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Purchase")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HUDt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HYoF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row short-deck-range-for-street"},[_c('section',{staticClass:"col-lg-6"},[_c('short-deck-hand-range',{ref:'player-' + _vm.playerIndex + '-' + _vm.playerStateIndex,attrs:{"generalHands":_vm.player.states[_vm.playerStateIndex].generalHands,"weightToApplyToAddedHands":_vm.player.weightToApplyToAddedHands,"combosToAdd":_vm.player.combosToAdd,"disableAllSelectors":_vm.disableAllSelectors,"disableAllButGridSelector":_vm.playerStateIndex > 0,"canBeRemoved":false},on:{"clearRange":function($event){return _vm.player.handleClearPlayerEvent(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)},"addComboToCombosToAdd":function($event){return _vm.player.handleAddComboToCombosToAddEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex)},"removeComboFromCombosToAdd":function($event){return _vm.player.handleRemoveComboFromCombosToAddEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex)},"applyExactWeightToGeneralHands":function($event){return _vm.player.handleApplyExactWeightToGeneralHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"selectGeneralHand":function($event){return _vm.player.handleSelectGeneralHandEvent(_vm.storeModuleName, _vm.$store, $event.generalHandString, $event.triggeredByMouseover, _vm.playerIndex, _vm.playerStateIndex)},"deselectGeneralHand":function($event){return _vm.player.handleDeselectGeneralHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"selectGeneralHands":function($event){return _vm.player.handleSelectGeneralHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"deselectGeneralHands":function($event){return _vm.player.handleDeselectGeneralHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"selectSpecificHand":function($event){return _vm.player.handleSelectSpecificHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"deselectSpecificHand":function($event){return _vm.player.handleDeselectSpecificHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setRangeToMatchGeneralHands":function($event){return _vm.player.handleSetRangeToMatchGeneralHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setRangeToMatchDoubleSlider":function($event){return _vm.player.handleSetRangeToMatchDoubleSliderEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex, _vm.handRankings)},"setRangeToMatchSpecificHandStrings":function($event){return _vm.player.handleSetRangeToMatchSpecificHandStringsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setSpecificHandAsManuallySet":function($event){return _vm.player.handleSetSpecificHandAsManuallySetEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setSpecificHandAsNotManuallySet":function($event){return _vm.player.handleSetSpecificHandAsNotManuallySetEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"applyExactWeightToGeneralHand":function($event){return _vm.player.handleApplyExactWeightToGeneralHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setWeightOfSpecificHand":function($event){return _vm.player.handleSetWeightOfSpecificHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setWeightToApplyToAddedHands":function($event){return _vm.player.handleSetWeightToApplyToAddedHandsEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"finishedClickAndDrag":function($event){return _vm.player.handleFinishedClickAndDrag(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)}}},[_vm._t("left-header",null,{"slot":"left-header"}),_vm._v(" "),(_vm.storeModuleName === 'guidedAnalysesCalling' && _vm.playerStateIndex > 0)?_c('value-to-bluff-ratio',{attrs:{"slot":"left-header","generalHands":_vm.player.states[_vm.playerStateIndex].generalHands,"communityCards":_vm.presetCommunityCards.getArrayForState(_vm.player.states[_vm.playerStateIndex].name)},slot:"left-header"}):_vm._e()],2)],1),_vm._v(" "),_c('section',{staticClass:"col-lg-6"},[(_vm.playerStateIndex > 0)?_c('five-card-hands-section',{attrs:{"playerState":_vm.player.states[_vm.playerStateIndex],"hitPercentageUpToDate":_vm.player.states[_vm.playerStateIndex].isHitPercentageUpToDate(_vm.player, _vm.presetCommunityCards, _vm.presetHoleCards),"showPercentagesOrCombos":true,"shortDeck":true,"authorized":_vm.authorized},on:{"setCheckedValueOfFiveCardHand":function($event){return _vm.player.handleSetCheckedValueOfFiveCardHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"applyExactWeightToFiveCardHand":function($event){return _vm.player.handleApplyExactWeightToFiveCardHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"toggleCollapsedValueOfFiveCardHandParent":function($event){return _vm.player.handleToggleCollapsedValueOfFiveCardHandParentEvent(_vm.storeModuleName, _vm.$store, $event)},"updateWeightOfFiveCardHand":function($event){return _vm.player.handleUpdateWeightOfFiveCardHandEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"clearAllChecks":function($event){return _vm.player.handleClearAllChecksEvent(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)},"selectAllChecks":function($event){return _vm.player.handleSelectAllChecksEvent(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)},"setChecksToDefault":function($event){return _vm.player.handleSetChecksToDefaultEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"setChecksBasedOnUserDefinedFilter":function($event){return _vm.player.handleSetChecksBasedOnUserDefinedFilterEvent(_vm.storeModuleName, _vm.$store, $event, _vm.playerIndex, _vm.playerStateIndex)},"fiveCardHandMouseover":function($event){return _vm.handleFiveCardHandMouseover(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex, $event)},"fiveCardHandMouseleave":function($event){return _vm.handleFiveCardHandMouseleave(_vm.storeModuleName, _vm.$store, _vm.playerIndex, _vm.playerStateIndex)}}},[(_vm.simulateButton)?_c('section',{staticClass:"panel-footer",attrs:{"slot":"simulate-button"},slot:"simulate-button"},[_c('simulate-button',{on:{"simulate":function($event){return _vm.$emit('simulate')}}})],1):_vm._e(),_vm._v(" "),_c('five-card-hands-section-alerts',{attrs:{"slot":"alerts","textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"areFiveCardHandPercentagesUpToDate":_vm.player.states[_vm.playerStateIndex].areFiveCardHandPercentagesUpToDate(_vm.player, _vm.presetCommunityCards, _vm.presetHoleCards)},slot:"alerts"}),_vm._v(" "),_vm._t("insights",null,{"slot":"insights"})],2):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HdM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  getFlopTone: function getFlopTone(flopCards) {
    var firstSuit = flopCards[0][1];
    var secondSuit = flopCards[1][1];
    var thirdSuit = flopCards[2][1];
    var suits = [firstSuit, secondSuit, thirdSuit];
    var uniqueSuits = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(suits);

    if (uniqueSuits.length === 1) {
      return 'monotone';
    } else if (uniqueSuits.length === 2) {
      return 'twoToned';
    } else if (uniqueSuits.length === 3) {
      return 'rainbow';
    } else {
      throw new Error('Invalid flop tone.');
    }
  },
  getFlopTexture: function getFlopTexture(flopCards) {
    var flopCardRanks = [flopCards[0][0], flopCards[1][0], flopCards[2][0]];

    if (this._checkIfBingo(flopCardRanks)) {
      return 'bingo';
    } else if (this._checkIfPaired(flopCardRanks)) {
      return 'paired';
    } else if (this._checkIfTripleBroadway(flopCardRanks)) {
      return 'tripleBroadway';
    } else if (this._checkIfDoubleBroadway(flopCardRanks)) {
      return 'doubleBroadway';
    } else if (this._checkIfSingleBroadway(flopCardRanks)) {
      return 'singleBroadway';
    } else if (this._checkIfCoorddinatedMiddle(flopCardRanks)) {
      return 'coordinatedMiddle';
    } else if (this._checkIfCoordinatedSmall(flopCardRanks)) {
      return 'coordinatedSmall';
    } else if (this._checkIfRaggedy(flopCardRanks)) {
      return 'raggedy';
    } else {
      return 'other';
    }
  },
  _checkIfBingo: function _checkIfBingo(flopCardRanks) {
    var uniqueRanks = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(flopCardRanks);

    if (uniqueRanks.length === 1) {
      return true;
    }
    return false;
  },
  _checkIfPaired: function _checkIfPaired(flopCardRanks) {
    var uniqueRanks = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.uniq(flopCardRanks);

    if (uniqueRanks.length === 2) {
      return true;
    }
    return false;
  },
  __getNumBroadwayCards: function __getNumBroadwayCards(flopCardRanks) {
    var numBroadwayCards = 0;

    flopCardRanks.forEach(function (flopCardRank) {
      if (__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].broadwayRanks.includes(flopCardRank)) {
        numBroadwayCards++;
      }
    });

    return numBroadwayCards;
  },
  _checkIfTripleBroadway: function _checkIfTripleBroadway(flopCardRanks) {
    var numBroadwayCards = this.__getNumBroadwayCards(flopCardRanks);

    if (numBroadwayCards === 3) {
      return true;
    }
    return false;
  },
  _checkIfDoubleBroadway: function _checkIfDoubleBroadway(flopCardRanks) {
    var numBroadwayCards = this.__getNumBroadwayCards(flopCardRanks);

    if (numBroadwayCards === 2) {
      return true;
    }
    return false;
  },
  _checkIfSingleBroadway: function _checkIfSingleBroadway(flopCardRanks) {
    var numBroadwayCards = this.__getNumBroadwayCards(flopCardRanks);

    if (numBroadwayCards === 1) {
      return true;
    }
    return false;
  },
  _checkIfCoorddinatedMiddle: function _checkIfCoorddinatedMiddle(flopCardRanks) {
    flopCardRanks.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction);

    if (__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].coordinatedMiddleFlopRanks.includes(flopCardRanks.join(''))) {
      return true;
    }
    return false;
  },
  _checkIfCoordinatedSmall: function _checkIfCoordinatedSmall(flopCardRanks) {
    flopCardRanks.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction);

    if (__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].coordinatedSmallFlopRanks.includes(flopCardRanks.join(''))) {
      return true;
    }
    return false;
  },
  _checkIfRaggedy: function _checkIfRaggedy(flopCardRanks) {
    var spaceBetweenRanks = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getSpaceBetweenRanks(flopCardRanks);

    if (spaceBetweenRanks > 4) {
      return true;
    }
    return false;
  },
  getSampleTexture: function getSampleTexture(textureType) {
    if (textureType === 'triple broadway') {
      return this._getSampleTripleBroadwayTexture();
    } else if (textureType === 'double broadway') {
      return this._getSampleDoubleBroadwayTexture();
    } else if (textureType === 'single broadway') {
      return this._getSampleSingleBroadwayTexture();
    } else if (textureType === 'paired') {
      return this._getSamplePairedTexture();
    } else if (textureType === 'raggedy') {
      return this._getSampleRaggedyTexture();
    } else if (textureType === 'coordinated middle') {
      return this._getSampleCoordinatedMiddleTexture();
    } else if (textureType === 'coordinated small') {
      return this._getSampleCoordinatedSmallTexture();
    } else if (textureType === 'bingo') {
      return this._getSampleBingoTexture();
    } else {
      throw new Error('Invalid value of textureType.');
    }
  },
  _getSampleTripleBroadwayTexture: function _getSampleTripleBroadwayTexture() {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(['akq', 'akj', 'akt', 'aqj', 'aqt', 'ajt', 'kqj', 'kqt', 'kjt', 'qjt']);
  },
  _getSampleDoubleBroadwayTexture: function _getSampleDoubleBroadwayTexture() {
    var firstTwoRanks = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(['ak', 'aq', 'aj', 'at', 'kq', 'kj', 'kt', 'qj', 'qt', 'jt']);
    var thirdRank = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].nonBroadwayRanks);
    return firstTwoRanks + thirdRank;
  },
  _getSampleSingleBroadwayTexture: function _getSampleSingleBroadwayTexture() {
    var firstRank = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].broadwayRanks);
    var secondTwoRanks = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sampleSize(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].nonBroadwayRanks, 2);
    return firstRank + secondTwoRanks[0] + secondTwoRanks[1];
  },
  _getSamplePairedTexture: function _getSamplePairedTexture() {
    var twoRanks = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sampleSize(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].ranks, 2);
    return twoRanks[0] + twoRanks[0] + twoRanks[1];
  },
  _getSampleRaggedyTexture: function _getSampleRaggedyTexture() {
    var threeRanks = void 0;
    var rankOneIndex = void 0;
    var rankTwoIndex = void 0;
    var rankThreeIndex = void 0;
    var spaceBetweenRanks = void 0;

    while (true) {
      threeRanks = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sampleSize(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].nonBroadwayRanks, 3);
      spaceBetweenRanks = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getSpaceBetweenRanks(threeRanks);

      if (spaceBetweenRanks > 4) {
        threeRanks.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction);
        return threeRanks[0] + threeRanks[1] + threeRanks[2];
      } else {
        // take another sample
      }
    }
  },
  _getSampleCoordinatedMiddleTexture: function _getSampleCoordinatedMiddleTexture() {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].coordinatedMiddleFlopRanks);
  },
  _getSampleCoordinatedSmallTexture: function _getSampleCoordinatedSmallTexture() {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].coordinatedSmallFlopRanks);
  },
  _getSampleBingoTexture: function _getSampleBingoTexture() {
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].bingoFlopRanks);
  },
  getSampleTone: function getSampleTone(toneType) {
    if (toneType === 'rainbow') {
      return this._getSampleRainbowTone();
    } else if (toneType === 'two-toned') {
      return this._getSampleTwoTonedTone();
    } else if (toneType === 'monotone') {
      return this._getSampleMonotoneTone();
    } else {
      throw new Error('Invalid tone type.');
    }
  },
  _getSampleRainbowTone: function _getSampleRainbowTone() {
    var suits = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sampleSize(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].suits, 3);
    return suits[0] + suits[1] + suits[2];
  },
  _getSampleTwoTonedTone: function _getSampleTwoTonedTone() {
    var suits = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sampleSize(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].suits, 2);
    return suits[0] + suits[1] + suits[1];
  },
  _getSampleMonotoneTone: function _getSampleMonotoneTone() {
    var suit = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.sample(__WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].suits);
    return suit + suit + suit;
  }
});

/***/ }),

/***/ "Hjmd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Hmvt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faq_vue__ = __webpack_require__("FIkw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ff79ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__ = __webpack_require__("Ds5C");
function injectStyle (ssrContext) {
  __webpack_require__("wKtO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34ff79ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34ff79ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HnmA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_flop_info_helpers__ = __webpack_require__("HdM6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_constants__ = __webpack_require__("vjYN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'random-board-selector',
  props: ['presetHoleCards', 'popoverDirectionClass', 'disabled', 'disableTurnAndRiver'],
  methods: {
    setRandomFlop: function setRandomFlop() {
      var boardCards = void 0;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);

        if (!this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) && !__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(boardCards)) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    setRandomTurn: function setRandomTurn() {
      var boardCards = void 0;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
        boardCards.push(this._getRandomCard());

        if (!this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) && !__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(boardCards)) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    setRandomRiver: function setRandomRiver() {
      var boardCards = void 0;

      while (true) {
        boardCards = [];
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());
        boardCards.sort(__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);
        boardCards.push(this._getRandomCard());
        boardCards.push(this._getRandomCard());

        if (!this._checkIfTryingToUseAPresetHoleCard(boardCards, this.presetHoleCards) && !__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(boardCards)) {
          break;
        }
      }

      this.$emit('setBoard', boardCards);
    },
    _getRandomCard: function _getRandomCard() {
      var rank = __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].ranks[_.random(0, 12)];
      var suit = __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].suits[_.random(0, 3)];

      return rank + suit;
    },
    setRandomFlopAccordingToTexture: function setRandomFlopAccordingToTexture(textureType, toneType) {
      var texture = void 0;
      var tone = void 0;
      var flopCards = void 0;

      while (true) {
        texture = __WEBPACK_IMPORTED_MODULE_1__services_flop_info_helpers__["a" /* default */].getSampleTexture(textureType);
        tone = __WEBPACK_IMPORTED_MODULE_1__services_flop_info_helpers__["a" /* default */].getSampleTone(toneType);
        flopCards = [texture[0] + tone[0], texture[1] + tone[1], texture[2] + tone[2]];

        if (!this._checkIfTryingToUseAPresetHoleCard(flopCards, this.presetHoleCards) && !__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(flopCards)) {
          break;
        }
      }

      this.$emit('setBoard', flopCards);
    },
    _checkIfTryingToUseAPresetHoleCard: function _checkIfTryingToUseAPresetHoleCard(boardCards, presetHoleCards) {
      var tryingToUseAPresetHoleCard = false;

      boardCards.forEach(function (flopCard) {
        if (presetHoleCards.includes(flopCard)) {
          tryingToUseAPresetHoleCard = true;
        }
      });

      return tryingToUseAPresetHoleCard;
    }
  }
});

/***/ }),

/***/ "HoqA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__ = __webpack_require__("oox5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-turn-selector',
  components: {
    'short-deck-individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__["a" /* default */]
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'turn') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function _toggleNextDropdown(previousPosition) {
      var nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function __getNextPosition(previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else if (previousPosition === 'flop3') {
        return 'turn';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    }
  }
});

/***/ }),

/***/ "I4Dr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"hand-range-header panel-heading"},[_vm._t("left-header"),_vm._v(" "),(_vm.canBeRemoved)?_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('removePlayer')}}},[_vm._v("×")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"dropdown"},[_c('button',{staticClass:"btn btn-default dropdown-toggle",attrs:{"data-toggle":"dropdown","disabled":_vm.disabled}},[_c('span',{staticClass:"glyphicon glyphicon-menu-hamburger"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[(_vm.generalHands.numberOfSpecificHandsInRange > 0)?_c('li',[_c('a',{on:{"click":function($event){return _vm.expandSetHandWeightsModal()}}},[_vm._v("Set hand weights "),_c('span',{staticClass:"glyphicon glyphicon-new-window"})])]):_vm._e(),_vm._v(" "),(_vm.settingHandWeightsSetting === 'setWeightToApplyToAddedHandsModal')?_c('li',[_c('a',{on:{"click":function($event){return _vm.expandSetWeightToApplyToAddedHandsModal()}}},[_vm._v("Set weight to apply to added hands "),_c('span',{staticClass:"glyphicon glyphicon-new-window"})])]):_vm._e(),_vm._v(" "),(!_vm.specificHandsNotAllowed)?_c('li',[_c('a',{on:{"click":function($event){return _vm.expandCombosToAddModal()}}},[_vm._v("Select specific suits "),_c('span',{staticClass:"glyphicon glyphicon-new-window"})])]):_vm._e(),_vm._v(" "),_vm._t("extra-dropdown-item-1")],2)]),_vm._v(" "),_c('button',{staticClass:"clear btn btn-default",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('clearRange')}}},[_vm._v("\n    Clear\n  ")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.combosToAdd.length < 16),expression:"combosToAdd.length < 16"}],staticClass:"glyphicon glyphicon-info-sign",attrs:{"tabindex":"0","data-toggle":"popover","data-content":_vm.combosToAddInfoText,"data-placement":"bottom","role":"button","data-trigger":"focus"}}),_vm._v(" "),_c('set-hand-weights-modal',{staticClass:"set-hand-weights-modal",attrs:{"playerStateGeneralHands":_vm.generalHands},on:{"applyExactWeightToGeneralHands":function($event){return _vm.$emit('applyExactWeightToGeneralHands', $event)}}}),_vm._v(" "),_c('set-weight-to-apply-to-added-hands-modal',{staticClass:"set-weight-to-apply-to-added-hands-modal",attrs:{"weightToApplyToAddedHands":_vm.weightToApplyToAddedHands},on:{"setWeightToApplyToAddedHands":function($event){return _vm.$emit('setWeightToApplyToAddedHands', $event)}}}),_vm._v(" "),_c('combos-to-add-modal',{staticClass:"combos-to-add-modal",attrs:{"combosToAdd":_vm.combosToAdd},on:{"addComboToCombosToAdd":function($event){return _vm.$emit('addComboToCombosToAdd', $event)},"removeComboFromCombosToAdd":function($event){return _vm.$emit('removeComboFromCombosToAdd', $event)}}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "I523":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_for_street_vue__ = __webpack_require__("noRI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1481f29d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_for_street_vue__ = __webpack_require__("EZ1g");
function injectStyle (ssrContext) {
  __webpack_require__("QxzY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1481f29d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_for_street_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1481f29d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_for_street_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I7Vb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"short-deck-purchase"},[_vm._m(0),_vm._v(" "),_c('errors-alert',{attrs:{"errors":_vm.errorsFromBackend},on:{"clear":function($event){return _vm.clearAlert()}}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/pages/short-deck-hit-calculator.png"}}),_vm._v(" "),_c('section',{staticClass:"alert alert-info"},[(_vm.daysLeftOnFreeTrial > 0)?_c('section',[_c('p',[_vm._v("You have "),_c('strong',[_vm._v(_vm._s(_vm.daysLeftOnFreeTrial)+" days left")]),_vm._v(" on your 14 day free trial. You can certainly wait for your free trial to end before purchasing, but if you'd like to purchase now, fill out and submit the form below.")])]):_vm._e(),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      Credit card number\n      "),_c('card-number',{ref:"cardNumber",staticClass:"stripe-element card-number form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.number = $event.complete}}})],1)]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      Expiration date\n      "),_c('card-expiry',{ref:"cardExpiry",staticClass:"stripe-element card-expiry form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.expiry = $event.complete}}})],1)]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      CVC\n      "),_c('card-cvc',{ref:"cardCvc",staticClass:"stripe-element card-cvc form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.cvc = $event.complete}}})],1)]),_vm._v(" "),_c('button',{staticClass:"pay-with-stripe btn btn-primary btn-block btn-lg",attrs:{"disabled":!_vm.complete || _vm.purchasing},on:{"click":function($event){return _vm.purchase()}}},[_vm._v("\n    "+_vm._s(_vm.purchaseText)+"\n  ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Purchase Short Deck Hit Calculator")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Any questions? Don't hesitate to reach out: "),_c('a',{attrs:{"href":"mailto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IJ53":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IPbg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_player_Player__ = __webpack_require__("YxBc");




var Players = function () {
  function Players() {
    var numPlayers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Players);

    this._players = [];

    for (var i = 0; i < numPlayers; i++) {
      this.add();
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Players, [{
    key: 'add',
    value: function add() {
      this._players.push(new __WEBPACK_IMPORTED_MODULE_2__services_player_Player__["a" /* default */]());
    }
  }, {
    key: 'remove',
    value: function remove(index) {
      this._players.splice(index, 1);
    }
  }, {
    key: 'find',
    value: function find(index) {
      return this._players[index];
    }
  }, {
    key: 'forEach',
    value: function forEach(cb, thisValue) {
      this._players.forEach(function (player, index) {
        cb.call(thisValue, player, index);
      });
    }
  }, {
    key: 'deselectAllSpecificHandsThatUseCardAndSetAsImpossible',


    // hands
    value: function deselectAllSpecificHandsThatUseCardAndSetAsImpossible(card, shortDeck) {
      this._players.forEach(function (player) {
        player.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(card, shortDeck);
      });
    }
  }, {
    key: 'selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange',
    value: function selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(card, presetCommunityCards, presetHoleCards, shortDeck) {
      this.forEach(function (player) {
        player.selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(card, presetCommunityCards, presetHoleCards, shortDeck);
      });
    }
  }, {
    key: 'setWhetherSpecificHandsThatUseCardArePossibleOnInitialState',
    value: function setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(card, presetCommunityCards, presetHoleCards, shortDeck) {
      this.forEach(function (player) {
        player.setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(card, presetCommunityCards, presetHoleCards, shortDeck);
      });
    }
  }, {
    key: 'hasEmptyRange',
    value: function hasEmptyRange(street) {
      var hasEmptyRange = false;

      this.forEach(function (player) {
        if (player.hasEmptyRange(street)) {
          hasEmptyRange = true;
        }
      });

      return hasEmptyRange;
    }
  }, {
    key: 'setFiveCardHandValuesToDefaults',


    // results
    value: function setFiveCardHandValuesToDefaults(presetCommunityCards, opponentTightness, settings) {
      this.forEach(function (player) {
        player.setFiveCardHandValuesToDefaults(presetCommunityCards, opponentTightness, settings);
      });
    }
  }, {
    key: 'setLastSimulationInfo',


    // simulation
    value: function setLastSimulationInfo(presetCommunityCards, presetHoleCards, playerStateIndex) {
      this.forEach(function (player) {
        player.setLastSimulationInfo(presetCommunityCards, presetHoleCards, playerStateIndex);
      });
    }
  }, {
    key: 'adjustForShortDeck',


    // short deck
    value: function adjustForShortDeck() {
      this.forEach(function (player) {
        player.adjustForShortDeck();
      });
    }
  }, {
    key: 'last',
    get: function get() {
      return this._players[this._players.length - 1];
    }
  }, {
    key: 'numPlayers',
    get: function get() {
      return this._players.length;
    }
  }]);

  return Players;
}();

/* harmony default export */ __webpack_exports__["a"] = (Players);
;

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_account_account__ = __webpack_require__("TmOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_modules_hit_calculator_hit_calculator__ = __webpack_require__("3Vhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_modules_equity_calculator_equity_calculator__ = __webpack_require__("8TW+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_modules_equity_matrix_equity_matrix__ = __webpack_require__("i40l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_range_constructor_range_constructor__ = __webpack_require__("qg5h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_modules_guided_analyses_calling__ = __webpack_require__("Yj1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_modules_guided_analyses_bluffing__ = __webpack_require__("pn0x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_modules_three_bet_cbet_explorer_three_bet_cbet_explorer__ = __webpack_require__("mJM+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_modules_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn__ = __webpack_require__("+1/X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_modules_short_deck_short_deck_equity_calculator__ = __webpack_require__("Ma3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_modules_short_deck_short_deck_hit_calculator__ = __webpack_require__("rBF1");














__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    account: __WEBPACK_IMPORTED_MODULE_2__store_modules_account_account__["a" /* default */],
    hitCalculator: __WEBPACK_IMPORTED_MODULE_3__store_modules_hit_calculator_hit_calculator__["a" /* default */],
    equityCalculator: __WEBPACK_IMPORTED_MODULE_4__store_modules_equity_calculator_equity_calculator__["a" /* default */],
    equityMatrix: __WEBPACK_IMPORTED_MODULE_5__store_modules_equity_matrix_equity_matrix__["a" /* default */],
    rangeConstructor: __WEBPACK_IMPORTED_MODULE_6__store_modules_range_constructor_range_constructor__["a" /* default */],
    guidedAnalysesCalling: __WEBPACK_IMPORTED_MODULE_7__store_modules_guided_analyses_calling__["a" /* default */],
    guidedAnalysesBluffing: __WEBPACK_IMPORTED_MODULE_8__store_modules_guided_analyses_bluffing__["a" /* default */],
    threeBetCbetExplorer: __WEBPACK_IMPORTED_MODULE_9__store_modules_three_bet_cbet_explorer_three_bet_cbet_explorer__["a" /* default */],
    breakevenPercentageForBluffingTheTurn: __WEBPACK_IMPORTED_MODULE_10__store_modules_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn__["a" /* default */],
    shortDeckEquityCalculator: __WEBPACK_IMPORTED_MODULE_11__store_modules_short_deck_short_deck_equity_calculator__["a" /* default */],
    shortDeckHitCalculator: __WEBPACK_IMPORTED_MODULE_12__store_modules_short_deck_short_deck_hit_calculator__["a" /* default */]
  }
}));

/***/ }),

/***/ "Ie6j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IkRe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well should-you-bluff-future-streets-help-section-1 help-section"},[_c('p',[_vm._v("Consider an example. The board is AcKc4s5h and you're sitting there with Tc9c. You might bluff the turn, get called by A7 or something, and then catch a club on the river. In that case, you'll end up winning the hand even though your bluff didn't work.")]),_vm._v(" "),_c('p',[_vm._v("When we say that a 1/2 pot bluff needs to work more than 33.3% of the time in order to be immediately proftiable, it doesn't factor in the chance that you win the hand after being caught bluffing. It assumes that after getting caught bluffing, you always lose. It assumes that the outcomes are either 1) your bluff forces a fold and you win the pot or 2) your opponent continues versus your bluff and you lose the pot.")]),_vm._v(" "),_c('p',[_vm._v("As you may be able to see, if you have a lot of equity, the immediately profitable breakeven percentage can be a pretty bad number to use. The reality is that you don't need nearly as many folds as that number suggests.")]),_vm._v(" "),_c('p',[_vm._v("In order to estimate how much equity you have, step 1 is to count your outs, and step 2 is to use the Rule of 4 and 2. I'll demonstrate:")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("In this example, your only outs are probably to the flush. Hitting a ten or a nine probably isn't going to win you the hand after you get called on the turn. There are 13 clubs in the deck and 4 of them are out, which means that there are 9 left, and that you have 9 outs.")]),_vm._v(" "),_c('li',[_vm._v("Since we are on the turn, the Rule of 4 and 2 says to multiple the number of outs you have (9) by 2. 9 * 2 = 18. This is the percent of the time you hit one of your outs, and since you probably won't win without hitting one of your outs, you have about 18% equity. If we were on the flop we'd multiply by 4 instead of by 2, but be careful, because you may not "),_c('em',[_vm._v("realize")]),_vm._v(" all of your equity. You may be forced to fold the turn and never get to see the river.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IphQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "IpzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_header_with_toggle__ = __webpack_require__("Kl2i");
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'togglable-section',
  props: ['title'],
  components: {
    'header-with-toggle': __WEBPACK_IMPORTED_MODULE_0__components_utilities_header_with_toggle__["a" /* default */]
  },
  data: function data() {
    return {
      expanded: true
    };
  }
});

/***/ }),

/***/ "IqOy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hand_range_grid_selector_grid_square_suits__ = __webpack_require__("d/vm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hand_range_grid_selector_grid_square_weight_bar__ = __webpack_require__("C2BC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_hand_range_grid_selector_grid_square_modal__ = __webpack_require__("vAN/");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grid-square',
  components: {
    'grid-square-suits': __WEBPACK_IMPORTED_MODULE_2__components_hand_range_grid_selector_grid_square_suits__["a" /* default */],
    'weight-bar': __WEBPACK_IMPORTED_MODULE_3__components_hand_range_grid_selector_grid_square_weight_bar__["a" /* default */],
    'grid-square-modal': __WEBPACK_IMPORTED_MODULE_4__components_hand_range_grid_selector_grid_square_modal__["a" /* default */]
  },
  props: ['generalHand', 'clickAndDragContext', 'altKeyPressed', 'disabled', 'specificHandsNotAllowed', 'equityMatrix', 'requiredEquity', 'rangeConstructor', 'shortDeck'],
  data: function data() {
    return {
      modalVisible: false
    };
  },
  computed: {
    tdClassObj: function tdClassObj() {
      var shade = void 0;

      if (this.generalHand.inRange) {
        if (this.$store.state.account.user.settings.general.visual.gridSquareColors === 'green') {
          shade = (this.generalHand.averageWeight * (this.generalHand.numSpecificHandsInRange / 12)).roundToNearestFive();
        } else {
          shade = this.generalHand.averageWeight;
        }
      } else {
        shade = 100;
      }

      if (!this.equityMatrix && !this.rangeConstructor) {
        var _ref;

        return _ref = {
          'multicolored-grid-square': this.$store.state.account.user.settings.general.visual.gridSquareColors === 'multicolored',
          'green-grid-square': this.$store.state.account.user.settings.general.visual.gridSquareColors === 'green',

          'suited': this.generalHand.suitedOffsuitOrPair === 'suited',
          'offsuit': this.generalHand.suitedOffsuitOrPair === 'offsuit',
          'pair': this.generalHand.suitedOffsuitOrPair === 'pair',

          'in-range': this.generalHand.inRange
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'shade-' + shade, shade < 100), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'default', !this.suitsDisplayVisible && !this.weightVisible && !this.numSpecificHandsInRangeVisbile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'just-suits', this.suitsDisplayVisible && !this.weightVisible && !this.numSpecificHandsInRangeVisbile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'just-weight-bar', !this.suitsDisplayVisible && this.weightVisible && !this.numSpecificHandsInRangeVisbile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'just-num-specific-hands-in-range', !this.suitsDisplayVisible && !this.weightVisible && this.numSpecificHandsInRangeVisbile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'suits-and-weight-bar', this.suitsDisplayVisible && this.weightVisible && !this.numSpecificHandsInRangeVisbile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'suits-and-num-specific-hands-in-range', this.suitsDisplayVisible && !this.weightVisible && this.numSpecificHandsInRangeVisbile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'weight-bar-and-num-specific-hands-in-range', !this.suitsDisplayVisible && this.weightVisible && this.numSpecificHandsInRangeVisbile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'suits-weight-bar-and-num-specific-hands-in-range', this.suitsDisplayVisible && this.weightVisible && this.numSpecificHandsInRangeVisbile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'impossible', !this.generalHand.possible), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'nw-cursor', this.altKeyPressed && this.generalHand.spaceBetweenRanks < 3), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'west-cursor', this.altKeyPressed && this.generalHand.spaceBetweenRanks >= 3 && this.generalHand.suitedOffsuitOrPair === 'suited'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'north-cursor', this.altKeyPressed && this.generalHand.spaceBetweenRanks >= 3 && this.generalHand.suitedOffsuitOrPair === 'offsuit'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'matches-five-card-hand-hover', this.generalHand.matchesFiveCardHandHover), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'disabled', this.disabled), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'short-deck', this.shortDeck), _ref;
      } else if (this.equityMatrix) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
          'equity-matrix': true
        }, 'diff-' + Math.floor(this.generalHand.equity - this.requiredEquity), this.generalHand.equity !== null);
      } else if (this.rangeConstructor) {
        return {
          'red': this.generalHand.color === 'red',
          'blue': this.generalHand.color === 'blue',
          'green': this.generalHand.color === 'green',
          'yellow': this.generalHand.color === 'yellow',
          'orange': this.generalHand.color === 'orange',
          'purple': this.generalHand.color === 'purple',
          'brown': this.generalHand.color === 'brown',
          'impossible-range-constructor': this.generalHand.color === 'impossible',
          'possible-but-deselected': this.generalHand.color === null
        };
      }
    },
    suitsDisplayVisible: function suitsDisplayVisible() {
      if (this.numSpecificHandsInRangeVisbile) {
        return false;
      }

      return this.generalHand.numSpecificHandsInRange > 0 && this.generalHand.numSpecificHandsInRange < this.generalHand.numPossibleSpecificHandsFromSuitedOffsuitOrPair;
    },
    weightVisible: function weightVisible() {
      return this.generalHand.inRange && this.generalHand.averageWeight < 100;
    },
    numSpecificHandsInRangeVisbile: function numSpecificHandsInRangeVisbile() {
      return this.$store.state.account.user.settings.general.visual.areNumCombosInRangeVisible === true;
    },
    title: function title() {
      var title = '';

      if (this.generalHand.inRange === 'partial') {
        this.generalHand.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.inRange) {
            title += specificHand.displayString + ', ';
          }
        });
        title = title.slice(0, -2);
      }

      return title;
    }
  },
  mounted: function mounted() {
    if (true) {
      $(this.$el).find('[data-toggle="tooltip"]').tooltip({
        container: 'body'
      });
    }
  },
  updated: function updated() {
    $(this.$el).find('[data-toggle="tooltip"]').tooltip('destroy');
    $(this.$el).find('[data-toggle="tooltip"]').tooltip({
      container: 'body'
    });
  },
  methods: {
    toggleGridSquare: function toggleGridSquare() {
      if (this.modalVisible) {
        return;
      }

      if (this.generalHand.inRange) {
        this.$emit('deselectGeneralHand', this.generalHand.string);
      } else {
        this.$emit('selectGeneralHand', {
          generalHandString: this.generalHand.string,
          triggeredByMouseover: false
        });
      }
    },
    toggleAscendingGeneralHands: function toggleAscendingGeneralHands() {
      if (this.modalVisible) {
        return;
      }

      if (this.generalHand.inRange) {
        this.$emit('deselectAscendingGeneralHands', this.generalHand.string);
      } else {
        this.$emit('selectAscendingGeneralHands', this.generalHand.string);
      }
    },
    handleMouseover: function handleMouseover() {
      if (this.modalVisible) {
        return;
      }

      if (this.clickAndDragContext === 'adding' && !this.generalHand.inRange) {
        this.$emit('selectGeneralHand', {
          generalHandString: this.generalHand.string,
          triggeredByMouseover: true
        });
      } else if (this.clickAndDragContext === 'removing' && this.generalHand.inRange) {
        this.$emit('deselectGeneralHand', this.generalHand.string);
      }
    },
    expandGridSquareModal: function expandGridSquareModal() {
      var self = this;

      if (self.modalVisible) {
        throw new Error('Trying to call expandGridSquareModal when modal is already visible.');
      }

      if (self.specificHandsNotAllowed) {
        return;
      }

      self.modalVisible = true;
      self.$nextTick(function () {
        $(self.$el).find('.grid-square-modal').modal();
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "IxtF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4LV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J56h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__ = __webpack_require__("3hq0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c3685a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__ = __webpack_require__("hwar");
function injectStyle (ssrContext) {
  __webpack_require__("ebo7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c3685a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c3685a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J8Sm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"short-deck-grid-selector"},_vm._l((_vm.gridOfGeneralHands),function(rowOfGeneralHands){return _c('tr',_vm._l((rowOfGeneralHands),function(generalHand){return _c('grid-square',{key:generalHand.string,attrs:{"generalHand":generalHand,"clickAndDragContext":_vm.clickAndDragContext,"altKeyPressed":_vm.altKeyPressed,"disabled":_vm.disabled,"specificHandsNotAllowed":_vm.specificHandsNotAllowed,"equityMatrix":_vm.equityMatrix,"requiredEquity":_vm.requiredEquity,"rangeConstructor":_vm.rangeConstructor,"shortDeck":true},on:{"selectGeneralHand":function($event){return _vm.selectGeneralHand($event)},"deselectGeneralHand":function($event){return _vm.deselectGeneralHand($event)},"selectAscendingGeneralHands":function($event){return _vm.selectAscendingGeneralHands($event)},"deselectAscendingGeneralHands":function($event){return _vm.deselectAscendingGeneralHands($event)},"selectSpecificHand":function($event){return _vm.$emit('selectSpecificHand', $event)},"deselectSpecificHand":function($event){return _vm.$emit('deselectSpecificHand', $event)},"setSpecificHandAsManuallySet":function($event){return _vm.$emit('setSpecificHandAsManuallySet', $event)},"setSpecificHandAsNotManuallySet":function($event){return _vm.$emit('setSpecificHandAsNotManuallySet', $event)},"applyExactWeightToGeneralHand":function($event){return _vm.$emit('applyExactWeightToGeneralHand', $event)},"setWeightOfSpecificHand":function($event){return _vm.$emit('setWeightOfSpecificHand', $event)}}})}),1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JBFI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");


/* harmony default export */ __webpack_exports__["a"] = ({
  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    state.players.find(payload.playerIndex).selectGeneralHand(payload.generalHandString, state.presetCommunityCards, payload.playerStateIndex);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    state.players.find(payload.playerIndex).deselectGeneralHand(payload.generalHandString, state.presetCommunityCards, payload.playerStateIndex);
  },
  manuallySelectGeneralHand: function manuallySelectGeneralHand(state, payload) {
    state.players.find(payload.playerIndex).manuallySelectGeneralHand(payload.generalHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallyDeselectGeneralHand: function manuallyDeselectGeneralHand(state, payload) {
    state.players.find(payload.playerIndex).manuallyDeselectGeneralHand(payload.generalHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    state.players.find(payload.playerIndex).selectGeneralHands(payload.generalHandStrings, state.presetCommunityCards, payload.playerStateIndex);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    state.players.find(payload.playerIndex).deselectGeneralHands(payload.generalHandStrings, state.presetCommunityCards, payload.playerStateIndex);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    state.players.find(payload.playerIndex).deselectAllGeneralHands(state.presetCommunityCards, payload.playerStateIndex);
  },
  selectSpecificHand: function selectSpecificHand(state, payload) {
    state.players.find(payload.playerIndex).selectSpecificHand(payload.specificHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  deselectSpecificHand: function deselectSpecificHand(state, payload) {
    state.players.find(payload.playerIndex).deselectSpecificHand(payload.specificHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallySelectSpecificHand: function manuallySelectSpecificHand(state, payload) {
    state.players.find(payload.playerIndex).manuallySelectSpecificHand(payload.specificHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallyDeselectSpecificHand: function manuallyDeselectSpecificHand(state, payload) {
    state.players.find(payload.playerIndex).manuallyDeselectSpecificHand(payload.specificHandString, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallyDeselectAllGeneralHands: function manuallyDeselectAllGeneralHands(state, payload) {
    state.players.find(payload.playerIndex).manuallyDeselectAllGeneralHands(state.presetCommunityCards, payload.playerStateIndex);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    state.players.find(payload.playerIndex).selectSpecificHands(payload.specificHandStrings, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  setSpecificHandAsManuallySet: function setSpecificHandAsManuallySet(state, payload) {
    state.players.find(payload.playerIndex).setSpecificHandAsManuallySet(payload.specificHandString, payload.playerStateIndex);
  },
  setSpecificHandAsNotManuallySet: function setSpecificHandAsNotManuallySet(state, payload) {
    state.players.find(payload.playerIndex).setSpecificHandAsNotManuallySet(payload.specificHandString, payload.playerStateIndex);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    state.players.find(payload.playerIndex).applyExactWeightToGeneralHand(payload.generalHandString, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    var player = state.players.find(payload.playerIndex);

    payload.generalHandsFromModal.forEachGeneralHandInRange(function (generalHandFromModalInRange) {
      player.applyExactWeightToGeneralHand(generalHandFromModalInRange.string, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex);
    });
  },
  setWeightOfSpecificHand: function setWeightOfSpecificHand(state, payload) {
    state.players.find(payload.playerIndex).setWeightOfSpecificHand(payload.specificHandString, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallyApplyExactWeightToGeneralHand: function manuallyApplyExactWeightToGeneralHand(state, payload) {
    state.players.find(payload.playerIndex).manuallyApplyExactWeightToGeneralHand(payload.generalHandString, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  manuallySetWeightOfSpecificHand: function manuallySetWeightOfSpecificHand(state, payload) {
    state.players.find(payload.playerIndex).manuallySetWeightOfSpecificHand(payload.specificHandString, payload.newWeight, state.presetCommunityCards, payload.playerStateIndex, payload.shortDeck);
  },
  clearManuallyAddedHands: function clearManuallyAddedHands(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].generalHands.clearManuallyAddedHands();
  },
  clearManuallyRemovedHands: function clearManuallyRemovedHands(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].generalHands.clearManuallyRemovedHands();
  },
  setRangesAccordingToFilters: function setRangesAccordingToFilters(state, playerIndex, shortDeck) {
    state.players.find(playerIndex).setRangesAccordingToFilters(state.presetCommunityCards, shortDeck);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    state.players.find(payload.playerIndex).weightToApplyToAddedHands = payload.weightToApplyToAddedHands;
  },
  addComboToCombosToAdd: function addComboToCombosToAdd(state, payload) {
    state.players.find(payload.playerIndex).combosToAdd.pushIfNotIncluded(payload.combo);
  },
  removeComboFromCombosToAdd: function removeComboFromCombosToAdd(state, payload) {
    state.players.find(payload.playerIndex).combosToAdd.removeIfIncluded(payload.combo);
  },
  highlightGeneralHandsThatMatchFiveCardHand: function highlightGeneralHandsThatMatchFiveCardHand(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].generalHands.highlightMatchingGeneralHands(payload.matchingSpecificHands);
  },
  removeFiveCardHandHighlights: function removeFiveCardHandHighlights(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].generalHands.removeFiveCardHandHighlights();
  },

  // controls
  setPresetHoleCard: function setPresetHoleCard(state, payload) {
    state.presetHoleCards[payload.position] = payload.card;
    state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(payload.card, payload.shortDeck);
  },
  removePresetHoleCard: function removePresetHoleCard(state, position, shortDeck) {
    var holeCardToRemove = state.presetHoleCards[position];

    state.presetHoleCards[position] = null;

    if (holeCardToRemove) {
      state.players.selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(holeCardToRemove, state.presetCommunityCards, state.presetHoleCards, shortDeck);
      state.players.setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(holeCardToRemove, state.presetCommunityCards, state.presetHoleCards, shortDeck);
    }
  },
  setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(state, payload) {
    state.presetCommunityCards[payload.position] = payload.card;
    state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(payload.card, payload.shortDeck);
  },
  setBoard: function setBoard(state, boardCards, shortDeck) {
    if (boardCards.length === 3) {
      state.presetCommunityCards.flop1 = boardCards[0];
      state.presetCommunityCards.flop2 = boardCards[1];
      state.presetCommunityCards.flop3 = boardCards[2];
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[0], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[1], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[2], state.presetCommunityCards, shortDeck);
    } else if (boardCards.length === 4) {
      state.presetCommunityCards.flop1 = boardCards[0];
      state.presetCommunityCards.flop2 = boardCards[1];
      state.presetCommunityCards.flop3 = boardCards[2];
      state.presetCommunityCards.turn = boardCards[3];
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[0], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[1], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[2], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[3], state.presetCommunityCards, shortDeck);
    } else if (boardCards.length === 5) {
      state.presetCommunityCards.flop1 = boardCards[0];
      state.presetCommunityCards.flop2 = boardCards[1];
      state.presetCommunityCards.flop3 = boardCards[2];
      state.presetCommunityCards.turn = boardCards[3];
      state.presetCommunityCards.river = boardCards[4];
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[0], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[1], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[2], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[3], state.presetCommunityCards, shortDeck);
      state.players.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(boardCards[4], state.presetCommunityCards, shortDeck);
    }
  },
  removePresetCommunityCard: function removePresetCommunityCard(state, position, shortDeck) {
    var presetCommunityCardToRemove = state.presetCommunityCards[position];
    var presetHoleCards = state.presetHoleCards || { holeCardOne: '', holeCardTwo: '' };

    state.presetCommunityCards[position] = null;

    if (presetCommunityCardToRemove) {
      state.players.selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(presetCommunityCardToRemove, state.presetCommunityCards, presetHoleCards, shortDeck);
      state.players.setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(presetCommunityCardToRemove, state.presetCommunityCards, presetHoleCards, shortDeck);
    }
  },
  addPlayer: function addPlayer(state, payload) {
    payload = payload || {};
    state.players.add(state.presetCommunityCards);
    state.presetCommunityCards.array.forEach(function (presetCommunityCard) {
      state.players.last.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(presetCommunityCard, payload.shortDeck);
    });

    if (payload.opponentTightness) {
      state.players.last.setFiveCardHandValuesToDefaults(state.presetCommunityCards, payload.opponentTightness, payload.settings);
      state.presetHoleCards.array.forEach(function (presetHoleCard) {
        state.players.last.deselectAllSpecificHandsThatUseCardAndSetAsImpossible(presetHoleCard, payload.shortDeck);
      });
    }
  },
  removePlayer: function removePlayer(state, playerIndex) {
    state.players.remove(playerIndex);
  },

  // five card hands section checkboxes
  setCheckedValueOfFiveCardHand: function setCheckedValueOfFiveCardHand(state, payload) {
    payload.fiveCardHand.checked = payload.newCheckedValue;
  },
  applyExactWeightToFiveCardHand: function applyExactWeightToFiveCardHand(state, payload) {
    payload.fiveCardHand.applyExactWeightToFiveCardHand(payload.newWeight);
  },
  uncheckAllFiveCardHandsForGivenState: function uncheckAllFiveCardHandsForGivenState(state, payload) {
    var player = state.players.find(payload.playerIndex);

    player.states[payload.playerStateIndex].fiveCardHands.uncheckAllVisibleFiveCardHands();
  },
  checkAllFiveCardHandsForGivenState: function checkAllFiveCardHandsForGivenState(state, payload) {
    var player = state.players.find(payload.playerIndex);

    player.states[payload.playerStateIndex].fiveCardHands.checkAllVisibleFiveCardHands();
  },
  setChecksToDefaultsForGivenState: function setChecksToDefaultsForGivenState(state, payload) {
    var player = state.players.find(payload.playerIndex);
    var fiveCardHandsThatAreCheckedByDefault = player.states[payload.playerStateIndex].getFiveCardHandsThatAreCheckedByDefault(state.presetCommunityCards, payload.opponentTightness, payload.settings);

    player.states[payload.playerStateIndex].fiveCardHands.setChecksToDefaults(fiveCardHandsThatAreCheckedByDefault, player.states[payload.playerStateIndex].name);
  },
  setChecksAccordingToUserDefinedFilterForGivenState: function setChecksAccordingToUserDefinedFilterForGivenState(state, payload) {
    var player = state.players.find(payload.playerIndex);

    player.states[payload.playerStateIndex].fiveCardHands.setChecksAccordingToUserDefinedFilters(payload.filterName, payload.userDefinedFilters);
  },
  setFiveCardHandValuesToDefaults: function setFiveCardHandValuesToDefaults(state, payload) {
    state.players.setFiveCardHandValuesToDefaults(state.presetCommunityCards, payload.opponentTightness, payload.settings);
  },
  updateWeightOfFiveCardHand: function updateWeightOfFiveCardHand(state, payload) {
    payload.fiveCardHand.weight = payload.newWeight;
  },
  clearManuallySetHandsThatPassThroughFilter: function clearManuallySetHandsThatPassThroughFilter(state, payload) {
    var player = state.players.find(payload.playerIndex);
    var fiveCardHand = player.states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId);
    var presetCommunityCardsArray = state.presetCommunityCards.getArrayForStateViaIndex(payload.playerStateIndex);

    player.states[payload.playerStateIndex].generalHands.clearManuallySetHandsThatPassThroughFilter(fiveCardHand, presetCommunityCardsArray, payload.shortDeck);
  },

  // five card hands section other
  toggleCollapsedValueOfFiveCardHandParent: function toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent) {
    fiveCardHandParent.collapsed = !fiveCardHandParent.collapsed;
  },
  setProbabilitiesOfFiveCardHands: function setProbabilitiesOfFiveCardHands(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.setProbabilities(payload.handAndDrawInfo, payload.numberOfSimulations);
  },
  setHandAndDrawInfo: function setHandAndDrawInfo(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].handAndDrawInfo = _.cloneDeep(payload.handAndDrawInfoFromSimulationResults);
  },
  setPercentagesOfSpecificHandsThatAreSelected: function setPercentagesOfSpecificHandsThatAreSelected(state, payload) {
    var playerState = state.players.find(payload.playerIndex).states[payload.playerStateIndex];

    playerState.fiveCardHands.setPercentagesOfSpecificHandsThatAreSelected(playerState.generalHands);
  },

  // simulations
  setHasSimulationBeenRun: function setHasSimulationBeenRun(state, value) {
    state.hasSimulationBeenRun = value;
  },
  setLastSimulationInfo: function setLastSimulationInfo(state, playerStateIndex) {
    state.players.setLastSimulationInfo(state.presetCommunityCards, state.presetHoleCards, playerStateIndex);
  },

  // cumulative hit percentages
  getPercentageOfTimeEveryoneMissesTheBoard: function getPercentageOfTimeEveryoneMissesTheBoard(state, street) {
    var playerStateIndex = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.getPlayerStateIndexFromStreet(street);
    var missPercentages = [];

    state.players.forEach(function (player) {
      missPercentages.push(100 - player.states[playerStateIndex].hitPercentage);
    });

    return missPercentages.reduce(function (accumulator, missPercentage) {
      return accumulator * (missPercentage / 100);
    }, 1) * 100;
  },
  getPercentageOfTimeExactlyOnePlayerHitsTheBoard: function getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, street) {
    var playerStateIndex = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.getPlayerStateIndexFromStreet(street);
    var hitPercentages = [];
    var result = 0;
    var resultOfMultiplyingInverseOfOthers = void 0;

    state.players.forEach(function (player) {
      hitPercentages.push(player.states[playerStateIndex].hitPercentage);
    });
    hitPercentages.forEach(function (hitPercentageOuter, i) {
      resultOfMultiplyingInverseOfOthers = 1;
      hitPercentages.forEach(function (hitPercentageInner, j) {
        if (i === j) return;

        resultOfMultiplyingInverseOfOthers *= 1 - hitPercentageInner / 100;
      });
      result += hitPercentageOuter / 100 * resultOfMultiplyingInverseOfOthers;
    });

    return result * 100;
  },
  getPercentageOfTimeTwoOrMorePlayersHitTheBoard: function getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, street) {
    var percentageOfTimeEveryoneMissesTheBoard = this.getPercentageOfTimeEveryoneMissesTheBoard(state, street);
    var percentageOfTimeExactlyOnePlayerHitsTheBoard = this.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, street);

    return 100 - percentageOfTimeEveryoneMissesTheBoard - percentageOfTimeExactlyOnePlayerHitsTheBoard;
  },
  getCumulativeHitPercentages: function getCumulativeHitPercentages(state) {
    return {
      flop: {
        percentageOfTimeEveryoneMissesTheBoard: this.getPercentageOfTimeEveryoneMissesTheBoard(state, 'flop'),
        percentageOfTimeExactlyOnePlayerHitsTheBoard: this.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, 'flop'),
        percentageOfTimeTwoOrMorePlayersHitTheBoard: this.getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, 'flop')
      },
      turn: {
        percentageOfTimeEveryoneMissesTheBoard: this.getPercentageOfTimeEveryoneMissesTheBoard(state, 'turn'),
        percentageOfTimeExactlyOnePlayerHitsTheBoard: this.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, 'turn'),
        percentageOfTimeTwoOrMorePlayersHitTheBoard: this.getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, 'turn')
      },
      river: {
        percentageOfTimeEveryoneMissesTheBoard: this.getPercentageOfTimeEveryoneMissesTheBoard(state, 'river'),
        percentageOfTimeExactlyOnePlayerHitsTheBoard: this.getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, 'river'),
        percentageOfTimeTwoOrMorePlayersHitTheBoard: this.getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, 'river')
      }
    };
  }
});

/***/ }),

/***/ "JBOc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JCHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_vue__ = __webpack_require__("rT37");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7599fe56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__ = __webpack_require__("wTCP");
function injectStyle (ssrContext) {
  __webpack_require__("cQ7x")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7599fe56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_account_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7599fe56_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_account_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JH1h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JIZ4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JKDa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_five_card_hands_categories_MadeHands__ = __webpack_require__("2OhB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_categories_Draws__ = __webpack_require__("Ru/A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_categories_Combos__ = __webpack_require__("gzNY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);








var FiveCardHands = function () {
  function FiveCardHands() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FiveCardHands);

    this.madeHands = new __WEBPACK_IMPORTED_MODULE_3__services_five_card_hands_categories_MadeHands__["a" /* default */]();
    this.draws = new __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_categories_Draws__["a" /* default */]();
    this.combos = new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_categories_Combos__["a" /* default */]();
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(FiveCardHands, [{
    key: 'forEachNode',
    value: function forEachNode(cb) {
      this.madeHands.forEachNode(cb);
      this.draws.forEachNode(cb);
      this.combos.forEachNode(cb);
    }
  }, {
    key: 'forEachVisibleNode',
    value: function forEachVisibleNode(arr, level, cb) {
      arr.forEach(function (el) {
        if (el.visible) {
          cb(el, level);

          if (el.children && !el.collapsed) {
            this.forEachVisibleNode(el.children, level + 1, cb);
          }
        }
      }, this);
    }
  }, {
    key: 'forEachLeaf',
    value: function forEachLeaf(cb) {
      this.madeHands.forEachLeaf(cb);
      this.draws.forEachLeaf(cb);
      this.combos.forEachLeaf(cb);
    }
  }, {
    key: 'forEachParent',
    value: function forEachParent(cb) {
      this.madeHands.forEachParent(cb);
      this.draws.forEachParent(cb);
      this.combos.forEachParent(cb);
    }
  }, {
    key: 'forEachVisibleLeaf',
    value: function forEachVisibleLeaf(cb) {
      this.madeHands.forEachVisibleLeaf(cb);
      this.draws.forEachVisibleLeaf(cb);
      this.combos.forEachVisibleLeaf(cb);
    }
  }, {
    key: 'forEachFromNodeInList',
    value: function forEachFromNodeInList(listOfFiveCardHandIds, cb) {
      this.forEachNode(function (node) {
        if (listOfFiveCardHandIds.includes(node.id)) {
          cb(node);
        }
      });
    }
  }, {
    key: 'forEachVisibleNodeInList',
    value: function forEachVisibleNodeInList(listOfFiveCardHandIds, cb) {
      this.forEachFromNodeInList(listOfFiveCardHandIds, function (node) {
        if (node.visible) {
          cb(node);
        }
      });
    }
  }, {
    key: 'find',
    value: function find(id) {
      var fiveCardHand = void 0;

      this.forEachNode(function (node) {
        if (node.id === id) {
          fiveCardHand = node;
        }
      });

      return fiveCardHand;
    }
  }, {
    key: 'uncheckAllVisibleFiveCardHands',
    value: function uncheckAllVisibleFiveCardHands() {
      this.forEachVisibleLeaf(function (fiveCardHand) {
        fiveCardHand.checked = false;
      });
    }
  }, {
    key: 'checkAllVisibleFiveCardHands',
    value: function checkAllVisibleFiveCardHands() {
      this.forEachVisibleLeaf(function (fiveCardHand) {
        fiveCardHand.checked = true;
      });
    }
  }, {
    key: 'setChecksAccordingToUserDefinedFilters',
    value: function setChecksAccordingToUserDefinedFilters(filterName, userDefinedFilters) {
      var self = this;

      self.forEachVisibleLeaf(function (fiveCardHand) {
        var isPartOfUserDefinedFilter = self._isPartOfUserDefinedFilter(fiveCardHand, filterName, userDefinedFilters);

        if (isPartOfUserDefinedFilter) {
          fiveCardHand.checked = true;
        } else {
          fiveCardHand.checked = false;
        }
      });
    }
  }, {
    key: '_isPartOfUserDefinedFilter',
    value: function _isPartOfUserDefinedFilter(fiveCardHand, filterName, userDefinedFilters) {
      var fiveCardHandsThatAreCheckedForUserDefinedFilter = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.find(userDefinedFilters, function (userDefinedFilter) {
        return userDefinedFilter.name === filterName;
      }).fiveCardHands;

      if (fiveCardHand.madeHandDrawOrCombo === 'made hand') {
        return fiveCardHandsThatAreCheckedForUserDefinedFilter.madeHands.includes(fiveCardHand.id);
      } else if (fiveCardHand.madeHandDrawOrCombo === 'draw') {
        return fiveCardHandsThatAreCheckedForUserDefinedFilter.draws.includes(fiveCardHand.id);
      } else if (fiveCardHand.madeHandDrawOrCombo === 'combo') {
        return fiveCardHandsThatAreCheckedForUserDefinedFilter.combos.includes(fiveCardHand.id);
      }
    }
  }, {
    key: 'setChecksToDefaults',
    value: function setChecksToDefaults(fiveCardHandsThatAreCheckedByDefault, playerStateName) {
      this.forEachVisibleLeaf(function (fiveCardHand) {
        fiveCardHand.checked = fiveCardHand.getDefaultCheckedValue(fiveCardHandsThatAreCheckedByDefault, playerStateName);
      });
    }
  }, {
    key: 'setCollapsedValuesToDefaults',
    value: function setCollapsedValuesToDefaults(settings) {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.each(settings.hitCalculator.collapsedByDefault, function (collapsedByDefault, id) {
        self.find(id).collapsed = collapsedByDefault;
      });
    }
  }, {
    key: 'setIncludedValuesToDefaults',
    value: function setIncludedValuesToDefaults(settings) {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.each(settings.hitCalculator.includedByDefault, function (includedByDefault, id) {
        self.find(id).included = includedByDefault;
      });
    }
  }, {
    key: 'setProbabilities',
    value: function setProbabilities(handAndDrawInfo, numberOfSimulations) {
      this._setCounts(handAndDrawInfo);
      this._setProbabilitiesGivenCounts(numberOfSimulations);
      this._resetCounts();
    }
  }, {
    key: '_setCounts',
    value: function _setCounts(handAndDrawInfo) {
      this.forEachNode(function (node) {
        handAndDrawInfo.forEach(function (_ref) {
          var handInfo = _ref.handInfo,
              drawInfo = _ref.drawInfo;

          drawInfo = drawInfo || {};

          if (node.isAHit(handInfo, drawInfo)) {
            node.count++;
          }
        });
      });
    }
  }, {
    key: '_setProbabilitiesGivenCounts',
    value: function _setProbabilitiesGivenCounts(numberOfSimulations) {
      this.forEachNode(function (node) {
        node._probability = (node.count / numberOfSimulations * 100).roundToTwoDecimalPlaces();
      });
    }
  }, {
    key: '_resetCounts',
    value: function _resetCounts() {
      this.forEachNode(function (node) {
        node.count = 0;
      });
    }
  }, {
    key: 'setMatchingSpecificHands',
    value: function setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck) {
      this.madeHands.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);

      if (presetCommunityCardsArray.length < 5) {
        this.draws.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);
        this.combos.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);
      }
    }
  }, {
    key: 'clearMatchingSpecificHands',
    value: function clearMatchingSpecificHands() {
      this.forEachLeaf(function (fiveCardHandLeaf) {
        fiveCardHandLeaf.matchingSpecificHands = [];
      });
    }
  }, {
    key: 'setProbabilitiesAccordingToMatchingSpecificHands',
    value: function setProbabilitiesAccordingToMatchingSpecificHands(generalHands) {
      this.forEachNode(function (fiveCardHand) {
        fiveCardHand.setProbabilityAccordingToMatchingSpecificHands(generalHands);
      });
    }
  }, {
    key: 'setPercentagesOfSpecificHandsThatAreSelected',
    value: function setPercentagesOfSpecificHandsThatAreSelected(generalHands) {
      this.forEachNode(function (fiveCardHand) {
        fiveCardHand.setPercentageOfSpecificHandsThatAreSelected(generalHands);
      });
    }
  }, {
    key: 'checkedHands',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.checkedMadeHands, this.checkedDraws, this.checkedCombos);
    }
  }, {
    key: 'checkedMadeHands',
    get: function get() {
      var checkedMadeHands = {};

      this.madeHands.forEachLeaf(function (madeHandLeaf) {
        if (madeHandLeaf.visible && madeHandLeaf.checked) {
          checkedMadeHands[madeHandLeaf.id] = madeHandLeaf;
        }
      });

      return checkedMadeHands;
    }
  }, {
    key: 'checkedDraws',
    get: function get() {
      var checkedDraws = {};

      this.draws.forEachLeaf(function (drawLeaf) {
        if (drawLeaf.visible && drawLeaf.checked) {
          checkedDraws[drawLeaf.id] = drawLeaf;
        }
      });

      return checkedDraws;
    }
  }, {
    key: 'checkedCombos',
    get: function get() {
      var checkedCombos = {};

      this.combos.forEachLeaf(function (comboLeaf) {
        if (comboLeaf.visible && comboLeaf.checked) {
          checkedCombos[comboLeaf.id] = comboLeaf;
        }
      });

      return checkedCombos;
    }
  }, {
    key: 'anyCheckedDraws',
    get: function get() {
      return !__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(this.checkedDraws);
    }
  }, {
    key: 'anyCheckedCombos',
    get: function get() {
      return !__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.isEmpty(this.checkedCombos);
    }
  }, {
    key: 'visibleMadeHands',
    get: function get() {
      var visibleMadeHands = [];

      this.forEachVisibleNode(this.madeHands.data, 0, function (node, level) {
        node.level = level;
        visibleMadeHands.push(node);
      });

      return visibleMadeHands;
    }
  }, {
    key: 'shortDeckVisibleMadeHands',
    get: function get() {
      var order = ['fourOfAKindPlus', 'fourOfAKindPlus:royalFlush', 'fourOfAKindPlus:straightFlush', 'fourOfAKindPlus:fourOfAKind', 'flush', 'flush:nut', 'flush:secondNut', 'flush:thirdNut', 'flush:weak', 'fullHouse', 'straight', 'threeOfAKind', 'threeOfAKind:topSet', 'threeOfAKind:secondSet', 'threeOfAKind:thirdSet', 'threeOfAKind:fourthSet', 'threeOfAKind:middleSet', 'threeOfAKind:bottomSet', 'threeOfAKind:trips', 'twoPair', 'twoPair:usingTopBoardCard', 'twoPair:weak', 'pair', 'pair:overpair', 'pair:tptk', 'pair:tpgk', 'pair:tpwk', 'pair:ppUnderTp', 'pair:secondPair', 'pair:middlePair', 'pair:weakPair', 'usingABoardCard', 'usingABoardCard:flushUsingOneHoleCard', 'usingABoardCard:flushUsingOneHoleCard:nut', 'usingABoardCard:flushUsingOneHoleCard:secondNut', 'usingABoardCard:flushUsingOneHoleCard:thirdNut', 'usingABoardCard:flushUsingOneHoleCard:weak', 'usingABoardCard:flushOnBoard', 'usingABoardCard:threeOfAKindOnBoard', 'usingABoardCard:twoPairWithPairOnBoard', 'usingABoardCard:twoPairOnBoard', 'usingABoardCard:pairOnBoard', 'highCard', 'highCard:aceHigh', 'highCard:kingHigh', 'highCard:weak'];

      return this.visibleMadeHands.sort(function (a, b) {
        return order.indexOf(a.id) - order.indexOf(b.id);
      });
    }
  }, {
    key: 'visibleDraws',
    get: function get() {
      var visibleDraws = [];

      this.forEachVisibleNode(this.draws.data, 0, function (node, level) {
        node.level = level;
        visibleDraws.push(node);
      });

      return visibleDraws;
    }
  }, {
    key: 'visibleCombos',
    get: function get() {
      var visibleCombos = [];

      this.forEachVisibleNode(this.combos.data, 0, function (node, level) {
        node.level = level;
        visibleCombos.push(node);
      });

      return visibleCombos;
    }
  }, {
    key: 'flatArrayOfLeaves',
    get: function get() {
      var flatArrayOfLeaves = [];

      this.madeHands.flatArrayOfLeaves.forEach(function (leaf) {
        flatArrayOfLeaves.push(leaf);
      });
      this.draws.flatArrayOfLeaves.forEach(function (leaf) {
        flatArrayOfLeaves.push(leaf);
      });
      this.combos.flatArrayOfLeaves.forEach(function (leaf) {
        flatArrayOfLeaves.push(leaf);
      });

      return flatArrayOfLeaves;
    }
  }, {
    key: 'flatArrayOfParents',
    get: function get() {
      var flatArrayOfParents = [];

      this.madeHands.flatArrayOfParents.forEach(function (parent) {
        flatArrayOfParents.push(parent);
      });
      this.draws.flatArrayOfParents.forEach(function (parent) {
        flatArrayOfParents.push(parent);
      });
      this.combos.flatArrayOfParents.forEach(function (parent) {
        flatArrayOfParents.push(parent);
      });

      return flatArrayOfParents;
    }
  }, {
    key: 'defaultIncludedByDefault',
    get: function get() {
      var defaultIncludedByDefault = {};

      this.flatArrayOfLeaves.forEach(function (leaf) {
        defaultIncludedByDefault[leaf.id] = true;
      });

      return defaultIncludedByDefault;
    }
  }, {
    key: 'defaultCollapsedByDefault',
    get: function get() {
      var defaultCollapsedByDefault = {};

      this.flatArrayOfParents.forEach(function (parent) {
        if (parent.id === 'pair') {
          defaultCollapsedByDefault[parent.id] = false;
        } else {
          defaultCollapsedByDefault[parent.id] = true;
        }
      });

      return defaultCollapsedByDefault;
    }
  }]);

  return FiveCardHands;
}();

/* harmony default export */ __webpack_exports__["a"] = (FiveCardHands);
;

/***/ }),

/***/ "JZWF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Help / Should You Call")])]),_vm._v(" "),_c('p',[_vm._v("Check out the videos in the playlist below:")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa_RWSQoicrJ7LgOR_7Rm1ef","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Still need help?")]),_vm._v(" "),_c('p',[_vm._v("I'm here for you. Hit me up at "),_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(".")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jy2w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KB/h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KCAa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{attrs:{"modalLg":"true"}},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.narrowRange()}}},[_vm._v("Narrow range")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default clear-checks",on:{"click":function($event){return _vm.clearAllChecks()}}},[_c('span',{staticClass:"full-text"},[_vm._v("Clear all checks")]),_vm._v(" "),_c('span',{staticClass:"partial-text"},[_vm._v("Clear")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default set-checks-to-default",on:{"click":function($event){return _vm.setChecksToDefault()}}},[_c('span',{staticClass:"full-text"},[_vm._v("Set checkboxes to default")]),_vm._v(" "),_c('span',{staticClass:"partial-text"},[_vm._v("Default")])])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[_c('five-card-hands-section',{attrs:{"playerState":_vm.playerState,"hideHeader":true},on:{"setCheckedValueOfFiveCardHand":function($event){return _vm.setCheckedValueOfFiveCardHand($event)},"toggleCollapsedValueOfFiveCardHandParent":function($event){return _vm.toggleCollapsedValueOfFiveCardHandParent($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KFpT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_results_vue__ = __webpack_require__("o9kw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46941114_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_results_vue__ = __webpack_require__("osKv");
function injectStyle (ssrContext) {
  __webpack_require__("Ed9P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46941114"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_results_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46941114_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_results_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KIUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__ = __webpack_require__("T8TE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_help_future_streets_1__ = __webpack_require__("gws6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_help_future_streets_2__ = __webpack_require__("wceS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-final-conclusion',
  components: {
    'toggle-help-button': __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__["a" /* default */],
    'future-streets-help-section-1': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_help_future_streets_1__["a" /* default */],
    'future-streets-help-section-2': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_help_future_streets_2__["a" /* default */]
  },
  props: ['equitySimulationsInProgress', 'ableToRunEquityCalculations', 'equity', 'bluffSize', 'streetToBluff', 'hitPercentageForStreetToBluff', 'foldEquity', 'immediatelyProfitableBreakevenPercentage', 'profitableBreakevenPercentage'],
  data: function data() {
    return {
      helpAreaVisible: {
        futureStreets: [false, false, false]
      }
    };
  },
  computed: {
    isBluffProfitable: function isBluffProfitable() {
      return this.foldEquity > this.profitableBreakevenPercentage;
    }
  },
  watch: {
    bluffSize: function bluffSize(newBluffSize, oldBluffSize) {
      var newProfitableBreakevenPercentage = Math.round(this.immediatelyProfitableBreakevenPercentage - 5);

      this.$emit('setProfitableBreakevenPercentage', newProfitableBreakevenPercentage);
    }
  },
  methods: {
    toggleHelp: function toggleHelp(type, index) {
      if (type === 'futureStreets') {
        this.helpAreaVisible.futureStreets[index] = !this.helpAreaVisible.futureStreets[index];
      }

      this.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "KQ4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'errors-alert',
  props: ['errors']
});

/***/ }),

/***/ "KaYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_included_vue__ = __webpack_require__("Er0k");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c699fd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_included_vue__ = __webpack_require__("lx+6");
function injectStyle (ssrContext) {
  __webpack_require__("WcwY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c699fd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_included_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c699fd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_included_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kl2i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_with_toggle_vue__ = __webpack_require__("ziD+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2fbdc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_with_toggle_vue__ = __webpack_require__("DvC0");
function injectStyle (ssrContext) {
  __webpack_require__("KvYu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c2fbdc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_with_toggle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2fbdc4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_with_toggle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Kpym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-long-run-disclaimer'
});

/***/ }),

/***/ "Ks7W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'grid-square-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */],
    'vue-slider': __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },
  props: ['generalHand'],
  data: function data() {
    return {
      sliderOptions: {
        min: 5,
        interval: 5,
        tooltip: 'hover',
        debug: false // prevents console.error stuff; I'm getting a mistaken console.error about the value being 0, which is less than the min of 5
      }
    };
  },
  computed: {
    specificHandsGrid: function specificHandsGrid() {
      var self = this;
      var suitsGrid = [['cc', 'cs', 'ch', 'cd'], ['sc', 'ss', 'sh', 'sd'], ['hc', 'hs', 'hh', 'hd'], ['dc', 'ds', 'dh', 'dd']];

      return suitsGrid.map(function (row) {
        return row.map(function (suits) {
          return self.generalHand.specificHands[suits];
        });
      });
    }
  },
  mounted: function mounted() {
    var self = this;

    $(self.$el).on('shown.bs.modal', function () {
      $(self.$el).find('[data-toggle="popover"]').popover();
      self.$nextTick(function () {
        if (self.$refs.slider) {
          self.$refs.slider.forEach(function (ref) {
            ref.refresh();
          });
        }
      });
    });
    $(self.$el).on('hidden.bs.modal', function () {
      self.$emit('modalHidden');
    });
  },
  methods: {
    getHTMLForSuitIcons: function getHTMLForSuitIcons(suits) {
      return __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].general.getHTMLForSuitIcons(suits);
    },
    toggleSpecificHandInRange: function toggleSpecificHandInRange(specificHand) {
      if (!specificHand || !specificHand.possible) {
        return;
      }

      if (specificHand.inRange) {
        this.$emit('deselectSpecificHand', specificHand.string);
      } else {
        this.$emit('selectSpecificHand', specificHand.string);
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "KvYu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KxC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"cumulative-hit-percentages table"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[(_vm.moreThanTwoPlayers)?_c('span',[_vm._v("All opponents miss the board")]):_c('span',[_vm._v("Both opponents miss the board")])]),_vm._v(" "),_c('th',[_vm._v("One opponent hits")]),_vm._v(" "),_c('th',[(_vm.moreThanTwoPlayers)?_c('span',[_vm._v("Two or more opponents hit")]):_c('span',[_vm._v("Both opponents hit")])])])]),_vm._v(" "),_c('tbody',[(_vm.displayFlop)?_c('tr',[_c('th',[_vm._v("Flop")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.flop.percentageOfTimeEveryoneMissesTheBoard.roundToTwoDecimalPlaces())+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.flop.percentageOfTimeExactlyOnePlayerHitsTheBoard.roundToTwoDecimalPlaces())+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.flop.percentageOfTimeTwoOrMorePlayersHitTheBoard.roundToTwoDecimalPlaces())+"%")])]):_vm._e(),_vm._v(" "),(_vm.displayTurn)?_c('tr',[_c('th',[_vm._v("Turn")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.turn.percentageOfTimeEveryoneMissesTheBoard.roundToTwoDecimalPlaces())+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.turn.percentageOfTimeExactlyOnePlayerHitsTheBoard.roundToTwoDecimalPlaces())+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.turn.percentageOfTimeTwoOrMorePlayersHitTheBoard.roundToTwoDecimalPlaces())+"%")])]):_vm._e(),_vm._v(" "),(_vm.displayRiver)?_c('tr',[_c('th',[_vm._v("River")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.river.percentageOfTimeEveryoneMissesTheBoard.roundToTwoDecimalPlaces())+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.river.percentageOfTimeExactlyOnePlayerHitsTheBoard.roundToTwoDecimalPlaces())+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.cumulativeHitPercentages.river.percentageOfTimeTwoOrMorePlayersHitTheBoard.roundToTwoDecimalPlaces())+"%")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L0Ni":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_range_vue__ = __webpack_require__("i3fB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6db940_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_range_vue__ = __webpack_require__("r/5L");
function injectStyle (ssrContext) {
  __webpack_require__("aaFb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a6db940"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_range_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a6db940_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LAeg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'range-constructor-help'
});

/***/ }),

/***/ "LGkT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_initial_conclusion_vue__ = __webpack_require__("jCDX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a016b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_initial_conclusion_vue__ = __webpack_require__("auGP");
function injectStyle (ssrContext) {
  __webpack_require__("uf/A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0a016b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_initial_conclusion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0a016b2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_initial_conclusion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "LO8Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_PlayerState__ = __webpack_require__("BTn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_modal__ = __webpack_require__("jEKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_five_card_hands_section_five_card_hands_section__ = __webpack_require__("+Gii");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'narrow-range-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_1__components_utilities_modal__["a" /* default */],
    'five-card-hands-section': __WEBPACK_IMPORTED_MODULE_2__components_five_card_hands_section_five_card_hands_section__["a" /* default */]
  },
  data: function data() {
    var playerState = new __WEBPACK_IMPORTED_MODULE_0__services_player_PlayerState__["a" /* default */]();

    playerState.fiveCardHands.forEachLeaf(function (leaf) {
      leaf._probability = 0.000001;
    });

    return {
      playerState: playerState
    };
  },
  created: function created() {
    this.setChecksToDefault();
    this.setCollapsedValuesToDefault();
  },
  methods: {
    setCheckedValueOfFiveCardHand: function setCheckedValueOfFiveCardHand(payload) {
      this.playerState.fiveCardHands.find(payload.fiveCardHandId).checked = payload.newCheckedValue;
    },
    toggleCollapsedValueOfFiveCardHandParent: function toggleCollapsedValueOfFiveCardHandParent(fiveCardHandParent) {
      fiveCardHandParent.collapsed = !fiveCardHandParent.collapsed;
    },
    clearAllChecks: function clearAllChecks() {
      this.playerState.fiveCardHands.forEachLeaf(function (leaf) {
        leaf.checked = false;
      });
    },
    narrowRange: function narrowRange() {
      this.$emit('narrowRange', this.playerState.fiveCardHands.checkedHands);
      $(this.$el).modal('hide');
    },
    setChecksToDefault: function setChecksToDefault() {
      var settingsDefaultChecks = this.$store.state.account.user.settings.hitCalculator.defaultChecks;
      var defaultCheckedResults = settingsDefaultChecks.afterFlop.default.straightforward;

      this.playerState.fiveCardHands.madeHands.forEachLeaf(function (madeHand) {
        if (defaultCheckedResults.madeHands.includes(madeHand.id)) {
          madeHand.checked = true;
        } else {
          madeHand.checked = false;
        }
      });
      this.playerState.fiveCardHands.draws.forEachLeaf(function (draw) {
        if (defaultCheckedResults.draws.includes(draw.id)) {
          draw.checked = true;
        } else {
          draw.checked = false;
        }
      });
      this.playerState.fiveCardHands.combos.forEachLeaf(function (combo) {
        if (defaultCheckedResults.combos.includes(combo.id)) {
          combo.checked = true;
        } else {
          combo.checked = false;
        }
      });
    },
    setCollapsedValuesToDefault: function setCollapsedValuesToDefault() {
      this.playerState.fiveCardHands.setCollapsedValuesToDefaults(this.$store.state.account.user.settings);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "LQRi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LeNQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LkJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ln84":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__ = __webpack_require__("Ywgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__ = __webpack_require__("/CiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-purchase',
  components: {
    'errors-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__["a" /* default */],
    'card-number': __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__["CardNumber"],
    'card-expiry': __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__["CardExpiry"],
    'card-cvc': __WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__["CardCvc"]
  },
  data: function data() {
    return {
      stripeConsumerKey: "",
      options: {},
      complete: false,
      number: false,
      expiry: false,
      cvc: false,
      purchasing: false,
      errorsFromBackend: []
    };
  },
  computed: {
    daysLeftOnFreeTrial: function daysLeftOnFreeTrial() {
      return this.$store.getters['account/daysLeftOnFreeTrial'];
    },
    purchaseText: function purchaseText() {
      if (this.purchasing) {
        return 'Purchasing...';
      }

      return 'Purchase the Short Deck Hit Calculator for $150';
    }
  },
  watch: {
    number: function number() {
      this.update();
    },
    expiry: function expiry() {
      this.update();
    },
    cvc: function cvc() {
      this.update();
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.$destroy(); // because of stripe issue
    next();
  },
  methods: {
    update: function update() {
      this.complete = this.number && this.expiry && this.cvc;

      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus();
        } else if (!this.cvc) {
          this.$refs.cardCvc.focus();
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus();
        } else if (!this.number) {
          this.$refs.cardNumber.focus();
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    },
    purchase: function purchase() {
      var self = this;

      self.purchasing = true;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vue_stripe_elements_plus__["createToken"])().then(function (result) {
        if (result.error) {
          self.purchasing = false;
          self.errorsFromBackend.push(result.error.message);
        } else {
          self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/purchase-short-deck', {
            token: result.token.id
          }).then(function () {
            self.$store.commit('account/purchasePPT', 'short deck');
            self.purchasing = false;
            alert('Successfully purchased the short deck hit calculator!');
            self.$router.push({ path: '/account' });
          }).catch(function (e) {
            self.purchasing = false;
            __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].general.handleNetworkError(e);
          }).then(function () {
            if (true) {
              $FPROM.trackSignup({
                email: self.$store.state.account.user.email
              }, function () {
                console.log('Callback received!');
              });
              rdt('track', 'Purchase');
              // self.gtagReportConversion();
              self.microsoftReportConversion();
            }
          }).catch(function () {
            console.log('Error with the conversion tracking for ads.');
          });
        }
      }).catch(function (e) {
        self.purchasing = false;
        __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].general.handleNetworkError(e);
      });
    },
    gtagReportConversion: function gtagReportConversion(url) {
      var callback = function callback() {
        if (typeof url != 'undefined') {
          window.location = url;
        }
      };
      gtag('event', 'conversion', {
        'send_to': 'AW-714944788/w5PhCJ3ozqgBEJTi9NQC',
        'transaction_id': '',
        'event_callback': callback
      });
      return false;
    },
    microsoftReportConversion: function microsoftReportConversion() {
      var eventValue = 150;

      window.uetq = window.uetq || [];
      window.uetq.push('event', 'Subscribe', { event_value: eventValue });
    },
    clearAlert: function clearAlert() {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    }
  }
});

/***/ }),

/***/ "LxOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_help_toggle_help_button__ = __webpack_require__("T8TE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_controls_simulate_button__ = __webpack_require__("PQAu");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'betting-criteria-table',
  components: {
    'toggle-help-button': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_help_toggle_help_button__["a" /* default */],
    'simulate-button': __WEBPACK_IMPORTED_MODULE_2__components_controls_simulate_button__["a" /* default */]
  },
  props: ['state', 'breakevenPercentageViaPotOdds', 'breakevenPercentageViaRealOdds'],
  data: function data() {
    return {
      helpAreaVisible: false
    };
  },
  computed: {
    possibleBettingCriteria: function possibleBettingCriteria() {
      var possibleBettingCriteria = [];

      if (!this.state.bettingCriteria[this.state.streetToCall].threeToOne) {
        return [];
      }

      this.state.bettingCriteria[this.state.streetToCall].allValue.forEach(function (allValueBettingCriterion, i) {
        if (allValueBettingCriterion.equity !== null) {
          possibleBettingCriteria.push({
            allValue: this.state.bettingCriteria[this.state.streetToCall].allValue[i],
            threeToOne: this.state.bettingCriteria[this.state.streetToCall].threeToOne[i],
            twoToOne: this.state.bettingCriteria[this.state.streetToCall].twoToOne[i],
            oneToOne: this.state.bettingCriteria[this.state.streetToCall].oneToOne[i],
            oneToTwo: this.state.bettingCriteria[this.state.streetToCall].oneToTwo[i]
          });
        }
      }, this);

      return possibleBettingCriteria;
    }
  },
  methods: {
    fiveCardHandIdToDisplayString: function fiveCardHandIdToDisplayString(fiveCardHandId) {
      return this.state.players.find(0).states[1].fiveCardHands.find(fiveCardHandId).fullText;
    },
    getCellText: function getCellText(equity) {
      if (equity === null) {
        return 'n/a';
      }

      return (equity - this.breakevenPercentageViaRealOdds).roundToTwoDecimalPlaces() + '%';
    },
    getDiffClass: function getDiffClass(equity) {
      if (equity === null) {
        return;
      }

      return 'diff-' + Math.floor(equity - this.breakevenPercentageViaRealOdds);
    },
    getCellTitle: function getCellTitle(equity) {
      if (equity === null) {
        return 'Not enough bluffs availalble for this to be possible.';
      }
    },
    simulate: function simulate() {
      this.helpAreaVisible = true;
      this.$emit('simulate');
    }
  }
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9f9cac4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("ph2B");
function injectStyle (ssrContext) {
  __webpack_require__("YQ5K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c9f9cac4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MOzP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ma3k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_Players__ = __webpack_require__("IPbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__ = __webpack_require__("XRwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_service__ = __webpack_require__("JBFI");






var players = new __WEBPACK_IMPORTED_MODULE_0__services_player_Players__["a" /* default */]();

players.adjustForShortDeck();

var state = {
  hasSimulationBeenRun: false,
  presetCommunityCards: new __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__["a" /* default */](),
  players: players
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_2__services_share_url_service__["a" /* default */].setEquityCalculatorStoreState(stateFromServer, state);
  },
  setHasSimulationBeenRun: function setHasSimulationBeenRun(state, value) {
    state.hasSimulationBeenRun = value;
  },

  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHand(state, payload);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHands(state, payload);
  },
  selectSpecificHand: function selectSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function deselectSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectSpecificHand(state, payload);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHands(state, payload);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectAllGeneralHands(state, payload);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function setWeightOfSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightOfSpecificHand(state, payload);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function addComboToCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function removeComboFromCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeComboFromCombosToAdd(state, payload);
  },
  narrowRange: function narrowRange(state, payload) {
    state.players.find(payload.playerIndex).narrowRange(payload.checkedHands, state.presetCommunityCards, true);
  },

  // controls
  setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function setBoard(state, boardCards) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setBoard(state, boardCards, true);
  },
  removePresetCommunityCard: function removePresetCommunityCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetCommunityCard(state, position, true);
  },
  addPlayer: function addPlayer(state, payload) {
    payload = payload || {};
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addPlayer(state, payload);
    state.players.last.adjustForShortDeck();
  },
  removePlayer: function removePlayer(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePlayer(state, playerIndex);
  },
  updateEquityResults: function updateEquityResults(state, payload) {
    var player = void 0;
    var equity = void 0;
    var wins = void 0;
    var ties = void 0;
    var winFractions = void 0;
    var numberOfSimulations = payload.numberOfSimulations;
    var numPlayers = payload.simulationResults.length;

    for (var i = 0; i < numPlayers; i++) {
      player = state.players.find(i);
      wins = payload.simulationResults[i].wins;
      ties = payload.simulationResults[i].ties;
      winFractions = payload.simulationResults[i].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = (wins + winFractions) / numberOfSimulations * 100;
      equity -= equity * (payload.rakePercentage / 100) + equity * (payload.tipPercentage / 100);

      player.states[0].equity = equity;
      player.states[0].winPercentage = wins / numberOfSimulations * 100;
      player.states[0].tiePercentage = ties / numberOfSimulations * 100;
    }

    state.hasSimulationBeenRun = true;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations
});



/***/ }),

/***/ "Mdrr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"settings-container"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v("\n  General:\n  "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/settings/general/hand-rankings"}},[_vm._v("Hand rankings")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/general/saved-ranges"}},[_vm._v("Saved ranges")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/general/tiers"}},[_vm._v("Tiers")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/general/included-selectors"}},[_vm._v("Included selectors")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/general/visual"}},[_vm._v("Visual")])],1)]),_vm._v("\n  Equity calculator:\n  "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/settings/equity-calculator/rake-and-tip"}},[_vm._v("Rake and tip")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/equity-calculator/number-of-simulations"}},[_vm._v("Number of simulations")])],1)]),_vm._v("\n  Hit calculator:\n  "),_c('ul',[_c('li',[_vm._v("\n      Checkboxes:\n      "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/settings/hit-calculator/checkboxes/included"}},[_vm._v("Included")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/hit-calculator/checkboxes/collapsed-by-default"}},[_vm._v("Collapsed by default")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/hit-calculator/checkboxes/filters"}},[_vm._v("Filters")])],1)])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/hit-calculator/number-of-simulations"}},[_vm._v("Number of simulations")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings/hit-calculator/insights"}},[_vm._v("Insights")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Settings")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/qpXyZu0Ydfc?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "MlmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"saved-scenario-alert alert alert-info"},[_c('strong',[_vm._v("Saved scenario:")]),_vm._v(" "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N0Mf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N7/9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N8HT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_range_for_street_vue__ = __webpack_require__("73EF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446c527e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_range_for_street_vue__ = __webpack_require__("HYoF");
function injectStyle (ssrContext) {
  __webpack_require__("MOzP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-446c527e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_range_for_street_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_446c527e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_range_for_street_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "N8VK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator-help'
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_monkey_patches__ = __webpack_require__("hdqd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_monkey_patches___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_monkey_patches__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_axios__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
window.$ = __webpack_require__("7t+N");
__webpack_require__("gNGx");









__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_6_axios___default.a);
__WEBPACK_IMPORTED_MODULE_6_axios___default.a.interceptors.request.use(function (config) {
  config.withCredentials = true;
  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

$(function () {
  $('[data-toggle="popover"]').popover();
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "NVMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'save-scenario-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */]
  },
  data: function data() {
    return {
      scenarioName: ''
    };
  },
  methods: {
    save: function save() {
      this.$emit('save', this.scenarioName);
      $(this.$el).modal('hide');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "NZHB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_matrix_help_vue__ = __webpack_require__("hk4/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_531dd87c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_matrix_help_vue__ = __webpack_require__("RU07");
function injectStyle (ssrContext) {
  __webpack_require__("bwZm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-531dd87c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_matrix_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_531dd87c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_matrix_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NcAl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Help / Equity Calculator")])]),_vm._v(" "),_c('p',[_vm._v("Check out the videos in the playlist below:")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8D4oRivn2E6S_RebtRAJ3A","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Still need help?")]),_vm._v(" "),_c('p',[_vm._v("I'm here for you. Hit me up at "),_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(". I'd love to answer any questions you have.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ngfb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getCardsByRank: function getCardsByRank(cards) {
    var cardsByRank = {
      '2': [],
      '3': [],
      '4': [],
      '5': [],
      '6': [],
      '7': [],
      '8': [],
      '9': [],
      't': [],
      'j': [],
      'q': [],
      'k': [],
      'a': []
    };

    cards.forEach(function (card) {
      var rank = card[0];

      cardsByRank[rank].push(card);
    });

    return cardsByRank;
  },
  getCardsBySuit: function getCardsBySuit(cards) {
    var cardsBySuit = {
      c: [],
      s: [],
      h: [],
      d: []
    };

    cards.forEach(function (card) {
      var suit = card[1];
      cardsBySuit[suit].push(card);
    });

    return cardsBySuit;
  },
  checkIfRankIndexesAreSequential: function checkIfRankIndexesAreSequential(rankIndexes) {
    for (var i = 0; i < rankIndexes.length - 1; i++) {
      if (rankIndexes[i] + 1 !== rankIndexes[i + 1]) {
        return false;
      }
    }

    return true;
  }
});

/***/ }),

/***/ "NlOQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{staticClass:"onboarding-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[_c('h1',[_vm._v("New here?")]),_vm._v(" "),_c('p',[_vm._v("Looks like you haven't used the "+_vm._s(_vm.toolName)+" before. If so, it'd probably be a good idea to check out the "),_c('a',{attrs:{"href":""},on:{"click":function($event){return _vm.navigate($event)}}},[_vm._v(_vm._s(_vm.toolName)+" help page")]),_vm._v(" before moving forward.")]),_vm._v(" "),_c('h3',[_vm._v("Feel like you already know what you're doing?")]),_vm._v(" "),_c('p',[_vm._v("You'll probably be fine if you just start to play around. However, you may still pick up a few things if you check out the help page first. Investing that little bit of time upfront will probably be worth it in the long run. Even if you only learn one thing from the help page.")]),_vm._v(" "),_c('h3',[_vm._v("Still confused after checking out the help page?")]),_vm._v(" "),_c('p',[_vm._v("Don't worry, I'll help you out. These tools are all complex and I want to make sure that you really understand them, because if you don't, you won't derrive as much value from the app. Shoot me an email at "),_c('a',{attrs:{"href":"mailto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(". I'd be happy to answer any questions and/or Skype with you to get you started.")]),_vm._v(" "),_c('h3',[_vm._v("Hate pop-ups?")]),_vm._v(" "),_c('p',[_vm._v("Yeah, I do too. Don't worry though, this is the last time you'll see the pop-up on this page.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Np1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sharable-url-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */]
  },
  props: ['url', 'approximateWaitTime']
});

/***/ }),

/***/ "Nr+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_save_scenario_modal_vue__ = __webpack_require__("NVMa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750ecf29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_save_scenario_modal_vue__ = __webpack_require__("pT65");
function injectStyle (ssrContext) {
  __webpack_require__("LeNQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-750ecf29"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_save_scenario_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_750ecf29_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_save_scenario_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NwOM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'value-to-bluff-ratio',
  props: ['generalHands', 'communityCards'],
  data: function data() {
    return {
      idOfSelectedCutoffHand: 'pair:tpwk',
      cutoffHands: [{
        name: 'Royal flush',
        id: 'fourOfAKindPlus:royalFlush'
      }, {
        name: 'Straight flush',
        id: 'fourOfAKindPlus:straightFlush'
      }, {
        name: 'Four of a kind',
        id: 'fourOfAKindPlus:fourOfAKind'
      }, {
        name: 'Full house',
        id: 'fullHouse'
      }, {
        name: 'Nut flush',
        id: 'flush:nut'
      }, {
        name: 'Second nut flush',
        id: 'flush:secondNut'
      }, {
        name: 'Third nut flush',
        id: 'flush:thirdNut'
      }, {
        name: 'Weak flush',
        id: 'flush:weak'
      }, {
        name: 'Straight',
        id: 'straight'
      }, {
        name: 'Top set',
        id: 'threeOfAKind:topSet'
      }, {
        name: 'Second set',
        id: 'threeOfAKind:secondSet'
      }, {
        name: 'Third set',
        id: 'threeOfAKind:thirdSet'
      }, {
        name: 'Fourth set',
        id: 'threeOfAKind:fourthSet'
      }, {
        name: 'Middle set',
        id: 'threeOfAKind:middleSet'
      }, {
        name: 'Bottom set',
        id: 'threeOfAKind:bottomSet'
      }, {
        name: 'Trips',
        id: 'threeOfAKind:trips'
      }, {
        name: 'Two pair using top board card',
        id: 'twoPair:usingTopBoardCard'
      }, {
        name: 'Weak two pair',
        id: 'twoPair:weak'
      }, {
        name: 'Overpair',
        id: 'pair:overpair'
      }, {
        name: 'TPTK',
        id: 'pair:tptk'
      }, {
        name: 'TPGK',
        id: 'pair:tpgk'
      }, {
        name: 'TPWK',
        id: 'pair:tpwk'
      }, {
        name: 'PP under TP',
        id: 'pair:ppUnderTp'
      }, {
        name: 'Second pair',
        id: 'pair:secondPair'
      }, {
        name: 'Middle pair',
        id: 'pair:middlePair'
      }, {
        name: 'Weak pair',
        id: 'pair:weakPair'
      }, {
        name: 'Ace high',
        id: 'highCard:aceHigh'
      }]
    };
  },
  computed: {
    percentOfSelectedRangeThatIsValue: function percentOfSelectedRangeThatIsValue() {
      return this.generalHands.getPercentOfSelectedRangeThatIsValue(this.idOfSelectedCutoffHand, this.communityCards);
    },
    percentOfSelectedRangeThatIsBluffs: function percentOfSelectedRangeThatIsBluffs() {
      return (100 - this.percentOfSelectedRangeThatIsValue).roundToTwoDecimalPlaces();
    }
  },
  mounted: function mounted() {
    $(this.$el).find('[data-toggle="popover"]').popover({
      html: true
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "O+62":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tiers-settings settings"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.tiers),function(tier,index){return _c('div',[_c('label',[_vm._v("\n      Tier "+_vm._s(index + 1)+":\n    ")]),_vm._v(" "),(!_vm.shortDeck)?_c('grid-selector',{attrs:{"generalHands":tier.generalHands,"specificHandsNotAllowed":true},on:{"selectGeneralHand":function($event){return _vm.selectGeneralHand($event.generalHandString, tier.generalHands)},"deselectGeneralHand":function($event){return _vm.deselectGeneralHand($event, tier.generalHands)},"selectGeneralHands":function($event){return _vm.selectGeneralHands($event, tier.generalHands)},"deselectGeneralHands":function($event){return _vm.deselectGeneralHands($event, tier.generalHands)}}}):_vm._e(),_vm._v(" "),(_vm.shortDeck)?_c('short-deck-grid-selector',{attrs:{"generalHands":tier.generalHands,"specificHandsNotAllowed":true},on:{"selectGeneralHand":function($event){return _vm.selectGeneralHand($event.generalHandString, tier.generalHands)},"deselectGeneralHand":function($event){return _vm.deselectGeneralHand($event, tier.generalHands)},"selectGeneralHands":function($event){return _vm.selectGeneralHands($event, tier.generalHands)},"deselectGeneralHands":function($event){return _vm.deselectGeneralHands($event, tier.generalHands)}}}):_vm._e(),_vm._v(" "),_c('hr')],1)}),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-lg",attrs:{"type":"button"},on:{"click":function($event){return _vm.reset()}}},[_vm._v("Set to defaults")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button"},on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_c('p',[_vm._v("When you click one of the tiers highlighted in the picture below, it will add/remove hands from the range based on how the tiers are set above.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/tiers/tiers.png"}})]):_vm._e()],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Tiers")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("The default tiers come from the "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/Texas_hold_%27em_starting_hands#Sklansky_hand_groups"}},[_vm._v("Sklansky hand groups")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O/F6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Help / Should You Bluff")])]),_vm._v(" "),_c('p',[_vm._v("Check out the videos in the playlist below:")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8rMORHUibOfufweZL8ki9s","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Still need help?")]),_vm._v(" "),_c('p',[_vm._v("I'm here for you. Hit me up at "),_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(". I'd love to answer any questions you have.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O7Wo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_turn_selector__ = __webpack_require__("SOcV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_pot_odds_selector__ = __webpack_require__("a398");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_call_conclusions_betting_criteria_table__ = __webpack_require__("E+KM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__ = __webpack_require__("unvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_call_help_range__ = __webpack_require__("9sL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-turn-steps',
  components: {
    'turn-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_turn_selector__["a" /* default */],
    'pot-odds-selector': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_pot_odds_selector__["a" /* default */],
    'betting-criteria-table': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_call_conclusions_betting_criteria_table__["a" /* default */],
    'set-range-step': __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__["a" /* default */],
    'range-help-section': __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_call_help_range__["a" /* default */]
  },
  props: ['state', 'textWhenFiveCardHandPercentagesArentUpToDate', 'authorized'],
  methods: {
    getTextForPlayerRangeStep: function getTextForPlayerRangeStep(playerIndex) {
      var numOpponents = this.state.players.numPlayers;

      if (this.state.streetToCall === 'turn' && numOpponents === 1) {
        return 'Step ' + (7 + numOpponents * 2 + playerIndex) + ': What do you think your opponent would bet the turn with?';
      } else if (this.state.streetToCall === 'turn' && numOpponents > 1) {
        return 'Step ' + (7 + numOpponents * 2 + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is after the turn action is finished (eg. heading in to the river)?';
      } else if (this.state.streetToCall !== 'turn' && numOpponents === 1) {
        return 'Step ' + (6 + numOpponents * 2 + playerIndex) + ': What do you think your opponents range is after the turn action is finished (eg. heading in to the river)?';
      } else if (this.state.streetToCall !== 'turn' && numOpponents > 1) {
        return 'Step ' + (6 + numOpponents * 2 + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is after the turn action is finished (eg. heading in to the river)?';
      }
    }
  }
});

/***/ }),

/***/ "OBk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vertical-set-weight-to-apply-to-added-hands-with-settings',
  components: {
    'vue-slider': __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },
  props: ['disabled'],
  data: function data() {
    return {
      buttons: [100, 75, 25],
      indexOfActiveButton: 0,
      sliderOptions: {
        min: 5,
        value: 100,
        interval: 5,
        width: 4,
        height: 285,
        direction: 'vertical',
        tooltip: 'hover',
        tooltipDir: 'top',
        style: {
          'margin-right': '5px',
          'margin-left': '-2px'
        },
        sliderStyle: {
          cursor: 'ns-resize'
        }
      }
    };
  },
  methods: {
    handleSliderChange: function handleSliderChange(newValue) {
      this.buttons[this.indexOfActiveButton] = newValue;
      this.$emit('setWeightToApplyToAddedHands', newValue);
      this.$forceUpdate();
    },
    selectButton: function selectButton(buttonIndex) {
      this.indexOfActiveButton = buttonIndex;
      this.$refs.slider.setValue(this.buttons[buttonIndex]);
    },
    refreshVueSlider: function refreshVueSlider() {
      var self = this;

      setTimeout(function () {
        // needs a setTimeout for some reason
        self.$refs.slider.refresh();
      });
    }
  }
});

/***/ }),

/***/ "OGsk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_readonly_alert__ = __webpack_require__("lDlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hand_range_grid_selector_grid_selector__ = __webpack_require__("G1lD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_range_constructor_action_selector__ = __webpack_require__("7gy8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_sharable_url_modal__ = __webpack_require__("hu4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_save_scenario_modal__ = __webpack_require__("Nr+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_onboarding_modal__ = __webpack_require__("iexb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_controls_create_sharable_url_button__ = __webpack_require__("zMC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_controls_save_scenario_button__ = __webpack_require__("A/Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_help_icon__ = __webpack_require__("FmIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'range-constructor',
  components: {
    'readonly-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_readonly_alert__["a" /* default */],
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_saved_scenario_alert__["a" /* default */],
    'grid-selector': __WEBPACK_IMPORTED_MODULE_2__components_hand_range_grid_selector_grid_selector__["a" /* default */],
    'action-selector': __WEBPACK_IMPORTED_MODULE_3__components_range_constructor_action_selector__["a" /* default */],
    'create-sharable-url-button': __WEBPACK_IMPORTED_MODULE_8__components_controls_create_sharable_url_button__["a" /* default */],
    'save-scenario-button': __WEBPACK_IMPORTED_MODULE_9__components_controls_save_scenario_button__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_7__components_onboarding_modal__["a" /* default */],
    'help-icon': __WEBPACK_IMPORTED_MODULE_10__components_help_icon__["a" /* default */]
  },
  computed: {
    state: function state() {
      return this.$store.state.rangeConstructor;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.rangeConstructor.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    actionsWithIds: function actionsWithIds() {
      return this.state.actions.map(function (action) {
        action.id = __WEBPACK_IMPORTED_MODULE_11_lodash___default.a.uniqueId();

        return action;
      });
    },
    authorized: function authorized() {
      return this.$store.getters['account/authorizedForPremium'];
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.load();
    }

    this.handleOnboard();
  },
  methods: {
    // mounted
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default range constructor page.');
          self.$router.push('/range-constructor');
        } else {
          self.$store.commit('rangeConstructor/setState', response.data.storeState);
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default range constructor page.');
        self.$router.push('/range-constructor');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.rangeConstructor) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'rangeConstructor' }).then(function () {
        self.$store.commit('account/onboard', 'rangeConstructor');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },
    selectGeneralHand: function selectGeneralHand(generalHandString) {
      if (!this.authorized) {
        return;
      }

      this.$store.commit('rangeConstructor/selectGeneralHand', generalHandString);
    },
    deselectGeneralHand: function deselectGeneralHand(generalHandString) {
      if (!this.authorized) {
        return;
      }

      this.$store.commit('rangeConstructor/deselectGeneralHand', generalHandString);
    },
    selectGeneralHands: function selectGeneralHands(generalHandStrings) {
      if (!this.authorized) {
        return;
      }

      this.$store.commit('rangeConstructor/selectGeneralHands', generalHandStrings);
    },
    deselectGeneralHands: function deselectGeneralHands(generalHandStrings) {
      if (!this.authorized) {
        return;
      }

      this.$store.commit('rangeConstructor/deselectGeneralHands', generalHandStrings);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "OIE4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_five_card_hands_FiveCardHands__ = __webpack_require__("JKDa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_five_card_hands_section__ = __webpack_require__("+Gii");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator-checkboxes-filters-settings',
  components: {
    'five-card-hands-section': __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_five_card_hands_section__["a" /* default */]
  },
  data: function data() {
    var userDefinedFilters = [];

    this.$store.state.account.user.settings.hitCalculator.userDefinedFilters.forEach(function (userDefinedFilterFromSettings) {
      var userDefinedFilterToAdd = {
        name: userDefinedFilterFromSettings.name,
        fiveCardHands: new __WEBPACK_IMPORTED_MODULE_0__services_five_card_hands_FiveCardHands__["a" /* default */]()
      };

      userDefinedFilterToAdd.fiveCardHands.madeHands.forEachLeaf(function (madeHandLeaf) {
        if (userDefinedFilterFromSettings.fiveCardHands.madeHands.includes(madeHandLeaf.id)) {
          madeHandLeaf.checked = true;
        }
      });
      userDefinedFilterToAdd.fiveCardHands.draws.forEachLeaf(function (drawLeaf) {
        if (userDefinedFilterFromSettings.fiveCardHands.draws.includes(drawLeaf.id)) {
          drawLeaf.checked = true;
        }
      });
      userDefinedFilterToAdd.fiveCardHands.combos.forEachLeaf(function (comboLeaf) {
        if (userDefinedFilterFromSettings.fiveCardHands.combos.includes(comboLeaf.id)) {
          comboLeaf.checked = true;
        }
      });
      userDefinedFilters.push(userDefinedFilterToAdd);
    });

    return {
      userDefinedFilters: userDefinedFilters,
      isHelpVisible: false
    };
  },
  methods: {
    addFilter: function addFilter() {
      this.userDefinedFilters.push({
        name: '',
        fiveCardHands: new __WEBPACK_IMPORTED_MODULE_0__services_five_card_hands_FiveCardHands__["a" /* default */]()
      });
    },
    removeFilter: function removeFilter(index) {
      this.userDefinedFilters.splice(index, 1);
    },
    setCheckedValueOfFiveCardHand: function setCheckedValueOfFiveCardHand(fiveCardHands, payload) {
      fiveCardHands.find(payload.fiveCardHandId).checked = payload.newCheckedValue;
    },
    toggleCollapsedValueOfFiveCardHandParent: function toggleCollapsedValueOfFiveCardHandParent(fiveCardHandParent) {
      fiveCardHandParent.collapsed = !fiveCardHandParent.collapsed;
    },
    areUserDefinedFiltersValid: function areUserDefinedFiltersValid() {
      var userDefinedFilter = void 0;

      for (var i = 0; i < this.userDefinedFilters.length; i++) {
        userDefinedFilter = this.userDefinedFilters[i];

        if (userDefinedFilter.name.length === 0) {
          return false;
        }
      }

      return true;
    },
    save: function save() {
      if (!this.areUserDefinedFiltersValid()) {
        alert('Make sure that all filters have a name.');
        return;
      }

      var self = this;
      var user = _.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.userDefinedFilters = this._getUserDefinedFiltersForServer();
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    _getUserDefinedFiltersForServer: function _getUserDefinedFiltersForServer() {
      var userDefinedFilterForServer = void 0;
      var userDefinedFiltersForServer = [];

      this.userDefinedFilters.forEach(function (userDefinedFilter) {
        userDefinedFilterForServer = this.__getUserDefinedFilterForServer(userDefinedFilter);
        userDefinedFiltersForServer.push(userDefinedFilterForServer);
      }, this);

      return userDefinedFiltersForServer;
    },
    __getUserDefinedFilterForServer: function __getUserDefinedFilterForServer(userDefinedFilter) {
      var userDefinedFilterForServer = {
        name: userDefinedFilter.name,
        fiveCardHands: {
          madeHands: [],
          draws: [],
          combos: []
        }
      };

      userDefinedFilter.fiveCardHands.madeHands.forEachCheckedLeaf(function (checkedMadeHandLeaf) {
        userDefinedFilterForServer.fiveCardHands.madeHands.push(checkedMadeHandLeaf.id);
      });
      userDefinedFilter.fiveCardHands.draws.forEachCheckedLeaf(function (checkedDrawLeaf) {
        userDefinedFilterForServer.fiveCardHands.draws.push(checkedDrawLeaf.id);
      });
      userDefinedFilter.fiveCardHands.combos.forEachCheckedLeaf(function (checkedComboLeaf) {
        userDefinedFilterForServer.fiveCardHands.combos.push(checkedComboLeaf.id);
      });

      return userDefinedFilterForServer;
    }
  }
});

/***/ }),

/***/ "OU8i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_final_conclusion_vue__ = __webpack_require__("0HTX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e15863e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_final_conclusion_vue__ = __webpack_require__("9wNP");
function injectStyle (ssrContext) {
  __webpack_require__("AGWH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e15863e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_final_conclusion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e15863e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_final_conclusion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OjzM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_selector_vue__ = __webpack_require__("idVL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84a39c02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_selector_vue__ = __webpack_require__("zdHq");
function injectStyle (ssrContext) {
  __webpack_require__("5D18")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84a39c02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_slider_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84a39c02_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_slider_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Os5f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P13r":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home"},[_c('errors-alert',{attrs:{"errors":_vm.errorsFromBackend},on:{"clear":function($event){return _vm.clearAlert()}}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/logo.png"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('router-link',{attrs:{"to":"/register"}},[_c('button',{staticClass:"btn btn-primary btn-block btn-lg"},[_vm._v("Register")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Check out the quiz below to get more of a feel for what you can do with Six Plus Hold’em.")]),_vm._v(" "),_c('section',{staticClass:"quiz well"},[_vm._m(3),_vm._v(" "),_c('section',{staticClass:"question-container"},[_c('h3',[_vm._v("1) How many folds will you get on a K84 rainbow board if you cbet and only get called by pairs and better?")]),_vm._v(" "),_c('section',{staticClass:"choices"},[_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[0].selection !== null,
            'selected': _vm.questions[0].selection === 0,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[0], 0)}}},[_vm._v("\n          30%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[0].selection !== null,
            'selected': _vm.questions[0].selection === 1,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[0], 1)}}},[_vm._v("\n          40%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[0].selection !== null,
            'selected': _vm.questions[0].selection === 2,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[0], 2)}}},[_vm._v("\n          50%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[0].selection !== null,
            'selected': _vm.questions[0].selection === 3,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[0], 3)}}},[_vm._v("\n          60%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[0].selection !== null,
            'selected': _vm.questions[0].selection === 4,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[0], 4)}}},[_vm._v("\n          70%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[0].selection !== null,
            'selected': _vm.questions[0].selection === 5,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[0], 5)}}},[_vm._v("\n          80%\n        ")])]),_vm._v(" "),(_vm.questions[0].selection !== null)?_c('section',[(_vm.questions[0].selection === _vm.questions[0].answer)?_c('section',{staticClass:"alert alert-success"},[_vm._v("\n          Correct! "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.questions[0].selection !== _vm.questions[0].answer)?_c('section',{staticClass:"alert alert-danger"},[_vm._v("\n          Incorrect. The correct answer was 60%. "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"well"},[_vm._m(4),_vm._v(" "),_c('p',[_vm._v("Let's assume that we open preflop and get called by a 25% range, where the bottom of the range includes stuff like A9o, 54s, and 96s, and we remove QQ+/AK from the top of the range. If we then assume that they'll only continue on the flop with pairs or better, we're going to be generating about 60% folds. That means that cbet bluffing will be super profitable!")]),_vm._v(" "),_c('p',[_vm._v("Of course, these assumptions won't always apply. Sometimes people will call with stuff like gutshots and AQ. Sometimes they'll check-raise as a bluff. Sometimes they'll enter the flop with a stronger range.")]),_vm._v(" "),_c('p',[_vm._v("This quiz question was just meant to wet your appetite. If you want to explore other scenarios, head over to the "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" page to get started with your "),_c('strong',[_vm._v("14 day free trail")]),_vm._v(" (no credit card required).")],1)])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"question-container"},[_c('h3',[_vm._v("2) What if we change the board to KJ2shh and add in flush draws and straight draws?")]),_vm._v(" "),_c('section',{staticClass:"choices"},[_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[1].selection !== null,
            'selected': _vm.questions[1].selection === 0,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[1], 0)}}},[_vm._v("\n          30%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[1].selection !== null,
            'selected': _vm.questions[1].selection === 1,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[1], 1)}}},[_vm._v("\n          40%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[1].selection !== null,
            'selected': _vm.questions[1].selection === 2,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[1], 2)}}},[_vm._v("\n          50%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[1].selection !== null,
            'selected': _vm.questions[1].selection === 3,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[1], 3)}}},[_vm._v("\n          60%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[1].selection !== null,
            'selected': _vm.questions[1].selection === 4,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[1], 4)}}},[_vm._v("\n          70%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[1].selection !== null,
            'selected': _vm.questions[1].selection === 5,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[1], 5)}}},[_vm._v("\n          80%\n        ")])]),_vm._v(" "),(_vm.questions[1].selection !== null)?_c('section',[(_vm.questions[1].selection === _vm.questions[1].answer)?_c('section',{staticClass:"alert alert-success"},[_vm._v("\n          Correct! "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.questions[1].selection !== _vm.questions[1].answer)?_c('section',{staticClass:"alert alert-danger"},[_vm._v("\n          Incorrect. The correct answer was 40%. "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"well"},[_vm._m(5),_vm._v(" "),_c('p',[_vm._v("Let's assume that we open preflop and get called by a 25% range, where the bottom of the range includes stuff like A9o, 54s, and 96s, and we remove QQ+/AK from the top of the range. If we then assume that they'll only continue on the flop with pairs or better, flush draws, and open ended straight draws, we're going to be generating about 40% folds. That means that a cbet bluff will still usually be profitable, but not always.")]),_vm._v(" "),_c('p',[_vm._v("Of course, these assumptions won't always apply. Sometimes people will call with stuff like gutshots and AX. Sometimes they'll check-raise as a bluff. Sometimes they'll enter the flop with a stronger range.")]),_vm._v(" "),_c('p',[_vm._v("This quiz question was just meant to wet your appetite. If you want to explore other scenarios, head over to the "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" page to get started with your "),_c('strong',[_vm._v("14 day free trail")]),_vm._v(" (no credit card required).")],1)])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"question-container"},[_c('h3',[_vm._v("3) Assume we get called on the flop in the previous question, and that the turn is a 4h, completing the flush draws. How many folds will you get if they only continue with top pair and better?")]),_vm._v(" "),_c('section',{staticClass:"choices"},[_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[2].selection !== null,
            'selected': _vm.questions[2].selection === 0,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[2], 0)}}},[_vm._v("\n          30%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[2].selection !== null,
            'selected': _vm.questions[2].selection === 1,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[2], 1)}}},[_vm._v("\n          40%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[2].selection !== null,
            'selected': _vm.questions[2].selection === 2,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[2], 2)}}},[_vm._v("\n          50%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[2].selection !== null,
            'selected': _vm.questions[2].selection === 3,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[2], 3)}}},[_vm._v("\n          60%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[2].selection !== null,
            'selected': _vm.questions[2].selection === 4,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[2], 4)}}},[_vm._v("\n          70%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[2].selection !== null,
            'selected': _vm.questions[2].selection === 5,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[2], 5)}}},[_vm._v("\n          80%\n        ")])]),_vm._v(" "),(_vm.questions[2].selection !== null)?_c('section',[(_vm.questions[2].selection === _vm.questions[2].answer)?_c('section',{staticClass:"alert alert-success"},[_vm._v("\n          Correct! "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.questions[2].selection !== _vm.questions[2].answer)?_c('section',{staticClass:"alert alert-danger"},[_vm._v("\n          Incorrect. The correct answer was 60%. "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"well"},[_vm._m(6),_vm._v(" "),_c('p',[_vm._v("A lot of people are scared by the possible flush completing. They worry that their opponent called the flop with a lot of flush draws, and now all of those flush draws became flushes, which means it's time to give up.")]),_vm._v(" "),_c('p',[_vm._v("In reality, this fear is exaggerated. In fact, it can work to your advantage! Many of your opponents will have the same fears. They'll see the flush complete and want to get out of there with any mediocre hands. That means that you'll be able to generate a lot of folds.")]),_vm._v(" "),_c('p',[_vm._v("Of course, these assumptions won't always apply. This quiz question was just meant to wet your appetite. If you want to explore other scenarios, head over to the "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" page to get started with your "),_c('strong',[_vm._v("14 day free trail")]),_vm._v(" (no credit card required).")],1)])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"question-container"},[_c('h3',[_vm._v("4) Can you ever get away from KK preflop?")]),_vm._v(" "),_c('section',{staticClass:"choices"},[_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[3].selection !== null,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[3], 0)}}},[_vm._v("\n          Yes\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[3].selection !== null,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[3], 0)}}},[_vm._v("\n          No\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[3].selection !== null,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[3], 0)}}},[_vm._v("\n          Maybe\n        ")])]),_vm._v(" "),(_vm.questions[3].selection !== null)?_c('section',[(_vm.questions[3].selection === _vm.questions[3].answer)?_c('section',{staticClass:"alert alert-success"},[_vm._v("\n          All answers were considered to be correct here; this one was a freebie :) "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"well"},[_vm._m(7),_vm._v(" "),_c('p',[_vm._v("This was meant as a fun one. Please don't go around folding KK all the time and blaming me! Laying it down is very frequently going to be a big mistake.")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_vm._v("The reason I chose this question is because it demonstrates how to think probabilistically using weighted ranges. That skill will be important for many, many other parts of poker.")]),_vm._v(" "),_c('p',[_vm._v("Here it's just about how likely they have QQ or AK, so it was a good example to demonstrate how that sort of thinking works, but in other spots things get a little bit more involved. Nothing too crazy though! Six Plus Hold’em does a lot of the heavy lifting for you.")]),_vm._v(" "),_c('p',[_vm._v("If you want to explore other scenarios, head over to the "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" page to get started with your "),_c('strong',[_vm._v("14 day free trail")]),_vm._v(" (no credit card required).")],1)])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"question-container"},[_c('h3',[_vm._v("5) What hands can you call a shove with when a short stack shoves for 20bb over your 2bb open, and is shoving A7+ and 44+?")]),_vm._v(" "),_c('section',{staticClass:"choices"},[_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[4].selection !== null,
            'selected': _vm.questions[4].selection === 0,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[4], 0)}}},[_vm._v("\n          22+, A2+\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[4].selection !== null,
            'selected': _vm.questions[4].selection === 1,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[4], 1)}}},[_vm._v("\n          44+, A7+\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[4].selection !== null,
            'selected': _vm.questions[4].selection === 2,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[4], 2)}}},[_vm._v("\n          66+, AT+\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[4].selection !== null,
            'selected': _vm.questions[4].selection === 3,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[4], 3)}}},[_vm._v("\n          77+, AJ+\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[4].selection !== null,
            'selected': _vm.questions[4].selection === 4,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[4], 4)}}},[_vm._v("\n          88+, AQ+\n        ")])]),_vm._v(" "),(_vm.questions[4].selection !== null)?_c('section',[(_vm.questions[4].selection === _vm.questions[4].answer)?_c('section',{staticClass:"alert alert-success"},[_vm._v("\n          Correct! "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.questions[4].selection !== _vm.questions[4].answer)?_c('section',{staticClass:"alert alert-danger"},[_vm._v("\n          Incorrect. The correct answer was \"66+, AT+\". "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"well"},[_vm._m(9),_vm._v(" "),_c('p',[_vm._v("To answer this question, there are two things we need to do. 1) Figure out what our required equity is, and 2) figure out what hands meet that requirement.")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("To figure out what hands meet that requirement, we use the equity matrix tool ("),_c('router-link',{attrs:{"to":"/help/equity-matrix"}},[_vm._v("overview")]),_vm._v("), and find out that the answer is roughly 66+, AT+.")],1),_vm._v(" "),_c('p',[_vm._v("If you want to explore other scenarios, head over to the "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" page to get started with your "),_c('strong',[_vm._v("14 day free trail")]),_vm._v(" (no credit card required).")],1)])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"question-container"},[_c('h3',[_vm._v("6) What hands can you 3bet with for value if they open a 20% range and call your 3bet 75% of the time?")]),_vm._v(" "),_c('section',{staticClass:"choices"},[_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[5].selection !== null,
            'selected': _vm.questions[5].selection === 0,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[5], 0)}}},[_vm._v("\n          88+, AJ+\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[5].selection !== null,
            'selected': _vm.questions[5].selection === 1,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[5], 1)}}},[_vm._v("\n          TT+, AQ+\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[5].selection !== null,
            'selected': _vm.questions[5].selection === 2,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[5], 2)}}},[_vm._v("\n          QQ+, AK\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[5].selection !== null,
            'selected': _vm.questions[5].selection === 3,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[5], 3)}}},[_vm._v("\n          KK+\n        ")])]),_vm._v(" "),(_vm.questions[5].selection !== null)?_c('section',[(_vm.questions[5].selection === _vm.questions[5].answer)?_c('section',{staticClass:"alert alert-success"},[_vm._v("\n          Correct! "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.questions[5].selection !== _vm.questions[5].answer)?_c('section',{staticClass:"alert alert-danger"},[_vm._v("\n          Incorrect. The correct answer was \"88+, AJ+\". "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"well"},[_vm._m(11),_vm._v(" "),_c('p',[_vm._v("To answer this question, we want to know how much equity we have against the range that they're going to continue with. If they open with the top 20% of hands and continue 75% of the time, we can probably reduce the 20% range to 15%, and then remove AA and KK assuming that they'd 4bet those hands.")]),_vm._v(" "),_c('p',[_vm._v("Then, we can head over to the equity matrix tool ("),_c('router-link',{attrs:{"to":"/help/equity-matrix"}},[_vm._v("overview")]),_vm._v(") and simulate to see how we're doing against that range. Hands that have over 50% equity are good candidates to 3bet with for value, although you'll also want to consider things like postflop playability and position.")],1),_vm._v(" "),_c('p',[_vm._v("If you want to explore other scenarios, head over to the "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" page to get started with your "),_c('strong',[_vm._v("14 day free trail")]),_vm._v(" (no credit card required).")],1)])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"question-container"},[_c('h3',[_vm._v("7) Can you 3bet bluff if they call your 3bet 60% of the time, and then continue vs cbets 40% of the time?")]),_vm._v(" "),_c('section',{staticClass:"choices"},[_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[6].selection !== null,
            'selected': _vm.questions[6].selection === 0,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[6], 0)}}},[_vm._v("\n          Yes\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[6].selection !== null,
            'selected': _vm.questions[6].selection === 1,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[6], 1)}}},[_vm._v("\n          No\n        ")])]),_vm._v(" "),(_vm.questions[6].selection !== null)?_c('section',[(_vm.questions[6].selection === _vm.questions[6].answer)?_c('section',{staticClass:"alert alert-success"},[_vm._v("\n          Correct! "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.questions[6].selection !== _vm.questions[6].answer)?_c('section',{staticClass:"alert alert-danger"},[_vm._v("\n          Incorrect. The correct answer was \"Yes\". "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"well"},[_vm._m(12),_vm._v(" "),_c('p',[_vm._v("To answer this question, we need to use the 3bet-cbet explorer ("),_c('router-link',{attrs:{"to":"/help/three-bet-cbet-explorer"}},[_vm._v("overview")]),_vm._v("). You plug in a bunch of inputs, and it tells you the EV of taking a 3bet-cbet line. The inputs help you estimate how they respond to your 3bet, how often you get 4bet, how they respond to the cbet, and how often they pay you off when you happen to smash the flop.")],1),_vm._v(" "),_c('p',[_vm._v("Generally, when they're only defending vs the follow-up cbet 40% of the time, the 3bet-cbet line will be pretty +EV.")]),_vm._v(" "),_c('p',[_vm._v("It does depend on the assumptions you make though. If you want to explore other scenarios, head over to the "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" page to get started with your "),_c('strong',[_vm._v("14 day free trail")]),_vm._v(" (no credit card required).")],1)])]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"question-container"},[_c('h3',[_vm._v("8) How often does a full pot bluff need to work on the turn when you have a flush draw and expect to get paid off on the river?")]),_vm._v(" "),_c('section',{staticClass:"choices"},[_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[7].selection !== null,
            'selected': _vm.questions[7].selection === 0,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[7], 0)}}},[_vm._v("\n          30%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-success': _vm.questions[7].selection !== null,
            'selected': _vm.questions[7].selection === 1,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[7], 1)}}},[_vm._v("\n          35%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[7].selection !== null,
            'selected': _vm.questions[7].selection === 2,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[7], 2)}}},[_vm._v("\n          40%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[7].selection !== null,
            'selected': _vm.questions[7].selection === 3,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[7], 3)}}},[_vm._v("\n          45%\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{
            'btn-danger': _vm.questions[7].selection !== null,
            'selected': _vm.questions[7].selection === 3,
          },on:{"click":function($event){return _vm.submitAnswer(_vm.questions[7], 3)}}},[_vm._v("\n          50%\n        ")])]),_vm._v(" "),(_vm.questions[7].selection !== null)?_c('section',[(_vm.questions[7].selection === _vm.questions[7].answer)?_c('section',{staticClass:"alert alert-success"},[_vm._v("\n          Correct! "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.questions[7].selection !== _vm.questions[7].answer)?_c('section',{staticClass:"alert alert-danger"},[_vm._v("\n          Incorrect. The correct answer was 35%. "+_vm._s(_vm.currentScoreText)+"\n        ")]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"well"},[_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('p',[_vm._v("But that formula doesn't capture the whole story. What if we have outs? What if there are river cards that we have +EV bluffs on? The risk-reward formula doesn't take those things into account, but the breakeven percentage for bluffing the turn tool does ("),_c('router-link',{attrs:{"to":"/help/breakeven-percentage-for-bluffing-the-turn"}},[_vm._v("overview")]),_vm._v("). With that tool, we find that the 50% number drops down to about 35% when we have a flush draw and are betting full pot.")],1),_vm._v(" "),_c('p',[_vm._v("If you want to explore other scenarios, head over to the "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" page to get started with your "),_c('strong',[_vm._v("14 day free trail")]),_vm._v(" (no credit card required).")],1)])]):_vm._e()])]),_vm._v(" "),_c('section',{staticClass:"other-questions"},[_vm._m(15),_vm._v(" "),_c('section',[_c('h3',[_vm._v("Are there any options for short deck?")]),_vm._v(" "),_c('p',[_vm._v("Yes! There are short deck versions of the "),_c('router-link',{attrs:{"to":"/short-deck/equity-calculator"}},[_vm._v("equity calculator")]),_vm._v(" and hit calculator.")],1),_vm._v(" "),_c('p',[_vm._v("The equity calculator is free (I'm experimenting with monetizing via affiliate links), and the hit calculator is $150. Check out the "),_c('router-link',{attrs:{"to":"/short-deck-pricing"}},[_vm._v("short deck pricing page")]),_vm._v(" for more information.")],1)]),_vm._v(" "),_c('section',[_c('h3',[_vm._v("Where can you go if you want to learn more?")]),_vm._v(" "),_c('p',[_vm._v("Check out the "),_c('router-link',{attrs:{"to":"/faq"}},[_vm._v("FAQ page")]),_vm._v(", the "),_c('router-link',{attrs:{"to":"/help"}},[_vm._v("help page")]),_vm._v(", and the "),_c('a',{attrs:{"href":"https://www.youtube.com/channel/UCNrKf4FUAN6E8NoSDKV20Ng","target":"_blank"}},[_vm._v("YouTube channel")]),_vm._v(".")],1),_vm._v(" "),_c('p',[_vm._v("Also, never hesitate to "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("get in touch")]),_vm._v("!")],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8vRDnCZ_h1XsBar-k190Bs","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"row"},[_c('section',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("14 day free trial")])]),_vm._v(" "),_c('section',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("$25 for the basic plan")])]),_vm._v(" "),_c('section',{staticClass:"col-xs-4"},[_c('strong',[_vm._v("$75 for the premium plan")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel slide",attrs:{"id":"carousel","data-ride":"carousel"}},[_c('div',{staticClass:"carousel-inner"},[_c('div',{staticClass:"item active"},[_c('img',{attrs:{"src":"/static/carousel/10.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/11.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/12.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/1.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/2.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/8.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/9.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/3.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/4.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/5.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/6.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/7.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/13.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/14.png"}})]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('img',{attrs:{"src":"/static/carousel/15.png"}})])]),_vm._v(" "),_c('a',{staticClass:"left carousel-control",attrs:{"href":"#carousel","data-slide":"prev"}},[_c('span',{staticClass:"glyphicon glyphicon-chevron-left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Previous")])]),_vm._v(" "),_c('a',{staticClass:"right carousel-control",attrs:{"href":"#carousel","data-slide":"next"}},[_c('span',{staticClass:"glyphicon glyphicon-chevron-right"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v("Next")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h2',{staticClass:"page-header"},[_vm._v("Quiz")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/3bbXx2TQLGQ?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/dNQsztMLAFE?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/jVXpVRpkFrs?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/NExb5KXxorM?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("However, as the video demonstrates, "),_c('em',[_vm._v("if")]),_vm._v(" you're confident enough that their range is KK+ — that they don't even have QQ or AK — then you can go ahead and lay it down. Hey, some opponents really are that nitty.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/zmvxZ3A9ysA?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("To figure out our required equity, we use the "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(" formula. We're risking 18bb to win 23.5bb, so we need about 43% equity to break even.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/N-DBWNwc4VA?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/systBflkFhI?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/FIKtY5ScbJM?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Often times we use the "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(" formula to say that a full pot bluff needs to work 50% of the time, and a 1/2 pot bet needs to work 33% of the time.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h3',[_vm._v("How else can you use Six Plus Hold’em to study?")]),_vm._v(" "),_c('p',[_vm._v("Check out some of the demo videos in the playlist below:")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8rhfjlwM7OFsq_1YDfJNCf","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PJ+B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_guide_vue__ = __webpack_require__("xfbN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1aacee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_guide_vue__ = __webpack_require__("8tiS");
function injectStyle (ssrContext) {
  __webpack_require__("Jy2w")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d1aacee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quick_guide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1aacee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quick_guide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PQAu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simulate_button_vue__ = __webpack_require__("e27S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f5d55fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simulate_button_vue__ = __webpack_require__("0D1j");
function injectStyle (ssrContext) {
  __webpack_require__("Qz+A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5f5d55fd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_simulate_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f5d55fd_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_simulate_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PTG4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"alert alert-info"},[_c('strong',[_vm._v("Heads up!")]),_vm._v(" Right now you're in readonly mode. You can look, but can't touch. If you want to be able to use the tool yourself, "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" to get started with your 14 day free trial.\n")],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Pc/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_constants__ = __webpack_require__("vjYN");


/* harmony default export */ __webpack_exports__["a"] = ({
  sortRanksDescendingCompareFunction: sortRanksDescendingCompareFunction,
  sortCardsDescendingByRankCompareFunction: function sortCardsDescendingByRankCompareFunction(cardOne, cardTwo) {
    var rankOne = cardOne[0];
    var rankTwo = cardTwo[0];
    return sortRanksDescendingCompareFunction(rankOne, rankTwo);
  },
  sortCardGroupsDescendingByRankCompareFunction: function sortCardGroupsDescendingByRankCompareFunction(cardGroupOne, cardGroupTwo) {
    var rankOne = cardGroupOne[0][0];
    var rankTwo = cardGroupTwo[0][0];
    return sortRanksDescendingCompareFunction(rankOne, rankTwo);
  },
  getRankOneLower: function getRankOneLower(rank) {
    return this.getRankNUnitsLower(rank, 1);
  },
  getRankNUnitsLower: function getRankNUnitsLower(rank, amountLower) {
    var rankIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rank);
    var lowerRankIndex = rankIndex + amountLower;

    if (lowerRankIndex === 13) {
      return 'a';
    }

    if (lowerRankIndex > 13) {
      throw new Error('Trying to get a rank that is too low.');
    }

    return __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[lowerRankIndex];
  },
  getRankNUnitsLowerShortDeck: function getRankNUnitsLowerShortDeck(rank, amountLower) {
    var rankIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rank);
    var lowerRankIndex = rankIndex + amountLower;

    if (lowerRankIndex === 9) {
      return 'a';
    }

    if (lowerRankIndex > 9) {
      throw new Error('Trying to get a rank that is too low.');
    }

    return __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[lowerRankIndex];
  },
  getHighestCardFromCards: function getHighestCardFromCards(cards) {
    cards.sort(this.sortCardsDescendingByRankCompareFunction);
    return cards[0];
  },
  getHighestRankFromCards: function getHighestRankFromCards(cards) {
    var ranks = this.getRanksFromCards(cards);
    return this.getHighestRankFromRanks(ranks);
  },
  getHighestRankFromRanks: function getHighestRankFromRanks(ranks) {
    ranks.sort(sortRanksDescendingCompareFunction);
    return ranks[0];
  },
  getRanksFromCards: function getRanksFromCards(cards) {
    var ranks = [];

    cards.forEach(function (card) {
      var rank = card[0];

      if (ranks.indexOf(rank) === -1) {
        ranks.push(rank);
      }
    });

    ranks.sort(sortRanksDescendingCompareFunction);

    return ranks;
  },
  getRankIndexesFromCards: function getRankIndexesFromCards(cards, aceOnBothEnds) {
    var ranks = this.getRanksFromCards(cards);
    return this.getRankIndexesFromRanks(ranks, aceOnBothEnds);
  },
  getRankIndexesFromCardsShortDeck: function getRankIndexesFromCardsShortDeck(cards, aceOnBothEnds) {
    var ranks = this.getRanksFromCards(cards);
    return this.getRankIndexesFromRanksShortDeck(ranks, aceOnBothEnds);
  },
  getRankIndexesFromRanks: function getRankIndexesFromRanks(ranks, aceOnBothEnds) {
    var rankIndexes = [];

    ranks.forEach(function (rank) {
      rankIndexes.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rank));
    });

    if (aceOnBothEnds && ranks.indexOf('a') > -1) {
      rankIndexes.push(13);
    }

    return rankIndexes;
  },
  getRankIndexesFromRanksShortDeck: function getRankIndexesFromRanksShortDeck(ranks, aceOnBothEnds) {
    var rankIndexes = [];

    ranks.forEach(function (rank) {
      rankIndexes.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rank));
    });

    if (aceOnBothEnds && ranks.indexOf('a') > -1) {
      rankIndexes.push(9);
    }

    return rankIndexes;
  },
  getRankPositionAmongstCommunityCards: function getRankPositionAmongstCommunityCards(rank, communityCardRanks) {
    var rankIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rank);
    var communityCardRankIndexes = [];

    if (communityCardRanks.length < 3) {
      throw new Error("Don't call getRankPositionAmongstCommunityCards with less than three community cards");
    }

    communityCardRanks.forEach(function (communityCardRank) {
      communityCardRankIndexes.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(communityCardRank));
    });
    communityCardRankIndexes.sort(function (a, b) {
      return a - b;
    }); // sort descending

    if (communityCardRanks.length === 5) {
      if (rankIndex < communityCardRankIndexes[0]) {
        return 'over';
      } else if (rankIndex === communityCardRankIndexes[0]) {
        return 'top';
      } else if (rankIndex < communityCardRankIndexes[1]) {
        return 'over second';
      } else if (rankIndex === communityCardRankIndexes[1]) {
        return 'second';
      } else if (rankIndex < communityCardRankIndexes[2]) {
        return 'over third';
      } else if (rankIndex === communityCardRankIndexes[2]) {
        return 'third';
      } else if (rankIndex < communityCardRankIndexes[3]) {
        return 'over fourth';
      } else if (rankIndex === communityCardRankIndexes[3]) {
        return 'fourth';
      } else if (rankIndex < communityCardRankIndexes[4]) {
        return 'over bottom';
      } else if (rankIndex === communityCardRankIndexes[4]) {
        return 'bottom';
      } else if (rankIndex > communityCardRankIndexes[4]) {
        return 'under';
      } else {
        throw new Error('Problem trying to get the rank position amongst the community cards.');
      }
    } else if (communityCardRanks.length === 4) {
      if (rankIndex < communityCardRankIndexes[0]) {
        return 'over';
      } else if (rankIndex === communityCardRankIndexes[0]) {
        return 'top';
      } else if (rankIndex < communityCardRankIndexes[1]) {
        return 'over second';
      } else if (rankIndex === communityCardRankIndexes[1]) {
        return 'second';
      } else if (rankIndex < communityCardRankIndexes[2]) {
        return 'over third';
      } else if (rankIndex === communityCardRankIndexes[2]) {
        return 'third';
      } else if (rankIndex < communityCardRankIndexes[3]) {
        return 'over bottom';
      } else if (rankIndex === communityCardRankIndexes[3]) {
        return 'bottom';
      } else if (rankIndex > communityCardRankIndexes[3]) {
        return 'under';
      } else {
        throw new Error('Problem trying to get the rank position amongst the community cards.');
      }
    } else if (communityCardRanks.length === 3) {
      if (rankIndex < communityCardRankIndexes[0]) {
        return 'over';
      } else if (rankIndex === communityCardRankIndexes[0]) {
        return 'top';
      } else if (rankIndex < communityCardRankIndexes[1]) {
        return 'over middle';
      } else if (rankIndex === communityCardRankIndexes[1]) {
        return 'middle';
      } else if (rankIndex < communityCardRankIndexes[2]) {
        return 'over bottom';
      } else if (rankIndex === communityCardRankIndexes[2]) {
        return 'bottom';
      } else if (rankIndex > communityCardRankIndexes[2]) {
        return 'under';
      } else {
        throw new Error('Problem trying to get the rank position amongst the community cards.');
      }
    }
  },
  isFirstRankLargerThanSecond: function isFirstRankLargerThanSecond(rankOne, rankTwo) {
    var rankOneIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rankOne);
    var rankTwoIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rankTwo);

    return rankOneIndex < rankTwoIndex;
  },
  getSpaceBetweenRanks: function getSpaceBetweenRanks(ranks) {
    var spaceBetweenRanks = 0;
    var rankIndexes = ranks.map(function (rank) {
      return __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rank);
    });

    rankIndexes.sort(function (a, b) {
      return b - a;
    });

    for (var i = 0; i < rankIndexes.length - 1; i++) {
      spaceBetweenRanks += rankIndexes[i] - rankIndexes[i + 1];
    }

    return spaceBetweenRanks;
  },
  forEachRank: function forEachRank(firstRank, lastRank, cb) {
    var highRankIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(firstRank); // 2
    var lowRankIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(lastRank); // 5

    for (var i = highRankIndex; i <= lowRankIndex; i++) {
      cb(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i]);
    }
  }
});

function sortRanksDescendingCompareFunction(rankOne, rankTwo) {
  var rankOneIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rankOne);
  var rankTwoIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(rankTwo);

  // invalid ranks
  if (rankOneIndex === -1 || rankTwoIndex === -1) {
    throw new Error('Invalid rank(s).');
  }

  // rankOne is bigger
  if (rankOneIndex < rankTwoIndex) {
    return -1;
  }

  // rankTwo is bigger
  else if (rankTwoIndex < rankOneIndex) {
      return 1;
    }

    // they're equal
    else {
        return 0;
      }
}

/***/ }),

/***/ "PfH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spaced_repetition_and_poker_vue__ = __webpack_require__("0pfp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53145f09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spaced_repetition_and_poker_vue__ = __webpack_require__("WRtx");
function injectStyle (ssrContext) {
  __webpack_require__("1cU7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53145f09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_spaced_repetition_and_poker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53145f09_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_spaced_repetition_and_poker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Plqr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"river-selector"},[_c('individual-card-selector',{ref:"flop1",attrs:{"cardString":_vm.presetCommunityCards.flop1,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop1')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop1')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"flop2",attrs:{"cardString":_vm.presetCommunityCards.flop2,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop2')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop2')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"flop3",attrs:{"cardString":_vm.presetCommunityCards.flop3,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop3')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop3')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"turn",attrs:{"cardString":_vm.presetCommunityCards.turn,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'turn')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'turn')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"river",attrs:{"cardString":_vm.presetCommunityCards.river,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'river')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'river')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PrIL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue__ = __webpack_require__("fLJN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9873814_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_vue__ = __webpack_require__("Rlz4");
function injectStyle (ssrContext) {
  __webpack_require__("JH1h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e9873814"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9873814_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Q+19":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_vm._l((_vm.savedScenarios[_vm.tool]),function(savedScenario,i){return _c('li',[_c('a',{attrs:{"href":savedScenario.url}},[_vm._v(_vm._s(savedScenario.title))]),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-edit",on:{"click":function($event){return _vm.expandEditNameModal(i)}}}),_vm._v(" "),(i > 0)?_c('span',{staticClass:"glyphicon glyphicon-chevron-up",on:{"click":function($event){return _vm.moveScenarioUp(i)}}}):_vm._e(),_vm._v(" "),(i < _vm.savedScenarios[_vm.tool].length - 1)?_c('span',{staticClass:"glyphicon glyphicon-chevron-down",on:{"click":function($event){return _vm.moveScenarioDown(i)}}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"close",on:{"click":function($event){return _vm.deleteScenario(_vm.tool, i)}}},[_vm._v("\n      ×\n    ")])])}),_vm._v(" "),_c('ppt-modal',{staticClass:"edit-name-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Update name")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("Old name: "+_vm._s(_vm.savedScenarios[_vm.tool][_vm.indexForEditNameModal].title))]),_vm._v(" "),_c('p',[_vm._v("\n        New name: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newName),expression:"newName"}],attrs:{"type":"text"},domProps:{"value":(_vm.newName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newName=$event.target.value}}})])]),_vm._v(" "),_c('section',{attrs:{"slot":"footer"},slot:"footer"},[_c('section',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.collapseEditNameModal()}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.updateName()}}},[_vm._v("\n          Update\n        ")])])])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q3DD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insights_vue__ = __webpack_require__("wWrn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d2b89d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insights_vue__ = __webpack_require__("Z27U");
function injectStyle (ssrContext) {
  __webpack_require__("Tdre")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d2b89d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insights_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d2b89d8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insights_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QCca":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vertical_set_weight_to_apply_to_added_hands_with_settings_vue__ = __webpack_require__("OBk9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_184a2085_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vertical_set_weight_to_apply_to_added_hands_with_settings_vue__ = __webpack_require__("YCoa");
function injectStyle (ssrContext) {
  __webpack_require__("vyb0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-184a2085"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vertical_set_weight_to_apply_to_added_hands_with_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_184a2085_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vertical_set_weight_to_apply_to_added_hands_with_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QCyo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__ = __webpack_require__("Pc/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




/* harmony default export */ __webpack_exports__["a"] = ({
  areGeneralHandsInRange: function areGeneralHandsInRange(generalHandStrings, generalHands) {
    var numGeneralHandsInRange = 0;
    var generalHand = void 0;

    generalHandStrings.forEach(function (generalHandString) {
      generalHand = generalHands.find(generalHandString);

      if (generalHand.inRange === true) {
        numGeneralHandsInRange++;
      }
    }, this);

    if (numGeneralHandsInRange === 0) {
      return false;
    } else if (numGeneralHandsInRange === generalHandStrings.length) {
      return true;
    } else if (numGeneralHandsInRange < generalHandStrings.length) {
      return 'partially';
    } else {
      throw new Error('Problem determining whether general hand strings are in range.');
    }
  },
  getGeneralHandStringFromSpecificHandString: function getGeneralHandStringFromSpecificHandString(specificHandString) {
    var rank1 = specificHandString[0];
    var rank2 = specificHandString[2];
    var suit1 = specificHandString[1];
    var suit2 = specificHandString[3];
    var suitedLetter = void 0;

    if (rank1 === rank2) {
      suitedLetter = '';
    } else if (suit1 === suit2) {
      suitedLetter = 's';
    } else {
      suitedLetter = 'o';
    }

    return rank1 + rank2 + suitedLetter;
  },
  getAllSpecificHandStringsFromGeneralHandString: function getAllSpecificHandStringsFromGeneralHandString(generalHandString) {
    // duplicated elsewhere because of cyclic dependency issues
    var specificHandStrings = [];
    var rankOne = generalHandString[0];
    var rankTwo = generalHandString[1];
    var suitedOffsuitOrPair = void 0;

    if (generalHandString.length >= 4) {
      throw new Error('Invalid value of generalHandString.');
    }

    if (generalHandString[2] === 's') {
      suitedOffsuitOrPair = 'suited';
    } else if (generalHandString[2] === 'o') {
      suitedOffsuitOrPair = 'offsuit';
    } else {
      suitedOffsuitOrPair = 'pair';
    }

    if (suitedOffsuitOrPair === 'pair') {
      specificHandStrings.push(rankOne + 'c' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 'd');
    } else if (suitedOffsuitOrPair === 'suited') {
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'c');
      specificHandStrings.push(rankOne + 's' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 'd' + rankTwo + 'd');
    } else if (suitedOffsuitOrPair === 'offsuit') {
      specificHandStrings.push(rankOne + 'c' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 'c' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'c');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'h');
      specificHandStrings.push(rankOne + 's' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 'c');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'h' + rankTwo + 'd');
      specificHandStrings.push(rankOne + 'd' + rankTwo + 'c');
      specificHandStrings.push(rankOne + 'd' + rankTwo + 's');
      specificHandStrings.push(rankOne + 'd' + rankTwo + 'h');
    }

    return specificHandStrings;
  },
  getSpecificHandStringsFromGeneralHandStrings: function getSpecificHandStringsFromGeneralHandStrings(generalHandStrings) {
    var specificHandStrings = [];
    var specificHandStringsFromGeneralHandString = void 0;

    generalHandStrings.forEach(function (generalHandString) {
      specificHandStringsFromGeneralHandString = this.getAllSpecificHandStringsFromGeneralHandString(generalHandString);
      specificHandStrings.pushEachElement(specificHandStringsFromGeneralHandString);
    }, this);

    return specificHandStrings;
  },
  getNormalizedSpecificHandString: function getNormalizedSpecificHandString(specificHandString) {
    // eg. asac --> acas
    var rank1 = specificHandString[0];
    var rank2 = specificHandString[2];
    var suit1 = specificHandString[1];
    var suit2 = specificHandString[3];
    var isAPair = rank1 === rank2;
    var suitOrder = ['c', 's', 'h', 'd'];
    var suitOneIndex = suitOrder.indexOf(suit1);
    var suitTwoIndex = suitOrder.indexOf(suit2);

    if (!isAPair) {
      return specificHandString;
    }

    if (suitOneIndex > suitTwoIndex) {
      return rank1 + suit2 + rank2 + suit1;
    } else {
      return rank1 + suit1 + rank2 + suit2;
    }
  },
  getAscendingGeneralHandStrings: function getAscendingGeneralHandStrings(generalHandString) {
    var firstRank = generalHandString[0];
    var secondRank = generalHandString[1];
    var spaceBetweenRanks = __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */].getSpaceBetweenRanks([firstRank, secondRank]);

    // jj+
    if (firstRank === secondRank) {
      return this._getAscendingPairGeneralHandStrings(firstRank);
    }

    // 65s+ or 64s+
    else if (spaceBetweenRanks === 1 || spaceBetweenRanks === 2) {
        return this._getAscendingConnectorOrOneGapperGeneralHandStrings(generalHandString, firstRank, spaceBetweenRanks);
      }

      // ajs+, ajo+ or aj+
      else {
          return this._getAscendingOtherGeneralHandStrings(firstRank, secondRank, generalHandString);
        }
  },
  _getAscendingPairGeneralHandStrings: function _getAscendingPairGeneralHandStrings(lowRank) {
    var ascendingGeneralHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */].forEachRank('a', lowRank, function (rank) {
      ascendingGeneralHandStrings.push(rank + rank);
    });

    return ascendingGeneralHandStrings;
  },
  _getAscendingConnectorOrOneGapperGeneralHandStrings: function _getAscendingConnectorOrOneGapperGeneralHandStrings(generalHandString, lowRank, spaceBetweenRanks) {
    var highRankIndex = 0; // (ace)
    var lowRankIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(lowRank); // 8 (six)
    var ascendingGeneralHandStrings = [];

    // a..6
    for (var i = highRankIndex; i <= lowRankIndex; i++) {
      if (generalHandString[2] === 's') {
        ascendingGeneralHandStrings.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i] + __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i + spaceBetweenRanks] + 's');
      } else if (generalHandString[2] === 'o') {
        ascendingGeneralHandStrings.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i] + __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i + spaceBetweenRanks] + 'o');
      } else {
        ascendingGeneralHandStrings.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i] + __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i + spaceBetweenRanks] + 's');
        ascendingGeneralHandStrings.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i] + __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i + spaceBetweenRanks] + 'o');
      }
    }

    return ascendingGeneralHandStrings;
  },
  _getAscendingOtherGeneralHandStrings: function _getAscendingOtherGeneralHandStrings(firstRank, secondRank, generalHandString) {
    var ascendingGeneralHandStrings = [];

    // k..j
    __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */].forEachRank(__WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */].getRankOneLower(firstRank), secondRank, function (rank) {
      if (generalHandString[2] === 's') {
        ascendingGeneralHandStrings.push(firstRank + rank + 's');
      } else if (generalHandString[2] === 'o') {
        ascendingGeneralHandStrings.push(firstRank + rank + 'o');
      } else {
        ascendingGeneralHandStrings.push(firstRank + rank + 's');
        ascendingGeneralHandStrings.push(firstRank + rank + 'o');
      }
    });

    return ascendingGeneralHandStrings;
  },
  getDescendingGeneralHandStrings: function getDescendingGeneralHandStrings(generalHandString) {
    var firstRank = generalHandString[0];
    var secondRank = generalHandString[1];
    var spaceBetweenRanks = __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */].getSpaceBetweenRanks([firstRank, secondRank]);

    // jj-
    if (firstRank === secondRank) {
      return this._getDescendingPairGeneralHandStrings(firstRank);
    }

    // 65s- or 64s
    else if (spaceBetweenRanks === 1 || spaceBetweenRanks === 2) {
        return this._getDescendingConnectorOrOneGapperGeneralHandStrings(generalHandString, firstRank, spaceBetweenRanks);
      }

      // ajs+, ajo+ or aj+
      else {
          return this._getDescendingOtherGeneralHandStrings(firstRank, secondRank, generalHandString);
        }
  },
  _getDescendingPairGeneralHandStrings: function _getDescendingPairGeneralHandStrings(highRank) {
    var descendingGeneralHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */].forEachRank(highRank, '2', function (rank) {
      descendingGeneralHandStrings.push(rank + rank);
    });

    return descendingGeneralHandStrings;
  },
  _getDescendingConnectorOrOneGapperGeneralHandStrings: function _getDescendingConnectorOrOneGapperGeneralHandStrings(generalHandString, highRank, spaceBetweenRanks) {
    var highRankIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf(highRank);
    var lowRankIndex = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.indexOf('2');
    var descendingGeneralHandStrings = [];

    for (var i = highRankIndex; i <= lowRankIndex - spaceBetweenRanks; i++) {
      if (generalHandString[2] === 's') {
        descendingGeneralHandStrings.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i] + __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i + spaceBetweenRanks] + 's');
      } else if (generalHandString[2] === 'o') {
        descendingGeneralHandStrings.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i] + __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i + spaceBetweenRanks] + 'o');
      } else {
        descendingGeneralHandStrings.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i] + __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i + spaceBetweenRanks] + 's');
        descendingGeneralHandStrings.push(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i] + __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks[i + spaceBetweenRanks] + 'o');
      }
    }

    return descendingGeneralHandStrings;
  },
  _getDescendingOtherGeneralHandStrings: function _getDescendingOtherGeneralHandStrings(firstRank, secondRank, generalHandString) {
    var descendingGeneralHandStrings = [];

    // k..j
    __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */].forEachRank(secondRank, '2', function (rank) {
      if (generalHandString[2] === 's') {
        descendingGeneralHandStrings.push(firstRank + rank + 's');
      } else if (generalHandString[2] === 'o') {
        descendingGeneralHandStrings.push(firstRank + rank + 'o');
      } else {
        descendingGeneralHandStrings.push(firstRank + rank + 's');
        descendingGeneralHandStrings.push(firstRank + rank + 'o');
      }
    });

    return descendingGeneralHandStrings;
  },
  getAllSpecificHandStringsUsingCard: function getAllSpecificHandStringsUsingCard(card) {
    // eg. js --> acjs, asjs, ahjs, adjs..., jcjs, jsjh, jsjd..., tcjs, tsjs, thjs, tdjs...
    var cardRank = card[0];
    var cardSuit = card[1];
    var specificHandsUsingCard = [];

    __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.forEach(function (currRank) {
      if (currRank !== cardRank) {
        if (__WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */].isFirstRankLargerThanSecond(currRank, cardRank)) {
          specificHandsUsingCard.push(currRank + 'c' + card); // eg. acjs
          specificHandsUsingCard.push(currRank + 's' + card);
          specificHandsUsingCard.push(currRank + 'h' + card);
          specificHandsUsingCard.push(currRank + 'd' + card);
        } else {
          specificHandsUsingCard.push(card + currRank + 'c'); // eg. jstc
          specificHandsUsingCard.push(card + currRank + 's');
          specificHandsUsingCard.push(card + currRank + 'h');
          specificHandsUsingCard.push(card + currRank + 'd');
        }
      } else if (currRank === cardRank) {
        if (cardSuit === 'c') {
          specificHandsUsingCard.push(card + currRank + 's');
          specificHandsUsingCard.push(card + currRank + 'h');
          specificHandsUsingCard.push(card + currRank + 'd');
        } else if (cardSuit === 's') {
          specificHandsUsingCard.push(currRank + 'c' + card);
          specificHandsUsingCard.push(card + currRank + 'h');
          specificHandsUsingCard.push(card + currRank + 'd');
        } else if (cardSuit === 'h') {
          specificHandsUsingCard.push(currRank + 'c' + card);
          specificHandsUsingCard.push(currRank + 's' + card);
          specificHandsUsingCard.push(card + currRank + 'd');
        } else if (cardSuit === 'd') {
          specificHandsUsingCard.push(currRank + 'c' + card);
          specificHandsUsingCard.push(currRank + 's' + card);
          specificHandsUsingCard.push(currRank + 'h' + card);
        }
      }
    });

    return specificHandsUsingCard;
  },
  getGeneralHandStringsToAddFromDoubleSlider: function getGeneralHandStringsToAddFromDoubleSlider(topPercentile, bottomPercentile, generalHands, handRankings) {
    var generalHandStringsUpToTopPercentile = this._getGeneralHandStringsUpToGivenPercentile(topPercentile, generalHands, handRankings);
    var generalHandStringsUpToBottomPercentile = this._getGeneralHandStringsUpToGivenPercentile(bottomPercentile, generalHands, handRankings);
    return __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.difference(generalHandStringsUpToTopPercentile, generalHandStringsUpToBottomPercentile);
  },
  _getGeneralHandStringsUpToGivenPercentile: function _getGeneralHandStringsUpToGivenPercentile(percentile, generalHands, handRankings) {
    var currPercentage = 0;
    var numSpecificHandsAdded = 0;
    var generalHandIndex = 0;
    var generalHandStringsUpToGivenPercentile = [];
    var currGeneralHand = void 0;

    while (currPercentage < percentile) {
      currGeneralHand = this.__getCurrGeneralHand(generalHands, handRankings, generalHandIndex);

      if (currGeneralHand.possible) {
        generalHandStringsUpToGivenPercentile.push(currGeneralHand.string);
        numSpecificHandsAdded += currGeneralHand.numPossibleSpecificHands;
        currPercentage = numSpecificHandsAdded / generalHands.numberOfPossibleSpecificHands * 100;
      }

      generalHandIndex++;
    }

    return generalHandStringsUpToGivenPercentile;
  },
  __getCurrGeneralHand: function __getCurrGeneralHand(generalHands, handRankings, generalHandIndex) {
    var generalHandString = handRankings[generalHandIndex];

    return generalHands.find(generalHandString);
  },
  getGeneralHandsToUseForSimulation: function getGeneralHandsToUseForSimulation(player, presetCommunityCards, simulateTo) {
    return this._getPlayerStateToUseForSimulation(player, presetCommunityCards, simulateTo).generalHands;
  },
  getNameOfStateToUseForSimulation: function getNameOfStateToUseForSimulation(player, presetCommunityCards, simulateTo) {
    return this._getPlayerStateToUseForSimulation(player, presetCommunityCards, simulateTo).name;
  },
  _getPlayerStateToUseForSimulation: function _getPlayerStateToUseForSimulation(player, presetCommunityCards, simulateTo) {
    if (simulateTo === 'flop') {
      return player.states[0];
    } else if (simulateTo === 'turn') {
      if (presetCommunityCards.numSet >= 3) {
        return player.states[1];
      } else {
        return player.states[0];
      }
    } else if (simulateTo === 'river') {
      if (presetCommunityCards.numSet >= 4) {
        return player.states[2];
      } else if (presetCommunityCards.numSet === 3) {
        return player.states[1];
      } else {
        return player.states[0];
      }
    } else {
      throw new Error('Invalid value for simulateTo.');
    }
  },
  getWeightedRangeFromGeneralHandString: function getWeightedRangeFromGeneralHandString(generalHandString, presetCommunityCardsArray) {
    var specificHandStrings = this.getAllSpecificHandStringsFromGeneralHandString(generalHandString);
    var weightedRange = [];
    var firstCard = void 0;
    var secondCard = void 0;

    specificHandStrings.forEach(function (specificHandString) {
      firstCard = specificHandString.substring(0, 2);
      secondCard = specificHandString.substring(2, 4);

      if (!presetCommunityCardsArray.includes(firstCard) && !presetCommunityCardsArray.includes(secondCard)) {
        weightedRange.push([firstCard, secondCard]);
      }
    });

    return weightedRange;
  }
});

/***/ }),

/***/ "QD5b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QHJC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"three-bet-cbet-explorer-help"},[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Help / 3bet-Cbet Explorer")])]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa-IunH4GjEdRvR1HytttVBO","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Overview")]),_vm._v(" "),_c('p',[_vm._v("The point of this tool is to explore a 3bet-cbet bluff line. Eg. with a hand like 54s, not a hand like AA. Let me elaborate on what I mean by that.")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("An opponent opens, it folds around to you, and you 3bet.")]),_vm._v(" "),_c('li',[_vm._v("If someone 4bets you, you fold.")]),_vm._v(" "),_c('li',[_vm._v("We assume that no players behind will ever flat your 3bet. They're either 4betting or folding.")]),_vm._v(" "),_c('li',[_vm._v("\n      When the initial raiser calls and we miss:\n      "),_c('ul',[_c('li',[_vm._v("We're firing a cbet every time. And the cbet will always be the same size.")]),_vm._v(" "),_c('li',[_vm._v("If they call our cbet, we assume that we never end up winning the pot. That we never hit one of our outs, and that we never fire the turn or river as a bluff.")])])]),_vm._v(" "),_c('li',[_vm._v("When the initial raiser calls and we hit the flop, we assume that we will always win the pot.")])]),_vm._v(" "),_c('h3',[_vm._v("Accuracy vs simplicity")]),_vm._v(" "),_c('p',[_vm._v("Sometimes these assumptions are unrealistic. For example, when we miss, cbet, and get called, sometimes we'll have a flush draw or something and hit one of our outs by the river.")]),_vm._v(" "),_c('p',[_vm._v("But here's the thing: the more \"what ifs\" you consider, the more complicated the tool becomes, and the harder it is to reason about and use. I tried to strike a good balance between accuracy and simplicity.")]),_vm._v(" "),_c('h3',[_vm._v("How do you calculate EV?")]),_vm._v(" "),_c('p',[_vm._v("Like this!")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/h-FJK0F5Xik?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Still need help?")]),_vm._v(" "),_c('p',[_vm._v("I'm here for you. Hit me up at "),_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(". I'd love to answer any questions you have.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QQQk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'num-opponents-selector',
  props: ['numOpponents', 'authorized']
});

/***/ }),

/***/ "QTl4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"category-selector"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.categoryGroups),function(categoryGroup){return _c('tr',_vm._l((categoryGroup),function(category){return _c('td',[(category.displayText)?_c('label',{class:{ disabled: _vm.disabled }},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isCategoryInRange(category.camelCase),"indeterminate":_vm.isCategoryInRange(category.camelCase) === 'partially'},on:{"change":function($event){return _vm.selectOrDeselectGeneralHandsFromCategory(category.camelCase)}}}),_vm._v("\n          "+_vm._s(category.displayText)+"\n        ")]):_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isCategoryInRange(category.camelCase),"indeterminate":_vm.isCategoryInRange(category.camelCase) === 'partially'},on:{"change":function($event){return _vm.selectOrDeselectGeneralHandsFromCategory(category.camelCase)}}})])}),0)}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Mid")]),_vm._v(" "),_c('th',[_vm._v("Small")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Qiug":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"breakeven-percentage-for-bluffing-the-turn-table well"},[_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.breakevenPercentages[0]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.breakevenPercentages[1]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.breakevenPercentages[2]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.breakevenPercentages[3]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.breakevenPercentages[4]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.breakevenPercentages[5]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.breakevenPercentages[6]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.breakevenPercentages[7]))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s(_vm.dropoffPercentages[0]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.dropoffPercentages[1]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.dropoffPercentages[2]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.dropoffPercentages[3]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.dropoffPercentages[4]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.dropoffPercentages[5]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.dropoffPercentages[6]))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.dropoffPercentages[7]))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Selected")]),_vm._v(" "),_c('th',[_vm._v("1/3")]),_vm._v(" "),_c('th',[_vm._v("1/2")]),_vm._v(" "),_c('th',[_vm._v("2/3")]),_vm._v(" "),_c('th',[_vm._v("3/4")]),_vm._v(" "),_c('th',[_vm._v("Full")]),_vm._v(" "),_c('th',[_vm._v("1.5x")]),_vm._v(" "),_c('th',[_vm._v("2x")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QqqS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_vue__ = __webpack_require__("q2pU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d19751ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_bet_cbet_explorer_vue__ = __webpack_require__("3Sc2");
function injectStyle (ssrContext) {
  __webpack_require__("YFwH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d19751ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d19751ac_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_bet_cbet_explorer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Qs3N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'included-selectors-settings',
  data: function data() {
    return {
      slider: this.$store.state.account.user.settings.general.includedSelectors.slider
    };
  },
  methods: {
    save: function save() {
      var self = this;
      var user = _.cloneDeep(this.$store.state.account.user);

      user.settings.general.includedSelectors = {
        slider: this.slider
      };
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "QxzY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QyAZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qz+A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R3jD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RBWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_individual_card_selector_vue__ = __webpack_require__("07Up");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2acaabfc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_individual_card_selector_vue__ = __webpack_require__("3FI8");
function injectStyle (ssrContext) {
  __webpack_require__("/xcZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2acaabfc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_individual_card_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2acaabfc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_individual_card_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RSTb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  isHandInCheckedHands: function isHandInCheckedHands(handInfo, drawInfo, checkedHands) {
    for (var key in checkedHands) {
      if (checkedHands.hasOwnProperty(key)) {
        if (checkedHands[key].isAHit(handInfo, drawInfo)) {
          return true;
        }
      }
    }

    return false;
  },
  getWeightOfLargestMatchingFiveCardHand: function getWeightOfLargestMatchingFiveCardHand(handInfo, drawInfo, checkedHands) {
    var weightOfLargestMatchingHand = 0;

    for (var key in checkedHands) {
      if (checkedHands.hasOwnProperty(key)) {
        if (checkedHands[key].isAHit(handInfo, drawInfo)) {
          if (checkedHands[key].weight === 100) {
            return 100;
          } else {
            weightOfLargestMatchingHand = checkedHands[key].weight;
          }
        }
      }
    }

    return weightOfLargestMatchingHand;
  }
});

/***/ }),

/***/ "RTxP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RU07":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Help / Equity Matrix")])]),_vm._v(" "),_c('p',[_vm._v("Check out the videos in the playlist below:")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa-FTuHY_UA1a7FPNLchZZaw","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Still need help?")]),_vm._v(" "),_c('p',[_vm._v("I'm here for you. Hit me up at "),_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(". I'd love to answer any questions you have.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Rlz4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well range-help-section help-section"},[(_vm.playerStateIndex === 0)?_c('section',[_c('h3',[_vm._v("After the preflop action is finished? What are you talking about?")]),_vm._v(" "),_c('p',[_vm._v("Consider an example: you open to 3 big blinds from the button, and your opponent calls you from the big blind. At this point, the preflop action is over and you're about to head to the flop. We want to know what your opponents range is at this point. What would they flat with from the big blind?")]),_vm._v(" "),_c('p',[_vm._v("Consider another example: you open to 3 big blinds from the button, your opponent 3bets you from the big blind, and you call. Same thing: at this point, the preflop action is over, you're about to head to the flop, and we want to know what your opponents range is. What would they 3bet with from the big blind?")])]):_vm._e(),_vm._v(" "),(_vm.playerStateIndex === 1 && _vm.streetToBluff !== 'flop')?_c('section',[_c('h3',[_vm._v("After the flop action is finished? What are you talking about?")]),_vm._v(" "),_c('p',[_vm._v("Consider an example: your opponent checks, you bet, and your opponent calls. At this point, the flop action is over and you're about to head to the turn. We want to know what your opponents range is at this point. What do you think they would check-call the flop with?")]),_vm._v(" "),_c('p',[_vm._v("Consider another example: your opponent checks, you bet, your opponent raises you, and you call. Same thing: at this point, the flop action is over, you're about to head to the turn, and we want to know what your opponents range is. What would they check-raise with?")])]):_vm._e(),_vm._v(" "),(_vm.playerStateIndex === 2 && _vm.streetToBluff !== 'turn')?_c('section',[_c('h3',[_vm._v("After the turn action is finished? What are you talking about?")]),_vm._v(" "),_c('p',[_vm._v("Consider an example: your opponent checks, you bet, and your opponent calls. At this point, the turn action is over and you're about to head to the river. We want to know what your opponents range is at this point. What do you think they would check-call the turn with?")]),_vm._v(" "),_c('p',[_vm._v("Consider another example: your opponent checks, you bet, your opponent raises you, and you call. Same thing: at this point, the turn action is over, you're about to head to the river, and we want to know what your opponents range is. What would they check-raise with?")])]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("What is a range?")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.playerStateIndex === 0)?_c('section',[_c('h3',[_vm._v("How do I know what their range is?")]),_vm._v(" "),_c('p',[_vm._v("You have to use your judgement.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]):_c('section',[_c('h3',[_vm._v("How do I know what their range is?")]),_vm._v(" "),_c('p',[_vm._v("You have to use your judgement.")]),_vm._v(" "),_c('p',[_vm._v("Your opponent probably wouldn't check-call with air. They'd probably fold their air. And they also probably wouldn't check-call with a strong hand like a flush. They'd probably raise with their strong hands. But maybe they'd check-call with their top pairs and middle pairs. Or maybe they'd fold their middle pairs. These are questions that are more about poker experience and feel than software and math.")]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('h3',[_vm._v("Why am I setting ranges?")]),_vm._v(" "),_c('p',[_vm._v("Ultimately, we want to know how often your opponent will fold the "+_vm._s(_vm.streetToBluff)+" to your bluff. In order to figure that out, we need to know 1) what their range is coming in to the "+_vm._s(_vm.streetToBluff)+", and 2) what range they would continue with versus your bet.")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Consider the example where you open from the button and get 3bet by the big blind. Suppose that you know that your opponent is a passive player who only 3bets with aces or kings. That means that your opponents "),_c('em',[_vm._v("range")]),_vm._v(" is aces and kings. That the possible hands your opponent might have are AA and KK.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you want to be more thorough, you can give hands a "),_c('em',[_vm._v("weight")]),_vm._v(". Maybe you think that your opponent will 3bet with QQ 50% of the time. If so, "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-setting-hand-weights","target":"_blank"}},[_vm._v("you can")]),_vm._v(" select QQ with a weight of 50.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Your opponent probably wouldn't 3bet preflop with 72o. They probably "),_c('em',[_vm._v("would")]),_vm._v(" 3bet with AA. Same with KK. But would they do so with QQ? JJ? TT? Those are questions that are more about poker experience and feel than software and math.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you're not sure whether they'd 3bet QQ for example, you can "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-setting-hand-weights","target":"_blank"}},[_vm._v("use weights")]),_vm._v(" to express your a probability estimate. For example, if you think there's a 25% chance that they'd 3bet QQ, you can give QQ a weight of 25 (and AA and KK weights of 100).")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can also use the default "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-saved-ranges","target":"_blank"}},[_vm._v("saved ranges")]),_vm._v(" as a starting point.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you aren't sure whether they would check-call with their middle pairs, "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-set-checkbox-weights","target":"_blank"}},[_vm._v("you can give middle pairs a weight")]),_vm._v(" to express a probability estimate. For example, if you think that there's a 25% chance that they check-call with their middle pairs, you can give middle pairs a weight of 25.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can also use the "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-set-checks-to-default","target":"_blank"}},[_vm._v("set checks to default")]),_vm._v(" feature as a starting point. It'll check off the stuff that a tight/straightforward/loose opponent is likely to continue with. On the flop it'll check off different things depending on the board: eg. on a scary board like KcTc9s even a loose opponent probably wouldn't continue with their gutshots, but on a dry board like 9c6s2h, they would. On the turn and river, \"set checks to defaults\" it isn't \"smart\". It doesn't take the board texture in to account.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RnAW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ru/A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__ = __webpack_require__("SW7P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_DrawParent__ = __webpack_require__("c+Lz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_five_card_hands_categories_FiveCardHandsCategory__ = __webpack_require__("siI+");









var Draws = function (_FiveCardHandsCategor) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Draws, _FiveCardHandsCategor);

  function Draws() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Draws);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Draws.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Draws)).call(this));

    _this.data = [new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_DrawParent__["a" /* default */]({
      id: 'flushDraw',
      text: 'Flush draw',
      fullText: 'Flush draw',
      inlineText: 'a flush draw',
      isAHit: function isAHit(handInfo, drawInfo) {
        return drawInfo.flush && drawInfo.flush.type === 'four card';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
        id: 'flushDraw:nut',
        text: 'Nut',
        fullText: 'Nut flush draw',
        inlineText: 'a nut flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'four card' && drawInfo.flush.nutLevel === 'nut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
        id: 'flushDraw:secondNut',
        text: 'Second nut',
        fullText: 'Second nut flush draw',
        inlineText: 'a second nut flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'four card' && drawInfo.flush.nutLevel === 'second nut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
        id: 'flushDraw:thirdNut',
        text: 'Third nut',
        fullText: 'Third nut flush draw',
        inlineText: 'a third nut flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'four card' && drawInfo.flush.nutLevel === 'third nut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
        id: 'flushDraw:weak',
        text: 'Weak',
        fullText: 'Weak flush draw',
        inlineText: 'a weak flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'four card' && drawInfo.flush.nutLevel === 'weak';
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
      id: 'oesd',
      text: '<abbr title="Open ended straight draw">OESD</abbr>',
      fullText: 'OESD',
      inlineText: 'an open ended straight draw',
      isAHit: function isAHit(handInfo, drawInfo) {
        return drawInfo.straight && drawInfo.straight.type === 'open ended';
      }
    }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
      id: 'doubleGutshot',
      text: 'Double gutshot',
      fullText: 'Double gutshot',
      inlineText: 'a double gutshot',
      isAHit: function isAHit(handInfo, drawInfo) {
        return drawInfo.straight && drawInfo.straight.type === 'double gutshot';
      }
    }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
      id: 'gutshot',
      text: 'Gutshot',
      fullText: 'Gutshot',
      inlineText: 'a gutshot',
      isAHit: function isAHit(handInfo, drawInfo) {
        return drawInfo.straight && drawInfo.straight.type === 'gutshot';
      }
    }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
      id: 'twoOvercards',
      text: 'Two overcards',
      fullText: 'Two overcards',
      inlineText: 'two overcards',
      isAHit: function isAHit(handInfo, drawInfo) {
        return drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
      }
    }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
      id: 'oneOvercard',
      text: 'One overcard',
      fullText: 'One overcard',
      inlineText: 'one overcard',
      isAHit: function isAHit(handInfo, drawInfo) {
        return drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
      }
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_DrawParent__["a" /* default */]({
      id: 'backdoorFlushDraw',
      text: '<abbr title="Backdoor flush draw">Bckdr fl draw</abbr>',
      fullText: 'Backdoor flush draw',
      inlineText: 'a backdoor flush draw',
      isAHit: function isAHit(handInfo, drawInfo) {
        return drawInfo.flush && drawInfo.flush.type === 'backdoor';
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
        id: 'backdoorFlushDraw:nut',
        text: 'Nut',
        fullText: 'Backdoor nut flush draw',
        inlineText: 'a backdoor nut flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'backdoor' && drawInfo.flush.nutLevel === 'nut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
        id: 'backdoorFlushDraw:secondNut',
        text: 'Second nut',
        fullText: 'Backdoor second nut flush draw',
        inlineText: 'a backdoor second nut flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'backdoor' && drawInfo.flush.nutLevel === 'second nut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
        id: 'backdoorFlushDraw:thirdNut',
        text: 'Third nut',
        fullText: 'Backdoor third nut flush draw',
        inlineText: 'a backdoor third nut flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'backdoor' && drawInfo.flush.nutLevel === 'third nut';
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
        id: 'backdoorFlushDraw:weak',
        text: 'Weak',
        fullText: 'Backdoor weak flush draw',
        inlineText: 'a backdoor weak flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          return drawInfo.flush && drawInfo.flush.type === 'backdoor' && drawInfo.flush.nutLevel === 'weak';
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_DrawLeaf__["a" /* default */]({
      id: 'backdoorStraightDraw',
      text: '<abbr title="Backdoor straight draw">Bckdr str draw</abbr>',
      fullText: 'Backdoor straight draw',
      inlineText: 'a backdoor straight draw',
      isAHit: function isAHit(handInfo, drawInfo) {
        return drawInfo.straight && drawInfo.straight.type === 'backdoor';
      }
    })];
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(Draws.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Draws.prototype), 'setBreadcrumbText', _this).call(_this);
    return _this;
  }

  return Draws;
}(__WEBPACK_IMPORTED_MODULE_7__services_five_card_hands_categories_FiveCardHandsCategory__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Draws);
;

/***/ }),

/***/ "RuDn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rya7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ryr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ppt-upgrade"},[_vm._m(0),_vm._v(" "),_c('errors-alert',{attrs:{"errors":_vm.errorsFromBackend},on:{"clear":function($event){return _vm.clearAlert()}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('pricing-table'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      Credit card number\n      "),_c('card-number',{ref:"cardNumber",staticClass:"stripe-element card-number form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.number = $event.complete}}})],1)]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      Expiration date\n      "),_c('card-expiry',{ref:"cardExpiry",staticClass:"stripe-element card-expiry form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.expiry = $event.complete}}})],1)]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n      CVC\n      "),_c('card-cvc',{ref:"cardCvc",staticClass:"stripe-element card-cvc form-control",attrs:{"stripe":_vm.stripeConsumerKey,"options":_vm.options},on:{"change":function($event){_vm.cvc = $event.complete}}})],1)]),_vm._v(" "),_c('button',{staticClass:"pay-with-stripe btn btn-primary btn-block btn-lg",attrs:{"disabled":!_vm.complete || _vm.upgrading},on:{"click":function($event){return _vm.upgrade()}}},[_vm._v("\n    "+_vm._s(_vm.upgradeText)+"\n  ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Upgrade")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"alert alert-info"},[_c('p',[_vm._v("You have previously purchased the basic version of Six Plus Hold’em for $25. If you would like to upgrade to the premium version for an additional $50, fill out and submit the form below.")]),_vm._v(" "),_c('p',[_vm._v("If you have any questions, don't hesitate to reach out: "),_c('a',{attrs:{"href":"mailto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(".")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "S4JM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__("bBBi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6529f02a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("ack5");
function injectStyle (ssrContext) {
  __webpack_require__("jTUt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6529f02a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6529f02a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SGGR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_made_hands_and_draws_vue__ = __webpack_require__("Sd51");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c124bed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_made_hands_and_draws_vue__ = __webpack_require__("5iEU");
function injectStyle (ssrContext) {
  __webpack_require__("r1DT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3c124bed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_made_hands_and_draws_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c124bed_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_made_hands_and_draws_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SL8U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SMyf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SOcV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_turn_selector_vue__ = __webpack_require__("1XY+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_506e2ffa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_turn_selector_vue__ = __webpack_require__("rvTG");
function injectStyle (ssrContext) {
  __webpack_require__("x4VW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-506e2ffa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_turn_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_506e2ffa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_turn_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "STB5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_pricing_table__ = __webpack_require__("89NH");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-pricing',
  components: {
    'pricing-table': __WEBPACK_IMPORTED_MODULE_0__components_utilities_pricing_table__["a" /* default */]
  },
  computed: {
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    }
  }
});

/***/ }),

/***/ "SW7P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_leaf_FiveCardHandLeaf__ = __webpack_require__("sJ/U");






var DrawLeaf = function (_FiveCardHandLeaf) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DrawLeaf, _FiveCardHandLeaf);

  function DrawLeaf(argsObj) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DrawLeaf);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DrawLeaf.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DrawLeaf)).call(this, argsObj));

    _this.madeHandDrawOrCombo = 'draw';
    return _this;
  }

  return DrawLeaf;
}(__WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_leaf_FiveCardHandLeaf__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DrawLeaf);
;

/***/ }),

/***/ "SYH8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_hands_SpecificHand__ = __webpack_require__("0qOH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  inRange: function inRange(generalHands) {
    var pairGeneralHandsInRange = this._getPairGeneralHandsInRange(generalHands);
    var groupsOfConsecutivePairs = this._getGroupsOfConsecutivePairs(pairGeneralHandsInRange);
    var textFromPairs = this._getTextFromGroupsOfConsecutivePairs(groupsOfConsecutivePairs);

    return textFromPairs;
  },
  manuallyAdded: function manuallyAdded(generalHands) {
    var pairGeneralHandsManuallyAdded = this._getPairGeneralHandsManuallyAdded(generalHands);
    var groupsOfConsecutivePairs = this._getGroupsOfConsecutivePairs(pairGeneralHandsManuallyAdded);
    var textFromPairs = this._getTextFromGroupsOfConsecutivePairs(groupsOfConsecutivePairs);

    return textFromPairs;
  },
  manuallyRemoved: function manuallyRemoved(generalHands) {
    var pairGeneralHandsManuallyRemoved = this._getPairGeneralHandsManuallyRemoved(generalHands);
    var groupsOfConsecutivePairs = this._getGroupsOfConsecutivePairs(pairGeneralHandsManuallyRemoved);
    var textFromPairs = this._getTextFromGroupsOfConsecutivePairs(groupsOfConsecutivePairs);

    return textFromPairs;
  },
  _getPairGeneralHandsInRange: function _getPairGeneralHandsInRange(generalHands) {
    var listOfPairGeneralHandsInRange = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.pairs.forEach(function (pairGeneralHandString) {
      var pairGeneralHand = generalHands.find(pairGeneralHandString);

      if (pairGeneralHand.inRange === true) {
        listOfPairGeneralHandsInRange.push(pairGeneralHand);
      } else if (pairGeneralHand.inRange === 'partial') {
        pairGeneralHand.forEachSpecificHandInRange(function (specificHand) {
          listOfPairGeneralHandsInRange.push(specificHand);
        });
      }
    });

    return listOfPairGeneralHandsInRange;
  },
  _getPairGeneralHandsManuallyAdded: function _getPairGeneralHandsManuallyAdded(generalHands) {
    var listOfPairGeneralHandsManuallyAdded = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.pairs.forEach(function (pairGeneralHandString) {
      var pairGeneralHand = generalHands.find(pairGeneralHandString);

      if (pairGeneralHand.manuallyAdded === true) {
        listOfPairGeneralHandsManuallyAdded.push(pairGeneralHand);
      } else if (pairGeneralHand.manuallyAdded === 'partial') {
        pairGeneralHand.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyAdded) {
            listOfPairGeneralHandsManuallyAdded.push(specificHand);
          }
        });
      }
    });

    return listOfPairGeneralHandsManuallyAdded;
  },
  _getPairGeneralHandsManuallyRemoved: function _getPairGeneralHandsManuallyRemoved(generalHands) {
    var listOfPairGeneralHandsManuallyRemoved = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.pairs.forEach(function (pairGeneralHandString) {
      var pairGeneralHand = generalHands.find(pairGeneralHandString);

      if (pairGeneralHand.manuallyRemoved === true) {
        listOfPairGeneralHandsManuallyRemoved.push(pairGeneralHand);
      } else if (pairGeneralHand.manuallyRemoved === 'partial') {
        pairGeneralHand.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyRemoved) {
            listOfPairGeneralHandsManuallyRemoved.push(specificHand);
          }
        });
      }
    });

    return listOfPairGeneralHandsManuallyRemoved;
  },
  _getGroupsOfConsecutivePairs: function _getGroupsOfConsecutivePairs(pairGeneralHandsInRange) {
    var groupsOfConsecutivePairs = [];
    var currGroupOfConsecutivePairs = [];

    pairGeneralHandsInRange.forEach(function (pairGeneralHandInRange) {
      var pairGeneralHandInRangeIsNextInOrder = this._isPairGeneralHandInRangeNextInOrder(pairGeneralHandInRange, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(currGroupOfConsecutivePairs));

      if (currGroupOfConsecutivePairs.length === 0 || pairGeneralHandInRangeIsNextInOrder) {
        currGroupOfConsecutivePairs.push(pairGeneralHandInRange);
      } else {
        groupsOfConsecutivePairs.push(currGroupOfConsecutivePairs);
        currGroupOfConsecutivePairs = [];
        currGroupOfConsecutivePairs.push(pairGeneralHandInRange);
      }
    }, this);

    if (currGroupOfConsecutivePairs.length > 0) {
      groupsOfConsecutivePairs.push(currGroupOfConsecutivePairs);
    }

    return groupsOfConsecutivePairs;
  },
  _isPairGeneralHandInRangeNextInOrder: function _isPairGeneralHandInRangeNextInOrder(currPair, previousPair) {
    if (currPair instanceof __WEBPACK_IMPORTED_MODULE_0__services_hands_SpecificHand__["a" /* default */]) {
      return false;
    }

    if (!previousPair) {
      return true;
    }

    var currPairRank = currPair.rankOne;
    var previousPairRank = previousPair.rankOne;

    return __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(previousPairRank) === currPairRank;
  },
  _getTextFromGroupsOfConsecutivePairs: function _getTextFromGroupsOfConsecutivePairs(groupsOfConsecutivePairs) {
    var textFromGroupsOfConsecutivePairs = '';

    groupsOfConsecutivePairs.forEach(function (groupOfConsecutivePairs) {
      textFromGroupsOfConsecutivePairs += this._getTextFromGroupOfConsecutivePairs(groupOfConsecutivePairs) + ', ';
    }, this);

    return textFromGroupsOfConsecutivePairs;
  },
  _getTextFromGroupOfConsecutivePairs: function _getTextFromGroupOfConsecutivePairs(groupOfConsecutivePairs) {
    var firstPairString = groupOfConsecutivePairs[0].string;
    var lastPairString = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(groupOfConsecutivePairs).string;

    if (groupOfConsecutivePairs.length === 1) {
      return firstPairString;
    } else if (lastPairString === '22') {
      return firstPairString + '-';
    } else if (firstPairString === 'aa') {
      return lastPairString + '+';
    } else {
      return firstPairString + '-' + lastPairString;
    }
  }
});

/***/ }),

/***/ "Sd51":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'made-hands-and-draws'
});

/***/ }),

/***/ "Se0g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Segf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_help_vue__ = __webpack_require__("GNZx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6151f322_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_bet_cbet_explorer_help_vue__ = __webpack_require__("QHJC");
function injectStyle (ssrContext) {
  __webpack_require__("TNj6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6151f322"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6151f322_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_bet_cbet_explorer_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SkKs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rake_and_tip_vue__ = __webpack_require__("gHip");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0672c762_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rake_and_tip_vue__ = __webpack_require__("ZAzC");
function injectStyle (ssrContext) {
  __webpack_require__("/A07")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0672c762"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rake_and_tip_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0672c762_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rake_and_tip_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sl4K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hole_cards_selector_vue__ = __webpack_require__("zKTs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_062b5f48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hole_cards_selector_vue__ = __webpack_require__("lfON");
function injectStyle (ssrContext) {
  __webpack_require__("H+hc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-062b5f48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hole_cards_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_062b5f48_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hole_cards_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SoMB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SoXG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_hand_weight_set_hand_weights_modal__ = __webpack_require__("4Ypn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_hand_range_hand_weight_set_weight_to_apply_to_added_hands_modal__ = __webpack_require__("mDCG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hand_range_modals_combos_to_add_modal__ = __webpack_require__("tV7Q");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hand-range-header',
  components: {
    'set-hand-weights-modal': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_hand_weight_set_hand_weights_modal__["a" /* default */],
    'set-weight-to-apply-to-added-hands-modal': __WEBPACK_IMPORTED_MODULE_1__components_hand_range_hand_weight_set_weight_to_apply_to_added_hands_modal__["a" /* default */],
    'combos-to-add-modal': __WEBPACK_IMPORTED_MODULE_2__components_hand_range_modals_combos_to_add_modal__["a" /* default */]
  },
  props: ['generalHands', 'weightToApplyToAddedHands', 'combosToAdd', 'canBeRemoved', 'specificHandsNotAllowed', 'disabled'],
  computed: {
    settingHandWeightsSetting: function settingHandWeightsSetting() {
      return this.$store.state.account.user.settings.general.visual.settingHandWeights;
    },
    combosToAddInfoText: function combosToAddInfoText() {
      if (this.combosToAdd.length === 0) {
        return 'No combos are selected in the select specific suits menu.';
      }

      var text = 'When you click a hand, only the following combos will be added: ';

      this.combosToAdd.forEach(function (combo) {
        text += combo + ', ';
      });
      text = text.slice(0, -2);
      text += '. To change this, click the hamburger menu and then click "Select specific suits".';

      return text;
    }
  },
  mounted: function mounted() {
    $('[data-toggle="popover"]').popover();
  },
  methods: {
    expandSetHandWeightsModal: function expandSetHandWeightsModal() {
      $(this.$el).find('.set-hand-weights-modal').modal();
    },
    expandSetWeightToApplyToAddedHandsModal: function expandSetWeightToApplyToAddedHandsModal() {
      $(this.$el).find('.set-weight-to-apply-to-added-hands-modal').modal();
    },
    expandCombosToAddModal: function expandCombosToAddModal() {
      $(this.$el).find('.combos-to-add-modal').modal();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "SoyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'save-scenario-button',
  props: ['disabled', 'savedScenario'],
  computed: {
    text: function text() {
      if (this.savedScenario) {
        return 'Update scenario';
      }

      return 'Save scenario';
    },
    tooltipValue: function tooltipValue() {
      // if (this.disabled) {
      //   return 'Disabled.';
      // }

      return ''; // disables the tooltip
    }
  },
  mounted: function mounted() {
    if (true) {
      $(this.$el).tooltip();
    }
  },
  methods: {
    handleClick: function handleClick() {
      if (this.savedScenario) {
        this.$emit('updateScenario');
      } else {
        this.$emit('saveScenario');
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Swv+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"equity-matrix"},[_c('div',{staticClass:"simulation-progress"}),_vm._v(" "),(!_vm.authorized)?_c('readonly-alert'):_vm._e(),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{class:_vm.columnClass},[_c('result-grid',{ref:"resultGrid",attrs:{"generalHands":_vm.state.resultGeneralHands,"requiredEquity":_vm.state.requiredEquity},on:{"setRequiredEquity":function($event){return _vm.$store.commit('equityMatrix/setRequiredEquity', $event)}}})],1),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('div',{key:player.id,class:_vm.columnClass},[_c('hand-range',{ref:'player' + playerIndex,refInFor:true,class:{
          'one-or-three-players': _vm.state.players.numPlayers === 1 || _vm.state.players.numPlayers === 3,
          'two-four-or-more-players': _vm.state.players.numPlayers === 2 || _vm.state.players.numPlayers >= 4,
        },attrs:{"generalHands":player.states[0].generalHands,"weightToApplyToAddedHands":player.weightToApplyToAddedHands,"combosToAdd":player.combosToAdd,"disableAllButGridSelector":false,"disableAllSelectors":!_vm.authorized,"canBeRemoved":playerIndex > 0},on:{"removePlayer":function($event){return player.handleRemovePlayerEvent('equityMatrix', _vm.$store, playerIndex)},"clearRange":function($event){return player.handleClearPlayerEvent('equityMatrix', _vm.$store, playerIndex, 0)},"addComboToCombosToAdd":function($event){return player.handleAddComboToCombosToAddEvent('equityMatrix', _vm.$store, $event, playerIndex)},"removeComboFromCombosToAdd":function($event){return player.handleRemoveComboFromCombosToAddEvent('equityMatrix', _vm.$store, $event, playerIndex)},"applyExactWeightToGeneralHands":function($event){return player.handleApplyExactWeightToGeneralHandsEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"selectGeneralHand":function($event){return player.handleSelectGeneralHandEvent('equityMatrix', _vm.$store, $event.generalHandString, $event.triggeredByMouseover, playerIndex, 0)},"deselectGeneralHand":function($event){return player.handleDeselectGeneralHandEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"selectGeneralHands":function($event){return player.handleSelectGeneralHandsEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"deselectGeneralHands":function($event){return player.handleDeselectGeneralHandsEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"selectSpecificHand":function($event){return player.handleSelectSpecificHandEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"deselectSpecificHand":function($event){return player.handleDeselectSpecificHandEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"setRangeToMatchGeneralHands":function($event){return player.handleSetRangeToMatchGeneralHandsEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"setRangeToMatchDoubleSlider":function($event){return player.handleSetRangeToMatchDoubleSliderEvent('equityMatrix', _vm.$store, $event, playerIndex, 0, _vm.handRankings)},"setRangeToMatchSpecificHandStrings":function($event){return player.handleSetRangeToMatchSpecificHandStringsEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"applyExactWeightToGeneralHand":function($event){return player.handleApplyExactWeightToGeneralHandEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"setWeightOfSpecificHand":function($event){return player.handleSetWeightOfSpecificHandEvent('equityMatrix', _vm.$store, $event, playerIndex, 0)},"setWeightToApplyToAddedHands":function($event){return player.handleSetWeightToApplyToAddedHandsEvent('equityMatrix', _vm.$store, $event, playerIndex)}}},[(_vm.state.presetCommunityCards.flopSet)?_c('li',{attrs:{"slot":"extra-dropdown-item-1"},on:{"click":function($event){return _vm.expandNarrowRangeModal(playerIndex)}},slot:"extra-dropdown-item-1"},[_c('a',[_vm._v("Narrow range "),_c('span',{staticClass:"glyphicon glyphicon-new-window"})])]):_vm._e()])],1)})],2),_vm._v(" "),_c('equity-calculator-controls',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"hasSimulationBeenRun":_vm.state.hasSimulationBeenRun,"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized,"loggedIn":_vm.loggedIn},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"addPlayer":function($event){return _vm.addPlayer()},"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
      method: 'createSharableEquityMatrixURL',
      state: _vm.state,
    })},"saveScenario":function($event){return _vm.$emit('saveScenario', {
      method: 'createSharableEquityMatrixURL',
      savedScenarioPropertyName: 'equityMatrix',
      state: _vm.state,
    })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
      method: '_constructEquityMatrixData',
      state: _vm.state,
    })},"simulate":function($event){return _vm.simulate()}}}),_vm._v(" "),_c('narrow-range-modal',{staticClass:"narrow-range-modal",on:{"narrowRange":function($event){return _vm.narrowRange($event)}}}),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"equity matrix","urlPath":"equity-matrix"}}),_vm._v(" "),_c('help-icon',{attrs:{"path":"/help/equity-matrix"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SyQL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"expand-collapse",class:_vm.classValue,on:{"click":function($event){return _vm.$emit('toggle')}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Sytm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T8TE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toggle_help_button_vue__ = __webpack_require__("cOmL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11737930_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toggle_help_button_vue__ = __webpack_require__("YAoe");
function injectStyle (ssrContext) {
  __webpack_require__("1MGM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11737930"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_toggle_help_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11737930_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_toggle_help_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TMYU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_ranges_selector_vue__ = __webpack_require__("ejqY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047f7907_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_ranges_selector_vue__ = __webpack_require__("36Uc");
function injectStyle (ssrContext) {
  __webpack_require__("aoFU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-047f7907"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_ranges_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_047f7907_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_ranges_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TNj6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TQG8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_text_selector_help_modal__ = __webpack_require__("hR++");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_text_validate__ = __webpack_require__("AFoN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_text_get_specific_hand_strings_from_text__ = __webpack_require__("a81n");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'text-selector',
  components: {
    'help-modal': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_text_selector_help_modal__["a" /* default */]
  },
  props: ['generalHands', 'disabled'],
  methods: {
    getTextFromGeneralHands: function getTextFromGeneralHands() {
      return this.generalHands.inRangeText;
    },
    setRangeToMatchText: function setRangeToMatchText() {
      var text = this._getCleanedText();
      var checkTextValidityResult = __WEBPACK_IMPORTED_MODULE_1__services_text_validate__["a" /* default */].checkTextValidity(text);
      var specificHandStringsFromText = void 0;

      if (!checkTextValidityResult.valid) {
        alert('Invalid inputs: ' + checkTextValidityResult.invalidParts.join(', '));
        return;
      }

      specificHandStringsFromText = __WEBPACK_IMPORTED_MODULE_2__services_text_get_specific_hand_strings_from_text__["a" /* default */].run(text);
      this.$emit('setRangeToMatchSpecificHandStrings', specificHandStringsFromText);
    },
    _getCleanedText: function _getCleanedText() {
      var text = this.$refs['text-input'].value;

      text = text.toLowerCase();
      text = text.trim();
      text = text.replace(new RegExp(', ', 'g'), ',');

      return text;
    }
  }
});

/***/ }),

/***/ "TU9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapsed_by_default_vue__ = __webpack_require__("rpE+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d1cf69_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsed_by_default_vue__ = __webpack_require__("9kXV");
function injectStyle (ssrContext) {
  __webpack_require__("R3jD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79d1cf69"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collapsed_by_default_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79d1cf69_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collapsed_by_default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TWjd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('ul',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/blog"}},[_vm._v("Blog")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/help"}},[_vm._v("Help")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("About")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("Contact")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://www.youtube.com/channel/UCNrKf4FUAN6E8NoSDKV20Ng"}},[_vm._v("YouTube")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"https://discord.gg/Sn4G4Jx"}},[_vm._v("Discord")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TYCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flop_steps_vue__ = __webpack_require__("8jNq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf27848a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flop_steps_vue__ = __webpack_require__("vISl");
function injectStyle (ssrContext) {
  __webpack_require__("haFD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cf27848a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flop_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf27848a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flop_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ta4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-calculator-help'
});

/***/ }),

/***/ "TbjV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_settings_general_saved_range_vue__ = __webpack_require__("L0Ni");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_hand_range_grid_selector_grid_selector__ = __webpack_require__("G1lD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_short_deck_short_deck_grid_selector__ = __webpack_require__("9N94");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hand_range_slider_selector_slider_selector__ = __webpack_require__("OjzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_hand_range_text_selector_text_selector__ = __webpack_require__("lMB+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_hands_GeneralHands__ = __webpack_require__("udlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_settings_validators__ = __webpack_require__("F892");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'saved-ranges-settings',
  components: {
    'saved-range': __WEBPACK_IMPORTED_MODULE_0__components_settings_general_saved_range_vue__["a" /* default */],
    'grid-selector': __WEBPACK_IMPORTED_MODULE_1__components_hand_range_grid_selector_grid_selector__["a" /* default */],
    'short-deck-grid-selector': __WEBPACK_IMPORTED_MODULE_2__components_short_deck_short_deck_grid_selector__["a" /* default */],
    'slider-selector': __WEBPACK_IMPORTED_MODULE_3__components_hand_range_slider_selector_slider_selector__["a" /* default */],
    'text-selector': __WEBPACK_IMPORTED_MODULE_4__components_hand_range_text_selector_text_selector__["a" /* default */]
  },
  data: function data() {
    return {
      savedRanges: null,
      selectedSavedRange: null,
      indexesOfSelectedSavedRange: null,
      isHelpVisible: false,
      percentOfHandsInRangeNumberForDisplay: 0
    };
  },
  computed: {
    shortDeck: function shortDeck() {
      return this.$store.getters['account/purchasedShortDeck'];
    },
    numberOfPossibleSpecificHands: function numberOfPossibleSpecificHands() {
      if (this.shortDeck) {
        return 630;
      }

      return 1326;
    },
    noSavedRanges: function noSavedRanges() {
      return this.savedRanges && this.savedRanges.length === 0;
    },
    selectedRangeName: function selectedRangeName() {
      if (!this.indexesOfSelectedSavedRange) {
        return '';
      }

      var name = '';
      var currArray = this.savedRanges;

      this.indexesOfSelectedSavedRange.forEach(function (index) {
        name += currArray[index].name + ' / ';
        currArray = currArray[index].children;
      });

      return name.slice(0, -2);
    },
    includedSelectors: function includedSelectors() {
      return this.$store.state.account.user.settings.general.includedSelectors;
    },
    numberOfSpecificHandsInSelectedSavedRange: function numberOfSpecificHandsInSelectedSavedRange() {
      var numberOfSpecificHandsInSelectedSavedRange = 0;

      this.selectedSavedRange.generalHands.forEachSpecificHandInRange(function (specificHand) {
        numberOfSpecificHandsInSelectedSavedRange += specificHand.weight / 100;
      });

      return numberOfSpecificHandsInSelectedSavedRange;
    }
  },
  mounted: function mounted() {
    this.initialize();
  },
  methods: {
    // ranges
    remove: function remove(indexes) {
      var arr = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, indexes);
      arr.splice(indexes[indexes.length - 1], 1);

      if (__WEBPACK_IMPORTED_MODULE_8_lodash___default.a.isEqual(indexes, this.indexesOfSelectedSavedRange)) {
        this.showFirstRange();
      }

      // delete parents if they have no children anymore
      if (arr.length === 0) {
        indexes.pop();
        this.remove(indexes);
      }
    },
    showRange: function showRange(indexes) {
      var el = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(this.savedRanges, indexes);
      this.selectedSavedRange = el;
      this.indexesOfSelectedSavedRange = indexes;
      this.updatePercentOfHandsInRangeDisplay();
    },
    showFirstRange: function showFirstRange() {
      var indexesArrayOfRangeToShow = [];
      var currArray = this.savedRanges;

      while (true) {
        indexesArrayOfRangeToShow.push(0);
        if (currArray[0].children) {
          currArray = currArray[0].children;
        } else {
          break;
        }
      }

      this.showRange(indexesArrayOfRangeToShow);
    },
    addChild: function addChild(indexes) {
      var el = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(this.savedRanges, indexes);
      var generalHands = void 0;

      generalHands = new __WEBPACK_IMPORTED_MODULE_6__services_hands_GeneralHands__["a" /* default */]();

      if (this.shortDeck) {
        generalHands.adjustForShortDeck();
      }

      if (!el.children) {
        this.$set(el, 'collapsed', false);
        this.$set(el, 'children', []);
      }

      el.children.push({
        name: 'New range',
        editNameMode: false,
        generalHands: generalHands,
        numberOfPossibleSpecificHands: this.numberOfPossibleSpecificHands
      });
    },
    addSibling: function addSibling(indexes) {
      var arr = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, indexes);
      var generalHands = void 0;

      generalHands = new __WEBPACK_IMPORTED_MODULE_6__services_hands_GeneralHands__["a" /* default */]();

      if (this.shortDeck) {
        generalHands.adjustForShortDeck();
      }

      arr.splice(indexes[indexes.length - 1] + 1, 0, {
        name: 'New range',
        editNameMode: false,
        generalHands: generalHands,
        numberOfPossibleSpecificHands: this.numberOfPossibleSpecificHands
      });
    },
    moveUp: function moveUp(indexes) {
      var el = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(this.savedRanges, indexes);
      var arr = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, indexes);
      arr.splice(indexes[indexes.length - 1], 1);

      // space to move up on the current level
      if (indexes[indexes.length - 1] > 0) {
        arr.splice(indexes[indexes.length - 1] - 1, 0, el);
      }

      // first element of the current level
      else {
          indexes.pop();
          arr = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, indexes);
          arr.splice(indexes[indexes.length - 1], 0, el);
        }
    },
    moveDown: function moveDown(indexes) {
      var el = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(this.savedRanges, indexes);
      var arr = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, indexes);

      // space to move down the current level
      if (arr[indexes[indexes.length - 1] + 1]) {
        arr.splice(indexes[indexes.length - 1], 1);
        arr.splice(indexes[indexes.length - 1] + 1, 0, el);
      }

      // no space to move down the current level
      else {
          throw new Error('moveDown shouldn\'t be possible.');
        }
    },
    indentRight: function indentRight(indexes) {
      var arr = void 0;
      var el = void 0;
      var indexesForElementAbove = void 0;
      var elAbove = void 0;

      arr = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, indexes);
      el = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(this.savedRanges, indexes);
      indexesForElementAbove = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(indexes);
      indexesForElementAbove[indexesForElementAbove.length - 1]--;
      elAbove = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(this.savedRanges, indexesForElementAbove);

      if (!elAbove.children) {
        this.$set(elAbove, 'collapsed', false);
        this.$set(elAbove, 'children', []);
      }

      elAbove.children.push(el);
      arr.splice(indexes[indexes.length - 1], 1);
    },
    indentLeft: function indentLeft(indexes) {
      var el = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(this.savedRanges, indexes);
      var arr = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, indexes);
      var parentArr = void 0;

      arr.splice(indexes[indexes.length - 1], 1);
      indexes.pop();
      parentArr = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, indexes);
      parentArr.splice(indexes[indexes.length - 1] + 1, 0, el);

      if (arr.length === 0) {
        parentArr.splice(indexes[indexes.length - 1], 1);
      }
    },
    save: function save() {
      var self = this;
      var user = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(this.$store.state.account.user);

      __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.forEachLeaf(this.savedRanges, function (leaf) {
        leaf.handsInRange = [];
        leaf.generalHands.forEach(function (generalHand) {
          if (generalHand.inRange === true) {
            leaf.handsInRange.push(generalHand.string);
          }
        });
      });

      if (!__WEBPACK_IMPORTED_MODULE_9__services_settings_validators__["a" /* default */].areSavedRangesValid(this.savedRanges)) {
        alert('Make sure that each saved range has a name and that you didn\'t leave the range empty.');
        return;
      }

      user.settings.general.savedRanges = self._getSavedRanges();
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    _getSavedRanges: function _getSavedRanges() {
      var savedRanges = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(this.savedRanges);

      __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.forEachLeaf(savedRanges, function (leaf) {
        delete leaf.editNameMode;
        delete leaf.generalHands;
        delete leaf.numberOfPossibleSpecificHands;
      });
      __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.forEachParent(savedRanges, function (parent) {
        delete parent.editNameMode;
        delete parent.collapsed;
        delete parent.numberOfPossibleSpecificHands;
        delete parent.generalHands;
        delete parent.handsInRange;
      });

      return savedRanges;
    },

    // range
    _selectGeneralHand: function _selectGeneralHand(generalHandString) {
      var generalHand = this.selectedSavedRange.generalHands.find(generalHandString);

      generalHand.forEachPossibleSpecificHand(function (specificHand) {
        if (!specificHand.inRange) {
          specificHand.weight = 100;
        }
      });
    },
    _deselectGeneralHand: function _deselectGeneralHand(generalHandString) {
      var generalHand = this.selectedSavedRange.generalHands.find(generalHandString);

      generalHand.forEachSpecificHandInRange(function (specificHand) {
        specificHand.weight = 0;
      });
    },
    _selectGeneralHands: function _selectGeneralHands(generalHandStrings) {
      generalHandStrings.forEach(function (generalHandString) {
        this._selectGeneralHand(generalHandString);
      }, this);
    },
    _deselectGeneralHands: function _deselectGeneralHands(generalHandStrings) {
      generalHandStrings.forEach(function (generalHandString) {
        this._deselectGeneralHand(generalHandString);
      }, this);
    },
    _selectSpecificHand: function _selectSpecificHand(specificHandString) {
      var specificHand = this.selectedSavedRange.generalHands.find(specificHandString);

      if (!specificHand.inRange) {
        specificHand.weight = 100;
      }
    },
    _deselectSpecificHand: function _deselectSpecificHand(specificHandString) {
      var specificHand = this.selectedSavedRange.generalHands.find(specificHandString);

      if (specificHand.inRange) {
        specificHand.weight = 0;
      }
    },
    _selectSpecificHands: function _selectSpecificHands(specificHandStrings) {
      specificHandStrings.forEach(function (specificHandString) {
        this._selectSpecificHand(specificHandString);
      }, this);
    },
    _setRangeToMatchSpecificHandStrings: function _setRangeToMatchSpecificHandStrings(specificHandStrings) {
      this._clearRange();
      this._selectSpecificHands(specificHandStrings);
    },
    _clearRange: function _clearRange() {
      var allGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_7__services_constants__["a" /* default */].handRankings['sklansky-chubukov'];

      this._deselectGeneralHands(allGeneralHandStrings);
    },
    selectGeneralHand: function selectGeneralHand(generalHandString) {
      this._selectGeneralHand(generalHandString);
      this.updatePercentOfHandsInRangeDisplay();
      this.resetDoubleSlider();
    },
    deselectGeneralHand: function deselectGeneralHand(generalHandString) {
      this._deselectGeneralHand(generalHandString);
      this.updatePercentOfHandsInRangeDisplay();
      this.resetDoubleSlider();
    },
    selectGeneralHands: function selectGeneralHands(generalHandStrings) {
      this._selectGeneralHands(generalHandStrings);
      this.updatePercentOfHandsInRangeDisplay();
      this.resetDoubleSlider();
    },
    deselectGeneralHands: function deselectGeneralHands(generalHandStrings) {
      this._deselectGeneralHands(generalHandStrings);
      this.updatePercentOfHandsInRangeDisplay();
      this.resetDoubleSlider();
    },
    setRangeToMatchSpecificHandStrings: function setRangeToMatchSpecificHandStrings(specificHandStrings) {
      this._setRangeToMatchSpecificHandStrings(specificHandStrings);
      this.updatePercentOfHandsInRangeDisplay();
      this.resetDoubleSlider();
    },
    setRangeToMatchDoubleSlider: function setRangeToMatchDoubleSlider(percentilesObj) {
      var generalHandStringsToAddFromDoubleSlider = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].hands.getGeneralHandStringsToAddFromDoubleSlider(percentilesObj.topPercentile, percentilesObj.bottomPercentile, this.selectedSavedRange.generalHands, this.$store.getters['account/handRankings']);

      this._setRangeToMatchSpecificHandStrings(generalHandStringsToAddFromDoubleSlider);
      this.updatePercentOfHandsInRangeDisplay();
    },
    resetDoubleSlider: function resetDoubleSlider() {
      this.$refs.sliderSelector.resetDoubleSlider();
    },
    updatePercentOfHandsInRangeDisplay: function updatePercentOfHandsInRangeDisplay() {
      if (this.numberOfSpecificHandsInSelectedSavedRange === 0) {
        this.percentOfHandsInRangeNumberForDisplay = 0;
        return;
      }

      var exactPercentOfHandsInRange = this.numberOfSpecificHandsInSelectedSavedRange / this.numberOfPossibleSpecificHands * 100;

      if (exactPercentOfHandsInRange < 0.5) {
        this.percentOfHandsInRangeNumberForDisplay = 1;
        return;
      } else {
        this.percentOfHandsInRangeNumberForDisplay = Math.round(exactPercentOfHandsInRange);
        return;
      }
    },

    // initialize
    initialize: function initialize() {
      this._initializeSavedRanges();
      this.showFirstRange();
      this.updatePercentOfHandsInRangeDisplay();
    },
    _initializeSavedRanges: function _initializeSavedRanges() {
      var savedRanges = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.cloneDeep(this.$store.state.account.user.settings.general.savedRanges);

      this.__initializePropertiesOfSavedRanges(savedRanges);
      this.__initializeHandsInRangeForSavedRanges(savedRanges);
      this.savedRanges = savedRanges;
    },
    __initializePropertiesOfSavedRanges: function __initializePropertiesOfSavedRanges(savedRanges) {
      var self = this;
      var generalHands = void 0;

      __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.forEachLeaf(savedRanges, function (leaf) {
        generalHands = new __WEBPACK_IMPORTED_MODULE_6__services_hands_GeneralHands__["a" /* default */]();

        if (self.shortDeck) {
          generalHands.adjustForShortDeck();
        }

        leaf.editNameMode = false;
        leaf.generalHands = generalHands, leaf.numberOfPossibleSpecificHands = self.numberOfPossibleSpecificHands;
        leaf.id = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniqueId();
      });
      __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.forEachParent(savedRanges, function (parent) {
        parent.editNameMode = false;
        parent.collapsed = false;
        parent.id = __WEBPACK_IMPORTED_MODULE_8_lodash___default.a.uniqueId();
      });
    },
    __initializeHandsInRangeForSavedRanges: function __initializeHandsInRangeForSavedRanges(savedRanges) {
      var self = this;

      __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].general.forEachLeaf(savedRanges, function (savedRange) {
        self.___initializeHandsInRangeForSavedRange(savedRange);
      });
    },
    ___initializeHandsInRangeForSavedRange: function ___initializeHandsInRangeForSavedRange(savedRange) {
      savedRange.generalHands.forEach(function (generalHand) {
        generalHand.forEachPossibleSpecificHand(function (specificHand) {
          if (savedRange.handsInRange.includes(generalHand.string) && !specificHand.inRange) {
            specificHand.weight = 100;
          } else if (!savedRange.handsInRange.includes(generalHand.string) && specificHand.inRange) {
            specificHand.weight = 0;
          }
        });
      });
    }
  }
});

/***/ }),

/***/ "TcHI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_should_you_bluff_vue__ = __webpack_require__("Z4h7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faeded62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_should_you_bluff_vue__ = __webpack_require__("qfKq");
function injectStyle (ssrContext) {
  __webpack_require__("w9+p")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-faeded62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_should_you_bluff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_faeded62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_should_you_bluff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Tdre":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TlKt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hand-rankings-settings settings"},[_vm._m(0),_vm._v(" "),(_vm.shortDeck)?_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"short-deck-all-in-5-handed"},domProps:{"checked":_vm._q(_vm.handRankingsType,"short-deck-all-in-5-handed")},on:{"change":function($event){_vm.handRankingsType="short-deck-all-in-5-handed"}}}),_vm._v("\n      Short deck all in 5-handed\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"/static/short-deck-all-in-five-handed-hand-rankings.txt"}},[_vm._v("order")]),_vm._v(")\n  ")]):_vm._e(),_vm._v(" "),(_vm.shortDeck)?_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"short-deck-all-in-heads-up"},domProps:{"checked":_vm._q(_vm.handRankingsType,"short-deck-all-in-heads-up")},on:{"change":function($event){_vm.handRankingsType="short-deck-all-in-heads-up"}}}),_vm._v("\n      Short deck all in heads up\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"/static/short-deck-all-in-heads-up-hand-rankings.txt"}},[_vm._v("order")]),_vm._v(")\n    "),_c('hr')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"ten-handed-evolutionary"},domProps:{"checked":_vm._q(_vm.handRankingsType,"ten-handed-evolutionary")},on:{"change":function($event){_vm.handRankingsType="ten-handed-evolutionary"}}}),_vm._v("\n      10-handed evolutionary\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"http://www.propokertools.com/orderings/heordering.txt"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"six-handed-evolutionary"},domProps:{"checked":_vm._q(_vm.handRankingsType,"six-handed-evolutionary")},on:{"change":function($event){_vm.handRankingsType="six-handed-evolutionary"}}}),_vm._v("\n      6-handed evolutionary\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"http://www.propokertools.com/orderings/he6maxordering.txt"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"three-handed-evolutionary"},domProps:{"checked":_vm._q(_vm.handRankingsType,"three-handed-evolutionary")},on:{"change":function($event){_vm.handRankingsType="three-handed-evolutionary"}}}),_vm._v("\n      3-handed evolutionary\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"http://www.propokertools.com/orderings/he3maxordering.txt"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"expected-value"},domProps:{"checked":_vm._q(_vm.handRankingsType,"expected-value")},on:{"change":function($event){_vm.handRankingsType="expected-value"}}}),_vm._v("\n      Expected value\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"https://www.tightpoker.com/poker_hands.html"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"sklansky-chubukov"},domProps:{"checked":_vm._q(_vm.handRankingsType,"sklansky-chubukov")},on:{"change":function($event){_vm.handRankingsType="sklansky-chubukov"}}}),_vm._v("\n      Sklansky-Chubukov\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"http://archives2.twoplustwo.com/showflat.php?Cat=0&Number=382772&page=3&fpart=all&vc=1"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"all-in-9-handed"},domProps:{"checked":_vm._q(_vm.handRankingsType,"all-in-9-handed")},on:{"change":function($event){_vm.handRankingsType="all-in-9-handed"}}}),_vm._v("\n      All in 9-handed\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"https://www.gamblingsites.org/poker/texas-holdem/starting-hand-rankings/"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"all-in-3-handed"},domProps:{"checked":_vm._q(_vm.handRankingsType,"all-in-3-handed")},on:{"change":function($event){_vm.handRankingsType="all-in-3-handed"}}}),_vm._v("\n      All in 3-handed\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"https://wizardofodds.com/games/texas-hold-em/3-player-game/"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"all-in-heads-up"},domProps:{"checked":_vm._q(_vm.handRankingsType,"all-in-heads-up")},on:{"change":function($event){_vm.handRankingsType="all-in-heads-up"}}}),_vm._v("\n      All in heads up\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"http://www.propokertools.com/orderings/hevsrandomordering.txt"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"heads-up-equity-squared"},domProps:{"checked":_vm._q(_vm.handRankingsType,"heads-up-equity-squared")},on:{"change":function($event){_vm.handRankingsType="heads-up-equity-squared"}}}),_vm._v("\n      Heads up equity squared\n    ")]),_vm._v("\n    ("),_c('a',{attrs:{"href":"http://www.propokertools.com/orderings/heequitysquaredordering.txt"}},[_vm._v("order")]),_vm._v(")\n  ")]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.handRankingsType),expression:"handRankingsType"}],attrs:{"type":"radio","value":"custom"},domProps:{"checked":_vm._q(_vm.handRankingsType,"custom")},on:{"change":function($event){_vm.handRankingsType="custom"}}}),_vm._v("\n      Custom:\n    ")]),_vm._v(" "),_c('input',{ref:"customHandRankings",attrs:{"type":"text"},domProps:{"value":_vm.$store.state.account.user.settings.general.handRankings.customHandRankings},on:{"click":function($event){_vm.handRankingsType = 'custom'}}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.saveHandRankings()}}},[_vm._v("Save")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_c('h3',[_vm._v("What do you mean by \"hand rankings?\"")]),_vm._v(" "),_c('p',[_vm._v("When you slide the slider, it adds/removes hands in a certain order. This order is based on how the hands are ranked.")]),_vm._v(" "),_c('p',[_vm._v("For example, if you have the hands ranked in the following order: AA, KK, QQ, JJ, AKs, TT..., then when you slide the slider, AA gets added first, then KK, then QQ, then JJ, then AKs, then TT, etc.")]),_vm._v(" "),_c('h3',[_vm._v("There is no definitive way to rank starting poker hands")]),_vm._v(" "),_c('p',[_vm._v("The strength of a starting hands depends on many things. For example, whether the pot is heads up or multi-way:")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("The strength of a starting hand also depends on other things like your table image, your perceived range, your position, your opponents range, and your opponents playing style.")]),_vm._v(" "),_c('h3',[_vm._v("Descriptions")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Hand rankings")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("When playing a multi-way pot, hands like 98s have a relatively higher value, because in a multi-way pot you usually need a premium hand to win, and 98s is good for making flushes and straights.")]),_vm._v(" "),_c('li',[_vm._v("When playing heads up, a hand like A8o has a relatively higher value because it makes solid top pairs, and it gives you a good kicker when no one makes a pair or better. But in a multi-way pot, A8o has a relatively low value because it has a relatively low chance of making premium hands such as three of a kind, straights, and flushes.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("X-handed evolutionary")]),_vm._v(": Uses an evolutionary computer simulation where hands are simulated against other \"good hands\". See "),_c('a',{attrs:{"href":"http://pokercoder.blogspot.co.uk/2006/07/towards-meaningful-ordering-of-hands.html"}},[_vm._v("Towards a Meaningful Ordering of Hands")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Expected value")]),_vm._v(": Uses actual expected values compiled from live table data.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Sklansky-Chubukov")]),_vm._v(": Compares hands based on how they perform in a particular situation where you shove from the SB. See "),_c('a',{attrs:{"href":"https://poker.stackexchange.com/a/1377/4911"}},[_vm._v("this")]),_vm._v(" StackExchange answer for more.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("All in x-handed")]),_vm._v(": Eg. suppose you have AA and you are all in vs. 9 random opponents. Run a lot of simulations to see how often you win. Then try with KK, QQ, etc. Rank the hands by win percentage. Ditto for x random opponents.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Heads up equity squared")]),_vm._v(": Pre-flop equity squared vs. a random hand.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Custom")]),_vm._v(": Enter your own customized hand rankings. It should look something like this: aa, kk, aks, ako, etc.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Make sure you enter all 169 hands")]),_vm._v(" "),_c('li',[_vm._v("Use a comma to separate hands")]),_vm._v(" "),_c('li',[_vm._v("It doesn't matter whether or not there is a space after the commas")]),_vm._v(" "),_c('li',[_vm._v("No abbreviations like JJ+")]),_vm._v(" "),_c('li',[_vm._v("Upper/lowercase doesn't matter")]),_vm._v(" "),_c('li',[_vm._v("Valid pair hand example: aa")]),_vm._v(" "),_c('li',[_vm._v("Valid suited hand example: aks")]),_vm._v(" "),_c('li',[_vm._v("Valid offsuit hand example: ako")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TmOh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");




var state = {
  user: {}
};

var mutations = {
  setUser: function setUser(state, newUser) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(state, 'user', newUser);

    if (newUser.googleId) {
      localStorage.setItem('previousSignInType', 'google');
    } else if (newUser.twitterId) {
      localStorage.setItem('previousSignInType', 'twitter');
    } else if (newUser.linkedinId) {
      localStorage.setItem('previousSignInType', 'linkedin');
    } else if (newUser.email) {
      localStorage.setItem('previousSignInType', 'email');
    }

    history.replaceState(null, null, ' '); // remove # from url that google sso puts on there
  },
  subscribeToEmail: function subscribeToEmail(state) {
    state.user.emailOptIn = true;
  },
  unsubscribeFromEmail: function unsubscribeFromEmail(state) {
    state.user.emailOptIn = false;
  },
  purchasePPT: function purchasePPT(state, version) {
    state.user.auth.push(version);
  },
  upgradeToPremiumVersion: function upgradeToPremiumVersion(state) {
    if (!state.user.auth.includes('basic')) {
      throw new Error('Trying to upgrade when you\'re not on the basic version.');
    }

    var i = state.user.auth.indexOf('basic');

    state.user.auth.splice(i, 1);
    state.user.auth.push('premium');
  },
  onboard: function onboard(state, page) {
    state.user.settings.onboarding[page] = true;
  }
};

var actions = {
  clearUser: function clearUser(context) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get("https://oddscalc.sixplusholdem.com/api" + '/user/default').then(function (res) {
      return context.commit('setUser', res.data.user);
    }).catch(function () {
      alert('Error. Problem clearing/setting the user. Email contact@sixplusholdem.com for help.');
    });
  }
};

var getters = {
  loggedIn: function loggedIn(state) {
    return !!state.user.email;
  },
  authorizedForBasic: function authorizedForBasic(state, getters) {
    if (!getters.loggedIn) {
      return false;
    }

    if (getters.daysLeftOnFreeTrial > 0) {
      return true;
    }

    if (state.user.auth && (state.user.auth.includes('basic') || state.user.auth.includes('premium'))) {
      return true;
    }

    return false;
  },
  authorizedForPremium: function authorizedForPremium(state, getters) {
    if (!getters.loggedIn) {
      return false;
    }

    if (getters.daysLeftOnFreeTrial > 0) {
      return true;
    }

    if (state.user.auth && state.user.auth.includes('premium')) {
      return true;
    }

    return false;
  },
  authorizedForShortDeck: function authorizedForShortDeck(state, getters) {
    if (!getters.loggedIn) {
      return false;
    }

    if (getters.daysLeftOnFreeTrial > 0) {
      return true;
    }

    if (state.user.auth && state.user.auth.includes('short deck')) {
      return true;
    }

    return false;
  },
  paid: function paid(state, getters) {
    return state.user.auth && (state.user.auth.includes('basic') || state.user.auth.includes('premium') || state.user.auth.includes('short deck'));
  },
  basicOrPremium: function basicOrPremium(state, getters) {
    return state.user.auth && (state.user.auth.includes('basic') || state.user.auth.includes('premium'));
  },
  purchasedShortDeck: function purchasedShortDeck(state, getters) {
    return state.user.auth && state.user.auth.includes('short deck');
  },
  daysSinceSignup: function daysSinceSignup(state) {
    if (!state.user.created) {
      throw new Error('Trying to figure out daysSinceSignup for someone who isn\'t logged in.');
    }

    return __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].general.getDaysBetweenDates(state.user.created, new Date());
  },
  daysLeftOnFreeTrial: function daysLeftOnFreeTrial(state, getters) {
    var DAYS_FOR_FREE_TRIAL = 14;

    if (!state.user.created) {
      return 0;
    }

    return (DAYS_FOR_FREE_TRIAL - getters.daysSinceSignup).roundToTwoDecimalPlaces();
  },
  handRankings: function handRankings(state) {
    var type = state.user.settings.general.handRankings.type;

    if (type !== 'custom') {
      return __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].handRankings[type];
    }

    return state.user.settings.general.handRankings.customHandRankings;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});



/***/ }),

/***/ "Tn63":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U3YL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__ = __webpack_require__("hfvn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eb2eddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__ = __webpack_require__("gCo1");
function injectStyle (ssrContext) {
  __webpack_require__("KB/h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3eb2eddc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3eb2eddc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UJfa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ppt-about"
});

/***/ }),

/***/ "UQBd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UYPa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_long_run_disclaimer_vue__ = __webpack_require__("Kpym");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728328db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_long_run_disclaimer_vue__ = __webpack_require__("GMrd");
function injectStyle (ssrContext) {
  __webpack_require__("ir5Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-728328db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_long_run_disclaimer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_728328db_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_long_run_disclaimer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UZvK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UcXI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = function() {
  return new Worker(__webpack_require__.p + "605ab694b5dafb8e2182.worker.js");
};

/***/ }),

/***/ "UeXH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_flop_selector__ = __webpack_require__("d+yY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_pot_odds_selector__ = __webpack_require__("a398");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_call_conclusions_betting_criteria_table__ = __webpack_require__("E+KM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__ = __webpack_require__("unvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_call_help_range__ = __webpack_require__("9sL7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-flop-steps',
  components: {
    'flop-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_flop_selector__["a" /* default */],
    'pot-odds-selector': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_pot_odds_selector__["a" /* default */],
    'betting-criteria-table': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_call_conclusions_betting_criteria_table__["a" /* default */],
    'set-range-step': __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__["a" /* default */],
    'range-help-section': __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_call_help_range__["a" /* default */]
  },
  props: ['state', 'textWhenFiveCardHandPercentagesArentUpToDate', 'authorized'],
  methods: {
    getTextForPlayerRangeStep: function getTextForPlayerRangeStep(playerIndex) {
      var numOpponents = this.state.players.numPlayers;

      if (this.state.streetToCall === 'flop' && numOpponents === 1) {
        return 'Step ' + (6 + numOpponents + playerIndex) + ': What do you think your opponent would bet the flop with?';
      } else if (this.state.streetToCall === 'flop' && numOpponents > 1) {
        return 'Step ' + (6 + numOpponents + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is after the flop action is finished (eg. heading in to the turn)?';
      } else if (this.state.streetToCall !== 'flop' && numOpponents === 1) {
        return 'Step ' + (5 + numOpponents + playerIndex) + ': What do you think your opponents range is after the flop action is finished (eg. heading in to the turn)?';
      } else if (this.state.streetToCall !== 'flop' && numOpponents > 1) {
        return 'Step ' + (5 + numOpponents + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is after the flop action is finished (eg. heading in to the turn)?';
      }
    }
  }
});

/***/ }),

/***/ "Uqw6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VAax":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bluff_size_selection_vue__ = __webpack_require__("5Tjn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e155034e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bluff_size_selection_vue__ = __webpack_require__("5Au4");
function injectStyle (ssrContext) {
  __webpack_require__("Y9bJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e155034e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bluff_size_selection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e155034e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bluff_size_selection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VKLz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"result-table"},[_c('table',{staticClass:"table"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.generalHandsOrderedByEquity),function(generalHand){return _c('tr',{key:generalHand.string},[_c('td',[_vm._v(_vm._s(generalHand.displayString))]),_vm._v(" "),_c('td',[(generalHand.equity !== null)?_c('span',[_vm._v(_vm._s(generalHand.equity)+"%")]):_vm._e()])])}),0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Hand")]),_vm._v(" "),_c('th',[_vm._v("Equity")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W0KM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_ranges_vue__ = __webpack_require__("TbjV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79181808_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_ranges_vue__ = __webpack_require__("87tY");
function injectStyle (ssrContext) {
  __webpack_require__("+5ZU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79181808"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_ranges_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79181808_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_ranges_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "W5Ra":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{staticClass:"five-card-hand-weight-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])]),_vm._v(" "),(_vm.fiveCardHand)?_c('h4',{staticClass:"modal-title",domProps:{"innerHTML":_vm._s(_vm.fiveCardHand.text)}}):_vm._e()]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[(_vm.fiveCardHand && _vm.fiveCardHand.visible)?_c('section',[(!_vm.fiveCardHand.checked)?_c('p',[_vm._v("\n        You can't set the weight of checkboxes that aren't checked.\n      ")]):(_vm.fiveCardHand.children)?_c('section',[_c('p',[_vm._v("Set weight of all children:")]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"sliderParent",model:{value:(_vm.fiveCardHandParentWeight),callback:function ($$v) {_vm.fiveCardHandParentWeight=$$v},expression:"fiveCardHandParentWeight"}},'vue-slider',_vm.vueSliderOptions,false)),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.applyExactWeightToFiveCardHand(_vm.fiveCardHand, _vm.$refs.sliderParent.value)}}},[_vm._v("\n          Apply\n        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Example use case: if you think that opponents would only continue with their flush draws 75% of the time rather than 100% of the time.")])],1):_c('section',[_c('p',[_vm._v("Set weight:")]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"sliderLeaf",on:{"callback":function($event){return _vm.$emit('updateWeightOfFiveCardHand', { fiveCardHandId: _vm.fiveCardHand.id, newWeight: $event })}},model:{value:(_vm.fiveCardHandLeafWeight),callback:function ($$v) {_vm.fiveCardHandLeafWeight=$$v},expression:"fiveCardHandLeafWeight"}},'vue-slider',_vm.vueSliderOptions,false)),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Example use case: if you think that opponents would continue with their gutshots 25% of the time rather than 0% of the time.")])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W9EZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_vue__ = __webpack_require__("om4Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_730a76b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breakeven_percentage_for_bluffing_the_turn_vue__ = __webpack_require__("sbUy");
function injectStyle (ssrContext) {
  __webpack_require__("hkfp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-730a76b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_730a76b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breakeven_percentage_for_bluffing_the_turn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WF3E":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WRsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_settings_validators__ = __webpack_require__("F892");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hand-rankings-settings',
  data: function data() {
    return {
      handRankingsType: this.$store.state.account.user.settings.general.handRankings.type,
      isHelpVisible: false
    };
  },
  computed: {
    shortDeck: function shortDeck() {
      return this.$store.getters['account/purchasedShortDeck'];
    }
  },
  methods: {
    saveHandRankings: function saveHandRankings() {
      var self = this;
      var customHandRankings = '';
      var user = _.cloneDeep(this.$store.state.account.user);

      if (this.handRankingsType === 'custom') {
        customHandRankings = this.$refs.customHandRankings.value;

        if (!__WEBPACK_IMPORTED_MODULE_0__services_settings_validators__["a" /* default */].areCustomHandRankingsValid(customHandRankings)) {
          alert('The custom hands you entered are invalid. See the rules at the bottom of this page.');
        } else {
          customHandRankings = customHandRankings.toLowerCase();
          customHandRankings = customHandRankings.replace(/, /g, ',');
        }
      }

      user.settings.general.handRankings = {
        type: self.handRankingsType,
        customHandRankings: customHandRankings
      }, self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "WRtx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',[_vm._v("Say you learn that “manzana” means “apple” in spanish. If you don’t come back and practice what you learned, you’re going to forget it over time.")]),_vm._v(" "),_c('p',[_vm._v("At first, you’ll probably want to review your new vocabulary word every day. After you do that for a couple days, it’ll start to sink in and you’ll only have to review it once a week. Then after doing that a few times, it’ll really have sunk in, and you’ll only have to review it once every few months. So on and so forth.")]),_vm._v(" "),_c('p',[_vm._v("The big idea is that when you learn things, you have to make sure that you review and practice them at reasonably spaced out intervals.")]),_vm._v(" "),_c('img',{attrs:{"src":"https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.pdhpe.net%2Fwp-content%2Fuploads%2F2016%2F01%2Fspaced-repetition.jpg&f=1&nofb=1"}}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("Say you take Chemistry 101 your freshman year, and then Chemistry 102 your senior year. They let you take 102 because you “have the prerequisite”. But if you haven’t thought about chemistry in three years, you probably don’t remember anything from Chemistry 101.")]),_vm._v(" "),_c('p',[_vm._v("And then within a given class, you’ll learn about some topic, move on from it, and then have it pop up on the final exam 12 weeks later. Sometimes you’ll be lucky and the topic will be reinforced throughout the semester, but all too often it won’t, and you’ll have forgotten it if you didn’t take the initiative to review it yourself throughout the semester.")]),_vm._v(" "),_c('p',[_vm._v("I’m not trying to get into a debate about the education system here. The reason I bring it up is because I think we’ve all developed some pretty bad habits from it. It’s hard not to when you spend 13-17+ years of your life in a traditional schooling system.")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("Let’s focus on spaced repetition for now, and talk about how you can use it to your advantage when you study poker.")]),_vm._v(" "),_c('p',[_vm._v("There are some spots that come up over and over and over again. Cbetting a dry ace high or king high board is a good example. So if you study that spot and just go about your normal business playing poker, you’ll probably come across enough hands to hammer in that concept.")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('p',[_vm._v("I know, I know. Create flash cards to study what to do on a TTT board? Definitely seems a little weird. I doubt any of your friends are doing that. But TTT is just an extreme example. What about something like 4betting and dealing with 4bets? I know that for me, these sorts of unusual spots do come up and give me trouble.")]),_vm._v(" "),_c('p',[_vm._v("Of course, there's something to be said for the fact that if these spots are occur infrequently, it isn't worth spending as much time studying them. That's a fair point. But if you're a more advanced player and already feel comfortable in the more common spots, you'll need to start pinning down these less common spots if you want to add to your game.")]),_vm._v(" "),_c('p',[_vm._v("The overall message of this post isn't that all poker players need to study with flash cards and precise intervals. It's moreso just to be aware that spaced repetition is a thing, and to take it into consideration when you study poker.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('subscribe-to-blog')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Spaced repetition and poker")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("There’s an idea in educational psychology called "),_c('a',{attrs:{"href":"https://apps.ankiweb.net/docs/manual.html#spaced-repetition"}},[_vm._v("spaced repetition")]),_vm._v(". Here’s how it works.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("It’s worth noting that the education system "),_c('em',[_vm._v("sucks")]),_vm._v(" at doing this.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("I think that this is very relevant to you as a poker player. All battles are won before they are fought. In poker, this means that games are won off the table. Eg. when you're studying. But if you’ve grown up in a traditional schooling system, you’ve no doubt had some really bad study habits ingrained in you, and thus your off-table work will suffer. My point is that "),_c('a',{attrs:{"href":"https://www.coursera.org/learn/learning-how-to-learn/"}},[_vm._v("learning how to learn")]),_vm._v(" is really important.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("But other spots don’t come up as often. An extreme example would be a “bingo” board, like TTT or 444 or JJJ. For those spots, if you want to play them well, going about your normal business probably won’t be good enough. You’ll have to go out of your way to make sure you reinforce what you learn. Especially if you don't play a significant number of hands every month. I’d consider using an app like "),_c('a',{attrs:{"href":"https://apps.ankiweb.net"}},[_vm._v("Anki")]),_vm._v(" or "),_c('a',{attrs:{"href":"https://www.supermemo.com/en"}},[_vm._v("Supermemo")]),_vm._v(" to create flash cards.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WcwY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Wdtl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WjAE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'three-bet-cbet-explorer-table',
  props: ['selectedContinueVs3betPercentage', 'evForSelected', 'evForZeroPercent', 'evForTwentyPercent', 'evForFourtyPercent', 'evForSixtyPercent', 'evForEightyPercent', 'evForOneHundredPercent'],
  mounted: function mounted() {
    if (true) {
      $(this.$el).find('[data-toggle="tooltip"]').tooltip();
    }
  },
  methods: {
    getEVDisplayText: function getEVDisplayText(ev) {
      if (ev === null || isNaN(ev)) {
        return 'n/a';
      }

      return ev + 'bb';
    },
    getColorClass: function getColorClass(ev) {
      if (ev === null || isNaN(ev)) {
        return;
      }

      if (ev >= 5.5) {
        return 'green-95-100';
      } else if (ev >= 5) {
        return 'green-90-95';
      } else if (ev >= 4.5) {
        return 'green-85-90';
      } else if (ev >= 3) {
        return 'green-80-85';
      } else if (ev >= 2.5) {
        return 'green-75-80';
      } else if (ev >= 2) {
        return 'green-70-75';
      } else if (ev >= 1.5) {
        return 'green-65-70';
      } else if (ev >= 1) {
        return 'green-60-65';
      } else if (ev >= 0.5) {
        return 'green-55-60';
      } else if (ev > 0) {
        return 'green-50-55';
      } else if (ev === 0) {
        return 'gray-50';
      } else if (ev >= -0.5) {
        return 'red-45-50';
      } else if (ev >= -1) {
        return 'red-40-45';
      } else if (ev >= -1.5) {
        return 'red-35-40';
      } else if (ev >= -2) {
        return 'red-30-35';
      } else if (ev >= -2.5) {
        return 'red-25-30';
      } else if (ev >= -3) {
        return 'red-20-25';
      } else if (ev >= -3.5) {
        return 'red-15-20';
      } else if (ev >= -4) {
        return 'red-10-15';
      } else if (ev >= -4.5) {
        return 'red-5-10';
      } else if (ev < -4.5) {
        return 'red-0-5';
      } else {
        console.log(ev);
        throw new Error('Invalid value for ev');
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Wrf2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_hands_SpecificHand__ = __webpack_require__("0qOH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  inRangeWithFirstRank: function inRangeWithFirstRank(generalHands, firstRank) {
    var offsuitGeneralHandsInRangeWithFirstRank = this._getOffsuitGeneralHandsInRangeWithFirstRank(generalHands, firstRank);
    var groupsOfConsecutiveOffsuitGeneralHands = this._getGroupsOfConsecutiveOffsuitGeneralHands(offsuitGeneralHandsInRangeWithFirstRank);
    var textFromOffsuitGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveOffsuitGeneralHands(groupsOfConsecutiveOffsuitGeneralHands);

    return textFromOffsuitGeneralHandsWithFirstRank;
  },
  manuallyAddedWithFirstRank: function manuallyAddedWithFirstRank(generalHands, firstRank) {
    var offsuitGeneralHandsManuallyAddedWithFirstRank = this._getOffsuitGeneralHandsManuallyAddedWithFirstRank(generalHands, firstRank);
    var groupsOfConsecutiveOffsuitGeneralHands = this._getGroupsOfConsecutiveOffsuitGeneralHands(offsuitGeneralHandsManuallyAddedWithFirstRank);
    var textFromOffsuitGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveOffsuitGeneralHands(groupsOfConsecutiveOffsuitGeneralHands);

    return textFromOffsuitGeneralHandsWithFirstRank;
  },
  manuallyRemovedWithFirstRank: function manuallyRemovedWithFirstRank(generalHands, firstRank) {
    var offsuitGeneralHandsManuallyRemovedWithFirstRank = this._getOffsuitGeneralHandsManuallyRemovedWithFirstRank(generalHands, firstRank);
    var groupsOfConsecutiveOffsuitGeneralHands = this._getGroupsOfConsecutiveOffsuitGeneralHands(offsuitGeneralHandsManuallyRemovedWithFirstRank);
    var textFromOffsuitGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveOffsuitGeneralHands(groupsOfConsecutiveOffsuitGeneralHands);

    return textFromOffsuitGeneralHandsWithFirstRank;
  },
  _getOffsuitGeneralHandsInRangeWithFirstRank: function _getOffsuitGeneralHandsInRangeWithFirstRank(generalHands, firstRank) {
    var listOfOffsuitGeneralHandsInRangeWithFirstRank = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.offsuit[firstRank].forEach(function (offsuitGeneralHandWithFirstRankString) {
      var offsuitGeneralHandWithFirstRank = generalHands.find(offsuitGeneralHandWithFirstRankString);

      if (offsuitGeneralHandWithFirstRank.inRange === true) {
        listOfOffsuitGeneralHandsInRangeWithFirstRank.push(offsuitGeneralHandWithFirstRank);
      } else if (offsuitGeneralHandWithFirstRank.inRange === 'partial') {
        offsuitGeneralHandWithFirstRank.forEachSpecificHandInRange(function (specificHand) {
          listOfOffsuitGeneralHandsInRangeWithFirstRank.push(specificHand);
        });
      }
    });

    return listOfOffsuitGeneralHandsInRangeWithFirstRank;
  },
  _getOffsuitGeneralHandsManuallyAddedWithFirstRank: function _getOffsuitGeneralHandsManuallyAddedWithFirstRank(generalHands, firstRank) {
    var listOfOffsuitGeneralHandsManuallyAddedWithFirstRank = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.offsuit[firstRank].forEach(function (offsuitGeneralHandWithFirstRankString) {
      var offsuitGeneralHandWithFirstRank = generalHands.find(offsuitGeneralHandWithFirstRankString);

      if (offsuitGeneralHandWithFirstRank.manuallyAdded === true) {
        listOfOffsuitGeneralHandsManuallyAddedWithFirstRank.push(offsuitGeneralHandWithFirstRank);
      } else if (offsuitGeneralHandWithFirstRank.manuallyAdded === 'partial') {
        offsuitGeneralHandWithFirstRank.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyAdded) {
            listOfOffsuitGeneralHandsManuallyAddedWithFirstRank.push(specificHand);
          }
        });
      }
    });

    return listOfOffsuitGeneralHandsManuallyAddedWithFirstRank;
  },
  _getOffsuitGeneralHandsManuallyRemovedWithFirstRank: function _getOffsuitGeneralHandsManuallyRemovedWithFirstRank(generalHands, firstRank) {
    var listOfOffsuitGeneralHandsManuallyRemovedWithFirstRank = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.offsuit[firstRank].forEach(function (offsuitGeneralHandWithFirstRankString) {
      var offsuitGeneralHandWithFirstRank = generalHands.find(offsuitGeneralHandWithFirstRankString);

      if (offsuitGeneralHandWithFirstRank.manuallyRemoved === true) {
        listOfOffsuitGeneralHandsManuallyRemovedWithFirstRank.push(offsuitGeneralHandWithFirstRank);
      } else if (offsuitGeneralHandWithFirstRank.manuallyRemoved === 'partial') {
        offsuitGeneralHandWithFirstRank.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyRemoved) {
            listOfOffsuitGeneralHandsManuallyRemovedWithFirstRank.push(specificHand);
          }
        });
      }
    });

    return listOfOffsuitGeneralHandsManuallyRemovedWithFirstRank;
  },
  _getGroupsOfConsecutiveOffsuitGeneralHands: function _getGroupsOfConsecutiveOffsuitGeneralHands(suitedGeneralHandsInRange) {
    var groupsOfConsecutiveOffsuitGeneralHands = [];
    var currGroupOfConsecutiveOffsuitGeneralHands = [];

    suitedGeneralHandsInRange.forEach(function (suitedGeneralHandInRange) {
      var suitedGeneralHandInRangeIsNextInOrder = this._isOffsuitGeneralHandInRangeNextInOrder(suitedGeneralHandInRange, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(currGroupOfConsecutiveOffsuitGeneralHands));

      if (currGroupOfConsecutiveOffsuitGeneralHands.length === 0 || suitedGeneralHandInRangeIsNextInOrder) {
        currGroupOfConsecutiveOffsuitGeneralHands.push(suitedGeneralHandInRange);
      } else {
        groupsOfConsecutiveOffsuitGeneralHands.push(currGroupOfConsecutiveOffsuitGeneralHands);
        currGroupOfConsecutiveOffsuitGeneralHands = [];
        currGroupOfConsecutiveOffsuitGeneralHands.push(suitedGeneralHandInRange);
      }
    }, this);

    if (currGroupOfConsecutiveOffsuitGeneralHands.length > 0) {
      groupsOfConsecutiveOffsuitGeneralHands.push(currGroupOfConsecutiveOffsuitGeneralHands);
    }

    return groupsOfConsecutiveOffsuitGeneralHands;
  },
  _isOffsuitGeneralHandInRangeNextInOrder: function _isOffsuitGeneralHandInRangeNextInOrder(currOffsuitGeneralHand, previousOffsuitGeneralHand) {
    if (currOffsuitGeneralHand instanceof __WEBPACK_IMPORTED_MODULE_0__services_hands_SpecificHand__["a" /* default */]) {
      return false;
    }

    if (!previousOffsuitGeneralHand) {
      return true;
    }

    var currOffsuitGeneralHandRank = currOffsuitGeneralHand.rankTwo;
    var previousOffsuitGeneralHandRank = previousOffsuitGeneralHand.rankTwo;

    return __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(previousOffsuitGeneralHandRank) === currOffsuitGeneralHandRank;
  },
  _getTextFromGroupsOfConsecutiveOffsuitGeneralHands: function _getTextFromGroupsOfConsecutiveOffsuitGeneralHands(groupsOfConsecutiveOffsuitGeneralHands) {
    var textFromGroupsOfConsecutiveOffsuitGeneralHands = '';

    groupsOfConsecutiveOffsuitGeneralHands.forEach(function (groupOfConsecutiveOffsuitGeneralHands) {
      textFromGroupsOfConsecutiveOffsuitGeneralHands += this._getTextFromGroupOfConsecutiveOffsuitGeneralHands(groupOfConsecutiveOffsuitGeneralHands) + ', ';
    }, this);

    return textFromGroupsOfConsecutiveOffsuitGeneralHands;
  },
  _getTextFromGroupOfConsecutiveOffsuitGeneralHands: function _getTextFromGroupOfConsecutiveOffsuitGeneralHands(groupOfConsecutiveOffsuitGeneralHands) {
    var firstOffsuitGeneralHand = groupOfConsecutiveOffsuitGeneralHands[0];
    var lastOffsuitGeneralHand = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(groupOfConsecutiveOffsuitGeneralHands);
    var biggestPossibleSecondRank = __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(firstOffsuitGeneralHand.rankOne);
    var secondRankOfFirstOffsuitGeneralHand = firstOffsuitGeneralHand.rankTwo;
    var secondRankOfLastOffsuitGeneralHand = lastOffsuitGeneralHand.rankTwo;

    if (groupOfConsecutiveOffsuitGeneralHands.length === 1) {
      return firstOffsuitGeneralHand.string;
    } else {
      return firstOffsuitGeneralHand.string + '-' + lastOffsuitGeneralHand.string;
    }
  }
});

/***/ }),

/***/ "WsCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  props: ['chartData'],
  data: function data() {
    return {
      chartOptions: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'Continue vs 3bet percentage'
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'EV (bb)'
            }
          }]
        }
      }
    };
  },
  mounted: function mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
});

/***/ }),

/***/ "WwOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator-insights-settings',
  data: function data() {
    return {
      hitCalculatorInsightsVisible: this.$store.state.account.user.settings.hitCalculator.insightsVisible.toString()
    };
  },
  methods: {
    save: function save() {
      var self = this;
      var user = _.cloneDeep(this.$store.state.account.user);
      var newValue = this.hitCalculatorInsightsVisible === 'true' ? true : false;

      user.settings.hitCalculator.insightsVisible = newValue;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "WztS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{staticClass:"set-weight-to-apply-to-added-hands-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Set weight to apply to added hands")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("When you add hands to the range, those hands will be given a weight indicated by the value of the slider below.")]),_vm._v(" "),_c('p',[_vm._v("Eg. if you set the slider to 70 and then add AA, AA will have a weight of 70.")]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"slider",on:{"callback":function($event){return _vm.$emit('setWeightToApplyToAddedHands', _vm.weightToApplyToAddedHandsVModel)}},model:{value:(_vm.weightToApplyToAddedHandsVModel),callback:function ($$v) {_vm.weightToApplyToAddedHandsVModel=$$v},expression:"weightToApplyToAddedHandsVModel"}},'vue-slider',_vm.sliderOptions,false))],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X/7U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insights_vue__ = __webpack_require__("z7qe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc85f30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insights_vue__ = __webpack_require__("XrQx");
function injectStyle (ssrContext) {
  __webpack_require__("tgMT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dc85f30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insights_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc85f30_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insights_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X/Fc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_text_get_text_from_general_hands_get_text_from_pairs__ = __webpack_require__("SYH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__ = __webpack_require__("zwxf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__ = __webpack_require__("Wrf2");




/* harmony default export */ __webpack_exports__["a"] = ({
  inRange: function inRange(generalHands) {
    var textString = '';

    textString += __WEBPACK_IMPORTED_MODULE_0__services_text_get_text_from_general_hands_get_text_from_pairs__["a" /* default */].inRange(generalHands);
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 'a');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 'a');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 'k');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 'k');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 'q');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 'q');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 'j');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 'j');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 't');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, 't');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '9');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '9');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '8');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '8');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '7');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '7');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '6');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '6');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '5');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '5');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '4');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '4');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '3');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].inRangeWithFirstRank(generalHands, '3');
    textString = textString.replace(/a/g, 'A');
    textString = textString.replace(/k/g, 'K');
    textString = textString.replace(/q/g, 'Q');
    textString = textString.replace(/j/g, 'J');
    textString = textString.replace(/t/g, 'T');
    textString = textString.slice(0, -2); // remove trailing comma

    return textString;
  },
  manuallyAdded: function manuallyAdded(generalHands) {
    var textString = '';

    textString += __WEBPACK_IMPORTED_MODULE_0__services_text_get_text_from_general_hands_get_text_from_pairs__["a" /* default */].manuallyAdded(generalHands);
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 'a');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 'a');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 'k');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 'k');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 'q');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 'q');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 'j');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 'j');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 't');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, 't');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '9');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '9');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '8');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '8');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '7');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '7');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '6');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '6');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '5');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '5');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '4');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '4');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '3');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyAddedWithFirstRank(generalHands, '3');
    textString = textString.replace(/a/g, 'A');
    textString = textString.replace(/k/g, 'K');
    textString = textString.replace(/q/g, 'Q');
    textString = textString.replace(/j/g, 'J');
    textString = textString.replace(/t/g, 'T');
    textString = textString.slice(0, -2); // remove trailing comma

    return textString;
  },
  manuallyRemoved: function manuallyRemoved(generalHands) {
    var textString = '';

    textString += __WEBPACK_IMPORTED_MODULE_0__services_text_get_text_from_general_hands_get_text_from_pairs__["a" /* default */].manuallyRemoved(generalHands);
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 'a');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 'a');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 'k');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 'k');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 'q');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 'q');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 'j');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 'j');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 't');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, 't');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '9');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '9');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '8');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '8');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '7');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '7');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '6');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '6');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '5');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '5');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '4');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '4');
    textString += __WEBPACK_IMPORTED_MODULE_1__services_text_get_text_from_general_hands_get_text_from_suited_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '3');
    textString += __WEBPACK_IMPORTED_MODULE_2__services_text_get_text_from_general_hands_get_text_from_offsuit_general_hands__["a" /* default */].manuallyRemovedWithFirstRank(generalHands, '3');
    textString = textString.replace(/a/g, 'A');
    textString = textString.replace(/k/g, 'K');
    textString = textString.replace(/q/g, 'Q');
    textString = textString.replace(/j/g, 'J');
    textString = textString.replace(/t/g, 'T');
    textString = textString.slice(0, -2); // remove trailing comma

    return textString;
  }
});

/***/ }),

/***/ "XL0g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__ = __webpack_require__("2EOj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  run: function run(handInfo, holeCards, communityCards, shortDeck) {
    if (handInfo.name === 'flush') {
      this._setSpecificFlushType(handInfo, holeCards, communityCards, shortDeck);
    } else if (handInfo.name === 'three of a kind') {
      this._setSpecificThreeOfAKindType(handInfo, holeCards, communityCards);
    } else if (handInfo.name === 'two pair') {
      this._setSpecificTwoPairType(handInfo, holeCards, communityCards);
    } else if (handInfo.name === 'pair') {
      this._setSpecificPairType(handInfo, holeCards, communityCards, shortDeck);
    } else if (handInfo.name === 'high card') {
      this._setSpecificHighCardType(handInfo, holeCards, communityCards);
    }
  },
  _setSpecificFlushType: function _setSpecificFlushType(handInfo, holeCards, communityCards, shortDeck) {
    var numHoleCardsUsed = this.__getNumHoleCardsUsed(handInfo, holeCards, communityCards);
    var nutLevel = this.__getNutLevel(handInfo, holeCards, communityCards, shortDeck);
    var nutLevelCamelCase = void 0;

    if (nutLevel === 'nut') {
      nutLevelCamelCase = 'nut';
    } else if (nutLevel === 'second nut') {
      nutLevelCamelCase = 'secondNut';
    } else if (nutLevel === 'third nut') {
      nutLevelCamelCase = 'thirdNut';
    } else if (nutLevel === 'weak') {
      nutLevelCamelCase = 'weak';
    }

    if (numHoleCardsUsed === 0) {
      handInfo.id = 'usingABoardCard:flushOnBoard';
      handInfo.type = 'on board';
    } else if (numHoleCardsUsed === 1) {
      handInfo.id = 'usingABoardCard:flushUsingOneHoleCard:' + nutLevelCamelCase;
      handInfo.type = 'using one hole card - ' + nutLevel;
    } else if (numHoleCardsUsed === 2) {
      handInfo.id = 'flush:' + nutLevelCamelCase;
      handInfo.type = 'using two hole cards - ' + nutLevel;
    } else {
      throw new Error('Invalid value for numHoleCardsUsed.');
    }
  },
  __getNumHoleCardsUsed: function __getNumHoleCardsUsed(handInfo, holeCards, communityCards) {
    var flushSuit = handInfo.suit;
    var numHandCardsThatAreHoleCards = 0;
    var numCommunityCardsOfFlushSuit = this.___getNumMatches(communityCards, function (communityCard) {
      var communityCardSuit = communityCard[1];
      return communityCardSuit === flushSuit;
    });
    var numHoleCardsOfFlushSuit = this.___getNumMatches(holeCards, function (holeCard) {
      var holeCardSuit = holeCard[1];
      return holeCardSuit === flushSuit;
    });

    if (numCommunityCardsOfFlushSuit === 3 && numHoleCardsOfFlushSuit === 2) {
      return 2;
    } else if (numCommunityCardsOfFlushSuit === 4 && numHoleCardsOfFlushSuit >= 1) {
      return 1;
    } else if (numCommunityCardsOfFlushSuit === 5) {
      numHandCardsThatAreHoleCards = this.___getNumMatches(holeCards, function (holeCard) {
        return handInfo.handCards.includes(holeCard);
      });

      if (numHandCardsThatAreHoleCards >= 1) {
        return 1;
      } else if (numHandCardsThatAreHoleCards === 0) {
        return 0;
      }
    }
  },
  ___getNumMatches: function ___getNumMatches(arr, arg2) {
    var count = 0;

    // predicate function was passed in to test for matching
    if (typeof arg2 === 'function') {
      arr.forEach(function (el) {
        if (arg2(el)) {
          count++;
        }
      });
    }

    // value was passed in to test for matching
    else {
        arr.forEach(function (el) {
          if (el === arg2) {
            count++;
          }
        });
      }

    return count;
  },
  __getNutLevel: function __getNutLevel(handInfo, holeCards, communityCards, shortDeck) {
    var communityCardFlushRanks = void 0;
    var unusedRanks = void 0;
    var holeCardsOfFlushSuit = void 0;
    var biggestHoleCardOfFlushSuitRank = void 0;
    var nutLevelIndex = void 0;
    var flushSuit = void 0;

    flushSuit = handInfo.suit;
    communityCardFlushRanks = [];
    communityCards.forEach(function (communityCard) {
      var communityCardRank = communityCard[0];
      var communityCardSuit = communityCard[1];

      if (communityCardSuit === flushSuit) {
        communityCardFlushRanks.push(communityCardRank);
      }
    });
    unusedRanks = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.filter(function (rank) {
      var isACommunityCardFlushRank = void 0;
      var makesARoyalOrStraightFlush = void 0;

      isACommunityCardFlushRank = communityCardFlushRanks.includes(rank);
      if (isACommunityCardFlushRank) {
        return false;
      }

      if (shortDeck) {
        makesARoyalOrStraightFlush = !!__WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */]._checkForFiveOrMoreRanksInARowShortDeck(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(communityCardFlushRanks, [rank]).sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction));
      } else {
        makesARoyalOrStraightFlush = !!__WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */]._checkForFiveOrMoreRanksInARow(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(communityCardFlushRanks, [rank]).sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction));
      }
      if (makesARoyalOrStraightFlush) {
        return false;
      }

      return true;
    });
    holeCardsOfFlushSuit = holeCards.filter(function (holeCard) {
      var holeCardSuit = holeCard[1];
      return holeCardSuit === flushSuit;
    });
    biggestHoleCardOfFlushSuitRank = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getHighestRankFromCards(holeCardsOfFlushSuit);
    nutLevelIndex = unusedRanks.indexOf(biggestHoleCardOfFlushSuitRank);

    if (holeCardsOfFlushSuit.length > 0 && nutLevelIndex === -1) {
      throw new Error('Error getting nut level');
    } else if (nutLevelIndex === 0) {
      return 'nut';
    } else if (nutLevelIndex === 1) {
      return 'second nut';
    } else if (nutLevelIndex === 2) {
      return 'third nut';
    } else if (nutLevelIndex >= 3 && nutLevelIndex <= 12) {
      return 'weak';
    } else if (nutLevelIndex !== -1) {
      throw new Error('Invalid value of nutLevelIndex.');
    }
  },
  _setSpecificThreeOfAKindType: function _setSpecificThreeOfAKindType(handInfo, holeCards, communityCards) {
    var threeOfAKindCards = handInfo.handCards.slice(0, 3);
    var threeOfAKindRank = handInfo.rank;
    var numHoleCardsUsedInThreeOfAKind = this.___getNumMatches(holeCards, function (holeCard) {
      return threeOfAKindCards.includes(holeCard);
    });

    if (numHoleCardsUsedInThreeOfAKind === 0) {
      handInfo.id = 'usingABoardCard:threeOfAKindOnBoard';
      handInfo.type = 'on board';
    } else if (numHoleCardsUsedInThreeOfAKind === 1) {
      handInfo.id = 'threeOfAKind:trips';
      handInfo.type = 'trips';
    } else if (numHoleCardsUsedInThreeOfAKind === 2) {
      communityCards.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction);

      if (communityCards.length === 3) {
        if (communityCards[0][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:topSet';
          handInfo.type = 'top set';
        } else if (communityCards[1][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:middleSet';
          handInfo.type = 'middle set';
        } else if (communityCards[2][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:bottomSet';
          handInfo.type = 'bottom set';
        }
      } else if (communityCards.length === 4) {
        if (communityCards[0][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:topSet';
          handInfo.type = 'top set';
        } else if (communityCards[1][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:secondSet';
          handInfo.type = 'second set';
        } else if (communityCards[2][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:thirdSet';
          handInfo.type = 'third set';
        } else if (communityCards[3][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:bottomSet';
          handInfo.type = 'bottom set';
        }
      } else if (communityCards.length === 5) {
        if (communityCards[0][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:topSet';
          handInfo.type = 'top set';
        } else if (communityCards[1][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:secondSet';
          handInfo.type = 'second set';
        } else if (communityCards[2][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:thirdSet';
          handInfo.type = 'third set';
        } else if (communityCards[3][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:fourthSet';
          handInfo.type = 'fourth set';
        } else if (communityCards[4][0] === threeOfAKindRank) {
          handInfo.id = 'threeOfAKind:bottomSet';
          handInfo.type = 'bottom set';
        }
      }
    } else {
      throw new Error('Invalid value for numHoleCardsUsedInThreeOfAKind.');
    }
  },
  _setSpecificTwoPairType: function _setSpecificTwoPairType(handInfo, holeCards, communityCards) {
    var holeCardRanks = [holeCards[0][0], holeCards[1][0]];
    holeCardRanks.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction);
    var largerHoleCardRank = holeCardRanks[0];
    var smallerHoleCardRank = holeCardRanks[1];
    var holeCardsArePaired = largerHoleCardRank === smallerHoleCardRank;
    var twoPairRanks = [handInfo.higherPairRank, handInfo.lowerPairRank];
    var largestCommunityCardRank = communityCards.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction)[0][0];
    var bothHoleCardsUsedForTwoPair = void 0;
    var oneHoleCardUsedForTwoPair = void 0;

    if (holeCardsArePaired) {
      if (twoPairRanks.includes(largerHoleCardRank)) {
        handInfo.id = 'usingABoardCard:twoPairWithPairOnBoard';
        handInfo.type = 'pair on board';
      } else {
        handInfo.id = 'usingABoardCard:twoPairOnBoard';
        handInfo.type = 'on board';
      }
    } else if (!holeCardsArePaired) {
      bothHoleCardsUsedForTwoPair = twoPairRanks.includes(largerHoleCardRank) && twoPairRanks.includes(smallerHoleCardRank);
      oneHoleCardUsedForTwoPair = twoPairRanks.includes(largerHoleCardRank) !== twoPairRanks.includes(smallerHoleCardRank); // xor

      if (bothHoleCardsUsedForTwoPair) {
        if (twoPairRanks.includes(largestCommunityCardRank)) {
          handInfo.id = 'twoPair:usingTopBoardCard';
          handInfo.type = 'using top board card';
        } else {
          handInfo.id = 'twoPair:weak';
          handInfo.type = 'weak';
        }
      } else if (oneHoleCardUsedForTwoPair) {
        handInfo.id = 'usingABoardCard:twoPairWithPairOnBoard';
        handInfo.type = 'pair on board';
      } else {
        // no hole cards used for two pair
        handInfo.id = 'usingABoardCard:twoPairOnBoard';
        handInfo.type = 'on board';
      }
    }
  },
  _setSpecificPairType: function _setSpecificPairType(handInfo, holeCards, communityCards, shortDeck) {
    var communityCardRanks = void 0;
    var pairRankPosition = void 0;
    var kickerType = void 0;
    var kickerRank = void 0;

    communityCardRanks = [];
    communityCards.forEach(function (communityCard) {
      communityCardRanks.push(communityCard[0]);
    });

    // when there is a pair on the board
    if (__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].general.checkForDuplicates(communityCardRanks)) {
      handInfo.id = 'usingABoardCard:pairOnBoard';
      handInfo.type = 'on board';
      return;
    }

    communityCardRanks.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction);
    pairRankPosition = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.getRankPositionAmongstCommunityCards(handInfo.rank, communityCardRanks);

    if (pairRankPosition === 'over') {
      handInfo.id = 'pair:overpair';
      handInfo.type = 'overpair';
    } else if (pairRankPosition === 'top') {
      holeCards.forEach(function (holeCard) {
        if (holeCard[0] !== handInfo.rank) {
          kickerRank = holeCard[0];
        }
      });
      kickerType = this.__getKickerType(kickerRank, communityCardRanks, shortDeck);
      handInfo.type = 'top pair, ' + kickerType + ' kicker';

      if (kickerType === 'top') {
        handInfo.id = 'pair:tptk';
      } else if (kickerType === 'good') {
        handInfo.id = 'pair:tpgk';
      } else if (kickerType === 'weak') {
        handInfo.id = 'pair:tpwk';
      }
    } else if (pairRankPosition === 'over middle' || pairRankPosition === 'over second') {
      handInfo.id = 'pair:ppUnderTp';
      handInfo.type = 'pocket pair under top pair';
    } else if (pairRankPosition === 'second') {
      handInfo.id = 'pair:secondPair';
      handInfo.type = 'second';
    } else if (pairRankPosition === 'middle') {
      handInfo.id = 'pair:middlePair';
      handInfo.type = 'middle';
    } else {
      handInfo.id = 'pair:weakPair';
      handInfo.type = 'weak';
    }
  },
  __getKickerType: function __getKickerType(kickerRank, communityCardRanks, shortDeck) {
    // a8 on akqj9
    // 8765432
    var unusedRanks = __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].ranks.filter(function (rank) {
      var isACommunityCardRank = void 0;
      var makesAStraight = void 0;

      isACommunityCardRank = communityCardRanks.includes(rank);
      if (isACommunityCardRank) {
        return false;
      }

      if (shortDeck) {
        makesAStraight = !!__WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */]._checkForFiveOrMoreRanksInARowShortDeck(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(communityCardRanks, [rank]).sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction));
      } else {
        makesAStraight = !!__WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */]._checkForFiveOrMoreRanksInARow(__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.union(communityCardRanks, [rank]).sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction));
      }
      if (makesAStraight) {
        return false;
      }

      return true;
    });
    var kickerRankIndexInUnusedRanks = unusedRanks.indexOf(kickerRank);

    if (kickerRankIndexInUnusedRanks === 0) {
      return 'top';
    } else if (kickerRankIndexInUnusedRanks === 1 || kickerRankIndexInUnusedRanks === 2) {
      return 'good';
    } else if (kickerRankIndexInUnusedRanks > 2) {
      return 'weak';
    } else {
      throw new Error('Error getting kicker type.');
    }
  },
  _setSpecificHighCardType: function _setSpecificHighCardType(handInfo, holeCards, communityCards) {
    var highCardRank = handInfo.kickers[0][0];
    var highHoleCardRank = holeCards.sort(__WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].ranks.sortCardsDescendingByRankCompareFunction)[0][0];

    if (highHoleCardRank === 'a') {
      handInfo.id = 'highCard:aceHigh';
      handInfo.type = 'ace high';
    } else if (highHoleCardRank === 'k' && highCardRank !== 'a') {
      handInfo.id = 'highCard:kingHigh';
      handInfo.type = 'king high';
    } else {
      handInfo.id = 'highCard:weak';
      handInfo.type = 'weak';
    }
  }
});

/***/ }),

/***/ "XP0q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_selector__ = __webpack_require__("G1lD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_modal__ = __webpack_require__("jEKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_hands_GeneralHands__ = __webpack_require__("udlG");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'set-hand-weights-modal',
  components: {
    'grid-selector': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_selector__["a" /* default */],
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_1__components_utilities_modal__["a" /* default */],
    'vue-slider': __WEBPACK_IMPORTED_MODULE_2_vue_slider_component___default.a
  },
  props: ['playerStateGeneralHands'],
  data: function data() {
    return {
      sliderOptions: {
        min: 5,
        interval: 5
      },
      weightToApply: 100,
      generalHands: null
    };
  },
  mounted: function mounted() {
    var self = this;

    $(self.$el).on('shown.bs.modal', function () {
      self.initializeGeneralHands();
      self.$nextTick(function () {
        if (self.$refs.slider) {
          self.$refs.slider.refresh();
        }
      });
    });
  },
  methods: {
    initializeGeneralHands: function initializeGeneralHands() {
      this.generalHands = new __WEBPACK_IMPORTED_MODULE_4__services_hands_GeneralHands__["a" /* default */]();

      this.playerStateGeneralHands.forEach(function (generalHandForPlayer, index) {
        var generalHandForModal = this.generalHands.findByIndex(index);

        if (!generalHandForPlayer.inRange) {
          generalHandForModal.forEachPossibleSpecificHand(function (specificHand) {
            specificHand.maxPossibleWeight = 0;
          });
        }
      }, this);
    },
    selectGeneralHand: function selectGeneralHand(generalHandString) {
      var generalHand = this.generalHands.find(generalHandString);

      generalHand.forEachPossibleSpecificHand(function (specificHand) {

        if (!specificHand.inRange) {
          specificHand.weight = 100;
        }
      });
    },
    deselectGeneralHand: function deselectGeneralHand(generalHandString) {
      var generalHand = this.generalHands.find(generalHandString);

      generalHand.forEachSpecificHandInRange(function (specificHand) {
        specificHand.weight = 0;
      });
    },
    selectGeneralHands: function selectGeneralHands(generalHandStrings) {
      generalHandStrings.forEach(function (generalHandString) {
        this.selectGeneralHand(generalHandString);
      }, this);
    },
    deselectGeneralHands: function deselectGeneralHands(generalHandStrings) {
      generalHandStrings.forEach(function (generalHandString) {
        this.deselectGeneralHand(generalHandString);
      }, this);
    },
    deselectAllGeneralHands: function deselectAllGeneralHands() {
      var allGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_3__services_constants__["a" /* default */].handRankings['sklansky-chubukov'];

      this.deselectGeneralHands(allGeneralHandStrings);
    },
    applyWeightToSelectedHands: function applyWeightToSelectedHands() {
      this.$emit('applyExactWeightToGeneralHands', {
        generalHandsFromModal: this.generalHands,
        newWeight: this.weightToApply
      });
      this.deselectAllGeneralHands();
      $('.set-hand-weights-modal').modal('hide');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "XRwE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





var PresetCommunityCards = function () {
  function PresetCommunityCards() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PresetCommunityCards);

    this.flop1 = null;
    this.flop2 = null;
    this.flop3 = null;
    this.turn = null;
    this.river = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PresetCommunityCards, [{
    key: 'getArrayOfImagePaths',
    value: function getArrayOfImagePaths(playerStateIndex) {
      var arrayOfImagePaths = [];
      var arrayOfCards = void 0;
      var rankText = void 0;
      var suitText = void 0;

      if (playerStateIndex === 1) {
        arrayOfCards = this.flopArray;
      } else if (playerStateIndex === 2) {
        arrayOfCards = this.turnArray;
      } else if (playerStateIndex === 3) {
        arrayOfCards = this.riverArray;
      }

      arrayOfCards.forEach(function (card) {
        if (card[0] === 'a') {
          rankText = 'ace';
        } else if (card[0] === 'k') {
          rankText = 'king';
        } else if (card[0] === 'q') {
          rankText = 'queen';
        } else if (card[0] === 'j') {
          rankText = 'jack';
        } else if (card[0] === 't') {
          rankText = 'ten';
        } else if (card[0] === '9') {
          rankText = 'nine';
        } else if (card[0] === '8') {
          rankText = 'eight';
        } else if (card[0] === '7') {
          rankText = 'seven';
        } else if (card[0] === '6') {
          rankText = 'six';
        } else if (card[0] === '5') {
          rankText = 'five';
        } else if (card[0] === '4') {
          rankText = 'four';
        } else if (card[0] === '3') {
          rankText = 'three';
        } else if (card[0] === '2') {
          rankText = 'two';
        }

        if (card[1] === 'c') {
          suitText = 'clubs';
        } else if (card[1] === 's') {
          suitText = 'spades';
        } else if (card[1] === 'h') {
          suitText = 'hearts';
        } else if (card[1] === 'd') {
          suitText = 'diamonds';
        }

        arrayOfImagePaths.push('/static/cards/' + rankText + '-of-' + suitText + '.png');
      });

      return arrayOfImagePaths;
    }
  }, {
    key: 'getArrayForState',
    value: function getArrayForState(stateName) {
      if (stateName === 'afterFlop') {
        return this.flopArray;
      } else if (stateName === 'afterTurn') {
        return this.turnArray;
      } else if (stateName === 'afterRiver') {
        return this.riverArray;
      } else {
        throw new Error('Invalid stateName.');
      }
    }
  }, {
    key: 'getArrayForStateViaIndex',
    value: function getArrayForStateViaIndex(stateIndex) {
      if (stateIndex === 0) {
        return [];
      } else if (stateIndex === 1) {
        return this.flopArray;
      } else if (stateIndex === 2) {
        return this.turnArray;
      } else if (stateIndex === 3) {
        return this.riverArray;
      }
    }
  }, {
    key: 'getArrayForStateViaStreet',
    value: function getArrayForStateViaStreet(street) {
      if (street === 'preflop') {
        return [];
      } else if (street === 'flop') {
        if (this.flopSet) {
          return this.flopArray;
        } else {
          return [];
        }
      } else if (street === 'turn') {
        if (this.turnSet) {
          return this.turnArray;
        } else if (this.flopSet) {
          return this.flopArray;
        } else {
          return [];
        }
      } else if (street === 'river') {
        if (this.riverSet) {
          return this.riverArray;
        } else if (this.turnSet) {
          return this.turnArray;
        } else if (this.flopSet) {
          return this.flopArray;
        } else {
          return [];
        }
      } else {
        throw new Error('Invalid street.');
      }
    }
  }, {
    key: 'areAllCardsSet',
    value: function areAllCardsSet(stateIndex) {
      if (stateIndex === 1) {
        return this.flopSet;
      } else if (stateIndex === 2) {
        return this.turnSet;
      } else if (stateIndex === 3) {
        return this.riverSet;
      }
    }
  }, {
    key: 'numSet',
    get: function get() {
      var numPreset = 0;

      if (this.flop1) {
        numPreset++;
      }

      if (this.flop2) {
        numPreset++;
      }

      if (this.flop3) {
        numPreset++;
      }

      if (this.turn) {
        numPreset++;
      }

      if (this.river) {
        numPreset++;
      }

      return numPreset;
    }
  }, {
    key: 'flopSet',
    get: function get() {
      return this.flop1 && this.flop2 && this.flop3;
    }
  }, {
    key: 'turnSet',
    get: function get() {
      return this.flop1 && this.flop2 && this.flop3 && this.turn;
    }
  }, {
    key: 'riverSet',
    get: function get() {
      return this.flop1 && this.flop2 && this.flop3 && this.turn && this.river;
    }
  }, {
    key: 'array',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].general.getBoardCardsArrayFromObj(this);
    }
  }, {
    key: 'flopArray',
    get: function get() {
      if (!this.flopSet) {
        throw new Error('Trying to get flop array when flop isn\'t set.');
      }

      return [this.flop1, this.flop2, this.flop3];
    }
  }, {
    key: 'turnArray',
    get: function get() {
      if (!this.turnSet) {
        throw new Error('Trying to get turn array when turn isn\'t set.');
      }

      return [this.flop1, this.flop2, this.flop3, this.turn];
    }
  }, {
    key: 'riverArray',
    get: function get() {
      if (!this.riverSet) {
        throw new Error('Trying to get river array when river isn\'t set.');
      }

      return [this.flop1, this.flop2, this.flop3, this.turn, this.river];
    }
  }, {
    key: 'possiblePlayerStateIndexes',
    get: function get() {
      if (this.riverSet) {
        return [0, 1, 2, 3];
      } else if (this.turnSet) {
        return [0, 1, 2];
      } else if (this.flopSet) {
        return [0, 1];
      } else {
        return [0];
      }
    }
  }, {
    key: 'lastPossiblePlayerStateIndex',
    get: function get() {
      if (this.riverSet) {
        return 3;
      } else if (this.turnSet) {
        return 2;
      } else if (this.flopSet) {
        return 1;
      } else {
        return 0;
      }
    }
  }, {
    key: 'flopImagePaths',
    get: function get() {
      return this.getArrayOfImagePaths(1);
    }
  }, {
    key: 'turnImagePaths',
    get: function get() {
      return this.getArrayOfImagePaths(2);
    }
  }, {
    key: 'riverImagePaths',
    get: function get() {
      return this.getArrayOfImagePaths(3);
    }
  }, {
    key: 'pairedBoard',
    get: function get() {
      if (this.flopSet && this.ranks.length < 3) {
        return true;
      }

      if (this.turnSet && this.ranks.length < 4) {
        return true;
      }

      if (this.riverSet && this.ranks.length < 5) {
        return true;
      }

      return false;
    }
  }, {
    key: 'ranks',
    get: function get() {
      var ranks = [];

      if (this.flop1) {
        ranks.push(this.flop1[0]);
      }

      if (this.flop2) {
        ranks.push(this.flop2[0]);
      }

      if (this.flop3) {
        ranks.push(this.flop3[0]);
      }

      if (this.turn) {
        ranks.push(this.turn[0]);
      }

      if (this.river) {
        ranks.push(this.river[0]);
      }

      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.uniq(ranks);
    }
  }]);

  return PresetCommunityCards;
}();

/* harmony default export */ __webpack_exports__["a"] = (PresetCommunityCards);
;

/***/ }),

/***/ "XXru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"short-deck-river-selector"},[_c('short-deck-individual-card-selector',{ref:"flop1",attrs:{"cardString":_vm.presetCommunityCards.flop1,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop1')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop1')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"flop2",attrs:{"cardString":_vm.presetCommunityCards.flop2,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop2')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop2')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"flop3",attrs:{"cardString":_vm.presetCommunityCards.flop3,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop3')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop3')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"turn",attrs:{"cardString":_vm.presetCommunityCards.turn,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'turn')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'turn')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"river",attrs:{"cardString":_vm.presetCommunityCards.river,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'river')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'river')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XZEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_should_you_call_help_vue__ = __webpack_require__("ryF4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6427b240_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_should_you_call_help_vue__ = __webpack_require__("JZWF");
function injectStyle (ssrContext) {
  __webpack_require__("meBw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6427b240"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_should_you_call_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6427b240_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_should_you_call_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XZEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-player-button-container",attrs:{"data-title":_vm.tooltipValue,"data-toggle":"tooltip","data-placement":"top"}},[_c('button',{staticClass:"btn btn-default add-player-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('addPlayer')}}},[_vm._v("\n    "+_vm._s(_vm.text)+" "),_c('span',{staticClass:"glyphicon glyphicon-plus"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XbSQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',_vm._b({ref:"vueSlider",staticClass:"vertical-set-weight-to-apply-to-added-hands-basic",attrs:{"disabled":_vm.disabled},on:{"callback":function($event){return _vm.$emit('setWeightToApplyToAddedHands', _vm.weightToApplyToAddedHandsVModel)}},scopedSlots:_vm._u([{key:"tooltip",fn:function(ref){
var value = ref.value;
return _c('div',{staticClass:"vue-slider-tooltip"},[_vm._v("\n    Weight to apply to added hands: "),_c('strong',[_vm._v(_vm._s(value))])])}}]),model:{value:(_vm.weightToApplyToAddedHandsVModel),callback:function ($$v) {_vm.weightToApplyToAddedHandsVModel=$$v},expression:"weightToApplyToAddedHandsVModel"}},'vue-slider',_vm.sliderOptions,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xct9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_single_slider_selector_vue__ = __webpack_require__("a4NO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc0ded2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_single_slider_selector_vue__ = __webpack_require__("Bjry");
function injectStyle (ssrContext) {
  __webpack_require__("3LcH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3fc0ded2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_single_slider_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fc0ded2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_single_slider_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XfhI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__ = __webpack_require__("oox5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_random_board_selector__ = __webpack_require__("8uf7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-preset-community-cards-selector',
  components: {
    'short-deck-individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__["a" /* default */],
    'short-deck-random-board-selector': __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_random_board_selector__["a" /* default */]
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'popoverDirectionClass', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'river') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function _toggleNextDropdown(previousPosition) {
      var nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function __getNextPosition(previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else if (previousPosition === 'flop3') {
        return 'turn';
      } else if (previousPosition === 'turn') {
        return 'river';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    }
  }
});

/***/ }),

/***/ "XkqR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well should-you-bluff-future-streets-help-section-2 help-section"},[_c('p',[_vm._v("Consider an example. You have 5c4c and the board is Ts7h2d. Suppose that you bluff the flop, get called, and then the turn comes Ah. Now you bluff the turn, and this time you get a fold.")]),_vm._v(" "),_c('p',[_vm._v("In that example, you ended up winning the hand even though your initial bluff didn't work. The immediately profitable breakeven percentage doesn't take this possibility into account. It assumes that you either 1) win the pot outright when your opponent folds, or 2) get called (or raised) and end up losing the pot.")]),_vm._v(" "),_c('p',[_vm._v("Assuming that you always lose when your bluff gets called is often a bad assumption though! So the immediately profitable breakeven percentage is often misleading. Consider this example. The ace is what we call a scare card. Is your opponent continuing with 55? With 87? With T9? The ace may scare them away when they have these mediocre hands.")]),_vm._v(" "),_c('p',[_vm._v("On a board like T72, there are a lot of scare cards. A king is also probably going to be seen as a scare card. Queens and jacks often are too. It's important to factor in the possibility that you win the pot even when your first bluff doesn't work.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XlcI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_blog_blog_post_link__ = __webpack_require__("7nko");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_blog_subscribe_to_blog__ = __webpack_require__("bnhV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-blog',
  components: {
    'blog-post-link': __WEBPACK_IMPORTED_MODULE_0__components_blog_blog_post_link__["a" /* default */],
    'subscribe-to-blog': __WEBPACK_IMPORTED_MODULE_1__components_blog_subscribe_to_blog__["a" /* default */]
  }
});

/***/ }),

/***/ "Xr2F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_street_selector_vue__ = __webpack_require__("0V+e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ea6b694_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_street_selector_vue__ = __webpack_require__("avLb");
function injectStyle (ssrContext) {
  __webpack_require__("mOpl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ea6b694"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_street_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ea6b694_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_street_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XrQx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"equity-calculator-insights"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('header-cell',{attrs:{"profitable":_vm.isCallProfitable(4, 1)}},[_vm._v("\n          4:1 pot odds\n        ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isCallProfitable(3, 1)}},[_vm._v("\n          3:1 pot odds\n        ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isCallProfitable(2, 1)}},[_vm._v("\n          2:1 pot odds\n        ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isCallProfitable(3, 2)}},[_vm._v("\n          3:2 pot odds\n        ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isCallProfitable(1, 1)}},[_vm._v("\n          1:1 pot odds\n        ")])],1)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('table-cell',{attrs:{"profitable":_vm.isCallProfitable(4, 1)}},[_vm._v("\n          20%\n        ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isCallProfitable(3, 1)}},[_vm._v("\n          25%\n        ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isCallProfitable(2, 1)}},[_vm._v("\n          33.3%\n        ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isCallProfitable(3, 2)}},[_vm._v("\n          40%\n        ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isCallProfitable(1, 1)}},[_vm._v("\n          50%\n        ")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Y/UK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FiveCardHandParent = function () {
  function FiveCardHandParent(argsObj) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FiveCardHandParent);

    this.id = argsObj.id;
    this.text = argsObj.text;
    this.fullText = argsObj.fullText;
    this.inlineText = argsObj.inlineText;
    this.children = argsObj.children;
    this.collapsed = true;
    this.count = 0;
    this._probability = null;
    this.percentageOfSpecificHandsThatAreSelected = 0;
    this.isAHit = argsObj.isAHit;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FiveCardHandParent, [{
    key: 'applyExactWeightToFiveCardHand',
    value: function applyExactWeightToFiveCardHand(newWeight) {
      if (!this.visible) {
        throw new Error('Trying to call applyExactWeightToFiveCardHand on a fiveCardHand that isn\'t visible.');
      }

      this.children.forEach(function (child) {
        if (!child.visible) {
          return;
        }

        if (!child.children && child.checked) {
          child.weight = newWeight;
        }

        if (child.children && (child.checked === true || child.checked === 'partially')) {
          child.applyExactWeightToFiveCardHand(newWeight);
        }
      });
    }
  }, {
    key: 'setProbabilityAccordingToMatchingSpecificHands',
    value: function setProbabilityAccordingToMatchingSpecificHands(generalHands) {
      var numberOfPossibleSpecificHands = generalHands.numberOfPossibleSpecificHands;
      var numberOfMatchingSpecificHands = 0;
      var currSpecificHand = void 0;

      this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
        currSpecificHand = generalHands.find(matchingSpecificHandString);
        numberOfMatchingSpecificHands += currSpecificHand.maxPossibleWeight / 100;
      });

      this._probability = numberOfMatchingSpecificHands / numberOfPossibleSpecificHands * 100;
    }
  }, {
    key: 'getNumCombos',
    value: function getNumCombos(numberOfPossibleSpecificHands) {
      return (this.probability / 100 * numberOfPossibleSpecificHands).roundToOneDecimalPlace();
    }
  }, {
    key: 'setPercentageOfSpecificHandsThatAreSelected',
    value: function setPercentageOfSpecificHandsThatAreSelected(generalHands) {
      if (this.matchingSpecificHands.length === 0) {
        if (this.checked) {
          return 100;
        } else {
          return 0;
        }
      }

      this.percentageOfSpecificHandsThatAreSelected = this._getWeightedNumSpecificHandsThatAreSelected(generalHands) / this._getWeightedNumSpecificHandsThatArePossible(generalHands) * 100;
    }
  }, {
    key: '_getWeightedNumSpecificHandsThatAreSelected',
    value: function _getWeightedNumSpecificHandsThatAreSelected(generalHands) {
      var currSpecificHand = void 0;
      var weightedNumSpecificHandsThatAreSelected = 0;

      this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
        currSpecificHand = generalHands.find(matchingSpecificHandString);

        if (currSpecificHand.possible) {
          weightedNumSpecificHandsThatAreSelected += currSpecificHand.weight;
        }
      });

      return weightedNumSpecificHandsThatAreSelected;
    }
  }, {
    key: '_getWeightedNumSpecificHandsThatArePossible',
    value: function _getWeightedNumSpecificHandsThatArePossible(generalHands) {
      var currSpecificHand = void 0;
      var weightedNumSpecificHandsThatAreSelected = 0;

      this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
        currSpecificHand = generalHands.find(matchingSpecificHandString);

        if (currSpecificHand.possible) {
          weightedNumSpecificHandsThatAreSelected += currSpecificHand.maxPossibleWeight;
        }
      });

      return weightedNumSpecificHandsThatAreSelected;
    }
  }, {
    key: 'included',
    get: function get() {
      for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].included) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: 'visible',
    get: function get() {
      if (!this.included) {
        return false;
      }

      for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].visible) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: 'checked',
    get: function get() {
      var anyCheckedChildren = false;
      var anyPartiallyCheckedChildren = false;
      var anyUncheckedChildren = false;
      var currChildCheckedValue = void 0;

      for (var i = 0; i < this.children.length; i++) {
        if (!this.children[i].visible) {
          continue;
        }

        currChildCheckedValue = this.children[i].checked;

        if (currChildCheckedValue === true) {
          anyCheckedChildren = true;
        } else if (currChildCheckedValue === 'partially') {
          anyPartiallyCheckedChildren = true;
        } else if (currChildCheckedValue === false) {
          anyUncheckedChildren = true;
        }
      }

      if (anyCheckedChildren && !anyPartiallyCheckedChildren && !anyUncheckedChildren) {
        return true;
      } else if (!anyCheckedChildren && !anyPartiallyCheckedChildren) {
        return false;
      } else {
        return 'partially';
      }
    },
    set: function set(newCheckedValue) {
      if (!this.visible) {
        throw new Error('Trying to set the checked value of a fiveCardHand that isn\'t visible.');
      }

      if (newCheckedValue !== true && newCheckedValue !== false) {
        throw new Error('Invalid value for newCheckedValue.');
      }

      this.children.forEach(function (child) {
        if (child.visible) {
          child.checked = newCheckedValue;
        }
      });
    }
  }, {
    key: 'probability',
    get: function get() {
      if (this._probability > 100) {
        return 100;
      }

      return this._probability || 0;
    }
  }, {
    key: 'weight',
    get: function get() {
      var currWeight = void 0;

      for (var i = 0; i < this.children.length; i++) {
        if (!this.children[i].visible) {
          continue;
        }

        if (!this.children[i].checked) {
          return undefined;
        }

        if (!this.children[i].weight) {
          return undefined;
        }

        // first visible, checked child
        if (!currWeight) {
          if (this.children[i].weight === 100) {
            return undefined;
          }

          currWeight = this.children[i].weight;
        }

        // after first visible, checked child
        else {
            if (this.children[i].weight !== currWeight) {
              return undefined;
            }
          }
      }

      return currWeight;
    },
    set: function set(newWeight) {
      this.children.forEach(function (child) {
        if (!child.visible) {
          return;
        }

        child.weight = newWeight;
      });
    }
  }, {
    key: 'hasWeight',
    get: function get() {
      if (!this.visible || !this.checked) {
        return false;
      }

      for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].hasWeight) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: 'hasExplicitWeight',
    get: function get() {
      if (this.visible && this.checked && this.weight && this.weight < 100) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'matchingSpecificHands',
    get: function get() {
      var matchingSpecificHands = [];

      this.children.forEach(function (child) {
        child.matchingSpecificHands.forEach(function (childMatchingSpecificHand) {
          if (!matchingSpecificHands.includes(childMatchingSpecificHand)) {
            matchingSpecificHands.push(childMatchingSpecificHand);
          }
        });
      });

      return matchingSpecificHands;
    }
  }]);

  return FiveCardHandParent;
}();

/* harmony default export */ __webpack_exports__["a"] = (FiveCardHandParent);
;

/***/ }),

/***/ "Y9bJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YAIz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YAoe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default btn-xs",on:{"click":function($event){return _vm.$emit('toggleHelp')}}},[_vm._v("\n  Help "),(!_vm.helpAreaVisible)?_c('span',[_vm._v("▾")]):_c('span',[_vm._v("▴")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YCoa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"vertical-set-weight-to-apply-to-added-hands-with-settings-container"},[_c('div',{staticClass:"btn-group-vertical btn-group-xs"},[_c('button',{staticClass:"btn btn-default",class:{ active: _vm.indexOfActiveButton === 0 },on:{"click":function($event){return _vm.selectButton(0)}}},[_vm._v("\n      "+_vm._s(_vm.buttons[0])+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ active: _vm.indexOfActiveButton === 1 },on:{"click":function($event){return _vm.selectButton(1)}}},[_vm._v("\n      "+_vm._s(_vm.buttons[1])+"\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ active: _vm.indexOfActiveButton === 2 },on:{"click":function($event){return _vm.selectButton(2)}}},[_vm._v("\n      "+_vm._s(_vm.buttons[2])+"\n    ")])]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"slider",staticClass:"vertical-set-weight-to-apply-to-added-hands-with-settings",attrs:{"disabled":_vm.disabled},on:{"callback":function($event){return _vm.handleSliderChange($event)}},scopedSlots:_vm._u([{key:"tooltip",fn:function(ref){
var value = ref.value;
return _c('div',{staticClass:"vue-slider-tooltip"},[_vm._v("\n      Weight to apply to added hands: "),_c('strong',[_vm._v(_vm._s(value))])])}}])},'vue-slider',_vm.sliderOptions,false))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YFwH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YNdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YOXr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_matrix_vue__ = __webpack_require__("DydF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071495eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_matrix_vue__ = __webpack_require__("Swv+");
function injectStyle (ssrContext) {
  __webpack_require__("9F12")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-071495eb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_equity_matrix_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071495eb_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_equity_matrix_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YPLg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Help / Range Constructor")])]),_vm._v(" "),_c('h3',[_vm._v("Overview")]),_vm._v(" "),_c('p',[_vm._v("As you become a more advanced poker player, it is often a good idea to ask yourself not what you would do with your current hole cards, but instead what you would do with your entire range.")]),_vm._v(" "),_c('p',[_vm._v("For example, suppose that you open AcTs from the button, get called by the big blind and go heads up to the flop. The flop comes Ah7d5d, and you get check-raised.")]),_vm._v(" "),_c('p',[_vm._v("You "),_c('em',[_vm._v("could")]),_vm._v(" think about pot odds, real odds, the range that your opponent is on, and what you want to do with your AcTs. "),_c('em',[_vm._v("Or")]),_vm._v(", you could ask yourself what you want to do with your entire range. What are you doing when you have AK? A2? TT? 98? Are you defending enough against his raise? Are you reraising with a balanced range? This tool helps you explore these sorts of questions.")]),_vm._v(" "),_c('p',[_vm._v("If you are unfamiliar with this sort of thinking and would like to learn more about it, check out "),_c('a',{attrs:{"href":"https://edmillerpoker.com/product/pokers-1-one-big-secret-keeps-elite-players-top/"}},[_vm._v("Poker's 1%: The One Big Secret that Keeps Elite Players on Top")]),_vm._v(" by Ed Miller.")]),_vm._v(" "),_c('h3',[_vm._v("Postflop")]),_vm._v(" "),_c('p',[_vm._v("Right now the tool works best for preflop situations. It is a little wonky for postflop ones. Improving that is very high up on my priority list right now.")]),_vm._v(" "),_c('p',[_vm._v("If you want to analyze postflop situations, here's what you can do:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Suppose the CO opens, you flat from the BB, the flop comes K86r, you check, and they cbet 1/2 pot.")]),_vm._v(" "),_c('li',[_vm._v("You can start by thinking about what hands you enter the flop with, and then the rest as \"not possible\". Setting hands as \"not possible\" works the same way as setting a hand as a raise/call/fold.")]),_vm._v(" "),_c('li',[_vm._v("From there, you can start selecting which hands you want to call with, raise with, and fold with. As you do this, the tool will show you your frequencies (eg. 20% raise, 30% call, 50% fold).")]),_vm._v(" "),_c('li',[_vm._v("Unfortunately the tool doesn't actually allow you to enter board cards or specify specific suits (eg. AKcc rather than AKs). Sorry about that. I'll make it better soon!")])]),_vm._v(" "),_c('h3',[_vm._v("Still need help?")]),_vm._v(" "),_c('p',[_vm._v("I'm here for you. Hit me up at "),_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(". I'd love to answer any questions you have.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YQ5K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__("wUZA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_equity_calculator_equity_calculator__ = __webpack_require__("32Qs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_hit_calculator_hit_calculator__ = __webpack_require__("lKD2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_range_constructor_range_constructor__ = __webpack_require__("fkhk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_equity_matrix_equity_matrix__ = __webpack_require__("YOXr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_guided_analyses_should_you_call_should_you_call__ = __webpack_require__("dVkd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_guided_analyses_should_you_bluff_should_you_bluff__ = __webpack_require__("TcHI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn__ = __webpack_require__("W9EZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_three_bet_cbet_explorer_three_bet_cbet_explorer__ = __webpack_require__("QqqS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_settings_settings__ = __webpack_require__("bwvA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_settings_general_hand_rankings__ = __webpack_require__("hLeQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_settings_general_saved_ranges__ = __webpack_require__("W0KM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_settings_general_tiers__ = __webpack_require__("dIRe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_settings_general_included_selectors__ = __webpack_require__("F3ao");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_settings_general_visual__ = __webpack_require__("wOxj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_settings_equity_calculator_rake_and_tip__ = __webpack_require__("SkKs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_settings_equity_calculator_number_of_simulations__ = __webpack_require__("Ced7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_settings_equity_calculator_insights__ = __webpack_require__("/1uN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_settings_hit_calculator_checkboxes_included__ = __webpack_require__("KaYk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_settings_hit_calculator_checkboxes_collapsed_by_default__ = __webpack_require__("TU9h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_settings_hit_calculator_checkboxes_filters__ = __webpack_require__("BNXB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_settings_hit_calculator_checkboxes_checked_by_default__ = __webpack_require__("ul0I");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_settings_hit_calculator_number_of_simulations__ = __webpack_require__("4CCR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_settings_hit_calculator_insights__ = __webpack_require__("cBZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_blog_blog__ = __webpack_require__("4L6g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_blog_prior_probability_and_estimating_your_winrate__ = __webpack_require__("Yu7i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_blog_summary_of_pokers_one_percent__ = __webpack_require__("z4Oz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_blog_zoom_out__ = __webpack_require__("tKAZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_blog_spaced_repetition_and_poker__ = __webpack_require__("PfH8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_help_help__ = __webpack_require__("U3YL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_help_equity_calculator_help__ = __webpack_require__("2Ewd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_help_hit_calculator_help__ = __webpack_require__("+uV/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_help_equity_matrix_help__ = __webpack_require__("NZHB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_help_range_constructor_help__ = __webpack_require__("EkWo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_help_should_you_bluff_help__ = __webpack_require__("rqiw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_help_should_you_call_help__ = __webpack_require__("XZEa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_help_breakeven_percentage_for_bluffing_the_turn_help__ = __webpack_require__("GqVt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_help_three_bet_cbet_explorer_help__ = __webpack_require__("Segf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_help_quick_guide__ = __webpack_require__("PJ+B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_help_beginners_guide__ = __webpack_require__("Zc1L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_help_made_hands_and_draws__ = __webpack_require__("SGGR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_help_faq__ = __webpack_require__("Hmvt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_about__ = __webpack_require__("zRCK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_contact__ = __webpack_require__("S4JM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_pricing__ = __webpack_require__("pnxJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_short_deck_pricing__ = __webpack_require__("Fwnt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_user_sign_in__ = __webpack_require__("qeSg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_user_register__ = __webpack_require__("Dj9F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_user_forgot_password__ = __webpack_require__("CYY8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_user_create_new_password__ = __webpack_require__("jc79");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_user_account__ = __webpack_require__("JCHq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_user_change_password__ = __webpack_require__("9WJy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_user_purchase__ = __webpack_require__("2Y/5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_user_short_deck_purchase__ = __webpack_require__("acpR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_user_upgrade__ = __webpack_require__("dY5y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_short_deck_short_deck_equity_calculator__ = __webpack_require__("0Gzd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_short_deck_short_deck_hit_calculator__ = __webpack_require__("9HlT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__store__ = __webpack_require__("IcnI");






























































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: "hash",
  routes: [{
    path: "/",
    component: __WEBPACK_IMPORTED_MODULE_58__components_short_deck_short_deck_equity_calculator__["a" /* default */],
    name: "home",
    meta: {
      title: "Six Plus Hold’em | Short Deck | Equity / Odds Calculator",
      narrow: true
    }
  }, {
    path: "/:id",
    component: __WEBPACK_IMPORTED_MODULE_58__components_short_deck_short_deck_equity_calculator__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Short Deck | Equity / Odds Calculator",
      narrow: true
    }
  }, {
    path: "/short-deck/equity-calculator",
    component: __WEBPACK_IMPORTED_MODULE_58__components_short_deck_short_deck_equity_calculator__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Short Deck | Equity / Odds Calculator"
    }
  }, {
    path: "/short-deck/equity-calculator/:id",
    component: __WEBPACK_IMPORTED_MODULE_58__components_short_deck_short_deck_equity_calculator__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Short Deck | Equity / Odds Calculator"
    }
  }, {
    path: "/short-deck/hit-calculator",
    component: __WEBPACK_IMPORTED_MODULE_59__components_short_deck_short_deck_hit_calculator__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Short Deck | Hit Calculator"
      //requiresShortDeckAuth: true
    }
  }, {
    path: "/short-deck/hit-calculator/:id",
    component: __WEBPACK_IMPORTED_MODULE_59__components_short_deck_short_deck_hit_calculator__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Short Deck | Hit Calculator"
      //requiresShortDeckAuth: true
    }
  }, {
    path: "/equity-calculator",
    component: __WEBPACK_IMPORTED_MODULE_4__components_equity_calculator_equity_calculator__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Equity Calculator",
      requiresBasicAuth: true
    }
  }, {
    path: "/equity-calculator/:id",
    component: __WEBPACK_IMPORTED_MODULE_4__components_equity_calculator_equity_calculator__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Equity Calculator"
    }
  }, {
    path: "/hit-calculator",
    component: __WEBPACK_IMPORTED_MODULE_5__components_hit_calculator_hit_calculator__["a" /* default */],
    name: "hit calculator",
    meta: {
      title: "Six Plus Hold’em | Hit Calculator",
      requiresBasicAuth: true
    }
  }, {
    path: "/hit-calculator/:id",
    component: __WEBPACK_IMPORTED_MODULE_5__components_hit_calculator_hit_calculator__["a" /* default */],
    name: "hit calculator sharable",
    meta: {
      title: "Six Plus Hold’em | Hit Calculator"
    }
  }, {
    path: "/range-constructor",
    component: __WEBPACK_IMPORTED_MODULE_6__components_range_constructor_range_constructor__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Range Constructor",
      requiresPremiumAuth: true
    }
  }, {
    path: "/range-constructor/:id",
    component: __WEBPACK_IMPORTED_MODULE_6__components_range_constructor_range_constructor__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Range Constructor"
    }
  }, {
    path: "/equity-matrix/",
    component: __WEBPACK_IMPORTED_MODULE_7__components_equity_matrix_equity_matrix__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Equity Matrix",
      requiresPremiumAuth: true
    }
  }, {
    path: "/equity-matrix/:id",
    component: __WEBPACK_IMPORTED_MODULE_7__components_equity_matrix_equity_matrix__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Equity Matrix"
    }
  }, {
    path: "/guided-analyses/should-you-bluff",
    component: __WEBPACK_IMPORTED_MODULE_9__components_guided_analyses_should_you_bluff_should_you_bluff__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Should You Bluff",
      requiresBasicAuth: true
    }
  }, {
    path: "/guided-analyses/should-you-bluff/:id",
    component: __WEBPACK_IMPORTED_MODULE_9__components_guided_analyses_should_you_bluff_should_you_bluff__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Should You Bluff"
    }
  }, {
    path: "/guided-analyses/should-you-call",
    component: __WEBPACK_IMPORTED_MODULE_8__components_guided_analyses_should_you_call_should_you_call__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Should You Call",
      requiresBasicAuth: true
    }
  }, {
    path: "/guided-analyses/should-you-call/:id",
    component: __WEBPACK_IMPORTED_MODULE_8__components_guided_analyses_should_you_call_should_you_call__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Should You Call"
    }
  }, {
    path: "/breakeven-percentage-for-bluffing-the-turn",
    component: __WEBPACK_IMPORTED_MODULE_10__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Breakeven Percentage For Bluffing The Turn",
      requiresPremiumAuth: true
    }
  }, {
    path: "/breakeven-percentage-for-bluffing-the-turn/:id",
    component: __WEBPACK_IMPORTED_MODULE_10__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Breakeven Percentage For Bluffing The Turn"
    }
  }, {
    path: "/three-bet-cbet-explorer",
    component: __WEBPACK_IMPORTED_MODULE_11__components_three_bet_cbet_explorer_three_bet_cbet_explorer__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | 3bet-Cbet Explorer",
      requiresPremiumAuth: true
    }
  }, {
    path: "/three-bet-cbet-explorer/:id",
    component: __WEBPACK_IMPORTED_MODULE_11__components_three_bet_cbet_explorer_three_bet_cbet_explorer__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | 3bet-Cbet Explorer"
    }
  }, {
    path: "/settings",
    component: __WEBPACK_IMPORTED_MODULE_12__components_settings_settings__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/general/hand-rankings",
    component: __WEBPACK_IMPORTED_MODULE_13__components_settings_general_hand_rankings__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Hand Rankings",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/general/saved-ranges",
    component: __WEBPACK_IMPORTED_MODULE_14__components_settings_general_saved_ranges__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Saved Ranges",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/general/tiers",
    component: __WEBPACK_IMPORTED_MODULE_15__components_settings_general_tiers__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Tiers",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/general/included-selectors",
    component: __WEBPACK_IMPORTED_MODULE_16__components_settings_general_included_selectors__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Included Selectors",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/general/visual",
    component: __WEBPACK_IMPORTED_MODULE_17__components_settings_general_visual__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Visual",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/equity-calculator/rake-and-tip",
    component: __WEBPACK_IMPORTED_MODULE_18__components_settings_equity_calculator_rake_and_tip__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Rake And Tip",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/equity-calculator/number-of-simulations",
    component: __WEBPACK_IMPORTED_MODULE_19__components_settings_equity_calculator_number_of_simulations__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Equity Calculator Number Of Simulations",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/equity-calculator/insights",
    component: __WEBPACK_IMPORTED_MODULE_20__components_settings_equity_calculator_insights__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Equity Calculator Insights",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/hit-calculator/checkboxes/included",
    component: __WEBPACK_IMPORTED_MODULE_21__components_settings_hit_calculator_checkboxes_included__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Included Checkboxes",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/hit-calculator/checkboxes/collapsed-by-default",
    component: __WEBPACK_IMPORTED_MODULE_22__components_settings_hit_calculator_checkboxes_collapsed_by_default__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Collapsed By Default Checkboxes",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/hit-calculator/checkboxes/filters",
    component: __WEBPACK_IMPORTED_MODULE_23__components_settings_hit_calculator_checkboxes_filters__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Checkbox Filters",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/hit-calculator/checkboxes/checked-by-default",
    component: __WEBPACK_IMPORTED_MODULE_24__components_settings_hit_calculator_checkboxes_checked_by_default__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Checkboxes Checked By Default",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/hit-calculator/number-of-simulations",
    component: __WEBPACK_IMPORTED_MODULE_25__components_settings_hit_calculator_number_of_simulations__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Hit Calculator Number Of Simulations",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/settings/hit-calculator/insights",
    component: __WEBPACK_IMPORTED_MODULE_26__components_settings_hit_calculator_insights__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Settings | Hit Calculator Insights",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/blog",
    component: __WEBPACK_IMPORTED_MODULE_27__components_blog_blog__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Blog",
      narrow: true
    }
  }, {
    path: "/blog/prior-probability-and-estimating-your-winrate",
    component: __WEBPACK_IMPORTED_MODULE_28__components_blog_prior_probability_and_estimating_your_winrate__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Blog | Prior Probability and Estimating Your Winrate",
      narrow: true
    }
  }, {
    path: "/blog/summary-of-pokers-one-percent",
    component: __WEBPACK_IMPORTED_MODULE_29__components_blog_summary_of_pokers_one_percent__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Blog | Summary of Pokers 1% by Ed Miller",
      narrow: true
    }
  }, {
    path: "/blog/zoom-out",
    component: __WEBPACK_IMPORTED_MODULE_30__components_blog_zoom_out__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Blog | Zoom out",
      narrow: true
    }
  }, {
    path: "/blog/spaced-repetition-and-poker",
    component: __WEBPACK_IMPORTED_MODULE_31__components_blog_spaced_repetition_and_poker__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Blog | Spaced repetition and poker",
      narrow: true
    }
  }, {
    path: "/help",
    component: __WEBPACK_IMPORTED_MODULE_32__components_help_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help",
      narrow: true
    }
  }, {
    path: "/help/equity-calculator",
    component: __WEBPACK_IMPORTED_MODULE_33__components_help_equity_calculator_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help | Equity Calculator",
      narrow: true
    }
  }, {
    path: "/help/hit-calculator",
    component: __WEBPACK_IMPORTED_MODULE_34__components_help_hit_calculator_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help | Hit Calculator",
      narrow: true
    }
  }, {
    path: "/help/equity-matrix",
    component: __WEBPACK_IMPORTED_MODULE_35__components_help_equity_matrix_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help | Equity Matrix",
      narrow: true
    }
  }, {
    path: "/help/range-constructor",
    component: __WEBPACK_IMPORTED_MODULE_36__components_help_range_constructor_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help | Range Constructor",
      narrow: true
    }
  }, {
    path: "/help/should-you-bluff",
    component: __WEBPACK_IMPORTED_MODULE_37__components_help_should_you_bluff_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help | Should You Bluff",
      narrow: true
    }
  }, {
    path: "/help/should-you-call",
    component: __WEBPACK_IMPORTED_MODULE_38__components_help_should_you_call_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help | Should You Call",
      narrow: true
    }
  }, {
    path: "/help/breakeven-percentage-for-bluffing-the-turn",
    component: __WEBPACK_IMPORTED_MODULE_39__components_help_breakeven_percentage_for_bluffing_the_turn_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help | Breakeven Percentage For Bluffing The Turn",
      narrow: true
    }
  }, {
    path: "/help/three-bet-cbet-explorer",
    component: __WEBPACK_IMPORTED_MODULE_40__components_help_three_bet_cbet_explorer_help__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Help | 3bet-Cbet Explorer",
      narrow: true
    }
  }, {
    path: "/quick-guide",
    component: __WEBPACK_IMPORTED_MODULE_41__components_help_quick_guide__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Quick Guide",
      narrow: true
    }
  }, {
    path: "/beginners-guide",
    component: __WEBPACK_IMPORTED_MODULE_42__components_help_beginners_guide__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Beginners Guide",
      narrow: true
    }
  }, {
    path: "/made-hands-and-draws",
    component: __WEBPACK_IMPORTED_MODULE_43__components_help_made_hands_and_draws__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Made Hands And Draws Guide",
      narrow: true
    }
  }, {
    path: "/faq",
    component: __WEBPACK_IMPORTED_MODULE_44__components_help_faq__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | FAQ",
      narrow: true
    }
  }, {
    path: "/about",
    component: __WEBPACK_IMPORTED_MODULE_45__components_about__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | About",
      narrow: true
    }
  }, {
    path: "/contact",
    component: __WEBPACK_IMPORTED_MODULE_46__components_contact__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Contact",
      narrow: true
    }
  }, {
    path: "/pricing",
    component: __WEBPACK_IMPORTED_MODULE_47__components_pricing__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Pricing",
      narrow: true
    }
  }, {
    path: "/short-deck-pricing",
    component: __WEBPACK_IMPORTED_MODULE_48__components_short_deck_pricing__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Short Deck Pricing",
      narrow: true
    }
  }, {
    path: "/sign-in",
    component: __WEBPACK_IMPORTED_MODULE_49__components_user_sign_in__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Sign In",
      requiresLoggedOut: true,
      narrow: true
    }
  }, {
    path: "/register",
    component: __WEBPACK_IMPORTED_MODULE_50__components_user_register__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Register",
      requiresLoggedOut: true,
      narrow: true
    }
  }, {
    path: "/forgot-password",
    component: __WEBPACK_IMPORTED_MODULE_51__components_user_forgot_password__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Forgot Password",
      requiresLoggedOut: true,
      narrow: true
    }
  }, {
    path: "/create-new-password/:token",
    component: __WEBPACK_IMPORTED_MODULE_52__components_user_create_new_password__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Create New Password",
      requiresLoggedOut: true,
      narrow: true
    }
  }, {
    path: "/account",
    component: __WEBPACK_IMPORTED_MODULE_53__components_user_account__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Account",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/change-password",
    component: __WEBPACK_IMPORTED_MODULE_54__components_user_change_password__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Change Password",
      requiresLoggedIn: true,
      narrow: true
    }
  }, {
    path: "/purchase",
    component: __WEBPACK_IMPORTED_MODULE_55__components_user_purchase__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Purchase",
      requiresLoggedIn: true,
      requiresNotBasicOrPremium: true,
      narrow: true
    }
  }, {
    path: "/purchase-short-deck",
    component: __WEBPACK_IMPORTED_MODULE_56__components_user_short_deck_purchase__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Purchase Short Deck",
      requiresLoggedIn: true,
      requiresNotShortDeckUser: true,
      narrow: true
    }
  }, {
    path: "/upgrade",
    component: __WEBPACK_IMPORTED_MODULE_57__components_user_upgrade__["a" /* default */],
    meta: {
      title: "Six Plus Hold’em | Upgrade",
      requiresLoggedIn: true,
      iffBasicAuth: true,
      narrow: true
    }
  }]
});

router.beforeEach(function (to, from, next) {
  document.title = to.meta.title;

  if (__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].state.account.user.email === undefined) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.get("https://oddscalc.sixplusholdem.com/api" + "/user/me").then(function (res) {
      return __WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].commit("account/setUser", res.data.user);
    }).catch(function (err) {
      return __WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].dispatch("account/clearUser");
    }).then(function () {
      if (to.meta.requiresLoggedIn && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/loggedIn"]) {
        return next("/sign-in?error=not-logged-in");
      }

      if (to.meta.requiresLoggedOut && __WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/loggedIn"]) {
        return next("/");
      }

      if (to.meta.requiresBasicAuth && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/authorizedForBasic"]) {
        return next("/?error=requires-basic-auth");
      }

      if (to.meta.requiresPremiumAuth && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/authorizedForPremium"]) {
        return next("/?error=requires-premium-auth");
      }

      if (to.meta.iffBasicAuth && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].state.account.user.auth.includes("basic")) {
        return next("/?error=iff-basic-auth");
      }

      if (to.meta.requiresNotBasicOrPremium && __WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/basicOrPremium"]) {
        return next("/?error=already-paid");
      }

      if (to.meta.requiresShortDeckAuth && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/authorizedForShortDeck"]) {
        return next("/");
      }

      if (to.meta.requiresNotShortDeckUser && __WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].state.account.user.auth.includes("short deck")) {
        return next("/");
      }

      next();
    });
  } else {
    if (to.meta.requiresLoggedIn && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/loggedIn"]) {
      return next("/sign-in?error=not-logged-in");
    }

    if (to.meta.requiresLoggedOut && __WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/loggedIn"]) {
      return next("/");
    }

    if (to.meta.requiresBasicAuth && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/authorizedForBasic"]) {
      return next("/?error=requires-basic-auth");
    }

    if (to.meta.requiresPremiumAuth && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/authorizedForPremium"]) {
      return next("/?error=requires-premium-auth");
    }

    if (to.meta.iffBasicAuth && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].state.account.user.auth.includes("basic")) {
      return next("/?error=iff-basic-auth");
    }

    if (to.meta.requiresNotBasicOrPremium && __WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/basicOrPremium"]) {
      return next("/?error=already-paid");
    }

    if (to.meta.requiresShortDeckAuth && !__WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].getters["account/authorizedForShortDeck"]) {
      return next("/");
    }

    if (to.meta.requiresNotShortDeckUser && __WEBPACK_IMPORTED_MODULE_60__store__["a" /* default */].state.account.user.auth.includes("short deck")) {
      return next("/");
    }

    next();
  }
});

if ("production" === "production" && navigator.onLine) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_analytics___default.a, {
    id: "",
    router: router,
    set: [{ field: "config", value: "AW-714944788" }]
  });
}

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ "YiON":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yj1M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_Players__ = __webpack_require__("IPbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__ = __webpack_require__("XRwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_PresetHoleCards__ = __webpack_require__("oC4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_simulator_breakeven_set_betting_criteria_for_calling__ = __webpack_require__("f0lb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_worker_loader_betting_criteria_worker_js__ = __webpack_require__("UcXI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_worker_loader_betting_criteria_worker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_worker_loader_betting_criteria_worker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_service__ = __webpack_require__("JBFI");








var state = {
  presetHoleCards: new __WEBPACK_IMPORTED_MODULE_2__services_PresetHoleCards__["a" /* default */](),
  presetCommunityCards: new __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__["a" /* default */](),
  players: new __WEBPACK_IMPORTED_MODULE_0__services_player_Players__["a" /* default */](),
  streetToCall: 'flop',
  potOdds: '2:1',
  realOddsLHS: 2,
  bettingCriteria: {
    flop: {},
    turn: {},
    river: {}
  },
  bettingCriteriaOnePercentIncrements: 0
};

var getters = {
  breakevenPercentageViaPotOdds: function breakevenPercentageViaPotOdds(state) {
    var split = state.potOdds.split(':');
    var reward = Number(split[0]);
    var risk = Number(split[1]);

    return (risk / (risk + reward) * 100).roundToTwoDecimalPlaces();
  },
  breakevenPercentageViaRealOdds: function breakevenPercentageViaRealOdds(state) {
    return (1 / (1 + Number(state.realOddsLHS)) * 100).roundToTwoDecimalPlaces();
  }
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_5__services_share_url_service__["a" /* default */].setGuidedAnalysesCallingStoreState(stateFromServer, state);
  },

  // calling
  setStreetToCall: function setStreetToCall(state, streetToCall) {
    state.streetToCall = streetToCall;
  },
  setPotOdds: function setPotOdds(state, potOdds) {
    state.potOdds = potOdds;
  },
  setRealOddsLHS: function setRealOddsLHS(state, realOddsLHS) {
    state.realOddsLHS = realOddsLHS;
  },

  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].deselectGeneralHand(state, payload);
  },
  manuallySelectGeneralHand: function manuallySelectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].manuallySelectGeneralHand(state, payload);
  },
  manuallyDeselectGeneralHand: function manuallyDeselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].manuallyDeselectGeneralHand(state, payload);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].deselectGeneralHands(state, payload);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].deselectAllGeneralHands(state, payload);
  },
  selectSpecificHand: function selectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function deselectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].deselectSpecificHand(state, payload);
  },
  manuallySelectSpecificHand: function manuallySelectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].manuallySelectSpecificHand(state, payload);
  },
  manuallyDeselectSpecificHand: function manuallyDeselectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].manuallyDeselectSpecificHand(state, payload);
  },
  manuallyDeselectAllGeneralHands: function manuallyDeselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].manuallyDeselectAllGeneralHands(state, payload);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].selectSpecificHands(state, payload);
  },
  setSpecificHandAsManuallySet: function setSpecificHandAsManuallySet(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setSpecificHandAsManuallySet(state, payload);
  },
  setSpecificHandAsNotManuallySet: function setSpecificHandAsNotManuallySet(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setSpecificHandAsManuallySet(state, payload);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function setWeightOfSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setWeightOfSpecificHand(state, payload);
  },
  manuallyApplyExactWeightToGeneralHand: function manuallyApplyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].manuallyApplyExactWeightToGeneralHand(state, payload);
  },
  manuallySetWeightOfSpecificHand: function manuallySetWeightOfSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].manuallySetWeightOfSpecificHand(state, payload);
  },
  clearManuallyAddedHands: function clearManuallyAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
  },
  clearManuallyRemovedHands: function clearManuallyRemovedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  setRangesAccordingToFilters: function setRangesAccordingToFilters(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setRangesAccordingToFilters(state, playerIndex);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function addComboToCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function removeComboFromCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].removeComboFromCombosToAdd(state, payload);
  },
  highlightGeneralHandsThatMatchFiveCardHand: function highlightGeneralHandsThatMatchFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].highlightGeneralHandsThatMatchFiveCardHand(state, payload);
  },
  removeFiveCardHandHighlights: function removeFiveCardHandHighlights(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].removeFiveCardHandHighlights(state, payload);
  },

  // controls
  setPresetHoleCard: function setPresetHoleCard(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setPresetHoleCard(state, payload);
  },
  removePresetHoleCard: function removePresetHoleCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].removePresetHoleCard(state, position);
  },
  setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function setBoard(state, boardCards) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setBoard(state, boardCards);
  },
  removePresetCommunityCard: function removePresetCommunityCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].removePresetCommunityCard(state, position);
  },
  addPlayer: function addPlayer(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].addPlayer(state, payload);
  },
  removePlayer: function removePlayer(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].removePlayer(state, playerIndex);
  },

  // five card hands section checkboxes
  setCheckedValueOfFiveCardHand: function setCheckedValueOfFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setCheckedValueOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newCheckedValue: payload.newCheckedValue
    });
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallySetHandsThatPassThroughFilter(state, {
      playerIndex: payload.playerIndex,
      playerStateIndex: payload.playerStateIndex,
      fiveCardHandId: payload.fiveCardHandId
    });
  },
  applyExactWeightToFiveCardHand: function applyExactWeightToFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].applyExactWeightToFiveCardHand(state, payload);
  },
  uncheckAllFiveCardHandsForGivenState: function uncheckAllFiveCardHandsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].uncheckAllFiveCardHandsForGivenState(state, payload);
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  checkAllFiveCardHandsForGivenState: function checkAllFiveCardHandsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].checkAllFiveCardHandsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  setChecksToDefaultsForGivenState: function setChecksToDefaultsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setChecksToDefaultsForGivenState(state, payload);
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  setChecksAccordingToUserDefinedFilterForGivenState: function setChecksAccordingToUserDefinedFilterForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setChecksAccordingToUserDefinedFilterForGivenState(state, payload);
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  setFiveCardHandValuesToDefaults: function setFiveCardHandValuesToDefaults(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setFiveCardHandValuesToDefaults(state, payload);
  },
  updateWeightOfFiveCardHand: function updateWeightOfFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].updateWeightOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newWeight: payload.newWeight
    });
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].clearManuallySetHandsThatPassThroughFilter(state, {
      playerIndex: payload.playerIndex,
      playerStateIndex: payload.playerStateIndex,
      fiveCardHandId: payload.fiveCardHandId
    });
  },

  // five card hands section other
  toggleCollapsedValueOfFiveCardHandParent: function toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent);
  },
  setProbabilitiesOfFiveCardHands: function setProbabilitiesOfFiveCardHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setProbabilitiesOfFiveCardHands(state, payload);
  },
  setHandAndDrawInfo: function setHandAndDrawInfo(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setHandAndDrawInfo(state, payload);
  },
  setPercentagesOfSpecificHandsThatAreSelected: function setPercentagesOfSpecificHandsThatAreSelected(state, payload) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setPercentagesOfSpecificHandsThatAreSelected(state, payload);
  },

  // simulations
  setLastSimulationInfo: function setLastSimulationInfo(state, playerStateIndex) {
    __WEBPACK_IMPORTED_MODULE_6__store_service__["a" /* default */].setLastSimulationInfo(state, playerStateIndex);
  },
  updateEquityResults: function updateEquityResults(state, payload) {
    var equity = void 0;
    var wins = void 0;
    var ties = void 0;
    var winFractions = void 0;
    var numberOfSimulations = payload.numberOfSimulations;
    var numPlayers = payload.simulationResults.length;

    state.players.forEach(function (player, playerIndex) {
      wins = payload.simulationResults[playerIndex + 1].wins;
      ties = payload.simulationResults[playerIndex + 1].ties;
      winFractions = payload.simulationResults[playerIndex + 1].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = (wins + winFractions) / numberOfSimulations * 100;
      equity -= equity * (payload.rakePercentage / 100) + equity * (payload.tipPercentage / 100);
      player.states[0].equity = equity.roundToTwoDecimalPlaces();
      player.states[0].winPercentage = wins / numberOfSimulations * 100;
      player.states[0].tiePercentage = ties / numberOfSimulations * 100;
    });
  }
};

var actions = {
  setBettingCriteria: function setBettingCriteria(context, payload) {
    var worker = new __WEBPACK_IMPORTED_MODULE_4_worker_loader_betting_criteria_worker_js___default.a();
    var totalNumOnePercentIncrements = __WEBPACK_IMPORTED_MODULE_3__services_simulator_breakeven_set_betting_criteria_for_calling__["a" /* default */].getTotalNumOnePercentIncrements(context.state.players.find(0), context.state.streetToCall);

    if (totalNumOnePercentIncrements === 0) {
      alert('Your opponent never has any value hands entering the ' + context.state.streetToCall + '.');
      payload.resetSimulationProgress();
    }

    __WEBPACK_IMPORTED_MODULE_3__services_simulator_breakeven_set_betting_criteria_for_calling__["a" /* default */].initializeBettingCriteria(context.state.bettingCriteria, context.state.streetToCall);
    __WEBPACK_IMPORTED_MODULE_3__services_simulator_breakeven_set_betting_criteria_for_calling__["a" /* default */].setWeightedRangeForEachBettingCriterion(context.state);
    worker.postMessage({
      message: 'set equity for each betting criterion',
      bettingCriteria: context.state.bettingCriteria,
      totalNumOnePercentIncrements: totalNumOnePercentIncrements,
      streetToCall: context.state.streetToCall,
      presetCommunityCardsArray: context.state.presetCommunityCards.getArrayForStateViaStreet(context.state.streetToCall),
      heroWeightedRange: [[context.state.presetHoleCards.holeCardOne, context.state.presetHoleCards.holeCardTwo]],
      numberOfSimulations: payload.numberOfSimulations,
      rakePercentage: payload.rakePercentage,
      tipPercentage: payload.tipPercentage
    });

    worker.onmessage = function (e) {
      if (e.data.message === 'progress') {
        context.state.bettingCriteria = e.data.bettingCriteria;
        payload.incrementSimulationProgress(e.data.value);
      } else if (e.data.message === 'finished') {
        context.state.bettingCriteria = e.data.bettingCriteria;
        payload.resetSimulationProgress();
      }
    };
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "YmSe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade"},[_c('div',{staticClass:"modal-dialog",class:{
      'modal-lg': _vm.modalLg
    }},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._t("body")],2),_vm._v(" "),_vm._t("footer")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Yt9I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yu7i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prior_probability_and_estimating_your_winrate_vue__ = __webpack_require__("4P0h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b60cb30a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prior_probability_and_estimating_your_winrate_vue__ = __webpack_require__("fWJY");
function injectStyle (ssrContext) {
  __webpack_require__("/cQn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b60cb30a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_prior_probability_and_estimating_your_winrate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b60cb30a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_prior_probability_and_estimating_your_winrate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Yudz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YuiF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ywgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_errors_alert_vue__ = __webpack_require__("KQ4F");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d6d169_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_errors_alert_vue__ = __webpack_require__("yYoB");
function injectStyle (ssrContext) {
  __webpack_require__("Ie6j")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60d6d169"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_errors_alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d6d169_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_errors_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YxBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_player_PlayerState__ = __webpack_require__("BTn5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);







var Player = function () {
  function Player() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Player);

    this.id = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.uniqueId();
    this.weightToApplyToAddedHands = 100;
    this.combosToAdd = ['cc', 'cs', 'ch', 'cd', 'sc', 'ss', 'sh', 'sd', 'hc', 'hs', 'hh', 'hd', 'dc', 'ds', 'dh', 'dd'];
    this.states = [new __WEBPACK_IMPORTED_MODULE_2__services_player_PlayerState__["a" /* default */]('afterPreflop'), new __WEBPACK_IMPORTED_MODULE_2__services_player_PlayerState__["a" /* default */]('afterFlop'), new __WEBPACK_IMPORTED_MODULE_2__services_player_PlayerState__["a" /* default */]('afterTurn'), new __WEBPACK_IMPORTED_MODULE_2__services_player_PlayerState__["a" /* default */]('afterRiver')];
    this._setNextStateProperties();
    this._setPreviousStateProperties();
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Player, [{
    key: '_setNextStateProperties',


    // constructor helpers
    value: function _setNextStateProperties() {
      this.states[0].nextState = this.states[1];
      this.states[1].nextState = this.states[2];
      this.states[2].nextState = this.states[3];
      this.states[3].nextState = null;
    }
  }, {
    key: '_setPreviousStateProperties',
    value: function _setPreviousStateProperties() {
      this.states[0].previousState = null;
      this.states[1].previousState = this.states[0];
      this.states[2].previousState = this.states[1];
      this.states[3].previousState = this.states[2];
    }
  }, {
    key: 'selectGeneralHands',


    // hands
    value: function selectGeneralHands(generalHandStrings, presetCommunityCards, playerStateIndex, shortDeck) {
      generalHandStrings.forEach(function (generalHandString) {
        this.selectGeneralHand(generalHandString, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'selectGeneralHand',
    value: function selectGeneralHand(generalHandString, presetCommunityCards, playerStateIndex, shortDeck) {
      var generalHand = this.states[playerStateIndex].generalHands.find(generalHandString);
      var specificHandStringsToSelect = generalHand.getSpecificHandStringsToSelect(this.combosToAdd);

      specificHandStringsToSelect.forEach(function (specificHandString) {
        this.selectSpecificHand(specificHandString, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'selectSpecificHand',
    value: function selectSpecificHand(specificHandString, presetCommunityCards, playerStateIndex, shortDeck) {
      this.setWeightOfSpecificHand(specificHandString, this.weightToApplyToAddedHands, presetCommunityCards, playerStateIndex, shortDeck);
    }
  }, {
    key: 'selectSpecificHands',
    value: function selectSpecificHands(specificHandStrings, presetCommunityCards, playerStateIndex, shortDeck) {
      var specificHand = void 0;

      specificHandStrings.forEach(function (specificHandString) {
        specificHand = this.states[playerStateIndex].generalHands.find(specificHandString);

        if (specificHand.availableToSelect(this.combosToAdd)) {
          this.selectSpecificHand(specificHandString, presetCommunityCards, playerStateIndex, shortDeck);
        }
      }, this);
    }
  }, {
    key: 'manuallySelectGeneralHand',
    value: function manuallySelectGeneralHand(generalHandString, presetCommunityCards, playerStateIndex, shortDeck) {
      if (playerStateIndex === 0) {
        throw new Error('Trying to call manuallySelectGeneralHand for the afterPreflop state.');
      }

      var generalHand = this.states[playerStateIndex].generalHands.find(generalHandString);
      var specificHandStringsToSelect = generalHand.getSpecificHandStringsToSelect(this.combosToAdd);

      specificHandStringsToSelect.forEach(function (specificHandString) {
        this.manuallySelectSpecificHand(specificHandString, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'manuallySelectSpecificHand',
    value: function manuallySelectSpecificHand(specificHandString, presetCommunityCards, playerStateIndex, shortDeck) {
      if (playerStateIndex === 0) {
        throw new Error('Trying to call manuallySelectSpecificHand for the afterPreflop state.');
      }

      this.manuallySetWeightOfSpecificHand(specificHandString, this.weightToApplyToAddedHands, presetCommunityCards, playerStateIndex, shortDeck);
    }
  }, {
    key: 'setSpecificHandAsManuallySet',
    value: function setSpecificHandAsManuallySet(specificHandString, playerStateIndex) {
      var specificHand = this.states[playerStateIndex].generalHands.find(specificHandString);

      if (specificHand.inRange) {
        specificHand.manuallySet = 'added';
      } else {
        specificHand.manuallySet = 'removed';
      }
    }
  }, {
    key: 'setSpecificHandAsNotManuallySet',
    value: function setSpecificHandAsNotManuallySet(specificHandString, playerStateIndex) {
      var specificHand = this.states[playerStateIndex].generalHands.find(specificHandString);

      specificHand.manuallySet = false;
    }
  }, {
    key: 'deselectGeneralHand',
    value: function deselectGeneralHand(generalHandString, presetCommunityCards, playerStateIndex, shortDeck) {
      var generalHand = this.states[playerStateIndex].generalHands.find(generalHandString);

      generalHand.forEachSpecificHandInRange(function (specificHand) {
        this.deselectSpecificHand(specificHand.string, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'deselectGeneralHands',
    value: function deselectGeneralHands(generalHandStrings, presetCommunityCards, playerStateIndex, shortDeck) {
      generalHandStrings.forEach(function (generalHandString) {
        this.deselectGeneralHand(generalHandString, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'deselectAllGeneralHands',
    value: function deselectAllGeneralHands(presetCommunityCards, playerStateIndex, shortDeck) {
      var allGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_4__services_constants__["a" /* default */].handRankings['sklansky-chubukov'];

      this.deselectGeneralHands(allGeneralHandStrings, presetCommunityCards, playerStateIndex, shortDeck);
    }
  }, {
    key: 'deselectSpecificHand',
    value: function deselectSpecificHand(specificHandString, presetCommunityCards, playerStateIndex, shortDeck) {
      this.setWeightOfSpecificHand(specificHandString, 0, presetCommunityCards, playerStateIndex, shortDeck);
    }
  }, {
    key: 'deselectAllSpecificHandsThatUseCardAndSetAsImpossible',
    value: function deselectAllSpecificHandsThatUseCardAndSetAsImpossible(card, presetCommunityCards, shortDeck) {
      var specificHandStringsThatUseCard = __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].hands.getAllSpecificHandStringsUsingCard(card);
      var specificHandForAfterPreflop = void 0;

      specificHandStringsThatUseCard.forEach(function (specificHandString) {
        specificHandForAfterPreflop = this.states[0].generalHands.find(specificHandString);

        if (specificHandForAfterPreflop.possible && specificHandForAfterPreflop.inRange) {
          this.deselectSpecificHand(specificHandString, presetCommunityCards, 0, shortDeck);
        }

        if (specificHandForAfterPreflop.possible) {
          this.states[0].generalHands.numberOfPossibleSpecificHands--; // maxPossibleWeight will always be 100 because it's the afterPreflop range
          specificHandForAfterPreflop.maxPossibleWeight = 0;
        }
      }, this);
    }
  }, {
    key: 'manuallyDeselectGeneralHand',
    value: function manuallyDeselectGeneralHand(generalHandString, presetCommunityCards, playerStateIndex, shortDeck) {
      if (playerStateIndex === 0) {
        throw new Error('Trying to call manuallyDeselectGeneralHand for the afterPreflop state.');
      }

      var generalHand = this.states[playerStateIndex].generalHands.find(generalHandString);

      generalHand.forEachSpecificHandInRange(function (specificHand) {
        this.manuallyDeselectSpecificHand(specificHand.string, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'manuallyDeselectAllGeneralHands',
    value: function manuallyDeselectAllGeneralHands(presetCommunityCards, playerStateIndex, shortDeck) {
      var allGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_4__services_constants__["a" /* default */].handRankings['sklansky-chubukov'];

      allGeneralHandStrings.forEach(function (generalHandString) {
        this.manuallyDeselectGeneralHand(generalHandString, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'manuallyDeselectSpecificHand',
    value: function manuallyDeselectSpecificHand(specificHandString, presetCommunityCards, playerStateIndex, shortDeck) {
      if (playerStateIndex === 0) {
        throw new Error('Trying to call manuallyDeselectSpecificHand for the afterPreflop state.');
      }

      this.manuallySetWeightOfSpecificHand(specificHandString, 0, presetCommunityCards, playerStateIndex, shortDeck);
    }
  }, {
    key: 'applyExactWeightToGeneralHand',
    value: function applyExactWeightToGeneralHand(generalHandString, newWeight, presetCommunityCards, playerStateIndex, shortDeck) {
      var generalHand = this.states[playerStateIndex].generalHands.find(generalHandString);

      generalHand.forEachSpecificHandInRange(function (specificHand) {
        this.setWeightOfSpecificHand(specificHand.string, newWeight, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'setWeightOfSpecificHand',
    value: function setWeightOfSpecificHand(specificHandString, newWeight, presetCommunityCards, playerStateIndex, shortDeck) {
      var specificHandOfCurrentState = void 0;
      var specificHandOfNextState = void 0;

      for (var i = playerStateIndex; i < this.states.length; i++) {
        this.states[i].setWeightOfSpecificHand(specificHandString, newWeight);

        if (!this.states[i].nextState) {
          break;
        }

        specificHandOfCurrentState = this.states[i].generalHands.find(specificHandString);
        specificHandOfNextState = this.states[i].nextState.generalHands.find(specificHandString);
        newWeight = specificHandOfNextState.getWeightToApply(this.states[i].nextState, presetCommunityCards, specificHandOfCurrentState.weight, shortDeck);
      }
    }
  }, {
    key: 'manuallyApplyExactWeightToGeneralHand',
    value: function manuallyApplyExactWeightToGeneralHand(generalHandString, newWeight, presetCommunityCards, playerStateIndex, shortDeck) {
      if (playerStateIndex === 0) {
        throw new Error('Trying to call manuallyApplyExactWeightToGeneralHand for the afterPreflop state.');
      }

      var generalHand = this.states[playerStateIndex].generalHands.find(generalHandString);

      generalHand.forEachSpecificHandInRange(function (specificHand) {
        this.manuallySetWeightOfSpecificHand(specificHand.string, newWeight, presetCommunityCards, playerStateIndex, shortDeck);
      }, this);
    }
  }, {
    key: 'manuallySetWeightOfSpecificHand',
    value: function manuallySetWeightOfSpecificHand(specificHandString, newWeight, presetCommunityCards, playerStateIndex, shortDeck) {
      var specificHand = this.states[playerStateIndex].generalHands.find(specificHandString);
      var initialWeight = specificHand.weight;

      if (playerStateIndex === 0) {
        throw new Error('Trying to call manuallySetWeightOfSpecificHand for the afterPreflop state.');
      }

      if (newWeight === initialWeight) {
        return;
      }

      this.setWeightOfSpecificHand(specificHandString, newWeight, presetCommunityCards, playerStateIndex, shortDeck);
      specificHand.updateManuallySetValue(initialWeight, newWeight, this.states[playerStateIndex], presetCommunityCards, playerStateIndex, shortDeck);
    }
  }, {
    key: 'setRangesAccordingToFilters',
    value: function setRangesAccordingToFilters(presetCommunityCards, shortDeck) {
      for (var i = 1; i < this.states.length; i++) {
        this.states[i].setRangeAccordingToFilters(this.states[i - 1].generalHands, presetCommunityCards, shortDeck);
      }
    }
  }, {
    key: 'setFiveCardHandValuesToDefaults',


    // five card hands
    value: function setFiveCardHandValuesToDefaults(presetCommunityCards, opponentTightness, settings) {
      var fiveCardHandsThatAreCheckedByDefault = void 0;

      this.states.forEach(function (playerState) {
        if (playerState.name !== 'afterPreflop') {
          fiveCardHandsThatAreCheckedByDefault = playerState.getFiveCardHandsThatAreCheckedByDefault(presetCommunityCards, opponentTightness, settings);
          playerState.fiveCardHands.setChecksToDefaults(fiveCardHandsThatAreCheckedByDefault, playerState.name);
          playerState.fiveCardHands.setCollapsedValuesToDefaults(settings);
          playerState.fiveCardHands.setIncludedValuesToDefaults(settings);
        }
      });
    }
  }, {
    key: 'selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange',


    // other
    value: function selectAllSpecificHandsThatUseCardIfGeneralHandWasPreviouslyFullyInRange(card, presetCommunityCards, presetHoleCards, shortDeck) {
      var specificHandStringsThatUseCard = __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].hands.getAllSpecificHandStringsUsingCard(card);
      var specificHandForAfterPreflop = void 0;
      var generalHandForAfterPreflop = void 0;

      specificHandStringsThatUseCard.forEach(function (specificHandString) {
        specificHandForAfterPreflop = this.states[0].generalHands.find(specificHandString);
        generalHandForAfterPreflop = specificHandForAfterPreflop.generalHand;

        if (generalHandForAfterPreflop.inRange === true && !specificHandForAfterPreflop.possible && !specificHandForAfterPreflop._includesPresetCommunityCard(presetCommunityCards) && !specificHandForAfterPreflop._includesPresetHoleCard(presetHoleCards)) {
          specificHandForAfterPreflop.maxPossibleWeight = 100;
          this.states[0].generalHands.numberOfPossibleSpecificHands++;
          this.setWeightOfSpecificHand(specificHandForAfterPreflop.string, generalHandForAfterPreflop.averageWeight, presetCommunityCards, 0, shortDeck);
        }
      }, this);
    }
  }, {
    key: 'setWhetherSpecificHandsThatUseCardArePossibleOnInitialState',
    value: function setWhetherSpecificHandsThatUseCardArePossibleOnInitialState(card, presetCommunityCards, presetHoleCards, shortDeck) {
      var specificHandStringsThatUseCard = __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].hands.getAllSpecificHandStringsUsingCard(card);

      if (shortDeck) {
        specificHandStringsThatUseCard = specificHandStringsThatUseCard.filter(function (specificHandString) {
          return !['5', '4', '3', '2'].includes(specificHandString[0]) && !['5', '4', '3', '2'].includes(specificHandString[2]);
        });
      }

      specificHandStringsThatUseCard.forEach(function (specificHandString) {
        var specificHandForAfterPreflop = this.states[0].generalHands.find(specificHandString);

        if (!specificHandForAfterPreflop.possible && !specificHandForAfterPreflop._includesPresetCommunityCard(presetCommunityCards) && !specificHandForAfterPreflop._includesPresetHoleCard(presetHoleCards)) {
          specificHandForAfterPreflop.maxPossibleWeight = 100;
          this.states[0].generalHands.numberOfPossibleSpecificHands++;
        }
      }, this);
    }
  }, {
    key: 'hasEmptyRange',
    value: function hasEmptyRange(street) {
      if (street === 'preflop') {
        return this._hasEmptyRange(0);
      } else if (street === 'flop') {
        return this._hasEmptyRange(1);
      } else if (street === 'turn') {
        return this._hasEmptyRange(2);
      } else if (street === 'river') {
        return this._hasEmptyRange(3);
      }
    }
  }, {
    key: '_hasEmptyRange',
    value: function _hasEmptyRange(playerStateIndex) {
      return this.states[playerStateIndex].generalHands.numberOfSpecificHandsInRange < 0.05;
    }
  }, {
    key: 'setLastSimulationInfo',


    // simulation
    value: function setLastSimulationInfo(presetCommunityCards, presetHoleCards, playerStateIndex) {
      if (playerStateIndex === 0) {
        throw new Error('Trying to call setLastSimulationInfo on the preflop state.');
      }

      var playerState = this.states[playerStateIndex];
      var lastSimulation = playerState.lastSimulation;

      lastSimulation.presetCommunityCards = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(presetCommunityCards);
      lastSimulation.presetHoleCards = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(presetHoleCards);
      lastSimulation.nameOfStateUsedForSimulation = __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].hands.getNameOfStateToUseForSimulation(this, presetCommunityCards, playerState.simulateTo);
      lastSimulation.generalHands = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a.cloneDeep(__WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].hands.getGeneralHandsToUseForSimulation(this, presetCommunityCards, playerState.simulateTo));
      lastSimulation.exhaustive = this._isExhaustive(playerState.simulateTo, presetCommunityCards);
    }
  }, {
    key: '_isExhaustive',
    value: function _isExhaustive(simulateTo, presetCommunityCards) {
      if (simulateTo === 'flop') {
        return presetCommunityCards.flopSet;
      } else if (simulateTo === 'turn') {
        return presetCommunityCards.turnSet;
      } else if (simulateTo === 'river') {
        return presetCommunityCards.riverSet;
      } else {
        throw new Error('Invalid value for simulateTo.');
      }
    }
  }, {
    key: 'getGeneralHandsToUseForSimulation',
    value: function getGeneralHandsToUseForSimulation(presetCommunityCards, simulateTo) {
      return __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].hands.getGeneralHandsToUseForSimulation(this, presetCommunityCards, simulateTo);
    }
  }, {
    key: 'getWeightedRangeToUseForSimulation',
    value: function getWeightedRangeToUseForSimulation(presetCommunityCards, simulateTo) {
      return this.getGeneralHandsToUseForSimulation(presetCommunityCards, simulateTo).weightedRange;
    }
  }, {
    key: 'narrowRange',


    // equity calculator
    value: function narrowRange(checkedHands, presetCommunityCards, shortDeck) {
      if (!presetCommunityCards.flopSet) {
        throw new Error('Trying to narrow range without the flop being set.');
      }

      this.states[0].generalHands.forEachSpecificHandInRange(function (specificHand) {
        if (!specificHand.passesThroughFiveCardHandFilter(checkedHands, presetCommunityCards.array, shortDeck)) {
          this.deselectSpecificHand(specificHand.string, presetCommunityCards, 0, shortDeck);
        }
      }, this);
    }
  }, {
    key: 'handleSelectGeneralHandEvent',


    // handle event
    value: function handleSelectGeneralHandEvent(storeModule, store, generalHandString, triggeredByMouseover, playerIndex, playerStateIndex) {
      var numSpecificHandsToSelect = this._getNumSpecificHandsToSelect(generalHandString, playerStateIndex);

      if (numSpecificHandsToSelect === 0 && !triggeredByMouseover) {
        alert('It isn\'t possible to select this hand because of what you have checked off in the select specific suits menu.');
        setTimeout(function () {
          $('body').trigger('mouseup'); // so that clickAndDragContext in GridSelector component gets set to null
        }, 0);
        return;
      }

      if (playerStateIndex === 0) {
        store.commit(storeModule + '/selectGeneralHand', {
          generalHandString: generalHandString,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      } else {
        store.commit(storeModule + '/manuallySelectGeneralHand', {
          generalHandString: generalHandString,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: '_getNumSpecificHandsToSelect',
    value: function _getNumSpecificHandsToSelect(generalHandString, playerStateIndex) {
      var generalHand = this.states[playerStateIndex].generalHands.find(generalHandString);

      return generalHand.getSpecificHandStringsToSelect(this.combosToAdd).length;
    }
  }, {
    key: 'handleDeselectGeneralHandEvent',
    value: function handleDeselectGeneralHandEvent(storeModule, store, generalHandString, playerIndex, playerStateIndex) {
      if (playerStateIndex === 0) {
        store.commit(storeModule + '/deselectGeneralHand', {
          generalHandString: generalHandString,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      } else {
        store.commit(storeModule + '/manuallyDeselectGeneralHand', {
          generalHandString: generalHandString,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleSelectGeneralHandsEvent',
    value: function handleSelectGeneralHandsEvent(storeModule, store, generalHandStrings, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/selectGeneralHands', {
        generalHandStrings: generalHandStrings,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
    }
  }, {
    key: 'handleDeselectGeneralHandsEvent',
    value: function handleDeselectGeneralHandsEvent(storeModule, store, generalHandStrings, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/deselectGeneralHands', {
        generalHandStrings: generalHandStrings,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
    }
  }, {
    key: 'handleSelectSpecificHandEvent',
    value: function handleSelectSpecificHandEvent(storeModule, store, specificHandString, playerIndex, playerStateIndex) {
      if (playerStateIndex === 0) {
        store.commit(storeModule + '/selectSpecificHand', {
          specificHandString: specificHandString,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      } else {
        store.commit(storeModule + '/manuallySelectSpecificHand', {
          specificHandString: specificHandString,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleDeselectSpecificHandEvent',
    value: function handleDeselectSpecificHandEvent(storeModule, store, specificHandString, playerIndex, playerStateIndex) {
      if (playerStateIndex === 0) {
        store.commit(storeModule + '/deselectSpecificHand', {
          specificHandString: specificHandString,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      } else {
        store.commit(storeModule + '/manuallyDeselectSpecificHand', {
          specificHandString: specificHandString,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleSetRangeToMatchGeneralHandsEvent',
    value: function handleSetRangeToMatchGeneralHandsEvent(storeModule, store, generalHandStrings, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/deselectAllGeneralHands', {
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/selectGeneralHands', {
        generalHandStrings: generalHandStrings,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
    }
  }, {
    key: 'handleSetRangeToMatchDoubleSliderEvent',
    value: function handleSetRangeToMatchDoubleSliderEvent(storeModule, store, percentilesObj, playerIndex, playerStateIndex, handRankings) {
      var generalHandStringsToAddFromDoubleSlider = __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].hands.getGeneralHandStringsToAddFromDoubleSlider(percentilesObj.topPercentile, percentilesObj.bottomPercentile, this.states[playerStateIndex].generalHands, handRankings);

      this.handleSetRangeToMatchGeneralHandsEvent(storeModule, store, generalHandStringsToAddFromDoubleSlider, playerIndex, playerStateIndex);
    }
  }, {
    key: 'handleSetRangeToMatchSpecificHandStringsEvent',
    value: function handleSetRangeToMatchSpecificHandStringsEvent(storeModule, store, specificHandStrings, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/deselectAllGeneralHands', {
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/selectSpecificHands', {
        specificHandStrings: specificHandStrings,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
    }
  }, {
    key: 'handleSetSpecificHandAsManuallySetEvent',
    value: function handleSetSpecificHandAsManuallySetEvent(storeModule, store, specificHandString, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/setSpecificHandAsManuallySet', {
        specificHandString: specificHandString,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);
    }
  }, {
    key: 'handleSetSpecificHandAsNotManuallySetEvent',
    value: function handleSetSpecificHandAsNotManuallySetEvent(storeModule, store, specificHandString, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/setSpecificHandAsNotManuallySet', {
        specificHandString: specificHandString,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);
    }
  }, {
    key: 'handleApplyExactWeightToGeneralHandEvent',
    value: function handleApplyExactWeightToGeneralHandEvent(storeModule, store, payload, playerIndex, playerStateIndex) {
      if (playerStateIndex === 0) {
        store.commit(storeModule + '/applyExactWeightToGeneralHand', {
          generalHandString: payload.generalHandString,
          newWeight: payload.newWeight,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      } else {
        store.commit(storeModule + '/manuallyApplyExactWeightToGeneralHand', {
          generalHandString: payload.generalHandString,
          newWeight: payload.newWeight,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleSetWeightOfSpecificHandEvent',
    value: function handleSetWeightOfSpecificHandEvent(storeModule, store, payload, playerIndex, playerStateIndex) {
      if (playerStateIndex === 0) {
        store.commit(storeModule + '/setWeightOfSpecificHand', {
          specificHandString: payload.specificHandString,
          newWeight: payload.newWeight,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      } else {
        store.commit(storeModule + '/manuallySetWeightOfSpecificHand', {
          specificHandString: payload.specificHandString,
          newWeight: payload.newWeight,
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleSetWeightToApplyToAddedHandsEvent',
    value: function handleSetWeightToApplyToAddedHandsEvent(storeModule, store, weightToApplyToAddedHands, playerIndex) {
      store.commit(storeModule + '/setWeightToApplyToAddedHands', {
        weightToApplyToAddedHands: weightToApplyToAddedHands,
        playerIndex: playerIndex
      });
    }
  }, {
    key: 'handleFinishedClickAndDrag',
    value: function handleFinishedClickAndDrag(storeModule, store, playerIndex, playerStateIndex) {
      if (playerStateIndex > 0) {
        store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleRemovePlayerEvent',
    value: function handleRemovePlayerEvent(storeModule, store, playerIndex) {
      store.commit(storeModule + '/removePlayer', playerIndex);
    }
  }, {
    key: 'handleClearPlayerEvent',
    value: function handleClearPlayerEvent(storeModule, store, playerIndex, playerStateIndex) {
      if (['hitCalculator', 'shortDeckHitCalculator', 'guidedAnalysesBluffing', 'guidedAnalysesCalling'].includes(storeModule) && playerStateIndex > 0) {
        // simulate clear all checks click
        store.commit(storeModule + '/uncheckAllFiveCardHandsForGivenState', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
        store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);

        if (store.state[storeModule].presetCommunityCards.areAllCardsSet(playerStateIndex)) {
          store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
            playerIndex: playerIndex,
            playerStateIndex: playerStateIndex
          });
        }

        return;
      }

      if (playerStateIndex === 0) {
        store.commit(storeModule + '/deselectAllGeneralHands', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      } else {
        store.commit(storeModule + '/manuallyDeselectAllGeneralHands', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleAddComboToCombosToAddEvent',
    value: function handleAddComboToCombosToAddEvent(storeModule, store, combo, playerIndex) {
      store.commit(storeModule + '/addComboToCombosToAdd', {
        combo: combo,
        playerIndex: playerIndex
      });
    }
  }, {
    key: 'handleRemoveComboFromCombosToAddEvent',
    value: function handleRemoveComboFromCombosToAddEvent(storeModule, store, combo, playerIndex) {
      store.commit(storeModule + '/removeComboFromCombosToAdd', {
        combo: combo,
        playerIndex: playerIndex
      });
    }
  }, {
    key: 'handleApplyExactWeightToGeneralHandsEvent',
    value: function handleApplyExactWeightToGeneralHandsEvent(storeModule, store, payload, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/applyExactWeightToGeneralHands', {
        generalHandsFromModal: payload.generalHandsFromModal,
        newWeight: payload.newWeight,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
    }
  }, {
    key: 'handleSetCheckedValueOfFiveCardHandEvent',
    value: function handleSetCheckedValueOfFiveCardHandEvent(storeModule, store, payload, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/setCheckedValueOfFiveCardHand', {
        fiveCardHandId: payload.fiveCardHandId,
        newCheckedValue: payload.newCheckedValue,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);

      if (storeModule === 'hitCalculator' && !store.state.hitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex) || storeModule === 'shortDeckHitCalculator' && !store.state.shortDeckHitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.dispatch(storeModule + '/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }

      if (store.state[storeModule].presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleApplyExactWeightToFiveCardHandEvent',
    value: function handleApplyExactWeightToFiveCardHandEvent(storeModule, store, payload, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/applyExactWeightToFiveCardHand', payload);
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);

      if (storeModule === 'hitCalculator' && !store.state.hitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex) || storeModule === 'shortDeckHitCalculator' && !store.state.shortDeckHitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.dispatch(storeModule + '/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }

      if (store.state[storeModule].presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleToggleCollapsedValueOfFiveCardHandParentEvent',
    value: function handleToggleCollapsedValueOfFiveCardHandParentEvent(storeModule, store, fiveCardHandParent) {
      store.commit(storeModule + '/toggleCollapsedValueOfFiveCardHandParent', fiveCardHandParent);
    }
  }, {
    key: 'handleUpdateWeightOfFiveCardHandEvent',
    value: function handleUpdateWeightOfFiveCardHandEvent(storeModule, store, payload, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/updateWeightOfFiveCardHand', {
        fiveCardHandId: payload.fiveCardHandId,
        newWeight: payload.newWeight,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);

      if (storeModule === 'hitCalculator' && !store.state.hitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex) || storeModule === 'shortDeckHitCalculator' && !store.state.shortDeckHitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.dispatch(storeModule + '/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }

      if (store.state[storeModule].presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleClearAllChecksEvent',
    value: function handleClearAllChecksEvent(storeModule, store, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/uncheckAllFiveCardHandsForGivenState', {
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);

      if (storeModule === 'hitCalculator' && !store.state.hitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex) || storeModule === 'shortDeckHitCalculator' && !store.state.shortDeckHitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.dispatch(storeModule + '/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }

      if (store.state[storeModule].presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleSelectAllChecksEvent',
    value: function handleSelectAllChecksEvent(storeModule, store, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/checkAllFiveCardHandsForGivenState', {
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);

      if (storeModule === 'hitCalculator' && !store.state.hitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex) || storeModule === 'shortDeckHitCalculator' && !store.state.shortDeckHitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.dispatch(storeModule + '/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }

      if (store.state[storeModule].presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleSetChecksToDefaultEvent',
    value: function handleSetChecksToDefaultEvent(storeModule, store, opponentTightness, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/setChecksToDefaultsForGivenState', {
        opponentTightness: opponentTightness,
        playerIndex: playerIndex,
        settings: store.state.account.user.settings,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);

      if (storeModule === 'hitCalculator' && !store.state.hitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex) || storeModule === 'shortDeckHitCalculator' && !store.state.shortDeckHitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.dispatch(storeModule + '/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }

      if (store.state[storeModule].presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleSetChecksBasedOnUserDefinedFilterEvent',
    value: function handleSetChecksBasedOnUserDefinedFilterEvent(storeModule, store, filterName, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/setChecksAccordingToUserDefinedFilterForGivenState', {
        filterName: filterName,
        userDefinedFilters: store.state.account.user.settings.hitCalculator.userDefinedFilters,
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
      store.commit(storeModule + '/setRangesAccordingToFilters', playerIndex);

      if (storeModule === 'hitCalculator' && !store.state.hitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex) || storeModule === 'shortDeckHitCalculator' && !store.state.shortDeckHitCalculator.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.dispatch(storeModule + '/setHitPercentage', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }

      if (store.state[storeModule].presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        store.commit(storeModule + '/setPercentagesOfSpecificHandsThatAreSelected', {
          playerIndex: playerIndex,
          playerStateIndex: playerStateIndex
        });
      }
    }
  }, {
    key: 'handleFiveCardHandMouseover',
    value: function handleFiveCardHandMouseover(storeModule, store, playerIndex, playerStateIndex, matchingSpecificHands) {
      store.commit(storeModule + '/highlightGeneralHandsThatMatchFiveCardHand', {
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex,
        matchingSpecificHands: matchingSpecificHands
      });
    }
  }, {
    key: 'handleFiveCardHandMouseleave',
    value: function handleFiveCardHandMouseleave(storeModule, store, playerIndex, playerStateIndex) {
      store.commit(storeModule + '/removeFiveCardHandHighlights', {
        playerIndex: playerIndex,
        playerStateIndex: playerStateIndex
      });
    }
  }, {
    key: 'adjustForShortDeck',


    // short deck
    value: function adjustForShortDeck() {
      this.states.forEach(function (playerState) {
        playerState.generalHands.adjustForShortDeck();
      });
    }
  }]);

  return Player;
}();

/* harmony default export */ __webpack_exports__["a"] = (Player);
;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "Z27U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"insights"},[_c('ul',{staticClass:"nav nav-pills"},[_c('li',{class:{ active: _vm.activeInsightSection === 'bluffing' }},[_c('a',{on:{"click":function($event){_vm.activeInsightSection = 'bluffing'}}},[_vm._v("\n        Bluffing\n      ")])]),_vm._v(" "),_c('li',{class:{ active: _vm.activeInsightSection === 'bluff raising' }},[_c('a',{on:{"click":function($event){_vm.activeInsightSection = 'bluff raising'}}},[_vm._v("\n        Bluff raising\n      ")])])]),_vm._v(" "),(_vm.activeInsightSection === 'bluffing')?_c('section',[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('header-cell',{attrs:{"profitable":_vm.isBluffProfitable(1, 3)}},[_vm._v("\n            1/3 pot\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isBluffProfitable(1, 2)}},[_vm._v("\n            1/2 pot\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isBluffProfitable(2, 3)}},[_vm._v("\n            2/3 pot\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isBluffProfitable(3, 4)}},[_vm._v("\n            3/4 pot\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isBluffProfitable(1, 1)}},[_vm._v("\n            Full pot\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isBluffProfitable(3, 2)}},[_vm._v("\n            1.5x pot\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isBluffProfitable(2, 1)}},[_vm._v("\n            2x pot\n          ")])],1)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('table-cell',{attrs:{"profitable":_vm.isBluffProfitable(1, 3)}},[_vm._v("\n            25%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isBluffProfitable(1, 2)}},[_vm._v("\n            33.3%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isBluffProfitable(2, 3)}},[_vm._v("\n            40%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isBluffProfitable(3, 4)}},[_vm._v("\n            42.9%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isBluffProfitable(1, 1)}},[_vm._v("\n            50%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isBluffProfitable(3, 2)}},[_vm._v("\n            60%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isBluffProfitable(2, 1)}},[_vm._v("\n            66.6%\n          ")])],1)])])]):_vm._e(),_vm._v(" "),(_vm.activeInsightSection === 'bluff raising')?_c('section',{staticClass:"bluff-raising"},[_c('initial-bet-size-button-group',{attrs:{"initialBetSize":_vm.initialBetSize},on:{"setInitialBetSize":function($event){_vm.initialBetSize = $event}}}),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('header-cell',{attrs:{"profitable":_vm.isRaiseProfitable(2)}},[_vm._v("\n            2x initial bet\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isRaiseProfitable(3)}},[_vm._v("\n            3x initial bet\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isRaiseProfitable(4)}},[_vm._v("\n            4x initial bet\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isRaiseProfitable(5)}},[_vm._v("\n            5x initial bet\n          ")]),_vm._v(" "),_c('header-cell',{attrs:{"profitable":_vm.isRaiseProfitable(6)}},[_vm._v("\n            6x initial bet\n          ")])],1)]),_vm._v(" "),_c('tbody',[_c('tr',[_c('table-cell',{attrs:{"profitable":_vm.isRaiseProfitable(2)}},[_vm._v("\n            "+_vm._s(_vm.getPercentageOfTimeRaiseNeedsToWork(2).toFixed(0))+"%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isRaiseProfitable(3)}},[_vm._v("\n            "+_vm._s(_vm.getPercentageOfTimeRaiseNeedsToWork(3).toFixed(0))+"%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isRaiseProfitable(4)}},[_vm._v("\n            "+_vm._s(_vm.getPercentageOfTimeRaiseNeedsToWork(4).toFixed(0))+"%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isRaiseProfitable(5)}},[_vm._v("\n            "+_vm._s(_vm.getPercentageOfTimeRaiseNeedsToWork(5).toFixed(0))+"%\n          ")]),_vm._v(" "),_c('table-cell',{attrs:{"profitable":_vm.isRaiseProfitable(6)}},[_vm._v("\n            "+_vm._s(_vm.getPercentageOfTimeRaiseNeedsToWork(6).toFixed(0))+"%\n          ")])],1)])])],1):_vm._e(),_vm._v(" "),_c('hr')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z4h7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__ = __webpack_require__("lDlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_controls_card_selection_hole_cards_selector__ = __webpack_require__("Sl4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_street_selector__ = __webpack_require__("Xr2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_guided_analyses_num_opponents_selector__ = __webpack_require__("Cesf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_guided_analyses_should_you_bluff_preflop_steps__ = __webpack_require__("cxwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_guided_analyses_should_you_bluff_flop_steps__ = __webpack_require__("TYCb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_guided_analyses_should_you_bluff_turn_steps__ = __webpack_require__("qCdt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_guided_analyses_should_you_bluff_river_steps__ = __webpack_require__("5Ec5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_guided_analyses_should_you_bluff_conclusions_initial_conclusion__ = __webpack_require__("LGkT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_guided_analyses_should_you_bluff_conclusions_final_conclusion__ = __webpack_require__("xdGD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_guided_analyses_should_you_bluff_conclusions_long_run_disclaimer__ = __webpack_require__("UYPa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_controls_create_sharable_url_button__ = __webpack_require__("zMC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_controls_save_scenario_button__ = __webpack_require__("A/Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_onboarding_modal__ = __webpack_require__("iexb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_help_icon__ = __webpack_require__("FmIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__ = __webpack_require__("pihl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'guided-analyses-should-you-bluff',
  components: {
    'readonly-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__["a" /* default */],
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__["a" /* default */],
    'hole-cards-selector': __WEBPACK_IMPORTED_MODULE_3__components_controls_card_selection_hole_cards_selector__["a" /* default */],
    'street-selector': __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_street_selector__["a" /* default */],
    'num-opponents-selector': __WEBPACK_IMPORTED_MODULE_5__components_guided_analyses_num_opponents_selector__["a" /* default */],
    'preflop-steps': __WEBPACK_IMPORTED_MODULE_6__components_guided_analyses_should_you_bluff_preflop_steps__["a" /* default */],
    'flop-steps': __WEBPACK_IMPORTED_MODULE_7__components_guided_analyses_should_you_bluff_flop_steps__["a" /* default */],
    'turn-steps': __WEBPACK_IMPORTED_MODULE_8__components_guided_analyses_should_you_bluff_turn_steps__["a" /* default */],
    'river-steps': __WEBPACK_IMPORTED_MODULE_9__components_guided_analyses_should_you_bluff_river_steps__["a" /* default */],
    'initial-conclusion': __WEBPACK_IMPORTED_MODULE_10__components_guided_analyses_should_you_bluff_conclusions_initial_conclusion__["a" /* default */],
    'final-conclusion': __WEBPACK_IMPORTED_MODULE_11__components_guided_analyses_should_you_bluff_conclusions_final_conclusion__["a" /* default */],
    'long-run-disclaimer': __WEBPACK_IMPORTED_MODULE_12__components_guided_analyses_should_you_bluff_conclusions_long_run_disclaimer__["a" /* default */],
    'create-sharable-url-button': __WEBPACK_IMPORTED_MODULE_13__components_controls_create_sharable_url_button__["a" /* default */],
    'save-scenario-button': __WEBPACK_IMPORTED_MODULE_14__components_controls_save_scenario_button__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_15__components_onboarding_modal__["a" /* default */],
    'help-icon': __WEBPACK_IMPORTED_MODULE_16__components_help_icon__["a" /* default */]
  },
  data: function data() {
    return {
      equitySimulationsInProgress: false
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.guidedAnalysesBluffing;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.shouldYouBluff.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    hitPercentageForStreetToBluff: function hitPercentageForStreetToBluff() {
      if (this.state.streetToBluff === 'flop') {
        return this.state.players.find(0).states[1].hitPercentage;
      } else if (this.state.streetToBluff === 'turn') {
        return this.state.players.find(0).states[2].hitPercentage;
      } else if (this.state.streetToBluff === 'river') {
        return this.state.players.find(0).states[3].hitPercentage;
      }
    },
    foldEquity: function foldEquity() {
      if (this.state.players.numPlayers === 1) {
        return (100 - this.hitPercentageForStreetToBluff).roundToTwoDecimalPlaces();
      } else {
        return this.$store.getters['guidedAnalysesBluffing/percentageOfTimeEveryoneMissesTheBoard'](this.state.streetToBluff).roundToTwoDecimalPlaces();
      }
    },
    equity: function equity() {
      var equity = 100;

      this.state.players.forEach(function (player) {
        equity -= player.states[0].equity;
      });

      return equity.roundToTwoDecimalPlaces();
    },
    ableToRunFiveCardHandPercentageSimulationsForTheFlop: function ableToRunFiveCardHandPercentageSimulationsForTheFlop() {
      var returnValue = true;

      if (!this.state.presetCommunityCards.flopSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('preflop')) {
        returnValue = false;
      }

      return returnValue;
    },
    ableToRunFiveCardHandPercentageSimulationsForTheTurn: function ableToRunFiveCardHandPercentageSimulationsForTheTurn() {
      var returnValue = true;

      if (!this.state.presetCommunityCards.turnSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('flop')) {
        returnValue = false;
      }

      return returnValue;
    },
    ableToRunFiveCardHandPercentageSimulationsForTheRiver: function ableToRunFiveCardHandPercentageSimulationsForTheRiver() {
      var returnValue = true;

      if (!this.state.presetCommunityCards.riverSet) {
        returnValue = false;
      }

      if (this.state.players.hasEmptyRange('turn')) {
        returnValue = false;
      }

      return returnValue;
    },
    ableToRunEquityCalculations: function ableToRunEquityCalculations() {
      var ableToRunEquityCalculations = true;

      if (!this.state.presetHoleCards.bothSet) {
        ableToRunEquityCalculations = false;
      } else if (this.state.streetToBluff === 'flop') {
        if (!this.state.presetCommunityCards.flopSet) {
          ableToRunEquityCalculations = false;
        }

        if (this.state.players.hasEmptyRange('flop')) {
          ableToRunEquityCalculations = false;
        }
      } else if (this.state.streetToBluff === 'turn') {
        if (!this.state.presetCommunityCards.turnSet) {
          ableToRunEquityCalculations = false;
        }

        if (this.state.players.hasEmptyRange('turn')) {
          ableToRunEquityCalculations = false;
        }
      } else if (this.state.streetToBluff === 'river') {
        if (!this.state.presetCommunityCards.riverSet) {
          ableToRunEquityCalculations = false;
        }

        if (this.state.players.hasEmptyRange('river')) {
          ableToRunEquityCalculations = false;
        }
      }

      return ableToRunEquityCalculations;
    },
    playerStateIndexToUseForSimulations: function playerStateIndexToUseForSimulations() {
      if (this.state.streetToBluff === 'flop') {
        return 1;
      } else if (this.state.streetToBluff === 'turn') {
        return 2;
      } else if (this.state.streetToBluff === 'river') {
        return 3;
      }
    },
    presetCards: function presetCards() {
      return __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.union(this.state.presetHoleCards.array, this.state.presetCommunityCards.array);
    },
    conclusionsVisible: function conclusionsVisible() {
      if (this.state.streetToBluff === 'flop') {
        return this.state.presetCommunityCards.flopSet;
      } else if (this.state.streetToBluff === 'turn') {
        return this.state.presetCommunityCards.turnSet;
      } else if (this.state.streetToBluff === 'river') {
        return this.state.presetCommunityCards.riverSet;
      }
    },
    authorized: function authorized() {
      return this.$store.getters['account/authorizedForBasic'];
    }
  },
  mounted: function mounted() {
    var self = this;

    if (self.$route.params.id) {
      self.load();
    } else {
      self.$store.commit('guidedAnalysesBluffing/setFiveCardHandValuesToDefaults', {
        settings: self.$store.state.account.user.settings,
        opponentTightness: 'straightforward'
      });
    }

    self.handleOnboard();

    // flop five card hand simulations
    self.$watch(function () {
      var sum = 0;

      self.state.players.forEach(function (player) {
        sum += player.states[0].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    }, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.debounce(self.runFiveCardHandPercentagesSimulationsForFlop, 1000));

    // turn five card hand simulations
    self.$watch(function () {
      var sum = 0;

      self.state.players.forEach(function (player) {
        sum += player.states[1].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    }, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.debounce(self.runFiveCardHandPercentagesSimulationsForTurn, 1000));

    // river five card hand simulations
    self.$watch(function () {
      var sum = 0;

      self.state.players.forEach(function (player) {
        sum += player.states[2].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    }, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.debounce(self.runFiveCardHandPercentagesSimulationsForRiver, 1000));

    // equity
    self.$watch(function () {
      var sum = 0;

      self.state.players.forEach(function (player) {
        sum += player.states[0].generalHands.numberOfSpecificHandsInRange;
        sum += player.states[1].generalHands.numberOfSpecificHandsInRange;
        sum += player.states[2].generalHands.numberOfSpecificHandsInRange;
        sum += player.states[3].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    }, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.debounce(self.runEquityCalculations, 1000));
  },
  methods: {
    // mounted
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default guided analysis bluffing page.');
          self.$router.push('/guided-analyses/should-you-bluff');
        } else {
          self.$store.commit('guidedAnalysesBluffing/setState', response.data.storeState);
          self.simulate();
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default guided analysis bluffing page.');
        self.$router.push('/guided-analyses/should-you-bluff');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.shouldYouBluff) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'shouldYouBluff' }).then(function () {
        self.$store.commit('account/onboard', 'shouldYouBluff');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },

    // stuff
    setStreetToBluff: function setStreetToBluff(streetToBluff) {
      this.$store.commit('guidedAnalysesBluffing/setStreetToBluff', streetToBluff);

      if (streetToBluff === 'flop') {
        this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', 'turn');
        this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', 'river');
        this.setRangesAccordingToFiltersForAllPlayers();
      } else if (streetToBluff === 'turn') {
        this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', 'river');
        this.setRangesAccordingToFiltersForAllPlayers();
      }
    },
    setBluffSize: function setBluffSize(bluffSize) {
      this.$store.commit('guidedAnalysesBluffing/setBluffSize', bluffSize);
    },
    setProfitableBreakevenPercentage: function setProfitableBreakevenPercentage(profitableBreakevenPercentage) {
      this.$store.commit('guidedAnalysesBluffing/setProfitableBreakevenPercentage', profitableBreakevenPercentage);
    },
    getTextWhenFiveCardHandPercentagesArentUpToDate: function getTextWhenFiveCardHandPercentagesArentUpToDate(playerStateIndex) {
      if (playerStateIndex === 1 && this.ableToRunFiveCardHandPercentageSimulationsForTheFlop || playerStateIndex === 2 && this.ableToRunFiveCardHandPercentageSimulationsForTheTurn || playerStateIndex === 3 && this.ableToRunFiveCardHandPercentageSimulationsForTheRiver) {
        return 'Running simulations...';
      } else {
        return 'Percentages of made hands, draws and combos are not up to date. Make sure that the range in the previous step has at least one hand selected so that simulations can be run to update the percentages.';
      }
    },

    // preset cards
    setPresetHoleCard: function setPresetHoleCard(params) {
      this.$store.commit('guidedAnalysesBluffing/removePresetHoleCard', params.position);
      this.$store.commit('guidedAnalysesBluffing/setPresetHoleCard', {
        card: params.card,
        position: params.position
      });
      this.resetAllDoubleSliders();
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    removePresetHoleCard: function removePresetHoleCard(position) {
      this.$store.commit('guidedAnalysesBluffing/removePresetHoleCard', position);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(card, position) {
      this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', position);
      this.$store.commit('guidedAnalysesBluffing/setIndividualPresetCommunityCard', {
        card: card,
        position: position
      });
      this.resetAllDoubleSliders();
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    setBoard: function setBoard(boardCards) {
      this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', 'flop1');
      this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', 'flop2');
      this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', 'flop3');
      this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', 'turn');
      this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', 'river');
      this.$store.commit('guidedAnalysesBluffing/setBoard', boardCards);
      this.resetAllDoubleSliders();
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    removePresetCommunityCard: function removePresetCommunityCard(position) {
      this.$store.commit('guidedAnalysesBluffing/removePresetCommunityCard', position);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    addPlayer: function addPlayer() {
      this.$store.commit('guidedAnalysesBluffing/addPlayer', {
        settings: this.$store.state.account.user.settings,
        opponentTightness: 'straightforward'
      });
    },
    removePlayer: function removePlayer() {
      this.$store.commit('guidedAnalysesBluffing/removePlayer', this.state.players.numPlayers - 1);
      this.simulate();
    },

    setRangesAccordingToFiltersForAllPlayers: function setRangesAccordingToFiltersForAllPlayers() {
      this.state.players.forEach(function (player, i) {
        this.$store.commit('guidedAnalysesBluffing/setRangesAccordingToFilters', i);
      }, this);
    },
    resetAllDoubleSliders: function resetAllDoubleSliders() {
      this.$refs.preflopSteps.resetAllDoubleSliders();
    },

    // simulate
    simulate: function simulate() {
      this.runEquityCalculations().then(this.runFiveCardHandPercentagesSimulationsForFlop).then(this.runFiveCardHandPercentagesSimulationsForTurn).then(this.runFiveCardHandPercentagesSimulationsForRiver);
    },
    runEquityCalculations: function runEquityCalculations() {
      if (!this.ableToRunEquityCalculations) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      var self = this;
      var weightedRanges = self._getWeightedRanges();
      var numberOfSimulations = self.$store.state.account.user.settings.equityCalculator.numberOfSimulations;

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getEquities(weightedRanges, self.state.presetCommunityCards.array, numberOfSimulations, function () {
        self.equitySimulationsInProgress = true;
      }).then(function (simulationResults) {
        self.$store.commit('guidedAnalysesBluffing/updateEquityResults', {
          simulationResults: simulationResults,
          numberOfSimulations: numberOfSimulations,
          rakePercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.rakePercentage,
          tipPercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.tipPercentage
        });
        self.equitySimulationsInProgress = false;
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    _getWeightedRanges: function _getWeightedRanges() {
      var weightedRanges = [];
      var heroWeightedRange = [[this.state.presetHoleCards.holeCardOne, this.state.presetHoleCards.holeCardTwo]];
      var playerStateIndexToUseForSimulations = this.playerStateIndexToUseForSimulations;

      weightedRanges.push(heroWeightedRange);
      this.state.players.forEach(function (player) {
        weightedRanges.push(player.states[playerStateIndexToUseForSimulations].generalHands.weightedRange);
      }, this);

      return weightedRanges;
    },
    runFiveCardHandPercentagesSimulationsForFlop: function runFiveCardHandPercentagesSimulationsForFlop() {
      var self = this;

      if (!self.ableToRunFiveCardHandPercentageSimulationsForTheFlop) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getFlopFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('guidedAnalysesBluffing/setLastSimulationInfo', 1);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    runFiveCardHandPercentagesSimulationsForTurn: function runFiveCardHandPercentagesSimulationsForTurn() {
      var self = this;

      if (!self.ableToRunFiveCardHandPercentageSimulationsForTheTurn) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getTurnFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('guidedAnalysesBluffing/setLastSimulationInfo', 2);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    runFiveCardHandPercentagesSimulationsForRiver: function runFiveCardHandPercentagesSimulationsForRiver() {
      var self = this;

      if (!self.ableToRunFiveCardHandPercentageSimulationsForTheRiver) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getRiverFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('guidedAnalysesBluffing/setLastSimulationInfo', 3);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "ZAzC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"rake-and-tip-settings settings"},[_vm._m(0),_vm._v(" "),_c('form',[_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n        Pot size ($):\n        "),_c('input',{ref:"potSize",staticClass:"form-control input-lg",attrs:{"type":"number","min":"0"},domProps:{"value":_vm.settings.equityCalculator.rakeAndTip.potSize}})])]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n        Rake percentage "),_c('a',{attrs:{"href":"https://www.pokerschoolonline.com/articles/Beginning-Poker-11-Rake-Considerations"}},[_vm._v("(usually 5-10%)")]),_vm._v(":\n        "),_c('input',{ref:"initialRakePercentage",staticClass:"form-control input-lg",attrs:{"type":"number","min":"0","max":"100"},domProps:{"value":_vm.settings.equityCalculator.rakeAndTip.initialRakePercentage}})])]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n        Rake cap "),_c('a',{attrs:{"href":"https://www.pokernews.com/strategy/las-vegas-poker-cash-games-rake-comps-27539.htm"}},[_vm._v("(usually $3-5)")]),_vm._v(":\n        "),_c('input',{ref:"rakeCap",staticClass:"form-control input-lg",attrs:{"type":"number","min":"0"},domProps:{"value":_vm.settings.equityCalculator.rakeAndTip.rakeCap}})])]),_vm._v(" "),_c('section',{staticClass:"form-group"},[_c('label',[_vm._v("\n        Tip amount ($):\n        "),_c('input',{ref:"tipAmount",staticClass:"form-control input-lg",attrs:{"type":"number","min":"0"},domProps:{"value":_vm.settings.equityCalculator.rakeAndTip.tipAmount}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-lg",attrs:{"type":"button"},on:{"click":function($event){return _vm.resetRakeAndTip()}}},[_vm._v("Set to defaults")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveRakeAndTip()}}},[_vm._v("Save")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_c('p',[_vm._v("Setting the rake and/or the tip will affect the resulting equity.")]),_vm._v(" "),_c('p',[_vm._v("If you think about it, that makes sense. If you win a $100 pot and the house takes $5 for rake, in a very real sense, the house has 5% equity in the pot. Similarly, if you win a $100 pot and tip the dealer $5, the dealer has 5% equity.")]),_vm._v(" "),_c('p',[_vm._v("If the house and dealer both have some equity in the hand, it will slightly reduce the amount of equity that the players have, which will be reflected in the equity calculator.")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Rake and tip")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZBHL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"action-selector well",attrs:{"disabled":!_vm.authorized}},[_vm._l((_vm.actions),function(action,index){return _c('div',{key:action.id,staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio"},domProps:{"checked":index === _vm.indexOfSelectedAction},on:{"input":function($event){return _vm.$emit('selectAction', index)}}}),_vm._v(" "),_c('span',{staticClass:"color-sample",class:action.color}),_vm._v(" "),(!action.immutableName)?_c('input',{attrs:{"type":"text"},domProps:{"value":action.name},on:{"click":function($event){return _vm.$emit('selectAction', index)},"input":function($event){return _vm.$emit('setNameOfAction', { name: $event.target.value, index: index })}}}):_c('span',[_vm._v(_vm._s(action.name))]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-xs",attrs:{"title":"Apply to all unselected hands"},on:{"click":function($event){return _vm.$emit('applyToAllUnselectedHands', action.color)}}},[_vm._v("\n        Apply\n      ")]),_vm._v(" "),(!action.immutableName)?_c('span',{staticClass:"close",on:{"click":function($event){$event.preventDefault();return _vm.$emit('removeAction', index)}}},[_vm._v("\n        ×\n      ")]):_vm._e(),_vm._v(" "),(action.name !== 'Not possible')?_c('span',[_vm._v(_vm._s(_vm.$store.getters['rangeConstructor/percentageForAction'](action.color))+"%")]):_vm._e()])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"disabled":_vm.actions.length === 8},on:{"click":function($event){return _vm.$emit('addAction')}}},[_vm._v("\n    Add\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZHcg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_square_vue__ = __webpack_require__("IqOy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd9eb94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_square_vue__ = __webpack_require__("7JaY");
function injectStyle (ssrContext) {
  __webpack_require__("N0Mf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5bd9eb94"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_square_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5bd9eb94_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_square_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZIZt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),(!_vm.loggedIn)?_c('section',{staticClass:"alert alert-info"},[_vm._v("\n    Note: You need to "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" before you can pay. When you do register, you'll automatically be entered in to the 14 day free trial.\n  ")],1):_vm._e(),_vm._v(" "),_c('section',{staticClass:"alert alert-info"},[_vm._v("\n    Interested in short deck? Head over to the "),_c('router-link',{attrs:{"to":"/short-deck-pricing"}},[_vm._v("short deck pricing page")]),_vm._v(".\n  ")],1),_vm._v(" "),_c('pricing-table')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Pricing")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZaAg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'subscribe-to-blog'
});

/***/ }),

/***/ "Zc1L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_beginners_guide_vue__ = __webpack_require__("ggGn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63a372ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_beginners_guide_vue__ = __webpack_require__("8r4B");
function injectStyle (ssrContext) {
  __webpack_require__("s/JT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63a372ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_beginners_guide_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63a372ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_beginners_guide_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZfmI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__ = __webpack_require__("RBWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_controls_card_selection_random_board_selector__ = __webpack_require__("c/qk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preset-community-cards-selector',
  components: {
    'individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__["a" /* default */],
    'random-board-selector': __WEBPACK_IMPORTED_MODULE_1__components_controls_card_selection_random_board_selector__["a" /* default */]
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'disabled', 'popoverDirectionClass'],
  computed: {
    presetCards: function presetCards() {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'river') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function _toggleNextDropdown(previousPosition) {
      var nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function __getNextPosition(previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else if (previousPosition === 'flop3') {
        return 'turn';
      } else if (previousPosition === 'turn') {
        return 'river';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    }
  }
});

/***/ }),

/***/ "ZtL1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preflop_steps_vue__ = __webpack_require__("qzey");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0d8991_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preflop_steps_vue__ = __webpack_require__("y6m+");
function injectStyle (ssrContext) {
  __webpack_require__("rs9h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f0d8991"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preflop_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0d8991_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preflop_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZvOQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a398":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pot_odds_selector_vue__ = __webpack_require__("CK9H");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a113ab3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pot_odds_selector_vue__ = __webpack_require__("1Cqg");
function injectStyle (ssrContext) {
  __webpack_require__("/HhM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a113ab3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pot_odds_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a113ab3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pot_odds_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "a4NO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'single-slider-selector',
  props: ['percentOfHandsInRangeNumberForDisplay', 'disabled'],
  methods: {
    setRangeToMatchSingleSlider: function setRangeToMatchSingleSlider(targetPercentage) {
      this.$emit('setRangeToMatchDoubleSlider', {
        topPercentile: targetPercentage,
        bottomPercentile: 0
      });
    }
  }
});

/***/ }),

/***/ "a6wH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a81n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");


/* harmony default export */ __webpack_exports__["a"] = ({
  run: function run(text) {
    var textSegments = text.split(',');
    var specificHandStringsFromTextSegment = void 0;
    var specificHandStrings = [];

    if (text === '') {
      return [];
    }

    textSegments.forEach(function (textSegment) {
      specificHandStringsFromTextSegment = this._getSpecificHandStringsFromTextSegment(textSegment);
      specificHandStrings.pushEachElement(specificHandStringsFromTextSegment);
    }, this);

    return specificHandStrings;
  },
  _getSpecificHandStringsFromTextSegment: function _getSpecificHandStringsFromTextSegment(textSegment) {
    // hardcoded stuff
    if (textSegment === 'aqs+') {
      return ['ackc', 'asks', 'ahkh', 'adkd', 'acqc', 'asqs', 'ahqh', 'adqd'];
    } else if (textSegment === 'aqo+') {
      return ['acks', 'ackh', 'ackd', 'askc', 'askh', 'askd', 'ahkc', 'ahks', 'ahkd', 'adkc', 'adks', 'adkh', 'acqs', 'acqh', 'acqd', 'asqc', 'asqh', 'asqd', 'ahqc', 'ahqs', 'ahqd', 'adqc', 'adqs', 'adqh'];
    } else if (textSegment === 'aq+') {
      return ['ackc', 'acks', 'ackh', 'ackd', 'askc', 'asks', 'askh', 'askd', 'ahkc', 'ahks', 'ahkh', 'ahkd', 'adkc', 'adks', 'adkh', 'adkd', 'acqc', 'acqs', 'acqh', 'acqd', 'asqc', 'asqs', 'asqh', 'asqd', 'ahqc', 'ahqs', 'ahqh', 'ahqd', 'adqc', 'adqs', 'adqh', 'adqd'];
    }

    var textSegmentType = this.__getTextSegmentType(textSegment);

    if (textSegmentType === 'ascending') {
      // 66+
      return this.__getSpecificHandStringsFromAscendingTextSegment(textSegment);
    } else if (textSegmentType === 'descending') {
      // 66-
      return this.__getSpecificHandStringsFromDescendingTextSegment(textSegment);
    } else if (textSegmentType === 'range') {
      // 66-33
      return this.__getSpecificHandStringsFromRangeTextSegment(textSegment);
    } else if (textSegmentType === 'general hand') {
      // 66
      return this.__getSpecificHandStringsFromGeneralHandTextSegment(textSegment);
    } else if (textSegmentType === 'specific hand') {
      // eg. 6c6s
      return [__WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getNormalizedSpecificHandString(textSegment)];
    } else {
      throw new Error('Unable to find text segment typpe.');
    }
  },
  __getTextSegmentType: function __getTextSegmentType(textSegment) {
    if (textSegment[2] === '+' || textSegment[3] === '+') {
      return 'ascending';
    } else if (textSegment.length >= 5 && textSegment.length <= 7) {
      return 'range';
    } else if (textSegment.includes('-')) {
      return 'descending';
    } else if (textSegment.length === 2 || textSegment.length === 3) {
      return 'general hand';
    } else if (textSegment.length === 4) {
      return 'specific hand';
    } else {
      throw new Error('Problem getting text segment type.');
    }
  },
  __getSpecificHandStringsFromAscendingTextSegment: function __getSpecificHandStringsFromAscendingTextSegment(textSegment) {
    var gapperType = this.___getGapperType(textSegment);
    var pocketPair = textSegment[0] === textSegment[1];

    if (pocketPair) {
      return this.___getSpecificHandStringsFromAscendingPocketPairTextSegment(textSegment);
    } else if (gapperType === 'connector') {
      return this.___getSpecificHandStringsFromAscendingConnectorTextSegment(textSegment);
    } else if (gapperType === 'one gapper') {
      return this.___getSpecificHandStringsFromAscendingOneGapperTextSegment(textSegment);
    } else if (gapperType === 'spaced') {
      return this.___getSpecificHandStringsFromSpacedAscendingTextSegment(textSegment);
    } else {
      throw new Error('Problem getting gapper type.');
    }
  },
  ___getGapperType: function ___getGapperType(textSegment) {
    var rankOne = textSegment[0];
    var rankTwo = textSegment[1];
    var rankThree = void 0;
    var rankFour = void 0;
    var spaceBetweenRanksOne = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getSpaceBetweenRanks([rankOne, rankTwo]);
    var spaceBetweenRanksTwo = void 0;

    // range
    if (textSegment.length === 5 || textSegment.length === 7) {
      if (textSegment.length === 5) {
        rankThree = textSegment[3];
        rankFour = textSegment[4];
      } else if (textSegment.length === 7) {
        rankThree = textSegment[4];
        rankFour = textSegment[5];
      }

      spaceBetweenRanksTwo = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getSpaceBetweenRanks([rankThree, rankFour]);

      if (spaceBetweenRanksOne === 1 && spaceBetweenRanksTwo === 1) {
        return 'connector';
      } else if (spaceBetweenRanksOne === 2 && spaceBetweenRanksTwo === 2) {
        return 'one gapper';
      } else {
        return 'spaced';
      }
    }

    // ascending or descending
    else {
        if (spaceBetweenRanksOne === 1) {
          return 'connector';
        } else if (spaceBetweenRanksOne === 2) {
          return 'one gapper';
        } else {
          return 'spaced';
        }
      }
  },
  ___getSpecificHandStringsFromAscendingPocketPairTextSegment: function ___getSpecificHandStringsFromAscendingPocketPairTextSegment(textSegment) {
    var rank = textSegment[0];
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank('a', rank, function (currRank) {
      generalHandStrings.push(currRank + currRank);
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromAscendingConnectorTextSegment: function ___getSpecificHandStringsFromAscendingConnectorTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var suitedAndOffsuit = textSegment.length === 3;
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var oneLower = void 0;
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank('a', highRankFromTextSegment, function (currRank) {
      oneLower = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(currRank);

      if (suitedAndOffsuit) {
        generalHandStrings.push(currRank + oneLower + 's');
        generalHandStrings.push(currRank + oneLower + 'o');
      } else {
        generalHandStrings.push(currRank + oneLower + suitedOrOffsuitFromTextSegment);
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromAscendingOneGapperTextSegment: function ___getSpecificHandStringsFromAscendingOneGapperTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var suitedAndOffsuit = textSegment.length === 3;
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var twoLower = void 0;
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank('a', highRankFromTextSegment, function (currRank) {
      twoLower = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(currRank, 2);

      if (suitedAndOffsuit) {
        generalHandStrings.push(currRank + twoLower + 's');
        generalHandStrings.push(currRank + twoLower + 'o');
      } else {
        generalHandStrings.push(currRank + twoLower + suitedOrOffsuitFromTextSegment);
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromSpacedAscendingTextSegment: function ___getSpecificHandStringsFromSpacedAscendingTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var lowRankFromTextSegment = textSegment[1];
    var suitedAndOffsuit = textSegment.length === 3;
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var oneLowerThanHighRankFromTextSegment = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(highRankFromTextSegment);
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(oneLowerThanHighRankFromTextSegment, lowRankFromTextSegment, function (currRank) {
      if (suitedAndOffsuit) {
        generalHandStrings.push(highRankFromTextSegment + currRank + 's');
        generalHandStrings.push(highRankFromTextSegment + currRank + 'o');
      } else {
        generalHandStrings.push(highRankFromTextSegment + currRank + suitedOrOffsuitFromTextSegment);
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  __getSpecificHandStringsFromDescendingTextSegment: function __getSpecificHandStringsFromDescendingTextSegment(textSegment) {
    var gapperType = this.___getGapperType(textSegment);
    var pocketPair = textSegment[0] === textSegment[1];

    if (pocketPair) {
      return this.___getSpecificHandStringsFromDescendingPocketPairTextSegment(textSegment);
    } else if (gapperType === 'connector') {
      return this.___getSpecificHandStringsFromDescendingConnectorTextSegment(textSegment);
    } else if (gapperType === 'one gapper') {
      return this.___getSpecificHandStringsFromDescendingOneGapperTextSegment(textSegment);
    } else if (gapperType === 'spaced') {
      return this.___getSpecificHandStringsFromSpacedDescendingTextSegment(textSegment);
    } else {
      throw new Error('Problem getting gapper type.');
    }
  },
  ___getSpecificHandStringsFromDescendingPocketPairTextSegment: function ___getSpecificHandStringsFromDescendingPocketPairTextSegment(textSegment) {
    var rank = textSegment[0];
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(rank, '2', function (currRank) {
      generalHandStrings.push(currRank + currRank);
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromDescendingConnectorTextSegment: function ___getSpecificHandStringsFromDescendingConnectorTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var suitedAndOffsuit = textSegment.length === 3;
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var oneLower = void 0;
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(highRankFromTextSegment, '3', function (currRank) {
      oneLower = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(currRank);

      if (suitedAndOffsuit) {
        generalHandStrings.push(currRank + oneLower + 's');
        generalHandStrings.push(currRank + oneLower + 'o');
      } else {
        generalHandStrings.push(currRank + oneLower + suitedOrOffsuitFromTextSegment);
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromDescendingOneGapperTextSegment: function ___getSpecificHandStringsFromDescendingOneGapperTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var suitedAndOffsuit = textSegment.length === 3;
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var twoLower = void 0;
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(highRankFromTextSegment, '4', function (currRank) {
      twoLower = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(currRank, 2);

      if (suitedAndOffsuit) {
        generalHandStrings.push(currRank + twoLower + 's');
        generalHandStrings.push(currRank + twoLower + 'o');
      } else {
        generalHandStrings.push(currRank + twoLower + suitedOrOffsuitFromTextSegment);
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromSpacedDescendingTextSegment: function ___getSpecificHandStringsFromSpacedDescendingTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var lowRankFromTextSegment = textSegment[1];
    var suitedAndOffsuit = textSegment.length === 3;
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(lowRankFromTextSegment, '2', function (currRank) {
      if (suitedAndOffsuit) {
        generalHandStrings.push(highRankFromTextSegment + currRank + 's');
        generalHandStrings.push(highRankFromTextSegment + currRank + 'o');
      } else {
        generalHandStrings.push(highRankFromTextSegment + currRank + suitedOrOffsuitFromTextSegment);
      }
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  __getSpecificHandStringsFromRangeTextSegment: function __getSpecificHandStringsFromRangeTextSegment(textSegment) {
    var gapperType = this.___getGapperType(textSegment);
    var pocketPair = textSegment[0] === textSegment[1];

    if (pocketPair) {
      return this.___getSpecificHandStringsFromPocketPairRangeTextSegment(textSegment);
    } else if (gapperType === 'connector') {
      return this.___getSpecificHandStringsFromConnectorRangeTextSegment(textSegment);
    } else if (gapperType === 'one gapper') {
      return this.___getSpecificHandStringsFromOneGapperRangeTextSegment(textSegment);
    } else if (gapperType === 'spaced') {
      return this.___getSpecificHandStringsFromSpacedRangeTextSegment(textSegment);
    } else {
      throw new Error('Problem getting gapper type.');
    }
  },
  ___getSpecificHandStringsFromPocketPairRangeTextSegment: function ___getSpecificHandStringsFromPocketPairRangeTextSegment(textSegment) {
    var highRank = textSegment[0];
    var lowRank = textSegment[3];
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(highRank, lowRank, function (currRank) {
      generalHandStrings.push(currRank + currRank);
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromConnectorRangeTextSegment: function ___getSpecificHandStringsFromConnectorRangeTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var lowRankFromTextSegment = textSegment[4];
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var oneLower = void 0;
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(highRankFromTextSegment, lowRankFromTextSegment, function (currRank) {
      oneLower = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(currRank);
      generalHandStrings.push(currRank + oneLower + suitedOrOffsuitFromTextSegment);
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromOneGapperRangeTextSegment: function ___getSpecificHandStringsFromOneGapperRangeTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var lowRankFromTextSegment = textSegment[4];
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var twoLower = void 0;
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(highRankFromTextSegment, lowRankFromTextSegment, function (currRank) {
      twoLower = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.getRankNUnitsLower(currRank, 2);
      generalHandStrings.push(currRank + twoLower + suitedOrOffsuitFromTextSegment);
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  ___getSpecificHandStringsFromSpacedRangeTextSegment: function ___getSpecificHandStringsFromSpacedRangeTextSegment(textSegment) {
    var highRankFromTextSegment = textSegment[0];
    var highLowRankFromTextSegment = textSegment[1];
    var lowLowRankFromTextSegment = textSegment[5];
    var suitedOrOffsuitFromTextSegment = textSegment[2];
    var generalHandStrings = [];

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].ranks.forEachRank(highLowRankFromTextSegment, lowLowRankFromTextSegment, function (currRank) {
      generalHandStrings.push(highRankFromTextSegment + currRank + suitedOrOffsuitFromTextSegment);
    });

    return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getSpecificHandStringsFromGeneralHandStrings(generalHandStrings);
  },
  __getSpecificHandStringsFromGeneralHandTextSegment: function __getSpecificHandStringsFromGeneralHandTextSegment(textSegment) {
    var pocketPair = textSegment.length === 2 && textSegment[0] === textSegment[1];

    if (pocketPair || textSegment.length === 3) {
      return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getAllSpecificHandStringsFromGeneralHandString(textSegment);
    } else if (textSegment.length === 2) {
      return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getAllSpecificHandStringsFromGeneralHandString(textSegment + 's');
      return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].hands.getAllSpecificHandStringsFromGeneralHandString(textSegment + 'o');
    }
  }
});

/***/ }),

/***/ "a9ya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_header__ = __webpack_require__("y8dE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_hand_range_grid_selector_grid_selector__ = __webpack_require__("G1lD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hand_range_slider_selector_slider_selector__ = __webpack_require__("OjzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hand_range_text_selector_text_selector__ = __webpack_require__("lMB+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_hand_range_hand_weight_vertical_set_weight_to_apply_to_added_hands_vertical_set_weight_to_apply_to_added_hands__ = __webpack_require__("zc1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_hand_range_hand_weight_horizontal_set_weight_to_apply_to_added_hands_basic__ = __webpack_require__("rIA0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_hand_range_tier_selector__ = __webpack_require__("o2lI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_hand_range_category_selector__ = __webpack_require__("H9xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_hand_range_saved_ranges_selector__ = __webpack_require__("TMYU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hand-range',
  components: {
    'hand-range-header': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_header__["a" /* default */],
    'grid-selector': __WEBPACK_IMPORTED_MODULE_1__components_hand_range_grid_selector_grid_selector__["a" /* default */],
    'slider-selector': __WEBPACK_IMPORTED_MODULE_2__components_hand_range_slider_selector_slider_selector__["a" /* default */],
    'text-selector': __WEBPACK_IMPORTED_MODULE_3__components_hand_range_text_selector_text_selector__["a" /* default */],
    'vertical-set-weight-to-apply-to-added-hands': __WEBPACK_IMPORTED_MODULE_4__components_hand_range_hand_weight_vertical_set_weight_to_apply_to_added_hands_vertical_set_weight_to_apply_to_added_hands__["a" /* default */],
    'horizontal-set-weight-to-apply-to-added-hands-basic': __WEBPACK_IMPORTED_MODULE_5__components_hand_range_hand_weight_horizontal_set_weight_to_apply_to_added_hands_basic__["a" /* default */],
    'tier-selector': __WEBPACK_IMPORTED_MODULE_6__components_hand_range_tier_selector__["a" /* default */],
    'category-selector': __WEBPACK_IMPORTED_MODULE_7__components_hand_range_category_selector__["a" /* default */],
    'saved-ranges-selector': __WEBPACK_IMPORTED_MODULE_8__components_hand_range_saved_ranges_selector__["a" /* default */]
  },
  props: ['generalHands', 'weightToApplyToAddedHands', 'combosToAdd', 'disableAllSelectors', 'disableAllButGridSelector', 'canBeRemoved', 'specificHandsNotAllowed'],
  data: function data() {
    return {
      activeTab: 'saved-ranges' // or 'tiers', or 'categories'
    };
  },
  computed: {
    includedSelectors: function includedSelectors() {
      return this.$store.state.account.user.settings.general.includedSelectors;
    },
    settingHandWeightsSetting: function settingHandWeightsSetting() {
      return this.$store.state.account.user.settings.general.visual.settingHandWeights;
    }
  },
  mounted: function mounted() {
    this.refreshDoubleSlider();
    this.refreshVerticalSetWeightToApplyToAddedHandsSlider();
    this.refreshHorizontalSetWeightToApplyToAddedHandsSlider();
  },
  updated: function updated() {
    this.refreshDoubleSlider();
    this.refreshVerticalSetWeightToApplyToAddedHandsSlider();
    this.refreshHorizontalSetWeightToApplyToAddedHandsSlider();
  },
  methods: {
    emitAndResetDoubleSlider: function emitAndResetDoubleSlider(eventName, arg1) {
      this.$emit(eventName, arg1);
      this.resetDoubleSlider();
    },
    resetDoubleSlider: function resetDoubleSlider() {
      this.$refs.sliderSelector.resetDoubleSlider();
    },
    refreshDoubleSlider: function refreshDoubleSlider() {
      this.$refs.sliderSelector.refreshDoubleSlider();
    },
    refreshVerticalSetWeightToApplyToAddedHandsSlider: function refreshVerticalSetWeightToApplyToAddedHandsSlider() {
      if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings') {
        this.$refs.verticalSetWeightToApplyToAddedHandsSlider.refreshVueSlider();
      }
    },
    refreshHorizontalSetWeightToApplyToAddedHandsSlider: function refreshHorizontalSetWeightToApplyToAddedHandsSlider() {
      if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings') {
        this.$refs.horizontalSetWeightToApplyToAddedHandsSlider.refreshVueSlider();
      }
    }
  }
});

/***/ }),

/***/ "aBsY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"short-deck-hit-calculator"},[_c('div',{staticClass:"simulation-progress"}),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h4',[_vm._v("How many opponents are you facing?")]),_vm._v(" "),_c('num-opponents-selector',{attrs:{"numOpponents":_vm.state.players.numPlayers,"authorized":_vm.authorized},on:{"addOpponent":function($event){return _vm.addPlayer()},"removeOpponent":function($event){return _vm.removePlayer()}}}),_vm._v(" "),_c('h4',[_vm._v("What are your hole cards?")]),_vm._v(" "),_c('short-deck-hole-cards-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setPresetHoleCard":function($event){return _vm.setPresetHoleCard($event)},"removePresetHoleCard":function($event){return _vm.removePresetHoleCard($event)}}}),_vm._v(" "),_c('h4',[_vm._v("What are the board cards?")]),_vm._v(" "),_c('short-deck-preset-community-cards-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)}}}),_vm._v(" "),_c('h3',[_vm._v("Preflop")]),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('short-deck-range-for-street',{key:("preflop-" + (player.id)),ref:("preflop-" + playerIndex),refInFor:true,attrs:{"player":player,"playerIndex":playerIndex,"playerStateIndex":0,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"storeModuleName":'shortDeckHitCalculator',"authorized":_vm.authorized}},[(_vm.ableToGetPreflopEquities())?_c('section',{staticClass:"equity-results-container",attrs:{"slot":"left-header"},slot:"left-header"},[_c('equity-results',{attrs:{"equity":player.states[0].equity,"equityString":player.states[0].equityString,"winPercentageString":player.states[0].winPercentageString,"tiePercentageString":player.states[0].tiePercentageString,"hasSimulationBeenRun":_vm.ableToGetPreflopEquities()}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This shows the equity that this range has against the selected hole cards in step two, and against any other preflop ranges if you're facing multiple opponents.","data-toggle":"tooltip","data-placement":"top"}})],1):_vm._e()])}),_vm._v(" "),_c('h3',[_vm._v("Flop")]),_vm._v(" "),_c('short-deck-flop-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)}}}),_vm._v(" "),(_vm.state.players.numPlayers > 1)?_c('cumulative-hit-percentages',{attrs:{"cumulativeHitPercentages":_vm.cumulativeHitPercentages,"moreThanTwoPlayers":_vm.state.players.numPlayers > 2,"streetsToDisplay":['flop']}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('short-deck-range-for-street',{key:("flop-" + (player.id)),ref:("flop-" + playerIndex),refInFor:true,attrs:{"player":player,"playerIndex":playerIndex,"playerStateIndex":1,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(1),"storeModuleName":'shortDeckHitCalculator',"simulateButton":_vm.showNonexhaustiveSimulationButton(playerIndex, 'flop'),"authorized":_vm.authorized},on:{"simulate":function($event){return _vm.runNonexhaustiveFiveCardHandPercentagesSimulationsForFlop(playerIndex)}}},[(_vm.ableToGetFlopEquities())?_c('section',{staticClass:"equity-results-container",attrs:{"slot":"left-header"},slot:"left-header"},[_c('equity-results',{attrs:{"equity":player.states[1].equity,"equityString":player.states[1].equityString,"winPercentageString":player.states[1].winPercentageString,"tiePercentageString":player.states[1].tiePercentageString,"hasSimulationBeenRun":_vm.ableToGetFlopEquities()}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This shows the equity that this range has against the selected hole cards in step two, and against any other flop ranges if you're facing multiple opponents. It assumes that the flop will always be what you have it set as, but that the turn and river will be dealt randomly.","data-toggle":"tooltip","data-placement":"top"}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.numSet <= 3)?_c('hit-calculator-insights',{attrs:{"slot":"insights","hitPercentage":player.states[1].hitPercentage,"hitPercentageUpToDate":_vm.isHitPercentageUpToDate[playerIndex][0]},slot:"insights"}):_vm._e()],1)}),_vm._v(" "),_c('h3',[_vm._v("Turn")]),_vm._v(" "),_c('short-deck-turn-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)}}}),_vm._v(" "),(_vm.state.players.numPlayers > 1)?_c('cumulative-hit-percentages',{attrs:{"cumulativeHitPercentages":_vm.cumulativeHitPercentages,"moreThanTwoPlayers":_vm.state.players.numPlayers > 2,"streetsToDisplay":['turn']}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('short-deck-range-for-street',{key:("turn-" + (player.id)),ref:("turn-" + playerIndex),refInFor:true,attrs:{"player":player,"playerIndex":playerIndex,"playerStateIndex":2,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(2),"storeModuleName":'shortDeckHitCalculator',"simulateButton":_vm.showNonexhaustiveSimulationButton(playerIndex, 'turn'),"authorized":_vm.authorized},on:{"simulate":function($event){return _vm.runNonexhaustiveFiveCardHandPercentagesSimulationsForTurn(playerIndex)}}},[(_vm.ableToGetTurnEquities())?_c('section',{staticClass:"equity-results-container",attrs:{"slot":"left-header"},slot:"left-header"},[_c('equity-results',{attrs:{"equity":player.states[2].equity,"equityString":player.states[2].equityString,"winPercentageString":player.states[2].winPercentageString,"tiePercentageString":player.states[2].tiePercentageString,"hasSimulationBeenRun":_vm.ableToGetTurnEquities()}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This shows the equity that this range has against the selected hole cards in step two, and against any other turn ranges if you're facing multiple opponents. It assumes that the turn will always be what you have it set as, but that the river will be dealt randomly.","data-toggle":"tooltip","data-placement":"top"}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.numSet === 4)?_c('hit-calculator-insights',{attrs:{"slot":"insights","hitPercentage":player.states[2].hitPercentage,"hitPercentageUpToDate":_vm.isHitPercentageUpToDate[playerIndex][1]},slot:"insights"}):_vm._e()],1)}),_vm._v(" "),_c('h3',[_vm._v("River")]),_vm._v(" "),_c('short-deck-river-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)}}}),_vm._v(" "),(_vm.state.players.numPlayers > 1)?_c('cumulative-hit-percentages',{attrs:{"cumulativeHitPercentages":_vm.cumulativeHitPercentages,"moreThanTwoPlayers":_vm.state.players.numPlayers > 2,"streetsToDisplay":['river']}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('short-deck-range-for-street',{key:("river-" + (player.id)),ref:("river-" + playerIndex),refInFor:true,attrs:{"player":player,"playerIndex":playerIndex,"playerStateIndex":3,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(3),"storeModuleName":'shortDeckHitCalculator',"simulateButton":_vm.showNonexhaustiveSimulationButton(playerIndex, 'river'),"authorized":_vm.authorized},on:{"simulate":function($event){return _vm.runNonexhaustiveFiveCardHandPercentagesSimulationsForRiver(playerIndex)}}},[(_vm.ableToGetRiverEquities())?_c('section',{staticClass:"equity-results-container",attrs:{"slot":"left-header"},slot:"left-header"},[_c('equity-results',{attrs:{"equity":player.states[3].equity,"equityString":player.states[3].equityString,"winPercentageString":player.states[3].winPercentageString,"tiePercentageString":player.states[3].tiePercentageString,"hasSimulationBeenRun":_vm.ableToGetRiverEquities()}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This shows the equity that this range has against the selected hole cards in step two, and against any other river ranges if you're facing multiple opponents.","data-toggle":"tooltip","data-placement":"top"}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.numSet === 5)?_c('hit-calculator-insights',{attrs:{"slot":"insights","hitPercentage":player.states[3].hitPercentage,"hitPercentageUpToDate":_vm.isHitPercentageUpToDate[playerIndex][2]},slot:"insights"}):_vm._e()],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.createSharableUrl()}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized},on:{"saveScenario":function($event){return _vm.expandSaveScenarioModal()},"updateScenario":function($event){return _vm.updateScenario()}}}),_vm._v(" "),_c('sharable-url-modal',{attrs:{"url":_vm.sharableUrl.url,"approximateWaitTime":_vm.sharableUrl.approximateWaitTime}}),_vm._v(" "),_c('save-scenario-modal',{on:{"save":function($event){return _vm.saveScenario($event)}}}),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"hit calculator","urlPath":"short-deck-hit-calculator"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Hit calculator")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aJ+Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"blog-post-link"},[_c('router-link',{attrs:{"to":_vm.path}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.date))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aLd2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"set-range-step"},[_c('h4',[_vm._v("\n    "+_vm._s(_vm.textForStep)+"\n    "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible},on:{"toggleHelp":function($event){return _vm.toggleHelp()}}})],1),_vm._v(" "),(_vm.helpAreaVisible)?_vm._t("rangeHelpSection"):_vm._e(),_vm._v(" "),_vm._t("boardCardsSelector"),_vm._v(" "),_c('range-for-street',{attrs:{"player":_vm.player,"playerIndex":_vm.playerIndex,"playerStateIndex":_vm.playerStateIndex,"presetCommunityCards":_vm.presetCommunityCards,"presetHoleCards":_vm.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"storeModuleName":_vm.storeModuleName,"authorized":_vm.authorized}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aaFb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ack5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('h3',[_vm._v("Email")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h3',[_vm._v("Live chat")]),_vm._v(" "),_c('p',[_vm._v("If the icon on the bottom right of this page says \"Hello\", you can click it to start a live chat.")]),_vm._v(" "),_c('h3',[_vm._v("Skype/phone")]),_vm._v(" "),_c('p',[_vm._v("I'd be more than happy to Skype or talk on the phone. Just shoot me an email and we'll set up a call.")]),_vm._v(" "),_c('h3',[_vm._v("In person")]),_vm._v(" "),_c('p',[_vm._v("I'd also be more than happy to meet up in person. I live in Vegas so if you live here or are in town, shoot me an email and we'll set up a time to hang out.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"well"},[_c('h3',[_vm._v("I really do want to hear from you!")]),_vm._v(" "),_c('p',[_vm._v("I know that's something that everyone says, but few actually mean. I know that as a consumer you've been trained to think \"they're probably just saying that\". But I really do mean it. I promise.")]),_vm._v(" "),_c('p',[_vm._v("I talk about my reasons a little more "),_c('router-link',{attrs:{"to":"/faq#general-2EWuS"}},[_vm._v("in this FAQ question")]),_vm._v(", but this about sums it up:")],1),_vm._v(" "),_c('tweet',{attrs:{"id":"898476047263518720"}}),_vm._v(" "),_c('p',[_vm._v("I also list out some good reasons to reach out "),_c('router-link',{attrs:{"to":"/faq#general-G9yAY"}},[_vm._v("in a different FAQ question")]),_vm._v(".")],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Contact")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "acpR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_purchase_vue__ = __webpack_require__("Ln84");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ace75e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_purchase_vue__ = __webpack_require__("I7Vb");
function injectStyle (ssrContext) {
  __webpack_require__("B/JW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27ace75e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_purchase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27ace75e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_purchase_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "alaU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_river_selector_vue__ = __webpack_require__("BCbh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83c28e62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_river_selector_vue__ = __webpack_require__("Plqr");
function injectStyle (ssrContext) {
  __webpack_require__("qEkd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-83c28e62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_river_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83c28e62_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_river_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aoFU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "argk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_graph_vue__ = __webpack_require__("qWvV");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("B6WE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db8b94a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_graph_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "auGP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well should-you-bluff-initial-conclusion"},[_c('section',[_c('div',{staticClass:"page-header"},[(_vm.streetToBluff !== 'river')?_c('h1',[_vm._v("Initial analysis")]):_vm._e(),_vm._v(" "),(_vm.streetToBluff === 'river')?_c('h1',[_vm._v("Analysis")]):_vm._e()]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Fold equity")]),_vm._v(" "),_c('th',[_vm._v("Break even percentage for "+_vm._s(_vm.bluffSize)+" pot bluff")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.foldEquity)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.immediatelyProfitableBreakevenPercentage)+"%")])])])]),_vm._v(" "),_c('section',{staticClass:"alert",class:{ 'alert-success': _vm.isBluffImmediatelyProfitable, 'alert-danger': !_vm.isBluffImmediatelyProfitable }},[_c('p',[_vm._v("Your "+_vm._s(_vm.bluffSize)+" pot bluff "),_c('em',[_vm._v("will "),(!_vm.isBluffImmediatelyProfitable)?_c('span',[_vm._v("not")]):_vm._e()]),_vm._v(" be "),(_vm.streetToBluff !== 'river')?_c('span',[_vm._v("immediately ")]):_vm._e(),_vm._v("profitable "),(_vm.isBluffImmediatelyProfitable)?_c('span',[_vm._v("✅")]):_c('span',[_vm._v("❌")])])]),_vm._v("\n    Reasoning:\n    "),(_vm.numPlayers === 1)?_c('ul',[_c('li',[_vm._v("\n        A "+_vm._s(_vm.bluffSize)+" pot bluff needs to work more than "+_vm._s(_vm.immediatelyProfitableBreakevenPercentage)+"% of the time in order to be "),(_vm.streetToBluff !== 'river')?_c('span',[_vm._v("immediately ")]):_vm._e(),_vm._v("profitable.\n        "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible.reasoning[0]},on:{"toggleHelp":function($event){return _vm.toggleHelp('reasoning', 0)}}}),_vm._v(" "),(_vm.helpAreaVisible.reasoning[0])?_c('reasoning-help-section-1'):_vm._e()],1),_vm._v(" "),_c('li',[_vm._v("\n        According to your assumptions, your opponent will be continuing "+_vm._s(_vm.hitPercentageForStreetToBluff)+"% of the time versus your "+_vm._s(_vm.bluffSize)+" pot "+_vm._s(_vm.streetToBluff)+" bluff.\n        "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible.reasoning[1]},on:{"toggleHelp":function($event){return _vm.toggleHelp('reasoning', 1)}}}),_vm._v(" "),(_vm.helpAreaVisible.reasoning[1])?_c('div',{staticClass:"well help-section"},[_vm._v("\n          This comes from the ranges you set. How many combos did your opponent have entering the "+_vm._s(_vm.streetToBluff)+"? How many of those combos would continue? What weights do those combos have?\n        ")]):_vm._e()],1),_vm._v(" "),_c('li',[_vm._v("\n        Which means that your opponent will be folding "+_vm._s(_vm.foldEquity)+"% of the time.\n        "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible.reasoning[2]},on:{"toggleHelp":function($event){return _vm.toggleHelp('reasoning', 2)}}}),_vm._v(" "),(_vm.helpAreaVisible.reasoning[2])?_c('div',{staticClass:"well help-section"},[_vm._v("\n          Continuing means calling or raising, so if you're not continuing, you're folding.\n        ")]):_vm._e()],1),_vm._v(" "),_c('li',[_vm._v("Which means that your bluff will work "+_vm._s(_vm.foldEquity)+"% of the time.")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.foldEquity)+"% is "),(_vm.isBluffImmediatelyProfitable)?_c('span',[_vm._v("more")]):_c('span',[_vm._v("less")]),_vm._v(" than the "+_vm._s(_vm.immediatelyProfitableBreakevenPercentage)+"% you need in order to be "),(_vm.streetToBluff !== 'river')?_c('span',[_vm._v("immediately ")]):_vm._e(),_vm._v("profitable.")]),_vm._v(" "),_c('li',[_vm._v("Therefore, your "+_vm._s(_vm.bluffSize)+" pot "+_vm._s(_vm.streetToBluff)+" bluff will "),(!_vm.isBluffImmediatelyProfitable)?_c('span',[_vm._v("not ")]):_vm._e(),_vm._v("be "),(_vm.streetToBluff !== 'river')?_c('span',[_vm._v("immediately ")]):_vm._e(),_vm._v("profitable.")])]):_c('ul',[_c('li',[_vm._v("\n        A "+_vm._s(_vm.bluffSize)+" pot bluff needs to work more than "+_vm._s(_vm.immediatelyProfitableBreakevenPercentage)+"% of the time in order to be "),(_vm.streetToBluff !== 'river')?_c('span',[_vm._v("immediately ")]):_vm._e(),_vm._v("profitable.\n        "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible.reasoning[0]},on:{"toggleHelp":function($event){return _vm.toggleHelp('reasoning', 0)}}}),_vm._v(" "),(_vm.helpAreaVisible.reasoning[0])?_c('reasoning-help-section-1'):_vm._e()],1),_vm._v(" "),_c('li',[_vm._v("According to the ranges that you set, your bluff will get "),(_vm.numPlayers === 2)?_c('span',[_vm._v("both")]):_c('span',[_vm._v("all")]),_vm._v(" opponents to fold "+_vm._s(_vm.foldEquity)+"% of the time.")]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.foldEquity)+"% is "),(_vm.isBluffImmediatelyProfitable)?_c('span',[_vm._v("more")]):_c('span',[_vm._v("less")]),_vm._v(" than the "+_vm._s(_vm.immediatelyProfitableBreakevenPercentage)+"% you need in order to be "),(_vm.streetToBluff !== 'river')?_c('span',[_vm._v("immediately ")]):_vm._e(),_vm._v("profitable.")]),_vm._v(" "),_c('li',[_vm._v("Therefore, your "+_vm._s(_vm.bluffSize)+" pot "+_vm._s(_vm.streetToBluff)+" bluff will "),(!_vm.isBluffImmediatelyProfitable)?_c('span',[_vm._v("not ")]):_vm._e(),_vm._v("be "),(_vm.streetToBluff !== 'river')?_c('span',[_vm._v("immediately ")]):_vm._e(),_vm._v("profitable.")])]),_vm._v(" "),(_vm.numPlayers > 1)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.numPlayers > 1)?_c('cumulative-hit-percentages',{attrs:{"cumulativeHitPercentages":_vm.cumulativeHitPercentages,"moreThanTwoPlayers":_vm.numPlayers > 2,"streetsToDisplay":_vm.cumulativeHitPercentagesStreetsToDisplay}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "avLb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group street-selector"},[_c('button',{staticClass:"btn btn-default",class:{ 'active': _vm.street === 'flop' },attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$emit('setStreet', 'flop')}}},[_vm._v("\n    Flop\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'active': _vm.street === 'turn' },attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$emit('setStreet', 'turn')}}},[_vm._v("\n    Turn\n  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ 'active': _vm.street === 'river' },attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$emit('setStreet', 'river')}}},[_vm._v("\n    River\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "b4By":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_leaf_FiveCardHandLeaf__ = __webpack_require__("sJ/U");






var MadeHandLeaf = function (_FiveCardHandLeaf) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MadeHandLeaf, _FiveCardHandLeaf);

  function MadeHandLeaf(argsObj) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MadeHandLeaf);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MadeHandLeaf.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(MadeHandLeaf)).call(this, argsObj));

    _this.madeHandDrawOrCombo = 'made hand';
    return _this;
  }

  return MadeHandLeaf;
}(__WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_leaf_FiveCardHandLeaf__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (MadeHandLeaf);
;

/***/ }),

/***/ "b4c9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "b96B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well should-you-call-long-run-disclaimer"},[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("The long run")])]),_vm._v(" "),_c('p',[_vm._v("Even after factoring in what might happen on future streets, there are still longer run game dynamic type things to consider, such as:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("Calling to gather information about your opponent.")]),_vm._v(" "),_c('li',[_vm._v("Calling to establish a certain table image.")]),_vm._v(" "),_c('li',[_vm._v("Calling to put your opponent on tilt.")])]),_vm._v(" "),_c('p',[_vm._v("Maybe the call is profitable in the long run for one of the reasons listed above, even if it isn't profitable right now.")]),_vm._v(" "),_c('p',[_vm._v("Factoring in these sorts of things is beyond the scope of Six Plus Hold’em right now, but perhaps there will be tools to do so in the future.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bBBi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tweet_embed__ = __webpack_require__("2Fkr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tweet_embed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_tweet_embed__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-contact',
  components: {
    'tweet': __WEBPACK_IMPORTED_MODULE_0_vue_tweet_embed__["Tweet"]
  }
});

/***/ }),

/***/ "bHtG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bIA6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bKmm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bPB9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{staticClass:"sharable-url-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[(!_vm.url)?_c('div',[(_vm.approximateWaitTime)?_c('p',[_vm._v("Creating the sharable URL. This could take "+_vm._s(_vm.approximateWaitTime)+"+ seconds.")]):_c('p',[_vm._v("Creating the sharable URL...")]),_vm._v(" "),(!_vm.url)?_c('img',{attrs:{"src":"/static/loading.svg","width":"100"}}):_vm._e()]):_c('div',[_c('p',[_vm._v("If someone visits this URL, they will see the exact same screen you are seeing. It's nice to be able to send it to friends, or share it in poker forums.")]),_vm._v(" "),_c('p',[_vm._v("If they aren't logged in, they'll be in readonly mode. If they are logged in, they'll be able to use the tool in exactly the same way you are.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{staticClass:"form-control input-lg",attrs:{"type":"url","autofocus":""},domProps:{"value":_vm.url},on:{"focus":function($event){return $event.target.select()}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bRpf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bjxn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_graph_vue__ = __webpack_require__("WsCG");
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("LkJJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2530d5f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_graph_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bnhV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subscribe_to_blog_vue__ = __webpack_require__("ZaAg");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b71650_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subscribe_to_blog_vue__ = __webpack_require__("bsM6");
function injectStyle (ssrContext) {
  __webpack_require__("tQk4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58b71650"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_subscribe_to_blog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58b71650_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_subscribe_to_blog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bsM6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"alert alert-info"},[_c('a',{attrs:{"href":"https://mailchi.mp/1e660cfec101/premium-poker-tools"}},[_vm._v("Subscribe")]),_vm._v(" to be emailed new posts."),_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bwZm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bwvA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__ = __webpack_require__("1uLK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba60647_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__("Mdrr");
function injectStyle (ssrContext) {
  __webpack_require__("/3LZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ba60647"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ba60647_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "c+Lz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_parent_FiveCardHandParent__ = __webpack_require__("Y/UK");






var DrawParent = function (_FiveCardHandParent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DrawParent, _FiveCardHandParent);

  function DrawParent(argsObj) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DrawParent);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DrawParent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DrawParent)).call(this, argsObj));
  }

  return DrawParent;
}(__WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_parent_FiveCardHandParent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (DrawParent);
;

/***/ }),

/***/ "c/qk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_random_board_selector_vue__ = __webpack_require__("HnmA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_637c1190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_random_board_selector_vue__ = __webpack_require__("9ZDO");
function injectStyle (ssrContext) {
  __webpack_require__("e36m")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-637c1190"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_random_board_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_637c1190_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_random_board_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cBZj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insights_vue__ = __webpack_require__("WwOJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da4fcf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insights_vue__ = __webpack_require__("kB5U");
function injectStyle (ssrContext) {
  __webpack_require__("v+YH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5da4fcf8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_insights_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5da4fcf8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_insights_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cEmC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-future-streets-help-section-1'
});

/***/ }),

/***/ "cNwD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cumulative_hit_percentages_vue__ = __webpack_require__("2QjM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05dfe336_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cumulative_hit_percentages_vue__ = __webpack_require__("KxC5");
function injectStyle (ssrContext) {
  __webpack_require__("Wdtl")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05dfe336"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cumulative_hit_percentages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05dfe336_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_cumulative_hit_percentages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cOfr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hand_range_vue__ = __webpack_require__("a9ya");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d8379ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hand_range_vue__ = __webpack_require__("8Wfc");
function injectStyle (ssrContext) {
  __webpack_require__("flqx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d8379ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hand_range_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d8379ef_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hand_range_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cOmL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toggle-help-button',
  props: ['helpAreaVisible']
});

/***/ }),

/***/ "cQ7x":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cRPJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cW5A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_river_selector__ = __webpack_require__("alaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_pot_odds_selector__ = __webpack_require__("a398");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_call_conclusions_betting_criteria_table__ = __webpack_require__("E+KM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__ = __webpack_require__("unvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_call_help_range__ = __webpack_require__("9sL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-river-steps',
  components: {
    'river-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_river_selector__["a" /* default */],
    'pot-odds-selector': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_pot_odds_selector__["a" /* default */],
    'betting-criteria-table': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_call_conclusions_betting_criteria_table__["a" /* default */],
    'set-range-step': __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__["a" /* default */],
    'range-help-section': __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_call_help_range__["a" /* default */]
  },
  props: ['state', 'textWhenFiveCardHandPercentagesArentUpToDate', 'authorized'],
  methods: {
    getTextForPlayerRangeStep: function getTextForPlayerRangeStep(playerIndex) {
      var numOpponents = this.state.players.numPlayers;

      if (numOpponents === 1) {
        return 'Step ' + (8 + numOpponents * 3 + playerIndex) + ': What do you think your opponent would bet the river with?';
      } else {
        return 'Step ' + (8 + numOpponents * 3 + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is as you face the river bet?';
      }
    }
  }
});

/***/ }),

/***/ "ce18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-footer',
  computed: {
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    }
  }
});

/***/ }),

/***/ "crMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'readonly-alert'
});

/***/ }),

/***/ "cxwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preflop_steps_vue__ = __webpack_require__("tfks");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9079e18e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preflop_steps_vue__ = __webpack_require__("1e3e");
function injectStyle (ssrContext) {
  __webpack_require__("/XeG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9079e18e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preflop_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9079e18e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preflop_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cyqG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_percentages_or_combos_vue__ = __webpack_require__("4mCb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d6d4f3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_percentages_or_combos_vue__ = __webpack_require__("u45b");
function injectStyle (ssrContext) {
  __webpack_require__("B9N6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8d6d4f3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_percentages_or_combos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8d6d4f3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_percentages_or_combos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d+yY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flop_selector_vue__ = __webpack_require__("unE3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af779e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flop_selector_vue__ = __webpack_require__("kBHf");
function injectStyle (ssrContext) {
  __webpack_require__("k1LJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4af779e7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flop_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4af779e7_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flop_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d/vm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_square_suits_vue__ = __webpack_require__("1q6q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3facfb40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_square_suits_vue__ = __webpack_require__("sdxh");
function injectStyle (ssrContext) {
  __webpack_require__("1AmU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3facfb40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_square_suits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3facfb40_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_square_suits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d4d/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hit-calculator-checkboxes-checked-by-default-settings settings"},[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Hit calculator checkboxes checked by default")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dBV+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flop_steps_vue__ = __webpack_require__("UeXH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68e934d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flop_steps_vue__ = __webpack_require__("y2Mo");
function injectStyle (ssrContext) {
  __webpack_require__("BH2Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68e934d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_flop_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68e934d3_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_flop_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dIRe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tiers_vue__ = __webpack_require__("4/gO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e178a16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tiers_vue__ = __webpack_require__("O+62");
function injectStyle (ssrContext) {
  __webpack_require__("IJ53")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e178a16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tiers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e178a16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tiers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dVkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_should_you_call_vue__ = __webpack_require__("jzf5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bba9917_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_should_you_call_vue__ = __webpack_require__("lxmf");
function injectStyle (ssrContext) {
  __webpack_require__("Yt9I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bba9917"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_should_you_call_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bba9917_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_should_you_call_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dY5y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upgrade_vue__ = __webpack_require__("25wl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe4384e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upgrade_vue__ = __webpack_require__("Ryr6");
function injectStyle (ssrContext) {
  __webpack_require__("z7HJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fe4384e8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upgrade_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe4384e8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upgrade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "db5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hit-calculator-checkboxes-filters-settings settings"},[_vm._m(0),_vm._v(" "),(_vm.userDefinedFilters.length === 0)?_c('p',[_vm._v("No user defined filters.")]):_c('section',_vm._l((_vm.userDefinedFilters),function(filter,index){return _c('section',{key:'filter-' + index,staticClass:"filter-container"},[_c('p',[_vm._v("\n        Filter name: "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(filter.name),expression:"filter.name"}],domProps:{"value":(filter.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(filter, "name", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove",on:{"click":function($event){return _vm.removeFilter(index)}}})]),_vm._v(" "),_c('five-card-hands-section',{attrs:{"playerState":{
          fiveCardHands: filter.fiveCardHands,
          name: 'afterFlop',
          hasSimulationBeenRun: true,
          generalHands: {
            numberOfPossibleSpecificHands: 1326,
          },
        },"hideHeader":true,"showPercentagesOrCombos":false,"hideRightContainer":true},on:{"setCheckedValueOfFiveCardHand":function($event){return _vm.setCheckedValueOfFiveCardHand(filter.fiveCardHands, $event)},"toggleCollapsedValueOfFiveCardHandParent":function($event){return _vm.toggleCollapsedValueOfFiveCardHandParent($event)}}})],1)}),0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){return _vm.addFilter()}}},[_vm._v("\n      Add filter\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("\n      Save\n    ")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_vm._m(1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Hit calculator checkboxes filters")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/TVFelYdHtBw?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dd8B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{attrs:{"id":"text-selector-help-modal"}},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal"}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("Text Selector Rules")])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Correct")]),_vm._v(" "),_c('th',[_vm._v("Incorrect")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("AA, 44, 76s, KJo")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("AA,44,76s,KJo (don't need spaces between commas)")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("44, KJo, 76s, AA (order doesn't matter)")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("kk, t7s, kqo (case insensitive)")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("AhKh (specific suits)")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("TT")]),_vm._v(" "),_c('td',[_vm._v("1010")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("76s")]),_vm._v(" "),_c('td',[_vm._v("67s")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("AK (shortcut for AKs, AKo)")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("JJ+ (shortcut for JJ, QQ, KK, AA)")]),_vm._v(" "),_c('td',[_vm._v("AA+ (can't go any higher than ace)")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("JJ, QQ, KK, AA (shortcuts aren't required)")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("44- (shortcut for 44, 33, 22)")]),_vm._v(" "),_c('td',[_vm._v("22- (can't go any lower than two)")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("K8s+ (shortcut for K8s, K9s, KTs, KJs, KQs)")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("98s+ (shortcut for 98s, T9s, JTs, QJs, KQs, AKs)")]),_vm._v(" "),_c('td',[_vm._v("AKs+ (can't go any higher)")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("97s+ (shortcut for 97s, T8s, J9s, QTs, KJs, AQs)")]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("99-55")]),_vm._v(" "),_c('td',[_vm._v("KJs-K7o, KJs-87s")])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_vm._v("55-99, K7s-KJs")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "diNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"three-bet-cbet-explorer-table well"},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Continue vs. 3bet")]),_vm._v(" "),_c('td',{attrs:{"data-title":"This is based on what you have selected in the hand matrixes below.","data-toggle":"tooltip","data-placement":"bottom","data-container":"body"}},[_c('em',[_vm._v(_vm._s(_vm.selectedContinueVs3betPercentage)+"%")])]),_vm._v(" "),_c('td',[_vm._v("0%")]),_vm._v(" "),_c('td',[_vm._v("20%")]),_vm._v(" "),_c('td',[_vm._v("40%")]),_vm._v(" "),_c('td',[_vm._v("60%")]),_vm._v(" "),_c('td',[_vm._v("80%")]),_vm._v(" "),_c('td',[_vm._v("100%")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('th',[_vm._v("EV")]),_vm._v(" "),_c('td',{class:_vm.getColorClass(_vm.evForSelected),attrs:{"data-title":"This is based on what you have selected in the hand matrixes below.","data-toggle":"tooltip","data-placement":"bottom","data-container":"body"}},[_c('em',[_vm._v(_vm._s(_vm.getEVDisplayText(_vm.evForSelected)))])]),_vm._v(" "),_c('td',{class:_vm.getColorClass(_vm.evForZeroPercent)},[_vm._v(_vm._s(_vm.getEVDisplayText(_vm.evForZeroPercent)))]),_vm._v(" "),_c('td',{class:_vm.getColorClass(_vm.evForTwentyPercent)},[_vm._v(_vm._s(_vm.getEVDisplayText(_vm.evForTwentyPercent)))]),_vm._v(" "),_c('td',{class:_vm.getColorClass(_vm.evForFourtyPercent)},[_vm._v(_vm._s(_vm.getEVDisplayText(_vm.evForFourtyPercent)))]),_vm._v(" "),_c('td',{class:_vm.getColorClass(_vm.evForSixtyPercent)},[_vm._v(_vm._s(_vm.getEVDisplayText(_vm.evForSixtyPercent)))]),_vm._v(" "),_c('td',{class:_vm.getColorClass(_vm.evForEightyPercent)},[_vm._v(_vm._s(_vm.getEVDisplayText(_vm.evForEightyPercent)))]),_vm._v(" "),_c('td',{class:_vm.getColorClass(_vm.evForOneHundredPercent)},[_vm._v(_vm._s(_vm.getEVDisplayText(_vm.evForOneHundredPercent)))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dsZ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__ = __webpack_require__("Ywgb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'change-password',
  components: {
    'errors-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__["a" /* default */]
  },
  data: function data() {
    return {
      oldPassword: '',
      newPassword: '',
      xkcdVisible: false,
      submitAttempted: false,
      errorsFromBackend: []
    };
  },
  computed: {
    anyErrors: function anyErrors() {
      return !!(this.oldPasswordErrorMessage || this.newPasswordErrorMessage);
    },
    oldPasswordErrorMessage: function oldPasswordErrorMessage() {
      if (this.oldPassword === '') {
        return 'A password is required';
      } else {
        return false;
      }
    },
    newPasswordErrorMessage: function newPasswordErrorMessage() {
      if (this.newPassword === '') {
        return 'A password is required';
      } else if (this.newPassword.length < 8) {
        return 'Must be at least eight characters';
      } else {
        return false;
      }
    }
  },
  methods: {
    changePassword: function changePassword() {
      var self = this;

      if (self.anyErrors) {
        self.submitAttempted = true;
        return;
      }

      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/change-password', {
        oldPassword: self.oldPassword,
        newPassword: self.newPassword
      }).then(function (res) {
        self.$router.push({ path: '/' });
        alert('Successfully changed password.');
        localStorage.setItem('changedPasswordDate', new Date());
      }).catch(function (err) {
        self.errorsFromBackend.splice(0, self.errorsFromBackend.length);
        err.response.data.errors.forEach(function (errorFromBackend) {
          self.errorsFromBackend.push(errorFromBackend);
        });
      });
    },
    clearAlert: function clearAlert() {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    }
  }
});

/***/ }),

/***/ "e27S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'simulate-button',
  props: ['disabled'],
  computed: {
    tooltipValue: function tooltipValue() {
      // if (this.disabled) {
      //   return 'Disabled.';
      // }

      return ''; // disables the tooltip
    }
  },
  mounted: function mounted() {
    if (true) {
      $(this.$el).tooltip();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "e36m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e63H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e91s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eDaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-range-help-section',
  props: ['playerStateIndex', 'streetToCall']
});

/***/ }),

/***/ "eJiv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_table_vue__ = __webpack_require__("iw9m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3711718a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breakeven_percentage_for_bluffing_the_turn_table_vue__ = __webpack_require__("Qiug");
function injectStyle (ssrContext) {
  __webpack_require__("u2Mx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3711718a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3711718a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breakeven_percentage_for_bluffing_the_turn_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eSp8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',[_vm._v("Initial bet size:")]),_vm._v(" "),_c('section',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",class:{ active: _vm.initialBetSize === '1/2 pot' },on:{"click":function($event){return _vm.$emit('setInitialBetSize', '1/2 pot')}}},[_vm._v("\n      1/2 pot\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ active: _vm.initialBetSize === '3/4 pot' },on:{"click":function($event){return _vm.$emit('setInitialBetSize', '3/4 pot')}}},[_vm._v("\n      3/4 pot\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ active: _vm.initialBetSize === 'Full pot' },on:{"click":function($event){return _vm.$emit('setInitialBetSize', 'Full pot')}}},[_vm._v("\n      Full pot\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "eThn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eVwm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-sharable-url-button',
  props: ['overrideText', 'disabled'],
  computed: {
    text: function text() {
      if (this.overrideText) {
        return this.overrideText;
      }

      return 'Create sharable URL';
    },
    tooltipValue: function tooltipValue() {
      // if (this.disabled) {
      //   return 'Disabled.';
      // }
      //
      return ''; // disables the tooltip
    }
  },
  mounted: function mounted() {
    if (true) {
      $(this.$el).tooltip();
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "ebo7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ejqY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'saved-ranges-selector',
  props: ['generalHands', 'disabled'],
  data: function data() {
    var savedRanges = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.$store.state.account.user.settings.general.savedRanges);

    __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.forEachNode(savedRanges, function (node, indexes) {
      node.level = indexes.length - 1;
      node.indexes = indexes;
      node.checked = false;

      if (node.children) {
        node.collapsed = true;
      }
    });

    return {
      savedRanges: savedRanges
    };
  },
  computed: {
    visibleSavedRanges: function visibleSavedRanges() {
      var visibleSavedRanges = [];

      this.forEachVisibleNode(this.savedRanges, function (node, indexes) {
        node.id = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.uniqueId();
        visibleSavedRanges.push(node);
      });

      return visibleSavedRanges;
    },
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    }
  },
  created: function created() {
    this.expandFirstVisibleNode();
  },
  methods: {
    forEachVisibleNode: function forEachVisibleNode(arr, callback, indexesList) {
      indexesList = indexesList || [];

      arr.forEach(function (el, i) {
        var newIndexesList = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(indexesList);
        newIndexesList.push(i);
        callback(el, newIndexesList);

        if (el.children && !el.collapsed) {
          this.forEachVisibleNode(el.children, callback, newIndexesList);
        }
      }, this);
    },
    doesRangeExactlyEqualSavedRange: function doesRangeExactlyEqualSavedRange(savedRange) {
      var handStringsFromSavedRange = savedRange.handsInRange;
      var handStringsInRange = [];

      this.generalHands.forEach(function (generalHand) {
        if (generalHand.inRange === true) {
          handStringsInRange.push(generalHand.string);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.doArraysContainSameElements(handStringsFromSavedRange, handStringsInRange);
    },
    setRangeToMatchGeneralHands: function setRangeToMatchGeneralHands(savedRange, e) {

      //SHOR-7: More than one radio button shown as selected
      for (var i = 0; i < this.visibleSavedRanges.length; i++) {

        var range = this.visibleSavedRanges[i];

        if (this.visibleSavedRanges[i].id === savedRange.id) {

          range.checked = true;
        } else {
          range.checked = false;
        }
      }
      //SHOR-7


      this.$emit('setRangeToMatchGeneralHands', savedRange.handsInRange);
    },
    toggleCollapse: function toggleCollapse(visibleSavedRange) {
      visibleSavedRange.collapsed = !visibleSavedRange.collapsed;
    },
    expandFirstVisibleNode: function expandFirstVisibleNode() {
      for (var i = 0; i < this.visibleSavedRanges.length; i++) {
        if (this.visibleSavedRanges[i].children) {
          this.visibleSavedRanges[i].collapsed = false;
          break;
        }
      }
    }
  }
});

/***/ }),

/***/ "epxe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eqfO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eweX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'expand-collapse',
  props: ['expanded'],
  computed: {
    classValue: function classValue() {
      if (this.expanded) {
        return 'glyphicon glyphicon-triangle-bottom';
      } else {
        return 'glyphicon glyphicon-triangle-right';
      }
    }
  }
});

/***/ }),

/***/ "f0lb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_hands_GeneralHands__ = __webpack_require__("udlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__ = __webpack_require__("2EOj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_set_specific_hand_info__ = __webpack_require__("XL0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_get_draw_info__ = __webpack_require__("l9ti");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_simulator_simulator__ = __webpack_require__("pihl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash__);









/* harmony default export */ __webpack_exports__["a"] = ({
  fiveCardHandValueBetOrdering: ['fourOfAKindPlus:royalFlush', 'fourOfAKindPlus:straightFlush', 'fourOfAKindPlus:fourOfAKind', 'fullHouse', 'flush:nut', 'flush:secondNut', 'flush:thirdNut', 'flush:weak', 'straight', 'threeOfAKind:topSet', 'threeOfAKind:secondSet', 'threeOfAKind:thirdSet', 'threeOfAKind:fourthSet', 'threeOfAKind:middleSet', 'threeOfAKind:bottomSet', 'threeOfAKind:trips', 'twoPair:usingTopBoardCard', 'twoPair:weak', 'pair:overpair', 'pair:tptk', 'pair:tpgk', 'pair:tpwk', 'pair:ppUnderTp', 'pair:secondPair', 'pair:middlePair'],
  fiveCardHandBluffOrderingForFlop: ['flushDraw:nut', 'flushDraw:secondNut', 'flushDraw:thirdNut', 'flushDraw:weak', 'oesd', 'doubleGutshot', 'pair:weakPair', 'twoOvercards', 'gutshot', 'oneOvercard', 'highCard:weak', 'highCard:kingHigh', 'highCard:aceHigh'],
  fiveCardHandBluffOrderingForTurn: ['flushDraw:nut', 'flushDraw:secondNut', 'flushDraw:thirdNut', 'flushDraw:weak', 'oesd', 'doubleGutshot', 'pair:weakPair', 'twoOvercards', 'gutshot', 'oneOvercard', 'highCard:weak', 'highCard:kingHigh', 'highCard:aceHigh'],
  fiveCardHandBluffOrderingForRiver: ['highCard:weak', 'highCard:kingHigh', 'highCard:aceHigh', 'pair:weakPair', 'pair:middlePair', 'pair:secondPair', 'pair:ppUnderTp'],

  getTotalNumOnePercentIncrements: function getTotalNumOnePercentIncrements(player, streetToCall) {
    var totalNumOnePercentIncrements = 0;
    var indexForCurrState = this._getIndexForCurrState(streetToCall);

    this.fiveCardHandValueBetOrdering.forEach(function (valueId) {
      if (player.states[indexForCurrState].fiveCardHands.find(valueId).visible) {
        totalNumOnePercentIncrements += 100;
      }
    });

    return totalNumOnePercentIncrements * 5;
  },
  _getIndexForCurrState: function _getIndexForCurrState(streetToCall) {
    if (streetToCall === 'flop') {
      return 1;
    } else if (streetToCall === 'turn') {
      return 2;
    } else if (streetToCall === 'river') {
      return 3;
    }
  },

  initializeBettingCriteria: function initializeBettingCriteria(bettingCriteria, streetToCall) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(bettingCriteria[streetToCall], 'allValue', []);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(bettingCriteria[streetToCall], 'threeToOne', []);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(bettingCriteria[streetToCall], 'twoToOne', []);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(bettingCriteria[streetToCall], 'oneToOne', []);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(bettingCriteria[streetToCall], 'oneToTwo', []);

    this.fiveCardHandValueBetOrdering.forEach(function (valueId) {
      for (var valueToBluffRatio in bettingCriteria[streetToCall]) {
        bettingCriteria[streetToCall][valueToBluffRatio].push({
          worstValueId: valueId,
          weightedRange: null,
          equity: null
        });
      }
    });
  },

  setWeightedRangeForEachBettingCriterion: function setWeightedRangeForEachBettingCriterion(state) {
    var _this = this;

    var indexForCurrState = this._getIndexForCurrState(state.streetToCall);
    var currentStatesGeneralHands = state.players.find(0).states[indexForCurrState].generalHands;
    var presetCommunityCardsArray = state.presetCommunityCards.getArrayForStateViaStreet(state.streetToCall);

    var _loop = function _loop(valueToBluffRatio) {
      state.bettingCriteria[state.streetToCall][valueToBluffRatio].forEach(function (bettingCriterion) {
        if (state.players.find(0).states[indexForCurrState].fiveCardHands.find(bettingCriterion.worstValueId).visible) {
          this._setWeightedRangeForBettingCriterion(currentStatesGeneralHands, bettingCriterion, valueToBluffRatio, presetCommunityCardsArray, state.streetToCall);
        }
      }, _this);
    };

    for (var valueToBluffRatio in state.bettingCriteria[state.streetToCall]) {
      _loop(valueToBluffRatio);
    }
  },
  _setWeightedRangeForBettingCriterion: function _setWeightedRangeForBettingCriterion(currentStatesGeneralHands, bettingCriterion, valueToBluffRatio, presetCommunityCardsArray, streetToCall) {
    var copyOfCurrentStatesGeneralHands = this.__getCopyOfCurrentStatesGeneralHands(currentStatesGeneralHands);

    this.__selectValueHands(copyOfCurrentStatesGeneralHands, bettingCriterion.worstValueId, presetCommunityCardsArray);
    if (copyOfCurrentStatesGeneralHands.numberOfSpecificHandsInRange === 0) {
      bettingCriterion.weightedRange = null;
    }

    if (valueToBluffRatio !== 'allValue') {
      if (this.__selectBluffHands(copyOfCurrentStatesGeneralHands, valueToBluffRatio, streetToCall, presetCommunityCardsArray) === 'not enough bluffs available') {
        return;
      }
    }

    bettingCriterion.weightedRange = copyOfCurrentStatesGeneralHands.weightedRange;
  },
  __getCopyOfCurrentStatesGeneralHands: function __getCopyOfCurrentStatesGeneralHands(currentStatesGeneralHands) {
    var copyOfCurrentStatesGeneralHands = new __WEBPACK_IMPORTED_MODULE_1__services_hands_GeneralHands__["a" /* default */]();

    currentStatesGeneralHands.forEachSpecificHand(function (specificHand) {
      copyOfCurrentStatesGeneralHands.find(specificHand.string).maxPossibleWeight = specificHand.maxPossibleWeight;
    });
    copyOfCurrentStatesGeneralHands.numberOfPossibleSpecificHands = currentStatesGeneralHands.numberOfPossibleSpecificHands;

    return copyOfCurrentStatesGeneralHands;
  },
  __selectValueHands: function __selectValueHands(generalHands, worstValueId, presetCommunityCardsArray) {
    generalHands.forEachPossibleSpecificHand(function (specificHand) {
      if (this.___isSpecificHandEqualToOrBetterThanWorstValueId(specificHand, worstValueId, presetCommunityCardsArray)) {
        specificHand.weight = 100;
        generalHands.numberOfSpecificHandsInRange++;
      }
    }, this);
  },
  ___isSpecificHandEqualToOrBetterThanWorstValueId: function ___isSpecificHandEqualToOrBetterThanWorstValueId(specificHand, worstValueId, presetCommunityCardsArray) {
    var valueIds = void 0;
    var holeCards = void 0;
    var handInfo = void 0;
    var drawInfo = void 0;

    valueIds = this.____getValueIds(worstValueId);
    holeCards = [specificHand.firstCard, specificHand.secondCard];
    handInfo = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].run(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.union(holeCards, presetCommunityCardsArray));
    __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, presetCommunityCardsArray);
    drawInfo = __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_get_draw_info__["a" /* default */].run(holeCards, presetCommunityCardsArray, handInfo, true);

    for (var i = 0; i < valueIds.length; i++) {
      if (__WEBPACK_IMPORTED_MODULE_6__services_utilities_utilities__["a" /* default */].results.matchesFiveCardHandId(valueIds[i], handInfo, drawInfo)) {
        return true;
      }
    }

    return false;
  },
  ____getValueIds: function ____getValueIds(worstValueId) {
    var valueIds = [];

    for (var i = 0; i < this.fiveCardHandValueBetOrdering.length; i++) {
      valueIds.push(this.fiveCardHandValueBetOrdering[i]);

      if (this.fiveCardHandValueBetOrdering[i] === worstValueId) {
        break;
      }
    }

    return valueIds;
  },
  __selectBluffHands: function __selectBluffHands(generalHands, valueToBluffRatio, streetToCall, presetCommunityCardsArray) {
    var numBluffCombosToSelect = this.___getNumBluffCombosToSelect(generalHands, valueToBluffRatio);
    var numTotalCombosToSelect = numBluffCombosToSelect + generalHands.numberOfSpecificHandsInRange;
    var bluffIdOrdering = this.___getBluffIdOrdering(streetToCall);

    for (var i = 0; i < bluffIdOrdering.length; i++) {
      this.___addCombosThatMatchBluffId(generalHands, bluffIdOrdering[i], presetCommunityCardsArray, numTotalCombosToSelect);

      if (generalHands.numberOfSpecificHandsInRange >= numTotalCombosToSelect) {
        break;
      }
    }

    if (generalHands.numberOfSpecificHandsInRange !== numTotalCombosToSelect) {
      return 'not enough bluffs available';
    }
  },
  ___getNumBluffCombosToSelect: function ___getNumBluffCombosToSelect(generalHands, valueToBluffRatio) {
    var numBluffCombosToSelect = void 0;

    if (valueToBluffRatio === 'threeToOne') {
      numBluffCombosToSelect = generalHands.numberOfSpecificHandsInRange / 3;
    } else if (valueToBluffRatio === 'twoToOne') {
      numBluffCombosToSelect = generalHands.numberOfSpecificHandsInRange / 2;
    } else if (valueToBluffRatio === 'oneToOne') {
      numBluffCombosToSelect = generalHands.numberOfSpecificHandsInRange;
    } else if (valueToBluffRatio === 'oneToTwo') {
      numBluffCombosToSelect = generalHands.numberOfSpecificHandsInRange * 2;
    } else {
      throw new Error('Invalid value for valueToBluffRatio');
    }

    return Math.floor(numBluffCombosToSelect);
  },
  ___getBluffIdOrdering: function ___getBluffIdOrdering(streetToCall) {
    if (streetToCall === 'flop') {
      return this.fiveCardHandBluffOrderingForFlop;
    } else if (streetToCall === 'turn') {
      return this.fiveCardHandBluffOrderingForTurn;
    } else if (streetToCall === 'river') {
      return this.fiveCardHandBluffOrderingForRiver;
    } else {
      throw new Error('Invalid value for streetToCall');
    }
  },
  ___addCombosThatMatchBluffId: function ___addCombosThatMatchBluffId(generalHands, bluffId, presetCommunityCardsArray, numTotalCombosToSelect) {
    generalHands.forEachPossibleSpecificHandNotInRange(function (specificHand) {
      if (generalHands.numberOfSpecificHandsInRange >= numTotalCombosToSelect) {
        return;
      }

      if (this.____specificHandMatchesBluffId(specificHand, bluffId, presetCommunityCardsArray)) {
        specificHand.weight = 100;
        generalHands.numberOfSpecificHandsInRange++;
      }
    }, this);
  },
  ____specificHandMatchesBluffId: function ____specificHandMatchesBluffId(specificHand, bluffId, presetCommunityCardsArray) {
    var holeCards = void 0;
    var handInfo = void 0;
    var drawInfo = void 0;
    var onRiver = void 0;

    holeCards = [specificHand.firstCard, specificHand.secondCard];
    handInfo = __WEBPACK_IMPORTED_MODULE_2__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].run(__WEBPACK_IMPORTED_MODULE_7_lodash___default.a.union(holeCards, presetCommunityCardsArray));
    __WEBPACK_IMPORTED_MODULE_3__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, presetCommunityCardsArray);
    drawInfo = __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_get_draw_info__["a" /* default */].run(holeCards, presetCommunityCardsArray, handInfo, true);
    onRiver = presetCommunityCardsArray.length === 5;

    if (!onRiver && this._____specificHandIsAValueHand(handInfo, drawInfo, bluffId)) {
      return false;
    }

    return __WEBPACK_IMPORTED_MODULE_6__services_utilities_utilities__["a" /* default */].results.matchesFiveCardHandId(bluffId, handInfo, drawInfo);
  },
  _____specificHandIsAValueHand: function _____specificHandIsAValueHand(handInfo, drawInfo, bluffId) {
    if (bluffId.includes('pair:weakPair')) {
      return false;
    }

    return !(__WEBPACK_IMPORTED_MODULE_6__services_utilities_utilities__["a" /* default */].results.matchesFiveCardHandId('highCard:aceHigh', handInfo, drawInfo) || __WEBPACK_IMPORTED_MODULE_6__services_utilities_utilities__["a" /* default */].results.matchesFiveCardHandId('highCard:kingHigh', handInfo, drawInfo) || __WEBPACK_IMPORTED_MODULE_6__services_utilities_utilities__["a" /* default */].results.matchesFiveCardHandId('highCard:weak', handInfo, drawInfo));
  },

  setEquityForBettingCriterion: function setEquityForBettingCriterion(bettingCriterion, presetCommunityCardsArray, heroWeightedRange, numberOfSimulations, rakePercentage, tipPercentage, bettingCriteriaOnePercentIncrementsContainer, incrementCb) {
    var weightedRanges = [heroWeightedRange, bettingCriterion.weightedRange];
    var wins = void 0;
    var ties = void 0;
    var winFractions = void 0;
    var equity = void 0;

    return __WEBPACK_IMPORTED_MODULE_5__services_simulator_simulator__["a" /* default */].getEquities(weightedRanges, presetCommunityCardsArray, numberOfSimulations, function () {
      incrementCb(bettingCriteriaOnePercentIncrementsContainer);
    }).then(function (simulationResults) {
      wins = simulationResults[0].wins;
      winFractions = simulationResults[0].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = (wins + winFractions) / numberOfSimulations * 100;
      equity -= equity * (rakePercentage / 100) + equity * (tipPercentage / 100);
      bettingCriterion.equity = equity;
    }).catch(function (e) {
      console.error(e);
    });
  }
});

/***/ }),

/***/ "fFIt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fH14":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"three-bet-cbet-explorer-inputs"},[_c('section',[_c('h4',[_vm._v("What did they open to?")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"2","max":"100","step":"0.5","disabled":!_vm.authorized},domProps:{"value":_vm.state.openSize},on:{"input":function($event){return _vm.setOpenSize($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("big blinds")])]),_vm._v(" "),_c('h4',[_vm._v("What are you 3betting to?")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":_vm.state.openSize * 2,"max":"100","step":"0.5","disabled":!_vm.authorized},domProps:{"value":_vm.state.threeBetSize},on:{"input":function($event){return _vm.setThreeBetSize($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("big blinds")])]),_vm._v(" "),_c('h4',[_vm._v("What range do you think they're opening with?")]),_vm._v(" "),_c('hand-range',{attrs:{"generalHands":_vm.state.players.find(0).states[0].generalHands,"weightToApplyToAddedHands":_vm.state.players.find(0).weightToApplyToAddedHands,"combosToAdd":_vm.state.players.find(0).combosToAdd,"disableAllButGridSelector":false,"disableAllSelectors":!_vm.authorized,"canBeRemoved":false,"specificHandsNotAllowed":true},on:{"clearRange":function($event){_vm.state.players.find(0).handleClearPlayerEvent('threeBetCbetExplorer', _vm.$store, 0, 0)},"applyExactWeightToGeneralHands":function($event){_vm.state.players.find(0).handleApplyExactWeightToGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 0)},"selectGeneralHand":function($event){_vm.state.players.find(0).handleSelectGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event.generalHandString, $event.triggeredByMouseover, 0, 0)},"deselectGeneralHand":function($event){_vm.state.players.find(0).handleDeselectGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 0)},"selectGeneralHands":function($event){_vm.state.players.find(0).handleSelectGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 0)},"deselectGeneralHands":function($event){_vm.state.players.find(0).handleDeselectGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 0)},"setRangeToMatchGeneralHands":function($event){_vm.state.players.find(0).handleSetRangeToMatchGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 0)},"setRangeToMatchDoubleSlider":function($event){_vm.state.players.find(0).handleSetRangeToMatchDoubleSliderEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 0, _vm.handRankings)},"setRangeToMatchSpecificHandStrings":function($event){_vm.state.players.find(0).handleSetRangeToMatchSpecificHandStringsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 0)},"applyExactWeightToGeneralHand":function($event){_vm.state.players.find(0).handleApplyExactWeightToGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 0)},"setWeightToApplyToAddedHands":function($event){_vm.state.players.find(0).handleSetWeightToApplyToAddedHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0)}}}),_vm._v(" "),_c('h4',[_vm._v("What range do you think they're continuing with versus your 3bet?")]),_vm._v(" "),_c('hand-range',{attrs:{"generalHands":_vm.state.players.find(0).states[1].generalHands,"weightToApplyToAddedHands":_vm.state.players.find(0).weightToApplyToAddedHands,"combosToAdd":_vm.state.players.find(0).combosToAdd,"disableAllButGridSelector":false,"disableAllSelectors":!_vm.authorized,"canBeRemoved":false,"specificHandsNotAllowed":true},on:{"clearRange":function($event){_vm.state.players.find(0).handleClearPlayerEvent('threeBetCbetExplorer', _vm.$store, 0, 1)},"applyExactWeightToGeneralHands":function($event){_vm.state.players.find(0).handleApplyExactWeightToGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 1)},"selectGeneralHand":function($event){_vm.state.players.find(0).handleSelectGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event.generalHandString, $event.triggeredByMouseover, 0, 1)},"deselectGeneralHand":function($event){_vm.state.players.find(0).handleDeselectGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 1)},"selectGeneralHands":function($event){_vm.state.players.find(0).handleSelectGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 1)},"deselectGeneralHands":function($event){_vm.state.players.find(0).handleDeselectGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 1)},"setRangeToMatchGeneralHands":function($event){_vm.state.players.find(0).handleSetRangeToMatchGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 1)},"setRangeToMatchDoubleSlider":function($event){_vm.state.players.find(0).handleSetRangeToMatchDoubleSliderEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 1, _vm.handRankings)},"setRangeToMatchSpecificHandStrings":function($event){_vm.state.players.find(0).handleSetRangeToMatchSpecificHandStringsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 1)},"applyExactWeightToGeneralHand":function($event){_vm.state.players.find(0).handleApplyExactWeightToGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 1)},"setWeightToApplyToAddedHands":function($event){_vm.state.players.find(0).handleSetWeightToApplyToAddedHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 1)}}}),_vm._v(" "),_c('h4',[_vm._v("What range do you think they're 4betting with versus your 3bet?")]),_vm._v(" "),_c('hand-range',{attrs:{"generalHands":_vm.state.players.find(0).states[2].generalHands,"weightToApplyToAddedHands":_vm.state.players.find(0).weightToApplyToAddedHands,"combosToAdd":_vm.state.players.find(0).combosToAdd,"disableAllButGridSelector":false,"disableAllSelectors":!_vm.authorized,"canBeRemoved":false,"specificHandsNotAllowed":true},on:{"clearRange":function($event){_vm.state.players.find(0).handleClearPlayerEvent('threeBetCbetExplorer', _vm.$store, 0, 2)},"applyExactWeightToGeneralHands":function($event){_vm.state.players.find(0).handleApplyExactWeightToGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 2)},"selectGeneralHand":function($event){_vm.state.players.find(0).handleSelectGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event.generalHandString, $event.triggeredByMouseover, 0, 2)},"deselectGeneralHand":function($event){_vm.state.players.find(0).handleDeselectGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 2)},"selectGeneralHands":function($event){_vm.state.players.find(0).handleSelectGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 2)},"deselectGeneralHands":function($event){_vm.state.players.find(0).handleDeselectGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 2)},"setRangeToMatchGeneralHands":function($event){_vm.state.players.find(0).handleSetRangeToMatchGeneralHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 2)},"setRangeToMatchDoubleSlider":function($event){_vm.state.players.find(0).handleSetRangeToMatchDoubleSliderEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 2, _vm.handRankings)},"setRangeToMatchSpecificHandStrings":function($event){_vm.state.players.find(0).handleSetRangeToMatchSpecificHandStringsEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 2)},"applyExactWeightToGeneralHand":function($event){_vm.state.players.find(0).handleApplyExactWeightToGeneralHandEvent('threeBetCbetExplorer', _vm.$store, $event, 0, 2)},"setWeightToApplyToAddedHands":function($event){_vm.state.players.find(0).handleSetWeightToApplyToAddedHandsEvent('threeBetCbetExplorer', _vm.$store, $event, 2)}}})],1),_vm._v(" "),_c('togglable-section',{attrs:{"title":"Players behind"}},[_c('li',{staticClass:"list-group-item"},[_c('h4',[_vm._v("How many players are left to act?")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"8","step":"1","disabled":!_vm.authorized},domProps:{"value":_vm.state.numPlayersLeftToAct},on:{"input":function($event){return _vm.setNumPlayersLeftToAct($event.target.valueAsNumber)}}})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.numPlayersLeftToAct > 0),expression:"state.numPlayersLeftToAct > 0"}],staticClass:"list-group-item"},[_c('h4',[_vm._v("\n        What percentage of the time do you think each of them is 4betting you, on average?\n        "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"AA = 0.45%; KK+ = 0.9%; QQ+ = 1.35%; QQ+/AKs = 1.7%; QQ+/AK = 2.6%; JJ+/AK = 3%","data-placement":"bottom","data-toggle":"tooltip"}})]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"0.5","disabled":!_vm.authorized},domProps:{"value":_vm.state.averageFourBetPercentage},on:{"input":function($event){return _vm.setAverageFourBetPercentage($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])])]),_vm._v(" "),_c('togglable-section',{attrs:{"title":"Cbet"}},[_c('li',{staticClass:"list-group-item"},[_c('h4',[_vm._v("\n        What cbet size do you want to explore?\n        "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"To keep things simple, we're assuming that you cbet to this size on every flop that you miss. For more information see the caveats in the help section.","data-placement":"bottom","data-toggle":"tooltip"}})]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"10","step":"0.05","disabled":!_vm.authorized},domProps:{"value":_vm.state.cbetSize},on:{"input":function($event){return _vm.setCbetSize($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("x pot")])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.state.cbetSize > 0),expression:"state.cbetSize > 0"}],staticClass:"list-group-item"},[_c('h4',[_vm._v("\n        How often do you think they're continuing versus your cbet, on average?\n        "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"If you don't have a good feel for these numbers 1) try playing around with the Hit Calculator, 2) typical values range from about 30-70%.","data-placement":"bottom","data-toggle":"tooltip"}})]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.continueVsCbetPercentage},on:{"input":function($event){return _vm.setContinueVsCbetPercentage($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])])]),_vm._v(" "),_c('togglable-section',{attrs:{"title":"Getting paid when you hit"}},[_c('li',{staticClass:"list-group-item"},[_c('h4',[_vm._v("\n        How often do you hit the flop (eg. two pair or better)?\n        "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This is trying to ask how often you make a hand on the flop where feel confident that you are ahead of your opponent. If you have something like A5s and the flop comes A72, you can't really feel confident that you're ahead, so that probaably wouldn't count as 'hitting'. But if you made two pair, now you can feel confident that you are ahead. Two pair is probably going to be the bar you have to reach for it to be considered a 'hit', because any top pair hands you make are likely to be dominated when you're 3bet bluffing. If you don't have a good feel for how often you will 'hit', 1) try playing around with the Hit Calculator, 2) typical non-pocket pair hands are about 5%, and pocket pairs are about 12%.","data-placement":"bottom","data-toggle":"tooltip"}})]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"0.5","disabled":!_vm.authorized},domProps:{"value":_vm.state.hitPercentage},on:{"input":function($event){return _vm.setHitPercentage($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]),_vm._v(" "),(_vm.state.hitPercentage > 0)?_c('li',{staticClass:"list-group-item"},[_c('h4',[_vm._v("When you hit, how often do you expect to get the first street of value? (assuming a 3/4 pot bet)")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.firstStreetOfValuePercentage},on:{"input":function($event){return _vm.setFirstStreetOfValuePercentage($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e(),_vm._v(" "),(_vm.state.hitPercentage > 0)?_c('li',{staticClass:"list-group-item"},[_c('h4',[_vm._v("When you hit, how often do you expect to get the second street of value? (assuming 3/4 pot bets)")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.secondStreetOfValuePercentage},on:{"input":function($event){return _vm.setSecondStreetOfValuePercentage($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e(),_vm._v(" "),(_vm.state.hitPercentage > 0)?_c('li',{staticClass:"list-group-item"},[_c('h4',[_vm._v("When you hit, how often do you expect to get the third street of value? (assuming 3/4 pot bets)")]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"5","disabled":!_vm.authorized},domProps:{"value":_vm.state.thirdStreetOfValuePercentage},on:{"input":function($event){return _vm.setThirdStreetOfValuePercentage($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("%")])])]):_vm._e()]),_vm._v(" "),_c('togglable-section',{attrs:{"title":"Alternative to compare to"}},[_c('li',{staticClass:"list-group-item"},[_c('h4',[_vm._v("\n        What EV do you want to compare the 3bet-cbet line to?\n        "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"If you have something like 54s and you're going to fold if you don't take the 3bet-cbet line, then you want this to be zero, because the EV of folding is zero. But if you have something like 33 and the alternative to you taking the 3bet-cbet line is flatting, flatting might have an EV of +1.5bb or something, in which case you'll want to enter that in here.","data-placement":"bottom","data-toggle":"tooltip"}})]),_vm._v(" "),_c('section',{staticClass:"input-group"},[_c('input',{staticClass:"form-control",attrs:{"type":"number","min":"0","max":"100","step":"0.5","disabled":!_vm.authorized},domProps:{"value":_vm.state.alternativeEV},on:{"input":function($event){return _vm.setAlternativeEV($event.target.valueAsNumber)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("bb")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fLJN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-range-help-section',
  props: ['playerStateIndex', 'streetToBluff']
});

/***/ }),

/***/ "fQpx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"betting-criteria-table well"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Immediately profitable breakeven percentage (via pot odds of "+_vm._s(_vm.state.potOdds)+"): "),_c('strong',[_vm._v(_vm._s(_vm.breakevenPercentageViaPotOdds)+"%")])]),_vm._v(" "),_c('p',[_vm._v("True breakeven percentage (via real odds of "+_vm._s(_vm.state.realOddsLHS)+":1): "),_c('strong',[_vm._v(_vm._s(_vm.breakevenPercentageViaRealOdds)+"%")])]),_vm._v(" "),_c('p',[_vm._v("\n    Real odds:\n    "),_c('input',{attrs:{"type":"number","min":"0.1","step":"0.1"},domProps:{"value":_vm.state.realOddsLHS},on:{"input":function($event){return _vm.$emit('setRealOddsLHS', $event.target.valueAsNumber)}}}),_vm._v("\n    -to-1\n    "),_vm._m(1)]),_vm._v(" "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible},on:{"toggleHelp":function($event){_vm.helpAreaVisible = !_vm.helpAreaVisible}}}),_vm._v(" "),(_vm.helpAreaVisible)?_c('section',{staticClass:"well help"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/HZSf9zFOTgs?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}}),_vm._v(" "),_c('p',[_vm._v("The table below is meant to help you \"zoom out\" and think about how your hand performs against many possible ranges that your opponent could have.")]),_vm._v(" "),_c('p',[_vm._v("Here's how it works:")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("Notes:")]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.possibleBettingCriteria.length > 0)?_c('table',{staticClass:"table"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.possibleBettingCriteria),function(bettingCriterion,i){return _c('tr',[(i === 0)?_c('td',{attrs:{"rowspan":_vm.possibleBettingCriteria.length}},[_c('em',[_vm._v("Value betting range")])]):_vm._e(),_vm._v(" "),_c('th',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm.fiveCardHandIdToDisplayString(bettingCriterion.threeToOne.worstValueId))+"+")]),_vm._v(" "),_c('td',{class:_vm.getDiffClass(bettingCriterion.allValue.equity),attrs:{"title":_vm.getCellTitle(bettingCriterion.allValue.equity)}},[_vm._v("\n          "+_vm._s(_vm.getCellText(bettingCriterion.allValue.equity))+"\n        ")]),_vm._v(" "),_c('td',{class:_vm.getDiffClass(bettingCriterion.threeToOne.equity),attrs:{"title":_vm.getCellTitle(bettingCriterion.allValue.equity)}},[_vm._v("\n          "+_vm._s(_vm.getCellText(bettingCriterion.threeToOne.equity))+"\n        ")]),_vm._v(" "),_c('td',{class:_vm.getDiffClass(bettingCriterion.twoToOne.equity),attrs:{"title":_vm.getCellTitle(bettingCriterion.allValue.equity)}},[_vm._v("\n          "+_vm._s(_vm.getCellText(bettingCriterion.twoToOne.equity))+"\n        ")]),_vm._v(" "),_c('td',{class:_vm.getDiffClass(bettingCriterion.oneToOne.equity),attrs:{"title":_vm.getCellTitle(bettingCriterion.allValue.equity)}},[_vm._v("\n          "+_vm._s(_vm.getCellText(bettingCriterion.oneToOne.equity))+"\n        ")]),_vm._v(" "),_c('td',{class:_vm.getDiffClass(bettingCriterion.oneToTwo.equity),attrs:{"title":_vm.getCellTitle(bettingCriterion.allValue.equity)}},[_vm._v("\n          "+_vm._s(_vm.getCellText(bettingCriterion.oneToTwo.equity))+"\n        ")])])}),0)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('simulate-button',{on:{"simulate":function($event){return _vm.simulate()}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("\n      Equity versus various ranges\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('em',[_vm._v("(see "),_c('a',{attrs:{"href":"#should-you-call-final-conclusion"}},[_vm._v("further down")]),_vm._v(" for how to estimate this)")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("2:1 means \"for every two value bets, your opponent has one bluff\".")]),_vm._v(" "),_c('li',[_vm._v("TPTK means \"they're only betting TPTK and better for value\".")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("So the intersection of 2:1 and TPTK means that they're betting TPTK and better for value, and one bluff for every two value hands.")])]),_vm._v(" "),_c('li',[_vm._v("The numbers in the cells show your equity versus the corresponding range minus the required equity given the real odds. So if you have 35% equity but need 40%, the cell will show \"-5%\" and be shaded a corresponding light red color.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("How are bluff hands selected? They are added in the following order until enough combos are added to satisfy the value-to-bluff ratio: "),_c('em',[_vm._v("nut flush draw, second nut flush draw, third nut flush draw, weak flush draw, open ended straight draw, double gutshot, weak pair, two overcards, gutshot, one overcard, air")]),_vm._v(". And on the river it goes "),_c('em',[_vm._v("weak high card, king high, ace high, bottom pair, etc.")]),_vm._v(" So if you start adding nut flush draws and the value-to-bluff ratio gets satisfied, it won't continue to add second nut flush draws.")]),_vm._v(" "),_c('li',[_vm._v("What does \"n/a\" mean? It means that there weren't enough bluffs available for the cell to be possible.")]),_vm._v(" "),_c('li',[_vm._v("There are some kinks that I plan on working out on paired and other non-standard boards.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('td',{attrs:{"colspan":"5"}},[_c('em',[_vm._v("Value-to-bluff ratio")])])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("All value")]),_vm._v(" "),_c('th',[_vm._v("3:1")]),_vm._v(" "),_c('th',[_vm._v("2:1")]),_vm._v(" "),_c('th',[_vm._v("1:1")]),_vm._v(" "),_c('th',[_vm._v("1:2")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fVjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Pokers 1% is all about frequency-based play. What is frequency based play? I think it's best understood in contrast to hand-strength-based play.")]),_vm._v(" "),_c('p',[_vm._v("Consider an example. The board is A44r. Your opponent cbets.  What hands do you continue with?")]),_vm._v(" "),_c('p',[_vm._v("A nitty opponent might think:")]),_vm._v(" "),_c('blockquote',[_vm._v("Meh, 22 and 53 really just aren't strong enough for me to continue. But I guess I'd be cool peeling a street off with TT.")]),_vm._v(" "),_c('p',[_vm._v("A more straightforward opponent might think:")]),_vm._v(" "),_c('blockquote',[_vm._v("This is a super dry board. I normally wouldn't like small pocket pairs and naked gutshots without anything else going for them, but in this case I guess I'd call with them. I wouldn't have the balls to call with king high though.")]),_vm._v(" "),_c('p',[_vm._v("Now, watch how frequency-first approach would work:")]),_vm._v(" "),_c('blockquote',[_vm._v("I need to defend with 70% of my hands here. I've studied this spot before and I know that I only have about 45% pair or better hands. So I definitely need to continue with my backdoor flush draws. Probably a few king highs as well.")]),_vm._v(" "),_c('p',[_vm._v("Do you see the difference?")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('h2',[_vm._v("Why frequency-first is cool")]),_vm._v(" "),_c('p',[_vm._v("Frequency-first poker is really where it's at. For a bunch of reasons.")]),_vm._v(" "),_c('h3',[_vm._v("Reason #1: Without it, better opponents will eventually crush you.")]),_vm._v(" "),_c('p',[_vm._v("Say you move to Vegas with a dream to make it big as a poker pro. Here's how life will look if you take a hand-strength-first approach, like so many others do.")]),_vm._v(" "),_c('p',[_vm._v("You'll start off grinding $1-2. You'll study, improve, increase your winrate from $5/hr to $10/hr to maybe $15-20/hr. Then maybe you move up to $2-5, and go through a similar process. If you're really sharp, make you can take this all the way to $5-10. But eventually, your wits will fail you, and you'll hit a wall.")]),_vm._v(" "),_c('p',[_vm._v("You'll be upset. Frustrated.")]),_vm._v(" "),_c('p',[_vm._v("\"Why am I not winning? What's going on?\"")]),_vm._v(" "),_c('p',[_vm._v("What's going on is that the way you're thinking about the game has failed you. It's not that your opponents are smarter than you, or harder working. It's that hand-strength-first can only take you so far. To compete with the 1%, you need frequency-first.")]),_vm._v(" "),_c('h3',[_vm._v("Reason #2: It's inexploitable, so worst-case scenario, you'll be breaking even.")]),_vm._v(" "),_c('p',[_vm._v("When you take this frequency-first approach, something a little big magical happens: you become inexploitable. If you somehow got your frequencies perfect, no one would ever be able to beat you.")]),_vm._v(" "),_c('p',[_vm._v("You'd even be able to tell them exactly what you're doing! \"In this spot I'll be calling with all of my pairs, all of my backdoor flush draws, and KQ-KT. Whatcha gon' do 'bout it?\"")]),_vm._v(" "),_c('p',[_vm._v("They wouldn't be able to do anything about it.")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('p',[_vm._v("To me, this still feels a little bit magical. Like, how exactly does this work out to be true? I have some understanding, but I wouldn't say that I fully understand it. The book provides some intuition, but that's really not where it's focus is. I think it's focused a lot more on the \"what\" rather than the \"why\".")]),_vm._v(" "),_c('p',[_vm._v("The cool thing is that in order to be good at poker, you don't really need to understand the why. You just have to know that you have to meet certain frequencies, not why you have to meet them.")]),_vm._v(" "),_c('p',[_vm._v("(Personally I get an itching discomfort when I don't understand the why, so I'm going to have to get it figured out at some point, but that's neither here nor there.)")]),_vm._v(" "),_c('h3',[_vm._v("Reason #3: It'll help you exploit your opponents.")]),_vm._v(" "),_c('p',[_vm._v("The frequency-first approach will often tell you to defend vs your opponents bet/raise something like 70% of the time. That'll be inexploitable, but it won't always be the most profitable. That's a very important difference.")]),_vm._v(" "),_c('p',[_vm._v("For example, suppose your opponent fires a third barrel on the river. You're sitting there with top pair no kicker. A bluff catcher. Maybe it's part of your 70%, you're technically \"supposed\" to call. But does that mean you should call?")]),_vm._v(" "),_c('p',[_vm._v("Well, if you know your opponent isn't bluffing enough, the better choice would be to fold. Miller likes to say that once they break the rules — by not doing what frequency-based play says to do — then you can (and should!) break the rules too.")]),_vm._v(" "),_c('p',[_vm._v("Again, this is a very important point. As poker players, we want to maximize our profits, so we want to find these mistakes that our opponents are making, and we want to make them pay.")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('p',[_vm._v("Well, if they're betting like 10-20% of the time, then it's just obvious that they're making a mistake. That they're a nit and have the goods when they bet. But errors that large aren't too common. You want to be able to exploit the small and medium-sized errors too, not just the big and obvious ones. To do that, you need to know what the correct numbers are.")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("Disclaimer: Trying to exploit your opponents can backfire! Make sure that you actually know that they're making a mistake.")]),_vm._v(" "),_c('h3',[_vm._v("Reason #4: It's a great thing to fall back on when you're a little lost.")]),_vm._v(" "),_c('p',[_vm._v("Poker players love to pretend that they know everything, but the reality is that we're all pretty clueless. There's tons of spots where we don't know what the hell we're doing.")]),_vm._v(" "),_c('p',[_vm._v("For example, maybe you make $10/hr playing 1-2. Not bad, but there's still tons of room for improvement. Maybe you take advantage of your opponents by playing a strong range preflop and value betting hard with the goods, but maybe you never know what to do on monochrome boards, or when the flush completes, or when facing a minraise. Chances are that there are some spots where you feel lost. When this happens, it's nice to be able to fall back to the frequency-perfect play, and know that you're at least not getting exploited.")]),_vm._v(" "),_c('p',[_vm._v("Another situation where this becomes useful is when you move up to a higher stakes game and run into some trouble. It's nice to be able to play frequency-perfect and not get exploited while you get situated, and then start to deviate from that as you get reads on what your opponents are doing wrong.")]),_vm._v(" "),_c('p',[_vm._v("Let me give you an example of this. I recently moved up to NL50 online. I haven't been doing as well as I'd like. One thing that worries me is that whenever I check, I feel like I get put in tough spots and have to fold too often. What I'm going to do moving forward is to make sure I get my frequencies right. That way I'll be inexploitable for the time being. Then, once I have a better feel for what my opponents are doing, I can start exploiting them.")]),_vm._v(" "),_c('h2',[_vm._v("What the frequency-first approach really is")]),_vm._v(" "),_c('p',[_vm._v("Ok, that's been a little overview of why the frequency-first approach is cool. Now let's talk about how exactly to use this frequency-first approach. We saw the A44r example, but there's more to it. The book talks all about it, but essentially, there are two rules that you'll need to follow:")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('p',[_vm._v("To visualize the 70% thing, check out the pyramid below. The idea is that you narrow your range on each street. Eg. as you get further and further up the pyramid. The lower the percent, the steeper the slope.")]),_vm._v(" "),_c('img',{attrs:{"src":"https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.smartpokerstudy.com%2Fwp-content%2Fuploads%2F2019%2F04%2Fmillers-pyramid_thumb-300x262.png&f=1&nofb=1"}}),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('p',[_vm._v("The pyramids really make it clear when people have exploitable frequency errors.")]),_vm._v(" "),_c('img',{attrs:{"src":"https://proxy.duckduckgo.com/iu/?u=https%3A%2F%2Fwww.smartpokerstudy.com%2Fwp-content%2Fuploads%2F2019%2F04%2Fcutting-out-too-much-of-your-preflop-range-on-the-flop-300x215.png&f=1&nofb=1"}}),_vm._v(" "),_c('img',{attrs:{"src":""}}),_vm._v(" "),_c('img',{attrs:{"src":""}}),_vm._v(" "),_c('p',[_vm._v("Along similar lines, it helps you to think about your own strategy and to erase the vulnerabilities in your own game. Keep those slopes smooth!")]),_vm._v(" "),_c('p',[_vm._v("Before we get to the exceptions, here's another pretty essential thing: when you're betting, you basically want to have a 1-to-2 value-to-bluff ratio on the flop, 1-to-1 on the turn, and 2-to-1 on the river. Since this is a summary and is already really long, just roll with it for now, and check out the book for more information.")]),_vm._v(" "),_c('p',[_vm._v("Ok! Now on to the exceptions!")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',[_vm._v("The book talks about a bunch of other things that I don't think are worth diving too deeply into in this summary. I'll try to be brief:")]),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('p',[_vm._v("Here's an example of how studying works:")]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('p',[_vm._v("Again, Miller goes through these sorts of examples numerous times throughout the book, in much more detail, and it's really useful to watch him go through the process. There's also a bunch of cool little nuggets of insight where he talks about common errors people make and how to avoid + exploit them.")]),_vm._v(" "),_c('p',[_vm._v("But yeah, that's the gist of this book! He emphasizes that the book is similar to a workout DVD: it’ll inspire you and show you what to do, but you have to actually put in the work. You have to go through the process of developing your ranges for all the different spots you come across.")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('hr'),_vm._v(" "),_c('subscribe-to-blog')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Summary of Poker's 1% by Ed Miller")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("The hand-strength-first approach looks at the board, and asks what hands are strong enough to play on that board.")]),_vm._v(" "),_c('li',[_vm._v("The frequency-first approach first asks what frequency they want to continue at, and then asks what hands they want to select to meet that frequency.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("That's the big idea in this book. To use the frequency-first approach.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("If they tried to exploit you, they'd fail, and you'd profit off of them.")]),_vm._v(" "),_c('li',[_vm._v("If they tried to get their frequencies right, they'd probably make mistakes, and you'd profit off of them.")]),_vm._v(" "),_c('li',[_vm._v("If they happened to be elite players who also got their frequencies perfect, you'd just break even. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("But! In order to do that, we have to first know what the rules are.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Maybe we think they're betting 60% of their range when they should be betting 70%. We have to know that the 70% is what they "),_c('em',[_vm._v("should")]),_vm._v(" be doing before we actually know they're making a mistake.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('em',[_vm._v("This is why studying frequency-first play will also help you at games like 1-2 and 2-5!")]),_vm._v(" I think this point gets often gets lost or misunderstood when people read books like this and talk about frequencies. When people think frequencies, they usually are thinking about inexploitable, balanced poker. They’re not usually thinking about exploiting other people. But, again, knowing the frequencies will help you to find the mistakes that your opponents are making and use it against them.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',[_c('li',[_vm._v("When they bet, you'll want to be continuing about 70% of the time as a default to a full pot bet. And maybe something like 75% to a half pot bet.")]),_vm._v(" "),_c('li',[_vm._v("When you bet one street, you'll want to continue betting again on the next street about 70% of the time as a default.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("Those two rules are crucial!")]),_vm._v(" Like, in some sense, that's all there is to it. The rest is just caveats and exceptions; some bigger and more important than others. But if you ignored those exceptions and just followed the two rules above, "),_c('em',[_vm._v("you'd be pretty damn good at poker!")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("This pyramid analogy is pretty damn awesome.")]),_vm._v(" I think it's really helped me improve my game. Don't underestimate the value of a good mental model.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("In multiway pots, you basically share responsibility with the other players. Suppose that it's three-way and someone bets. "),_c('em',[_vm._v("You")]),_vm._v(" don't have to defend 70% of the time. You and the other guy have to defend 70% "),_c('em',[_vm._v("combined")]),_vm._v(". So maybe you each defend 35% or something.")]),_vm._v(" "),_c('li',[_vm._v("Say the cutoff opens 2bb and you flat from the BB. You were getting 3.5-to-1 pot odds, so you flat pretty widely. Then the flop comes and they cbet full pot. "),_c('em',[_vm._v("You don't need to defend the typical 70%.")]),_vm._v(" Since you didn't invest much to get here and you have a weak range, you can fold more often.")]),_vm._v(" "),_c('li',[_vm._v("Similarly, if you have been the bettor and decide to check at some point, you don't have to continue the normal 70% amount if they bet. The idea is sort of that they had to pay on previous streets to get this opportunity to bluff you when you check.")]),_vm._v(" "),_c('li',[_vm._v("The 70% defense thing is really just an "),_c('em',[_vm._v("average")]),_vm._v(" over all scenarios. Maybe you go 80% when you're in position and 60% when you're out of position. 80% when the turn improves your range, and 60% when it improves their range. Stuff like that. But be careful! Most of the time these factors will only tweak things a little bit. It's only when it's like the worst card in the deck or something that you can defend 20% instead of 70%.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("The hands you choose really don't matter too much, as long as you're somewhat intelligent about it. Like, it's not too big a deal whether you defend with 22 or with a gutshot. But still, the book provides some advice on how to choose hands for your different buckets (check-valuebet-bluff, or fold-call-raise).")]),_vm._v(" "),_c('li',[_vm._v("The call vs. raise decision is complicated and beyond the scope of the book, but Miller still provides a few guidelines.")]),_vm._v(" "),_c('li',[_vm._v("When you play too many hands preflop... you just totally screw yourself. You have a bunch of junk, and you have to do something with that junk. You either have to fold it out on some street, and thus overfold. Or you call down with it and end up paying people off with something stupid like second pair. There's no way out of the dilemma. Don't play junk preflop. I've always been pretty tight preflop, but this was a pretty big insight for me. I felt something click.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Throughout the book, Miller gives a bunch of examples of how you actually use this frequency-first approach. First of all, the work is done "),_c('em',[_vm._v("off")]),_vm._v(" the table. That's where you put your hours of study in. When you're actually at the table, you maybe spend a few seconds thinking, but you’re largely just using the intuition that you developed off the table.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Your opponent opens from MP, you flat from the CO and go heads up.")]),_vm._v(" "),_c('li',[_vm._v("Step 1: Figure out what range you're flatting with and entering the flop with.")]),_vm._v(" "),_c('li',[_vm._v("Flop comes A44r. Villain cbets.")]),_vm._v(" "),_c('li',[_vm._v("Step 2: Ask yourself how often you want to be continuing. Maybe it's 70% of the time here.")]),_vm._v(" "),_c('li',[_vm._v("Step 3: Ask yourself what hands you want to continue with. Maybe it's all pairs and all backdoor flush draws.")]),_vm._v(" "),_c('li',[_vm._v("Step 4: Ask yourself how you want to distribute your continuing between calls and raises. Suppose we don't want any raises here. We're flatting our whole continuing range.")]),_vm._v(" "),_c('li',[_vm._v("Turn comes an offsuit two. Villain fires a second barrel.")]),_vm._v(" "),_c('li',[_vm._v("At this point, we repeat steps 2, 3 and 4 for the turn. Maybe we want to defend 70% of the time again, which means continuing with all of our pairs, and flatting our whole range.")]),_vm._v(" "),_c('li',[_vm._v("Same thing for the river. Say it's a ten. Maybe they bet and we want to continue 70% of the time, which ends up meaning that we defend all of our Ax, and fold all of our pocket pairs.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("He also emphasizes many times that this book is really just the tip of the iceberg. The truly elite players spend a bunch of time pinpointing the precise numbers. Like, maybe the correct number in one spot 66% instead of 70%, and 73% in another spot. Miller is very clear that the numbers he uses should be roughly correct, but definitely not perfect. And that if you progress enough to need better numbers, you can check out stuff like Janda's "),_c('em',[_vm._v("Applications of NLH")]),_vm._v(", Chen and Ankennman's "),_c('em',[_vm._v("The Mathematics of Poker")]),_vm._v(", and the software like PIO Solver.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("But despite the fact that the numbers in this book aren't perfect, one thing is very clear: if you get your frequencies close to them, you'll have "),_c('em',[_vm._v("a ton")]),_vm._v(" of success. You'll become a "),_c('em',[_vm._v("significantly")]),_vm._v(" better poker player. Most people — even at higher stakes — make many mistakes with their frequencies, so the bar isn't being set very high. If you get your frequencies roughly correct, the poker gods will certainly reward you.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fWJY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Suppose you move to Vegas to give it a go and try playing poker for a living. Live $1/2. Your first month you play for 200 hours and are up $20,000. Woo hoo! Pretty good, right? That's a winrate of $100/hr!")]),_vm._v(" "),_c('p',[_vm._v("Now, would you go to your friends and say that you make $100/hr playing poker? Probably not, right? But why not? Well, The best live $1/2 grinders make maybe $30/hr. $100/hr at $1/2 is unheard of! So common sense says that you're just running hot. But let's try looking at this a little bit more deeply.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/prior-probability-and-estimating-your-winrate/1.png"}}),_vm._v(" "),_c('p',[_vm._v("From there, you play for a month and win $20,000 over 200 hours. This is data. Evidence. You take this, and you use it to update your belief.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/prior-probability-and-estimating-your-winrate/2.png"}}),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('img',{attrs:{"width":"400","src":"https://thelogicofscience.files.wordpress.com/2015/02/carl-sagan-extraordinary-evidence.jpg"}}),_vm._v(" "),_c('p',[_vm._v("A month is solid, but it isn't nearly strong enough to outweigh the prior improbability of being a $100/hr player.")]),_vm._v(" "),_c('p',[_vm._v("I want this to seem like common sense to you. At some level, I think it already is.")]),_vm._v(" "),_c('p',[_vm._v("Imagine that you're watching a basketball game and the score says 992-88. Would you think to yourself, \"Wow, the Blazers are really getting blown out tonight.\" No! You'd realize that it's a typo. And it would take a shit ton of evidence for you to actually believe that 992-88 is the real score.")]),_vm._v(" "),_c('p',[_vm._v("Imagine that you see people talking about what a blow out the game is on Twitter. That's more evidence that 992-88 is the real score, but it only nudges you in that direction slightly. You're still highly skeptical.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/prior-probability-and-estimating-your-winrate/3.png"}}),_vm._v(" "),_c('p',[_vm._v("Even if you saw a few articles online, you'd still probably only update a little bit. The journalists probably just made a mistake.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/prior-probability-and-estimating-your-winrate/4.png"}}),_vm._v(" "),_c('p',[_vm._v("If you start seeing a major player like ESPN publish an article, you'd probably start scratching your head.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/prior-probability-and-estimating-your-winrate/5.png"}}),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/prior-probability-and-estimating-your-winrate/6.png"}}),_vm._v(" "),_c('p',[_vm._v("Anyway, getting back to the point of this article, you can't just estimate your true winrate by looking at your actual winrate. Even though your actual winrate was $100/hr, you shouldn't estimate that to be your true winrate. You have to account for prior probability.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/prior-probability-and-estimating-your-winrate/7.png"}}),_vm._v(" "),_c('p',[_vm._v("Here's how I would approach things. First, try to get acquainted with some sort of distribution of typical winrates. Something like this:")]),_vm._v(" "),_c('img',{attrs:{"src":"http://www.thepokerbank.com/images/winrate-distribution.jpg"}}),_vm._v(" "),_c('p',[_vm._v("Then you have to try to figure out where you fall on that distribution. As you play more and more hands, that data starts to become pretty strong. But it takes a lot of hands to get to that point. Tens of thousands. Hopefully 100k+. What about before you get to that point?")]),_vm._v(" "),_c('p',[_vm._v("I think it makes sense to start incorporating more \"subjective\" data. For example, how much do you study? And how much do your opponents study? If you're studying a lot and your opponents aren't, then I think that's evidence that you can use to shift your estimate.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/prior-probability-and-estimating-your-winrate/8.png"}}),_vm._v(" "),_c('p',[_vm._v("Same with if you have more experience than them. Or if you review all of your hands and find that you're making the right plays, and you're discussing them with good players who also think you're making the right plays. I think that all of that sort of stuff is evidence that you can use to shift your estimate of where your true winrate is.")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('p',[_vm._v("Some parting advice: beware of overconfidence and bias. Don't take this as an excuse to say, \"I study poker, my opponents stuck, I know I've been breaking even for six months but I still think I'm a way better player than all of them.\"")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('subscribe-to-blog')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Prior probability and estimating your winrate")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("I'm going to talk about "),_c('a',{attrs:{"href":"https://arbital.com/p/bayes_rule/?l=1zq"}},[_vm._v("bayesian updating")]),_vm._v(" in this post, but I'm going to try to avoid technical language and actual numbers as much as possible. I want to convey that this sort of thinking is really just common sense.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Imagine that I asked you what you think your winrate is when you first moved to Vegas and haven't played a hand yet. Maybe you guess that it'd be $20/hr. Ok. That's your "),_c('em',[_vm._v("starting point")]),_vm._v(". What the cool kids call, your "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/Prior_probability"}},[_vm._v("prior")]),_vm._v(".")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("It makes sense to update your beliefs based on the "),_c('em',[_vm._v("strength")]),_vm._v(" of the evidence you have. If you only played for a few days, that evidence isn't really strong, so you wouldn't want to update your beliefs too much. But here we have a whole "),_c('em',[_vm._v("month's")]),_vm._v(" worth of data. That's a lot, right? So with this strong evidence, maybe we want to update our beliefs a lot?")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Well, that's one side of the coin. The other side of the coin is prior probability. Like I said in the beginning, a $100/hr winrate at $1/2 is unheard of. What does that mean? It means that you would need really really really strong evidence to justify believing that you actually are a $100/hr player. You may have heard "),_c('a',{attrs:{"href":"https://arbital.com/p/bayes_extraordinary_claims/"}},[_vm._v("\"extraordinary claims require extraordinary evidence\"")]),_vm._v(" before.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you start seeing "),_c('em',[_vm._v("multiple")]),_vm._v(" reliable sources publish an article, maybe you start thinking that it actually was the real score.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Notice that I put \"subjective\" in quotes earlier. Some people might say that this is all wishy-washy and you can't use this sort of stuff as evidence. All I can say to that is that it's wrong. "),_c('em',[_vm._v("Anything that nudges your belief one way or the other is evidence.")]),_vm._v(" Maybe it only nudges you a little bit. In that case it'd be weak evidence, but it still would be evidence. See "),_c('a',{attrs:{"href":"https://www.lesswrong.com/posts/fhojYBGGiYAFcryHZ/scientific-evidence-legal-evidence-rational-evidence"}},[_vm._v("Scientific Evidence, Legal Evidence, Rational Evidence")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fkhk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_constructor_vue__ = __webpack_require__("OGsk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2c1ccf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_constructor_vue__ = __webpack_require__("qaBB");
function injectStyle (ssrContext) {
  __webpack_require__("5ukL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b2c1ccf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_range_constructor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b2c1ccf_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_range_constructor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "flqx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fvjT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_initial_bet_size_button_group_vue__ = __webpack_require__("mbNt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ff6040_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_initial_bet_size_button_group_vue__ = __webpack_require__("eSp8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_initial_bet_size_button_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74ff6040_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_initial_bet_size_button_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g8te":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_general__ = __webpack_require__("1W+u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__ = __webpack_require__("Pc/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_hands__ = __webpack_require__("QCyo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utilities_results__ = __webpack_require__("RSTb");





/* harmony default export */ __webpack_exports__["a"] = ({
  general: __WEBPACK_IMPORTED_MODULE_0__services_utilities_general__["a" /* default */],
  ranks: __WEBPACK_IMPORTED_MODULE_1__services_utilities_ranks__["a" /* default */],
  hands: __WEBPACK_IMPORTED_MODULE_2__services_utilities_hands__["a" /* default */],
  results: __WEBPACK_IMPORTED_MODULE_3__services_utilities_results__["a" /* default */]
});

/***/ }),

/***/ "gCo1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"ppt-help"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Specific tools:")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/help/equity-calculator"}},[_vm._v("Equity calculator")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/help/hit-calculator"}},[_vm._v("Hit calculator")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/help/equity-matrix"}},[_vm._v("Equity matrix")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/help/range-constructor"}},[_vm._v("Range constructor")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/help/should-you-bluff"}},[_vm._v("Should you bluff?")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/help/should-you-call"}},[_vm._v("Should you call?")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/help/breakeven-percentage-for-bluffing-the-turn"}},[_vm._v("Breakeven percentage for bluffing the turn")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/help/three-bet-cbet-explorer"}},[_vm._v("3bet-cbet explorer")])],1)]),_vm._v(" "),_c('p',[_vm._v("Other:")]),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":"/faq"}},[_vm._v("FAQ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/quick-guide"}},[_vm._v("Quick guide")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/beginners-guide"}},[_vm._v("Beginners guide (old)")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/made-hands-and-draws"}},[_vm._v("Made hands and draws")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Help")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gHip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'rake-and-tip-settings',
  data: function data() {
    return {
      isHelpVisible: false
    };
  },
  computed: {
    settings: function settings() {
      return this.$store.state.account.user.settings;
    }
  },
  methods: {
    saveRakeAndTip: function saveRakeAndTip() {
      var user = _.cloneDeep(this.$store.state.account.user);
      var self = this;

      user.settings.equityCalculator.rakeAndTip = self._getRakeAndTip();
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    _getRakeAndTip: function _getRakeAndTip() {
      var rakePercentage = void 0;
      var tipPercentage = void 0;
      var potSize = Number(this.$refs.potSize.value);
      var initialRakePercentage = Number(this.$refs.initialRakePercentage.value);
      var rakeCap = Number(this.$refs.rakeCap.value);
      var tipAmount = Number(this.$refs.tipAmount.value);
      var rakeAndTip = {};

      // set potSize, initialRakePercentage, rakeCap, and tipAmount
      rakeAndTip.potSize = potSize;
      rakeAndTip.initialRakePercentage = initialRakePercentage;
      rakeAndTip.rakeCap = rakeCap;
      rakeAndTip.tipAmount = tipAmount;

      // calculate rake and tip percentage
      rakePercentage = Math.min(initialRakePercentage, rakeCap / potSize * 100);
      tipPercentage = tipAmount / potSize * 100;

      // set rake and tip percentage
      rakeAndTip.rakePercentage = rakePercentage;
      rakeAndTip.tipPercentage = tipPercentage;

      return rakeAndTip;
    },
    resetRakeAndTip: function resetRakeAndTip() {
      var self = this;
      var user = _.cloneDeep(this.$store.state.account.user);
      var defaultRakeAndTip = {
        potSize: 100,
        initialRakePercentage: 0,
        rakeCap: 0,
        tipAmount: 0,
        rakePercentage: 0,
        tipPercentage: 0
      };

      user.settings.equityCalculator.rakeAndTip = defaultRakeAndTip;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "gUwV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__ = __webpack_require__("oox5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_random_board_selector__ = __webpack_require__("8uf7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-flop-selector',
  components: {
    'short-deck-individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__["a" /* default */],
    'short-deck-random-board-selector': __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_random_board_selector__["a" /* default */]
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'popoverDirectionClass', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'flop3') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function _toggleNextDropdown(previousPosition) {
      var nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function __getNextPosition(previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    }
  }
});

/***/ }),

/***/ "gXeV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_scenarios_vue__ = __webpack_require__("wu3j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd028af4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_scenarios_vue__ = __webpack_require__("gdxS");
function injectStyle (ssrContext) {
  __webpack_require__("ZvOQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd028af4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_scenarios_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd028af4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_scenarios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gdxS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"saved-scenarios"},[_c('section',{staticClass:"panel panel-default"},[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"panel-body"},[(_vm.purchasedShortDeck && _vm.savedScenarios.shortDeckEquityCalculator.length > 0)?_c('section',[_c('span',[_vm._v("Short deck equity calculator:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'shortDeckEquityCalculator'}})],1):_vm._e(),_vm._v(" "),(_vm.purchasedShortDeck && _vm.savedScenarios.shortDeckHitCalculator.length > 0)?_c('section',[_c('span',[_vm._v("Short deck hit calculator:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'shortDeckHitCalculator'}})],1):_vm._e(),_vm._v(" "),(_vm.savedScenarios.equityCalculator.length > 0)?_c('section',[_c('span',[_vm._v("Equity calculator:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'equityCalculator'}})],1):_vm._e(),_vm._v(" "),(_vm.savedScenarios.hitCalculator.length > 0)?_c('section',[_c('span',[_vm._v("Hit calculator:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'hitCalculator'}})],1):_vm._e(),_vm._v(" "),(_vm.savedScenarios.equityMatrix.length > 0)?_c('section',[_c('span',[_vm._v("Equity matrix:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'equityMatrix'}})],1):_vm._e(),_vm._v(" "),(_vm.savedScenarios.rangeConstructor.length > 0)?_c('section',[_c('span',[_vm._v("Range constructor:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'rangeConstructor'}})],1):_vm._e(),_vm._v(" "),(_vm.savedScenarios.shouldYouBluff.length > 0)?_c('section',[_c('span',[_vm._v("Should you bluff:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'shouldYouBluff'}})],1):_vm._e(),_vm._v(" "),(_vm.savedScenarios.shouldYouCall.length > 0)?_c('section',[_c('span',[_vm._v("Should you call:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'shouldYouCall'}})],1):_vm._e(),_vm._v(" "),(_vm.savedScenarios.turnBluffBreakevenPercentage.length > 0)?_c('section',[_c('span',[_vm._v("Breakeven percentage for bluffing the turn:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'turnBluffBreakevenPercentage'}})],1):_vm._e(),_vm._v(" "),(_vm.savedScenarios.threeBetCbetExplorer.length > 0)?_c('section',[_c('span',[_vm._v("3bet-cbet explorer:")]),_vm._v(" "),_c('saved-scenarios-for-tool',{attrs:{"savedScenarios":_vm.savedScenarios,"tool":'threeBetCbetExplorer'}})],1):_vm._e(),_vm._v(" "),(_vm.pagesWithNoSavedScenarios.length > 0 && _vm.pagesWithNoSavedScenarios.length < 8)?_c('hr'):_vm._e(),_vm._v(" "),(_vm.pagesWithNoSavedScenarios.length > 0)?_c('p',[_vm._v(_vm._s(_vm.noSavedScenariosText))]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("\n        Saved scenarios\n        "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-save-scenarios"}},[_c('small',[_vm._v("What is this?")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ggGn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'beginners-guide'
});

/***/ }),

/***/ "gndg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gqru":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('errors-alert',{attrs:{"errors":_vm.errorsFromBackend},on:{"clear":function($event){return _vm.clearAlert()}}}),_vm._v(" "),_c('section',{staticClass:"alert alert-info"},[_c('p',[_vm._v("No credit card required right now. You'll automatically be entered into the 14 day free trial after you register. After that, you can choose to purchase the basic version for $25, or the premium version for $75.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("See the "),_c('router-link',{attrs:{"to":"/faq"}},[_vm._v("FAQ page")]),_vm._v(" for more info, and "),_c('router-link',{attrs:{"to":"/contact"}},[_vm._v("get in touch")]),_vm._v(" if you have any questions at all.")],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('form',[_c('section',{staticClass:"form-group",class:{ 'has-error': (_vm.submitAttempted && _vm.emailErrorMessage) }},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Email\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control input-lg",attrs:{"required":"","type":"email","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),(_vm.submitAttempted && _vm.emailErrorMessage)?_c('p',{staticClass:"help-block"},[_vm._v("\n        "+_vm._s(_vm.emailErrorMessage)+"\n      ")]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"form-group",class:{ 'has-error': (_vm.submitAttempted && _vm.passwordErrorMessage) }},[_c('label',{staticClass:"control-label"},[_vm._v("\n        Password\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"form-control input-lg",attrs:{"required":"","type":"text"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v("\n        Must be at least eight characters "),(_vm.password.length < 8)?_c('span',[_vm._v("ℹ️")]):_c('span',[_vm._v("✅")]),_vm._v(".\n        "),_c('span',{staticClass:"xkcd-toggle",on:{"click":function($event){$event.preventDefault();_vm.xkcdVisible = !_vm.xkcdVisible}}},[_vm._v("\n          Inspiration "),(!_vm.xkcdVisible)?_c('span',[_vm._v("▾")]):_c('span',[_vm._v("▴")])])]),_vm._v(" "),(_vm.submitAttempted && _vm.passwordErrorMessage)?_c('p',{staticClass:"help-block"},[_vm._v("\n        "+_vm._s(_vm.passwordErrorMessage)+"\n      ")]):_vm._e(),_vm._v(" "),(_vm.xkcdVisible)?_c('img',{attrs:{"src":"/static/xkcd-password-strength.png"}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailOptIn),expression:"emailOptIn"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.emailOptIn)?_vm._i(_vm.emailOptIn,null)>-1:(_vm.emailOptIn)},on:{"change":function($event){var $$a=_vm.emailOptIn,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.emailOptIn=$$a.concat([$$v]))}else{$$i>-1&&(_vm.emailOptIn=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.emailOptIn=$$c}}}}),_vm._v(" Opt in to receiving infrequent emails\n      ")]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v("\n        Some examples: important new features and \"What feature should I build next?\"-type questions. No spam or other bullshit.\n      ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",attrs:{"disabled":_vm.registering},on:{"click":function($event){$event.preventDefault();return _vm.registerWithEmail()}}},[_vm._v("\n      "+_vm._s(_vm.registerText)+"\n    ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-social btn-google btn-lg btn-block",attrs:{"href":_vm.googleRegistrationUrl,"disabled":_vm.registering}},[_c('i',{staticClass:"fab fa-google"}),_vm._v("\n      Register with Google\n    ")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-social btn-twitter btn-lg btn-block",attrs:{"href":_vm.twitterRegistrationUrl,"disabled":_vm.registering}},[_c('i',{staticClass:"fab fa-twitter"}),_vm._v("\n      Register with Twitter\n    ")])]),_vm._v(" "),_c('p',[_c('a',{staticClass:"btn btn-social btn-linkedin btn-lg btn-block",attrs:{"href":_vm.linkedinRegistrationUrl,"disabled":_vm.registering}},[_c('i',{staticClass:"fab fa-linkedin"}),_vm._v("\n      Register with LinkedIn\n    ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Already have an account? "),_c('router-link',{attrs:{"to":"/sign-in"}},[_vm._v("Sign in here")]),_vm._v(".")],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Register")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "grkG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gwng":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("The following thing has happened to me a lot. I study poker with John Doe once in a while. John and I are scheduled to study in a few days. I get an email from John saying that he hasn’t had a chance to play, or that he doesn’t have any interesting hands to go over, so maybe we should postpone another week.")]),_vm._v(" "),_c('p',[_vm._v("To John, studying poker is about reviewing hands.")]),_vm._v(" "),_c('p',[_vm._v("Then let’s say that John and I get together to study and have some interesting hands to go over. Here’s another thing that I often find. We go through a hand pretty quickly — maybe two or three minutes — decide what we think the right play would have been, and then we move on to the next hand.")]),_vm._v(" "),_c('p',[_vm._v("In my opinion, John is too “zoomed in”. I think he would benefit from zooming out when he studies poker. Let me explain what I mean by that with an example.")]),_vm._v(" "),_c('p',[_vm._v("Last night I was playing 1-2 at Red Rock. I had a spot where I think I should have made a big bluff, but I didn’t pull the trigger. Someone limps EP, main Villain limps behind, someone else limps, I iso to $15 from the CO with J8hh, and they all call. Flop comes KQ6r and it checks around. Turn is an offsuit 3.")]),_vm._v(" "),_c('p',[_vm._v("It checks to the main Villain, she bets $53 into the $61 pot, and it folds to me. I have about $220 behind. I wanted to shove, but I folded. (She showed 53o FWIW.)")]),_vm._v(" "),_c('p',[_vm._v("Why I wanted to shove is a little bit beside the point of this post, but it’s still worth some explanation. There’s a handful of reasons why, but the most important one to me is this lady’s preflop range. When she called my iso, she kinda mumbled to herself, “Ugh, I’m playing loose”. I don’t think she was trying to be deceptive. I believed her when she said that. So I really don’t think she has any sets. She’d probably 3bet KK and QQ, and I don’t think she makes that comment with 66 or 33. Or with KQ, K6s, or even K3s. Which leaves her with very little value. After playing around in Six Plus Hold’em, I came away pretty confident that a shove would have been +EV.")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("Try to look at it this way. There are soooooo many possible spots you could find yourself in as a poker player. Let’s just call it a trillion different spots.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/zoom-out/1.png","width":"400"}}),_vm._v(" "),_c('p',[_vm._v("If you only ask yourself what you would do in this one specific spot, well, that’s not really helping you that much. You’re probably never going to find yourself in that one specific spot ever again.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/zoom-out/2.png","width":"400"}}),_vm._v(" "),_c('p',[_vm._v("But, if you ask yourself what you would do in a bunch of related spots — if you zoom out — now you’re really helping yourself grow as a poker player.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/zoom-out/3.png","width":"400"}}),_vm._v(" "),_c('p',[_vm._v("Note that this concept isn’t unique to poker. Imagine that you just get your first job as a lawyer and want to understand how your mentor approached a certain case. Imagine that you’re a programmer trying to understand how your team lead was able to fix that nasty performance issue. Imagine that you’re a chef trying to understand why the owner adds fish sauce to the tomato sauce. You’re not just trying to understand that one particular scenario, you’re trying to get some more general takeaways.")]),_vm._v(" "),_c('p',[_vm._v("Maybe you think I’m arguing against a strawman here. Take the J8s hand for instance. I was saying that most people figure out what they want to do there, and then move on. I was sort of implying that they weren’t taking away any general lessons here. Maybe you want to respond and say that that’s not true. That by studying that specific hand, you naturally just sort of are able to see how things would be different under different circumstances. Maybe it’s just really clear that when we add all of the sets and other value combos to her range, that we no longer have a +EV bluff, for instance. Or that if she was a typical weaker 1-2 player, her range would be too value-heavy for us to make a play at the pot.")]),_vm._v(" "),_c('p',[_vm._v("Here’s my response to this. Yes, this happens. By studying one hand, you do naturally extract out some general lessons. However, I think that by explicitly trying to zoom out and ask yourself a bunch of related questions, you’re going to be able to extract out many more general lessons than you otherwise would. And I think that doing so is usually a better use of your study time than simply moving on to the next hand.")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/blog/zoom-out/4.png"}}),_vm._v(" "),_c('p',[_vm._v("Let’s end by returning to the very beginning of this post, where John wanted to postpone the study session because he didn’t have any hands to review. I always find that a little silly. It doesn’t mean you can’t study poker! You just have to zoom out!")]),_vm._v(" "),_c('p',[_vm._v("For example, instead of studying a particular hand, try to study something more general, like triple barreling them off top pair. Try to get a feel for when it is, and when it isn’t profitable to make that play. Try studying value 3betting, or 3bet bluffing, or cbet sizing, or whatever else you find interesting. There is so much to the game of poker. So many of these more general situations that you can study.")]),_vm._v(" "),_c('p',[_vm._v("Again, you don’t need a particular hand to study these sorts of things. You’re zooming out and asking yourself what you want to do with different hands, against different Villlains, on different boards, with different stack sizes, etc. etc. etc. If you do this, I think that you’ll find your study time to be a lot more productive.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('subscribe-to-blog')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Zoom out")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Now, back to the main point of this post: "),_c('em',[_vm._v("at this point when people study, they often just move on to the next hand")]),_vm._v(". I propose that you do something different. I propose that you "),_c('em',[_vm._v("zoom out:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Ask yourself what you would do if she didn’t make the comment preflop.")]),_vm._v(" "),_c('li',[_vm._v("Ask yourself what you would do if she tends to play a tighter range in general preflop (this lady played a lot of junky hands).")]),_vm._v(" "),_c('li',[_vm._v("Ask yourself what you would do if you were shorter stacked.")]),_vm._v(" "),_c('li',[_vm._v("Ask yourself what you would do if you were deeper stacked.")]),_vm._v(" "),_c('li',[_vm._v("Ask yourself what you would do if she’s a good handreader.")]),_vm._v(" "),_c('li',[_vm._v("A bad handreader.")]),_vm._v(" "),_c('li',[_vm._v("If you have a bluffy image.")]),_vm._v(" "),_c('li',[_vm._v("Etc. etc. etc.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gws6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_future_streets_1_vue__ = __webpack_require__("cEmC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd02ff2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_future_streets_1_vue__ = __webpack_require__("IkRe");
function injectStyle (ssrContext) {
  __webpack_require__("nzJx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fd02ff2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_future_streets_1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fd02ff2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_future_streets_1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gzNY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__ = __webpack_require__("yEsh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__ = __webpack_require__("tCnF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__ = __webpack_require__("kiNz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_five_card_hands_categories_FiveCardHandsCategory__ = __webpack_require__("siI+");









var Combos = function (_FiveCardHandsCategor) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Combos, _FiveCardHandsCategor);

  function Combos() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Combos);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Combos.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Combos)).call(this));

    _this.data = [new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
      id: 'tpwkPlusAnd',
      text: '<abbr title="Top pair weak kicker">TPWK</abbr>+',
      fullText: '<abbr title="Top pair weak kicker">TPWK</abbr>+',
      isAHit: function isAHit(handInfo, drawInfo) {
        var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
        var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
        var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
        var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
        var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
        var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

        return handInfo.id === 'pair:overpair' && (flushDraw || eightOutStraightDraw || gutshot || backdoorFlushDraw || backdoorStraightDraw) || handInfo.id === 'pair:tptk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw) || handInfo.id === 'pair:tpgk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw) || handInfo.id === 'pair:tpwk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw);
      },
      children: [new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
        id: 'tpwkPlusAnd:overpairAnd',
        text: 'Overpair and&hellip;',
        fullText: 'Overpair and&hellip;',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return handInfo.id === 'pair:overpair' && (flushDraw || eightOutStraightDraw || gutshot || backdoorFlushDraw || backdoorStraightDraw);
        },
        children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:overpairAnd:flushDraw',
          text: '&hellip;flush draw',
          fullText: 'Overpair and flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

            return handInfo.id === 'pair:overpair' && flushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:overpairAnd:eightOutStraightDraw',
          text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
          fullText: 'Overpair and eight out straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

            return handInfo.id === 'pair:overpair' && eightOutStraightDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:overpairAnd:gutshot',
          text: '&hellip;gutshot',
          fullText: 'Overpair and gutshot',
          isAHit: function isAHit(handInfo, drawInfo) {
            var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

            return handInfo.id === 'pair:overpair' && gutshot;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:overpairAnd:backdoorFlushDraw',
          text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
          fullText: 'Overpair and backdoor flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

            return handInfo.id === 'pair:overpair' && backdoorFlushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:overpairAnd:backdoorStraightDraw',
          text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
          fullText: 'Overpair and backdoor straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorStraightDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

            return handInfo.id === 'pair:overpair' && backdoorStraightDraw;
          }
        })]
      }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
        id: 'tpwkPlusAnd:tptkAnd',
        text: '<abbr title="Top pair top kicker">TPTK</abbr> and&hellip;',
        fullText: '<abbr title="Top pair top kicker">TPTK</abbr> and&hellip;',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return handInfo.id === 'pair:tptk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw);
        },
        children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tptkAnd:flushDraw',
          text: '&hellip;flush draw',
          fullText: 'TPTK and flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

            return handInfo.id === 'pair:tptk' && flushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tptkAnd:eightOutStraightDraw',
          text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
          fullText: 'TPTK and eight out straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

            return handInfo.id === 'pair:tptk' && eightOutStraightDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tptkAnd:gutshot',
          text: '&hellip;gutshot',
          fullText: 'TPTK and gutshot',
          isAHit: function isAHit(handInfo, drawInfo) {
            var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

            return handInfo.id === 'pair:tptk' && gutshot;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tptkAnd:oneOvercard',
          text: '&hellip;1 overcard',
          fullText: 'TPTK and one overcard',
          isAHit: function isAHit(handInfo, drawInfo) {
            var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

            return handInfo.id === 'pair:tptk' && oneOvercard;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tptkAnd:backdoorFlushDraw',
          text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
          fullText: 'TPTK and backdoor flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

            return handInfo.id === 'pair:tptk' && backdoorFlushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tptkAnd:backdoorStraightDraw',
          text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
          fullText: 'TPTK and backdoor straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

            return handInfo.id === 'pair:tptk' && backdoorStraightDraw;
          }
        })]
      }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
        id: 'tpwkPlusAnd:tpgkAnd',
        text: '<abbr title="Top pair good kicker">TPGK</abbr> and&hellip;',
        fullText: '<abbr title="Top pair good kicker">TPGK</abbr> and&hellip;',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return handInfo.id === 'pair:tpgk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw);
        },
        children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpgkAnd:flushDraw',
          text: '&hellip;flush draw',
          fullText: 'TPGK and flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

            return handInfo.id === 'pair:tpgk' && flushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpgkAnd:eightOutStraightDraw',
          text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
          fullText: 'TPGK and eight out straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

            return handInfo.id === 'pair:tpgk' && eightOutStraightDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpgkAnd:gutshot',
          text: '&hellip;gutshot',
          fullText: 'TPGK and gutshot',
          isAHit: function isAHit(handInfo, drawInfo) {
            var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

            return handInfo.id === 'pair:tpgk' && gutshot;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpgkAnd:oneOvercard',
          text: '&hellip;1 overcard',
          fullText: 'TPGK and one overcard',
          isAHit: function isAHit(handInfo, drawInfo) {
            var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

            return handInfo.id === 'pair:tpgk' && oneOvercard;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpgkAnd:backdoorFlushDraw',
          text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
          fullText: 'TPGK and backdoor flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

            return handInfo.id === 'pair:tpgk' && backdoorFlushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpgkAnd:backdoorStraightDraw',
          text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
          fullText: 'TPGK and backdoor straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

            return handInfo.id === 'pair:tpgk' && backdoorStraightDraw;
          }
        })]
      }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
        id: 'tpwkPlusAnd:tpwkAnd',
        text: '<abbr title="Top pair weak kicker">TPWK</abbr> and&hellip;',
        fullText: '<abbr title="Top pair weak kicker">TPWK</abbr> and&hellip;',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return handInfo.id === 'pair:tpwk' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw);
        },
        children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpwkAnd:flushDraw',
          text: '&hellip;flush draw',
          fullText: 'TPWK and flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

            return handInfo.id === 'pair:tpwk' && flushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpwkAnd:eightOutStraightDraw',
          text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
          fullText: 'TPWK and eight out straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

            return handInfo.id === 'pair:tpwk' && eightOutStraightDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpwkAnd:gutshot',
          text: '&hellip;gutshot',
          fullText: 'TPWK and gutshot',
          isAHit: function isAHit(handInfo, drawInfo) {
            var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

            return handInfo.id === 'pair:tpwk' && gutshot;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpwkAnd:oneOvercard',
          text: '&hellip;1 overcard',
          fullText: 'TPWK and one overcard',
          isAHit: function isAHit(handInfo, drawInfo) {
            var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

            return handInfo.id === 'pair:tpwk' && oneOvercard;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpwkAnd:backdoorFlushDraw',
          text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
          fullText: 'TPWK and backdoor flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

            return handInfo.id === 'pair:tpwk' && backdoorFlushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'tpwkPlusAnd:tpwkAnd:backdoorStraightDraw',
          text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
          fullText: 'TPWK and backdoor straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

            return handInfo.id === 'pair:tpwk' && backdoorStraightDraw;
          }
        })]
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
      id: 'middlePairPlusAnd',
      text: 'Middle pair+',
      fullText: 'Middle pair+',
      isAHit: function isAHit(handInfo, drawInfo) {
        var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
        var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
        var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
        var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
        var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
        var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

        return handInfo.id === 'pair:ppUnderTp' && (flushDraw || eightOutStraightDraw || gutshot || backdoorFlushDraw || backdoorStraightDraw) || handInfo.id === 'pair:secondPair' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard) || handInfo.id === 'pair:middlePair' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw);
      },
      children: [new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
        id: 'middlePairPlusAnd:ppUnderTpAnd',
        text: '<abbr title="Pocket pair under top pair">PP under TP</abbr> and&hellip;',
        fullText: '<abbr title="Pocket pair under top pair">PP under TP</abbr> and&hellip;',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return handInfo.id === 'pair:ppUnderTp' && (flushDraw || eightOutStraightDraw || gutshot || backdoorFlushDraw || backdoorStraightDraw);
        },
        children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:ppUnderTpAnd:flushDraw',
          text: '&hellip;flush draw',
          fullText: 'PP under TP and flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

            return handInfo.id === 'pair:ppUnderTp' && flushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:ppUnderTpAnd:eightOutStraightDraw',
          text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
          fullText: 'PP under TP and eight out straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

            return handInfo.id === 'pair:ppUnderTp' && eightOutStraightDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:ppUnderTpAnd:gutshot',
          text: '&hellip;gutshot',
          fullText: 'PP under TP and gutshot',
          isAHit: function isAHit(handInfo, drawInfo) {
            var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

            return handInfo.id === 'pair:ppUnderTp' && gutshot;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:ppUnderTpAnd:backdoorFlushDraw',
          text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
          fullText: 'PP under TP and backdoor flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

            return handInfo.id === 'pair:ppUnderTp' && backdoorFlushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:ppUnderTpAnd:backdoorStraightDraw',
          text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
          fullText: 'PP under TP and backdoor straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

            return handInfo.id === 'pair:ppUnderTp' && backdoorStraightDraw;
          }
        })]
      }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
        id: 'middlePairPlusAnd:secondPairAnd',
        text: 'Second pair and&hellip;',
        fullText: 'Second pair and&hellip;',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return handInfo.id === 'pair:secondPair' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard);
        },
        children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:secondPairAnd:flushDraw',
          text: '&hellip;flush draw',
          fullText: 'Second pair and flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

            return handInfo.id === 'pair:secondPair' && flushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:secondPairAnd:eightOutStraightDraw',
          text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
          fullText: 'Second pair and eight out straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

            return handInfo.id === 'pair:secondPair' && eightOutStraightDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:secondPairAnd:gutshot',
          text: '&hellip;gutshot',
          fullText: 'Second pair and gutshot',
          isAHit: function isAHit(handInfo, drawInfo) {
            var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

            return handInfo.id === 'pair:secondPair' && gutshot;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:secondPairAnd:oneOvercard',
          text: '&hellip;1 overcard',
          fullText: 'Second pair and one overcard',
          isAHit: function isAHit(handInfo, drawInfo) {
            var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

            return handInfo.id === 'pair:secondPair' && oneOvercard;
          }
        })]
      }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
        id: 'middlePairPlusAnd:middlePairAnd',
        text: 'Middle pair and&hellip;',
        fullText: 'Middle pair and&hellip;',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return handInfo.id === 'pair:middlePair' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw);
        },
        children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:middlePairAnd:flushDraw',
          text: '&hellip;flush draw',
          fullText: 'Middle pair and flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

            return handInfo.id === 'pair:middlePair' && flushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:middlePairAnd:eightOutStraightDraw',
          text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
          fullText: 'Middle pair and eight out straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

            return handInfo.id === 'pair:middlePair' && eightOutStraightDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:middlePairAnd:gutshot',
          text: '&hellip;gutshot',
          fullText: 'Middle pair and gutshot',
          isAHit: function isAHit(handInfo, drawInfo) {
            var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

            return handInfo.id === 'pair:middlePair' && gutshot;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:middlePairAnd:oneOvercard',
          text: '&hellip;1 overcard',
          fullText: 'Middle pair and one overcard',
          isAHit: function isAHit(handInfo, drawInfo) {
            var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

            return handInfo.id === 'pair:middlePair' && oneOvercard;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:middlePairAnd:backdoorFlushDraw',
          text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
          fullText: 'Middle pair and backdoor flush draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

            return handInfo.id === 'pair:middlePair' && backdoorFlushDraw;
          }
        }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
          id: 'middlePairPlusAnd:middlePairAnd:backdoorStraightDraw',
          text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
          fullText: 'Middle pair and backdoor straight draw',
          isAHit: function isAHit(handInfo, drawInfo) {
            var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

            return handInfo.id === 'pair:middlePair' && backdoorStraightDraw;
          }
        })]
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
      id: 'weakPairAnd',
      text: 'Weak pair and&hellip;',
      fullText: 'Weak pair and&hellip;',
      isAHit: function isAHit(handInfo, drawInfo) {
        var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
        var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
        var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
        var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
        var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
        var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

        return handInfo.id === 'pair:weakPair' && (flushDraw || eightOutStraightDraw || gutshot || oneOvercard || backdoorFlushDraw || backdoorStraightDraw);
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'weakPairAnd:flushDraw',
        text: '&hellip;flush draw',
        fullText: 'Weak pair and flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';

          return handInfo.id === 'pair:weakPair' && flushDraw;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'weakPairAnd:eightOutStraightDraw',
        text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
        fullText: 'Weak pair and eight out straight draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

          return handInfo.id === 'pair:weakPair' && eightOutStraightDraw;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'weakPairAnd:gutshot',
        text: '&hellip;gutshot',
        fullText: 'Weak pair and gutshot',
        isAHit: function isAHit(handInfo, drawInfo) {
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

          return handInfo.id === 'pair:weakPair' && gutshot;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'weakPairAnd:oneOvercard',
        text: '&hellip;1 overcard',
        fullText: 'Weak pair and one overcard',
        isAHit: function isAHit(handInfo, drawInfo) {
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

          return handInfo.id === 'pair:weakPair' && oneOvercard;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'weakPairAnd:backdoorFlushDraw',
        text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
        fullText: 'Weak pair and backdoor flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

          return handInfo.id === 'pair:weakPair' && backdoorFlushDraw;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'weakPairAnd:backdoorStraightDraw',
        text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
        fullText: 'Weak pair and backdoor straight draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return handInfo.id === 'pair:weakPair' && backdoorStraightDraw;
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
      id: 'flushDrawAnd',
      text: 'Flush draw and&hellip;',
      fullText: 'Flush draw and&hellip;',
      isAHit: function isAHit(handInfo, drawInfo) {
        var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
        var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
        var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
        var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
        var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
        var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

        return flushDraw && (eightOutStraightDraw || gutshot || twoOvercards || oneOvercard || backdoorStraightDraw);
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'flushDrawAnd:eightOutStraightDraw',
        text: '&hellip;<abbr title="Eight out straight draw">8OSD</abbr>',
        fullText: 'Flush draw and eight out straight draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');

          return flushDraw && eightOutStraightDraw;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'flushDrawAnd:gutshot',
        text: '&hellip;gutshot',
        fullText: 'Flush draw and gutshot',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';

          return flushDraw && gutshot;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'flushDrawAnd:twoOvercards',
        text: '&hellip;2 overcards',
        fullText: 'Flush draw and two overcards',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

          return flushDraw && twoOvercards;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'flushDrawAnd:oneOvercard',
        text: '&hellip;1 overcard',
        fullText: 'Flush draw and one overcard',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

          return flushDraw && oneOvercard;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'flushDrawAnd:backdoorStraightDraw',
        text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
        fullText: 'Flush draw and backdoor straight draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var flushDraw = drawInfo.flush && drawInfo.flush.type === 'four card';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return flushDraw && backdoorStraightDraw;
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
      id: 'eightOutStraightDrawAnd',
      text: '<abbr title="Eight out straight draw">8OSD</abbr> and&hellip;',
      fullText: '<abbr title="Eight out straight draw">8OSD</abbr> and&hellip;',
      isAHit: function isAHit(handInfo, drawInfo) {
        var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
        var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
        var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
        var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

        return eightOutStraightDraw && (twoOvercards || oneOvercard || backdoorFlushDraw);
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'eightOutStraightDrawAnd:twoOvercards',
        text: '&hellip;2 overcards',
        fullText: 'Eight out straight draw and two overcards',
        isAHit: function isAHit(handInfo, drawInfo) {
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

          return eightOutStraightDraw && twoOvercards;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'eightOutStraightDrawAnd:oneOvercard',
        text: '&hellip;1 overcard',
        fullText: 'Eight out straight draw and one overcard',
        isAHit: function isAHit(handInfo, drawInfo) {
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

          return eightOutStraightDraw && oneOvercard;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'eightOutStraightDrawAnd:backdoorFlushDraw',
        text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
        fullText: 'Eight out straight draw and backdoor flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var eightOutStraightDraw = drawInfo.straight && (drawInfo.straight.type === 'open ended' || drawInfo.straight.type === 'double gutshot');
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

          return eightOutStraightDraw && backdoorFlushDraw;
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
      id: 'gutshotAnd',
      text: 'Gutshot and&hellip;',
      fullText: 'Gutshot and&hellip;',
      isAHit: function isAHit(handInfo, drawInfo) {
        var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
        var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
        var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
        var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

        return gutshot && (twoOvercards || oneOvercard || backdoorFlushDraw);
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'gutshotAnd:twoOvercards',
        text: '&hellip;2 overcards',
        fullText: 'Gutshot and two overcards',
        isAHit: function isAHit(handInfo, drawInfo) {
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

          return gutshot && twoOvercards;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'gutshotAnd:oneOvercard',
        text: '&hellip;1 overcard',
        fullText: 'Gutshot and one overcard',
        isAHit: function isAHit(handInfo, drawInfo) {
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

          return gutshot && oneOvercard;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'gutshotAnd:backdoorFlushDraw',
        text: '&hellip;<abbr title="Backdoor flush draw">bckdr fl dr</abbr>',
        fullText: 'Gutshot and backdoor flush draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var gutshot = drawInfo.straight && drawInfo.straight.type === 'gutshot';
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';

          return gutshot && backdoorFlushDraw;
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
      id: 'backdoorFlushDrawAnd',
      text: '<abbr title="Backdoor flush draw">Bckdr fl dr</abbr> and&hellip;',
      fullText: '<abbr title="Backdoor flush draw">Bckdr fl dr</abbr> and&hellip;',
      isAHit: function isAHit(handInfo, drawInfo) {
        var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
        var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
        var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';
        var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

        return backdoorFlushDraw && (twoOvercards || oneOvercard || backdoorStraightDraw);
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'backdoorFlushDrawAnd:twoOvercards',
        text: '&hellip;2 overcards',
        fullText: 'Backdoor flush draw and two overcards',
        isAHit: function isAHit(handInfo, drawInfo) {
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

          return backdoorFlushDraw && twoOvercards;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'backdoorFlushDrawAnd:oneOvercard',
        text: '&hellip;1 overcard',
        fullText: 'Backdoor flush draw and one overcard',
        isAHit: function isAHit(handInfo, drawInfo) {
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

          return backdoorFlushDraw && oneOvercard;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'backdoorFlushDrawAnd:backdoorStraightDraw',
        text: '&hellip;<abbr title="Backdoor straight draw">bckdr str dr</abbr>',
        fullText: 'Backdoor flush draw and backdoor straight draw',
        isAHit: function isAHit(handInfo, drawInfo) {
          var backdoorFlushDraw = drawInfo.flush && drawInfo.flush.type === 'backdoor';
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';

          return backdoorFlushDraw && backdoorStraightDraw;
        }
      })]
    }), new __WEBPACK_IMPORTED_MODULE_6__services_five_card_hands_five_card_hand_parent_ComboParent__["a" /* default */]({
      id: 'backdoorStraightDrawAnd',
      text: '<abbr title="Backdoor straight draw">Bckdr str dr</abbr> and&hellip;',
      fullText: '<abbr title="Backdoor straight draw">Bckdr str dr</abbr> and&hellip;',
      isAHit: function isAHit(handInfo, drawInfo) {
        var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';
        var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';
        var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

        return backdoorStraightDraw && (twoOvercards || oneOvercard);
      },
      children: [new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'backdoorStraightDrawAnd:twoOvercards',
        text: '&hellip;2 overcards',
        fullText: 'Backdoor straight draw and two overcards',
        isAHit: function isAHit(handInfo, drawInfo) {
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';
          var twoOvercards = drawInfo.topPair && drawInfo.topPair.type === 'two overcards';

          return backdoorStraightDraw && twoOvercards;
        }
      }), new __WEBPACK_IMPORTED_MODULE_5__services_five_card_hands_five_card_hand_leaf_ComboLeaf__["a" /* default */]({
        id: 'backdoorStraightDrawAnd:oneOvercard',
        text: '&hellip;1 overcard',
        fullText: 'Backdoor straight draw and one overcard',
        isAHit: function isAHit(handInfo, drawInfo) {
          var backdoorStraightDraw = drawInfo.straight && drawInfo.straight.type === 'backdoor';
          var oneOvercard = drawInfo.topPair && drawInfo.topPair.type === 'one overcard';

          return backdoorStraightDraw && oneOvercard;
        }
      })]
    })];
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_get___default()(Combos.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Combos.prototype), 'setBreadcrumbText', _this).call(_this);
    return _this;
  }

  return Combos;
}(__WEBPACK_IMPORTED_MODULE_7__services_five_card_hands_categories_FiveCardHandsCategory__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Combos);
;

/***/ }),

/***/ "h/CU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_narrow_range_modal_vue__ = __webpack_require__("LO8Z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66be20aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_narrow_range_modal_vue__ = __webpack_require__("KCAa");
function injectStyle (ssrContext) {
  __webpack_require__("uWKX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66be20aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_narrow_range_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66be20aa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_narrow_range_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h7mF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLeQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hand_rankings_vue__ = __webpack_require__("WRsF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f75d6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hand_rankings_vue__ = __webpack_require__("TlKt");
function injectStyle (ssrContext) {
  __webpack_require__("h7mF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08f75d6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hand_rankings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f75d6c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hand_rankings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hR++":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_modal_vue__ = __webpack_require__("4Tse");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d721440_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_modal_vue__ = __webpack_require__("dd8B");
function injectStyle (ssrContext) {
  __webpack_require__("J4LV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d721440"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_help_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d721440_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_help_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hVKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_header__ = __webpack_require__("y8dE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_grid_selector__ = __webpack_require__("9N94");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hand_range_slider_selector_slider_selector__ = __webpack_require__("OjzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hand_range_text_selector_text_selector__ = __webpack_require__("lMB+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_hand_range_hand_weight_vertical_set_weight_to_apply_to_added_hands_vertical_set_weight_to_apply_to_added_hands__ = __webpack_require__("zc1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_hand_range_hand_weight_horizontal_set_weight_to_apply_to_added_hands_basic__ = __webpack_require__("rIA0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_hand_range_tier_selector__ = __webpack_require__("o2lI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_hand_range_category_selector__ = __webpack_require__("H9xH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_hand_range_saved_ranges_selector__ = __webpack_require__("TMYU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-hand-range',
  components: {
    'hand-range-header': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_header__["a" /* default */],
    'short-deck-grid-selector': __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_grid_selector__["a" /* default */],
    'slider-selector': __WEBPACK_IMPORTED_MODULE_2__components_hand_range_slider_selector_slider_selector__["a" /* default */],
    'text-selector': __WEBPACK_IMPORTED_MODULE_3__components_hand_range_text_selector_text_selector__["a" /* default */],
    'vertical-set-weight-to-apply-to-added-hands': __WEBPACK_IMPORTED_MODULE_4__components_hand_range_hand_weight_vertical_set_weight_to_apply_to_added_hands_vertical_set_weight_to_apply_to_added_hands__["a" /* default */],
    'horizontal-set-weight-to-apply-to-added-hands-basic': __WEBPACK_IMPORTED_MODULE_5__components_hand_range_hand_weight_horizontal_set_weight_to_apply_to_added_hands_basic__["a" /* default */],
    'tier-selector': __WEBPACK_IMPORTED_MODULE_6__components_hand_range_tier_selector__["a" /* default */],
    'category-selector': __WEBPACK_IMPORTED_MODULE_7__components_hand_range_category_selector__["a" /* default */],
    'saved-ranges-selector': __WEBPACK_IMPORTED_MODULE_8__components_hand_range_saved_ranges_selector__["a" /* default */]
  },
  props: ['generalHands', 'weightToApplyToAddedHands', 'combosToAdd', 'disableAllSelectors', 'disableAllButGridSelector', 'canBeRemoved', 'specificHandsNotAllowed'],
  data: function data() {
    return {
      activeTab: 'saved-ranges' // or 'tiers', or 'categories'
    };
  },
  computed: {
    includedSelectors: function includedSelectors() {
      return this.$store.state.account.user.settings.general.includedSelectors;
    },
    settingHandWeightsSetting: function settingHandWeightsSetting() {
      return this.$store.state.account.user.settings.general.visual.settingHandWeights;
    }
  },
  mounted: function mounted() {
    this.refreshDoubleSlider();
    this.refreshVerticalSetWeightToApplyToAddedHandsSlider();
    this.refreshHorizontalSetWeightToApplyToAddedHandsSlider();
  },
  updated: function updated() {
    this.refreshDoubleSlider();
    this.refreshVerticalSetWeightToApplyToAddedHandsSlider();
    this.refreshHorizontalSetWeightToApplyToAddedHandsSlider();
  },
  methods: {
    emitAndResetDoubleSlider: function emitAndResetDoubleSlider(eventName, arg1) {
      this.$emit(eventName, arg1);
      this.resetDoubleSlider();
    },
    resetDoubleSlider: function resetDoubleSlider() {
      this.$refs.sliderSelector.resetDoubleSlider();
    },
    refreshDoubleSlider: function refreshDoubleSlider() {
      this.$refs.sliderSelector.refreshDoubleSlider();
    },
    refreshVerticalSetWeightToApplyToAddedHandsSlider: function refreshVerticalSetWeightToApplyToAddedHandsSlider() {
      if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings') {
        this.$refs.verticalSetWeightToApplyToAddedHandsSlider.refreshVueSlider();
      }
    },
    refreshHorizontalSetWeightToApplyToAddedHandsSlider: function refreshHorizontalSetWeightToApplyToAddedHandsSlider() {
      if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic' || this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings') {
        this.$refs.horizontalSetWeightToApplyToAddedHandsSlider.refreshVueSlider();
      }
    }
  }
});

/***/ }),

/***/ "hZMi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'help-icon',
  props: ['path', 'position']
});

/***/ }),

/***/ "haFD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hd12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("About")])]),_vm._v(" "),_c('h3',[_vm._v("What is Six Plus Hold’em?")]),_vm._v(" "),_c('p',[_vm._v("\n    Six Plus Hold’em is an app that makes it easier to study poker. Check\n    out the playlists below:\n  ")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8vRDnCZ_h1XsBar-k190Bs","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa8rhfjlwM7OFsq_1YDfJNCf","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Who is behind Six Plus Hold’em?")]),_vm._v(" "),_c('p',[_vm._v("\n    Me! My name is Adam Zerner. I'm 26 years old and live in Summerlin, Las\n    Vegas with my girlfriend and dog. I guess I'd call myself a serial\n    entrepreneur. I plan on starting startups throughout my life, and this is\n    my second one. Before Six Plus Hold’em I worked as a programmer,\n    started a startup called College Inside View, and got my degree in\n    neuroscience at Pitt.\n  ")]),_vm._v(" "),_c('h3',[_vm._v("What's the story behind Six Plus Hold’em?")]),_vm._v(" "),_c('p',[_vm._v("\n    After working as a programmer for two years, I had taken a year off to\n    self-study computer science. At the end of the year, I wanted to freelance\n    a bit to save up some more money before starting a startup. But my web\n    development skills had gotten rusty after focusing so much on computer\n    science, so I needed a project to dust off the rust.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    When I was looking for a project, I thought back to Flopzilla and Equilab.\n    I wanted to download them a few months back, but I wasn't able to because\n    I'm a Mac user. So I figured that for my project, I'd build myself a basic\n    version of those apps.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    Well, that project turned in to Six Plus Hold’em. I was having a really\n    good time working on it and I started realizing that it could be better\n    than the existing apps out there. That's when it turned in to my full time\n    pursuit.\n  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hdqd":
/***/ (function(module, exports) {

Array.prototype.pushEachElement = function (otherArray) {
  for (var i = 0, len = otherArray.length; i < len; i++) {
    this.push(otherArray[i]);
  }
};
Array.prototype.pushIfNotIncluded = function (el) {
  if (!this.includes(el)) {
    this.push(el);
  }
};
Array.prototype.removeIfIncluded = function (el) {
  if (this.includes(el)) {
    var indexOfElementToRemove = this.indexOf(el);

    this.splice(indexOfElementToRemove, 1);
  }
};
Array.prototype.last = function () {
  return this[this.length - 1];
};
Array.prototype.move = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};
Array.prototype.getElementsUpToAndIncluding = function (el) {
  var index = this.indexOf(el);

  if (index < 0) {
    return [];
  }

  return this.slice(0, index);
};
Number.prototype.roundToNearestFive = function () {
  var decimalPointIndex = void 0;
  var onesPlaceAndToTheRight = void 0;
  var toTheLeftOfOnesPlace = void 0;
  var returnValue = void 0;
  var number = void 0;

  number = this.toString();
  decimalPointIndex = number.indexOf('.');

  if (decimalPointIndex === -1) {
    decimalPointIndex = number.length;
  }
  onesPlaceAndToTheRight = number.substring(decimalPointIndex - 1);
  onesPlaceAndToTheRight = Number(onesPlaceAndToTheRight);
  toTheLeftOfOnesPlace = number.substring(0, decimalPointIndex - 1);

  if (onesPlaceAndToTheRight >= 0 && onesPlaceAndToTheRight < 2.5) {
    toTheLeftOfOnesPlace += '0';
    returnValue = Number(toTheLeftOfOnesPlace);
  } else if (onesPlaceAndToTheRight >= 2.5 && onesPlaceAndToTheRight < 7.5) {
    toTheLeftOfOnesPlace += '5';
    returnValue = Number(toTheLeftOfOnesPlace);
  } else if (onesPlaceAndToTheRight >= 7.5) {
    toTheLeftOfOnesPlace += '0';
    toTheLeftOfOnesPlace = Number(toTheLeftOfOnesPlace);
    toTheLeftOfOnesPlace += 10;
    returnValue = toTheLeftOfOnesPlace;
  } else {
    throw new Error('Invalid value for onesPlaceAndToTheRight: ', onesPlaceAndToTheRight);
  }

  return returnValue;
};
Number.prototype.roundToOneDecimalPlace = function () {
  return Number(this.toFixed(1));
};
Number.prototype.roundToTwoDecimalPlaces = function () {
  return Number(this.toFixed(2));
};

/***/ }),

/***/ "hf1u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-matrix-result-table',
  props: ['generalHands'],
  computed: {
    generalHandsOrderedByEquity: function generalHandsOrderedByEquity() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.sortBy(this.generalHands._data, function (generalHand) {
        return -generalHand.equity;
      });
    }
  }
});

/***/ }),

/***/ "hfvn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-help'
});

/***/ }),

/***/ "hk4/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-matrix-help'
});

/***/ }),

/***/ "hkfp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hmzL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alerts_vue__ = __webpack_require__("s3fm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df06f998_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alerts_vue__ = __webpack_require__("onxA");
function injectStyle (ssrContext) {
  __webpack_require__("RnAW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df06f998"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alerts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df06f998_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alerts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hnCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hit-calculator"},[_c('div',{staticClass:"simulation-progress"}),_vm._v(" "),(!_vm.authorized)?_c('readonly-alert'):_vm._e(),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h4',[_vm._v("How many opponents are you facing?")]),_vm._v(" "),_c('num-opponents-selector',{attrs:{"numOpponents":_vm.state.players.numPlayers,"authorized":_vm.authorized},on:{"addOpponent":function($event){return _vm.addPlayer()},"removeOpponent":function($event){return _vm.removePlayer()}}}),_vm._v(" "),_c('h4',[_vm._v("What are your hole cards?")]),_vm._v(" "),_c('hole-cards-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setPresetHoleCard":function($event){return _vm.setPresetHoleCard($event)},"removePresetHoleCard":function($event){return _vm.removePresetHoleCard($event)}}}),_vm._v(" "),_c('h4',[_vm._v("What are the board cards?")]),_vm._v(" "),_c('preset-community-cards-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)}}}),_vm._v(" "),_c('h3',[_vm._v("Preflop")]),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('range-for-street',{key:("preflop-" + (player.id)),ref:("preflop-" + playerIndex),refInFor:true,attrs:{"player":player,"playerIndex":playerIndex,"playerStateIndex":0,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"storeModuleName":'hitCalculator',"authorized":_vm.authorized}},[((_vm.state.presetHoleCards.bothSet && !_vm.state.players.hasEmptyRange('preflop')))?_c('section',{staticClass:"equity-results-container",attrs:{"slot":"left-header"},slot:"left-header"},[_c('equity-results',{attrs:{"equity":player.states[0].equity,"equityString":player.states[0].equityString,"winPercentageString":player.states[0].winPercentageString,"tiePercentageString":player.states[0].tiePercentageString,"hasSimulationBeenRun":_vm.ableToGetPreflopEquities()}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This shows the equity that this range has against the selected hole cards in step two, and against any other preflop ranges if you're facing multiple opponents.","data-toggle":"tooltip","data-placement":"top"}})],1):_vm._e()])}),_vm._v(" "),_c('h3',[_vm._v("Flop")]),_vm._v(" "),_c('flop-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)}}}),_vm._v(" "),(_vm.state.players.numPlayers > 1)?_c('cumulative-hit-percentages',{attrs:{"cumulativeHitPercentages":_vm.cumulativeHitPercentages,"moreThanTwoPlayers":_vm.state.players.numPlayers > 2,"streetsToDisplay":['flop']}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('range-for-street',{key:("flop-" + (player.id)),ref:("flop-" + playerIndex),refInFor:true,attrs:{"player":player,"playerIndex":playerIndex,"playerStateIndex":1,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(1),"storeModuleName":'hitCalculator',"simulateButton":_vm.showNonexhaustiveSimulationButton(playerIndex, 'flop'),"authorized":_vm.authorized},on:{"simulate":function($event){return _vm.runNonexhaustiveFiveCardHandPercentagesSimulationsForFlop(playerIndex)}}},[((_vm.state.presetHoleCards.bothSet && _vm.state.presetCommunityCards.flopSet && !_vm.state.players.hasEmptyRange('flop')))?_c('section',{staticClass:"equity-results-container",attrs:{"slot":"left-header"},slot:"left-header"},[_c('equity-results',{attrs:{"equity":player.states[1].equity,"equityString":player.states[1].equityString,"winPercentageString":player.states[1].winPercentageString,"tiePercentageString":player.states[1].tiePercentageString,"hasSimulationBeenRun":_vm.ableToGetFlopEquities()}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This shows the equity that this range has against the selected hole cards in step two, and against any other flop ranges if you're facing multiple opponents. It assumes that the flop will always be what you have it set as, but that the turn and river will be dealt randomly.","data-toggle":"tooltip","data-placement":"top"}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.numSet <= 3)?_c('hit-calculator-insights',{attrs:{"slot":"insights","hitPercentage":player.states[1].hitPercentage,"hitPercentageUpToDate":_vm.isHitPercentageUpToDate[playerIndex][0]},slot:"insights"}):_vm._e()],1)}),_vm._v(" "),_c('h3',[_vm._v("Turn")]),_vm._v(" "),_c('turn-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)}}}),_vm._v(" "),(_vm.state.players.numPlayers > 1)?_c('cumulative-hit-percentages',{attrs:{"cumulativeHitPercentages":_vm.cumulativeHitPercentages,"moreThanTwoPlayers":_vm.state.players.numPlayers > 2,"streetsToDisplay":['turn']}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('range-for-street',{key:("turn-" + (player.id)),ref:("turn-" + playerIndex),refInFor:true,attrs:{"player":player,"playerIndex":playerIndex,"playerStateIndex":2,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(2),"storeModuleName":'hitCalculator',"simulateButton":_vm.showNonexhaustiveSimulationButton(playerIndex, 'turn'),"authorized":_vm.authorized},on:{"simulate":function($event){return _vm.runNonexhaustiveFiveCardHandPercentagesSimulationsForTurn(playerIndex)}}},[((_vm.state.presetHoleCards.bothSet && _vm.state.presetCommunityCards.turnSet && !_vm.state.players.hasEmptyRange('turn')))?_c('section',{staticClass:"equity-results-container",attrs:{"slot":"left-header"},slot:"left-header"},[_c('equity-results',{attrs:{"equity":player.states[2].equity,"equityString":player.states[2].equityString,"winPercentageString":player.states[2].winPercentageString,"tiePercentageString":player.states[2].tiePercentageString,"hasSimulationBeenRun":_vm.ableToGetTurnEquities()}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This shows the equity that this range has against the selected hole cards in step two, and against any other turn ranges if you're facing multiple opponents. It assumes that the turn will always be what you have it set as, but that the river will be dealt randomly.","data-toggle":"tooltip","data-placement":"top"}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.numSet === 4)?_c('hit-calculator-insights',{attrs:{"slot":"insights","hitPercentage":player.states[2].hitPercentage,"hitPercentageUpToDate":_vm.isHitPercentageUpToDate[playerIndex][1]},slot:"insights"}):_vm._e()],1)}),_vm._v(" "),_c('h3',[_vm._v("River")]),_vm._v(" "),_c('river-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)}}}),_vm._v(" "),(_vm.state.players.numPlayers > 1)?_c('cumulative-hit-percentages',{attrs:{"cumulativeHitPercentages":_vm.cumulativeHitPercentages,"moreThanTwoPlayers":_vm.state.players.numPlayers > 2,"streetsToDisplay":['river']}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('range-for-street',{key:("river-" + (player.id)),ref:("river-" + playerIndex),refInFor:true,attrs:{"player":player,"playerIndex":playerIndex,"playerStateIndex":3,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(3),"storeModuleName":'hitCalculator',"simulateButton":_vm.showNonexhaustiveSimulationButton(playerIndex, 'river'),"authorized":_vm.authorized},on:{"simulate":function($event){return _vm.runNonexhaustiveFiveCardHandPercentagesSimulationsForRiver(playerIndex)}}},[((_vm.state.presetHoleCards.bothSet && _vm.state.presetCommunityCards.riverSet && !_vm.state.players.hasEmptyRange('river')))?_c('section',{staticClass:"equity-results-container",attrs:{"slot":"left-header"},slot:"left-header"},[_c('equity-results',{attrs:{"equity":player.states[3].equity,"equityString":player.states[3].equityString,"winPercentageString":player.states[3].winPercentageString,"tiePercentageString":player.states[3].tiePercentageString,"hasSimulationBeenRun":_vm.ableToGetRiverEquities()}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"data-title":"This shows the equity that this range has against the selected hole cards in step two, and against any other river ranges if you're facing multiple opponents.","data-toggle":"tooltip","data-placement":"top"}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.numSet === 5)?_c('hit-calculator-insights',{attrs:{"slot":"insights","hitPercentage":player.states[3].hitPercentage,"hitPercentageUpToDate":_vm.isHitPercentageUpToDate[playerIndex][2]},slot:"insights"}):_vm._e()],1)}),_vm._v(" "),_c('br'),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
      method: 'createSharableHitCalculatorURL',
      state: _vm.state,
      approximateWaitTime: 5,
    })}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"disabled":!_vm.authorized,"savedScenario":_vm.savedScenario},on:{"saveScenario":function($event){return _vm.$emit('saveScenario', {
      method: 'createSharableHitCalculatorURL',
      savedScenarioPropertyName: 'hitCalculator',
      state: _vm.state,
    })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
      method: '_constructHitCalculatorData',
      state: _vm.state,
    })}}}),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"hit calculator","urlPath":"hit-calculator"}}),_vm._v(" "),_c('help-icon',{attrs:{"path":"/help/hit-calculator"}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Hit calculator")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "htQj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_blog_subscribe_to_blog__ = __webpack_require__("bnhV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog_zoom-out',
  components: {
    'subscribe-to-blog': __WEBPACK_IMPORTED_MODULE_0__components_blog_subscribe_to_blog__["a" /* default */]
  }
});

/***/ }),

/***/ "hu4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sharable_url_modal_vue__ = __webpack_require__("Np1h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7f146f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sharable_url_modal_vue__ = __webpack_require__("bPB9");
function injectStyle (ssrContext) {
  __webpack_require__("jxrC")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e7f146f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sharable_url_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e7f146f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sharable_url_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hwar":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar yamm navbar-default"},[_c('div',{staticClass:"container"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',[_c('router-link',{class:{ 'home-active': _vm.homeActive },attrs:{"to":"/","exact":""}},[_vm._v("Home")])],1),_vm._v(" "),(_vm.loggedIn && !_vm.purchasedShortDeck)?_c('li',[_c('router-link',{attrs:{"to":"/equity-calculator"}},[_vm._v("Equity Calculator")])],1):_vm._e(),_vm._v(" "),(_vm.loggedIn && !_vm.purchasedShortDeck)?_c('li',[_c('router-link',{attrs:{"to":"/hit-calculator"}},[_vm._v("Hit Calculator")])],1):_vm._e(),_vm._v(" "),(_vm.loggedIn && !_vm.purchasedShortDeck)?_c('li',{staticClass:"dropdown yamm-fw"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('div',{staticClass:"yamm-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('h3',[_c('router-link',{attrs:{"to":"/equity-calculator"}},[_vm._v("Equity Calculator")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/equity-calculator"}},[_c('img',{attrs:{"src":"/static/pages/equity-calculator.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('h3',[_c('router-link',{attrs:{"to":"/hit-calculator"}},[_vm._v("Hit Calculator")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/hit-calculator"}},[_c('img',{attrs:{"src":"/static/pages/hit-calculator.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('h3',[_c('router-link',{attrs:{"to":"/equity-matrix"}},[_vm._v("Equity Matrix")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/equity-matrix"}},[_c('img',{attrs:{"src":"/static/pages/equity-matrix.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('h3',[_c('router-link',{attrs:{"to":"/range-constructor"}},[_vm._v("Range Constructor")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/range-constructor"}},[_c('img',{attrs:{"src":"/static/pages/range-constructor.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('h3',[_c('router-link',{attrs:{"to":"/guided-analyses/should-you-bluff"}},[_vm._v("Should You Bluff?")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/guided-analyses/should-you-bluff"}},[_c('img',{attrs:{"src":"/static/pages/should-you-bluff.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('h3',[_c('router-link',{attrs:{"to":"/guided-analyses/should-you-call"}},[_vm._v("Should You Call?")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/guided-analyses/should-you-call"}},[_c('img',{attrs:{"src":"/static/pages/should-you-call.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('h3',[_c('router-link',{attrs:{"to":"/breakeven-percentage-for-bluffing-the-turn"}},[_vm._v("Breakeven Percentage For Bluffing The Turn")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/breakeven-percentage-for-bluffing-the-turn"}},[_c('img',{attrs:{"src":"/static/pages/breakeven-percentage-for-bluffing-the-turn.png"}})])],1),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-4"},[_c('h3',[_c('router-link',{attrs:{"to":"/three-bet-cbet-explorer"}},[_vm._v("3bet-Cbet Explorer")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/three-bet-cbet-explorer"}},[_c('img',{attrs:{"src":"/static/pages/three-bet-cbet-explorer.png"}})])],1)])])])])]):_vm._e(),_vm._v(" "),(_vm.loggedIn && !_vm.purchasedShortDeck)?_c('li',{staticClass:"dropdown mobile"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/equity-calculator"}},[_vm._v("Equity Calculator")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/hit-calculator"}},[_vm._v("Hit Calculator")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/equity-matrix"}},[_vm._v("Equity Matrix")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/range-constructor"}},[_vm._v("Range Constructor")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/guided-analyses/should-you-bluff"}},[_vm._v("Should You Bluff?")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/guided-analyses/should-you-call"}},[_vm._v("Should You Call?")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/breakeven-percentage-for-bluffing-the-turn"}},[_vm._v("Breakeven Percentage For Bluffing The Turn")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/three-bet-cbet-explorer"}},[_vm._v("3bet-Cbet Explorer")])],1)])]):_vm._e(),_vm._v(" "),(_vm.purchasedShortDeck)?_c('li',{staticClass:"dropdown"},[_vm._m(2),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/short-deck/equity-calculator"}},[_vm._v("Equity Calculator")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/short-deck/hit-calculator"}},[_vm._v("Hit Calculator")])],1)])]):_vm._e(),_vm._v(" "),(_vm.purchasedShortDeck)?_c('li',{staticClass:"dropdown"},[_vm._m(3),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/equity-calculator"}},[_vm._v("Equity Calculator")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/hit-calculator"}},[_vm._v("Hit Calculator")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/equity-matrix"}},[_vm._v("Equity Matrix")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/range-constructor"}},[_vm._v("Range Constructor")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/guided-analyses/should-you-bluff"}},[_vm._v("Should You Bluff?")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/guided-analyses/should-you-call"}},[_vm._v("Should You Call?")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/breakeven-percentage-for-bluffing-the-turn"}},[_vm._v("Breakeven Percentage For Bluffing The Turn")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/three-bet-cbet-explorer"}},[_vm._v("3bet-Cbet Explorer")])],1)])]):_vm._e()]),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav navbar-right"},[(!_vm.loggedIn)?_c('li',[_c('router-link',{attrs:{"to":"/pricing"}},[_vm._v("Pricing")])],1):_vm._e(),_vm._v(" "),(!_vm.loggedIn)?_c('li',[_c('router-link',{attrs:{"to":"/sign-in"}},[_vm._v("Sign In")])],1):_vm._e(),_vm._v(" "),(!_vm.loggedIn)?_c('li',[_c('router-link',{attrs:{"to":"/register"}},[_vm._v("Register")])],1):_vm._e(),_vm._v(" "),(_vm.loggedIn && !_vm.basicOrPremium)?_c('li',[_c('router-link',{attrs:{"to":"/purchase"}},[_vm._v("Purchase")])],1):_vm._e(),_vm._v(" "),(_vm.loggedIn)?_c('li',{staticClass:"dropdown"},[_vm._m(4),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu dropdown-menu-right"},[(_vm.onBasicPlan)?_c('li',[_c('router-link',{attrs:{"to":"/upgrade"}},[_vm._v("Upgrade")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/settings","exact":""}},[_vm._v("Settings")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/account"}},[_vm._v("Account")])],1),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logOut()}}},[_vm._v("Log Out")])])])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_vm._v("\n          All Tools "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_vm._v("\n          All Tools "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_vm._v("\n          Short Deck "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_vm._v("\n          Long Deck "),_c('span',{staticClass:"caret"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_vm._v("\n          Account "),_c('span',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "i3fB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'saved-range',
  props: ['savedRange', 'indexes', 'savedRanges', 'indexesOfSelectedSavedRange'],
  data: function data() {
    return {
      isBeingHovered: true // for now I'm hardcoding this; it should only happen on hover
    };
  },
  computed: {
    level: function level() {
      return this.indexes.length - 1;
    },
    isSelected: function isSelected() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isEqual(this.indexes, this.indexesOfSelectedSavedRange);
    },
    isMoveUpPossible: function isMoveUpPossible() {
      if (this.indexes.length === 1 && this.indexes[0] === 0) {
        return false;
      }
      return true;
    },
    isMoveDownPossible: function isMoveDownPossible() {
      var arr = __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__["a" /* default */].general.getArrayFromNextToLastArrayIndex(this.savedRanges, this.indexes);
      return !!arr[this.indexes[this.indexes.length - 1] + 1];
    },
    isIndentRightPossible: function isIndentRightPossible() {
      return this.indexes[this.indexes.length - 1] !== 0;
    },
    isIndentLeftPossible: function isIndentLeftPossible() {
      return this.level > 0;
    }
  },
  methods: {
    toggleIsCollapsed: function toggleIsCollapsed() {
      this.savedRange.collapsed = !this.savedRange.collapsed;
    },
    getChildIndexes: function getChildIndexes(childIndex) {
      var currIndexes = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.cloneDeep(this.indexes);
      currIndexes.push(childIndex);
      return currIndexes;
    },
    editName: function editName() {
      var self = this;

      self.savedRange.editNameMode = true;
      setTimeout(function () {
        self.$refs.editName.focus();
      }, 0);
    },
    finishEditingName: function finishEditingName() {
      this.savedRange.editNameMode = false;
    },
    handleNameClick: function handleNameClick() {
      if (this.savedRange.children) {
        this.toggleIsCollapsed();
      } else {
        this.$emit('showRange', this.indexes);
      }
    }
  }
});

/***/ }),

/***/ "i40l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_Players__ = __webpack_require__("IPbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__ = __webpack_require__("XRwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_hands_GeneralHands__ = __webpack_require__("udlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_service__ = __webpack_require__("JBFI");






var state = {
  hasSimulationBeenRun: false,
  presetCommunityCards: new __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__["a" /* default */](),
  players: new __WEBPACK_IMPORTED_MODULE_0__services_player_Players__["a" /* default */](),
  resultGeneralHands: new __WEBPACK_IMPORTED_MODULE_2__services_hands_GeneralHands__["a" /* default */](),
  requiredEquity: 50
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_3__services_share_url_service__["a" /* default */].setEquityMatrixStoreState(stateFromServer, state);
  },
  setRequiredEquity: function setRequiredEquity(state, newRequiredEquity) {
    state.requiredEquity = newRequiredEquity;
  },
  setHasSimulationBeenRun: function setHasSimulationBeenRun(state, value) {
    state.hasSimulationBeenRun = value;
  },

  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHand(state, payload);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHands(state, payload);
  },
  selectSpecificHand: function selectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function deselectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectSpecificHand(state, payload);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHands(state, payload);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectAllGeneralHands(state, payload);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function setWeightOfSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightOfSpecificHand(state, payload);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function addComboToCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function removeComboFromCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeComboFromCombosToAdd(state, payload);
  },
  narrowRange: function narrowRange(state, payload) {
    state.players.find(payload.playerIndex).narrowRange(payload.checkedHands, state.presetCommunityCards);
  },

  // controls
  setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function setBoard(state, boardCards) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setBoard(state, boardCards);
  },
  removePresetCommunityCard: function removePresetCommunityCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetCommunityCard(state, position);
  },
  addPlayer: function addPlayer(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addPlayer(state, payload);
  },
  removePlayer: function removePlayer(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePlayer(state, playerIndex);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations
});



/***/ }),

/***/ "idVL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_slider_selector_log_double_slider_selector__ = __webpack_require__("5A+w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_hand_range_slider_selector_double_slider_selector__ = __webpack_require__("uC4e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hand_range_slider_selector_single_slider_selector__ = __webpack_require__("Xct9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'slider-selector',
  components: {
    'log-double-slider-selector': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_slider_selector_log_double_slider_selector__["a" /* default */],
    'double-slider-selector': __WEBPACK_IMPORTED_MODULE_1__components_hand_range_slider_selector_double_slider_selector__["a" /* default */],
    'single-slider-selector': __WEBPACK_IMPORTED_MODULE_2__components_hand_range_slider_selector_single_slider_selector__["a" /* default */]
  },
  props: ['percentOfHandsInRangeNumberForDisplay', 'numberOfSpecificHandsInRange', 'numberOfPossibleSpecificHands', 'disabled'],
  computed: {
    includedSlider: function includedSlider() {
      return this.$store.state.account.user.settings.general.includedSelectors.slider;
    }
  },
  methods: {
    resetDoubleSlider: function resetDoubleSlider() {
      if (this.includedSlider === 'log double') {
        this.$refs.logDoubleSlider.reset();
      } else if (this.includedSlider === 'double') {
        this.$refs.doubleSlider.reset();
      }
    },
    refreshDoubleSlider: function refreshDoubleSlider() {
      if (this.includedSlider === 'log double') {
        this.$refs.logDoubleSlider.refresh();
      } else if (this.includedSlider === 'double') {
        this.$refs.doubleSlider.refresh();
      }
    }
  }
});

/***/ }),

/***/ "iexb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_onboarding_modal_vue__ = __webpack_require__("8NDo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a200c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_onboarding_modal_vue__ = __webpack_require__("NlOQ");
function injectStyle (ssrContext) {
  __webpack_require__("+Czk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40a200c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_onboarding_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40a200c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_onboarding_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ir5Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ivL/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"short-deck-flop-selector"},[_c('short-deck-individual-card-selector',{ref:"flop1",attrs:{"cardString":_vm.presetCommunityCards.flop1,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop1')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop1')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"flop2",attrs:{"cardString":_vm.presetCommunityCards.flop2,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop2')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop2')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"flop3",attrs:{"cardString":_vm.presetCommunityCards.flop3,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop3')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop3')}}}),_vm._v(" "),_c('short-deck-random-board-selector',{attrs:{"presetHoleCards":this.presetHoleCards.array,"popoverDirectionClass":_vm.popoverDirectionClass,"disableTurnAndRiver":true,"disabled":_vm.disabled},on:{"setBoard":function($event){return _vm.$emit('setBoard', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iw9m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breakeven-percentage-for-bluffing-the-turn-table',
  props: ['breakevenPercentages', 'dropoffPercentages']
});

/***/ }),

/***/ "j1Sj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-reasoning-help-section-1'
});

/***/ }),

/***/ "jCDX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_cumulative_hit_percentages__ = __webpack_require__("cNwD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_help_toggle_help_button__ = __webpack_require__("T8TE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_help_reasoning_1__ = __webpack_require__("AaE9");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-initial-conclusion',
  components: {
    'cumulative-hit-percentages': __WEBPACK_IMPORTED_MODULE_0__components_cumulative_hit_percentages__["a" /* default */],
    'toggle-help-button': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_help_toggle_help_button__["a" /* default */],
    'reasoning-help-section-1': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_help_reasoning_1__["a" /* default */]
  },
  props: ['bluffSize', 'streetToBluff', 'hitPercentageForStreetToBluff', 'foldEquity', 'immediatelyProfitableBreakevenPercentage', 'cumulativeHitPercentages', 'numPlayers'],
  data: function data() {
    return {
      profitableBreakevenPercentage: 30,
      helpAreaVisible: {
        reasoning: [false, false, false]
      }
    };
  },
  computed: {
    isBluffImmediatelyProfitable: function isBluffImmediatelyProfitable() {
      return this.foldEquity > this.immediatelyProfitableBreakevenPercentage;
    },
    cumulativeHitPercentagesStreetsToDisplay: function cumulativeHitPercentagesStreetsToDisplay() {
      if (this.streetToBluff === 'flop') {
        return ['flop'];
      } else if (this.streetToBluff === 'turn') {
        return ['flop', 'turn'];
      } else if (this.streetToBluff === 'river') {
        return ['flop', 'turn', 'river'];
      }
    }
  },
  methods: {
    toggleHelp: function toggleHelp(type, index) {
      if (type === 'reasoning') {
        this.helpAreaVisible.reasoning[index] = !this.helpAreaVisible.reasoning[index];
      }

      this.$forceUpdate();
    }
  }
});

/***/ }),

/***/ "jE9g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jEKO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("/isP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af3cf08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__("YmSe");
function injectStyle (ssrContext) {
  __webpack_require__("vUlo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3af3cf08"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af3cf08_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jRq9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expand_collapse_vue__ = __webpack_require__("eweX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae79caa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expand_collapse_vue__ = __webpack_require__("SyQL");
function injectStyle (ssrContext) {
  __webpack_require__("5IUT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ae79caa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expand_collapse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ae79caa_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expand_collapse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jTUt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jZCj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_hand_range__ = __webpack_require__("cOfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_togglable_section__ = __webpack_require__("mXeB");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'three-bet-cbet-explorer-inputs',
  props: ['state', 'authorized'],
  components: {
    'hand-range': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_hand_range__["a" /* default */],
    'togglable-section': __WEBPACK_IMPORTED_MODULE_1__components_utilities_togglable_section__["a" /* default */]
  },
  computed: {
    handRankings: function handRankings() {
      return this.$store.getters['account/handRankings'];
    }
  },
  mounted: function mounted() {
    this.initializeTooltips();
  },
  methods: {
    initializeTooltips: function initializeTooltips() {
      if (true) {
        $(this.$el).find('[data-toggle="tooltip"]').tooltip();
      }
    },

    setOpenSize: function setOpenSize(openSize) {
      this.$store.commit('threeBetCbetExplorer/setOpenSize', openSize);
    },
    setThreeBetSize: function setThreeBetSize(threeBetSize) {
      this.$store.commit('threeBetCbetExplorer/setThreeBetSize', threeBetSize);
    },
    setNumPlayersLeftToAct: function setNumPlayersLeftToAct(numPlayersLeftToAct) {
      this.$store.commit('threeBetCbetExplorer/setNumPlayersLeftToAct', numPlayersLeftToAct);
    },
    setAverageFourBetPercentage: function setAverageFourBetPercentage(averageFourBetPercentage) {
      this.$store.commit('threeBetCbetExplorer/setAverageFourBetPercentage', averageFourBetPercentage);
    },
    setCbetSize: function setCbetSize(cbetSize) {
      this.$store.commit('threeBetCbetExplorer/setCbetSize', cbetSize);
    },
    setContinueVsCbetPercentage: function setContinueVsCbetPercentage(continueVsCbetPercentage) {
      this.$store.commit('threeBetCbetExplorer/setContinueVsCbetPercentage', continueVsCbetPercentage);
    },
    setHitPercentage: function setHitPercentage(hitPercentage) {
      this.$store.commit('threeBetCbetExplorer/setHitPercentage', hitPercentage);
    },
    setFirstStreetOfValuePercentage: function setFirstStreetOfValuePercentage(firstStreetOfValuePercentage) {
      this.$store.commit('threeBetCbetExplorer/setFirstStreetOfValuePercentage', firstStreetOfValuePercentage);
    },
    setSecondStreetOfValuePercentage: function setSecondStreetOfValuePercentage(secondStreetOfValuePercentage) {
      this.$store.commit('threeBetCbetExplorer/setSecondStreetOfValuePercentage', secondStreetOfValuePercentage);
    },
    setThirdStreetOfValuePercentage: function setThirdStreetOfValuePercentage(thirdStreetOfValuePercentage) {
      this.$store.commit('threeBetCbetExplorer/setThirdStreetOfValuePercentage', thirdStreetOfValuePercentage);
    },
    setAlternativeEV: function setAlternativeEV(alternativeEV) {
      this.$store.commit('threeBetCbetExplorer/setAlternativeEV', alternativeEV);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "jc79":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_new_password_vue__ = __webpack_require__("uxqK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a86a7d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_new_password_vue__ = __webpack_require__("uySj");
function injectStyle (ssrContext) {
  __webpack_require__("jE9g")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8a86a7d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_new_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8a86a7d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_new_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "jeYv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jev9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'action-selector',
  props: ['actions', 'indexOfSelectedAction', 'authorized']
});

/***/ }),

/***/ "jv6P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jw7l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well should-you-call-initial-conclusion"},[_c('header',{staticClass:"page-header"},[(_vm.streetToCall !== 'river')?_c('h1',[_vm._v("Initial analysis")]):_vm._e(),_vm._v(" "),(_vm.streetToCall === 'river')?_c('h1',[_vm._v("Analysis")]):_vm._e()]),_vm._v(" "),_c('section',{staticClass:"alert",class:{ 'alert-success': _vm.isCallProfitableBasedOnPotOdds, 'alert-danger': !_vm.isCallProfitableBasedOnPotOdds }},[(_vm.streetToCall !== 'river')?_c('p',[_vm._v("If we don't factor in the possibility of betting on future streets, calling the "+_vm._s(_vm.streetToCall)+" bet with "+_vm._s(_vm.potOdds)+" pot odds "),_c('em',[_vm._v("will "),(!_vm.isCallProfitableBasedOnPotOdds)?_c('span',[_vm._v("not")]):_vm._e()]),_vm._v(" be profitable "),(_vm.isCallProfitableBasedOnPotOdds)?_c('span',[_vm._v("✅")]):_c('span',[_vm._v("❌")])]):_vm._e(),_vm._v(" "),(_vm.streetToCall === 'river')?_c('p',[_vm._v("Calling the river bet with "+_vm._s(_vm.potOdds)+" pot odds "),_c('em',[_vm._v("will "),(!_vm.isCallProfitableBasedOnPotOdds)?_c('span',[_vm._v("not")]):_vm._e()]),_vm._v(" be profitable "),(_vm.isCallProfitableBasedOnPotOdds)?_c('span',[_vm._v("✅")]):_c('span',[_vm._v("❌")])]):_vm._e()]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Equity")]),_vm._v(" "),_c('th',[_vm._v("Pot odds")]),_vm._v(" "),_c('th',[_vm._v("Break even percentage for "+_vm._s(_vm.potOdds)+" pot odds")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(_vm.equity)+"%")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.potOdds))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.breakevenPercentageViaPotOdds)+"%")])])])]),_vm._v(" "),_c('p',[_vm._v("Reasoning:")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("\n      When you have "+_vm._s(_vm.potOdds)+" pot odds, "),(_vm.streetToCall !== 'river')?_c('span',[_vm._v("without factoring in the possibility of betting on future streets, ")]):_vm._e(),_vm._v("for a call to be profitable, you need more than "+_vm._s(_vm.breakevenPercentageViaPotOdds)+"% equity.\n      "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible.reasoning[0]},on:{"toggleHelp":function($event){return _vm.toggleHelp('reasoning', 0)}}}),_vm._v(" "),(_vm.helpAreaVisible.reasoning[0])?_c('reasoning-help-section-1'):_vm._e()],1),_vm._v(" "),_c('li',[_vm._v("\n      According to your assumptions, you have "+_vm._s(_vm.equity)+"% equity, which is "),(_vm.isCallProfitableBasedOnPotOdds)?_c('span',[_vm._v("more")]):_c('span',[_vm._v("less")]),_vm._v(" than the "+_vm._s(_vm.breakevenPercentageViaPotOdds)+"% you need.\n      "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible.reasoning[1]},on:{"toggleHelp":function($event){return _vm.toggleHelp('reasoning', 1)}}}),_vm._v(" "),(_vm.helpAreaVisible.reasoning[1])?_c('div',{staticClass:"well"},[_vm._v("\n        This is your equity versus your opponents "+_vm._s(_vm.streetToCall)+" betting range. It is based on your assumptions because you've assumed that your opponent has whatever "+_vm._s(_vm.streetToCall)+" betting range. If that range were different, the equity would be different, and the conclusion you come to about whether or not to call may end up being different.\n      ")]):_vm._e()],1),_vm._v(" "),_c('li',[_vm._v("Therefore, according to this initial analysis, your call will "),(!_vm.isCallProfitableBasedOnPotOdds)?_c('span',[_vm._v("not")]):_vm._e(),_vm._v(" be profitable.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jxrC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jzf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__ = __webpack_require__("lDlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_street_selector__ = __webpack_require__("Xr2F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_num_opponents_selector__ = __webpack_require__("Cesf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_controls_card_selection_hole_cards_selector__ = __webpack_require__("Sl4K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_guided_analyses_should_you_call_preflop_steps__ = __webpack_require__("ZtL1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_guided_analyses_should_you_call_flop_steps__ = __webpack_require__("dBV+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_guided_analyses_should_you_call_turn_steps__ = __webpack_require__("nj4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_guided_analyses_should_you_call_river_steps__ = __webpack_require__("o0yB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_guided_analyses_should_you_call_conclusions_initial_conclusion__ = __webpack_require__("AAJ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_guided_analyses_should_you_call_conclusions_final_conclusion__ = __webpack_require__("OU8i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_guided_analyses_should_you_call_conclusions_long_run_disclaimer__ = __webpack_require__("so40");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_controls_create_sharable_url_button__ = __webpack_require__("zMC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_controls_save_scenario_button__ = __webpack_require__("A/Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_onboarding_modal__ = __webpack_require__("iexb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_help_icon__ = __webpack_require__("FmIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__ = __webpack_require__("pihl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'guided-analyses-should-you-call',
  components: {
    'readonly-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__["a" /* default */],
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__["a" /* default */],
    'street-selector': __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_street_selector__["a" /* default */],
    'num-opponents-selector': __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_num_opponents_selector__["a" /* default */],
    'hole-cards-selector': __WEBPACK_IMPORTED_MODULE_5__components_controls_card_selection_hole_cards_selector__["a" /* default */],
    'preflop-steps': __WEBPACK_IMPORTED_MODULE_6__components_guided_analyses_should_you_call_preflop_steps__["a" /* default */],
    'flop-steps': __WEBPACK_IMPORTED_MODULE_7__components_guided_analyses_should_you_call_flop_steps__["a" /* default */],
    'turn-steps': __WEBPACK_IMPORTED_MODULE_8__components_guided_analyses_should_you_call_turn_steps__["a" /* default */],
    'river-steps': __WEBPACK_IMPORTED_MODULE_9__components_guided_analyses_should_you_call_river_steps__["a" /* default */],
    'initial-conclusion': __WEBPACK_IMPORTED_MODULE_10__components_guided_analyses_should_you_call_conclusions_initial_conclusion__["a" /* default */],
    'final-conclusion': __WEBPACK_IMPORTED_MODULE_11__components_guided_analyses_should_you_call_conclusions_final_conclusion__["a" /* default */],
    'long-run-disclaimer': __WEBPACK_IMPORTED_MODULE_12__components_guided_analyses_should_you_call_conclusions_long_run_disclaimer__["a" /* default */],
    'create-sharable-url-button': __WEBPACK_IMPORTED_MODULE_13__components_controls_create_sharable_url_button__["a" /* default */],
    'save-scenario-button': __WEBPACK_IMPORTED_MODULE_14__components_controls_save_scenario_button__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_15__components_onboarding_modal__["a" /* default */],
    'help-icon': __WEBPACK_IMPORTED_MODULE_16__components_help_icon__["a" /* default */]
  },
  computed: {
    state: function state() {
      return this.$store.state.guidedAnalysesCalling;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.shouldYouCall.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    equity: function equity() {
      var equity = 100;

      this.state.players.forEach(function (player) {
        equity -= player.states[0].equity;
      });

      return equity.roundToTwoDecimalPlaces();
    },
    ableToRunFiveCardHandPercentageSimulationsForTheFlop: function ableToRunFiveCardHandPercentageSimulationsForTheFlop() {
      if (!this.state.presetCommunityCards.flopSet) {
        return false;
      } else if (this.state.players.find(0).hasEmptyRange('preflop')) {
        return false;
      } else {
        return true;
      }
    },
    ableToRunFiveCardHandPercentageSimulationsForTheTurn: function ableToRunFiveCardHandPercentageSimulationsForTheTurn() {
      if (!this.state.presetCommunityCards.turnSet) {
        return false;
      } else if (this.state.players.find(0).hasEmptyRange('flop')) {
        return false;
      } else {
        return true;
      }
    },
    ableToRunFiveCardHandPercentageSimulationsForTheRiver: function ableToRunFiveCardHandPercentageSimulationsForTheRiver() {
      if (!this.state.presetCommunityCards.riverSet) {
        return false;
      } else if (this.state.players.find(0).hasEmptyRange('turn')) {
        return false;
      } else {
        return true;
      }
    },
    ableToRunEquityCalculations: function ableToRunEquityCalculations() {
      var ableToRunEquityCalculations = true;

      if (!this.state.presetHoleCards.bothSet) {
        ableToRunEquityCalculations = false;
      } else if (this.state.streetToCall === 'flop') {
        if (!this.state.presetCommunityCards.flopSet) {
          ableToRunEquityCalculations = false;
        }

        if (this.state.players.hasEmptyRange('flop')) {
          ableToRunEquityCalculations = false;
        }
      } else if (this.state.streetToCall === 'turn') {
        if (!this.state.presetCommunityCards.turnSet) {
          ableToRunEquityCalculations = false;
        }

        if (this.state.players.hasEmptyRange('turn')) {
          ableToRunEquityCalculations = false;
        }
      } else if (this.state.streetToCall === 'river') {
        if (!this.state.presetCommunityCards.riverSet) {
          ableToRunEquityCalculations = false;
        }

        if (this.state.players.hasEmptyRange('river')) {
          ableToRunEquityCalculations = false;
        }
      }

      return ableToRunEquityCalculations;
    },
    playerStateIndexToUseForSimulations: function playerStateIndexToUseForSimulations() {
      if (this.state.streetToCall === 'flop') {
        return 1;
      } else if (this.state.streetToCall === 'turn') {
        return 2;
      } else if (this.state.streetToCall === 'river') {
        return 3;
      }
    },
    authorized: function authorized() {
      return this.$store.getters['account/authorizedForBasic'];
    }
  },
  mounted: function mounted() {
    var self = this;

    if (self.$route.params.id) {
      self.load();
    } else {
      self.$store.commit('guidedAnalysesCalling/setFiveCardHandValuesToDefaults', {
        settings: self.$store.state.account.user.settings,
        opponentTightness: 'straightforward'
      });
    }

    self.handleOnboard();

    // flop five card hand simulations
    self.$watch(function () {
      var sum = 0;

      self.state.players.forEach(function (player) {
        sum += player.states[0].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    }, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.debounce(self.runFiveCardHandPercentagesSimulationsForFlop, 1000));

    // turn five card hand simulations
    self.$watch(function () {
      var sum = 0;

      self.state.players.forEach(function (player) {
        sum += player.states[1].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    }, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.debounce(self.runFiveCardHandPercentagesSimulationsForTurn, 1000));

    // river five card hand simulations
    self.$watch(function () {
      var sum = 0;

      self.state.players.forEach(function (player) {
        sum += player.states[2].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    }, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.debounce(self.runFiveCardHandPercentagesSimulationsForRiver, 1000));

    // equity
    self.$watch(function () {
      var sum = 0;

      self.state.players.forEach(function (player) {
        sum += player.states[0].generalHands.numberOfSpecificHandsInRange;
        sum += player.states[1].generalHands.numberOfSpecificHandsInRange;
        sum += player.states[2].generalHands.numberOfSpecificHandsInRange;
        sum += player.states[3].generalHands.numberOfSpecificHandsInRange;
      });

      return sum;
    }, __WEBPACK_IMPORTED_MODULE_18_lodash___default.a.debounce(self.runEquityCalculations, 1000));
  },
  methods: {
    // mounted
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default guided analysis calling page.');
          self.$router.push('/guided-analyses/should-you-call');
        } else {
          self.$store.commit('guidedAnalysesCalling/setState', response.data.storeState);
          self.simulate();
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default guided analysis calling page.');
        self.$router.push('/guided-analyses/should-you-call');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.shouldYouCall) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'shouldYouCall' }).then(function () {
        self.$store.commit('account/onboard', 'shouldYouCall');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },

    // other
    setStreetToCall: function setStreetToCall(streetToCall) {
      this.$store.commit('guidedAnalysesCalling/setStreetToCall', streetToCall);

      if (streetToCall === 'flop') {
        this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', 'turn');
        this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', 'river');
        this.setRangesAccordingToFiltersForAllPlayers();
        this.simulate();
      } else if (streetToCall === 'turn') {
        this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', 'river');
        this.setRangesAccordingToFiltersForAllPlayers();
        this.simulate();
      } else if (streetToCall === 'river') {
        this.simulate();
      }
    },
    setPotOdds: function setPotOdds(potOdds) {
      this.$store.commit('guidedAnalysesCalling/setPotOdds', potOdds);
    },
    setRealOddsLHS: function setRealOddsLHS(realOddsLHS) {
      this.$store.commit('guidedAnalysesCalling/setRealOddsLHS', realOddsLHS);
    },
    getTextWhenFiveCardHandPercentagesArentUpToDate: function getTextWhenFiveCardHandPercentagesArentUpToDate(playerStateIndex) {
      if (playerStateIndex === 1 && this.ableToRunFiveCardHandPercentageSimulationsForTheFlop || playerStateIndex === 2 && this.ableToRunFiveCardHandPercentageSimulationsForTheTurn || playerStateIndex === 3 && this.ableToRunFiveCardHandPercentageSimulationsForTheRiver) {
        return 'Running simulations...';
      } else {
        return 'Percentages of made hands, draws and combos are not up to date. Make sure that the range in the previous step has at least one hand selected so that simulations can be run to update the percentages.';
      }
    },

    // controls
    setPresetHoleCard: function setPresetHoleCard(params) {
      this.$store.commit('guidedAnalysesCalling/removePresetHoleCard', params.position);
      this.$store.commit('guidedAnalysesCalling/setPresetHoleCard', {
        card: params.card,
        position: params.position
      });
      this.resetAllDoubleSliders();
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    removePresetHoleCard: function removePresetHoleCard(position) {
      this.$store.commit('guidedAnalysesCalling/removePresetHoleCard', position);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(card, position) {
      this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', position);
      this.$store.commit('guidedAnalysesCalling/setIndividualPresetCommunityCard', {
        card: card,
        position: position
      });
      this.resetAllDoubleSliders();
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    setBoard: function setBoard(boardCards) {
      this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', 'flop1');
      this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', 'flop2');
      this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', 'flop3');
      this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', 'turn');
      this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', 'river');
      this.$store.commit('guidedAnalysesCalling/setBoard', boardCards);
      this.resetAllDoubleSliders();
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    removePresetCommunityCard: function removePresetCommunityCard(position) {
      this.$store.commit('guidedAnalysesCalling/removePresetCommunityCard', position);
      this.setRangesAccordingToFiltersForAllPlayers();
      this.simulate();
    },
    addPlayer: function addPlayer() {
      this.$store.commit('guidedAnalysesCalling/addPlayer', {
        settings: this.$store.state.account.user.settings,
        opponentTightness: 'straightforward'
      });
    },
    removePlayer: function removePlayer() {
      this.$store.commit('guidedAnalysesCalling/removePlayer', this.state.players.numPlayers - 1);
      this.simulate();
    },

    setRangesAccordingToFiltersForAllPlayers: function setRangesAccordingToFiltersForAllPlayers() {
      this.state.players.forEach(function (player, i) {
        this.$store.commit('guidedAnalysesCalling/setRangesAccordingToFilters', i);
      }, this);
    },
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$refs['player-' + playerIndex + '-0'] && this.$refs['player-' + playerIndex + '-0'][0]) {
        this.$refs['player-' + playerIndex + '-0'][0].resetDoubleSlider();
      }
    },
    resetAllDoubleSliders: function resetAllDoubleSliders() {
      this.state.players.forEach(function (player, playerIndex) {
        if (this.state.presetCommunityCards.possiblePlayerStateIndexes.length > 1) {
          this.resetDoubleSlider(playerIndex, 0);
        }
      }, this);
    },

    simulate: function simulate() {
      this.runEquityCalculations().then(this.runFiveCardHandPercentagesSimulationsForFlop).then(this.runFiveCardHandPercentagesSimulationsForTurn).then(this.runFiveCardHandPercentagesSimulationsForRiver);
    },
    runEquityCalculations: function runEquityCalculations() {
      if (!this.ableToRunEquityCalculations) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      var self = this;
      var weightedRanges = self._getWeightedRanges();
      var numberOfSimulations = self.$store.state.account.user.settings.equityCalculator.numberOfSimulations;

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getEquities(weightedRanges, self.state.presetCommunityCards.array, numberOfSimulations, function () {}).then(function (simulationResults) {
        self.$store.commit('guidedAnalysesCalling/updateEquityResults', {
          simulationResults: simulationResults,
          numberOfSimulations: numberOfSimulations,
          rakePercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.rakePercentage,
          tipPercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.tipPercentage
        });
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    _getWeightedRanges: function _getWeightedRanges() {
      var weightedRanges = [];
      var heroWeightedRange = [[this.state.presetHoleCards.holeCardOne, this.state.presetHoleCards.holeCardTwo]];
      var playerStateIndexToUseForSimulations = this.playerStateIndexToUseForSimulations;

      weightedRanges.push(heroWeightedRange);
      this.state.players.forEach(function (player) {
        weightedRanges.push(player.states[playerStateIndexToUseForSimulations].generalHands.weightedRange);
      }, this);

      return weightedRanges;
    },
    runFiveCardHandPercentagesSimulationsForFlop: function runFiveCardHandPercentagesSimulationsForFlop() {
      var self = this;

      if (!self.ableToRunFiveCardHandPercentageSimulationsForTheFlop) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getFlopFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('guidedAnalysesCalling/setLastSimulationInfo', 1);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    runFiveCardHandPercentagesSimulationsForTurn: function runFiveCardHandPercentagesSimulationsForTurn() {
      var self = this;

      if (!self.ableToRunFiveCardHandPercentageSimulationsForTheTurn) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getTurnFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('guidedAnalysesCalling/setLastSimulationInfo', 2);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    runFiveCardHandPercentagesSimulationsForRiver: function runFiveCardHandPercentagesSimulationsForRiver() {
      var self = this;

      if (!self.ableToRunFiveCardHandPercentageSimulationsForTheRiver) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      }

      return __WEBPACK_IMPORTED_MODULE_17__services_simulator_simulator__["a" /* default */].getRiverFiveCardHandPercentages(self.state.players, self.state.presetCommunityCards).then(function () {
        self.setRangesAccordingToFiltersForAllPlayers();
        self.$store.commit('guidedAnalysesCalling/setLastSimulationInfo', 3);
      }).catch(function (e) {
        console.error(e);
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    setBettingCriteria: function setBettingCriteria() {
      if (!this.state.presetHoleCards.bothSet || this.state.players.numPlayers > 1 || this.state.streetToCall === 'flop' && !this.state.presetCommunityCards.flopSet || this.state.streetToCall === 'turn' && !this.state.presetCommunityCards.turnSet || this.state.streetToCall === 'river' && !this.state.presetCommunityCards.riverSet) {
        return;
      }

      this._initializeBettingCriteriaSimulationProgress();
      this.$store.dispatch('guidedAnalysesCalling/setBettingCriteria', {
        incrementSimulationProgress: this._incrementBettingCriteriaSimulationProgress,
        resetSimulationProgress: this._resetBettingCriteriaSimulationProgress,
        numberOfSimulations: this.$store.state.account.user.settings.equityCalculator.numberOfSimulations,
        rakePercentage: this.$store.state.account.user.settings.equityCalculator.rakeAndTip.rakePercentage,
        tipPercentage: this.$store.state.account.user.settings.equityCalculator.rakeAndTip.tipPercentage
      });
    },
    _initializeBettingCriteriaSimulationProgress: function _initializeBettingCriteriaSimulationProgress() {
      $(this.$el).find('.simulate-button-container .text').text('Simulating...');
      this._incrementBettingCriteriaSimulationProgress(0);
    },
    _incrementBettingCriteriaSimulationProgress: function _incrementBettingCriteriaSimulationProgress(value) {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      var $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', value + '%');
      $simulationButton.prop('disabled', true);
      $simulationButtonProgressBox.css('z-index', '1');
      $simulationButtonProgressBox.css('width', value + '%');
      $simulationButtonProgressBox.css('cursor', 'not-allowed');
    },
    _resetBettingCriteriaSimulationProgress: function _resetBettingCriteriaSimulationProgress() {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      var $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      var $simulationButtonProgressBox = $(this.$el).find('.betting-criteria-table .simulate-button-container .progress-box');

      $simulationProgress.css('width', '0%');
      $simulationButton.prop('disabled', false);
      $simulationButtonText.text('Simulate');
      $simulationButtonProgressBox.css('z-index', '-1');
      $simulationButtonProgressBox.css('cursor', 'auto');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "k1LJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k1yZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kAUi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_river_selector_vue__ = __webpack_require__("oo7y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b163c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_river_selector_vue__ = __webpack_require__("XXru");
function injectStyle (ssrContext) {
  __webpack_require__("JBOc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-46b163c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_river_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b163c6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_river_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kB5U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hit-calculator-insights-settings settings"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hitCalculatorInsightsVisible),expression:"hitCalculatorInsightsVisible"}],attrs:{"type":"radio","value":"true"},domProps:{"checked":_vm._q(_vm.hitCalculatorInsightsVisible,"true")},on:{"change":function($event){_vm.hitCalculatorInsightsVisible="true"}}}),_vm._v("\n          Show insights\n          "),_c('img',{attrs:{"src":"/static/settings/hit-calculator-insights-visible.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.hitCalculatorInsightsVisible),expression:"hitCalculatorInsightsVisible"}],attrs:{"type":"radio","value":"false"},domProps:{"checked":_vm._q(_vm.hitCalculatorInsightsVisible,"false")},on:{"change":function($event){_vm.hitCalculatorInsightsVisible="false"}}}),_vm._v("\n          Hide insights\n          "),_c('img',{attrs:{"src":"/static/settings/hit-calculator-insights-not-visible.png"}})])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Insights (hit calculator)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kBHf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"flop-selector"},[_c('individual-card-selector',{ref:"flop1",attrs:{"cardString":_vm.presetCommunityCards.flop1,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop1')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop1')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"flop2",attrs:{"cardString":_vm.presetCommunityCards.flop2,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop2')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop2')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"flop3",attrs:{"cardString":_vm.presetCommunityCards.flop3,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop3')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop3')}}}),_vm._v(" "),_c('random-board-selector',{attrs:{"presetHoleCards":this.presetHoleCards.array,"popoverDirectionClass":_vm.popoverDirectionClass,"disableTurnAndRiver":true,"disabled":_vm.disabled},on:{"setBoard":function($event){return _vm.$emit('setBoard', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kR2u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kR7L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kY7Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'five-card-hand-bar',
  props: ['type', 'probability', 'numCombos', 'percentagesOrCombos', 'percentageOfSpecificHandsThatAreSelected'],
  computed: {
    width: function width() {
      var screenWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;

      if (screenWidth >= 1200 && screenWidth <= 1340) {
        if (this.probability > 40) {
          return 50;
        }

        return Math.min(this.probability * 1.5, 50);
      } else if (screenWidth < 767) {
        return Math.min(this.probability * 3.5, 280);
      } else {
        if (this.probability > 40) {
          return 85;
        }

        return Math.min(this.probability * 1.75, 85);
      }
    },
    percentageOfSpecificHandsThatAreSelectedAsDecimal: function percentageOfSpecificHandsThatAreSelectedAsDecimal() {
      return this.percentageOfSpecificHandsThatAreSelected / 100;
    }
  }
});

/***/ }),

/***/ "kg+2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"well"},[_c('h3',[_vm._v("What are pot odds?")]),_vm._v(" "),_c('p',[_vm._v("The ratio of the pot size to the size of the bet you need to call.")]),_vm._v(" "),_c('p',[_vm._v("For example, suppose the pot is $10 and your opponent bets $10. Now the pot is $20 and you need to call $10. So the ratio is "),_c('code',[_vm._v("20:10")]),_vm._v(", or "),_c('code',[_vm._v("2:1")]),_vm._v(".")]),_vm._v(" "),_c('h3',[_vm._v("What is equity?")]),_vm._v(" "),_c('p',[_vm._v("Basically, it's your win percentage with ties factored in.")]),_vm._v(" "),_c('p',[_vm._v("Consider an example. Imagine that you win 30% of the time, lose 50% of the time, and tie 20% of the time. Your equity would be 40%: the 30% of the time you win, plus half of the 20% of ties, because in a tie you split the pot.")]),_vm._v(" "),_c('p',[_vm._v("It may make more sense when you think about what the word means in the context of finance. Suppose you're starting a startup and want to raise money from an investor. Suppose you raise $100k from an investor in exchange for 20% of your business. The investor now has 20% equity in your business. They "),_c('em',[_vm._v("own")]),_vm._v(" 20% of your business now. In the context of poker, you can think of your equity as how much of the pot you own. If the pot is $500 and you have 30% equity, you own $150 of that pot in a sense.")]),_vm._v(" "),_c('h3',[_vm._v("Where does the breakeven percentage come from?")]),_vm._v(" "),_c('p',[_vm._v("The overarching formula is "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Here's an example. If the pot is $2 and you need to call $1, you're risking $1 to win $2.")]),_vm._v(" "),_c('pre',[_vm._v("risk = $1\nreward = $2\nbreakeven percentage = risk / (risk + reward)\nbreakeven percentage = 1 / (1 + 2)\nbreakeven percentage = 1 / 3\nbreakeven percentage = 33.3%\n")]),_vm._v(" "),_c('p',[_vm._v("This formula actually isn't specific to poker at all. Suppose that the Steelers and Saints are in the Super Bowl and if you bet on the Steelers, the casino will give you $2 for every $1 you bet if you win, plus your money back. So if you bet $100, you'd get your $100 back, plus another $200. How often do you need to win this bet to break even? It's the same thing: "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(".")]),_vm._v(" "),_c('pre',[_vm._v("risk = $100\nreward = $200\nbreakeven percentage = risk / (risk + reward)\nbreakeven percentage = 100 / (100 + 200)\nbreakeven percentage = 100 / 300\nbreakeven percentage = 33.3%\n")]),_vm._v(" "),_c('p',[_vm._v("As a sanity check, ask yourself what happens if you win the bet once and lose it twice. First you win, and you're up $200. Then you lose, and you're up $100. Then you lose again, and you're even. When you win 33.3% of the time, you break even.")]),_vm._v(" "),_c('p',[_vm._v("And for those of you interested in the math, here is the derivation. We start off with "),_c('code',[_vm._v("(reward)(% success) = (risk)(1 - %success)")]),_vm._v(" because we're interested in knowing what "),_c('code',[_vm._v("% success")]),_vm._v(" leads to the risk balancing out the reward. From there it's just a little algebra.")]),_vm._v(" "),_c('pre',[_vm._v("(reward)(%success) = (risk)(1 - %success)\n(reward)(%success) = risk - (risk)(%success)\n(reward)(%success) + (risk)(%success) = risk\n%success(reward + risk) = risk\n%success = risk / (risk + reward)\n")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kiNz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_parent_FiveCardHandParent__ = __webpack_require__("Y/UK");






var ComboParent = function (_FiveCardHandParent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ComboParent, _FiveCardHandParent);

  function ComboParent(argsObj) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ComboParent);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ComboParent.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ComboParent)).call(this, argsObj));
  }

  return ComboParent;
}(__WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_parent_FiveCardHandParent__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ComboParent);
;

/***/ }),

/***/ "kpFp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l0rM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_readonly_alert__ = __webpack_require__("lDlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_equity_calculator_insights__ = __webpack_require__("X/7U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_hand_range_hand_range__ = __webpack_require__("cOfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_hand_range_equity_results__ = __webpack_require__("KFpT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_equity_calculator_narrow_range_modal__ = __webpack_require__("h/CU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_equity_calculator_controls__ = __webpack_require__("zMxE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_onboarding_modal__ = __webpack_require__("iexb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_help_icon__ = __webpack_require__("FmIh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_simulator_validator__ = __webpack_require__("qY6h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_simulator_simulator__ = __webpack_require__("pihl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-calculator',
  components: {
    'readonly-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_readonly_alert__["a" /* default */],
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_saved_scenario_alert__["a" /* default */],
    'equity-calculator-insights': __WEBPACK_IMPORTED_MODULE_2__components_equity_calculator_insights__["a" /* default */],
    'hand-range': __WEBPACK_IMPORTED_MODULE_3__components_hand_range_hand_range__["a" /* default */],
    'equity-results': __WEBPACK_IMPORTED_MODULE_4__components_hand_range_equity_results__["a" /* default */],
    'narrow-range-modal': __WEBPACK_IMPORTED_MODULE_5__components_equity_calculator_narrow_range_modal__["a" /* default */],
    'equity-calculator-controls': __WEBPACK_IMPORTED_MODULE_6__components_equity_calculator_controls__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_7__components_onboarding_modal__["a" /* default */],
    'help-icon': __WEBPACK_IMPORTED_MODULE_8__components_help_icon__["a" /* default */]
  },
  data: function data() {
    return {
      playerIndexThatExpandedTheNarrowRangeModal: null
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.equityCalculator;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.equityCalculator.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    insightsVisible: function insightsVisible() {
      return this.$store.state.account.user.settings.equityCalculator.insightsVisible;
    },
    columnClass: function columnClass() {
      if (this.state.players.numPlayers === 2 || this.state.players.numPlayers === 4) {
        return 'col-md-6';
      }

      return 'col-lg-4';
    },
    handRankings: function handRankings() {
      return this.$store.getters['account/handRankings'];
    },
    authorized: function authorized() {
      return this.$store.getters['account/authorizedForBasic'];
    },
    loggedIn: function loggedIn() {
      return this.$store.getters['account/loggedIn'];
    }
  },
  mounted: function mounted() {
    if (this.state.players.numPlayers === 1) {
      this.addPlayer();
    }

    if (this.$route.params.id) {
      this.load();
    }

    this.handleOnboard();

    $('html, body').animate({
      scrollTop: '55px'
    }, 2000);
  },
  methods: {
    // mounted
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default equity calculator page.');
          self.$router.push('/equity-calculator');
        } else {
          self.$store.commit('equityCalculator/setState', response.data.storeState);
          self.$store.commit('equityCalculator/setHasSimulationBeenRun', true);
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default equity calculator page.');
        self.$router.push('/equity-calculator');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.equityCalculator) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'equityCalculator' }).then(function () {
        self.$store.commit('account/onboard', 'equityCalculator');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },

    // range
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$store.state.account.user.settings.general.includedSelectors.slider === 'log double' || this.$store.state.account.useer.settings.general.includedSelectors.slider === 'double') {
        this.$refs['player' + playerIndex][0].resetDoubleSlider();
      }
    },
    resetDoubleSliders: function resetDoubleSliders() {
      this.state.players.forEach(function (player, playerIndex) {
        this.resetDoubleSlider(playerIndex);
      }, this);
    },

    // hamburger
    expandNarrowRangeModal: function expandNarrowRangeModal(playerIndexThatExpandedTheNarrowRangeModal) {
      $(this.$el).find('.narrow-range-modal').modal();
      this.playerIndexThatExpandedTheNarrowRangeModal = playerIndexThatExpandedTheNarrowRangeModal;
    },
    narrowRange: function narrowRange(checkedHands) {
      this.$store.commit('equityCalculator/narrowRange', {
        checkedHands: checkedHands,
        playerIndex: this.playerIndexThatExpandedTheNarrowRangeModal
      });
      this.resetDoubleSlider(this.playerIndexThatExpandedTheNarrowRangeModal);
    },

    // controls
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(params) {
      this.$store.commit('equityCalculator/removePresetCommunityCard', params.position);
      this.$store.commit('equityCalculator/setIndividualPresetCommunityCard', {
        card: params.card,
        position: params.position
      });
      this.resetDoubleSliders();
    },
    setBoard: function setBoard(boardCards) {
      this.$store.commit('equityCalculator/removePresetCommunityCard', 'flop1');
      this.$store.commit('equityCalculator/removePresetCommunityCard', 'flop2');
      this.$store.commit('equityCalculator/removePresetCommunityCard', 'flop3');
      this.$store.commit('equityCalculator/removePresetCommunityCard', 'turn');
      this.$store.commit('equityCalculator/removePresetCommunityCard', 'river');
      this.$store.commit('equityCalculator/setBoard', boardCards);
      this.resetDoubleSliders();
    },
    removePresetCommunityCard: function removePresetCommunityCard(position) {
      this.$store.commit('equityCalculator/removePresetCommunityCard', position);
    },
    addPlayer: function addPlayer() {
      this.$store.commit('equityCalculator/addPlayer');
    },
    simulate: function simulate() {
      var self = this;
      var validateResult = __WEBPACK_IMPORTED_MODULE_9__services_simulator_validator__["a" /* default */].validateBeforeEquityCalculatorSimulation(self.state.players, self.state.presetCommunityCards);
      var numberOfSimulations = self.$store.state.account.user.settings.equityCalculator.numberOfSimulations;
      var $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      var weightedRanges = void 0;

      if (!self.authorized) {
        return;
      }

      if (validateResult.error) {
        alert(validateResult.errorMessage);
        return;
      }

      $simulationButtonText.text('Simulating...');
      weightedRanges = self._getWeightedRanges();
      __WEBPACK_IMPORTED_MODULE_10__services_simulator_simulator__["a" /* default */].getEquities(weightedRanges, self.state.presetCommunityCards.array, numberOfSimulations, self._incrementSimulationProgress).then(function (simulationResults) {
        self._resetSimulationProgress();
        self.$store.commit('equityCalculator/updateEquityResults', {
          simulationResults: simulationResults,
          numberOfSimulations: numberOfSimulations,
          rakePercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.rakePercentage,
          tipPercentage: self.$store.state.account.user.settings.equityCalculator.rakeAndTip.tipPercentage
        });
      }).catch(function (e) {
        console.error(e);
        self._resetSimulationProgress();
        alert('Encountered an unexpected problem while running the simulations.');
      });
    },
    _getWeightedRanges: function _getWeightedRanges() {
      var weightedRanges = [];

      this.state.players.forEach(function (player) {
        weightedRanges.push(player.states[0].generalHands.weightedRange);
      });

      return weightedRanges;
    },
    _incrementSimulationProgress: function _incrementSimulationProgress(value) {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      var $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', value + '%');
      $simulationButton.prop('disabled', true);
      $simulationButtonProgressBox.css('z-index', '1');
      $simulationButtonProgressBox.css('width', value + '%');
      $simulationButtonProgressBox.css('cursor', 'not-allowed');
    },
    _resetSimulationProgress: function _resetSimulationProgress() {
      var $simulationProgress = $(this.$el).find('.simulation-progress');
      var $simulationButton = $(this.$el).find('.simulate-button-container .simulate-button');
      var $simulationButtonText = $(this.$el).find('.simulate-button-container .text');
      var $simulationButtonProgressBox = $(this.$el).find('.simulate-button-container .progress-box');

      $simulationProgress.css('width', '0%');
      $simulationButton.prop('disabled', false);
      $simulationButtonText.text('Simulate');
      $simulationButtonProgressBox.css('z-index', '-1');
      $simulationButtonProgressBox.css('cursor', 'auto');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "l9ti":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_simulator_get_info_from_combined_cards_helpers__ = __webpack_require__("Ngfb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_get_hand_info__ = __webpack_require__("2EOj");






/* harmony default export */ __webpack_exports__["a"] = ({
  run: function run(holeCards, communityCards, handInfo, usingAtLeastOneHoleCard, shortDeck) {
    var drawInfo = {};
    var straightDrawInfoFromCommunityCards = {};

    if (communityCards.length >= 3) {
      if (shortDeck && handInfo.value >= 7) {
        return drawInfo;
      } else if (!shortDeck && handInfo.value >= 6) {
        return drawInfo;
      }
    }

    this._checkForFlushDraws(holeCards, communityCards, drawInfo, usingAtLeastOneHoleCard, shortDeck);

    // player has a straight
    if (handInfo.value === 5) {
      return drawInfo;
    }

    if (usingAtLeastOneHoleCard) {
      this._checkForStraightDraws([], communityCards, straightDrawInfoFromCommunityCards, false, shortDeck);
      this._checkForStraightDraws(holeCards, communityCards, drawInfo, straightDrawInfoFromCommunityCards, shortDeck);
    } else {
      this._checkForStraightDraws(holeCards, communityCards, drawInfo, false, shortDeck);
    }

    if (usingAtLeastOneHoleCard && holeCards.length > 0 && (handInfo.name === 'high card' || handInfo.name === 'pair' && handInfo.type !== 'overpair')) {
      this._checkForTopPairDraw(holeCards, communityCards, drawInfo);
    }

    return drawInfo;
  },
  _checkForFlushDraws: function _checkForFlushDraws(holeCards, communityCards, drawInfo, usingAtLeastOneHoleCard, shortDeck) {
    var cardsBySuit = __WEBPACK_IMPORTED_MODULE_1__services_simulator_get_info_from_combined_cards_helpers__["a" /* default */].getCardsBySuit(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.union(holeCards, communityCards));

    this.__checkForFourCardFlushDraw(holeCards, communityCards, cardsBySuit, drawInfo, usingAtLeastOneHoleCard, shortDeck);

    if (!drawInfo.flush && communityCards.length === 3) {
      this.__checkForBackdoorFlushDraw(holeCards, communityCards, cardsBySuit, drawInfo, usingAtLeastOneHoleCard, shortDeck);
    }
  },
  __checkForFourCardFlushDraw: function __checkForFourCardFlushDraw(holeCards, communityCards, cardsBySuit, drawInfo, usingAtLeastOneHoleCard, shortDeck) {
    var self = this;

    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(cardsBySuit, function (cardsOfSuit, suit) {
      if (cardsOfSuit.length === 4) {
        if (usingAtLeastOneHoleCard && !cardsOfSuit.includes(holeCards[0]) && !cardsOfSuit.includes(holeCards[1])) {
          return;
        }

        var nutLevel = self.___getFlushDrawNutLevel(suit, holeCards, communityCards, shortDeck);
        var nutLevelCamelCase = void 0;

        if (nutLevel === 'nut') {
          nutLevelCamelCase = 'nut';
        } else if (nutLevel === 'second nut') {
          nutLevelCamelCase = 'secondNut';
        } else if (nutLevel === 'third nut') {
          nutLevelCamelCase = 'thirdNut';
        } else if (nutLevel === 'weak') {
          nutLevelCamelCase = 'weak';
        }

        drawInfo.flush = {
          id: 'flushDraw:' + nutLevelCamelCase,
          type: 'four card',
          nutLevel: nutLevel,
          suit: suit
        };
      }
    });
  },
  ___getFlushDrawNutLevel: function ___getFlushDrawNutLevel(flushSuit, holeCards, communityCards, shortDeck) {
    var highestFlushDrawRankFromHoleCards = void 0;
    var communityCardFlushRanks = void 0;
    var unusedRanks = void 0;
    var nutLevelIndex = void 0;

    highestFlushDrawRankFromHoleCards = this.____getHighestFlushDrawRankFromHoleCards(holeCards, flushSuit);
    communityCardFlushRanks = communityCards.filter(function (communityCard) {
      return communityCard[1] === flushSuit;
    }).map(function (communityCard) {
      return communityCard[0];
    });
    unusedRanks = __WEBPACK_IMPORTED_MODULE_3__services_constants__["a" /* default */].ranks.filter(function (rank) {
      var isACommunityCardFlushRank = void 0;
      var makesARoyalOrStraightFlush = void 0;

      isACommunityCardFlushRank = communityCardFlushRanks.includes(rank);
      if (isACommunityCardFlushRank) {
        return false;
      }

      if (shortDeck) {
        makesARoyalOrStraightFlush = !!__WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */]._checkForFiveOrMoreRanksInARowShortDeck(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.union(communityCardFlushRanks, [rank]).sort(__WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction));
      } else {
        makesARoyalOrStraightFlush = !!__WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */]._checkForFiveOrMoreRanksInARow(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.union(communityCardFlushRanks, [rank]).sort(__WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.sortRanksDescendingCompareFunction));
      }

      if (makesARoyalOrStraightFlush) {
        return false;
      }

      return true;
    });
    nutLevelIndex = unusedRanks.indexOf(highestFlushDrawRankFromHoleCards);

    if (nutLevelIndex === 0) {
      return 'nut';
    } else if (nutLevelIndex === 1) {
      return 'second nut';
    } else if (nutLevelIndex === 2) {
      return 'third nut';
    } else if (nutLevelIndex >= 3 && nutLevelIndex <= 13) {
      return 'weak';
    } else if (nutLevelIndex !== -1) {
      throw new Error('Invalid value of nutLevelIndex.');
    }
  },
  ____getHighestFlushDrawRankFromHoleCards: function ____getHighestFlushDrawRankFromHoleCards(holeCards, flushSuit) {
    var holeCardsWithFlushDraw = holeCards.filter(function (holeCard) {
      return holeCard[1] === flushSuit;
    });

    return __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getHighestRankFromCards(holeCardsWithFlushDraw);
  },
  __checkForBackdoorFlushDraw: function __checkForBackdoorFlushDraw(holeCards, communityCards, cardsBySuit, drawInfo, usingAtLeastOneHoleCard, shortDeck) {
    var self = this;

    __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.forEach(cardsBySuit, function (cardsOfSuit, suit) {
      if (cardsOfSuit.length === 3) {
        if (usingAtLeastOneHoleCard && !cardsOfSuit.includes(holeCards[0]) && !cardsOfSuit.includes(holeCards[1])) {
          return;
        }

        var nutLevel = self.___getFlushDrawNutLevel(suit, holeCards, communityCards, shortDeck);
        var nutLevelCamelCase = void 0;

        if (nutLevel === 'nut') {
          nutLevelCamelCase = 'nut';
        } else if (nutLevel === 'second nut') {
          nutLevelCamelCase = 'secondNut';
        } else if (nutLevel === 'third nut') {
          nutLevelCamelCase = 'thirdNut';
        } else if (nutLevel === 'weak') {
          nutLevelCamelCase = 'weak';
        }

        drawInfo.flush = {
          id: 'backdoorFlushDraw:' + nutLevelCamelCase,
          type: 'backdoor',
          nutLevel: nutLevel,
          suit: suit
        };
      }
    });
  },
  _checkForStraightDraws: function _checkForStraightDraws(holeCards, communityCards, drawInfo, straightDrawInfoFromCommunityCards, shortDeck) {
    var rankIndexes = void 0;

    if (shortDeck) {
      rankIndexes = __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getRankIndexesFromCardsShortDeck(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.union(holeCards, communityCards), true);
    } else {
      rankIndexes = __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getRankIndexesFromCards(__WEBPACK_IMPORTED_MODULE_0_lodash___default.a.union(holeCards, communityCards), true);
    }

    this.__checkForOpenEndedStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards, shortDeck);

    if (!drawInfo.straight) {
      this.__checkForDoubleGutshotStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards);
    }

    if (!drawInfo.straight) {
      this.__checkForGutshotStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards, shortDeck);
    }

    if (!drawInfo.straight && communityCards.length === 3) {
      this.__checkForBackdoorStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards);
    }
  },
  __checkForOpenEndedStraightDraw: function __checkForOpenEndedStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards, shortDeck) {
    if (!!straightDrawInfoFromCommunityCards && straightDrawInfoFromCommunityCards.straight && straightDrawInfoFromCommunityCards.straight.type === 'open ended') {
      return;
    }

    var fourRankIndexes = void 0;

    for (var i = 0; i <= rankIndexes.length - 4; i++) {
      fourRankIndexes = rankIndexes.slice(i, i + 4);

      if (fourRankIndexes[0] === 0 || // akqj isn't an oesd
      !shortDeck && fourRankIndexes[3] === 13 || // 432a isn't an oesd
      shortDeck && fourRankIndexes[3] === 9 // 432a isn't an oesd
      ) {
          continue;
        } else if (__WEBPACK_IMPORTED_MODULE_1__services_simulator_get_info_from_combined_cards_helpers__["a" /* default */].checkIfRankIndexesAreSequential(fourRankIndexes)) {
        drawInfo.straight = {
          id: 'oesd',
          type: 'open ended',
          highCardRank: __WEBPACK_IMPORTED_MODULE_3__services_constants__["a" /* default */].ranks[fourRankIndexes[0]]
        };
        break;
      }
    }
  },
  __checkForDoubleGutshotStraightDraw: function __checkForDoubleGutshotStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards) {
    if (!!straightDrawInfoFromCommunityCards && straightDrawInfoFromCommunityCards.straight && straightDrawInfoFromCommunityCards.straight.type === 'open ended'
    // double gutshot on board not possible
    ) {
        return;
      }

    var fiveRankIndexes = void 0;

    for (var i = 0; i <= rankIndexes.length - 5; i++) {
      fiveRankIndexes = rankIndexes.slice(i, i + 5);

      if (fiveRankIndexes[0] + 2 === fiveRankIndexes[1] && // eg. aq
      fiveRankIndexes[1] + 1 === fiveRankIndexes[2] && // eg. qj
      fiveRankIndexes[2] + 1 === fiveRankIndexes[3] && // eg. jt
      fiveRankIndexes[3] + 2 === fiveRankIndexes[4] // eg. t8
      ) {
          drawInfo.straight = {
            id: 'doubleGutshot',
            type: 'double gutshot',
            highCardRank: __WEBPACK_IMPORTED_MODULE_3__services_constants__["a" /* default */].ranks[fiveRankIndexes[0]]
          };
          break;
        }
    }
  },
  __checkForGutshotStraightDraw: function __checkForGutshotStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards, shortDeck) {
    if (!!straightDrawInfoFromCommunityCards && straightDrawInfoFromCommunityCards.straight && (straightDrawInfoFromCommunityCards.straight.type === 'open ended' ||
    // double gutshot on board not possible
    straightDrawInfoFromCommunityCards.straight.type === 'gutshot')) {
      return;
    }

    var fourRankIndexes = void 0;
    var oneTwoThreeFourGutshotPresent = void 0; // akqj_
    var twoThreeFourFiveGutshotPresent = void 0; // _432a
    var oneTwoThreeFiveGutshotPresent = void 0; // eg. akq_t
    var oneTwoFourFiveGutshotPresent = void 0; // eg. ak_jt
    var oneThreeFourFiveGutshotPresent = void 0; // eg. a_qjt

    for (var i = 0; i <= rankIndexes.length - 4; i++) {
      fourRankIndexes = rankIndexes.slice(i, i + 4);
      oneTwoThreeFourGutshotPresent = fourRankIndexes[0] === 0 && fourRankIndexes[1] === 1 && fourRankIndexes[2] === 2 && fourRankIndexes[3] === 3;
      if (!shortDeck) {
        twoThreeFourFiveGutshotPresent = fourRankIndexes[0] === 10 && fourRankIndexes[1] === 11 && fourRankIndexes[2] === 12 && fourRankIndexes[3] === 13;
      } else {
        twoThreeFourFiveGutshotPresent = fourRankIndexes[0] === 6 && fourRankIndexes[1] === 7 && fourRankIndexes[2] === 8 && fourRankIndexes[3] === 9;
      }
      oneTwoThreeFiveGutshotPresent = fourRankIndexes[0] + 1 === fourRankIndexes[1] && fourRankIndexes[1] + 1 === fourRankIndexes[2] && fourRankIndexes[2] + 2 === fourRankIndexes[3];
      oneTwoFourFiveGutshotPresent = fourRankIndexes[0] + 1 === fourRankIndexes[1] && fourRankIndexes[1] + 2 === fourRankIndexes[2] && fourRankIndexes[2] + 1 === fourRankIndexes[3];
      oneThreeFourFiveGutshotPresent = fourRankIndexes[0] + 2 === fourRankIndexes[1] && fourRankIndexes[1] + 1 === fourRankIndexes[2] && fourRankIndexes[2] + 1 === fourRankIndexes[3];

      if (oneTwoThreeFourGutshotPresent || twoThreeFourFiveGutshotPresent || oneTwoThreeFiveGutshotPresent || oneTwoFourFiveGutshotPresent || oneThreeFourFiveGutshotPresent) {
        drawInfo.straight = {
          id: 'gutshot',
          type: 'gutshot'
        };
        break;
      }
    }
  },
  __checkForBackdoorStraightDraw: function __checkForBackdoorStraightDraw(rankIndexes, drawInfo, straightDrawInfoFromCommunityCards) {
    if (!!straightDrawInfoFromCommunityCards && straightDrawInfoFromCommunityCards.straight) {
      return;
    }

    var threeRankIndexes = void 0;
    var oneTwoThreeBackdoorStraightDrawPresent = void 0; // eg. akq__
    var oneTwoFourBackdoorStraightDrawPresent = void 0; // eg. ak_j_
    var oneTwoFiveBackdoorStraightDrawPresent = void 0; // eg. ak__t
    var oneThreeFourBackdoorStraightDrawPresent = void 0; // eg. a_qj_
    var oneThreeFiveBackdoorStraightDrawPresent = void 0; // eg. a_q_t
    var oneFourFiveBackdoorStraightDrawPresent = void 0; // eg. a__jt

    for (var i = 0; i <= rankIndexes.length - 3; i++) {
      threeRankIndexes = rankIndexes.slice(i, i + 3);
      oneTwoThreeBackdoorStraightDrawPresent = threeRankIndexes[0] + 1 === threeRankIndexes[1] && threeRankIndexes[1] + 1 === threeRankIndexes[2];
      oneTwoFourBackdoorStraightDrawPresent = threeRankIndexes[0] + 1 === threeRankIndexes[1] && threeRankIndexes[1] + 2 === threeRankIndexes[2];
      oneTwoFiveBackdoorStraightDrawPresent = threeRankIndexes[0] + 1 === threeRankIndexes[1] && threeRankIndexes[1] + 3 === threeRankIndexes[2];
      oneThreeFourBackdoorStraightDrawPresent = threeRankIndexes[0] + 2 === threeRankIndexes[1] && threeRankIndexes[1] + 1 === threeRankIndexes[2];
      oneThreeFiveBackdoorStraightDrawPresent = threeRankIndexes[0] + 2 === threeRankIndexes[1] && threeRankIndexes[1] + 2 === threeRankIndexes[2];
      oneFourFiveBackdoorStraightDrawPresent = threeRankIndexes[0] + 3 === threeRankIndexes[1] && threeRankIndexes[1] + 1 === threeRankIndexes[2];

      if (oneTwoThreeBackdoorStraightDrawPresent || oneTwoFourBackdoorStraightDrawPresent || oneTwoFiveBackdoorStraightDrawPresent || oneThreeFourBackdoorStraightDrawPresent || oneThreeFiveBackdoorStraightDrawPresent || oneFourFiveBackdoorStraightDrawPresent) {
        drawInfo.straight = {
          id: 'backdoorStraightDraw',
          type: 'backdoor'
        };
        break;
      }
    }
  },
  _checkForTopPairDraw: function _checkForTopPairDraw(holeCards, communityCards, drawInfo) {
    var holeCardOneRank = holeCards[0][0];
    var holeCardTwoRank = holeCards[1][0];
    var highestBoardCardRank = __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getHighestRankFromCards(communityCards);
    var isFirstHoleCardAnOvercard = __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.isFirstRankLargerThanSecond(holeCardOneRank, highestBoardCardRank);
    var isSecondHoleCardAnOvercard = __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.isFirstRankLargerThanSecond(holeCardTwoRank, highestBoardCardRank);

    if (isFirstHoleCardAnOvercard && isSecondHoleCardAnOvercard) {
      drawInfo.topPair = {
        id: 'twoOvercards',
        type: 'two overcards'
      };
    } else if (isFirstHoleCardAnOvercard || isSecondHoleCardAnOvercard) {
      drawInfo.topPair = {
        id: 'oneOvercard',
        type: 'one overcard'
      };
    }
  }
});

/***/ }),

/***/ "lCdj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-help'
});

/***/ }),

/***/ "lDlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_readonly_alert_vue__ = __webpack_require__("crMD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e07d2cb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_readonly_alert_vue__ = __webpack_require__("PTG4");
function injectStyle (ssrContext) {
  __webpack_require__("QyAZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e07d2cb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_readonly_alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e07d2cb6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_readonly_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lG8Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lKD2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hit_calculator_vue__ = __webpack_require__("CaVI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eec79f0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hit_calculator_vue__ = __webpack_require__("hnCa");
function injectStyle (ssrContext) {
  __webpack_require__("N7/9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eec79f0c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_hit_calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eec79f0c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_hit_calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lMB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_selector_vue__ = __webpack_require__("TQG8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c96821cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_selector_vue__ = __webpack_require__("F7ui");
function injectStyle (ssrContext) {
  __webpack_require__("epxe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c96821cc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_text_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c96821cc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_text_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfON":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"preset-hole-cards-selector"},[_c('span',{staticClass:"preset-hole-cards-text"},[_vm._v("Your cards:")]),_vm._v(" "),_c('individual-card-selector',{ref:"holeCardOne",attrs:{"cardString":_vm.presetHoleCards.holeCardOne,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setPresetHoleCard($event, 'holeCardOne')},"deselect":function($event){return _vm.$emit('removePresetHoleCard', 'holeCardOne')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"holeCardTwo",attrs:{"cardString":_vm.presetHoleCards.holeCardTwo,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setPresetHoleCard($event, 'holeCardTwo')},"deselect":function($event){return _vm.$emit('removePresetHoleCard', 'holeCardTwo')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ll94":
/***/ (function(module, exports) {

module.exports = {"_from":"vue-chartjs@^2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"vue-chartjs@^2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"^2.8.7","saveSpec":null,"fetchSpec":"^2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_shasum":"bcd1cda1a1ef8ed80581638a02cf88182d437d09","_spec":"vue-chartjs@^2.8.7","_where":"/opt/atlassian/pipelines/agent/build/frontend","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"bundleDependencies":false,"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"deprecated":false,"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),

/***/ "lw+r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lx+6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hit-calculator-checkboxes-included-settings settings"},[_vm._m(0),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.madeHandLeaves),function(madeHandLeaf){return _c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(madeHandLeaf.breadcrumbText)}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.includedByDefault[madeHandLeaf.id]),expression:"includedByDefault[madeHandLeaf.id]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.includedByDefault[madeHandLeaf.id])?_vm._i(_vm.includedByDefault[madeHandLeaf.id],null)>-1:(_vm.includedByDefault[madeHandLeaf.id])},on:{"change":function($event){var $$a=_vm.includedByDefault[madeHandLeaf.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.includedByDefault, madeHandLeaf.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.includedByDefault, madeHandLeaf.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.includedByDefault, madeHandLeaf.id, $$c)}}}})])])}),0)]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.drawLeaves),function(drawLeaf){return _c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(drawLeaf.breadcrumbText)}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.includedByDefault[drawLeaf.id]),expression:"includedByDefault[drawLeaf.id]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.includedByDefault[drawLeaf.id])?_vm._i(_vm.includedByDefault[drawLeaf.id],null)>-1:(_vm.includedByDefault[drawLeaf.id])},on:{"change":function($event){var $$a=_vm.includedByDefault[drawLeaf.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.includedByDefault, drawLeaf.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.includedByDefault, drawLeaf.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.includedByDefault, drawLeaf.id, $$c)}}}})])])}),0)]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.comboLeaves),function(comboLeaf){return _c('tr',[_c('td',{domProps:{"innerHTML":_vm._s(comboLeaf.breadcrumbText)}}),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.includedByDefault[comboLeaf.id]),expression:"includedByDefault[comboLeaf.id]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.includedByDefault[comboLeaf.id])?_vm._i(_vm.includedByDefault[comboLeaf.id],null)>-1:(_vm.includedByDefault[comboLeaf.id])},on:{"change":function($event){var $$a=_vm.includedByDefault[comboLeaf.id],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.includedByDefault, comboLeaf.id, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.includedByDefault, comboLeaf.id, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.includedByDefault, comboLeaf.id, $$c)}}}})])])}),0)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){return _vm.reset()}}},[_vm._v("\n      Set to defaults\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("\n      Save\n    ")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_c('p',[_vm._v("If you feel like the hit calculator is cluttered and you aren't interested in some of the checkboxes, you may want to uninclude some of them.")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/hit-calculator-checkboxes-included-1.png"}}),_vm._v(" "),_c('img',{attrs:{"src":"/static/settings/hit-calculator-checkboxes-included-2.png"}})]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Hit calculator checkboxes included")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"col-xs-8 col-sm-6"},[_vm._v("Made hand")]),_vm._v(" "),_c('th',{staticClass:"col-xs-2 col-sm-3"},[_vm._v("Included")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"col-xs-8 col-sm-6"},[_vm._v("Draw")]),_vm._v(" "),_c('th',{staticClass:"col-xs-2 col-sm-3"},[_vm._v("Included")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"col-xs-8 col-sm-6"},[_vm._v("Combo")]),_vm._v(" "),_c('th',{staticClass:"col-xs-2 col-sm-3"},[_vm._v("Included")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lxmf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"guided-analyses-should-you-call"},[(!_vm.authorized)?_c('readonly-alert'):_vm._e(),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h4',[_vm._v("Step 1: What street are you deciding whether or not to call on?")]),_vm._v(" "),_c('street-selector',{attrs:{"street":_vm.state.streetToCall,"authorized":_vm.authorized},on:{"setStreet":function($event){return _vm.setStreetToCall($event)}}}),_vm._v(" "),_c('h4',[_vm._v("Step 2: How many opponents are you facing on that street?")]),_vm._v(" "),_c('num-opponents-selector',{attrs:{"numOpponents":_vm.state.players.numPlayers,"authorized":_vm.authorized},on:{"addOpponent":function($event){return _vm.addPlayer()},"removeOpponent":function($event){return _vm.removePlayer()}}}),_vm._v(" "),_c('h4',[_vm._v("Step 3: What are your hole cards?")]),_vm._v(" "),_c('hole-cards-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setPresetHoleCard":function($event){return _vm.setPresetHoleCard($event)},"removePresetHoleCard":function($event){return _vm.removePresetHoleCard($event)}}}),_vm._v(" "),_c('preflop-steps',{ref:"preflopSteps",attrs:{"players":_vm.state.players,"presetCommunityCards":_vm.state.presetCommunityCards,"streetToCall":_vm.state.streetToCall,"authorized":_vm.authorized}}),_vm._v(" "),(_vm.state.presetHoleCards.bothSet)?_c('flop-steps',{attrs:{"state":_vm.state,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(1),"authorized":_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event.card, $event.position)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"setPotOdds":function($event){return _vm.setPotOdds($event)},"setRealOddsLHS":function($event){return _vm.setRealOddsLHS($event)},"setBettingCriteria":function($event){return _vm.setBettingCriteria()}}}):_vm._e(),_vm._v(" "),((_vm.state.streetToCall === 'turn' || _vm.state.streetToCall === 'river') && _vm.state.presetCommunityCards.flopSet && _vm.state.presetHoleCards.bothSet)?_c('turn-steps',{attrs:{"state":_vm.state,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(2),"authorized":_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event.card, $event.position)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"setPotOdds":function($event){return _vm.setPotOdds($event)},"setRealOddsLHS":function($event){return _vm.setRealOddsLHS($event)},"setBettingCriteria":function($event){return _vm.setBettingCriteria()}}}):_vm._e(),_vm._v(" "),(_vm.state.streetToCall === 'river' && _vm.state.presetCommunityCards.turnSet && _vm.state.presetHoleCards.bothSet)?_c('river-steps',{attrs:{"state":_vm.state,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(3),"authorized":_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event.card, $event.position)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"setPotOdds":function($event){return _vm.setPotOdds($event)},"setRealOddsLHS":function($event){return _vm.setRealOddsLHS($event)},"setBettingCriteria":function($event){return _vm.setBettingCriteria()}}}):_vm._e(),_vm._v(" "),(_vm.ableToRunEquityCalculations)?_c('section',[_c('initial-conclusion',{attrs:{"potOdds":_vm.state.potOdds,"equity":_vm.equity,"streetToCall":_vm.state.streetToCall,"breakevenPercentageViaPotOdds":_vm.$store.getters['guidedAnalysesCalling/breakevenPercentageViaPotOdds']}}),_vm._v(" "),(_vm.state.streetToCall !== 'river')?_c('final-conclusion',{attrs:{"potOdds":_vm.state.potOdds,"equity":_vm.equity,"realOddsLHS":_vm.state.realOddsLHS,"breakevenPercentageViaRealOdds":_vm.$store.getters['guidedAnalysesCalling/breakevenPercentageViaRealOdds']},on:{"setRealOddsLHS":function($event){return _vm.setRealOddsLHS($event)}}}):_vm._e(),_vm._v(" "),_c('long-run-disclaimer'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
        method: 'createSharableGuidedAnalysesCallingURL',
        state: _vm.state,
        approximateWaitTime: 5,
      })}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized},on:{"saveScenario":function($event){return _vm.$emit('saveScenario', {
        method: 'createSharableGuidedAnalysesCallingURL',
        savedScenarioPropertyName: 'shouldYouCall',
        state: _vm.state,
      })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
        method: '_constructGuidedAnalysesCallingData',
        state: _vm.state,
      })}}})],1):_vm._e(),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"should you call tool","urlPath":"should-you-call"}}),_vm._v(" "),_c('help-icon',{attrs:{"path":"/help/should-you-call"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Guided Analysis: Should you call?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m4dX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preset_community_cards_selector_vue__ = __webpack_require__("ZfmI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b573e04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preset_community_cards_selector_vue__ = __webpack_require__("t/f8");
function injectStyle (ssrContext) {
  __webpack_require__("+D9E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b573e04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preset_community_cards_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b573e04_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preset_community_cards_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m5V8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Help / Hit Calculator")])]),_vm._v(" "),_c('p',[_vm._v("Check out the videos in the playlist below:")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/videoseries?list=PLRMU8AXUCOa-wmVFLXScyfBPlnISZIU4f","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Still need help?")]),_vm._v(" "),_c('p',[_vm._v("I'm here for you. Hit me up at "),_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(". I'd love to answer any questions you have.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "m62S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_blog_subscribe_to_blog__ = __webpack_require__("bnhV");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog_pokers-one-percent-summary',
  components: {
    'subscribe-to-blog': __WEBPACK_IMPORTED_MODULE_0__components_blog_subscribe_to_blog__["a" /* default */]
  }
});

/***/ }),

/***/ "m71c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well help-section"},[(_vm.playerStateIndex === 0)?_c('section',[_c('h3',[_vm._v("After the preflop action is finished? What are you talking about?")]),_vm._v(" "),_c('p',[_vm._v("Consider an example: your opponent opens to 3 big blinds from the button, and you call from the big blind. At this point, the preflop action is over and you're about to head to the flop. We want to know what your opponents range is at this point. What would they open with from the button?")]),_vm._v(" "),_c('p',[_vm._v("Consider another example: your opponent opens to 3 big blinds from the button, you 3bet from the big blind, and they call. Same thing: at this point, the preflop action is over, you're about to head to the flop, and we want to know what your opponents range is. What would they open-call with?")])]):_vm._e(),_vm._v(" "),(_vm.playerStateIndex === 1 && _vm.streetToCall !== 'flop')?_c('section',[_c('h3',[_vm._v("After the flop action is finished? What are you talking about?")]),_vm._v(" "),_c('p',[_vm._v("Consider an example: you check, they bet, and you call. At this point, the flop action is over and you're about to head to the turn. We want to know what your opponents range is at this point. What do you think they would bet the flop with?")]),_vm._v(" "),_c('p',[_vm._v("Consider another example: you check, they bet, you raise, and they call. Same thing: at this point, the flop action is over, you're about to head to the turn, and we want to know what your opponents range is. What would they bet-call the flop with?")])]):_vm._e(),_vm._v(" "),(_vm.playerStateIndex === 2 && _vm.streetToCall !== 'turn')?_c('section',[_c('h3',[_vm._v("After the turn action is finished? What are you talking about?")]),_vm._v(" "),_c('p',[_vm._v("Consider an example: you check, they bet, and you call. At this point, the turn action is over and you're about to head to the river. We want to know what your opponents range is at this point. What do you think they would bet the turn with?")]),_vm._v(" "),_c('p',[_vm._v("Consider another example: you check, they bet, you raise, and they call. Same thing: at this point, the turn action is over, you're about to head to the river, and we want to know what your opponents range is. What would they bet-call the turn with?")])]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("What is a range?")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.playerStateIndex === 0)?_c('section',[_c('h3',[_vm._v("How do I know what their range is?")]),_vm._v(" "),_c('p',[_vm._v("You have to use your judgement.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]):_c('section',[_c('h3',[_vm._v("How do I know what their range is?")]),_vm._v(" "),_c('p',[_vm._v("You have to use your judgement.")]),_vm._v(" "),_c('p',[_vm._v("Your opponent probably wouldn't bet with air. They'd probably check their complete air. But they would probably bet their top pairs and flush draws. Or maybe they'd check their flush draws. Those are questions that are more about poker experience and feel than software and math.")]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('h3',[_vm._v("Why am I setting ranges?")]),_vm._v(" "),_c('p',[_vm._v("Ultimately, we want to know how much equity you have against your opponent after they bet the "+_vm._s(_vm.streetToCall)+". In order to figure that out, we need to know what their range is when they bet. The process of figuring that out involves starting with their range after the preflop action and continuously narrowing it down after each street.")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Consider a simple example where you open from the button and get 3bet by the big blind. Suppose that you know that your opponent is a passive player who only 3bets with aces or kings. That means that your opponents "),_c('em',[_vm._v("range")]),_vm._v(" is aces and kings. That the possible hands your opponent might have are AA and KK.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you want to be more thorough, you can give hands a "),_c('em',[_vm._v("weight")]),_vm._v(". Maybe you think that your opponent will 3bet with QQ 50% of the time. If so, "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-setting-hand-weights","target":"_blank"}},[_vm._v("you can")]),_vm._v(" select QQ with a weight of 50.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("Your opponent probably wouldn't open preflop with 72o. They probably "),_c('em',[_vm._v("would")]),_vm._v(" open with AKo. Same with AQo. But what about AJo? ATo? A9o? Those are questions that are more about poker experience and feel than software and math.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you're not sure whether they'd open AJo for example, you can "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-setting-hand-weights","target":"_blank"}},[_vm._v("use weights")]),_vm._v(" to express your a probability estimate. For example, if you think there's a 25% chance that they'd open AJo, you can give AJo a weight of 25 (and AKo and AQo weights of 100).")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("You can also use the default "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-saved-ranges","target":"_blank"}},[_vm._v("saved ranges")]),_vm._v(" as a starting point.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("If you aren't sure whether they would bet their flush draws, "),_c('a',{attrs:{"href":"/quick-guide#quick-guide-set-checkbox-weights","target":"_blank"}},[_vm._v("you can give flush draws a weight")]),_vm._v(" to express a probability estimate. For example, if you think that there's a 25% chance that they bet with their flush draws, you can give flush draws a weight of 25.")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mDCG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_set_weight_to_apply_to_added_hands_modal_vue__ = __webpack_require__("1niS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72751f07_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_set_weight_to_apply_to_added_hands_modal_vue__ = __webpack_require__("WztS");
function injectStyle (ssrContext) {
  __webpack_require__("E2CI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72751f07"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_set_weight_to_apply_to_added_hands_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72751f07_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_set_weight_to_apply_to_added_hands_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mJM+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_Players__ = __webpack_require__("IPbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__ = __webpack_require__("XRwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_service__ = __webpack_require__("JBFI");





var state = {
  players: new __WEBPACK_IMPORTED_MODULE_0__services_player_Players__["a" /* default */](),
  presetCommunityCards: new __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__["a" /* default */](),
  openSize: 3,
  threeBetSize: 9,
  numPlayersLeftToAct: 3,
  averageFourBetPercentage: 1,
  cbetSize: 0.5,
  continueVsCbetPercentage: 50,
  hitPercentage: 5,
  firstStreetOfValuePercentage: 50,
  secondStreetOfValuePercentage: 50,
  thirdStreetOfValuePercentage: 50,
  alternativeEV: 0
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_2__services_share_url_service__["a" /* default */].setThreeBetCbetStoreState(stateFromServer, state);
  },

  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].deselectGeneralHand(state, payload);
  },
  manuallySelectGeneralHand: function manuallySelectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].manuallySelectGeneralHand(state, payload);
  },
  manuallyDeselectGeneralHand: function manuallyDeselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].manuallyDeselectGeneralHand(state, payload);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].deselectGeneralHands(state, payload);
  },
  manuallyDeselectAllGeneralHands: function manuallyDeselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].manuallyDeselectAllGeneralHands(state, payload);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].selectSpecificHands(state, payload);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].deselectAllGeneralHands(state, payload);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].applyExactWeightToGeneralHands(state, payload);
  },
  manuallyApplyExactWeightToGeneralHand: function manuallyApplyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].manuallyApplyExactWeightToGeneralHand(state, payload);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_3__store_service__["a" /* default */].setWeightToApplyToAddedHands(state, payload);
  },

  // other
  setOpenSize: function setOpenSize(state, openSize) {
    state.openSize = openSize;
  },
  setThreeBetSize: function setThreeBetSize(state, threeBetSize) {
    state.threeBetSize = threeBetSize;
  },
  setNumPlayersLeftToAct: function setNumPlayersLeftToAct(state, numPlayersLeftToAct) {
    state.numPlayersLeftToAct = numPlayersLeftToAct;
  },
  setAverageFourBetPercentage: function setAverageFourBetPercentage(state, averageFourBetPercentage) {
    state.averageFourBetPercentage = averageFourBetPercentage;
  },
  setCbetSize: function setCbetSize(state, cbetSize) {
    state.cbetSize = cbetSize;
  },
  setContinueVsCbetPercentage: function setContinueVsCbetPercentage(state, continueVsCbetPercentage) {
    state.continueVsCbetPercentage = continueVsCbetPercentage;
  },
  setHitPercentage: function setHitPercentage(state, hitPercentage) {
    state.hitPercentage = hitPercentage;
  },
  setFirstStreetOfValuePercentage: function setFirstStreetOfValuePercentage(state, firstStreetOfValuePercentage) {
    state.firstStreetOfValuePercentage = firstStreetOfValuePercentage;
  },
  setSecondStreetOfValuePercentage: function setSecondStreetOfValuePercentage(state, secondStreetOfValuePercentage) {
    state.secondStreetOfValuePercentage = secondStreetOfValuePercentage;
  },
  setThirdStreetOfValuePercentage: function setThirdStreetOfValuePercentage(state, thirdStreetOfValuePercentage) {
    state.thirdStreetOfValuePercentage = thirdStreetOfValuePercentage;
  },
  setAlternativeEV: function setAlternativeEV(state, alternativeEV) {
    state.alternativeEV = alternativeEV;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations
});



/***/ }),

/***/ "mOpl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mTvE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mXeB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_togglable_section_vue__ = __webpack_require__("IpzJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c1569e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_togglable_section_vue__ = __webpack_require__("vgNS");
function injectStyle (ssrContext) {
  __webpack_require__("WF3E")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c1569e1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_togglable_section_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c1569e1_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_togglable_section_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mYmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-bluff-final-conclusion well",attrs:{"id":"should-you-bluff-final-conclusion"}},[_vm._m(0),_vm._v(" "),(_vm.ableToRunEquityCalculations)?_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[(_vm.equitySimulationsInProgress)?_c('td',[_vm._v("Running simulations...")]):_c('td',[_vm._v(_vm._s(_vm.equity)+"%")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n      True breakeven percentage:\n      "),_c('input',{staticClass:"form-control input-lg",attrs:{"type":"number","min":"1","max":_vm.immediatelyProfitableBreakevenPercentage},domProps:{"value":_vm.profitableBreakevenPercentage},on:{"input":function($event){return _vm.$emit('setProfitableBreakevenPercentage', $event.target.valueAsNumber)}}})])]),_vm._v(" "),(_vm.isBluffProfitable)?_c('div',{staticClass:"alert alert-success"},[_vm._v("\n    According to the true breakeven percentage that you estimated, your bluff "),_c('em',[_vm._v("will")]),_vm._v(" be profitable. ✅\n  ")]):_c('div',{staticClass:"alert alert-danger"},[_vm._v("\n    According to the true breakeven percentage that you estimated, your bluff "),_c('em',[_vm._v("will not")]),_vm._v(" be profitable. ❌\n  ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("\n    1. Suppose that you bluff with a flush draw, get called, and then hit your flush. \"Immediately profitable\" doesn't take this into account.\n    "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible.futureStreets[0]},on:{"toggleHelp":function($event){return _vm.toggleHelp('futureStreets', 0)}}})],1),_vm._v(" "),(_vm.helpAreaVisible.futureStreets[0])?_c('future-streets-help-section-1'):_vm._e(),_vm._v(" "),_c('p',[_vm._v("\n    2. Suppose that you bluff, get called, hit a scare card, bluff again on the next street, and get a fold. \"Immediately profitable\" doesn't take this into account either.\n    "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible.futureStreets[1]},on:{"toggleHelp":function($event){return _vm.toggleHelp('futureStreets', 1)}}})],1),_vm._v(" "),(_vm.helpAreaVisible.futureStreets[1])?_c('future-streets-help-section-2'):_vm._e(),_vm._v(" "),_c('p',[_vm._v("So then, use your judgement to "),_c('strong',[_vm._v("drop the "+_vm._s(_vm.immediatelyProfitableBreakevenPercentage)+"% number down by about 5-15%")]),_vm._v(" depending on whether other factors are good or bad, and then enter that number in to the input box above.")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("Or, play around with the "),_c('router-link',{attrs:{"to":"/breakeven-percentage-for-bluffing-the-turn"}},[_vm._v("breakeven percentage tool")]),_vm._v(" to come up with a more exact number.")],1),_vm._v(" "),(_vm.streetToBluff === 'flop')?_c('p',[_vm._v("(Right now it only works for turn bluffs, not flop bluffs. In the future it will work for flop bluffs as well. For now, if you're considering a flop bluff, drop whatever number you come up with for a turn bluff down a little bit.)")]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Subsequent analysis that factors in future streets")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Equity versus your opponents continuing range")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Good factors")]),_vm._v(" "),_c('th',[_vm._v("Bad factors")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("A lot of outs")]),_vm._v(" "),_c('td',[_vm._v("Not many outs")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Good future fold equity")]),_vm._v(" "),_c('td',[_vm._v("Bad future fold equity")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("No showdown value")]),_vm._v(" "),_c('td',[_vm._v("Showdown value")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("In position")]),_vm._v(" "),_c('td',[_vm._v("Out of position")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mbNt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'initial-bet-size-button-group',
  props: ['initialBetSize']
});

/***/ }),

/***/ "meBw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "meTV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'pricing-table'
});

/***/ }),

/***/ "mi9E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("There are currently only two tools for short deck: the "),_c('router-link',{attrs:{"to":"/short-deck/equity-calculator"}},[_vm._v("Equity Calculator")]),_vm._v(" and the "),_c('router-link',{attrs:{"to":"/help/hit-calculator"}},[_vm._v("Hit Calculator")]),_vm._v(".")],1),_vm._v(" "),_c('h3',[_vm._v("Equity Calculator: Free")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/pages/short-deck-equity-calculator.png"}}),_vm._v(" "),_c('p',[_vm._v("I'm experimenting with offering the "),_c('router-link',{attrs:{"to":"/short-deck/equity-calculator"}},[_vm._v("equity calculator")]),_vm._v(" for free and making money with affiliate links for poker sites. I don't have the links yet, so stay tuned.")],1),_vm._v(" "),_c('h3',[_vm._v("Hit Calculator: $150 for lifetime access after a 14 day free trial")]),_vm._v(" "),_c('img',{attrs:{"src":"/static/pages/short-deck-hit-calculator.png"}}),_vm._v(" "),(_vm.loggedIn)?_c('p',[_vm._v("Head over to the "),_c('router-link',{attrs:{"to":"/purchase-short-deck"}},[_vm._v("purchase page")]),_vm._v(" if you're interested.")],1):_c('section',{staticClass:"alert alert-info"},[_vm._v("\n    Note: You need to "),_c('router-link',{attrs:{"to":"/register"}},[_vm._v("register")]),_vm._v(" before you can pay. When you do register, you'll automatically be entered in to the 14 day free trial.\n  ")],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Short deck pricing")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mjyE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_flop_selector_vue__ = __webpack_require__("gUwV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f605fd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_flop_selector_vue__ = __webpack_require__("ivL/");
function injectStyle (ssrContext) {
  __webpack_require__("bKmm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f605fd4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_flop_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f605fd4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_flop_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mzkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("ce18");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64092b98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("TWjd");
function injectStyle (ssrContext) {
  __webpack_require__("Tn63")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64092b98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64092b98_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "n+VG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bluff-size-selector"},[_c('h4',[_vm._v("\n    Step "+_vm._s(_vm.step)+": What bluff size do you want to explore?\n    "),_c('toggle-help-button',{attrs:{"helpAreaVisible":_vm.helpAreaVisible},on:{"toggleHelp":function($event){return _vm.toggleHelp()}}})],1),_vm._v(" "),(_vm.helpAreaVisible)?_c('help-section'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.bluffSize === '1/3'},on:{"input":function($event){return _vm.$emit('setBluffSize', '1/3')}}}),_vm._v("\n      1/3 pot (needs to work more than 25% of the time in order to be immediately profitable)\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.bluffSize === '1/2'},on:{"input":function($event){return _vm.$emit('setBluffSize', '1/2')}}}),_vm._v("\n      1/2 pot (needs to work more than 33.3% of the time in order to be immediately profitable)\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.bluffSize === '2/3'},on:{"input":function($event){return _vm.$emit('setBluffSize', '2/3')}}}),_vm._v("\n      2/3 pot (needs to work more than 40% of the time in order to be immediately profitable)\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.bluffSize === '3/4'},on:{"input":function($event){return _vm.$emit('setBluffSize', '3/4')}}}),_vm._v("\n      3/4 pot (needs to work more than 42.9% of the time in order to be immediately profitable)\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.bluffSize === 'full'},on:{"input":function($event){return _vm.$emit('setBluffSize', 'full')}}}),_vm._v("\n      Full pot (needs to work more than 50% of the time in order to be immediately profitable)\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.bluffSize === '1.5x'},on:{"input":function($event){return _vm.$emit('setBluffSize', '1.5x')}}}),_vm._v("\n      1.5x pot (needs to work more than 60% of the time in order to be immediately profitable)\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":_vm.bluffSize === '2x'},on:{"input":function($event){return _vm.$emit('setBluffSize', '2x')}}}),_vm._v("\n      2x pot (needs to work more than 66.6% of the time in order to be immediately profitable)\n    ")])]),_vm._v(" "),_c('div',{staticClass:"radio"},[_c('label',[_c('input',{attrs:{"type":"radio","disabled":!_vm.authorized},domProps:{"checked":!['1/3', '1/2', '2/3', '3/4', 'full', '1.5x', '2x'].includes(_vm.bluffSize)},on:{"input":function($event){return _vm.$emit('setBluffSize', _vm.customBluffSize + 'x')}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.customBluffSize),expression:"customBluffSize"}],attrs:{"type":"number","disabled":!_vm.authorized,"min":"0.1","step":"0.1"},domProps:{"value":(_vm.customBluffSize)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.customBluffSize=$event.target.value},function($event){return _vm.$emit('setBluffSize', _vm.customBluffSize + 'x')}]}}),_vm._v("x pot\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n2DV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"equity-calculator-insights-settings settings"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.equityCalculatorInsightsVisible),expression:"equityCalculatorInsightsVisible"}],attrs:{"type":"radio","value":"true"},domProps:{"checked":_vm._q(_vm.equityCalculatorInsightsVisible,"true")},on:{"change":function($event){_vm.equityCalculatorInsightsVisible="true"}}}),_vm._v("\n          Show insights\n          "),_c('img',{attrs:{"src":"/static/settings/equity-calculator-insights-visible.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.equityCalculatorInsightsVisible),expression:"equityCalculatorInsightsVisible"}],attrs:{"type":"radio","value":"false"},domProps:{"checked":_vm._q(_vm.equityCalculatorInsightsVisible,"false")},on:{"change":function($event){_vm.equityCalculatorInsightsVisible="false"}}}),_vm._v("\n          Hide insights\n          "),_c('img',{attrs:{"src":"/static/settings/equity-calculator-insights-not-visible.png"}})])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Insights (equity calculator)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "n79P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator-number-of-simulations-settings',
  data: function data() {
    return {
      numberOfSimulations: this.$store.state.account.user.settings.hitCalculator.numberOfSimulations,
      isHelpVisible: false
    };
  },
  methods: {
    reset: function reset() {
      var self = this;

      self.$refs.numberOfSimulations.value = 25000;
      setTimeout(function () {
        self.save();
      }, 50);
    },
    save: function save() {
      if (Number(this.$refs.numberOfSimulations.value) > 250000) {
        alert("That's too much. It'd probably crash your browser. Try 250,000 or less.");
        return;
      }

      var self = this;
      var user = _.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.numberOfSimulations = Number(this.$refs.numberOfSimulations.value);
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "nMYT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_scenario_alert_vue__ = __webpack_require__("qYOO");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_144a1010_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_scenario_alert_vue__ = __webpack_require__("MlmV");
function injectStyle (ssrContext) {
  __webpack_require__("26cs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-144a1010"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_saved_scenario_alert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_144a1010_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_saved_scenario_alert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nj4X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_turn_steps_vue__ = __webpack_require__("O7Wo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e9b3d80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_turn_steps_vue__ = __webpack_require__("z2cd");
function injectStyle (ssrContext) {
  __webpack_require__("EbCy")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e9b3d80"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_turn_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e9b3d80_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_turn_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "noRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_hand_range__ = __webpack_require__("cOfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_five_card_hands_section__ = __webpack_require__("+Gii");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_controls_simulate_button__ = __webpack_require__("PQAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_five_card_hands_section_alerts__ = __webpack_require__("hmzL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_hand_range_value_to_bluff_ratio__ = __webpack_require__("qfrL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'range-for-street',
  components: {
    'hand-range': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_hand_range__["a" /* default */],
    'five-card-hands-section': __WEBPACK_IMPORTED_MODULE_1__components_five_card_hands_section_five_card_hands_section__["a" /* default */],
    'simulate-button': __WEBPACK_IMPORTED_MODULE_2__components_controls_simulate_button__["a" /* default */],
    'five-card-hands-section-alerts': __WEBPACK_IMPORTED_MODULE_3__components_five_card_hands_section_alerts__["a" /* default */],
    'value-to-bluff-ratio': __WEBPACK_IMPORTED_MODULE_4__components_hand_range_value_to_bluff_ratio__["a" /* default */]
  },
  props: ['player', 'playerIndex', 'playerStateIndex', 'presetCommunityCards', 'presetHoleCards', 'textWhenFiveCardHandPercentagesArentUpToDate', 'storeModuleName', 'simulateButton', 'authorized'],
  computed: {
    handRankings: function handRankings() {
      return this.$store.getters['account/handRankings'];
    },
    disableAllSelectors: function disableAllSelectors() {
      if (!this.authorized) {
        return true;
      }

      if (this.playerStateIndex === 0) {
        return false;
      }

      return !this.presetCommunityCards.areAllCardsSet(this.playerStateIndex);
    }
  },
  methods: {
    handleFiveCardHandMouseover: function handleFiveCardHandMouseover(storeModuleName, $store, playerIndex, playerStateIndex, e) {
      if (!this.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        return;
      }

      this.player.handleFiveCardHandMouseover(storeModuleName, $store, playerIndex, playerStateIndex, e);
    },
    handleFiveCardHandMouseleave: function handleFiveCardHandMouseleave(storeModuleName, $store, playerIndex, playerStateIndex) {
      if (!this.presetCommunityCards.areAllCardsSet(playerStateIndex)) {
        return;
      }

      this.player.handleFiveCardHandMouseleave(storeModuleName, $store, playerIndex, playerStateIndex);
    },
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$refs['player-' + playerIndex + '-0']) {
        this.$refs['player-' + playerIndex + '-0'].resetDoubleSlider();
      }
    }
  }
});

/***/ }),

/***/ "nxTv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.generalHands.numberOfSpecificHandsInRange > 0)?_c('section',{staticClass:"value-to-bluff-ratio panel-title"},[_c('span',{staticClass:"result"},[_c('div',{staticClass:"result-label"},[_vm._v("Value:")]),_vm._v(" "),_c('div',{staticClass:"result-value"},[_vm._v(_vm._s(_vm.percentOfSelectedRangeThatIsValue)+"%")])]),_vm._v(" "),_c('span',{staticClass:"result"},[_c('div',{staticClass:"result-label"},[_vm._v("Bluffs:")]),_vm._v(" "),_c('div',{staticClass:"result-value"},[_vm._v(_vm._s(_vm.percentOfSelectedRangeThatIsBluffs)+"%")])]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.idOfSelectedCutoffHand),expression:"idOfSelectedCutoffHand"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.idOfSelectedCutoffHand=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((_vm.cutoffHands),function(hand){return _c('option',{key:hand.id,domProps:{"value":hand.id}},[_vm._v("\n      "+_vm._s(hand.name)+"\n    ")])}),0),_vm._v(" "),_c('a',{staticClass:"glyphicon glyphicon-question-sign",attrs:{"tabindex":"0","role":"button","data-toggle":"popover","data-placement":"top","data-trigger":"focus","data-content":"<p>Use the dropdown to select the cutoff hand. Example: If TPWK is selected, it means that everything TPWK and better is considered a value hand, and everything else is considered a bluff.</p><p>Think about whether the value-to-bluff ratio makes sense for your opponent. Is a nit really bluffing the river 85% of the time?</p>"}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nzJx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o0yB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_river_steps_vue__ = __webpack_require__("cW5A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17357d91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_river_steps_vue__ = __webpack_require__("AsmH");
function injectStyle (ssrContext) {
  __webpack_require__("Os5f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_river_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17357d91_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_river_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o2lI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_vue__ = __webpack_require__("9Zp6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67423e82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tier_selector_vue__ = __webpack_require__("pN41");
function injectStyle (ssrContext) {
  __webpack_require__("k1yZ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67423e82"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tier_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67423e82_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tier_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "o9kw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-results',
  props: ['equity', 'equityString', 'winPercentageString', 'tiePercentageString', 'hasSimulationBeenRun'],
  computed: {
    equityClass: function equityClass() {
      if (!this.hasSimulationBeenRun) {
        return '';
      }

      if (this.equity >= 95) {
        return 'green-95-100';
      } else if (this.equity >= 90) {
        return 'green-90-95';
      } else if (this.equity >= 85) {
        return 'green-85-90';
      } else if (this.equity >= 80) {
        return 'green-80-85';
      } else if (this.equity >= 75) {
        return 'green-75-80';
      } else if (this.equity >= 70) {
        return 'green-70-75';
      } else if (this.equity >= 65) {
        return 'green-65-70';
      } else if (this.equity >= 60) {
        return 'green-60-65';
      } else if (this.equity >= 55) {
        return 'green-55-60';
      } else if (this.equity > 50) {
        return 'green-50-55';
      } else if (this.equity === 50) {
        return 'gray-50';
      } else if (this.equity >= 45) {
        return 'red-45-50';
      } else if (this.equity >= 40) {
        return 'red-40-45';
      } else if (this.equity >= 35) {
        return 'red-35-40';
      } else if (this.equity >= 30) {
        return 'red-30-35';
      } else if (this.equity >= 25) {
        return 'red-25-30';
      } else if (this.equity >= 20) {
        return 'red-20-25';
      } else if (this.equity >= 15) {
        return 'red-15-20';
      } else if (this.equity >= 10) {
        return 'red-10-15';
      } else if (this.equity >= 5) {
        return 'red-5-10';
      } else if (this.equity >= 0) {
        return 'red-0-5';
      } else {
        throw new Error('Invalid value for this.equity: ', this.equity);
      }
    }
  }
});

/***/ }),

/***/ "oC4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__ = __webpack_require__("g8te");





var PresetHoleCards = function () {
  function PresetHoleCards() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PresetHoleCards);

    this.holeCardOne = null;
    this.holeCardTwo = null;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PresetHoleCards, [{
    key: 'numSet',
    get: function get() {
      var numPreset = 0;

      if (this.holeCardOne) {
        numPreset++;
      }

      if (this.holeCardTwo) {
        numPreset++;
      }

      return numPreset;
    }
  }, {
    key: 'array',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.getHoleCardsArrayFromObj(this);
    }
  }, {
    key: 'bothSet',
    get: function get() {
      return this.holeCardOne && this.holeCardTwo;
    }
  }]);

  return PresetHoleCards;
}();

/* harmony default export */ __webpack_exports__["a"] = (PresetHoleCards);
;

/***/ }),

/***/ "oGBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"equity-calculator-number-of-simulations-settings settings"},[_vm._m(0),_vm._v(" "),_c('input',{ref:"numberOfSimulations",staticClass:"form-control input-lg",attrs:{"type":"number","step":"1000"},domProps:{"value":_vm.numberOfSimulations}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',{staticClass:"buttons"},[_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){_vm.isHelpVisible = !_vm.isHelpVisible}}},[(!_vm.isHelpVisible)?_c('span',[_vm._v("Show help "),_c('span',{staticClass:"caret-down"})]):_vm._e(),_vm._v(" "),(_vm.isHelpVisible)?_c('span',[_vm._v("Hide help "),_c('span',{staticClass:"caret-up"})]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-lg",on:{"click":function($event){return _vm.reset()}}},[_vm._v("\n      Set to default (25,000)\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("\n      Save\n    ")])]),_vm._v(" "),(_vm.isHelpVisible)?_c('section',{staticClass:"well"},[_c('p',[_vm._v("By running more simulations, you'll get more accurate results, but it'll take longer. By running fewer simulations, it'll run more quickly, but the results won't be as accurate.")]),_vm._v(" "),_c('p',[_vm._v("How long the simulations take depend on the processing speed of the device you're using.")])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Number of simulations (equity calculator)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oIc1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Help / Breakeven Percentage For Bluffing The Turn")])]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/0wWYgrphiYM?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("What is the purpose of this tool?")]),_vm._v(" "),_c('p',[_vm._v("When looking at how often a bluff needs to work to be profitable, most people use "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(" as a starting point. Here's how that formula works for a 1/2 pot bluff. You are risking 1 to win 2, so "),_c('code',[_vm._v("1 / (1 + 2) = 1/3 = 33.3%")]),_vm._v(". Therefore, a half pot bluff needs to work more than 33.3% of the time to be immediately profitable.")]),_vm._v(" "),_c('p',[_vm._v("Many people end their analysis there. They shouldn't. That math assumes a few things that often aren't true:")]),_vm._v(" "),_c('ol',[_c('li',[_vm._v("You don't have any outs.")]),_vm._v(" "),_c('li',[_vm._v("There aren't any cards that can come on the river that will give you a +EV bluff.")]),_vm._v(" "),_c('li',[_vm._v("Checking has an EV of 0.")])]),_vm._v(" "),_c('p',[_vm._v("This tool helps you account for those things in order to figure out how often a turn bluff really needs to work for it to be profitable.")]),_vm._v(" "),_c('h3',[_vm._v("How do I interpret the table?")]),_vm._v(" "),_c('p',[_vm._v("The first row of the table shows the breakeven percentages for various turn bluff sizes - 1/3 pot, 1/2 pot, 2/3 pot, etc. - including the one that you selected in the \"Basics\" section.")]),_vm._v(" "),_c('p',[_vm._v("The second row shows the dropoff amount from what the immediately profitable breakeven percentage is. For example, the immediately profitable breakeven percentage for a 2/3 pot bluff is 40%, so if the true breakeven percentage is 28%, the dropoff amount is 12%. This is useful to know because you can think to yourself things like, \"I can decrease my breakeven percentage by about 10-15% when I have a flush draw.\"")]),_vm._v(" "),_c('h3',[_vm._v("How do I interpret the graph?")]),_vm._v(" "),_c('p',[_vm._v("The horizontal axis is how often your opponent folds. The vertical axis is EV. The teal line shows the EV of bluffing, and the black line shows the EV of checking. So when the teal line is above the black line, bluffing is the better option, and the point where they intersect gives you the breakeven percentage.")]),_vm._v(" "),_c('h3',[_vm._v("Why are we comparing it to the EV of checking instead of to zero?")]),_vm._v(" "),_c('p',[_vm._v("Because as poker players, we don't just want to make +EV decisions, we want to make the "),_c('em',[_vm._v("most")]),_vm._v(" +EV decisions. (This of course doesn't only apply to poker. It applies to life too!) If bluffing has an EV of +$10 but checking has an EV of +$20, checking is the better choice and we should pass up the opportunity to bluff.")]),_vm._v(" "),_c('h3',[_vm._v("How do I know how many outs I have? I could make top pair on the river, but I'm not sure if I'd be ahead with top pair.")]),_vm._v(" "),_c('p',[_vm._v("In poker, we talk about how "),_c('em',[_vm._v("clean")]),_vm._v(" an out is. If you have the nut flush draw and make your flush, those outs are pretty clean, because you're almost certain that you're ahead. But for something like an out to top pair, you're right that you often aren't sure if you're ahead when you hit it.")]),_vm._v(" "),_c('p',[_vm._v("To deal with this uncertainty, use a fraction. Eg. if you have six outs to top pair, maybe count each out as 3/4, and say that you have "),_c('code',[_vm._v("6 * (3/4) = 4.5")]),_vm._v(" outs instead of 6. That's sort of \"back of the napkin-y\", but it's fine for our purposes.")]),_vm._v(" "),_c('h3',[_vm._v("How do I know what percentage of the pot I'll win when I hit an out? Sometimes I'll bet half pot, sometimes full. And the chances of me getting paid off depend on what the river card is.")]),_vm._v(" "),_c('p',[_vm._v("The answer to these questions is very similar to the answer to the question above about how many outs you have. Ultimately, you have to use your judgement and come up with some sort of average.")]),_vm._v(" "),_c('p',[_vm._v("For example, let's suppose that you're always betting full pot on the river when you hit an out, and on half the river cards you're 75% sure you'll get called, and on the other half you're 25% sure you'll get called. In that case, you'll win "),_c('code',[_vm._v("(0.5)(0.75)(PSB) + (0.5)(0.25)(PSB) = (1/2)PSB = half of a pot sized bet = 50% of the pot")]),_vm._v(". If you're going to bet different amounts on different cards, the math gets a bit more complicated, but the approach is the same.")]),_vm._v(" "),_c('h3',[_vm._v("This is so inexact.")]),_vm._v(" "),_c('p',[_vm._v("There's a trade off between accuracy and effort. By adding more and more variables, you would get a more accurate number, but it takes more time and is harder to wrap your head around.")]),_vm._v(" "),_c('p',[_vm._v("I believe that the compromise I have now is appropriate for most players, for most situations. Knowing that the true breakeven percentage is 31.5% instead of 33% is rarely a big deal. Perhaps I'll add the option to include more variables in the future though.")]),_vm._v(" "),_c('h3',[_vm._v("How do you calculate EV?")]),_vm._v(" "),_c('p',[_vm._v("Like this!")]),_vm._v(" "),_c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/h-FJK0F5Xik?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),_c('h3',[_vm._v("Still need help?")]),_vm._v(" "),_c('p',[_vm._v("I'm here for you. Hit me up at "),_c('a',{attrs:{"href":"maillto:contact@sixplusholdem.com"}},[_vm._v("contact@sixplusholdem.com")]),_vm._v(". I'd love to answer any questions you have.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oPMm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "obUw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_hand_weight_vertical_set_weight_to_apply_to_added_hands_vertical_set_weight_to_apply_to_added_hands_basic__ = __webpack_require__("9htL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_hand_range_hand_weight_vertical_set_weight_to_apply_to_added_hands_vertical_set_weight_to_apply_to_added_hands_with_settings__ = __webpack_require__("QCca");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vertical-set-weight-to-apply-to-added-hands',
  components: {
    'vertical-set-weight-to-apply-to-added-hands-basic': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_hand_weight_vertical_set_weight_to_apply_to_added_hands_vertical_set_weight_to_apply_to_added_hands_basic__["a" /* default */],
    'vertical-set-weight-to-apply-to-added-hands-with-settings': __WEBPACK_IMPORTED_MODULE_1__components_hand_range_hand_weight_vertical_set_weight_to_apply_to_added_hands_vertical_set_weight_to_apply_to_added_hands_with_settings__["a" /* default */]
  },
  props: ['weightToApplyToAddedHands', 'disabled', 'shortDeck'],
  computed: {
    settingHandWeightsSetting: function settingHandWeightsSetting() {
      return this.$store.state.account.user.settings.general.visual.settingHandWeights;
    }
  },
  methods: {
    refreshVueSlider: function refreshVueSlider() {
      if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderBasic') {
        this.$refs.basicSlider.refreshVueSlider();
      } else if (this.settingHandWeightsSetting === 'verticalSetWeightToApplyToAddedHandsSliderWithSettings') {
        this.$refs.sliderWithSettings.refreshVueSlider();
      }
    }
  }
});

/***/ }),

/***/ "om4Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__ = __webpack_require__("lDlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn_inputs__ = __webpack_require__("rEkw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn_graph__ = __webpack_require__("argk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn_table__ = __webpack_require__("eJiv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_controls_create_sharable_url_button__ = __webpack_require__("zMC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_controls_save_scenario_button__ = __webpack_require__("A/Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_onboarding_modal__ = __webpack_require__("iexb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breakeven-percentage-for-bluffing-the-turn',
  components: {
    'readonly-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_readonly_alert__["a" /* default */],
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_2__components_utilities_saved_scenario_alert__["a" /* default */],
    'breakeven-percentage-for-bluffing-the-turn-inputs': __WEBPACK_IMPORTED_MODULE_3__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn_inputs__["a" /* default */],
    'breakeven-percentage-for-bluffing-the-turn-graph': __WEBPACK_IMPORTED_MODULE_4__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn_graph__["a" /* default */],
    'breakeven-percentage-for-bluffing-the-turn-table': __WEBPACK_IMPORTED_MODULE_5__components_breakeven_percentage_for_bluffing_the_turn_breakeven_percentage_for_bluffing_the_turn_table__["a" /* default */],
    'create-sharable-url-button': __WEBPACK_IMPORTED_MODULE_6__components_controls_create_sharable_url_button__["a" /* default */],
    'save-scenario-button': __WEBPACK_IMPORTED_MODULE_7__components_controls_save_scenario_button__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_8__components_onboarding_modal__["a" /* default */]
  },
  data: function data() {
    return {
      chartLabels: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100]
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.breakevenPercentageForBluffingTheTurn;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.turnBluffBreakevenPercentage.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },
    chartData: function chartData() {
      return {
        labels: this.chartLabels,
        datasets: [{
          label: 'EV of bluffing',
          data: this.evOfBluffingData,
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          lineTension: 0.1
        }, {
          label: 'EV of checking',
          data: this.evOfCheckingData,
          fill: false,
          borderColor: 'gray',
          lineTension: 0.1
        }]
      };
    },
    evOfBluffingData: function evOfBluffingData() {
      return this.chartLabels.map(function (turnFoldPercentage) {
        return this.calculateEVOfBluffing(this.state, turnFoldPercentage);
      }, this);
    },
    evOfCheckingData: function evOfCheckingData() {
      return this.chartLabels.map(function () {
        return this.calculateEVOfChecking(this.state);
      }, this);
    },
    authorized: function authorized() {
      return this.$store.getters['account/authorizedForPremium'];
    }
  },
  mounted: function mounted() {
    if (this.$route.params.id) {
      this.load();
    }

    this.handleOnboard();
  },
  methods: {
    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default breakeven percentage for bluffing the turn page.');
          self.$router.push('/breakeven-percentage-for-bluffing-the-turn');
        } else {
          self.$store.commit('breakevenPercentageForBluffingTheTurn/setState', response.data.storeState);
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default breakeven percentage for bluffing the turn page.');
        self.$router.push('/breakeven-percentage-for-bluffing-the-turn');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.breakevenPercentageForBluffingTheTurn) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'breakevenPercentageForBluffingTheTurn' }).then(function () {
        self.$store.commit('account/onboard', 'breakevenPercentageForBluffingTheTurn');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    },

    calculateEVOfBluffing: function calculateEVOfBluffing(state, turnFoldPercentage) {
      var bluffingEV_immediateFold = this._bluffingEV_immediateFold(state, turnFoldPercentage);
      var bluffingEV_blankRiver = this._bluffingEV_blankRiver(state, turnFoldPercentage);
      var bluffingEV_hitAnOut = this._bluffingEV_hitAnOut(state, turnFoldPercentage);
      var bluffingEV_scareCardAndWin = this._bluffingEV_scareCardAndWin(state, turnFoldPercentage);
      var bluffingEV_scareCardAndLose = this._bluffingEV_scareCardAndLose(state, turnFoldPercentage);

      return (bluffingEV_immediateFold + bluffingEV_blankRiver + bluffingEV_hitAnOut + bluffingEV_scareCardAndWin + bluffingEV_scareCardAndLose).roundToTwoDecimalPlaces();
    },
    _bluffingEV_immediateFold: function _bluffingEV_immediateFold(state, turnFoldPercentage) {
      return turnFoldPercentage / 100 * state.turnPotSize;
    },
    _bluffingEV_blankRiver: function _bluffingEV_blankRiver(state, turnFoldPercentage) {
      var probabilityOfTurnCall = 1 - turnFoldPercentage / 100;
      var probabilityOfBlankRiver = 1 - state.numberOfOuts / 46 - state.numRiverCardsYoullBluff / 46;
      var turnBet = state.turnPotSize * (state.turnBetSize / 100);

      return probabilityOfTurnCall * probabilityOfBlankRiver * -1 * turnBet;
    },
    _bluffingEV_hitAnOut: function _bluffingEV_hitAnOut(state, turnFoldPercentage) {
      var probabilityOfTurnCall = 1 - turnFoldPercentage / 100;
      var turnBet = state.turnPotSize * (state.turnBetSize / 100);
      var riverSize = state.turnPotSize + 2 * turnBet;
      var riverBet = state.percentageOfPotWonOnRiverWhenYouHitAnOut / 100 * riverSize;
      var amountWon = state.turnPotSize + turnBet + riverBet;

      return probabilityOfTurnCall * (state.numberOfOuts / 46) * amountWon;
    },
    _bluffingEV_scareCardAndWin: function _bluffingEV_scareCardAndWin(state, turnFoldPercentage) {
      var probabilityOfTurnCall = 1 - turnFoldPercentage / 100;
      var probabilityOfRiverFold = state.probabilityOfGettingFoldOnRiver / 100;
      var turnBet = state.turnPotSize * (state.turnBetSize / 100);
      var amountWon = state.turnPotSize + turnBet;

      return probabilityOfTurnCall * (state.numRiverCardsYoullBluff / 46) * probabilityOfRiverFold * amountWon;
    },
    _bluffingEV_scareCardAndLose: function _bluffingEV_scareCardAndLose(state, turnFoldPercentage) {
      var probabilityOfTurnCall = 1 - turnFoldPercentage / 100;
      var probabilityOfRiverCall = 1 - state.probabilityOfGettingFoldOnRiver / 100;
      var turnBet = state.turnPotSize * (state.turnBetSize / 100);
      var riverSize = state.turnPotSize + 2 * turnBet;
      var riverBet = state.riverBluffSize / 100 * riverSize;
      var amountLost = turnBet + riverBet;

      return probabilityOfTurnCall * (state.numRiverCardsYoullBluff / 46) * probabilityOfRiverCall * amountLost * -1;
    },
    calculateEVOfChecking: function calculateEVOfChecking(state) {
      if (state.position === 'in position') {
        return this._calculateEVOfCheckingIP(state).roundToTwoDecimalPlaces();
      } else if (state.position === 'out of position') {
        return this._calculateEVOfCheckingOOP(state).roundToTwoDecimalPlaces();
      }
    },
    _calculateEVOfCheckingIP: function _calculateEVOfCheckingIP(state) {
      var riverBet = state.turnPotSize * (state.percentageOfPotWonAfterTurnChecksThrough / 100);
      var amountWon = state.turnPotSize + riverBet;

      return state.numberOfOuts / 46 * amountWon;
    },
    _calculateEVOfCheckingOOP: function _calculateEVOfCheckingOOP(state) {
      var evOfCheckingOOP = 0;

      evOfCheckingOOP += this.__checkingEV_OOP_check_hit(state);

      if (state.checkCall) {
        evOfCheckingOOP += this.__checkingEV_OOP_bet_call_hit(state);
        evOfCheckingOOP += this.__checkingEV_OOP_bet_call_miss(state);
      }

      return evOfCheckingOOP;
    },
    __checkingEV_OOP_check_hit: function __checkingEV_OOP_check_hit(state) {
      var probabilityThatOpponentChecksBack = 1 - state.probabilityThatOpponentBetsWhenYouCheck / 100;
      var probabilityOfHitting = state.numberOfOuts / 46;
      var riverBet = state.turnPotSize * (state.percentageOfPotWonAfterTurnChecksThrough / 100);
      var amountWon = state.turnPotSize + riverBet;

      return probabilityThatOpponentChecksBack * probabilityOfHitting * amountWon;
    },
    __checkingEV_OOP_bet_call_hit: function __checkingEV_OOP_bet_call_hit(state) {
      var probabilityThatOpponentBetsWhenYouCheck = state.probabilityThatOpponentBetsWhenYouCheck / 100;
      var turnBet = state.turnPotSize * (state.opponentsTurnBetSize / 100);
      var riverSize = state.turnPotSize + turnBet * 2;
      var riverBet = riverSize * (state.percentageOfPotWonAfterCheckCall / 100);
      var amountWon = state.turnPotSize + turnBet + riverBet;

      return probabilityThatOpponentBetsWhenYouCheck * (state.numberOfOuts / 46) * amountWon;
    },
    __checkingEV_OOP_bet_call_miss: function __checkingEV_OOP_bet_call_miss(state) {
      var probabilityThatOpponentBetsWhenYouCheck = state.probabilityThatOpponentBetsWhenYouCheck / 100;
      var turnBet = state.turnPotSize * (state.opponentsTurnBetSize / 100);
      var probabilityOfMissing = 1 - state.numberOfOuts / 46;

      return probabilityThatOpponentBetsWhenYouCheck * probabilityOfMissing * turnBet * -1;
    },
    getBreakevenPercentage: function getBreakevenPercentage(state, turnBetSize) {
      var currEVOfBluffing = void 0;
      var currEVOfChecking = void 0;
      var stateCopy = {
        turnPotSize: state.turnPotSize,
        turnBetSize: state.turnBetSize,
        numberOfOuts: state.numberOfOuts,
        percentageOfPotWonOnRiverWhenYouHitAnOut: state.percentageOfPotWonOnRiverWhenYouHitAnOut,
        numRiverCardsYoullBluff: state.numRiverCardsYoullBluff,
        riverBluffSize: state.riverBluffSize,
        probabilityOfGettingFoldOnRiver: state.probabilityOfGettingFoldOnRiver,
        position: state.position,
        probabilityThatOpponentBetsWhenYouCheck: state.probabilityThatOpponentBetsWhenYouCheck,
        checkCall: state.checkCall,
        opponentsTurnBetSize: state.opponentsTurnBetSize,
        percentageOfPotWonAfterCheckCall: state.percentageOfPotWonAfterCheckCall,
        percentageOfPotWonAfterTurnChecksThrough: state.percentageOfPotWonAfterTurnChecksThrough
      };

      stateCopy.turnBetSize = turnBetSize;

      for (var turnFoldPercentage = -100; turnFoldPercentage <= 100; turnFoldPercentage += 0.01) {
        currEVOfBluffing = this.calculateEVOfBluffing(stateCopy, turnFoldPercentage);
        currEVOfChecking = this.calculateEVOfChecking(stateCopy);

        if (Math.abs(currEVOfBluffing - currEVOfChecking) < 0.02) {
          if (turnFoldPercentage < 0) {
            return null;
          }

          return turnFoldPercentage.roundToOneDecimalPlace();
        }
      }

      return null;
    },
    getBreakevenPercentageString: function getBreakevenPercentageString(state, turnBluffSize) {
      var breakevenPercentage = this.getBreakevenPercentage(state, turnBluffSize);

      if (breakevenPercentage === null) {
        return 'n/a';
      } else {
        return breakevenPercentage + '%';
      }
    },
    getDropoffPercentageString: function getDropoffPercentageString(state, turnBluffSize) {
      var profitableBreakevenPercentage = void 0;
      var immediatelyProfitableBreakevenPercentage = void 0;

      profitableBreakevenPercentage = this.getBreakevenPercentage(state, turnBluffSize);

      if (profitableBreakevenPercentage === null) {
        return 'n/a';
      }

      immediatelyProfitableBreakevenPercentage = turnBluffSize / (turnBluffSize + 100) * 100;

      return (immediatelyProfitableBreakevenPercentage - profitableBreakevenPercentage).roundToOneDecimalPlace() + '%';
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "onxA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.areFiveCardHandPercentagesUpToDate && _vm.textWhenFiveCardHandPercentagesArentUpToDate)?_c('section',{staticClass:"five-card-hands-section-alerts bg-warning"},[_vm._v("\n  "+_vm._s(_vm.textWhenFiveCardHandPercentagesArentUpToDate)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "oo7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__ = __webpack_require__("oox5");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-river-selector',
  components: {
    'short-deck-individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_short_deck_short_deck_individual_card_selector__["a" /* default */]
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'river') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function _toggleNextDropdown(previousPosition) {
      var nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function __getNextPosition(previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else if (previousPosition === 'flop3') {
        return 'turn';
      } else if (previousPosition === 'turn') {
        return 'river';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    }
  }
});

/***/ }),

/***/ "oox5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_individual_card_selector_vue__ = __webpack_require__("qnip");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f36f858_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_individual_card_selector_vue__ = __webpack_require__("qmK6");
function injectStyle (ssrContext) {
  __webpack_require__("grkG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f36f858"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_individual_card_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f36f858_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_individual_card_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "osKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"equity-results"},[_c('span',{staticClass:"result"},[_c('div',{staticClass:"result-label"},[_vm._v("Equity:")]),_vm._v(" "),_c('div',{staticClass:"result-value",class:_vm.equityClass},[_vm._v(_vm._s((_vm.equityString + '%') || '0.00%'))])]),_vm._v(" "),_c('span',{staticClass:"result win-percentage-result"},[_c('div',{staticClass:"result-label"},[_vm._v("Win:")]),_vm._v(" "),_c('div',{staticClass:"result-value"},[_vm._v(_vm._s((_vm.winPercentageString + '%') || '0.00%'))])]),_vm._v(" "),_c('span',{staticClass:"result tie-percentage-result"},[_c('div',{staticClass:"result-label"},[_vm._v("Tie:")]),_vm._v(" "),_c('div',{staticClass:"result-value"},[_vm._v(_vm._s((_vm.tiePercentageString + '%') || '0.00%'))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p29W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{staticClass:"combos-to-add-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Select suits")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.clear()}}},[_vm._v("Clear")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.selectAll()}}},[_vm._v("Select all")])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[_c('p',[_vm._v("When you click to add hands on the grid, these are the combos that will be added.")]),_vm._v(" "),_c('table',_vm._l((_vm.suitsGrid),function(row){return _c('tr',_vm._l((row),function(suits){return _c('td',{key:suits,class:{ 'selected': _vm.isComboInCombosToAdd(suits) },on:{"click":function($event){return _vm.toggleCombo(suits)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.getHTMLForSuitIcons(suits))}}),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isComboInCombosToAdd(suits)}})])}),0)}),0),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',[_vm._v("Example: If only club-club is selected...")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("...and you click AKs, only AcKc will be added.")]),_vm._v(" "),_c('li',[_vm._v("...and you click AKo, you will get an error, because there is no club-club combo of AKo.")]),_vm._v(" "),_c('li',[_vm._v("...and you click AA, you will get an error, because there is no club-club combo of AA.")])]),_vm._v(" "),_c('p',[_vm._v("Use case: If the board is Qc6c4s and you want to click and drag to add a bunch of club-club combos, because club-club combos make a flush draw.")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p42r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pEaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fold-equity-table',
  props: ['state', 'playerStateIndex', 'immediatelyProfitableBreakevenPercentage'],
  data: function data() {
    return {
      tableExpanded: false
    };
  },
  computed: {
    playerState: function playerState() {
      return this.state.players.find(0).states[this.playerStateIndex];
    },
    cutoffHand: function cutoffHand() {
      return this.playerState.getCutoffHandForBluffing(this.state.profitableBreakevenPercentage);
    },
    foldEquityAgainstDifferentRanges: function foldEquityAgainstDifferentRanges() {
      return this.playerState.foldEquityAgainstDifferentRanges.map(function (_ref) {
        var cutoffHand = _ref.cutoffHand,
            foldEquity = _ref.foldEquity;

        return {
          rangeTheyreFolding: cutoffHand.fullText + ' and worse',
          foldEquity: foldEquity,
          diff: (foldEquity - this.state.profitableBreakevenPercentage).roundToTwoDecimalPlaces()
        };
      }, this);
    },
    condensedFoldEquityAgainstDifferentRanges: function condensedFoldEquityAgainstDifferentRanges() {
      var condensedFoldEquityAgainstDifferentRanges = this.playerState.getCondensedFoldEquityAgainstDifferentRanges(this.state.profitableBreakevenPercentage);

      return condensedFoldEquityAgainstDifferentRanges.map(function (_ref2) {
        var cutoffHand = _ref2.cutoffHand,
            foldEquity = _ref2.foldEquity;

        return {
          rangeTheyreFolding: cutoffHand.fullText + ' and worse',
          foldEquity: foldEquity,
          diff: (foldEquity - this.state.profitableBreakevenPercentage).roundToTwoDecimalPlaces()
        };
      }, this);
    }
  },
  watch: {
    cutoffHand: function cutoffHand(newVal) {
      if (!newVal) {
        this.tableExpanded = true;
      }
    }
  },
  created: function created() {
    if (!this.cutoffHand) {
      this.tableExpanded = true;
    }
  },
  methods: {
    getDiffClass: function getDiffClass(diff) {
      return 'diff-' + Math.floor(diff);
    }
  }
});

/***/ }),

/***/ "pHWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__ = __webpack_require__("Ywgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sign-in',
  components: {
    'errors-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__["a" /* default */]
  },
  data: function data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      keepMeSignedIn: true,
      errorsFromBackend: [],
      signingIn: false
    };
  },
  computed: {
    isSafari: function isSafari() {
      return (/constructor/i.test(window.HTMLElement) || function (p) {
          return p.toString() === "[object SafariRemoteNotification]";
        }(!window['safari'] || typeof safari !== 'undefined' && safari.pushNotification)
      );
    },
    previousSignInType: function previousSignInType() {
      return localStorage.getItem('previousSignInType');
    },
    passwordFieldType: function passwordFieldType() {
      if (this.showPassword) {
        return 'text';
      } else {
        return 'password';
      }
    },
    daysSincePasswordChange: function daysSincePasswordChange() {
      var changedPasswordDate = localStorage.getItem('changedPasswordDate');
      var daysSincePasswordChange = void 0;

      if (!changedPasswordDate) {
        return null;
      }

      daysSincePasswordChange = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].general.getDaysBetweenDates(changedPasswordDate, new Date());

      if (daysSincePasswordChange > 7) {
        localStorage.removeItem('changedPasswordDate');
        return null;
      }

      return daysSincePasswordChange;
    },
    daysSincePasswordChangeText: function daysSincePasswordChangeText() {
      if (this.daysSincePasswordChange < 1) {
        return 'Note: You changed your password less than 24 hours ago.';
      }

      if (this.daysSincePasswordChange < 1.5) {
        return 'Note: You changed your password yesterday.';
      }

      return 'Note: You changed your password ' + Math.round(this.daysSincePasswordChange) + ' days ago.';
    },
    googleSignInUrl: function googleSignInUrl() {
      return "https://oddscalc.sixplusholdem.com/api" + '/user/google';
    },
    twitterSignInUrl: function twitterSignInUrl() {
      return "https://oddscalc.sixplusholdem.com/api" + '/user/twitter';
    },
    linkedinSignInUrl: function linkedinSignInUrl() {
      return "https://oddscalc.sixplusholdem.com/api" + '/user/linkedin';
    },
    signInText: function signInText() {
      if (this.signingIn) {
        return 'Signing you in...';
      }

      return 'Sign in';
    }
  },
  created: function created() {
    if (this.$route.query.error) {
      if (this.$route.query.error === 'email-in-use') {
        this.errorsFromBackend.push('The email you\'re trying to sign up with is already in  use.');
      }
    }

    if (this.$route.query.error) {
      if (this.$route.query.error === 'not-logged-in') {
        this.errorsFromBackend.push('You must be logged in to access that page.');
      }
    }
  },
  methods: {
    submit: function submit() {
      var self = this;

      self.signingIn = true;
      self.$http.post("https://oddscalc.sixplusholdem.com/api" + '/user/login', {
        user: {
          email: self.email,
          password: self.password
        },
        keepMeSignedIn: self.keepMeSignedIn
      }).then(function (res) {
        self.signingIn = false;
        self.$store.commit('account/setUser', res.data.user);
        self.$router.push({ path: '/account' });
      }).catch(function (err) {
        self.signingIn = false;
        self.errorsFromBackend.splice(0, self.errorsFromBackend.length);
        err.response.data.errors.forEach(function (errorFromBackend) {
          self.errorsFromBackend.push(errorFromBackend);
        });
      });
    },
    clearAlert: function clearAlert() {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    }
  }
});

/***/ }),

/***/ "pN41":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tier-selector"},[_c('div',{staticClass:"non-mobile"},[_vm._l((8),function(i){return _c('div',{staticClass:"checkbox"},[_c('label',{class:{ disabled: _vm.disabled }},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.isTierInRange(i),"indeterminate":_vm.isTierInRange(i) === 'partially'},on:{"change":function($event){return _vm.selectOrDeselectGeneralHandsFromTier(i)}}}),_vm._v("\n        Tier "+_vm._s(i)+"\n      ")])])}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.loggedIn)?_c('p',{staticClass:"customize"},[_c('router-link',{attrs:{"to":"/settings/general/tiers"}},[_c('small',[_vm._v("Customize tiers")])])],1):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"mobile"},[_c('div',{staticClass:"btn-group btn-group-justified"},_vm._l((4),function(i){return _c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",class:{ 'active': _vm.isTierInRange(i) },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.selectOrDeselectGeneralHandsFromTier(i)}}},[_vm._v("\n          "+_vm._s(i)+"\n        ")])])}),0),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-justified"},_vm._l((4),function(i){return _c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",class:{ 'active': _vm.isTierInRange(i + 4) },attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.selectOrDeselectGeneralHandsFromTier(i + 4)}}},[_vm._v("\n          "+_vm._s(i + 4)+"\n        ")])])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pOqy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pT65":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{staticClass:"save-scenario-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n        Name:\n      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scenarioName),expression:"scenarioName"}],staticClass:"form-control input-lg",attrs:{"placeholder":"Eg. Aces versus kings"},domProps:{"value":(_vm.scenarioName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.scenarioName=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-lg btn-primary",on:{"click":function($event){return _vm.save()}}},[_vm._v("\n      Save\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pTug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_turn_selector_vue__ = __webpack_require__("HoqA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afce41ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_turn_selector_vue__ = __webpack_require__("uALk");
function injectStyle (ssrContext) {
  __webpack_require__("Rya7")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-afce41ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_short_deck_turn_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_afce41ae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_short_deck_turn_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pbkT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"five-card-hands-section panel panel-default"},[(!_vm.hideHeader)?_c('five-card-hands-section-header',{attrs:{"hitPercentageBeingComputed":_vm.playerState.hitPercentageBeingComputed,"hitPercentageUpToDate":_vm.hitPercentageUpToDate,"hitPercentage":_vm.playerState.hitPercentage,"stateName":_vm.playerState.name,"authorized":_vm.authorized},on:{"clearAllChecks":function($event){return _vm.$emit('clearAllChecks')},"selectAllChecks":function($event){return _vm.$emit('selectAllChecks')},"setChecksToDefault":function($event){return _vm.$emit('setChecksToDefault', $event)},"setChecksBasedOnUserDefinedFilter":function($event){return _vm.$emit('setChecksBasedOnUserDefinedFilter', $event)}}}):_vm._e(),_vm._v(" "),_c('section',{staticClass:"panel-body"},[(_vm.insightsVisible)?_vm._t("insights"):_vm._e(),_vm._v(" "),(_vm.showPercentagesOrCombos)?_c('percentages-or-combos',{attrs:{"percentagesOrCombos":_vm.percentagesOrCombos,"numberOfSpecificHandsInRange":_vm.playerState.generalHands.numberOfSpecificHandsInRange,"numberOfPossibleSpecificHands":_vm.playerState.generalHands.numberOfPossibleSpecificHands},on:{"toggle":function($event){_vm.percentagesOrCombos = $event}}}):_vm._e(),_vm._v(" "),_vm._t("alerts"),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('span',{staticClass:"level-1"},[_vm._v("Made hands:")]),_vm._v(" "),_c('five-card-hands-for-category',{attrs:{"type":'made-hands',"playerState":_vm.playerState,"percentagesOrCombos":_vm.percentagesOrCombos,"hideRightContainer":_vm.hideRightContainer,"shortDeck":_vm.shortDeck,"authorized":_vm.authorized},on:{"setCheckedValueOfFiveCardHand":function($event){return _vm.setCheckedValueOfFiveCardHand($event)},"applyExactWeightToFiveCardHand":function($event){return _vm.$emit('applyExactWeightToFiveCardHand', $event)},"toggleCollapsedValueOfFiveCardHandParent":function($event){return _vm.$emit('toggleCollapsedValueOfFiveCardHandParent', $event)},"updateWeightOfFiveCardHand":function($event){return _vm.$emit('updateWeightOfFiveCardHand', $event)},"fiveCardHandMouseover":function($event){return _vm.$emit('fiveCardHandMouseover', $event)},"fiveCardHandMouseleave":function($event){return _vm.$emit('fiveCardHandMouseleave')}}})],1),_vm._v(" "),(_vm.playerState.fiveCardHands.visibleDraws.length > 0)?_c('div',{staticClass:"col-sm-4"},[_c('span',{staticClass:"level-1"},[_vm._v("Draws:")]),_vm._v(" "),_c('five-card-hands-for-category',{attrs:{"type":'draws',"playerState":_vm.playerState,"percentagesOrCombos":_vm.percentagesOrCombos,"hideRightContainer":_vm.hideRightContainer,"shortDeck":_vm.shortDeck,"authorized":_vm.authorized},on:{"setCheckedValueOfFiveCardHand":function($event){return _vm.setCheckedValueOfFiveCardHand($event)},"applyExactWeightToFiveCardHand":function($event){return _vm.$emit('applyExactWeightToFiveCardHand', $event)},"toggleCollapsedValueOfFiveCardHandParent":function($event){return _vm.$emit('toggleCollapsedValueOfFiveCardHandParent', $event)},"updateWeightOfFiveCardHand":function($event){return _vm.$emit('updateWeightOfFiveCardHand', $event)},"fiveCardHandMouseover":function($event){return _vm.$emit('fiveCardHandMouseover', $event)},"fiveCardHandMouseleave":function($event){return _vm.$emit('fiveCardHandMouseleave')}}})],1):_vm._e(),_vm._v(" "),(_vm.playerState.fiveCardHands.visibleCombos.length > 0)?_c('div',{staticClass:"col-sm-4"},[_c('span',{staticClass:"level-1"},[_vm._v("Combos:")]),_vm._v(" "),_c('five-card-hands-for-category',{attrs:{"type":'combos',"playerState":_vm.playerState,"percentagesOrCombos":_vm.percentagesOrCombos,"hideRightContainer":_vm.hideRightContainer,"shortDeck":_vm.shortDeck,"authorized":_vm.authorized},on:{"setCheckedValueOfFiveCardHand":function($event){return _vm.setCheckedValueOfFiveCardHand($event)},"applyExactWeightToFiveCardHand":function($event){return _vm.$emit('applyExactWeightToFiveCardHand', $event)},"toggleCollapsedValueOfFiveCardHandParent":function($event){return _vm.$emit('toggleCollapsedValueOfFiveCardHandParent', $event)},"updateWeightOfFiveCardHand":function($event){return _vm.$emit('updateWeightOfFiveCardHand', $event)},"fiveCardHandMouseover":function($event){return _vm.$emit('fiveCardHandMouseover', $event)},"fiveCardHandMouseleave":function($event){return _vm.$emit('fiveCardHandMouseleave')}}})],1):_vm._e()])],2),_vm._v(" "),_vm._t("simulate-button")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ph2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'narrow-page': _vm.onNarrowPage },attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('router-view',{on:{"createSharableUrl":function($event){return _vm.createSharableUrl($event)},"saveScenario":function($event){return _vm.expandSaveScenarioModal($event)},"updateScenario":function($event){return _vm.updateScenario($event)}}})],1),_vm._v(" "),_c('sharable-url-modal',{attrs:{"url":_vm.sharableUrl.url,"approximateWaitTime":_vm.sharableUrl.approximateWaitTime}}),_vm._v(" "),_c('save-scenario-modal',{on:{"save":function($event){return _vm.saveScenario($event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pihl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_worker_loader_run_simulations_worker_js__ = __webpack_require__("3wfu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_worker_loader_run_simulations_worker_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_worker_loader_run_simulations_worker_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_five_card_hands_FiveCardHands__ = __webpack_require__("JKDa");




/* harmony default export */ __webpack_exports__["a"] = ({
  getEquities: function getEquities(weightedRanges, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var worker = new __WEBPACK_IMPORTED_MODULE_1_worker_loader_run_simulations_worker_js___default.a();

      worker.onmessage = function (e) {
        if (e.data.message === 'progress') {
          progressCb(e.data.value);
        } else if (e.data.message === 'finished') {
          worker.terminate();
          resolve(e.data.simulationResults);
        } else if (e.data.message === 'error') {
          worker.terminate();
          reject(e.data.error);
        }
      };
      worker.postMessage({
        message: 'calculate equity',
        weightedRanges: weightedRanges,
        presetCommunityCardsArray: presetCommunityCardsArray,
        numberOfSimulations: numberOfSimulations
      });
    });
  },

  getFlopFiveCardHandPercentages: function getFlopFiveCardHandPercentages(players, presetCommunityCards, shortDeck) {
    if (!presetCommunityCards.flopSet) {
      throw new Error('Trying to run getFlopFiveCardHandPercentages when the flop isn\'t set.');
    }

    return this._getFiveCardHandPercentagesForPlayers(players, 1, presetCommunityCards.flopArray, shortDeck);
  },
  getTurnFiveCardHandPercentages: function getTurnFiveCardHandPercentages(players, presetCommunityCards, shortDeck) {
    if (!presetCommunityCards.turnSet) {
      throw new Error('Trying to run getTurnFiveCardHandPercentages when the turn isn\'t set.');
    }

    return this._getFiveCardHandPercentagesForPlayers(players, 2, presetCommunityCards.turnArray, shortDeck);
  },
  getRiverFiveCardHandPercentages: function getRiverFiveCardHandPercentages(players, presetCommunityCards, shortDeck) {
    if (!presetCommunityCards.riverSet) {
      throw new Error('Trying to run getRiverFiveCardHandPercentages when the river isn\'t set.');
    }

    return this._getFiveCardHandPercentagesForPlayers(players, 3, presetCommunityCards.riverArray, shortDeck);
  },
  _getFiveCardHandPercentagesForPlayers: function _getFiveCardHandPercentagesForPlayers(players, playerStateIndex, presetCommunityCardsArray, shortDeck) {
    players.forEach(function (player) {
      this.__getFiveCardHandPercentagesForPlayer(player.states[playerStateIndex].fiveCardHands, player.states[playerStateIndex].generalHands, presetCommunityCardsArray, shortDeck);
    }, this);
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(); // so we can call .then
  },
  __getFiveCardHandPercentagesForPlayer: function __getFiveCardHandPercentagesForPlayer(fiveCardHands, generalHands, presetCommunityCardsArray, shortDeck) {
    fiveCardHands.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);
    fiveCardHands.setProbabilitiesAccordingToMatchingSpecificHands(generalHands);
    fiveCardHands.setPercentagesOfSpecificHandsThatAreSelected(generalHands);
  },

  getFlopFiveCardHandPercentagesViaSimulations: function getFlopFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, 'flop', numberOfSimulations, progressCb);
  },
  getTurnFiveCardHandPercentagesViaSimulations: function getTurnFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, 'turn', numberOfSimulations, progressCb);
  },
  getRiverFiveCardHandPercentagesViaSimulations: function getRiverFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, 'river', numberOfSimulations, progressCb);
  },
  _getFiveCardHandPercentagesViaSimulations: function _getFiveCardHandPercentagesViaSimulations(weightedRange, presetCommunityCardsArray, streetToSimulateTo, numberOfSimulations, progressCb) {
    return this.__getFiveCardHandPercentagesViaSimulations({
      message: 'get five card hand percentages via simulations',
      weightedRange: weightedRange,
      presetCommunityCardsArray: presetCommunityCardsArray,
      streetToSimulateTo: streetToSimulateTo,
      numberOfSimulations: numberOfSimulations
    }, progressCb);
  },
  __getFiveCardHandPercentagesViaSimulations: function __getFiveCardHandPercentagesViaSimulations(payload, progressCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var worker = new __WEBPACK_IMPORTED_MODULE_1_worker_loader_run_simulations_worker_js___default.a();
      var workerPayload = {
        message: payload.message,
        weightedRange: payload.weightedRange,
        presetCommunityCardsArray: payload.presetCommunityCardsArray,
        streetToSimulateTo: payload.streetToSimulateTo,
        numberOfSimulations: payload.numberOfSimulations
      };

      worker.postMessage(workerPayload);
      worker.onmessage = function (e) {
        if (e.data.message === 'progress') {
          progressCb(e.data.value);
        } else if (e.data.message === 'finished') {
          worker.terminate();
          resolve(e.data.handAndDrawInfo);
        } else if (e.data.message === 'error') {
          worker.terminate();
          reject(e.data.error);
        }
      };
    });
  },

  getShortDeckEquities: function getShortDeckEquities(weightedRanges, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var worker = new __WEBPACK_IMPORTED_MODULE_1_worker_loader_run_simulations_worker_js___default.a();

      worker.onmessage = function (e) {
        if (e.data.message === 'progress') {
          progressCb(e.data.value);
        } else if (e.data.message === 'finished') {
          worker.terminate();
          resolve(e.data.simulationResults);
        } else if (e.data.message === 'error') {
          worker.terminate();
          reject(e.data.error);
        }
      };
      worker.postMessage({
        message: 'calculate short deck equity',
        weightedRanges: weightedRanges,
        presetCommunityCardsArray: presetCommunityCardsArray,
        numberOfSimulations: numberOfSimulations
      });
    });
  },

  getFlopFiveCardHandPercentagesViaShortDeckSimulations: function getFlopFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, 'flop', numberOfSimulations, progressCb);
  },
  getTurnFiveCardHandPercentagesViaShortDeckSimulations: function getTurnFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, 'turn', numberOfSimulations, progressCb);
  },
  getRiverFiveCardHandPercentagesViaShortDeckSimulations: function getRiverFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, numberOfSimulations, progressCb) {
    return this._getFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, 'river', numberOfSimulations, progressCb);
  },
  _getFiveCardHandPercentagesViaShortDeckSimulations: function _getFiveCardHandPercentagesViaShortDeckSimulations(weightedRange, presetCommunityCardsArray, streetToSimulateTo, numberOfSimulations, progressCb) {
    return this.__getFiveCardHandPercentagesViaShortDeckSimulations({
      message: 'get five card hand percentages via short deck simulations',
      weightedRange: weightedRange,
      presetCommunityCardsArray: presetCommunityCardsArray,
      streetToSimulateTo: streetToSimulateTo,
      numberOfSimulations: numberOfSimulations
    }, progressCb);
  },
  __getFiveCardHandPercentagesViaShortDeckSimulations: function __getFiveCardHandPercentagesViaShortDeckSimulations(payload, progressCb) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var worker = new __WEBPACK_IMPORTED_MODULE_1_worker_loader_run_simulations_worker_js___default.a();
      var workerPayload = {
        message: payload.message,
        weightedRange: payload.weightedRange,
        presetCommunityCardsArray: payload.presetCommunityCardsArray,
        streetToSimulateTo: payload.streetToSimulateTo,
        numberOfSimulations: payload.numberOfSimulations
      };

      worker.postMessage(workerPayload);
      worker.onmessage = function (e) {
        if (e.data.message === 'progress') {
          progressCb(e.data.value);
        } else if (e.data.message === 'finished') {
          worker.terminate();
          resolve(e.data.handAndDrawInfo);
        } else if (e.data.message === 'error') {
          worker.terminate();
          reject(e.data.error);
        }
      };
    });
  }
});

/***/ }),

/***/ "pmmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reasoning_1_vue__ = __webpack_require__("j1Sj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a98f247_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reasoning_1_vue__ = __webpack_require__("kg+2");
function injectStyle (ssrContext) {
  __webpack_require__("gndg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a98f247"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reasoning_1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a98f247_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reasoning_1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pn0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_Players__ = __webpack_require__("IPbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__ = __webpack_require__("XRwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_PresetHoleCards__ = __webpack_require__("oC4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_service__ = __webpack_require__("JBFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);







var state = {
  presetHoleCards: new __WEBPACK_IMPORTED_MODULE_2__services_PresetHoleCards__["a" /* default */](),
  presetCommunityCards: new __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__["a" /* default */](),
  players: new __WEBPACK_IMPORTED_MODULE_0__services_player_Players__["a" /* default */](),
  streetToBluff: 'flop',
  bluffSize: '1/2',
  profitableBreakevenPercentage: 28
};

var getters = {
  immediatelyProfitableBreakevenPercentage: function immediatelyProfitableBreakevenPercentage(state) {
    var risk = void 0;
    var reward = void 0;

    if (state.bluffSize === '1/3') {
      return 25;
    } else if (state.bluffSize === '1/2') {
      return 33.3;
    } else if (state.bluffSize === '2/3') {
      return 40;
    } else if (state.bluffSize === '3/4') {
      return 42.9;
    } else if (state.bluffSize === 'full') {
      return 50;
    } else if (state.bluffSize === '1.5x') {
      return 60;
    } else if (state.bluffSize === '2x') {
      return 66.6;
    } else {
      risk = Number(state.bluffSize.slice(0, -1));
      reward = 1;

      return Number((risk / (risk + reward) * 100).toFixed(1));
    }
  },
  percentageOfTimeEveryoneMissesTheBoard: function percentageOfTimeEveryoneMissesTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeEveryoneMissesTheBoard(state, street);
    };
  },
  percentageOfTimeExactlyOnePlayerHitsTheBoard: function percentageOfTimeExactlyOnePlayerHitsTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, street);
    };
  },
  percentageOfTimeTwoOrMorePlayersHitTheBoard: function percentageOfTimeTwoOrMorePlayersHitTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, street);
    };
  },
  cumulativeHitPercentages: function cumulativeHitPercentages(state) {
    return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getCumulativeHitPercentages(state);
  }
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_3__services_share_url_service__["a" /* default */].setGuidedAnalysesBluffingStoreState(stateFromServer, state);
  },

  // bluffing
  setStreetToBluff: function setStreetToBluff(state, streetToBluff) {
    state.streetToBluff = streetToBluff;
  },
  setBluffSize: function setBluffSize(state, bluffSize) {
    state.bluffSize = bluffSize;
  },
  setProfitableBreakevenPercentage: function setProfitableBreakevenPercentage(state, profitableBreakevenPercentage) {
    state.profitableBreakevenPercentage = profitableBreakevenPercentage;
  },

  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHand(state, payload);
  },
  manuallySelectGeneralHand: function manuallySelectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySelectGeneralHand(state, payload);
  },
  manuallyDeselectGeneralHand: function manuallyDeselectGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectGeneralHand(state, payload);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHands(state, payload);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectAllGeneralHands(state, payload);
  },
  selectSpecificHand: function selectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function deselectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectSpecificHand(state, payload);
  },
  manuallySelectSpecificHand: function manuallySelectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySelectSpecificHand(state, payload);
  },
  manuallyDeselectSpecificHand: function manuallyDeselectSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectSpecificHand(state, payload);
  },
  manuallyDeselectAllGeneralHands: function manuallyDeselectAllGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectAllGeneralHands(state, payload);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHands(state, payload);
  },
  setSpecificHandAsManuallySet: function setSpecificHandAsManuallySet(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setSpecificHandAsManuallySet(state, payload);
  },
  setSpecificHandAsNotManuallySet: function setSpecificHandAsNotManuallySet(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setSpecificHandAsManuallySet(state, payload);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function setWeightOfSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightOfSpecificHand(state, payload);
  },
  manuallyApplyExactWeightToGeneralHand: function manuallyApplyExactWeightToGeneralHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyApplyExactWeightToGeneralHand(state, payload);
  },
  manuallySetWeightOfSpecificHand: function manuallySetWeightOfSpecificHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySetWeightOfSpecificHand(state, payload);
  },
  clearManuallyAddedHands: function clearManuallyAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
  },
  clearManuallyRemovedHands: function clearManuallyRemovedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  setRangesAccordingToFilters: function setRangesAccordingToFilters(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setRangesAccordingToFilters(state, playerIndex);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function addComboToCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function removeComboFromCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeComboFromCombosToAdd(state, payload);
  },
  highlightGeneralHandsThatMatchFiveCardHand: function highlightGeneralHandsThatMatchFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].highlightGeneralHandsThatMatchFiveCardHand(state, payload);
  },
  removeFiveCardHandHighlights: function removeFiveCardHandHighlights(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeFiveCardHandHighlights(state, payload);
  },

  // controls
  setPresetHoleCard: function setPresetHoleCard(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setPresetHoleCard(state, payload);
  },
  removePresetHoleCard: function removePresetHoleCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetHoleCard(state, position);
  },
  setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function setBoard(state, boardCards) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setBoard(state, boardCards);
  },
  removePresetCommunityCard: function removePresetCommunityCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetCommunityCard(state, position);
  },
  addPlayer: function addPlayer(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addPlayer(state, payload);
  },
  removePlayer: function removePlayer(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePlayer(state, playerIndex);
  },

  // five card hands section checkboxes
  setCheckedValueOfFiveCardHand: function setCheckedValueOfFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setCheckedValueOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newCheckedValue: payload.newCheckedValue
    });
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallySetHandsThatPassThroughFilter(state, {
      playerIndex: payload.playerIndex,
      playerStateIndex: payload.playerStateIndex,
      fiveCardHandId: payload.fiveCardHandId
    });
  },
  applyExactWeightToFiveCardHand: function applyExactWeightToFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToFiveCardHand(state, payload);
  },
  uncheckAllFiveCardHandsForGivenState: function uncheckAllFiveCardHandsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].uncheckAllFiveCardHandsForGivenState(state, payload);
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  checkAllFiveCardHandsForGivenState: function checkAllFiveCardHandsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].checkAllFiveCardHandsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  setChecksToDefaultsForGivenState: function setChecksToDefaultsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setChecksToDefaultsForGivenState(state, payload);
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  setChecksAccordingToUserDefinedFilterForGivenState: function setChecksAccordingToUserDefinedFilterForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setChecksAccordingToUserDefinedFilterForGivenState(state, payload);
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  setFiveCardHandValuesToDefaults: function setFiveCardHandValuesToDefaults(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setFiveCardHandValuesToDefaults(state, payload);
  },
  updateWeightOfFiveCardHand: function updateWeightOfFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].updateWeightOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newWeight: payload.newWeight
    });
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallySetHandsThatPassThroughFilter(state, {
      playerIndex: payload.playerIndex,
      playerStateIndex: payload.playerStateIndex,
      fiveCardHandId: payload.fiveCardHandId
    });
  },

  // five card hands section other
  toggleCollapsedValueOfFiveCardHandParent: function toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent);
  },
  setProbabilitiesOfFiveCardHands: function setProbabilitiesOfFiveCardHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setProbabilitiesOfFiveCardHands(state, payload);
  },
  setHandAndDrawInfo: function setHandAndDrawInfo(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setHandAndDrawInfo(state, payload);
  },
  setPercentagesOfSpecificHandsThatAreSelected: function setPercentagesOfSpecificHandsThatAreSelected(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setPercentagesOfSpecificHandsThatAreSelected(state, payload);
  },

  // simulations
  setLastSimulationInfo: function setLastSimulationInfo(state, playerStateIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setLastSimulationInfo(state, playerStateIndex);
  },
  updateEquityResults: function updateEquityResults(state, payload) {
    var equity = void 0;
    var wins = void 0;
    var ties = void 0;
    var winFractions = void 0;
    var numberOfSimulations = payload.numberOfSimulations;
    var numPlayers = payload.simulationResults.length;

    state.players.forEach(function (player, playerIndex) {
      wins = payload.simulationResults[playerIndex + 1].wins;
      ties = payload.simulationResults[playerIndex + 1].ties;
      winFractions = payload.simulationResults[playerIndex + 1].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = (wins + winFractions) / numberOfSimulations * 100;
      equity -= equity * (payload.rakePercentage / 100) + equity * (payload.tipPercentage / 100);
      player.states[0].equity = equity.roundToTwoDecimalPlaces();
      player.states[0].winPercentage = wins / numberOfSimulations * 100;
      player.states[0].tiePercentage = ties / numberOfSimulations * 100;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations
});

/***/ }),

/***/ "pnxJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pricing_vue__ = __webpack_require__("STB5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79417fae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pricing_vue__ = __webpack_require__("ZIZt");
function injectStyle (ssrContext) {
  __webpack_require__("mTvE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79417fae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pricing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79417fae_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pricing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "q00v":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q2pU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_readonly_alert__ = __webpack_require__("lDlf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_utilities_saved_scenario_alert__ = __webpack_require__("nMYT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_three_bet_cbet_explorer_three_bet_cbet_explorer_inputs__ = __webpack_require__("rd0R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_three_bet_cbet_explorer_three_bet_cbet_explorer_table__ = __webpack_require__("yX2o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_three_bet_cbet_explorer_three_bet_cbet_explorer_graph__ = __webpack_require__("bjxn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_controls_create_sharable_url_button__ = __webpack_require__("zMC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_controls_save_scenario_button__ = __webpack_require__("A/Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_onboarding_modal__ = __webpack_require__("iexb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'three-bet-cbet-explorer',
  components: {
    'readonly-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_readonly_alert__["a" /* default */],
    'saved-scenario-alert': __WEBPACK_IMPORTED_MODULE_1__components_utilities_saved_scenario_alert__["a" /* default */],
    'three-bet-cbet-explorer-inputs': __WEBPACK_IMPORTED_MODULE_2__components_three_bet_cbet_explorer_three_bet_cbet_explorer_inputs__["a" /* default */],
    'three-bet-cbet-explorer-table': __WEBPACK_IMPORTED_MODULE_3__components_three_bet_cbet_explorer_three_bet_cbet_explorer_table__["a" /* default */],
    'three-bet-cbet-explorer-graph': __WEBPACK_IMPORTED_MODULE_4__components_three_bet_cbet_explorer_three_bet_cbet_explorer_graph__["a" /* default */],
    'create-sharable-url-button': __WEBPACK_IMPORTED_MODULE_5__components_controls_create_sharable_url_button__["a" /* default */],
    'save-scenario-button': __WEBPACK_IMPORTED_MODULE_6__components_controls_save_scenario_button__["a" /* default */],
    'onboarding-modal': __WEBPACK_IMPORTED_MODULE_7__components_onboarding_modal__["a" /* default */]
  },
  data: function data() {
    return {
      chartLabels: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100]
    };
  },
  computed: {
    state: function state() {
      return this.$store.state.threeBetCbetExplorer;
    },
    savedScenario: function savedScenario() {
      var routeId = this.$route.params.id;

      if (!this.authorized) {
        return false;
      }

      return this.$store.state.account.user.savedScenarios.threeBetCbetExplorer.find(function (savedScenario) {
        return savedScenario.url.includes(routeId);
      });
    },

    chartData: function chartData() {
      return {
        labels: this.chartLabels,
        datasets: [{
          label: 'EV of 3betting',
          data: this._evOfThreeBettingData,
          pointRadius: this._evOfThreeBettingDataPointRadius,
          fill: false,
          borderColor: 'rgb(75, 192, 192)',
          lineTension: 0.1
        }, {
          label: 'EV = ' + this.state.alternativeEV,
          data: this._alternativeEVData,
          fill: false,
          borderColor: 'gray',
          lineTension: 0.1
        }]
      };
    },
    _evOfThreeBettingData: function _evOfThreeBettingData() {
      return this.chartLabels.map(function (callVs3betPercentage) {
        return this.getEV(this.state, callVs3betPercentage / 100);
      }, this);
    },
    _evOfThreeBettingDataPointRadius: function _evOfThreeBettingDataPointRadius() {
      var roundedBreakevenPercentage = this.selectedContinueVs3betPercentage.roundToNearestFive();

      return this.chartLabels.map(function (callVs3betPercentage) {
        if (callVs3betPercentage === roundedBreakevenPercentage) {
          return 7;
        }

        return 3;
      }, this);
    },
    _alternativeEVData: function _alternativeEVData() {
      return this.chartLabels.map(function () {
        return this.state.alternativeEV;
      }, this);
    },

    selectedContinueVs3betPercentage: function selectedContinueVs3betPercentage() {
      var numberOfSpecificHandsThatOpen = this.state.players.find(0).states[0].generalHands.numberOfSpecificHandsInRange;
      var numberOfSpecificHandsThatContinue = this.state.players.find(0).states[1].generalHands.numberOfSpecificHandsInRange;

      if (numberOfSpecificHandsThatContinue === 0) {
        return 0;
      }

      return (numberOfSpecificHandsThatContinue / numberOfSpecificHandsThatOpen * 100).roundToOneDecimalPlace();
    },
    authorized: function authorized() {
      return this.$store.getters['account/authorizedForPremium'];
    }
  },
  created: function created() {
    if (this.$route.params.id) {
      this.load();
    }
  },
  mounted: function mounted() {
    this.handleOnboard();
  },
  methods: {
    getEV: function getEV(state, continueVs3betProbability) {
      if (!this._ableToComputeEV(state)) {
        return null;
      }

      var playerBehindFourBetsEV = this._getPlayerBehindFourBetsEV(state);
      var initialRaiserFourBetsEV = this._getInitialRaiserFourBetsEV(state, continueVs3betProbability);
      var foldToThreeBetEV = this._getFoldToThreeBetEV(state, continueVs3betProbability);
      var foldToCbetEV = this._getFoldToCbetEV(state, continueVs3betProbability);
      var continueVsCbetEV = this._getContinueVsCbetEV(state, continueVs3betProbability);
      var oneStreetOfValueEV = this._getOneStreetOfValueEV(state, continueVs3betProbability);
      var twoStreetsOfValueEV = this._getTwoStreetsOfValueEV(state, continueVs3betProbability);
      var threeStreetsOfValueEV = this._getThreeStreetsOfValueEV(state, continueVs3betProbability);

      return (playerBehindFourBetsEV + initialRaiserFourBetsEV + foldToThreeBetEV + foldToCbetEV + continueVsCbetEV + oneStreetOfValueEV + twoStreetsOfValueEV + threeStreetsOfValueEV).roundToTwoDecimalPlaces();
    },
    _ableToComputeEV: function _ableToComputeEV(state) {
      var numOpenCombos = state.players.find(0).states[0].generalHands.numberOfSpecificHandsInRange;

      return numOpenCombos > 0;
    },
    __getProbabilityThatNoPlayerBehindFourBets: function __getProbabilityThatNoPlayerBehindFourBets(state) {
      var averageFourBetProbability = state.averageFourBetPercentage / 100;
      var averageNoFourBetProbability = 1 - averageFourBetProbability;

      return Math.pow(averageNoFourBetProbability, state.numPlayersLeftToAct);
    },
    __getProbabilityThatInitialRaiserFourBets: function __getProbabilityThatInitialRaiserFourBets(state, continueVs3betProbability) {
      var numOpenCombos = state.players.find(0).states[0].generalHands.numberOfSpecificHandsInRange;
      var numContinueCombos = numOpenCombos * continueVs3betProbability;
      var numFourBetCombos = state.players.find(0).states[2].generalHands.numberOfSpecificHandsInRange;

      if (numFourBetCombos > numContinueCombos) {
        numFourBetCombos = numContinueCombos;
      }

      return numFourBetCombos / numOpenCombos;
    },
    __getProbabilityThatInitialRaiserFolds: function __getProbabilityThatInitialRaiserFolds(state, continueVs3betProbability) {
      var numOpenCombos = state.players.find(0).states[0].generalHands.numberOfSpecificHandsInRange;
      var numContinueCombos = numOpenCombos * continueVs3betProbability;
      var numFoldCombos = numOpenCombos - numContinueCombos;

      return numFoldCombos / numOpenCombos;
    },
    __getProbabilityThatInitialRaiserCalls: function __getProbabilityThatInitialRaiserCalls(state, continueVs3betProbability) {
      var numOpenCombos = state.players.find(0).states[0].generalHands.numberOfSpecificHandsInRange;
      var numContinueCombos = numOpenCombos * continueVs3betProbability;
      var numFourBetCombos = state.players.find(0).states[2].generalHands.numberOfSpecificHandsInRange;
      var numCallCombos = void 0;

      if (numFourBetCombos > numContinueCombos) {
        numFourBetCombos = numContinueCombos;
      }

      numCallCombos = numContinueCombos - numFourBetCombos;

      return numCallCombos / numOpenCombos;
    },
    _getPlayerBehindFourBetsEV: function _getPlayerBehindFourBetsEV(state) {
      var probabilityThatNoPlayerBehindFourBets = this.__getProbabilityThatNoPlayerBehindFourBets(state);
      var probabilityThatAPlayerBehindFourBets = 1 - probabilityThatNoPlayerBehindFourBets;
      var amountLost = state.threeBetSize;

      return probabilityThatAPlayerBehindFourBets * -1 * amountLost;
    },
    _getInitialRaiserFourBetsEV: function _getInitialRaiserFourBetsEV(state, continueVs3betProbability) {
      var probabilityThatNoPlayerBehindFourBets = this.__getProbabilityThatNoPlayerBehindFourBets(state);
      var probabilityThatInitialRaiserFourBets = this.__getProbabilityThatInitialRaiserFourBets(state, continueVs3betProbability);
      var amountLost = state.threeBetSize;

      return probabilityThatNoPlayerBehindFourBets * probabilityThatInitialRaiserFourBets * -1 * amountLost;
    },
    _getFoldToThreeBetEV: function _getFoldToThreeBetEV(state, continueVs3betProbability) {
      var probabilityThatNoPlayerBehindFourBets = this.__getProbabilityThatNoPlayerBehindFourBets(state);
      var probabilityThatInitialRaiserFolds = this.__getProbabilityThatInitialRaiserFolds(state, continueVs3betProbability);
      var blinds = 1.5;
      var amountWon = blinds + state.openSize;

      return probabilityThatNoPlayerBehindFourBets * probabilityThatInitialRaiserFolds * amountWon;
    },
    _getFoldToCbetEV: function _getFoldToCbetEV(state, continueVs3betProbability) {
      var probabilityThatNoPlayerBehindFourBets = this.__getProbabilityThatNoPlayerBehindFourBets(state);
      var probabilityThatInitialRaiserCalls = this.__getProbabilityThatInitialRaiserCalls(state, continueVs3betProbability);
      var probabilityOfMiss = 1 - state.hitPercentage / 100;
      var probabilityOfFoldToCbet = 1 - state.continueVsCbetPercentage / 100;
      var blinds = 1.5;
      var amountWon = blinds + state.threeBetSize;

      return probabilityThatNoPlayerBehindFourBets * probabilityThatInitialRaiserCalls * probabilityOfMiss * probabilityOfFoldToCbet * amountWon;
    },
    _getContinueVsCbetEV: function _getContinueVsCbetEV(state, continueVs3betProbability) {
      var probabilityThatNoPlayerBehindFourBets = this.__getProbabilityThatNoPlayerBehindFourBets(state);
      var probabilityThatInitialRaiserCalls = this.__getProbabilityThatInitialRaiserCalls(state, continueVs3betProbability);
      var probabilityOfMiss = 1 - state.hitPercentage / 100;
      var probabilityOfContinueVsCbet = state.continueVsCbetPercentage / 100;
      var blinds = 1.5;
      var flopPotSize = blinds + 2 * state.threeBetSize;
      var cbetAmount = state.cbetSize * flopPotSize;
      var amountLost = state.threeBetSize + cbetAmount;

      return probabilityThatNoPlayerBehindFourBets * probabilityThatInitialRaiserCalls * probabilityOfMiss * probabilityOfContinueVsCbet * -1 * amountLost;
    },
    _getOneStreetOfValueEV: function _getOneStreetOfValueEV(state, continueVs3betProbability) {
      if (state.hitPercentage === 0) {
        return 0;
      }

      var probabilityThatNoPlayerBehindFourBets = this.__getProbabilityThatNoPlayerBehindFourBets(state);
      var probabilityThatInitialRaiserCalls = this.__getProbabilityThatInitialRaiserCalls(state, continueVs3betProbability);
      var probabilityOfHit = state.hitPercentage / 100;
      var probabilityOfOneStreetOfValue = state.firstStreetOfValuePercentage / 100 * (1 - state.secondStreetOfValuePercentage / 100);
      var blinds = 1.5;
      var flopPotSize = blinds + 2 * state.threeBetSize;
      var flopBet = 0.75 * flopPotSize;
      var amountWon = blinds + state.threeBetSize + flopBet;

      return probabilityThatNoPlayerBehindFourBets * probabilityThatInitialRaiserCalls * probabilityOfHit * probabilityOfOneStreetOfValue * amountWon;
    },
    _getTwoStreetsOfValueEV: function _getTwoStreetsOfValueEV(state, continueVs3betProbability) {
      if (state.hitPercentage === 0) {
        return 0;
      }

      var probabilityThatNoPlayerBehindFourBets = this.__getProbabilityThatNoPlayerBehindFourBets(state);
      var probabilityThatInitialRaiserCalls = this.__getProbabilityThatInitialRaiserCalls(state, continueVs3betProbability);
      var probabilityOfHit = state.hitPercentage / 100;
      var probabilityOfTwoStreetsOfValue = state.firstStreetOfValuePercentage / 100 * (state.secondStreetOfValuePercentage / 100) * (1 - state.thirdStreetOfValuePercentage / 100);
      var blinds = 1.5;
      var flopPotSize = blinds + 2 * state.threeBetSize;
      var flopBet = 0.75 * flopPotSize;
      var turnPotSize = flopPotSize + 2 * flopBet;
      var turnBet = 0.75 * turnPotSize;
      var amountWon = blinds + state.threeBetSize + flopBet + turnBet;

      return probabilityThatNoPlayerBehindFourBets * probabilityThatInitialRaiserCalls * probabilityOfHit * probabilityOfTwoStreetsOfValue * amountWon;
    },
    _getThreeStreetsOfValueEV: function _getThreeStreetsOfValueEV(state, continueVs3betProbability) {
      if (state.hitPercentage === 0) {
        return 0;
      }

      var probabilityThatNoPlayerBehindFourBets = this.__getProbabilityThatNoPlayerBehindFourBets(state);
      var probabilityThatInitialRaiserCalls = this.__getProbabilityThatInitialRaiserCalls(state, continueVs3betProbability);
      var probabilityOfHit = state.hitPercentage / 100;
      var probabilityOfThreeStreetsOfValue = state.firstStreetOfValuePercentage / 100 * (state.secondStreetOfValuePercentage / 100) * (state.thirdStreetOfValuePercentage / 100);
      var blinds = 1.5;
      var flopPotSize = blinds + 2 * state.threeBetSize;
      var flopBet = 0.75 * flopPotSize;
      var turnPotSize = flopPotSize + 2 * flopBet;
      var turnBet = 0.75 * turnPotSize;
      var riverPotSize = turnPotSize + 2 * turnBet;
      var riverBet = 0.75 * riverPotSize;
      var amountWon = blinds + state.threeBetSize + flopBet + turnBet + riverBet;

      return probabilityThatNoPlayerBehindFourBets * probabilityThatInitialRaiserCalls * probabilityOfHit * probabilityOfThreeStreetsOfValue * amountWon;
    },

    getBreakevenPercentage: function getBreakevenPercentage() {
      var currEV = void 0;

      for (var continueVs3betPercentage = 0; continueVs3betPercentage <= 100; continueVs3betPercentage += 0.01) {
        currEV = this.getEV(this.state, continueVs3betPercentage / 100);

        if (Math.abs(currEV - this.state.alternativeEV) < 0.02) {
          return continueVs3betPercentage.roundToOneDecimalPlace();
        }
      }
    },

    load: function load() {
      var self = this;

      self.$http.get("https://oddscalc.sixplusholdem.com/api" + '/sharable-url-store/' + self.$route.params.id).then(function (response) {
        if (!response || !response.data.storeState) {
          alert('Didn\'t get data back from server. Redirecting to the default 3bet-cbet explorer page.');
          self.$router.push('/three-bet-cbet-explorer');
        } else {
          self.$store.commit('threeBetCbetExplorer/setState', response.data.storeState);
        }
      }).catch(function () {
        alert('URL doesn\'t exist. Redirecting to the default 3bet-cbet explorer page.');
        self.$router.push('/three-bet-cbet-explorer');
      });
    },
    handleOnboard: function handleOnboard() {
      var self = this;

      if (!self.authorized || !self.$store.state.account.user.settings.onboarding || self.$store.state.account.user.settings.onboarding.threeBetCbetExplorer) {
        return;
      }

      $(self.$el).find('.onboarding-modal').modal();
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/onboard', { page: 'threeBetCbetExplorer' }).then(function () {
        self.$store.commit('account/onboard', 'threeBetCbetExplorer');
      }).catch(function () {
        console.log('Error: Unable to onboard.');
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "qANK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_five_card_hands_for_category_vue__ = __webpack_require__("1aQk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4ee8c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_five_card_hands_for_category_vue__ = __webpack_require__("6Nur");
function injectStyle (ssrContext) {
  __webpack_require__("bIA6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dc4ee8c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_five_card_hands_for_category_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dc4ee8c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_five_card_hands_for_category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qCdt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_turn_steps_vue__ = __webpack_require__("sBy4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee29fce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_turn_steps_vue__ = __webpack_require__("EDRA");
function injectStyle (ssrContext) {
  __webpack_require__("Sytm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ee29fce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_turn_steps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee29fce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_turn_steps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qEkd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qM3k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_result_grid_vue__ = __webpack_require__("rbou");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230a0266_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_result_grid_vue__ = __webpack_require__("1U/Q");
function injectStyle (ssrContext) {
  __webpack_require__("7EEe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-230a0266"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_result_grid_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_230a0266_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_result_grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qWvV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__("UlOv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Line"],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  data: function data() {
    return {
      chartOptions: {
        maintainAspectRatio: false,
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'Fold to turn bet percentage'
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'EV ($)'
            }
          }]
        }
      }
    };
  },
  props: ['chartData'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
});

/***/ }),

/***/ "qY6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_utilities_utilities__ = __webpack_require__("g8te");


/* harmony default export */ __webpack_exports__["a"] = ({
  validateBeforeEquityCalculatorSimulation: function validateBeforeEquityCalculatorSimulation(players, presetCommunityCards) {
    var validatePlayerRangesNotEmptyResult = void 0;
    var validatePresetCommunityCardsResult = void 0;

    validatePlayerRangesNotEmptyResult = this._validateEquityCalculatorPlayerRangesNotEmpty(players);
    if (validatePlayerRangesNotEmptyResult.error) {
      return {
        error: true,
        errorMessage: validatePlayerRangesNotEmptyResult.errorMessage
      };
    }

    validatePresetCommunityCardsResult = this._validatePresetCommunityCards(presetCommunityCards);
    if (validatePresetCommunityCardsResult.error) {
      return {
        error: true,
        errorMessage: validatePresetCommunityCardsResult.errorMessage
      };
    }

    return {
      error: false
    };
  },
  validateBeforeHitCalculatorSimulation: function validateBeforeHitCalculatorSimulation(players, presetHoleCards, presetCommunityCards) {
    var validatePresetHoleCardsResult = void 0;
    var validatePresetCommunityCardsResult = void 0;
    var validatePlayerRangesNotEmptyResult = void 0;

    validatePresetHoleCardsResult = this._validatePresetHoleCards(presetHoleCards);
    if (validatePresetHoleCardsResult.error) {
      return {
        error: true,
        errorMessage: validatePresetHoleCardsResult.errorMessage
      };
    }

    validatePresetCommunityCardsResult = this._validatePresetCommunityCards(presetCommunityCards);
    if (validatePresetCommunityCardsResult.error) {
      return {
        error: true,
        errorMessage: validatePresetCommunityCardsResult.errorMessage
      };
    }

    validatePlayerRangesNotEmptyResult = this._validateHitCalculatorPlayerRangesNotEmpty(players, presetCommunityCards);
    if (validatePlayerRangesNotEmptyResult.error) {
      return {
        error: true,
        errorMessage: validatePlayerRangesNotEmptyResult.errorMessage
      };
    }

    return {
      error: false
    };
  },
  _validateEquityCalculatorPlayerRangesNotEmpty: function _validateEquityCalculatorPlayerRangesNotEmpty(players) {
    var error = false;
    var errorMessage = '';

    if (players.hasEmptyRange('preflop')) {
      error = true;
      errorMessage = 'One or more player range is empty.';
    }

    return {
      error: error,
      errorMessage: errorMessage
    };
  },
  _validatePresetHoleCards: function _validatePresetHoleCards(presetHoleCards) {
    var error = false;
    var errorMessage = '';
    var holeCardOneSet = !!presetHoleCards.holeCardOne;
    var holeCardTwoSet = !!presetHoleCards.holeCardTwo;

    if (holeCardOneSet && !holeCardTwoSet) {
      error = true;
      errorMessage = 'You forgot to set the second hole card.';
    } else if (!holeCardOneSet && holeCardTwoSet) {
      error = true;
      errorMessage = 'You forgot to set the first hole card.';
    }

    return {
      error: error,
      errorMessage: errorMessage
    };
  },
  _validatePresetCommunityCards: function _validatePresetCommunityCards(presetCommunityCards) {
    var error = false;
    var errorMessage = '';

    if (presetCommunityCards.river && (!presetCommunityCards.turn || !presetCommunityCards.flop3 || !presetCommunityCards.flop2 || !presetCommunityCards.flop1)) {
      error = true;
      errorMessage = 'You can\'t set the river without setting the flop and turn.';
    }

    if (presetCommunityCards.turn && (!presetCommunityCards.flop3 || !presetCommunityCards.flop2 || !presetCommunityCards.flop1)) {
      error = true;
      errorMessage = 'You can\'t set the turn without setting the flop.';
    }

    if (presetCommunityCards.flop3 && (!presetCommunityCards.flop2 || !presetCommunityCards.flop1)) {
      error = true;
      errorMessage = 'You can\'t set the third community card without setting the first two.';
    }

    if (presetCommunityCards.flop2 && !presetCommunityCards.flop1) {
      error = true;
      errorMessage = 'You can\'t set the second community card without setting the first.';
    }

    return {
      error: error,
      errorMessage: errorMessage
    };
  }
});

/***/ }),

/***/ "qYOO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'saved-scenario-alert',
  props: ['title']
});

/***/ }),

/***/ "qaBB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"range-constructor"},[(!_vm.authorized)?_c('readonly-alert'):_vm._e(),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('section',{staticClass:"grid-container"},[_c('grid-selector',{attrs:{"generalHands":_vm.state.generalHands,"rangeConstructor":true,"specificHandsNotAllowed":true},on:{"selectGeneralHand":function($event){return _vm.selectGeneralHand($event.generalHandString)},"deselectGeneralHand":function($event){return _vm.deselectGeneralHand($event)},"selectGeneralHands":function($event){return _vm.selectGeneralHands($event)},"deselectGeneralHands":function($event){return _vm.deselectGeneralHands($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block",attrs:{"disabled":!_vm.authorized},on:{"click":function($event){return _vm.$store.commit('rangeConstructor/deselectAllGeneralHands')}}},[_vm._v("\n      Reset\n    ")]),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
        method: 'createSharableRangeConstructorURL',
        state: _vm.state,
      })}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized},on:{"saveScenario":function($event){return _vm.$emit('saveScenario', {
        method: 'createSharableRangeConstructorURL',
        savedScenarioPropertyName: 'rangeConstructor',
        state: _vm.state,
      })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
        method: '_constructRangeConstructorData',
        state: _vm.state,
      })}}})],1),_vm._v(" "),_c('action-selector',{attrs:{"actions":_vm.actionsWithIds,"indexOfSelectedAction":_vm.state.indexOfSelectedAction,"authorized":_vm.authorized},on:{"selectAction":function($event){return _vm.$store.commit('rangeConstructor/selectAction', $event)},"setNameOfAction":function($event){return _vm.$store.commit('rangeConstructor/setNameOfAction', $event)},"addAction":function($event){return _vm.$store.commit('rangeConstructor/addAction')},"removeAction":function($event){return _vm.$store.commit('rangeConstructor/removeAction', $event)},"applyToAllUnselectedHands":function($event){return _vm.$store.commit('rangeConstructor/applyToAllUnselectedHands', $event)}}}),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"range constructor","urlPath":"range-constructor"}}),_vm._v(" "),_c('help-icon',{attrs:{"path":"/help/range-constructor"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Range constructor")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qeSg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sign_in_vue__ = __webpack_require__("pHWA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c74b3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sign_in_vue__ = __webpack_require__("+uKq");
function injectStyle (ssrContext) {
  __webpack_require__("lG8Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57c74b3c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sign_in_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57c74b3c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sign_in_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qfKq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"guided-analyses-should-you-bluff"},[(!_vm.authorized)?_c('readonly-alert'):_vm._e(),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h4',[_vm._v("Step 1: What street are you considering bluffing?")]),_vm._v(" "),_c('street-selector',{attrs:{"street":_vm.state.streetToBluff,"authorized":_vm.authorized},on:{"setStreet":function($event){return _vm.setStreetToBluff($event)}}}),_vm._v(" "),_c('h4',[_vm._v("Step 2: How many opponents are you facing on that street?")]),_vm._v(" "),_c('num-opponents-selector',{attrs:{"numOpponents":_vm.state.players.numPlayers,"authorized":_vm.authorized},on:{"addOpponent":function($event){return _vm.addPlayer()},"removeOpponent":function($event){return _vm.removePlayer()}}}),_vm._v(" "),_c('h4',[_vm._v("Step 3: What are your hole cards?")]),_vm._v(" "),_c('hole-cards-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setPresetHoleCard":function($event){return _vm.setPresetHoleCard($event)},"removePresetHoleCard":function($event){return _vm.removePresetHoleCard($event)}}}),_vm._v(" "),_c('preflop-steps',{ref:"preflopSteps",attrs:{"players":_vm.state.players,"presetCommunityCards":_vm.state.presetCommunityCards,"streetToBluff":_vm.state.streetToBluff,"authorized":_vm.authorized}}),_vm._v(" "),_c('flop-steps',{attrs:{"state":_vm.state,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(1),"authorized":_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event.card, $event.position)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"setBoard":function($event){return _vm.setBoard($event)},"setBluffSize":function($event){return _vm.setBluffSize($event)},"setProfitableBreakevenPercentage":function($event){return _vm.setProfitableBreakevenPercentage($event)}}}),_vm._v(" "),((_vm.state.streetToBluff === 'turn' || _vm.state.streetToBluff === 'river') && _vm.state.presetCommunityCards.flopSet)?_c('turn-steps',{attrs:{"state":_vm.state,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(2),"authorized":_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event.card, $event.position)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"setBluffSize":function($event){return _vm.setBluffSize($event)},"setProfitableBreakevenPercentage":function($event){return _vm.setProfitableBreakevenPercentage($event)}}}):_vm._e(),_vm._v(" "),(_vm.state.streetToBluff === 'river' && _vm.state.presetCommunityCards.turnSet)?_c('river-steps',{attrs:{"state":_vm.state,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.getTextWhenFiveCardHandPercentagesArentUpToDate(3),"authorized":_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.setIndividualPresetCommunityCard($event.card, $event.position)},"removePresetCommunityCard":function($event){return _vm.removePresetCommunityCard($event)},"setBluffSize":function($event){return _vm.setBluffSize($event)},"setProfitableBreakevenPercentage":function($event){return _vm.setProfitableBreakevenPercentage($event)}}}):_vm._e(),_vm._v(" "),(_vm.conclusionsVisible)?_c('section',[_c('hr'),_vm._v(" "),_c('initial-conclusion',{attrs:{"bluffSize":_vm.state.bluffSize,"streetToBluff":_vm.state.streetToBluff,"hitPercentageForStreetToBluff":_vm.hitPercentageForStreetToBluff,"foldEquity":_vm.foldEquity,"immediatelyProfitableBreakevenPercentage":_vm.$store.getters['guidedAnalysesBluffing/immediatelyProfitableBreakevenPercentage'],"cumulativeHitPercentages":_vm.$store.getters['guidedAnalysesBluffing/cumulativeHitPercentages'],"numPlayers":_vm.state.players.numPlayers}}),_vm._v(" "),(_vm.state.streetToBluff !== 'river')?_c('final-conclusion',{attrs:{"ableToRunEquityCalculations":_vm.ableToRunEquityCalculations,"equitySimulationsInProgress":_vm.equitySimulationsInProgress,"equity":_vm.equity,"bluffSize":_vm.state.bluffSize,"streetToBluff":_vm.state.streetToBluff,"hitPercentageForStreetToBluff":_vm.hitPercentageForStreetToBluff,"foldEquity":_vm.foldEquity,"immediatelyProfitableBreakevenPercentage":_vm.$store.getters['guidedAnalysesBluffing/immediatelyProfitableBreakevenPercentage'],"profitableBreakevenPercentage":_vm.state.profitableBreakevenPercentage},on:{"setProfitableBreakevenPercentage":function($event){return _vm.setProfitableBreakevenPercentage($event)}}}):_vm._e(),_vm._v(" "),_c('long-run-disclaimer'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
        method: 'createSharableGuidedAnalysesBluffingURL',
        state: _vm.state,
        approximateWaitTime: 5,
      })}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized},on:{"saveScenario":function($event){return _vm.$emit('saveScenario', {
        method: 'createSharableGuidedAnalysesBluffingURL',
        savedScenarioPropertyName: 'shouldYouBluff',
        state: _vm.state,
      })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
        method: '_constructGuidedAnalysesBluffingData',
        state: _vm.state,
      })}}})],1):_vm._e(),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"should you bluff tool","urlPath":"should-you-bluff"}}),_vm._v(" "),_c('help-icon',{attrs:{"path":"/help/should-you-bluff"}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("Guided Analysis: Should you bluff?")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qfrL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_value_to_bluff_ratio_vue__ = __webpack_require__("NwOM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6ce5086_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_value_to_bluff_ratio_vue__ = __webpack_require__("nxTv");
function injectStyle (ssrContext) {
  __webpack_require__("x+YS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6ce5086"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_value_to_bluff_ratio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6ce5086_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_value_to_bluff_ratio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qg5h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export state */
/* unused harmony export mutations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_hands_GeneralHands__ = __webpack_require__("udlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_constants__ = __webpack_require__("vjYN");




var state = {
  generalHands: new __WEBPACK_IMPORTED_MODULE_0__services_hands_GeneralHands__["a" /* default */](),
  indexOfSelectedAction: 0,
  actions: [{
    name: 'Raise',
    color: 'green'
  }, {
    name: 'Call',
    color: 'blue'
  }, {
    name: 'Fold',
    color: 'red'
  }, {
    name: 'Not possible',
    color: 'impossible',
    immutableName: true
  }]
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_1__services_share_url_service__["a" /* default */].setRangeConstructorStoreState(stateFromServer, state);
  },

  // grid
  selectGeneralHand: function selectGeneralHand(state, generalHandString) {
    var generalHand = state.generalHands.find(generalHandString);

    generalHand.color = state.actions[state.indexOfSelectedAction].color;
    generalHand.forEachSpecificHand(function (specificHand) {
      specificHand.weight = 100;
    });
  },
  deselectGeneralHand: function deselectGeneralHand(state, generalHandString) {
    var generalHand = state.generalHands.find(generalHandString);

    generalHand.color = null;
    generalHand.forEachSpecificHand(function (specificHand) {
      specificHand.weight = 0;
    });
  },
  selectGeneralHands: function selectGeneralHands(state, generalHandStrings) {
    var generalHand = void 0;

    generalHandStrings.forEach(function (generalHandString) {
      generalHand = state.generalHands.find(generalHandString);
      generalHand.color = state.actions[state.indexOfSelectedAction].color;
      generalHand.forEachSpecificHand(function (specificHand) {
        specificHand.weight = 100;
      });
    });
  },
  deselectGeneralHands: function deselectGeneralHands(state, generalHandStrings) {
    var generalHand = void 0;

    generalHandStrings.forEach(function (generalHandString) {
      generalHand = state.generalHands.find(generalHandString);
      generalHand.color = null;
      generalHand.forEachSpecificHand(function (specificHand) {
        specificHand.weight = 0;
      });
    });
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state) {
    var allGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].handRankings['sklansky-chubukov'];
    var generalHand = void 0;

    allGeneralHandStrings.forEach(function (generalHandString) {
      generalHand = state.generalHands.find(generalHandString);
      generalHand.color = null;
      generalHand.forEachSpecificHand(function (specificHand) {
        specificHand.weight = 0;
      });
    });
  },
  applyToAllUnselectedHands: function applyToAllUnselectedHands(state, color) {
    state.generalHands.forEach(function (generalHand) {
      if (generalHand.color === null) {
        generalHand.color = color;
        generalHand.forEachSpecificHand(function (specificHand) {
          specificHand.weight = 100;
        });
      }
    });
  },

  // actions
  selectAction: function selectAction(state, index) {
    state.indexOfSelectedAction = index;
  },
  setNameOfAction: function setNameOfAction(state, payload) {
    state.actions[payload.index].name = payload.name;
  },
  addAction: function addAction(state) {
    var newColor = void 0;
    var greenUsed = state.actions.find(function (action) {
      return action.color === 'green';
    });
    var blueUsed = state.actions.find(function (action) {
      return action.color === 'blue';
    });
    var redUsed = state.actions.find(function (action) {
      return action.color === 'red';
    });
    var yellowUsed = state.actions.find(function (action) {
      return action.color === 'yellow';
    });
    var orangeUsed = state.actions.find(function (action) {
      return action.color === 'orange';
    });
    var purpleUsed = state.actions.find(function (action) {
      return action.color === 'purple';
    });
    var brownUsed = state.actions.find(function (action) {
      return action.color === 'brown';
    });

    if (!greenUsed) {
      newColor = 'green';
    } else if (!blueUsed) {
      newColor = 'blue';
    } else if (!redUsed) {
      newColor = 'red';
    } else if (!yellowUsed) {
      newColor = 'yellow';
    } else if (!orangeUsed) {
      newColor = 'orange';
    } else if (!purpleUsed) {
      newColor = 'purple';
    } else if (!brownUsed) {
      newColor = 'brown';
    }

    state.actions.splice(state.actions.length - 1, 0, {
      name: 'Action #' + state.actions.length,
      color: newColor
    });
  },
  removeAction: function removeAction(state, index) {
    state.actions.splice(index, 1);
  }
};

var getters = {
  percentageForAction: function percentageForAction(state, getters) {
    return function (actionColor) {
      var numCombosForAction = 0;

      state.generalHands.forEach(function (generalHand) {
        if (generalHand.color === actionColor) {
          numCombosForAction += generalHand.numSpecificHandsInRange;
        }
      });

      return (numCombosForAction / getters.numberOfPossibleSpecificHands * 100).roundToTwoDecimalPlaces();
    };
  },
  numberOfPossibleSpecificHands: function numberOfPossibleSpecificHands(state) {
    var numberOfPossibleSpecificHands = 0;

    state.generalHands.forEach(function (generalHand) {
      if (generalHand.color !== 'impossible') {
        numberOfPossibleSpecificHands += generalHand.numPossibleSpecificHands;
      }
    });

    return numberOfPossibleSpecificHands;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters
});



/***/ }),

/***/ "qjMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'category-selector',
  props: ['generalHands', 'disabled', 'shortDeck'],
  data: function data() {
    return {
      categoryGroups: [[{
        displayText: 'Pocket pairs',
        camelCase: 'pocketPairs'
      }, {
        camelCase: 'mediumPocketPairs'
      }, {
        camelCase: 'smallPocketPairs'
      }], [{
        displayText: 'Suited connectors',
        camelCase: 'suitedConnectors'
      }, {
        camelCase: 'mediumSuitedConnectors'
      }, {
        camelCase: 'smallSuitedConnectors'
      }], [{
        displayText: 'Suited one gappers',
        camelCase: 'suitedOneGappers'
      }, {
        camelCase: 'mediumSuitedOneGappers'
      }, {
        camelCase: 'smallSuitedOneGappers'
      }], [{
        displayText: 'Suited aces',
        camelCase: 'suitedAces'
      }, {
        camelCase: 'mediumSuitedAces'
      }, {
        camelCase: 'smallSuitedAces'
      }], [{
        displayText: 'Suited kings',
        camelCase: 'suitedKings'
      }, {
        camelCase: 'mediumSuitedKings'
      }, {
        camelCase: 'smallSuitedKings'
      }]]
    };
  },
  computed: {
    categories: function categories() {
      if (this.shortDeck) {
        return __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].shortDeckCategories;
      }

      return __WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].categories;
    }
  },
  methods: {
    isCategoryInRange: function isCategoryInRange(categoryName) {
      return __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].hands.areGeneralHandsInRange(this.categories[categoryName], this.generalHands);
    },
    selectOrDeselectGeneralHandsFromCategory: function selectOrDeselectGeneralHandsFromCategory(categoryName) {
      var generalHandStringsForCategory = this.categories[categoryName];

      if (this.isCategoryInRange(categoryName)) {
        this.$emit('deselectGeneralHands', generalHandStringsForCategory);
      } else {
        this.$emit('selectGeneralHands', generalHandStringsForCategory);
      }
    }
  }
});

/***/ }),

/***/ "qmK6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"short-deck-individual-card-selector",attrs:{"disabled":_vm.disabled}},[_c('div',{class:_vm.popoverDirectionClass},[_c('span',{staticClass:"dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[(_vm.cardString)?_c('img',{attrs:{"src":_vm.cardImageSrc}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('section',{staticClass:"non-mobile"},[_c('table',[_c('tr',[_c('td',[(_vm.isCardAvailable('ah'))?_c('img',{attrs:{"src":"/static/cards/ace-of-hearts.png"},on:{"click":function($event){return _vm.select('ah', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kh'))?_c('img',{attrs:{"src":"/static/cards/king-of-hearts.png"},on:{"click":function($event){return _vm.select('kh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qh'))?_c('img',{attrs:{"src":"/static/cards/queen-of-hearts.png"},on:{"click":function($event){return _vm.select('qh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jh'))?_c('img',{attrs:{"src":"/static/cards/jack-of-hearts.png"},on:{"click":function($event){return _vm.select('jh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('th'))?_c('img',{attrs:{"src":"/static/cards/ten-of-hearts.png"},on:{"click":function($event){return _vm.select('th', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9h'))?_c('img',{attrs:{"src":"/static/cards/nine-of-hearts.png"},on:{"click":function($event){return _vm.select('9h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8h'))?_c('img',{attrs:{"src":"/static/cards/eight-of-hearts.png"},on:{"click":function($event){return _vm.select('8h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7h'))?_c('img',{attrs:{"src":"/static/cards/seven-of-hearts.png"},on:{"click":function($event){return _vm.select('7h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6h'))?_c('img',{attrs:{"src":"/static/cards/six-of-hearts.png"},on:{"click":function($event){return _vm.select('6h', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('as'))?_c('img',{attrs:{"src":"/static/cards/ace-of-spades.png"},on:{"click":function($event){return _vm.select('as', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ks'))?_c('img',{attrs:{"src":"/static/cards/king-of-spades.png"},on:{"click":function($event){return _vm.select('ks', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qs'))?_c('img',{attrs:{"src":"/static/cards/queen-of-spades.png"},on:{"click":function($event){return _vm.select('qs', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('js'))?_c('img',{attrs:{"src":"/static/cards/jack-of-spades.png"},on:{"click":function($event){return _vm.select('js', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ts'))?_c('img',{attrs:{"src":"/static/cards/ten-of-spades.png"},on:{"click":function($event){return _vm.select('ts', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9s'))?_c('img',{attrs:{"src":"/static/cards/nine-of-spades.png"},on:{"click":function($event){return _vm.select('9s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8s'))?_c('img',{attrs:{"src":"/static/cards/eight-of-spades.png"},on:{"click":function($event){return _vm.select('8s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7s'))?_c('img',{attrs:{"src":"/static/cards/seven-of-spades.png"},on:{"click":function($event){return _vm.select('7s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6s'))?_c('img',{attrs:{"src":"/static/cards/six-of-spades.png"},on:{"click":function($event){return _vm.select('6s', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('ad'))?_c('img',{attrs:{"src":"/static/cards/ace-of-diamonds.png"},on:{"click":function($event){return _vm.select('ad', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kd'))?_c('img',{attrs:{"src":"/static/cards/king-of-diamonds.png"},on:{"click":function($event){return _vm.select('kd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qd'))?_c('img',{attrs:{"src":"/static/cards/queen-of-diamonds.png"},on:{"click":function($event){return _vm.select('qd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jd'))?_c('img',{attrs:{"src":"/static/cards/jack-of-diamonds.png"},on:{"click":function($event){return _vm.select('jd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('td'))?_c('img',{attrs:{"src":"/static/cards/ten-of-diamonds.png"},on:{"click":function($event){return _vm.select('td', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9d'))?_c('img',{attrs:{"src":"/static/cards/nine-of-diamonds.png"},on:{"click":function($event){return _vm.select('9d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8d'))?_c('img',{attrs:{"src":"/static/cards/eight-of-diamonds.png"},on:{"click":function($event){return _vm.select('8d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7d'))?_c('img',{attrs:{"src":"/static/cards/seven-of-diamonds.png"},on:{"click":function($event){return _vm.select('7d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6d'))?_c('img',{attrs:{"src":"/static/cards/six-of-diamonds.png"},on:{"click":function($event){return _vm.select('6d', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('ac'))?_c('img',{attrs:{"src":"/static/cards/ace-of-clubs.png"},on:{"click":function($event){return _vm.select('ac', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kc'))?_c('img',{attrs:{"src":"/static/cards/king-of-clubs.png"},on:{"click":function($event){return _vm.select('kc', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qc'))?_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"},on:{"click":function($event){return _vm.select('qc', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jc'))?_c('img',{attrs:{"src":"/static/cards/jack-of-clubs.png"},on:{"click":function($event){return _vm.select('jc', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('tc'))?_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"},on:{"click":function($event){return _vm.select('tc', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9c'))?_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"},on:{"click":function($event){return _vm.select('9c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8c'))?_c('img',{attrs:{"src":"/static/cards/eight-of-clubs.png"},on:{"click":function($event){return _vm.select('8c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7c'))?_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"},on:{"click":function($event){return _vm.select('7c', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6c'))?_c('img',{attrs:{"src":"/static/cards/six-of-clubs.png"},on:{"click":function($event){return _vm.select('6c', $event)}}}):_vm._e()])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.selectRandomCard($event)}}},[_vm._v("\n          Random\n        ")])]),_vm._v(" "),_c('section',{staticClass:"mobile"},[(_vm.popoverDirectionClass === 'dropdown')?_c('button',{staticClass:"btn btn-default btn-block btn-lg",on:{"click":function($event){return _vm.selectRandomCard($event)}}},[_vm._v("\n          Random\n        ")]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('ah'))?_c('img',{attrs:{"src":"/static/cards/ace-of-hearts.png"},on:{"click":function($event){return _vm.select('ah', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('as'))?_c('img',{attrs:{"src":"/static/cards/ace-of-spades.png"},on:{"click":function($event){return _vm.select('as', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ad'))?_c('img',{attrs:{"src":"/static/cards/ace-of-diamonds.png"},on:{"click":function($event){return _vm.select('ad', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ac'))?_c('img',{attrs:{"src":"/static/cards/ace-of-clubs.png"},on:{"click":function($event){return _vm.select('ac', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('kh'))?_c('img',{attrs:{"src":"/static/cards/king-of-hearts.png"},on:{"click":function($event){return _vm.select('kh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ks'))?_c('img',{attrs:{"src":"/static/cards/king-of-spades.png"},on:{"click":function($event){return _vm.select('ks', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kd'))?_c('img',{attrs:{"src":"/static/cards/king-of-diamonds.png"},on:{"click":function($event){return _vm.select('kd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('kc'))?_c('img',{attrs:{"src":"/static/cards/king-of-clubs.png"},on:{"click":function($event){return _vm.select('kc', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('qh'))?_c('img',{attrs:{"src":"/static/cards/queen-of-hearts.png"},on:{"click":function($event){return _vm.select('qh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qs'))?_c('img',{attrs:{"src":"/static/cards/queen-of-spades.png"},on:{"click":function($event){return _vm.select('qs', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qd'))?_c('img',{attrs:{"src":"/static/cards/queen-of-diamonds.png"},on:{"click":function($event){return _vm.select('qd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('qc'))?_c('img',{attrs:{"src":"/static/cards/queen-of-clubs.png"},on:{"click":function($event){return _vm.select('ac', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('jh'))?_c('img',{attrs:{"src":"/static/cards/jack-of-hearts.png"},on:{"click":function($event){return _vm.select('jh', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('js'))?_c('img',{attrs:{"src":"/static/cards/jack-of-spades.png"},on:{"click":function($event){return _vm.select('js', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jd'))?_c('img',{attrs:{"src":"/static/cards/jack-of-diamonds.png"},on:{"click":function($event){return _vm.select('jd', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('jc'))?_c('img',{attrs:{"src":"/static/cards/jack-of-clubs.png"},on:{"click":function($event){return _vm.select('jc', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('th'))?_c('img',{attrs:{"src":"/static/cards/ten-of-hearts.png"},on:{"click":function($event){return _vm.select('th', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('ts'))?_c('img',{attrs:{"src":"/static/cards/ten-of-spades.png"},on:{"click":function($event){return _vm.select('ts', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('td'))?_c('img',{attrs:{"src":"/static/cards/ten-of-diamonds.png"},on:{"click":function($event){return _vm.select('td', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('tc'))?_c('img',{attrs:{"src":"/static/cards/ten-of-clubs.png"},on:{"click":function($event){return _vm.select('tc', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('9h'))?_c('img',{attrs:{"src":"/static/cards/nine-of-hearts.png"},on:{"click":function($event){return _vm.select('9h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9s'))?_c('img',{attrs:{"src":"/static/cards/nine-of-spades.png"},on:{"click":function($event){return _vm.select('9s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9d'))?_c('img',{attrs:{"src":"/static/cards/nine-of-diamonds.png"},on:{"click":function($event){return _vm.select('9d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('9c'))?_c('img',{attrs:{"src":"/static/cards/nine-of-clubs.png"},on:{"click":function($event){return _vm.select('9c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('8h'))?_c('img',{attrs:{"src":"/static/cards/eight-of-hearts.png"},on:{"click":function($event){return _vm.select('8h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8s'))?_c('img',{attrs:{"src":"/static/cards/eight-of-spades.png"},on:{"click":function($event){return _vm.select('8s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8d'))?_c('img',{attrs:{"src":"/static/cards/eight-of-diamonds.png"},on:{"click":function($event){return _vm.select('8d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('8c'))?_c('img',{attrs:{"src":"/static/cards/eight-of-clubs.png"},on:{"click":function($event){return _vm.select('8c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('7h'))?_c('img',{attrs:{"src":"/static/cards/seven-of-hearts.png"},on:{"click":function($event){return _vm.select('7h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7s'))?_c('img',{attrs:{"src":"/static/cards/seven-of-spades.png"},on:{"click":function($event){return _vm.select('7s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7d'))?_c('img',{attrs:{"src":"/static/cards/seven-of-diamonds.png"},on:{"click":function($event){return _vm.select('7d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('7c'))?_c('img',{attrs:{"src":"/static/cards/seven-of-clubs.png"},on:{"click":function($event){return _vm.select('7c', $event)}}}):_vm._e()])]),_vm._v(" "),_c('tr',[_c('td',[(_vm.isCardAvailable('6h'))?_c('img',{attrs:{"src":"/static/cards/six-of-hearts.png"},on:{"click":function($event){return _vm.select('6h', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6s'))?_c('img',{attrs:{"src":"/static/cards/six-of-spades.png"},on:{"click":function($event){return _vm.select('6s', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6d'))?_c('img',{attrs:{"src":"/static/cards/six-of-diamonds.png"},on:{"click":function($event){return _vm.select('6d', $event)}}}):_vm._e()]),_vm._v(" "),_c('td',[(_vm.isCardAvailable('6c'))?_c('img',{attrs:{"src":"/static/cards/six-of-clubs.png"},on:{"click":function($event){return _vm.select('6c', $event)}}}):_vm._e()])]),_vm._v(" "),(_vm.popoverDirectionClass === 'dropup')?_c('button',{staticClass:"btn btn-default btn-block btn-lg",on:{"click":function($event){return _vm.selectRandomCard($event)}}},[_vm._v("\n          Random\n        ")]):_vm._e()])])]),_vm._v(" "),_c('span',{staticClass:"deselect",on:{"click":function($event){return _vm.$emit('deselect')}}},[(_vm.cardString && !_vm.hideDeselect && !_vm.disabled)?_c('span',[_vm._v("×")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qnip":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_constants__ = __webpack_require__("vjYN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-individual-card-selector',
  props: ['cardString', 'presetCards', 'popoverDirectionClass', 'hideDeselect', 'disabled'],
  computed: {
    cardImageSrc: function cardImageSrc() {
      var src = '/static/cards/';
      var cardRank = this.cardString[0];
      var cardSuit = this.cardString[1];

      if (cardRank === 'a') {
        src += 'ace-of-';
      } else if (cardRank === 'k') {
        src += 'king-of-';
      } else if (cardRank === 'q') {
        src += 'queen-of-';
      } else if (cardRank === 'j') {
        src += 'jack-of-';
      } else if (cardRank === 't') {
        src += 'ten-of-';
      } else if (cardRank === '9') {
        src += 'nine-of-';
      } else if (cardRank === '8') {
        src += 'eight-of-';
      } else if (cardRank === '7') {
        src += 'seven-of-';
      } else if (cardRank === '6') {
        src += 'six-of-';
      } else {
        throw new Error('Invalid value for cardRank: ', cardRank);
      }

      if (cardSuit === 'h') {
        src += 'hearts';
      } else if (cardSuit === 'd') {
        src += 'diamonds';
      } else if (cardSuit === 's') {
        src += 'spades';
      } else if (cardSuit === 'c') {
        src += 'clubs';
      } else {
        throw new Error('Invalid value for cardSuit: ', cardSuit);
      }

      src += '.png';
      return src;
    }
  },
  methods: {
    isCardAvailable: function isCardAvailable(cardString) {
      if (Number(cardString[0]) < 6) {
        return false;
      }

      return !this.presetCards.includes(cardString);
    },
    select: function select(cardString, e) {
      this.$emit('select', {
        card: cardString,
        e: e
      });
    },
    selectRandomCard: function selectRandomCard(e) {
      var randomCard = void 0;

      while (!randomCard) {
        randomCard = this._getRandomCard();

        if (!this.isCardAvailable(randomCard)) {
          randomCard = null;
        }
      }

      this.$emit('select', {
        card: randomCard,
        e: e
      });
    },
    _getRandomCard: function _getRandomCard() {
      var rank = _.sample(['a', 'k', 'q', 'j', 't', '9', '8', '7', '6']);
      var suit = _.sample(__WEBPACK_IMPORTED_MODULE_0__services_constants__["a" /* default */].suits);

      return rank + suit;
    },
    toggle: function toggle() {
      $(this.$el).find('.dropdown-toggle').dropdown('toggle');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "qx2/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'blog-post-link',
  props: ['title', 'date', 'path']
});

/***/ }),

/***/ "qzey":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_set_range_step__ = __webpack_require__("unvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_help_range__ = __webpack_require__("9sL7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-preflop-steps',
  components: {
    'set-range-step': __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_set_range_step__["a" /* default */],
    'range-help-section': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_help_range__["a" /* default */]
  },
  props: ['players', 'presetCommunityCards', 'streetToCall', 'authorized'],
  methods: {
    getTextForPlayerRangeStep: function getTextForPlayerRangeStep(playerIndex) {
      if (this.players.numPlayers === 1) {
        return 'Step ' + (4 + playerIndex) + ': What do you think your opponents range is after the preflop action is finished (eg. heading in to the flop)?';
      } else {
        return 'Step ' + (4 + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is after the preflop action is finished (eg. heading in to the flop)?';
      }
    },
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$refs['setRangeStep-' + playerIndex] && this.$refs['setRangeStep-' + playerIndex][0]) {
        this.$refs['setRangeStep-' + playerIndex][0].resetDoubleSlider(playerIndex);
      }
    },
    resetAllDoubleSliders: function resetAllDoubleSliders() {
      this.players.forEach(function (player, playerIndex) {
        this.resetDoubleSlider(playerIndex);
      }, this);
    }
  }
});

/***/ }),

/***/ "r/5L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"saved-range",class:'level-' + _vm.level},[_c('div',{staticClass:"dropdown",class:{
      'leaf': !_vm.savedRange.children,
      'visibility-hidden': !_vm.isBeingHovered,
    }},[_c('span',{staticClass:"glyphicon glyphicon-option-vertical",attrs:{"data-toggle":"dropdown"}}),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{on:{"click":function($event){return _vm.editName()}}},[_vm._m(0)]),_vm._v(" "),(!_vm.savedRange.children)?_c('li',{on:{"click":function($event){return _vm.$emit('showRange', _vm.indexes)}}},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.$emit('remove', _vm.indexes)}}},[_vm._m(2)]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.$emit('addChild', _vm.indexes)}}},[_vm._m(3)]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.$emit('addSibling', _vm.indexes)}}},[_vm._m(4)]),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"separator"}}),_vm._v(" "),(_vm.isMoveUpPossible)?_c('li',{on:{"click":function($event){return _vm.$emit('moveUp', _vm.indexes)}}},[_vm._m(5)]):_vm._e(),_vm._v(" "),(_vm.isMoveDownPossible)?_c('li',{on:{"click":function($event){return _vm.$emit('moveDown', _vm.indexes)}}},[_vm._m(6)]):_vm._e(),_vm._v(" "),(_vm.isIndentRightPossible)?_c('li',{on:{"click":function($event){return _vm.$emit('indentRight', _vm.indexes)}}},[_vm._m(7)]):_vm._e(),_vm._v(" "),(_vm.isIndentLeftPossible)?_c('li',{on:{"click":function($event){return _vm.$emit('indentLeft', _vm.indexes)}}},[_vm._m(8)]):_vm._e()])]),_vm._v(" "),(_vm.savedRange.children)?_c('span',{staticClass:"glyphicon",class:{
        'glyphicon-triangle-bottom': !_vm.savedRange.collapsed,
        'glyphicon-triangle-right': _vm.savedRange.collapsed
      },on:{"click":function($event){return _vm.toggleIsCollapsed()}}}):_vm._e(),_vm._v(" "),(_vm.savedRange.editNameMode)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.savedRange.name),expression:"savedRange.name"}],ref:"editName",attrs:{"type":"text"},domProps:{"value":(_vm.savedRange.name)},on:{"blur":function($event){return _vm.finishEditingName()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.savedRange, "name", $event.target.value)}}}):_c('span',{staticClass:"saved-range-name",class:{
        'selected': _vm.isSelected,
      },on:{"click":function($event){return _vm.handleNameClick()},"dblclick":function($event){return _vm.editName()}}},[_vm._v("\n      "+_vm._s(_vm.savedRange.name)+"\n    ")])]),_vm._v(" "),_vm._l((_vm.savedRange.children),function(child,childIndex){return (_vm.savedRange.children && !_vm.savedRange.collapsed)?_c('saved-range',{key:child.id,attrs:{"savedRange":child,"indexes":_vm.getChildIndexes(childIndex),"savedRanges":_vm.savedRanges,"indexesOfSelectedSavedRange":_vm.indexesOfSelectedSavedRange},on:{"showRange":function($event){return _vm.$emit('showRange', $event)},"remove":function($event){return _vm.$emit('remove', $event)},"addChild":function($event){return _vm.$emit('addChild', $event)},"addSibling":function($event){return _vm.$emit('addSibling', $event)},"moveUp":function($event){return _vm.$emit('moveUp', $event)},"moveDown":function($event){return _vm.$emit('moveDown', $event)},"indentRight":function($event){return _vm.$emit('indentRight', $event)},"indentLeft":function($event){return _vm.$emit('indentLeft', $event)}}}):_vm._e()})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-edit"}),_vm._v(" Edit name")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-expand"}),_vm._v(" Show range")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-trash"}),_vm._v(" Remove")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Add child")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Add sibling")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-chevron-up"}),_vm._v(" Move up")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-chevron-down"}),_vm._v(" Move down")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-indent-right"}),_vm._v(" Indent right")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('span',{staticClass:"glyphicon glyphicon-indent-left"}),_vm._v(" Indent left")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r1DT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rBF1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_player_Players__ = __webpack_require__("IPbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__ = __webpack_require__("XRwE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_PresetHoleCards__ = __webpack_require__("oC4c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_service__ = __webpack_require__("JBFI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__ = __webpack_require__("g8te");







var players = new __WEBPACK_IMPORTED_MODULE_0__services_player_Players__["a" /* default */]();

players.adjustForShortDeck();

var state = {
  totalNumberOfSimulations: null,
  presetHoleCards: new __WEBPACK_IMPORTED_MODULE_2__services_PresetHoleCards__["a" /* default */](),
  presetCommunityCards: new __WEBPACK_IMPORTED_MODULE_1__services_PresetCommunityCards__["a" /* default */](),
  players: players
};

var getters = {
  percentageOfTimeEveryoneMissesTheBoard: function percentageOfTimeEveryoneMissesTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeEveryoneMissesTheBoard(state, street);
    };
  },
  percentageOfTimeExactlyOnePlayerHitsTheBoard: function percentageOfTimeExactlyOnePlayerHitsTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeExactlyOnePlayerHitsTheBoard(state, street);
    };
  },
  percentageOfTimeTwoOrMorePlayersHitTheBoard: function percentageOfTimeTwoOrMorePlayersHitTheBoard(state) {
    return function (street) {
      return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getPercentageOfTimeTwoOrMorePlayersHitTheBoard(state, street);
    };
  },
  cumulativeHitPercentages: function cumulativeHitPercentages(state) {
    return __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].getCumulativeHitPercentages(state);
  }
};

var mutations = {
  setState: function setState(state, stateFromServer) {
    __WEBPACK_IMPORTED_MODULE_3__services_share_url_service__["a" /* default */].setHitCalculatorStoreState(stateFromServer, state);
  },

  // player range
  selectGeneralHand: function selectGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function deselectGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHand(state, payload);
  },
  manuallySelectGeneralHand: function manuallySelectGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySelectGeneralHand(state, payload);
  },
  manuallyDeselectGeneralHand: function manuallyDeselectGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectGeneralHand(state, payload);
  },
  selectGeneralHands: function selectGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function deselectGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectGeneralHands(state, payload);
  },
  deselectAllGeneralHands: function deselectAllGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectAllGeneralHands(state, payload);
  },
  selectSpecificHand: function selectSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function deselectSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].deselectSpecificHand(state, payload);
  },
  manuallySelectSpecificHand: function manuallySelectSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySelectSpecificHand(state, payload);
  },
  manuallyDeselectSpecificHand: function manuallyDeselectSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectSpecificHand(state, payload);
  },
  manuallyDeselectAllGeneralHands: function manuallyDeselectAllGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyDeselectAllGeneralHands(state, payload);
  },
  selectSpecificHands: function selectSpecificHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].selectSpecificHands(state, payload);
  },
  setSpecificHandAsManuallySet: function setSpecificHandAsManuallySet(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setSpecificHandAsManuallySet(state, payload);
  },
  setSpecificHandAsNotManuallySet: function setSpecificHandAsNotManuallySet(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setSpecificHandAsNotManuallySet(state, payload);
  },
  applyExactWeightToGeneralHand: function applyExactWeightToGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function applyExactWeightToGeneralHands(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function setWeightOfSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightOfSpecificHand(state, payload);
  },
  manuallyApplyExactWeightToGeneralHand: function manuallyApplyExactWeightToGeneralHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallyApplyExactWeightToGeneralHand(state, payload);
  },
  manuallySetWeightOfSpecificHand: function manuallySetWeightOfSpecificHand(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].manuallySetWeightOfSpecificHand(state, payload);
  },
  clearManuallyAddedHands: function clearManuallyAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
  },
  clearManuallyRemovedHands: function clearManuallyRemovedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
  },
  setRangesAccordingToFilters: function setRangesAccordingToFilters(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setRangesAccordingToFilters(state, playerIndex, true);
  },

  // player other
  setWeightToApplyToAddedHands: function setWeightToApplyToAddedHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function addComboToCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function removeComboFromCombosToAdd(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeComboFromCombosToAdd(state, payload);
  },
  highlightGeneralHandsThatMatchFiveCardHand: function highlightGeneralHandsThatMatchFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].highlightGeneralHandsThatMatchFiveCardHand(state, payload);
  },
  removeFiveCardHandHighlights: function removeFiveCardHandHighlights(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removeFiveCardHandHighlights(state, payload);
  },

  // controls
  setPresetHoleCard: function setPresetHoleCard(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setPresetHoleCard(state, payload);
  },
  removePresetHoleCard: function removePresetHoleCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetHoleCard(state, position, true);
  },
  setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(state, payload) {
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function setBoard(state, boardCards) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setBoard(state, boardCards, true);
  },
  removePresetCommunityCard: function removePresetCommunityCard(state, position) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePresetCommunityCard(state, position, true);
  },
  addPlayer: function addPlayer(state, payload) {
    payload = payload || {};
    payload.shortDeck = true;
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].addPlayer(state, payload);
    state.players.last.adjustForShortDeck();
  },
  removePlayer: function removePlayer(state, playerIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].removePlayer(state, playerIndex);
  },

  // five card hands section checkboxes
  setCheckedValueOfFiveCardHand: function setCheckedValueOfFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setCheckedValueOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newCheckedValue: payload.newCheckedValue
    });

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallySetHandsThatPassThroughFilter(state, {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        fiveCardHandId: payload.fiveCardHandId,
        shortDeck: true
      });
    }
  },
  applyExactWeightToFiveCardHand: function applyExactWeightToFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].applyExactWeightToFiveCardHand(state, payload);
  },
  uncheckAllFiveCardHandsForGivenState: function uncheckAllFiveCardHandsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].uncheckAllFiveCardHandsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  checkAllFiveCardHandsForGivenState: function checkAllFiveCardHandsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].checkAllFiveCardHandsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  setChecksToDefaultsForGivenState: function setChecksToDefaultsForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setChecksToDefaultsForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  setChecksAccordingToUserDefinedFilterForGivenState: function setChecksAccordingToUserDefinedFilterForGivenState(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setChecksAccordingToUserDefinedFilterForGivenState(state, payload);

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyAddedHands(state, payload);
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallyRemovedHands(state, payload);
    }
  },
  setFiveCardHandValuesToDefaults: function setFiveCardHandValuesToDefaults(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setFiveCardHandValuesToDefaults(state, payload);
  },
  updateWeightOfFiveCardHand: function updateWeightOfFiveCardHand(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].updateWeightOfFiveCardHand(state, {
      fiveCardHand: state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.find(payload.fiveCardHandId),
      newWeight: payload.newWeight
    });

    if (state.presetCommunityCards.areAllCardsSet(payload.playerStateIndex)) {
      __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].clearManuallySetHandsThatPassThroughFilter(state, {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        fiveCardHandId: payload.fiveCardHandId,
        shortDeck: true
      });
    }
  },

  // five card hands section other
  toggleCollapsedValueOfFiveCardHandParent: function toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].toggleCollapsedValueOfFiveCardHandParent(state, fiveCardHandParent);
  },
  setProbabilitiesOfFiveCardHands: function setProbabilitiesOfFiveCardHands(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setProbabilitiesOfFiveCardHands(state, payload);
  },
  setHandAndDrawInfo: function setHandAndDrawInfo(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setHandAndDrawInfo(state, payload);
  },
  setHitPercentage: function setHitPercentage(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex]._hitPercentage = payload.hitPercentage;
  },
  setPercentagesOfSpecificHandsThatAreSelected: function setPercentagesOfSpecificHandsThatAreSelected(state, payload) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setPercentagesOfSpecificHandsThatAreSelected(state, payload);
  },

  // simulations
  setLastSimulationInfo: function setLastSimulationInfo(state, playerStateIndex) {
    __WEBPACK_IMPORTED_MODULE_4__store_service__["a" /* default */].setLastSimulationInfo(state, playerStateIndex);
  },
  setHitPercentageBeingComputed: function setHitPercentageBeingComputed(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].hitPercentageBeingComputed = payload.value;
  },
  updateEquityResults: function updateEquityResults(state, payload) {
    var equity = void 0;
    var wins = void 0;
    var ties = void 0;
    var winFractions = void 0;
    var numberOfSimulations = payload.numberOfSimulations;
    var playerStateIndex = payload.playerStateIndex;

    state.players.forEach(function (player, playerIndex) {
      wins = payload.simulationResults[playerIndex + 1].wins;
      ties = payload.simulationResults[playerIndex + 1].ties;
      winFractions = payload.simulationResults[playerIndex + 1].winFractions; // equity that comes from ties; ex. with 3 players, when it's a three way tie you'll get 1/3 win fractions, and when it's a two way tie you'll get 1/2 win fractions

      equity = (wins + winFractions) / numberOfSimulations * 100;
      equity -= equity * (payload.rakePercentage / 100) + equity * (payload.tipPercentage / 100);
      player.states[playerStateIndex].equity = equity.roundToTwoDecimalPlaces();
      player.states[playerStateIndex].winPercentage = wins / numberOfSimulations * 100;
      player.states[playerStateIndex].tiePercentage = ties / numberOfSimulations * 100;
    });
  },
  clearMatchingSpecificHands: function clearMatchingSpecificHands(state, payload) {
    state.players.find(payload.playerIndex).states[payload.playerStateIndex].fiveCardHands.clearMatchingSpecificHands();
  }
};

var actions = {
  setHitPercentage: function setHitPercentage(context, payload) {
    // doing this as an action rather than a mutation so that I could update the UI with "Computing hit percentage..."
    var hitPercentage = void 0;
    var hits = 0;
    var playerState = context.state.players.find(payload.playerIndex).states[payload.playerStateIndex];
    var weightOfLargestMatchingFiveCardHand = void 0;

    context.commit('setHitPercentageBeingComputed', {
      playerIndex: payload.playerIndex,
      playerStateIndex: payload.playerStateIndex,
      value: true
    });
    setTimeout(function () {
      // using setTimeout so UI updates
      playerState.handAndDrawInfo.forEach(function (_ref) {
        var handInfo = _ref.handInfo,
            drawInfo = _ref.drawInfo;

        weightOfLargestMatchingFiveCardHand = __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__["a" /* default */].results.getWeightOfLargestMatchingFiveCardHand(handInfo, drawInfo, playerState.fiveCardHands.checkedHands);
        hits += weightOfLargestMatchingFiveCardHand / 100;
      });
      hitPercentage = (hits / playerState.handAndDrawInfo.length * 100).roundToTwoDecimalPlaces();
      context.commit('setHitPercentage', {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        hitPercentage: hitPercentage
      });
      context.commit('setHitPercentageBeingComputed', {
        playerIndex: payload.playerIndex,
        playerStateIndex: payload.playerStateIndex,
        value: false
      });
    }, 100);
  }
};

function _getSavedScenarios() {
  if (localStorage.getItem('hitCalculatorSavedScenarios')) {
    return JSON.parse(localStorage.getItem('hitCalculatorSavedScenarios'));
  }

  return [];
}

/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ "rDiH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"grid-selector"},_vm._l((_vm.gridOfGeneralHands),function(rowOfGeneralHands){return _c('tr',_vm._l((rowOfGeneralHands),function(generalHand){return _c('grid-square',{key:generalHand.string,attrs:{"generalHand":generalHand,"clickAndDragContext":_vm.clickAndDragContext,"altKeyPressed":_vm.altKeyPressed,"disabled":_vm.disabled,"specificHandsNotAllowed":_vm.specificHandsNotAllowed,"equityMatrix":_vm.equityMatrix,"requiredEquity":_vm.requiredEquity,"rangeConstructor":_vm.rangeConstructor},on:{"selectGeneralHand":function($event){return _vm.selectGeneralHand($event)},"deselectGeneralHand":function($event){return _vm.deselectGeneralHand($event)},"selectAscendingGeneralHands":function($event){return _vm.selectAscendingGeneralHands($event)},"deselectAscendingGeneralHands":function($event){return _vm.deselectAscendingGeneralHands($event)},"selectSpecificHand":function($event){return _vm.$emit('selectSpecificHand', $event)},"deselectSpecificHand":function($event){return _vm.$emit('deselectSpecificHand', $event)},"setSpecificHandAsManuallySet":function($event){return _vm.$emit('setSpecificHandAsManuallySet', $event)},"setSpecificHandAsNotManuallySet":function($event){return _vm.$emit('setSpecificHandAsNotManuallySet', $event)},"applyExactWeightToGeneralHand":function($event){return _vm.$emit('applyExactWeightToGeneralHand', $event)},"setWeightOfSpecificHand":function($event){return _vm.$emit('setWeightOfSpecificHand', $event)}}})}),1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rEkw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_inputs_vue__ = __webpack_require__("50vp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568666b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breakeven_percentage_for_bluffing_the_turn_inputs_vue__ = __webpack_require__("5wz1");
function injectStyle (ssrContext) {
  __webpack_require__("ygTN")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-568666b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_breakeven_percentage_for_bluffing_the_turn_inputs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568666b6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_breakeven_percentage_for_bluffing_the_turn_inputs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rIA0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_horizontal_set_weight_to_apply_to_added_hands_basic_vue__ = __webpack_require__("4Gme");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19026072_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_horizontal_set_weight_to_apply_to_added_hands_basic_vue__ = __webpack_require__("zIRu");
function injectStyle (ssrContext) {
  __webpack_require__("+usQ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19026072"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_horizontal_set_weight_to_apply_to_added_hands_basic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19026072_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_horizontal_set_weight_to_apply_to_added_hands_basic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rT37":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_saved_scenarios__ = __webpack_require__("gXeV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ppt-account',
  components: {
    'saved-scenarios': __WEBPACK_IMPORTED_MODULE_0__components_user_saved_scenarios__["a" /* default */]
  },
  data: function data() {
    return {
      requestPending: false
    };
  },
  computed: {
    user: function user() {
      return this.$store.state.account.user;
    },
    daysLeftOnFreeTrial: function daysLeftOnFreeTrial() {
      return this.$store.getters['account/daysLeftOnFreeTrial'];
    },
    paid: function paid() {
      return this.$store.getters['account/paid'];
    },
    sso: function sso() {
      return this.user.googleId || this.user.twitterId || this.user.linkedinId;
    },
    unsubscribeFromEmailText: function unsubscribeFromEmailText() {
      if (this.requestPending === 'unsubscribe to email') {
        return 'Unsubscribing...';
      }

      return 'Unsubscribe';
    },
    subscribeToEmailText: function subscribeToEmailText() {
      if (this.requestPending === 'subscribe to email') {
        return 'Subscribing...';
      }

      return 'Subscribe';
    },
    deleteAccountText: function deleteAccountText() {
      if (this.requestPending === 'delete account') {
        return 'Deleting account...';
      }

      return 'Delete account';
    }
  },
  methods: {
    subscribeToEmail: function subscribeToEmail() {
      var self = this;

      self.requestPending = 'subscribe to email';
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/subscribe-to-email').then(function () {
        self.requestPending = false;
        self.$store.commit('account/subscribeToEmail');
        alert('Successfully subscribed!');
      }).catch(function () {
        self.requestPending = false;
        alert('Error. Unable to subscribe. Email contact@sixplusholdem.com for help.');
      });
    },
    unsubscribeFromEmail: function unsubscribeFromEmail() {
      var self = this;

      self.requestPending = 'unsubscribe to email';
      self.$http.patch("https://oddscalc.sixplusholdem.com/api" + '/user/unsubscribe-from-email').then(function () {
        self.requestPending = false;
        self.$store.commit('account/unsubscribeFromEmail');
        alert('Successfully unsubscribed.');
      }).catch(function () {
        self.requestPending = false;
        alert('Error. Unable to unsubscribe. Email contact@sixplusholdem.com for help.');
      });
    },
    deleteAccount: function deleteAccount() {
      var self = this;
      var areYouSure = this._checkIfUserIsSure();

      if (!areYouSure) {
        return;
      }

      self.requestPending = 'delete account';
      self.$http.delete("https://oddscalc.sixplusholdem.com/api" + '/user').then(function () {
        self.requestPending = false;
        self.$store.dispatch('account/clearUser');
        self.$router.push({ path: '/' });
        alert('Successfully deleted account.');
      }).catch(function () {
        self.requestPending = false;
        alert('Error. Unable to delete account. Email contact@sixplusholdem.com for help.');
      });
    },
    _checkIfUserIsSure: function _checkIfUserIsSure() {
      var confirmText = 'Are you sure you want to delete your account?';

      if (this.paid) {
        confirmText += ' Note: by deleting your account you will lose access to what you have paid for.';
      }

      return confirm(confirmText);
    }
  }
});

/***/ }),

/***/ "rbou":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_selector__ = __webpack_require__("G1lD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_equity_matrix_result_table__ = __webpack_require__("5ihg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-matrix-result-grid',
  components: {
    'grid-selector': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_selector__["a" /* default */],
    'result-table': __WEBPACK_IMPORTED_MODULE_1__components_equity_matrix_result_table__["a" /* default */]
  },
  props: ['generalHands', 'requiredEquity'],
  data: function data() {
    return {
      potOddsLHS: 1,
      potOddsRHS: 1
    };
  },
  watch: {
    potOddsLHS: function potOddsLHS() {
      this.setRequiredEquityBasedOnPotOdds();
    },
    potOddsRHS: function potOddsRHS() {
      this.setRequiredEquityBasedOnPotOdds();
    }
  },
  methods: {
    setRequiredEquityAfterManuallyChanged: function setRequiredEquityAfterManuallyChanged(requiredEquity) {
      var self = this;

      self.$emit('setRequiredEquity', requiredEquity);
      setTimeout(function () {
        self.setPotOddsBasedOnRequiredEquity();
      }, 50);
    },
    setRequiredEquityBasedOnPotOdds: function setRequiredEquityBasedOnPotOdds() {
      var risk = Number(this.potOddsRHS);
      var reward = Number(this.potOddsLHS);
      var requiredEquity = Math.round(risk / (risk + reward) * 100);

      this.$emit('setRequiredEquity', requiredEquity);
    },
    setPotOddsBasedOnRequiredEquity: function setPotOddsBasedOnRequiredEquity() {
      this.potOddsRHS = 1;
      this.potOddsLHS = (100 / this.requiredEquity - 1).roundToTwoDecimalPlaces();
    }
  }
});

/***/ }),

/***/ "rd0R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_inputs_vue__ = __webpack_require__("jZCj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20683a46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_bet_cbet_explorer_inputs_vue__ = __webpack_require__("fH14");
function injectStyle (ssrContext) {
  __webpack_require__("jeYv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20683a46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_inputs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20683a46_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_bet_cbet_explorer_inputs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rpE+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_five_card_hands_FiveCardHands__ = __webpack_require__("JKDa");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator-checkboxes-collapsed-by-default-settings',
  data: function data() {
    return {
      collapsedByDefault: __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.$store.state.account.user.settings.hitCalculator.collapsedByDefault),
      isHelpVisible: false
    };
  },
  computed: {
    madeHandParents: function madeHandParents() {
      var fiveCardHands = new __WEBPACK_IMPORTED_MODULE_1__services_five_card_hands_FiveCardHands__["a" /* default */]();

      return fiveCardHands.madeHands.flatArrayOfParents;
    },
    drawParents: function drawParents() {
      var fiveCardHands = new __WEBPACK_IMPORTED_MODULE_1__services_five_card_hands_FiveCardHands__["a" /* default */]();

      return fiveCardHands.draws.flatArrayOfParents;
    },
    comboParents: function comboParents() {
      var fiveCardHands = new __WEBPACK_IMPORTED_MODULE_1__services_five_card_hands_FiveCardHands__["a" /* default */]();

      return fiveCardHands.combos.flatArrayOfParents;
    }
  },
  methods: {
    save: function save() {
      var self = this;
      var user = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.cloneDeep(this.$store.state.account.user);

      user.settings.hitCalculator.collapsedByDefault = this.collapsedByDefault;
      self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    }
  }
});

/***/ }),

/***/ "rqiw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_should_you_bluff_help_vue__ = __webpack_require__("lCdj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108fc7ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_should_you_bluff_help_vue__ = __webpack_require__("O/F6");
function injectStyle (ssrContext) {
  __webpack_require__("+doo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-108fc7ad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_should_you_bluff_help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_108fc7ad_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_should_you_bluff_help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rs9h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rvTG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"turn-selector"},[_c('individual-card-selector',{ref:"flop1",attrs:{"cardString":_vm.presetCommunityCards.flop1,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop1')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop1')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"flop2",attrs:{"cardString":_vm.presetCommunityCards.flop2,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop2')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop2')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"flop3",attrs:{"cardString":_vm.presetCommunityCards.flop3,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop3')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop3')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"turn",attrs:{"cardString":_vm.presetCommunityCards.turn,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'turn')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'turn')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rw2A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rwHF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'breakeven-percentage-for-bluffing-the-turn-help'
});

/***/ }),

/***/ "ryF4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-help'
});

/***/ }),

/***/ "s/JT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "s3fm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'five-card-hands-section-alerts',
  props: ['textWhenFiveCardHandPercentagesArentUpToDate', 'areFiveCardHandPercentagesUpToDate']
});

/***/ }),

/***/ "sBy4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_turn_selector__ = __webpack_require__("SOcV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_bluff_size_selector__ = __webpack_require__("+rnN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_conclusions_fold_equity_table__ = __webpack_require__("zFKT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__ = __webpack_require__("unvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_bluff_help_range__ = __webpack_require__("PrIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-turn-steps',
  components: {
    'turn-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_turn_selector__["a" /* default */],
    'bluff-size-selector': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_bluff_size_selector__["a" /* default */],
    'fold-equity-table': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_conclusions_fold_equity_table__["a" /* default */],
    'set-range-step': __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__["a" /* default */],
    'range-help-section': __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_bluff_help_range__["a" /* default */]
  },
  props: ['state', 'textWhenFiveCardHandPercentagesArentUpToDate', 'authorized'],
  computed: {
    showFoldEquityTable: function showFoldEquityTable() {
      return this.state.players.numPlayers === 1 && this.state.players.find(0).states[2].hitPercentageForDifferentRanges.length > 0 && this.state.streetToBluff === 'turn' && this.state.presetCommunityCards.turnSet && !this.state.presetCommunityCards.pairedBoard;
    }
  },
  methods: {
    getTextForPlayerRangeStep: function getTextForPlayerRangeStep(playerIndex) {
      var numOpponents = this.state.players.numPlayers;

      if (this.state.streetToBluff === 'turn') {
        if (numOpponents === 1) {
          return 'Step ' + (7 + numOpponents * 2 + playerIndex) + ': What do you think your opponent would continue with versus your ' + this.state.bluffSize + ' pot turn bluff?';
        } else {
          return 'Step ' + (7 + numOpponents * 2 + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + ' would continue with versus your ' + this.state.bluffSize + ' pot turn bluff?';
        }
      } else {
        if (numOpponents === 1) {
          return 'Step ' + (6 + numOpponents * 2 + playerIndex) + ': What do you think your opponents range is after the turn action is finished (eg. heading in to the river)?';
        } else {
          return 'Step ' + (6 + numOpponents * 2 + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is after the turn action is finished (eg. heading in to the river)?';
        }
      }
    }
  }
});

/***/ }),

/***/ "sJ/U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FiveCardHandLeaf = function () {
  function FiveCardHandLeaf(argsObj) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FiveCardHandLeaf);

    this.id = argsObj.id;
    this.text = argsObj.text;
    this.fullText = argsObj.fullText;
    this.inlineText = argsObj.inlineText;
    this.count = 0;
    this._probability = null;
    this._weight = 0;
    this.included = true;
    this.matchingSpecificHands = [];
    this.percentageOfSpecificHandsThatAreSelected = 0;
    this.isAHit = argsObj.isAHit;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FiveCardHandLeaf, [{
    key: 'getDefaultCheckedValue',
    value: function getDefaultCheckedValue(fiveCardHandsThatAreCheckedByDefault, playerStateName) {
      if (this.madeHandDrawOrCombo === 'made hand') {
        return fiveCardHandsThatAreCheckedByDefault.madeHands.includes(this.id);
      } else if (this.madeHandDrawOrCombo === 'draw' && playerStateName !== 'afterRiver') {
        return fiveCardHandsThatAreCheckedByDefault.draws.includes(this.id);
      } else if (this.madeHandDrawOrCombo === 'combo' && playerStateName !== 'afterRiver') {
        return fiveCardHandsThatAreCheckedByDefault.combos.includes(this.id);
      } else {
        return false;
      }
    }
  }, {
    key: 'setMatchingSpecificHands',
    value: function setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck) {
      this.matchingSpecificHands = [];
      generalHands.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.matchesFiveCardHand(this, presetCommunityCardsArray, shortDeck)) {
          this.matchingSpecificHands.push(specificHand.string);
        }
      }, this);
    }
  }, {
    key: 'setProbabilityAccordingToMatchingSpecificHands',
    value: function setProbabilityAccordingToMatchingSpecificHands(generalHands) {
      var numberOfPossibleSpecificHands = generalHands.numberOfPossibleSpecificHands;
      var numberOfMatchingSpecificHands = 0;
      var currSpecificHand = void 0;

      this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
        currSpecificHand = generalHands.find(matchingSpecificHandString);
        numberOfMatchingSpecificHands += currSpecificHand.maxPossibleWeight / 100;
      });

      this._probability = numberOfMatchingSpecificHands / numberOfPossibleSpecificHands * 100;
    }
  }, {
    key: 'getNumCombos',
    value: function getNumCombos(numberOfPossibleSpecificHands) {
      return (this.probability / 100 * numberOfPossibleSpecificHands).roundToOneDecimalPlace();
    }
  }, {
    key: 'setPercentageOfSpecificHandsThatAreSelected',
    value: function setPercentageOfSpecificHandsThatAreSelected(generalHands) {
      var checked = this._weight > 0; // small hack to get around issue where you can't check the checked property before it's visible

      if (this.matchingSpecificHands.length === 0) {
        if (checked) {
          return 100;
        } else {
          return 0;
        }
      }

      this.percentageOfSpecificHandsThatAreSelected = this._getWeightedNumSpecificHandsThatAreSelected(generalHands) / this._getWeightedNumSpecificHandsThatArePossible(generalHands) * 100;
    }
  }, {
    key: '_getWeightedNumSpecificHandsThatAreSelected',
    value: function _getWeightedNumSpecificHandsThatAreSelected(generalHands) {
      var currSpecificHand = void 0;
      var weightedNumSpecificHandsThatAreSelected = 0;

      this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
        currSpecificHand = generalHands.find(matchingSpecificHandString);

        if (currSpecificHand.possible) {
          weightedNumSpecificHandsThatAreSelected += currSpecificHand.weight;
        }
      });

      return weightedNumSpecificHandsThatAreSelected;
    }
  }, {
    key: '_getWeightedNumSpecificHandsThatArePossible',
    value: function _getWeightedNumSpecificHandsThatArePossible(generalHands) {
      var currSpecificHand = void 0;
      var weightedNumSpecificHandsThatAreSelected = 0;

      this.matchingSpecificHands.forEach(function (matchingSpecificHandString) {
        currSpecificHand = generalHands.find(matchingSpecificHandString);

        if (currSpecificHand.possible) {
          weightedNumSpecificHandsThatAreSelected += currSpecificHand.maxPossibleWeight;
        }
      });

      return weightedNumSpecificHandsThatAreSelected;
    }
  }, {
    key: 'visible',
    get: function get() {
      if (!this.included) {
        return false;
      }

      // would be null if a simulation hadn't been run yet
      if (this._probability === 0) {
        return false;
      }

      return true;
    }
  }, {
    key: 'checked',
    get: function get() {
      if (!this.visible) {
        throw new Error('Trying to get the checked value of a five card hand that isn\'t visible.');
      }

      return this.weight > 0;
    },
    set: function set(newCheckedValue) {
      if (!this.visible) {
        throw new Error('Trying to set the checked value of a five card hand that isn\'t visible.');
      }

      if (newCheckedValue === true) {
        this.weight = 100;
      } else {
        this.weight = 0;
      }
    }
  }, {
    key: 'probability',
    get: function get() {
      if (this._probability === null) {
        return 0;
      } else if (typeof this._probability !== 'number') {
        throw new Error('Invalid value of _probability.');
      }

      return this._probability.roundToTwoDecimalPlaces();
    }
  }, {
    key: 'weight',
    get: function get() {
      if (!this.visible) {
        throw new Error('Trying to get the weight of a five card hand that isn\'t visible.');
      }

      return this._weight;
    },
    set: function set(newWeight) {
      if (!this.visible) {
        throw new Error('Trying to set the weight of a five card hand that isn\'t visible.');
      }

      if (typeof newWeight !== 'number' || newWeight < 0 || newWeight > 100 || newWeight % 5 !== 0) {
        throw new Error('Invalid value of newWeight');
      }

      this._weight = newWeight;
    }
  }, {
    key: 'hasWeight',
    get: function get() {
      return this.visible && this.weight < 100 && this.weight > 0;
    }
  }, {
    key: 'hasExplicitWeight',
    get: function get() {
      // for FiveCardHandParents, this differs from hasWeight
      return this.visible && this.weight < 100 && this.weight > 0;
    }
  }]);

  return FiveCardHandLeaf;
}();

/* harmony default export */ __webpack_exports__["a"] = (FiveCardHandLeaf);
;

/***/ }),

/***/ "sNuG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_five_card_hand_bar_vue__ = __webpack_require__("kY7Y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01153d4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_five_card_hand_bar_vue__ = __webpack_require__("xxe8");
function injectStyle (ssrContext) {
  __webpack_require__("QD5b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01153d4a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_five_card_hand_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01153d4a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_five_card_hand_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sXJ1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sbUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"breakeven-percentage-for-bluffing-the-turn"},[(!_vm.authorized)?_c('readonly-alert'):_vm._e(),_vm._v(" "),(_vm.savedScenario)?_c('saved-scenario-alert',{attrs:{"title":_vm.savedScenario.title}}):_vm._e(),_vm._v(" "),_c('header',{staticClass:"page-header"},[_c('h1',[_vm._v("\n      Breakeven percentage for bluffing the turn\n      "),_c('router-link',{attrs:{"to":"/help/breakeven-percentage-for-bluffing-the-turn"}},[_c('img',{attrs:{"src":"/static/help.png","width":"50"}})])],1)]),_vm._v(" "),_c('section',{staticClass:"row"},[_c('section',{staticClass:"col-sm-6"},[_c('breakeven-percentage-for-bluffing-the-turn-inputs',{attrs:{"state":_vm.state,"authorized":_vm.authorized}}),_vm._v(" "),_c('section',{staticClass:"hidden-xs"},[_c('hr'),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
            method: 'createSharableTurnBluffBreakevenPercentageURL',
            state: _vm.state,
          })}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized},on:{"saveScenario":function($event){return _vm.$emit('saveScenario', {
            method: 'createSharableTurnBluffBreakevenPercentageURL',
            savedScenarioPropertyName: 'turnBluffBreakevenPercentage',
            state: _vm.state,
          })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
            method: '_constructTurnBluffBreakevenPercentageData',
            state: _vm.state,
          })}}})],1)],1),_vm._v(" "),_c('section',{staticClass:"col-sm-6"},[_c('p',{staticClass:"breakeven-percentage"},[_vm._v("Breakeven percentage: "+_vm._s(_vm.getBreakevenPercentageString(_vm.state, _vm.state.turnBetSize)))]),_vm._v(" "),_c('breakeven-percentage-for-bluffing-the-turn-graph',{attrs:{"chartData":_vm.chartData}}),_vm._v(" "),_c('breakeven-percentage-for-bluffing-the-turn-table',{attrs:{"breakevenPercentages":[
          _vm.getBreakevenPercentageString(_vm.state, _vm.state.turnBetSize),
          _vm.getBreakevenPercentageString(_vm.state, 33.3),
          _vm.getBreakevenPercentageString(_vm.state, 50),
          _vm.getBreakevenPercentageString(_vm.state, 66.6),
          _vm.getBreakevenPercentageString(_vm.state, 75),
          _vm.getBreakevenPercentageString(_vm.state, 100),
          _vm.getBreakevenPercentageString(_vm.state, 150),
          _vm.getBreakevenPercentageString(_vm.state, 200)
        ],"dropoffPercentages":[
          _vm.getDropoffPercentageString(_vm.state, _vm.state.turnBetSize),
          _vm.getDropoffPercentageString(_vm.state, 33.3),
          _vm.getDropoffPercentageString(_vm.state, 50),
          _vm.getDropoffPercentageString(_vm.state, 66.6),
          _vm.getDropoffPercentageString(_vm.state, 75),
          _vm.getDropoffPercentageString(_vm.state, 100),
          _vm.getDropoffPercentageString(_vm.state, 150),
          _vm.getDropoffPercentageString(_vm.state, 200)
        ]}})],1)]),_vm._v(" "),_c('section',{staticClass:"visible-xs"},[_c('hr'),_vm._v(" "),_c('create-sharable-url-button',{attrs:{"disabled":!_vm.authorized},on:{"createSharableUrl":function($event){return _vm.$emit('createSharableUrl', {
        type: 'createSharableTurnBluffBreakevenPercentageURL',
        state: _vm.state,
      })}}}),_vm._v(" "),_c('save-scenario-button',{attrs:{"savedScenario":_vm.savedScenario,"disabled":!_vm.authorized},on:{"saveScenario":function($event){return _vm.$emit('saveScenario', {
        method: 'createSharableTurnBluffBreakevenPercentageURL',
        savedScenarioPropertyName: 'turnBluffBreakevenPercentage',
        state: _vm.state,
      })},"updateScenario":function($event){return _vm.$emit('updateScenario', {
        method: '_constructTurnBluffBreakevenPercentageData',
        state: _vm.state,
      })}}})],1),_vm._v(" "),_c('onboarding-modal',{attrs:{"toolName":"breakeven percentage for bluffing the turn tool","urlPath":"breakeven-percentage-for-bluffing-the-turn"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sdxh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"grid-square-suits",class:{ 'more-than-one': _vm.generalHand.numSpecificHandsInRange > 1 }},[(_vm.generalHand.numSpecificHandsInRange > 1 || _vm.numSpecificHandsInRangeVisbile)?_c('span',{staticClass:"more-than-one-text"},[_vm._v("\n    "+_vm._s(_vm.generalHand.numSpecificHandsInRange)+"\n  ")]):(_vm.suitsOfSpecificHandInRange === 'cc')?_c('span',[_vm._v("♣")]):(_vm.suitsOfSpecificHandInRange === 'ss')?_c('span',[_vm._v("♠")]):(_vm.suitsOfSpecificHandInRange === 'hh')?_c('span',{staticClass:"red"},[_vm._v("♥")]):(_vm.suitsOfSpecificHandInRange === 'dd')?_c('span',{staticClass:"red"},[_vm._v("♦")]):_c('span',[(_vm.firstSuitOfSpecificHandInRange === 'c')?_c('span',[_vm._v("♣")]):(_vm.firstSuitOfSpecificHandInRange === 's')?_c('span',[_vm._v("♠")]):(_vm.firstSuitOfSpecificHandInRange === 'h')?_c('span',{staticClass:"red"},[_vm._v("♥")]):(_vm.firstSuitOfSpecificHandInRange === 'd')?_c('span',{staticClass:"red"},[_vm._v("♦")]):_vm._e(),(_vm.secondSuitOfSpecificHandInRange === 'c')?_c('span',[_vm._v("♣")]):(_vm.secondSuitOfSpecificHandInRange === 's')?_c('span',[_vm._v("♠")]):(_vm.secondSuitOfSpecificHandInRange === 'h')?_c('span',{staticClass:"red"},[_vm._v("♥")]):(_vm.secondSuitOfSpecificHandInRange === 'd')?_c('span',{staticClass:"red"},[_vm._v("♦")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "shJE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "siI+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");




var FiveCardHandsCategory = function () {
  function FiveCardHandsCategory() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FiveCardHandsCategory);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FiveCardHandsCategory, [{
    key: 'forEachNode',
    value: function forEachNode(cb) {
      __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].general.forEachNode(this.data, cb);
    }
  }, {
    key: 'forEachLeaf',
    value: function forEachLeaf(cb) {
      __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].general.forEachLeaf(this.data, cb);
    }
  }, {
    key: 'forEachParent',
    value: function forEachParent(cb) {
      __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].general.forEachParent(this.data, cb);
    }
  }, {
    key: 'forEachVisibleLeaf',
    value: function forEachVisibleLeaf(cb) {
      this.forEachLeaf(function (leaf) {
        if (leaf.visible) {
          cb(leaf);
        }
      });
    }
  }, {
    key: 'forEachCheckedLeaf',
    value: function forEachCheckedLeaf(cb) {
      this.forEachLeaf(function (leaf) {
        if (leaf.visible && leaf.checked) {
          cb(leaf);
        }
      });
    }
  }, {
    key: 'setMatchingSpecificHands',
    value: function setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck) {
      this.forEachLeaf(function (fiveCardHandLeaf) {
        fiveCardHandLeaf.setMatchingSpecificHands(generalHands, presetCommunityCardsArray, shortDeck);
      });
    }
  }, {
    key: 'setBreadcrumbText',
    value: function setBreadcrumbText() {
      this._setBreadcrumbTextOnArray(this.data);
    }
  }, {
    key: '_setBreadcrumbTextOnArray',
    value: function _setBreadcrumbTextOnArray(array, parentBreadcrumbText) {
      array.forEach(function (node) {
        if (parentBreadcrumbText) {
          node.breadcrumbText = parentBreadcrumbText + ' | ' + node.text;
        } else {
          node.breadcrumbText = node.text;
        }

        if (node.children) {
          this._setBreadcrumbTextOnArray(node.children, node.breadcrumbText);
        }
      }, this);
    }
  }, {
    key: 'flatArrayOfLeaves',
    get: function get() {
      var flatArrayOfLeaves = [];

      this.forEachLeaf(function (leaf) {
        flatArrayOfLeaves.push(leaf);
      });

      return flatArrayOfLeaves;
    }
  }, {
    key: 'flatArrayOfParents',
    get: function get() {
      var flatArrayOfParents = [];

      this.forEachParent(function (leaf) {
        flatArrayOfParents.push(leaf);
      });

      return flatArrayOfParents;
    }
  }]);

  return FiveCardHandsCategory;
}();

/* harmony default export */ __webpack_exports__["a"] = (FiveCardHandsCategory);
;

/***/ }),

/***/ "so40":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_long_run_disclaimer_vue__ = __webpack_require__("7blJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f85b89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_long_run_disclaimer_vue__ = __webpack_require__("b96B");
function injectStyle (ssrContext) {
  __webpack_require__("rw2A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20f85b89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_long_run_disclaimer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f85b89_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_long_run_disclaimer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t/f8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"preset-community-cards-selector"},[_c('individual-card-selector',{ref:"flop1",attrs:{"cardString":_vm.presetCommunityCards.flop1,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop1')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop1')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"flop2",attrs:{"cardString":_vm.presetCommunityCards.flop2,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop2')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop2')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"flop3",attrs:{"cardString":_vm.presetCommunityCards.flop3,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop3')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop3')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"turn",attrs:{"cardString":_vm.presetCommunityCards.turn,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'turn')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'turn')}}}),_vm._v(" "),_c('individual-card-selector',{ref:"river",attrs:{"cardString":_vm.presetCommunityCards.river,"presetCards":_vm.presetCards,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'river')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'river')}}}),_vm._v(" "),_c('random-board-selector',{attrs:{"presetHoleCards":this.presetHoleCards.array,"popoverDirectionClass":_vm.popoverDirectionClass,"disabled":_vm.disabled},on:{"setBoard":function($event){return _vm.$emit('setBoard', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tCnF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_leaf_FiveCardHandLeaf__ = __webpack_require__("sJ/U");






var ComboLeaf = function (_FiveCardHandLeaf) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ComboLeaf, _FiveCardHandLeaf);

  function ComboLeaf(argsObj) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ComboLeaf);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ComboLeaf.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ComboLeaf)).call(this, argsObj));

    _this.madeHandDrawOrCombo = 'combo';
    return _this;
  }

  return ComboLeaf;
}(__WEBPACK_IMPORTED_MODULE_4__services_five_card_hands_five_card_hand_leaf_FiveCardHandLeaf__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ComboLeaf);
;

/***/ }),

/***/ "tEHc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{staticClass:"set-hand-weights-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Set hand weights")]),_vm._v(" "),_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default clear-selected-hands",on:{"click":function($event){return _vm.deselectAllGeneralHands()}}},[_c('span',{staticClass:"full-text"},[_vm._v("Clear selected hands")]),_vm._v(" "),_c('span',{staticClass:"partial-text"},[_vm._v("Clear")])])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[(_vm.generalHands)?_c('div',[(_vm.generalHands)?_c('grid-selector',{attrs:{"generalHands":_vm.generalHands,"specificHandsNotAllowed":true},on:{"selectGeneralHand":function($event){return _vm.selectGeneralHand($event.generalHandString)},"deselectGeneralHand":function($event){return _vm.deselectGeneralHand($event)},"selectGeneralHands":function($event){return _vm.selectGeneralHands($event)},"deselectGeneralHands":function($event){return _vm.deselectGeneralHands($event)}}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"slider-container"},[_c('span',[_vm._v("Weight:")]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"slider",staticClass:"hand-weight-to-apply",model:{value:(_vm.weightToApply),callback:function ($$v) {_vm.weightToApply=$$v},expression:"weightToApply"}},'vue-slider',_vm.sliderOptions,false))],1),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-block",on:{"click":function($event){return _vm.applyWeightToSelectedHands()}}},[_vm._v("\n        Apply weight to selected hands\n      ")])],1):_c('div',[_c('img',{attrs:{"src":"/static/loading.svg","width":"100"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "tKAZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoom_out_vue__ = __webpack_require__("htQj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6398d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoom_out_vue__ = __webpack_require__("gwng");
function injectStyle (ssrContext) {
  __webpack_require__("+UiU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b6398d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_zoom_out_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b6398d0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_zoom_out_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tQk4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tV7Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_combos_to_add_modal_vue__ = __webpack_require__("FQBA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc3a277_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_combos_to_add_modal_vue__ = __webpack_require__("p29W");
function injectStyle (ssrContext) {
  __webpack_require__("eThn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bc3a277"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_combos_to_add_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bc3a277_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_combos_to_add_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tfks":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_set_range_step__ = __webpack_require__("unvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_help_range__ = __webpack_require__("PrIL");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-preflop-steps',
  components: {
    'set-range-step': __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_set_range_step__["a" /* default */],
    'range-help-section': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_help_range__["a" /* default */]
  },
  props: ['players', 'presetCommunityCards', 'streetToBluff', 'authorized'],
  methods: {
    getTextForPlayerRangeStep: function getTextForPlayerRangeStep(playerIndex) {
      if (this.players.numPlayers === 1) {
        return 'Step ' + (4 + playerIndex) + ': What do you think your opponents range is after the preflop action is finished (eg. heading in to the flop)?';
      } else {
        return 'Step ' + (4 + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + '\'s range is after the preflop action is finished (eg. heading in to the flop)?';
      }
    },
    resetDoubleSlider: function resetDoubleSlider(playerIndex) {
      if (this.$refs['setRangeStep-' + playerIndex] && this.$refs['setRangeStep-' + playerIndex][0]) {
        this.$refs['setRangeStep-' + playerIndex][0].resetDoubleSlider(playerIndex);
      }
    },
    resetAllDoubleSliders: function resetAllDoubleSliders() {
      this.players.forEach(function (player, playerIndex) {
        this.resetDoubleSlider(playerIndex);
      }, this);
    }
  }
});

/***/ }),

/***/ "tgMT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tk+N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_preset_community_cards_selector__ = __webpack_require__("m4dX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_preset_community_cards_selector__ = __webpack_require__("/AJA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_controls_add_player_button__ = __webpack_require__("u5I9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_controls_create_sharable_url_button__ = __webpack_require__("zMC6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_controls_save_scenario_button__ = __webpack_require__("A/Yl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_controls_simulate_button__ = __webpack_require__("PQAu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_PresetHoleCards__ = __webpack_require__("oC4c");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-calculator-controls',
  components: {
    'preset-community-cards-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_preset_community_cards_selector__["a" /* default */],
    'short-deck-preset-community-cards-selector': __WEBPACK_IMPORTED_MODULE_1__components_short_deck_short_deck_preset_community_cards_selector__["a" /* default */],
    'add-player-button': __WEBPACK_IMPORTED_MODULE_2__components_controls_add_player_button__["a" /* default */],
    'create-sharable-url-button': __WEBPACK_IMPORTED_MODULE_3__components_controls_create_sharable_url_button__["a" /* default */],
    'save-scenario-button': __WEBPACK_IMPORTED_MODULE_4__components_controls_save_scenario_button__["a" /* default */],
    'simulate-button': __WEBPACK_IMPORTED_MODULE_5__components_controls_simulate_button__["a" /* default */]
  },
  props: ['presetCommunityCards', 'hasSimulationBeenRun', 'savedScenario', 'disabled', 'shortDeck', 'loggedIn'],
  data: function data() {
    return {
      presetHoleCards: new __WEBPACK_IMPORTED_MODULE_6__services_PresetHoleCards__["a" /* default */]()
    };
  }
});

/***/ }),

/***/ "twMY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slider_component__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vertical-set-weight-to-apply-to-added-hands-basic',
  components: {
    'vue-slider': __WEBPACK_IMPORTED_MODULE_0_vue_slider_component___default.a
  },
  props: ['weightToApplyToAddedHands', 'disabled', 'shortDeck'],
  data: function data() {
    var height = this.shortDeck ? 350 : 440;

    return {
      weightToApplyToAddedHandsVModel: this.weightToApplyToAddedHands,
      sliderOptions: {
        min: 5,
        interval: 5,
        width: 4,
        height: height,
        direction: 'vertical',
        tooltip: 'hover',
        tooltipDir: 'top',
        style: {
          'margin-right': '5px',
          'margin-left': '-10px'
        },
        sliderStyle: {
          cursor: 'ns-resize'
        }
      }
    };
  },
  watch: {
    weightToApplyToAddedHands: function weightToApplyToAddedHands(newVal) {
      this.weightToApplyToAddedHandsVModel = newVal;
    }
  },
  methods: {
    refreshVueSlider: function refreshVueSlider() {
      var self = this;

      setTimeout(function () {
        // needs a setTimeout for some reason
        self.$refs.vueSlider.refresh();
      }, 0);
    }
  }
});

/***/ }),

/***/ "tx6D":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u2Mx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u45b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"percentages-or-combos"},[_c('section',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default",class:{ active: _vm.percentagesOrCombos === 'percentages' },on:{"click":function($event){return _vm.$emit('toggle', 'percentages')}}},[_vm._v("\n      Percentages\n    ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",class:{ active: _vm.percentagesOrCombos === 'combos' },on:{"click":function($event){return _vm.$emit('toggle', 'combos')}}},[_vm._v("\n      Combos\n    ")])]),_vm._v(" "),(_vm.percentagesOrCombos === 'combos')?_c('section',{staticClass:"bg-warning"},[_vm._v("\n    "+_vm._s(_vm.numberOfSpecificHandsInRange.roundToOneDecimalPlace())+" / "+_vm._s(_vm.numberOfPossibleSpecificHands.roundToOneDecimalPlace())+" combos selected\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "u5I9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_player_button_vue__ = __webpack_require__("6/Xz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7fce5a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_player_button_vue__ = __webpack_require__("XZEy");
function injectStyle (ssrContext) {
  __webpack_require__("pTug")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a7fce5a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_player_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7fce5a6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_player_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uALk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"short-deck-turn-selector"},[_c('short-deck-individual-card-selector',{ref:"flop1",attrs:{"cardString":_vm.presetCommunityCards.flop1,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop1')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop1')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"flop2",attrs:{"cardString":_vm.presetCommunityCards.flop2,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop2')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop2')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"flop3",attrs:{"cardString":_vm.presetCommunityCards.flop3,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"hideDeselect":true,"disabled":true},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'flop3')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'flop3')}}}),_vm._v(" "),_c('short-deck-individual-card-selector',{ref:"turn",attrs:{"cardString":_vm.presetCommunityCards.turn,"presetCards":_vm.presetCards,"popoverDirectionClass":'dropdown',"disabled":_vm.disabled},on:{"select":function($event){return _vm.setIndividualPresetCommunityCard($event, 'turn')},"deselect":function($event){return _vm.$emit('removePresetCommunityCard', 'turn')}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uC4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_double_slider_selector_vue__ = __webpack_require__("BvQv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e22bc16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_double_slider_selector_vue__ = __webpack_require__("H1q8");
function injectStyle (ssrContext) {
  __webpack_require__("jv6P")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e22bc16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_double_slider_selector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e22bc16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_double_slider_selector_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uJvH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uWKX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "udlG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_hands_GeneralHand_js__ = __webpack_require__("ya+z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_text_get_text_from_general_hands_get_text_from_general_hands__ = __webpack_require__("X/Fc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_get_hand_info__ = __webpack_require__("2EOj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_simulator_get_info_from_combined_cards_set_specific_hand_info__ = __webpack_require__("XL0g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_modules_account_account__ = __webpack_require__("TmOh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash__);











var GeneralHands = function () {
  function GeneralHands() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GeneralHands);

    var orderedGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_8__services_constants__["a" /* default */].handRankings['ten-handed-evolutionary'];
    var generalHands = this._getGeneralHandsFromGeneralHandStrings(orderedGeneralHandStrings);

    this._data = generalHands;
    this.numberOfSpecificHandsInRange = 0;
    this.numberOfPossibleSpecificHands = 1326;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(GeneralHands, [{
    key: '_getGeneralHandsFromGeneralHandStrings',


    // constructor helpers
    value: function _getGeneralHandsFromGeneralHandStrings(generalHandStrings) {
      var generalHands = [];
      var generalHand = void 0;

      generalHandStrings.forEach(function (generalHandString) {
        generalHand = new __WEBPACK_IMPORTED_MODULE_2__services_hands_GeneralHand_js__["a" /* default */](generalHandString);
        generalHands.push(generalHand);
      });

      return generalHands;
    }
  }, {
    key: 'initializeAsBelongingToPlayerStateOtherThanFirstPlayerState',
    value: function initializeAsBelongingToPlayerStateOtherThanFirstPlayerState() {
      this.forEachSpecificHand(function (specificHand) {
        specificHand.manuallySet = false;
        specificHand.maxPossibleWeight = 0;
      });
      this.numberOfPossibleSpecificHands = 0;
    }
  }, {
    key: 'forEach',


    // iterators
    value: function forEach(cb, thisValue) {
      this._data.forEach(function (generalHand, index) {
        cb.call(thisValue, generalHand, index);
      });
    }
  }, {
    key: 'forEachPossibleGeneralHand',
    value: function forEachPossibleGeneralHand(cb) {
      this._data.forEach(function (generalHand) {
        if (generalHand.possible) {
          cb(generalHand);
        }
      });
    }
  }, {
    key: 'forEachGeneralHandInRange',
    value: function forEachGeneralHandInRange(cb) {
      this._data.forEach(function (generalHand) {
        if (generalHand.inRange) {
          cb(generalHand);
        }
      });
    }
  }, {
    key: 'forEachSpecificHand',
    value: function forEachSpecificHand(cb, thisValue) {
      this.forEach(function (generalHand) {
        generalHand.forEachSpecificHand(function (specificHand) {
          cb.call(thisValue, specificHand, specificHand.string);
        });
      });
    }
  }, {
    key: 'forEachPossibleSpecificHand',
    value: function forEachPossibleSpecificHand(cb, thisValue) {
      this.forEachSpecificHand(function (specificHand) {
        if (specificHand.possible) {
          cb.call(thisValue, specificHand);
        }
      });
    }
  }, {
    key: 'forEachSpecificHandInRange',
    value: function forEachSpecificHandInRange(cb, thisValue) {
      this.forEachSpecificHand(function (specificHand) {
        if (specificHand.possible && specificHand.inRange) {
          cb.call(thisValue, specificHand);
        }
      });
    }
  }, {
    key: 'forEachPossibleSpecificHandNotInRange',
    value: function forEachPossibleSpecificHandNotInRange(cb, thisValue) {
      this.forEachSpecificHand(function (specificHand) {
        if (specificHand.possible && !specificHand.inRange) {
          cb.call(thisValue, specificHand);
        }
      });
    }
  }, {
    key: 'find',


    // find
    value: function find(handString) {
      if (handString.length === 4) {
        return this._findSpecificHand(handString);
      } else if (handString.length === 3 || handString.length === 2) {
        return this._findGeneralHand(handString);
      } else {
        throw new Error('handString is invalid.');
      }
    }
  }, {
    key: '_findGeneralHand',
    value: function _findGeneralHand(generalHandString) {
      var index = __WEBPACK_IMPORTED_MODULE_8__services_constants__["a" /* default */].generalHandStringToIndexMap[generalHandString];

      if (index === undefined) {
        throw new Error('Unable to find a general hand.');
      }

      if (this._data[index].string !== generalHandString) {
        throw new Error('Found the wrong general hand.');
      }

      return this._data[index];
    }
  }, {
    key: '_findSpecificHand',
    value: function _findSpecificHand(specificHandString) {
      specificHandString = __WEBPACK_IMPORTED_MODULE_7__services_utilities_utilities__["a" /* default */].hands.getNormalizedSpecificHandString(specificHandString);
      var generalHand = this.__getGeneralHandFromSpecificHandString(specificHandString);
      var specificHands = generalHand.specificHands;

      for (var combo in specificHands) {
        if (specificHands.hasOwnProperty(combo)) {
          if (specificHands[combo].string === specificHandString) {
            return specificHands[combo];
          }
        }
      }

      throw new Error('Unable to find specific hand.');
    }
  }, {
    key: '__getGeneralHandFromSpecificHandString',
    value: function __getGeneralHandFromSpecificHandString(specificHandString) {
      if (specificHandString.length !== 4) {
        throw new Error('specificHandString is invalid.');
      }

      var generalHandString = __WEBPACK_IMPORTED_MODULE_7__services_utilities_utilities__["a" /* default */].hands.getGeneralHandStringFromSpecificHandString(specificHandString);

      return this._findGeneralHand(generalHandString);
    }
  }, {
    key: 'findByIndex',
    value: function findByIndex(index) {
      return this._data[index];
    }
  }, {
    key: 'clearManuallyAddedHands',


    // manually set
    value: function clearManuallyAddedHands() {
      this.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.manuallyAdded) {
          specificHand.manuallySet = false;
        }
      });
    }
  }, {
    key: 'clearManuallyRemovedHands',
    value: function clearManuallyRemovedHands() {
      this.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.manuallyRemoved) {
          specificHand.manuallySet = false;
        }
      });
    }
  }, {
    key: 'clearManuallySetHandsThatPassThroughFilter',
    value: function clearManuallySetHandsThatPassThroughFilter(fiveCardHand, presetCommunityCardsArray, shortDeck) {
      this.forEachPossibleSpecificHand(function (specificHand) {
        specificHand.clearManuallySetIfPassesThroughFilter(fiveCardHand, presetCommunityCardsArray, shortDeck);
      });
    }
  }, {
    key: '_constructArrayOfUsedHandWeights',
    value: function _constructArrayOfUsedHandWeights() {
      var usedHandWeights = [];

      this.forEachSpecificHandInRange(function (specificHand) {
        if (!usedHandWeights.includes(specificHand.weight)) {
          usedHandWeights.push(specificHand.weight);
        }
      });

      return usedHandWeights;
    }
  }, {
    key: '_getMaxUsedHandWeight',
    value: function _getMaxUsedHandWeight(usedHandWeights) {
      return Math.max.apply(null, usedHandWeights);
    }
  }, {
    key: '_getMaxNumberOfCopiesOfSpecificHandForWeightedRange',
    value: function _getMaxNumberOfCopiesOfSpecificHandForWeightedRange(usedHandWeights, maxUsedHandWeight) {
      if (usedHandWeights.length === 1) {
        return 1;
      }

      var gcdOfUsedHandWeights = this.__getGcdOfList(usedHandWeights);

      return maxUsedHandWeight / gcdOfUsedHandWeights;
    }
  }, {
    key: '__getGcdOfList',
    value: function __getGcdOfList(list) {
      return list.reduce(this.___getGcd);
    }
  }, {
    key: '___getGcd',
    value: function ___getGcd(a, b) {
      a = Math.abs(a);
      b = Math.abs(b);
      if (b > a) {
        var temp = a;a = b;b = temp;
      }
      while (true) {
        if (b == 0) return a;
        a %= b;
        if (a == 0) return b;
        b %= a;
      }
    }
  }, {
    key: 'getPercentOfSelectedRangeThatIsValue',


    // value to bluff ratio
    value: function getPercentOfSelectedRangeThatIsValue(idOfCutoffHand, communityCards) {
      var weightedNumberOfCombosThatAreValue = 0;
      var madeHandIds = ['fourOfAKindPlus:royalFlush', 'fourOfAKindPlus:straightFlush', 'fourOfAKindPlus:fourOfAKind', 'fullHouse', 'flush:nut', 'flush:secondNut', 'flush:thirdNut', 'flush:weak', 'straight', 'threeOfAKind:topSet', 'threeOfAKind:secondSet', 'threeOfAKind:thirdSet', 'threeOfAKind:fourthSet', 'threeOfAKind:middleSet', 'threeOfAKind:bottomSet', 'threeOfAKind:trips', 'twoPair:usingTopBoardCard', 'twoPair:weak', 'pair:overpair', 'pair:tptk', 'pair:tpgk', 'pair:tpwk', 'pair:ppUnderTp', 'pair:secondPair', 'pair:middlePair', 'pair:weakPair', 'highCard:aceHigh'];
      var holeCards = void 0;
      var handInfo = void 0;
      var isValueHand = void 0;

      this.forEachSpecificHandInRange(function (specificHand) {
        holeCards = [specificHand.firstCard, specificHand.secondCard];
        handInfo = __WEBPACK_IMPORTED_MODULE_4__services_simulator_get_info_from_combined_cards_get_hand_info__["a" /* default */].run(__WEBPACK_IMPORTED_MODULE_9_lodash___default.a.union(holeCards, communityCards));
        __WEBPACK_IMPORTED_MODULE_5__services_simulator_get_info_from_combined_cards_set_specific_hand_info__["a" /* default */].run(handInfo, holeCards, communityCards);
        isValueHand = madeHandIds.includes(handInfo.id) && madeHandIds.indexOf(handInfo.id) <= madeHandIds.indexOf(idOfCutoffHand);

        if (isValueHand) {
          weightedNumberOfCombosThatAreValue += specificHand.weight / 100;
        }
      });

      return (weightedNumberOfCombosThatAreValue / this.numberOfSpecificHandsInRange * 100).roundToTwoDecimalPlaces();
    }
  }, {
    key: 'highlightMatchingGeneralHands',


    // five card hand highlights
    value: function highlightMatchingGeneralHands(specificHandStrings) {
      this.forEachPossibleGeneralHand(function (generalHand) {
        generalHand.highlightIfMatchesSpecificHandStringList(specificHandStrings);
      });
    }
  }, {
    key: 'removeFiveCardHandHighlights',
    value: function removeFiveCardHandHighlights() {
      this.forEach(function (generalHand) {
        generalHand.matchesFiveCardHandHover = false;
      });
    }
  }, {
    key: 'adjustForShortDeck',


    // short deck
    value: function adjustForShortDeck() {
      this.forEachSpecificHand(function (specificHand) {
        if (specificHand.hasFiveFourThreeOrTwo) {
          this.numberOfPossibleSpecificHands -= specificHand.maxPossibleWeight / 100;
          specificHand.maxPossibleWeight = 0;
        }
      }, this);
    }
  }, {
    key: 'matchesOtherRange',


    // other
    value: function matchesOtherRange(otherGeneralHands, hack) {
      if (this._data.length !== 169 || otherGeneralHands._data.length !== 169) {
        throw new Error('One or more ranges are invalid.');
      }

      if ((this.numberOfSpecificHandsInRange >= 0.05 || otherGeneralHands.numberOfSpecificHandsInRange >= 0.05) && this.numberOfSpecificHandsInRange !== otherGeneralHands.numberOfSpecificHandsInRange) {
        return false;
      }

      if ((this.numberOfPossibleSpecificHands >= 0.05 || otherGeneralHands.numberOfPossibleSpecificHands >= 0.05) && this.numberOfPossibleSpecificHands !== otherGeneralHands.numberOfPossibleSpecificHands) {
        return false;
      }

      var specificHandOfThisRange = void 0;
      var specificHandOfOtherRange = void 0;

      // doing this as a hack because areFiveCardHandPercentagesUpToDate in RangeForStreet creates lag, and the downside is small
      if (!hack) {
        for (var i = 0; i < this._data.length; i++) {
          for (var specificHandSuits in this._data[i].specificHands) {
            specificHandOfThisRange = this.findByIndex(i).specificHands[specificHandSuits];
            specificHandOfOtherRange = otherGeneralHands.findByIndex(i).specificHands[specificHandSuits];

            if (specificHandOfThisRange._maxPossibleWeight !== specificHandOfOtherRange._maxPossibleWeight) {
              return false;
            }

            if (specificHandOfThisRange._weight !== specificHandOfOtherRange._weight) {
              return false;
            }

            if (specificHandOfThisRange._manuallySet !== specificHandOfOtherRange._manuallySet) {
              return false;
            }
          }
        }
      }

      return true;
    }
  }, {
    key: 'inRangeText',


    // text
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3__services_text_get_text_from_general_hands_get_text_from_general_hands__["a" /* default */].inRange(this);
    }
  }, {
    key: 'manuallyAddedText',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3__services_text_get_text_from_general_hands_get_text_from_general_hands__["a" /* default */].manuallyAdded(this);
    }
  }, {
    key: 'manuallyRemovedText',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3__services_text_get_text_from_general_hands_get_text_from_general_hands__["a" /* default */].manuallyRemoved(this);
    }
  }, {
    key: 'weightedRange',


    // weighted range
    get: function get() {
      var usedHandWeights = this._constructArrayOfUsedHandWeights();
      var maxUsedHandWeight = this._getMaxUsedHandWeight(usedHandWeights);
      var maxNumberOfCopiesOfSpecificHandForWeightedRange = this._getMaxNumberOfCopiesOfSpecificHandForWeightedRange(usedHandWeights, maxUsedHandWeight);
      var weightedRange = [];
      var numberOfCopiesOfSpecificHandForWeightedRange = void 0;

      this.forEachSpecificHandInRange(function (specificHand) {
        numberOfCopiesOfSpecificHandForWeightedRange = maxNumberOfCopiesOfSpecificHandForWeightedRange * (specificHand.weight / maxUsedHandWeight);
        __WEBPACK_IMPORTED_MODULE_9_lodash___default.a.times(numberOfCopiesOfSpecificHandForWeightedRange, function () {
          weightedRange.push([specificHand.firstCard, specificHand.secondCard]);
        });
      });

      return weightedRange;
    }
  }, {
    key: 'percentOfHandsInRangeNumberForDisplay',
    get: function get() {
      if (this.numberOfSpecificHandsInRange < 0.05) {
        return 0;
      }

      var exactPercentOfHandsInRange = this.numberOfSpecificHandsInRange / this.numberOfPossibleSpecificHands * 100;

      return exactPercentOfHandsInRange.roundToOneDecimalPlace();
    }
  }]);

  return GeneralHands;
}();

/* harmony default export */ __webpack_exports__["a"] = (GeneralHands);
;

/***/ }),

/***/ "uf/A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ul0I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checked_by_default_vue__ = __webpack_require__("CcOp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172b0bca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checked_by_default_vue__ = __webpack_require__("d4d/");
function injectStyle (ssrContext) {
  __webpack_require__("JIZ4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-172b0bca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checked_by_default_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172b0bca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_checked_by_default_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "unE3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__ = __webpack_require__("RBWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_controls_card_selection_random_board_selector__ = __webpack_require__("c/qk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flop-selector',
  components: {
    'individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__["a" /* default */],
    'random-board-selector': __WEBPACK_IMPORTED_MODULE_1__components_controls_card_selection_random_board_selector__["a" /* default */]
  },
  props: ['presetCommunityCards', 'presetHoleCards', 'popoverDirectionClass', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return _.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setIndividualPresetCommunityCard: function setIndividualPresetCommunityCard(payload, position) {
      this.$emit('setIndividualPresetCommunityCard', {
        card: payload.card,
        position: position
      });

      if (position !== 'flop3') {
        this._toggleNextDropdown(position);
        payload.e.stopPropagation();
      }
    },
    _toggleNextDropdown: function _toggleNextDropdown(previousPosition) {
      var nextPosition = this.__getNextPosition(previousPosition);

      this.$refs[nextPosition].toggle();
    },
    __getNextPosition: function __getNextPosition(previousPosition) {
      if (previousPosition === 'flop1') {
        return 'flop2';
      } else if (previousPosition === 'flop2') {
        return 'flop3';
      } else {
        throw new Error('Invalid value for previousPosition: ' + previousPosition);
      }
    }
  }
});

/***/ }),

/***/ "unvw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_set_range_step_vue__ = __webpack_require__("05oy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6433052_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_set_range_step_vue__ = __webpack_require__("aLd2");
function injectStyle (ssrContext) {
  __webpack_require__("b4c9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f6433052"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_set_range_step_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6433052_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_set_range_step_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uxqK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__ = __webpack_require__("Ywgb");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-new-password',
  components: {
    'errors-alert': __WEBPACK_IMPORTED_MODULE_0__components_utilities_errors_alert__["a" /* default */]
  },
  data: function data() {
    return {
      newPassword: '',
      xkcdVisible: false,
      submitAttempted: false,
      errorsFromBackend: []
    };
  },
  computed: {
    anyErrors: function anyErrors() {
      return !!this.newPasswordErrorMessage;
    },
    newPasswordErrorMessage: function newPasswordErrorMessage() {
      if (this.newPassword === '') {
        return 'A password is required';
      } else if (this.newPassword.length < 8) {
        return 'Must be at least eight characters';
      } else {
        return false;
      }
    }
  },
  methods: {
    changePassword: function changePassword() {
      var self = this;
      var token = this.$route.params.token;

      if (self.anyErrors) {
        self.submitAttempted = true;
        return;
      }

      self.$http.post("https://oddscalc.sixplusholdem.com/api" + '/user/reset-password/' + token, {
        newPassword: self.newPassword
      }).then(function (res) {
        alert('You have successfully reset your password.');
        self.$router.push({ path: '/sign-in' });
        localStorage.setItem('changedPasswordDate', new Date());
      }).catch(function (err) {
        self.errorsFromBackend.splice(0, self.errorsFromBackend.length);
        err.response.data.errors.forEach(function (errorFromBackend) {
          self.errorsFromBackend.push(errorFromBackend);
        });
      });
    },
    clearAlert: function clearAlert() {
      this.errorsFromBackend.splice(0, this.errorsFromBackend.length);
    }
  }
});

/***/ }),

/***/ "uySj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"create-new-password"},[_vm._m(0),_vm._v(" "),_c('errors-alert',{attrs:{"errors":_vm.errorsFromBackend},on:{"clear":function($event){return _vm.clearAlert()}}}),_vm._v(" "),_c('form',[_c('section',{staticClass:"form-group",class:{ 'has-error': (_vm.submitAttempted && _vm.newPasswordErrorMessage) }},[_c('label',{staticClass:"control-label"},[_vm._v("\n        New password\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newPassword),expression:"newPassword"}],staticClass:"form-control input-lg",attrs:{"required":"","type":"text"},domProps:{"value":(_vm.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newPassword=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v("\n        Must be at least eight characters "),(_vm.newPassword.length < 8)?_c('span',[_vm._v("ℹ️")]):_c('span',[_vm._v("✅")]),_vm._v(".\n        "),_c('span',{staticClass:"xkcd-toggle",on:{"click":function($event){$event.preventDefault();_vm.xkcdVisible = !_vm.xkcdVisible}}},[_vm._v("\n          Inspiration "),(!_vm.xkcdVisible)?_c('span',[_vm._v("▾")]):_c('span',[_vm._v("▴")])])]),_vm._v(" "),(_vm.submitAttempted && _vm.newPasswordErrorMessage)?_c('p',{staticClass:"help-block"},[_vm._v("\n        "+_vm._s(_vm.newPasswordErrorMessage)+"\n      ")]):_vm._e()]),_vm._v(" "),(_vm.xkcdVisible)?_c('img',{attrs:{"src":"/static/xkcd-password-strength.png"}}):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":function($event){$event.preventDefault();return _vm.changePassword()}}},[_vm._v("\n      Create new password\n    ")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Create new password")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v+YH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v5/C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"well should-you-bluff-reasoning-help-section-1 help-section"},[_c('p',[_vm._v("The overarching formula is "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(".")]),_vm._v(" "),_c('p',[_vm._v("Here's an example. If the pot is $2 and you want to try a 1/2 pot bluff, your bluff would be $1. You're risking $1 to win $2.")]),_vm._v(" "),_c('pre',[_vm._v("risk = $1\nreward = $2\nbreakeven percentage = risk / (risk + reward)\nbreakeven percentage = 1 / (1 + 2)\nbreakeven percentage = 1 / 3\nbreakeven percentage = 33.3%\n")]),_vm._v(" "),_c('p',[_vm._v("This formula actually isn't specific to poker at all. Suppose that the Steelers and Saints are in the Super Bowl and if you bet on the Steelers, the casino will give you $2 for every $1 you bet if you win, plus your money back. So if you bet $100, you'd get your $100 back, plus another $200. How often do you need to win this bet to break even? It's the same thing: "),_c('code',[_vm._v("risk / (risk + reward)")]),_vm._v(".")]),_vm._v(" "),_c('pre',[_vm._v("risk = $100\nreward = $200\nbreakeven percentage = risk / (risk + reward)\nbreakeven percentage = 100 / (100 + 200)\nbreakeven percentage = 100 / 300\nbreakeven percentage = 33.3%\n")]),_vm._v(" "),_c('p',[_vm._v("As a sanity check, ask yourself what happens if you win the bet once and lose it twice. First you win, and you're up $200. Then you lose, and you're up $100. Then you lose again, and you're even. When you win 33.3% of the time, you break even.")]),_vm._v(" "),_c('p',[_vm._v("And for those of you interested in the math, here is the derivation. We start off with "),_c('code',[_vm._v("(reward)(% success) = (risk)(1 - %success)")]),_vm._v(" because we're interested in knowing what "),_c('code',[_vm._v("% success")]),_vm._v(" leads to the risk balancing out the reward. From there it's just a little algebra.")]),_vm._v(" "),_c('pre',[_vm._v("(reward)(%success) = (risk)(1 - %success)\n(reward)(%success) = risk - (risk)(%success)\n(reward)(%success) + (risk)(%success) = risk\n%success(reward + risk) = risk\n%success = risk / (risk + reward)\n")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vAN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_square_modal_vue__ = __webpack_require__("Ks7W");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419f25d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_square_modal_vue__ = __webpack_require__("z1rl");
function injectStyle (ssrContext) {
  __webpack_require__("a6wH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-419f25d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grid_square_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419f25d4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grid_square_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vISl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-bluff-flop-steps"},[_c('div',[_c('h4',[_vm._v("Step "+_vm._s(4 + _vm.state.players.numPlayers)+": What are the flop cards?")]),_vm._v(" "),_c('flop-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)},"setBoard":function($event){return _vm.$emit('setBoard', $event)}}})],1),_vm._v(" "),(_vm.state.streetToBluff === 'flop')?_c('bluff-size-selector',{attrs:{"step":5 + _vm.state.players.numPlayers,"bluffSize":_vm.state.bluffSize,"authorized":_vm.authorized},on:{"setBluffSize":function($event){return _vm.$emit('setBluffSize', $event)}}}):_vm._e(),_vm._v(" "),(_vm.showFoldEquityTable)?_c('fold-equity-table',{attrs:{"state":_vm.state,"playerStateIndex":1,"immediatelyProfitableBreakevenPercentage":_vm.$store.getters['guidedAnalysesBluffing/immediatelyProfitableBreakevenPercentage']},on:{"setProfitableBreakevenPercentage":function($event){return _vm.$emit('setProfitableBreakevenPercentage', $event)}}}):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.flopSet)?_c('section',_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('set-range-step',{key:player.id,attrs:{"textForStep":_vm.getTextForPlayerRangeStep(playerIndex),"player":player,"playerIndex":playerIndex,"playerStateIndex":1,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"storeModuleName":'guidedAnalysesBluffing',"authorized":_vm.authorized}},[(_vm.state.streetToBluff === 'flop')?_c('flop-selector',{attrs:{"slot":"boardCardsSelector","presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)},"setBoard":function($event){return _vm.$emit('setBoard', $event)}},slot:"boardCardsSelector"}):_vm._e(),_vm._v(" "),_c('range-help-section',{attrs:{"slot":"rangeHelpSection","playerStateIndex":1,"streetToBluff":_vm.state.streetToBluff},slot:"rangeHelpSection"})],1)}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vUlo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vgNS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"togglable-section"},[_c('header-with-toggle',{attrs:{"title":_vm.title,"expanded":_vm.expanded},on:{"toggle":function($event){_vm.expanded = !_vm.expanded}}}),_vm._v(" "),(_vm.expanded)?_c('ul',{staticClass:"list-group"},[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vjYN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  ranks: ['a', 'k', 'q', 'j', 't', '9', '8', '7', '6', '5', '4', '3', '2'],
  suits: ['c', 's', 'h', 'd'],
  broadwayRanks: ['a', 'k', 'q', 'j', 't'],
  nonBroadwayRanks: ['9', '8', '7', '6', '5', '4', '3', '2'],
  coordinatedMiddleFlopRanks: ['987', '986', '976', '876', '875', '865', '765', '764', '754'],
  coordinatedSmallFlopRanks: ['654', '653', '643', '543', '542', '532', '432'],
  bingoFlopRanks: ['aaa', 'kkk', 'qqq', 'jjj', 'ttt', '999', '888', '777', '666', '555', '444', '333', '222'],
  combos: ['cc', 'cs', 'ch', 'cd', 'sc', 'ss', 'sh', 'sd', 'hc', 'hs', 'hh', 'hd', 'dc', 'ds', 'dh', 'dd'],
  handRankings: {
    // http://www.newsmth.net/bbsanc.php?path=/groups/sport.faq/Poker/pikeziliao/M.1288254660.S0&ap=641189
    'sklansky-chubukov': ['aa', 'kk', 'aks', 'qq', 'ako', 'jj', 'aqs', 'tt', 'aqo', '99', 'ajs', '88', 'ats', 'ajo', '77', '66', 'ato', 'a9s', '55', 'a8s', 'kqs', '44', 'a9o', 'a7s', 'kjs', 'a5s', 'a8o', 'a6s', 'a4s', '33', 'kts', 'a7o', 'a3s', 'kqo', 'a2s', 'a5o', 'a6o', 'a4o', 'kjo', 'qjs', 'a3o', '22', 'k9s', 'a2o', 'kto', 'qts', 'k8s', 'k7s', 'jts', 'k9o', 'k6s', 'qjo', 'q9s', 'k5s', 'k8o', 'k4s', 'qto', 'k7o', 'k3s', 'k2s', 'q8s', 'k6o', 'j9s', 'k5o', 'q9o', 'jto', 'k4o', 'q7s', 't9s', 'q6s', 'k3o', 'j8s', 'q5s', 'k2o', 'q8o', 'q4s', 'j9o', 'q3s', 't8s', 'j7s', 'q7o', 'q2s', 'q6o', '98s', 'q5o', 'j8o', 't9o', 'j6s', 't7s', 'j5s', 'q4o', 'j4s', 'j7o', 'q3o', '97s', 't8o', 'j3s', 't6s', 'q2o', 'j2s', '87s', 'j6o', '98o', 't7o', '96s', 'j5o', 't5s', 't4s', '86s', 'j4o', 't6o', '97o', 't3s', '76s', '95s', 'j3o', 't2s', '87o', '85s', '96o', 't5o', 'j2o', '75s', '94s', 't4o', '65s', '86o', '93s', '84s', '95o', 't3o', '76o', '92s', '74s', '54s', 't2o', '85o', '64s', '83s', '94o', '75o', '82s', '73s', '93o', '65o', '53s', '63s', '84o', '92o', '43s', '74o', '72s', '54o', '64o', '52s', '62s', '83o', '42s', '82o', '73o', '53o', '63o', '32s', '43o', '72o', '52o', '62o', '42o', '32o'],

    // https://www.tightpoker.com/poker_hands.html
    'expected-value': ['aa', 'kk', 'qq', 'jj', 'aks', 'aqs', 'tt', 'ako', 'ajs', 'kqs', '99', 'ats', 'aqo', 'kjs', '88', 'qjs', 'kts', 'a9s', 'ajo', 'qts', 'kqo', '77', 'jts', 'a8s', 'k9s', 'ato', 'a5s', 'a7s', 'kjo', '66', 't9s', 'a4s', 'q9s', 'j9s', 'qjo', 'a6s', '55', 'a3s', 'k8s', 'kto', '98s', 't8s', 'k7s', 'a2s', '87s', 'qto', 'q8s', '44', 'a9o', 'j8s', '76s', 'jto', '97s', 'k6s', 'k5s', 'k4s', 't7s', 'q7s', 'k9o', '65s', 't9o', '86s', 'a8o', 'j7s', '33', '54s', 'q6s', 'k3s', 'q9o', '75s', '22', 'j9o', '64s', 'q5s', 'k2s', '96s', 'q3s', 'j8o', '98o', 't8o', '97o', 'a7o', 't7o', 'q4s', 'q8o', 'j5s', 't6o', '75o', 'j4s', '74s', 'k8o', '86o', '53s', 'k7o', '63s', 'j6s', '85o', 't6s', '76o', 'a6o', 't2o', '95s', '84o', '62o', 't5s', '95o', 'a5o', 'q7o', 't5o', '87o', '83o', '65o', 'q2s', '94o', '74o', '54o', 'a4o', 't4o', '82o', '64o', '42o', 'j7o', '93o', '85s', '73o', '53o', 't3o', '63o', 'k6o', 'j6o', '96o', '92o', '72o', '52o', 'q4o', 'k5o', 'j5o', '43s', 'q3o', '43o', 'k4o', 'j4o', 't4s', 'q6o', 'q2o', 'j3s', 'j3o', 't3s', 'a3o', 'q5o', 'j2o', '84s', '82s', '42s', '93s', '73s', 'k3o', 'j2s', '92s', '52s', 'k2o', 't2s', '62s', '32o', 'a2o', '83s', '94s', '72s', '32s'],

    // https://www.gamblingsites.org/poker/texas-holdem/starting-hand-rankings/
    'all-in-9-handed': ['aa', 'kk', 'qq', 'aks', 'jj', 'aqs', 'kqs', 'ajs', 'kjs', 'tt', 'ako', 'ats', 'qjs', 'kts', 'qts', 'jts', '99', 'aqo', 'a9s', 'kqo', '88', 'k9s', 't9s', 'a8s', 'q9s', 'j9s', 'ajo', 'a5s', '77', 'a7s', 'kjo', 'a4s', 'a3s', 'a6s', 'qjo', '66', 'k8s', 't8s', 'a2s', '98s', 'j8s', 'ato', 'q8s', 'k7s', 'kto', '55', 'jto', '87s', 'qto', '44', '33', '22', 'k6s', '97s', 'k5s', '76s', 't7s', 'k4s', 'k3s', 'k2s', 'q7s', '86s', '65s', 'j7s', '54s', 'q6s', '75s', '96s', 'q5s', '64s', 'q4s', 'q3s', 't9o', 't6s', 'q2s', 'a9o', '53s', '85s', 'j6s', 'j9o', 'k9o', 'j5s', 'q9o', '43s', '74s', 'j4s', 'j3s', '95s', 'j2s', '63s', 'a8o', '52s', 't5s', '84s', 't4s', 't3s', '42s', 't2s', '98o', 't8o', 'a5o', 'a7o', '73s', 'a4o', '32s', '94s', '93s', 'j8o', 'a3o', '62s', '92s', 'k8o', 'a6o', '87o', 'q8o', '83s', 'a2o', '82s', '97o', '72s', '76o', 'k7o', '65o', 't7o', 'k6o', '86o', '54o', 'k5o', 'j7o', '75o', 'q7o', 'k4o', 'k3o', '96o', 'k2o', '64o', 'q6o', '53o', '85o', 't6o', 'q5o', '43o', 'q4o', 'q3o', '74o', 'q2o', 'j6o', '63o', 'j5o', '95o', '52o', 'j4o', 'j3o', '42o', 'j2o', '84o', 't5o', 't4o', '32o', 't3o', '73o', 't2o', '62o', '94o', '93o', '92o', '83o', '82o', '72o'],

    // https://wizardofodds.com/games/texas-hold-em/3-player-game/
    'all-in-3-handed': ['aa', 'kk', 'qq', 'jj', 'tt', '99', 'aks', '88', 'aqs', 'ako', 'ajs', 'kqs', 'ats', 'aqo', '77', 'kjs', 'ajo', 'kts', 'a9s', 'kqo', 'ato', 'qjs', 'a8s', '66', 'qts', 'kjo', 'a7s', 'k9s', 'jts', 'kto', 'a9o', 'a5s', 'qjo', 'a6s', 'q9s', 'a4s', 'a8o', 'qto', 'k8s', '55', 'a3s', 'j9s', 'k7s', 'a7o', 'k9o', 'jto', 'a2s', 't9s', 'q8s', 'k6s', 'a5o', 'a6o', 'q9o', 'k5s', 'j8s', 'a4o', 'k8o', '44', 't8s', 'k4s', 'q7s', 'j9o', 'a3o', 'k7o', '98s', 'q6s', 'k3s', 't9o', 'j7s', 'q8o', 'a2o', 'k6o', 'k2s', 'q5s', 't7s', 'j8o', '97s', 'q4s', 'k5o', '87s', '33', 't8o', 'j6s', 'q3s', 'q7o', 'k4o', 'j5s', '98o', 't6s', 'q2s', 'q6o', '96s', 'k3o', '86s', 'j7o', '76s', 'j4s', 'q5o', 't7o', 'k2o', 'j3s', 't5s', '97o', '22', '87o', 'q4o', 'j2s', '65s', '95s', 't4s', '75s', '85s', 'j6o', 'q3o', 't3s', 't6o', 'j5o', '54s', 't2s', 'q2o', '96o', '64s', '86o', '76o', '94s', '74s', 'j4o', '84s', '93s', 'j3o', '53s', 't5o', '92s', '65o', '63s', '95o', 'j2o', '75o', 't4o', '43s', '85o', '73s', '83s', '82s', 't3o', '52s', '54o', '62s', '64o', 't2o', '42s', '72s', '94o', '74o', '84o', '93o', '32s', '53o', '92o', '63o', '43o', '73o', '83o', '82o', '52o', '62o', '42o', '72o', '32o'],

    // http://www.propokertools.com/orderings/hevsrandomordering.txt
    'all-in-heads-up': ['aa', 'kk', 'qq', 'jj', 'tt', '99', '88', 'aks', '77', 'aqs', 'ajs', 'ako', 'ats', 'aqo', 'ajo', 'kqs', '66', 'a9s', 'ato', 'kjs', 'a8s', 'kts', 'kqo', 'a7s', 'a9o', 'kjo', '55', 'qjs', 'k9s', 'a5s', 'a6s', 'a8o', 'kto', 'qts', 'a4s', 'a7o', 'k8s', 'a3s', 'qjo', 'k9o', 'a5o', 'a6o', 'q9s', 'k7s', 'jts', 'a2s', 'qto', '44', 'a4o', 'k6s', 'k8o', 'q8s', 'a3o', 'k5s', 'j9s', 'q9o', 'jto', 'k7o', 'a2o', 'k4s', 'q7s', 'k6o', 'k3s', 't9s', 'j8s', '33', 'q6s', 'q8o', 'k5o', 'j9o', 'k2s', 'q5s', 't8s', 'k4o', 'j7s', 'q4s', 'q7o', 't9o', 'j8o', 'k3o', 'q6o', 'q3s', '98s', 't7s', 'j6s', 'k2o', '22', 'q2s', 'q5o', 'j5s', 't8o', 'j7o', 'q4o', '97s', 'j4s', 't6s', 'j3s', 'q3o', '98o', '87s', 't7o', 'j6o', '96s', 'j2s', 'q2o', 't5s', 'j5o', 't4s', '97o', '86s', 'j4o', 't6o', '95s', 't3s', '76s', 'j3o', '87o', 't2s', '85s', '96o', 'j2o', 't5o', '94s', '75s', 't4o', '93s', '86o', '65s', '84s', '95o', 't3o', '92s', '76o', '74s', 't2o', '54s', '85o', '64s', '83s', '94o', '75o', '82s', '73s', '93o', '65o', '53s', '63s', '84o', '92o', '43s', '74o', '72s', '54o', '64o', '52s', '62s', '83o', '42s', '82o', '73o', '53o', '63o', '32s', '43o', '72o', '52o', '62o', '42o', '32o'],

    // http://www.propokertools.com/orderings/heordering.txt
    'ten-handed-evolutionary': ['aa', 'kk', 'qq', 'jj', 'aks', 'tt', 'ako', 'aqs', '99', 'ajs', 'aqo', '88', 'ats', 'kqs', 'ajo', '77', 'kjs', 'qjs', 'kts', 'kqo', 'a9s', 'ato', '66', 'a8s', 'qts', 'jts', 'kjo', 'a7s', 'a5s', 'k9s', 'a4s', 'a6s', '55', 'q9s', 'a3s', 'j9s', 'kto', 'qjo', 'a9o', 't9s', 'k8s', 'a2s', 'k7s', '44', 'a8o', 'qto', 'q8s', 'jto', 'j8s', 'k6s', '98s', 't8s', 'k5s', 'a7o', 'k4s', 'k9o', 'a5o', '33', 'k3s', 'a4o', 'q9o', '87s', 'q7s', 't7s', 'q6s', 'k2s', 'j7s', 'a6o', '97s', 'q5s', 'a3o', 'j9o', 't9o', '22', 'k8o', 'a2o', 'q4s', '76s', 'k7o', '86s', '96s', 'j6s', 'j5s', 'k6o', 'q3s', 'q2s', 't6s', '65s', 'k5o', '75s', 'q8o', '54s', 'j8o', 'j4s', 't8o', '98o', '85s', '95s', 'k4o', 'j3s', '64s', 't4s', 't5s', '87o', 'q7o', 'k3o', 'j2s', '74s', '97o', 'j7o', '53s', 'q6o', 't3s', 'k2o', '94s', 't7o', '84s', '43s', '63s', 'q5o', '86o', 't2s', '93s', '76o', 'q4o', '92s', '96o', '73s', 'j6o', 'q3o', '52s', '65o', 'j5o', 't6o', '82s', '42s', '83s', 'q2o', '75o', '54o', 'j4o', '62s', '85o', '32s', '95o', '72s', 'j3o', 't5o', 't4o', '64o', 'j2o', '53o', '74o', '84o', 't3o', '43o', '94o', 't2o', '93o', '63o', '92o', '73o', '52o', '42o', '83o', '82o', '62o', '32o', '72o'],

    // http://www.propokertools.com/orderings/he6maxordering.txt
    'six-handed-evolutionary': ['aa', 'kk', 'qq', 'jj', 'tt', 'aks', 'ako', 'aqs', '99', 'ajs', 'aqo', '88', 'ats', 'ajo', 'kqs', '77', 'kjs', 'ato', 'kqo', 'a9s', 'kts', '66', 'a8s', 'qjs', 'a7s', 'kjo', 'qts', 'a5s', 'a9o', 'a6s', 'jts', '55', 'k9s', 'a4s', 'kto', 'a3s', 'a8o', 'qjo', 'q9s', 'a2s', 'k8s', 'j9s', '44', 'k7s', 't9s', 'qto', 'a7o', 'k6s', 'a5o', 'jto', 'q8s', 'k9o', 'a6o', 'k5s', 'j8s', 't8s', 'a4o', '33', '98s', 'k4s', 'a3o', 'q7s', 'q6s', 'q9o', 'k3s', 'k2s', 'a2o', 'j7s', 'k8o', 'j9o', 't7s', '87s', 't9o', 'q5s', '97s', 'k7o', '22', 'q4s', 'k6o', 'j6s', 'q8o', '86s', '76s', 't6s', 'q3s', 'k5o', '96s', 'j8o', 'j5s', 't8o', 'q2s', '98o', 'k4o', '65s', 'j4s', 'q7o', '75s', 'q6o', 'j3s', 'k3o', 'j7o', '95s', '85s', 't5s', 't7o', 'k2o', '87o', '54s', 'j2s', '97o', 'q5o', 't4s', '64s', 't3s', '74s', 'q4o', '76o', 'j6o', '84s', 't2s', '94s', 't6o', '53s', 'q3o', '86o', 'j5o', '93s', '96o', 'q2o', '63s', '92s', '65o', '43s', 'j4o', '73s', '75o', '83s', '52s', 'j3o', '85o', 't5o', '82s', '95o', '54o', 'j2o', '42s', 't4o', '62s', '64o', '72s', '32s', 't3o', '74o', '84o', 't2o', '53o', '94o', '93o', '43o', '63o', '92o', '73o', '83o', '52o', '82o', '42o', '62o', '72o', '32o'],

    // http://www.propokertools.com/orderings/he3maxordering.txt
    'three-handed-evolutionary': ['aa', 'kk', 'qq', 'jj', 'tt', '99', 'aks', 'aqs', '88', 'ako', 'ajs', 'aqo', 'ats', '77', 'ajo', 'kqs', 'ato', 'a9s', 'kjs', '66', 'a8s', 'kts', 'kqo', 'a7s', 'a9o', 'qjs', 'kjo', 'a6s', 'a5s', 'a8o', '55', 'qts', 'k9s', 'kto', 'a4s', 'a7o', 'jts', 'qjo', 'a3s', 'a2s', 'k8s', 'q9s', 'a5o', 'qto', 'a6o', '44', 'k9o', 'k7s', 'j9s', 'a4o', 'k6s', 'jto', 'a3o', 'q8s', 't9s', 'k5s', 'k8o', 'q9o', 'a2o', 'k4s', 'j8s', '33', 'k7o', 'q7s', 't8s', 'k3s', 'j9o', 'q6s', 'k6o', 'q8o', 'k2s', 't9o', '98s', 'q5s', 'j7s', 'k5o', 'q4s', 't7s', 'j8o', 'k4o', '97s', '22', 'j6s', 'q7o', 'j5s', 'q3s', '87s', 't8o', 'k3o', 't6s', 'q6o', 'q2s', '98o', 'j4s', 'k2o', 'j7o', 'q5o', '96s', 'j3s', '86s', '76s', 't7o', 'q4o', 't5s', 'j2s', '97o', 'j6o', 't4s', '95s', 'q3o', '87o', '85s', 'j5o', 't3s', '65s', '75s', 't6o', 'q2o', 't2s', 'j4o', '96o', '54s', '94s', '86o', 'j3o', '84s', '76o', '74s', '64s', '93s', 't5o', '92s', 'j2o', 't4o', '95o', '53s', '85o', '75o', 't3o', '73s', '65o', '63s', '83s', '82s', '43s', 't2o', '54o', '94o', '52s', '84o', '64o', '72s', '62s', '74o', '93o', '42s', '92o', '32s', '53o', '83o', '63o', '73o', '82o', '43o', '52o', '62o', '72o', '42o', '32o'],

    // http://www.propokertools.com/orderings/heequitysquaredordering.txt
    'heads-up-equity-squared': ['aa', 'kk', 'qq', 'jj', 'tt', '99', 'aks', '88', 'aqs', 'ako', 'ajs', 'ats', 'kqs', 'aqo', '77', 'kjs', 'ajo', 'kts', 'a9s', 'kqo', 'ato', 'qjs', 'a8s', '66', 'kjo', 'qts', 'a7s', 'k9s', 'kto', 'jts', 'a9o', 'a5s', 'qjo', 'a6s', 'q9s', 'a4s', 'a8o', '55', 'qto', 'k8s', 'a3s', 'j9s', 'a7o', 'k7s', 'k9o', 'jto', 'a2s', 't9s', 'q8s', 'k6s', 'a5o', 'a6o', 'q9o', 'k5s', 'j8s', 'a4o', 'k8o', '44', 't8s', 'k4s', 'q7s', 'a3o', 'j9o', 'k7o', '98s', 'k3s', 'q6s', 't9o', 'a2o', 'j7s', 'q8o', 'k6o', 'k2s', 'q5s', 't7s', 'j8o', 'q4s', 'k5o', '97s', '33', '87s', 't8o', 'j6s', 'q3s', 'q7o', 'k4o', 'j5s', '98o', 't6s', 'q2s', 'q6o', 'k3o', '96s', 'j7o', 'j4s', '86s', '76s', 'q5o', 'k2o', 't7o', 'j3s', '22', 't5s', '97o', 'q4o', 'j2s', '87o', '95s', 't4s', '65s', '75s', '85s', 'j6o', 'q3o', 't3s', 'j5o', 't6o', '54s', 'q2o', 't2s', '96o', '64s', '86o', '76o', '94s', 'j4o', '74s', '84s', '93s', 'j3o', '53s', 't5o', '92s', '65o', '63s', 'j2o', '95o', 't4o', '75o', '85o', '73s', '43s', '83s', '82s', 't3o', '52s', '54o', 't2o', '62s', '64o', '42s', '94o', '72s', '74o', '84o', '93o', '32s', '53o', '92o', '63o', '43o', '73o', '83o', '82o', '52o', '62o', '42o', '72o', '32o'],

    'short-deck-all-in-5-handed': ['aa', 'kk', 'qq', 'jts', 'jj', 'aks', 'qjs', 'kqs', 'qts', 'kjs', 'aqs', 'jto', 'tt', 'kts', 'ajs', 'ako', 'qjo', 'kqo', 't9s', 'ats', 'qto', 'kjo', 'aqo', 'kto', 'ajo', 'j9s', '99', 't9o', 'ato', 'a9s', 't8s', 'q9s', '98s', 'a8s', 'k9s', '88', 'j9o', 'j8s', 'a7s', '97s', 't8o', 'a9o', 't7s', '77', 'q8s', 'q9o', '98o', 'a6s', 'k8s', 'a8o', 'k9o', '87s', 'j7s', '66', 'k7s', 'j8o', '96s', 't6s', 'a7o', 'q7s', 'k6s', 't7o', '97o', 'q8o', '86s', 'q6s', 'j6s', 'k8o', 'a6o', 'j7o', '87o', '76s', 'k7o', '96o', 't6o', 'q7o', 'k6o', '86o', 'q6o', 'j6o', '76o'],

    'short-deck-all-in-heads-up': ['aa', 'kk', 'qq', 'jj', 'tt', 'aks', 'aqs', 'ako', 'ajs', 'kqs', 'aqo', 'ajo', 'ats', 'kjs', 'qjs', 'kts', 'kqo', 'qts', 'jts', '99', 'ato', 'kjo', 'qjo', 'a9s', 'kto', 'jto', 'qto', 'a8s', 'a9o', 'k9s', 'a8o', 't9s', 'q9s', 'a7s', 'j9s', 'k9o', 't9o', 'q9o', 'j9o', '88', 'a7o', 'a6s', 'k8s', '98s', 't8s', 'q8s', 'j8s', 'k7s', 'a6o', 'k8o', 't8o', '98o', 'q8o', 'j8o', 'k7o', 'k6s', '97s', 't7s', 'q7s', 'j7s', '77', 'q6s', 'k6o', '97o', 't7o', 'q7o', '87s', 'j7o', '96s', 'q6o', 't6s', 'j6s', '87o', '96o', '86s', 't6o', 'j6o', '66', '86o', '76s', '76o']
  },
  gridOfGeneralHandStrings: [['aa', 'aks', 'aqs', 'ajs', 'ats', 'a9s', 'a8s', 'a7s', 'a6s', 'a5s', 'a4s', 'a3s', 'a2s'], ['ako', 'kk', 'kqs', 'kjs', 'kts', 'k9s', 'k8s', 'k7s', 'k6s', 'k5s', 'k4s', 'k3s', 'k2s'], ['aqo', 'kqo', 'qq', 'qjs', 'qts', 'q9s', 'q8s', 'q7s', 'q6s', 'q5s', 'q4s', 'q3s', 'q2s'], ['ajo', 'kjo', 'qjo', 'jj', 'jts', 'j9s', 'j8s', 'j7s', 'j6s', 'j5s', 'j4s', 'j3s', 'j2s'], ['ato', 'kto', 'qto', 'jto', 'tt', 't9s', 't8s', 't7s', 't6s', 't5s', 't4s', 't3s', 't2s'], ['a9o', 'k9o', 'q9o', 'j9o', 't9o', '99', '98s', '97s', '96s', '95s', '94s', '93s', '92s'], ['a8o', 'k8o', 'q8o', 'j8o', 't8o', '98o', '88', '87s', '86s', '85s', '84s', '83s', '82s'], ['a7o', 'k7o', 'q7o', 'j7o', 't7o', '97o', '87o', '77', '76s', '75s', '74s', '73s', '72s'], ['a6o', 'k6o', 'q6o', 'j6o', 't6o', '96o', '86o', '76o', '66', '65s', '64s', '63s', '62s'], ['a5o', 'k5o', 'q5o', 'j5o', 't5o', '95o', '85o', '75o', '65o', '55', '54s', '53s', '52s'], ['a4o', 'k4o', 'q4o', 'j4o', 't4o', '94o', '84o', '74o', '64o', '54o', '44', '43s', '42s'], ['a3o', 'k3o', 'q3o', 'j3o', 't3o', '93o', '83o', '73o', '63o', '53o', '43o', '33', '32s'], ['a2o', 'k2o', 'q2o', 'j2o', 't2o', '92o', '82o', '72o', '62o', '52o', '42o', '32o', '22']],
  gridOfShortDeckGeneralHandStrings: [['aa', 'aks', 'aqs', 'ajs', 'ats', 'a9s', 'a8s', 'a7s', 'a6s'], ['ako', 'kk', 'kqs', 'kjs', 'kts', 'k9s', 'k8s', 'k7s', 'k6s'], ['aqo', 'kqo', 'qq', 'qjs', 'qts', 'q9s', 'q8s', 'q7s', 'q6s'], ['ajo', 'kjo', 'qjo', 'jj', 'jts', 'j9s', 'j8s', 'j7s', 'j6s'], ['ato', 'kto', 'qto', 'jto', 'tt', 't9s', 't8s', 't7s', 't6s'], ['a9o', 'k9o', 'q9o', 'j9o', 't9o', '99', '98s', '97s', '96s'], ['a8o', 'k8o', 'q8o', 'j8o', 't8o', '98o', '88', '87s', '86s'], ['a7o', 'k7o', 'q7o', 'j7o', 't7o', '97o', '87o', '77', '76s'], ['a6o', 'k6o', 'q6o', 'j6o', 't6o', '96o', '86o', '76o', '66']],
  categories: {
    pocketPairs: ['tt', '99', '88', '77', '66', '55', '44', '33', '22'],
    mediumPocketPairs: ['tt', '99', '88', '77'],
    smallPocketPairs: ['66', '55', '44', '33', '22'],
    suitedConnectors: ['t9s', '98s', '87s', '76s', '65s', '54s', '43s', '32s'],
    mediumSuitedConnectors: ['t9s', '98s', '87s', '76s'],
    smallSuitedConnectors: ['65s', '54s', '43s', '32s'],
    suitedOneGappers: ['t8s', '97s', '86s', '75s', '64s', '53s', '42s'],
    mediumSuitedOneGappers: ['t8s', '97s', '86s', '75s'],
    smallSuitedOneGappers: ['64s', '53s', '42s'],
    suitedAces: ['ats', 'a9s', 'a8s', 'a7s', 'a6s', 'a5s', 'a4s', 'a3s', 'a2s'],
    mediumSuitedAces: ['ats', 'a9s', 'a8s', 'a7s'],
    smallSuitedAces: ['a6s', 'a5s', 'a4s', 'a3s', 'a2s'],
    suitedKings: ['kts', 'k9s', 'k8s', 'k7s', 'k6s', 'k5s', 'k4s', 'k3s', 'k2s'],
    mediumSuitedKings: ['kts', 'k9s', 'k8s', 'k7s'],
    smallSuitedKings: ['k6s', 'k5s', 'k4s', 'k3s', 'k2s']
  },
  shortDeckCategories: {
    pocketPairs: ['jj', 'tt', '99', '88', '77', '66'],
    mediumPocketPairs: ['jj', 'tt', '99'],
    smallPocketPairs: ['88', '77', '66'],
    suitedConnectors: ['qjs', 'jts', 't9s', '98s', '87s', '76s'],
    mediumSuitedConnectors: ['qjs', 'jts', 't9s'],
    smallSuitedConnectors: ['98s', '87s', '76s'],
    suitedOneGappers: ['qts', 'j9s', 't8s', '97s', '86s'],
    mediumSuitedOneGappers: ['qts', 'j9s'],
    smallSuitedOneGappers: ['t8s', '97s', '86s'],
    suitedAces: ['ajs', 'ats', 'a9s', 'a8s', 'a7s', 'a6s'],
    mediumSuitedAces: ['ajs', 'ats', 'a9s'],
    smallSuitedAces: ['a8s', 'a7s', 'a6s'],
    suitedKings: ['kjs', 'kts', 'k9s', 'k8s', 'k7s', 'k6s'],
    mediumSuitedKings: ['kjs', 'kts', 'k9s'],
    smallSuitedKings: ['k8s', 'k7s', 'k6s']
  },
  textSelectorLists: {
    pairs: ['aa', 'kk', 'qq', 'jj', 'tt', '99', '88', '77', '66', '55', '44', '33', '22'],
    suited: {
      'a': ['aks', 'aqs', 'ajs', 'ats', 'a9s', 'a8s', 'a7s', 'a6s', 'a5s', 'a4s', 'a3s', 'a2s'],
      'k': ['kqs', 'kjs', 'kts', 'k9s', 'k8s', 'k7s', 'k6s', 'k5s', 'k4s', 'k3s', 'k2s'],
      'q': ['qjs', 'qts', 'q9s', 'q8s', 'q7s', 'q6s', 'q5s', 'q4s', 'q3s', 'q2s'],
      'j': ['jts', 'j9s', 'j8s', 'j7s', 'j6s', 'j5s', 'j4s', 'j3s', 'j2s'],
      't': ['t9s', 't8s', 't7s', 't6s', 't5s', 't4s', 't3s', 't2s'],
      '9': ['98s', '97s', '96s', '95s', '94s', '93s', '92s'],
      '8': ['87s', '86s', '85s', '84s', '83s', '82s'],
      '7': ['76s', '75s', '74s', '73s', '72s'],
      '6': ['65s', '64s', '63s', '62s'],
      '5': ['54s', '53s', '52s'],
      '4': ['43s', '42s'],
      '3': ['32s']
    },
    offsuit: {
      'a': ['ako', 'aqo', 'ajo', 'ato', 'a9o', 'a8o', 'a7o', 'a6o', 'a5o', 'a4o', 'a3o', 'a2o'],
      'k': ['kqo', 'kjo', 'kto', 'k9o', 'k8o', 'k7o', 'k6o', 'k5o', 'k4o', 'k3o', 'k2o'],
      'q': ['qjo', 'qto', 'q9o', 'q8o', 'q7o', 'q6o', 'q5o', 'q4o', 'q3o', 'q2o'],
      'j': ['jto', 'j9o', 'j8o', 'j7o', 'j6o', 'j5o', 'j4o', 'j3o', 'j2o'],
      't': ['t9o', 't8o', 't7o', 't6o', 't5o', 't4o', 't3o', 't2o'],
      '9': ['98o', '97o', '96o', '95o', '94o', '93o', '92o'],
      '8': ['87o', '86o', '85o', '84o', '83o', '82o'],
      '7': ['76o', '75o', '74o', '73o', '72o'],
      '6': ['65o', '64o', '63o', '62o'],
      '5': ['54o', '53o', '52o'],
      '4': ['43o', '42o'],
      '3': ['32o']
    }
  },
  generalHandStringToIndexMap: {
    'aa': 0,
    'kk': 1,
    'qq': 2,
    'jj': 3,
    'aks': 4,
    'tt': 5,
    'ako': 6,
    'aqs': 7,
    '99': 8,
    'ajs': 9,
    'aqo': 10,
    '88': 11,
    'ats': 12,
    'kqs': 13,
    'ajo': 14,
    '77': 15,
    'kjs': 16,
    'qjs': 17,
    'kts': 18,
    'kqo': 19,
    'a9s': 20,
    'ato': 21,
    '66': 22,
    'a8s': 23,
    'qts': 24,
    'jts': 25,
    'kjo': 26,
    'a7s': 27,
    'a5s': 28,
    'k9s': 29,
    'a4s': 30,
    'a6s': 31,
    '55': 32,
    'q9s': 33,
    'a3s': 34,
    'j9s': 35,
    'kto': 36,
    'qjo': 37,
    'a9o': 38,
    't9s': 39,
    'k8s': 40,
    'a2s': 41,
    'k7s': 42,
    '44': 43,
    'a8o': 44,
    'qto': 45,
    'q8s': 46,
    'jto': 47,
    'j8s': 48,
    'k6s': 49,
    '98s': 50,
    't8s': 51,
    'k5s': 52,
    'a7o': 53,
    'k4s': 54,
    'k9o': 55,
    'a5o': 56,
    '33': 57,
    'k3s': 58,
    'a4o': 59,
    'q9o': 60,
    '87s': 61,
    'q7s': 62,
    't7s': 63,
    'q6s': 64,
    'k2s': 65,
    'j7s': 66,
    'a6o': 67,
    '97s': 68,
    'q5s': 69,
    'a3o': 70,
    'j9o': 71,
    't9o': 72,
    '22': 73,
    'k8o': 74,
    'a2o': 75,
    'q4s': 76,
    '76s': 77,
    'k7o': 78,
    '86s': 79,
    '96s': 80,
    'j6s': 81,
    'j5s': 82,
    'k6o': 83,
    'q3s': 84,
    'q2s': 85,
    't6s': 86,
    '65s': 87,
    'k5o': 88,
    '75s': 89,
    'q8o': 90,
    '54s': 91,
    'j8o': 92,
    'j4s': 93,
    't8o': 94,
    '98o': 95,
    '85s': 96,
    '95s': 97,
    'k4o': 98,
    'j3s': 99,
    '64s': 100,
    't4s': 101,
    't5s': 102,
    '87o': 103,
    'q7o': 104,
    'k3o': 105,
    'j2s': 106,
    '74s': 107,
    '97o': 108,
    'j7o': 109,
    '53s': 110,
    'q6o': 111,
    't3s': 112,
    'k2o': 113,
    '94s': 114,
    't7o': 115,
    '84s': 116,
    '43s': 117,
    '63s': 118,
    'q5o': 119,
    '86o': 120,
    't2s': 121,
    '93s': 122,
    '76o': 123,
    'q4o': 124,
    '92s': 125,
    '96o': 126,
    '73s': 127,
    'j6o': 128,
    'q3o': 129,
    '52s': 130,
    '65o': 131,
    'j5o': 132,
    't6o': 133,
    '82s': 134,
    '42s': 135,
    '83s': 136,
    'q2o': 137,
    '75o': 138,
    '54o': 139,
    'j4o': 140,
    '62s': 141,
    '85o': 142,
    '32s': 143,
    '95o': 144,
    '72s': 145,
    'j3o': 146,
    't5o': 147,
    't4o': 148,
    '64o': 149,
    'j2o': 150,
    '53o': 151,
    '74o': 152,
    '84o': 153,
    't3o': 154,
    '43o': 155,
    '94o': 156,
    't2o': 157,
    '93o': 158,
    '63o': 159,
    '92o': 160,
    '73o': 161,
    '52o': 162,
    '42o': 163,
    '83o': 164,
    '82o': 165,
    '62o': 166,
    '32o': 167,
    '72o': 168
  },
  specificHandStrings: ['acas', 'acah', 'acad', 'asah', 'asad', 'ahad', 'kcks', 'kckh', 'kckd', 'kskh', 'kskd', 'khkd', 'qcqs', 'qcqh', 'qcqd', 'qsqh', 'qsqd', 'qhqd', 'jcjs', 'jcjh', 'jcjd', 'jsjh', 'jsjd', 'jhjd', 'ackc', 'asks', 'ahkh', 'adkd', 'tcts', 'tcth', 'tctd', 'tsth', 'tstd', 'thtd', 'acks', 'ackh', 'ackd', 'askc', 'askh', 'askd', 'ahkc', 'ahks', 'ahkd', 'adkc', 'adks', 'adkh', 'acqc', 'asqs', 'ahqh', 'adqd', '9c9s', '9c9h', '9c9d', '9s9h', '9s9d', '9h9d', 'acjc', 'asjs', 'ahjh', 'adjd', 'acqs', 'acqh', 'acqd', 'asqc', 'asqh', 'asqd', 'ahqc', 'ahqs', 'ahqd', 'adqc', 'adqs', 'adqh', '8c8s', '8c8h', '8c8d', '8s8h', '8s8d', '8h8d', 'actc', 'asts', 'ahth', 'adtd', 'kcqc', 'ksqs', 'khqh', 'kdqd', 'acjs', 'acjh', 'acjd', 'asjc', 'asjh', 'asjd', 'ahjc', 'ahjs', 'ahjd', 'adjc', 'adjs', 'adjh', '7c7s', '7c7h', '7c7d', '7s7h', '7s7d', '7h7d', 'kcjc', 'ksjs', 'khjh', 'kdjd', 'qcjc', 'qsjs', 'qhjh', 'qdjd', 'kctc', 'ksts', 'khth', 'kdtd', 'kcqs', 'kcqh', 'kcqd', 'ksqc', 'ksqh', 'ksqd', 'khqc', 'khqs', 'khqd', 'kdqc', 'kdqs', 'kdqh', 'ac9c', 'as9s', 'ah9h', 'ad9d', 'acts', 'acth', 'actd', 'astc', 'asth', 'astd', 'ahtc', 'ahts', 'ahtd', 'adtc', 'adts', 'adth', '6c6s', '6c6h', '6c6d', '6s6h', '6s6d', '6h6d', 'ac8c', 'as8s', 'ah8h', 'ad8d', 'qctc', 'qsts', 'qhth', 'qdtd', 'jctc', 'jsts', 'jhth', 'jdtd', 'kcjs', 'kcjh', 'kcjd', 'ksjc', 'ksjh', 'ksjd', 'khjc', 'khjs', 'khjd', 'kdjc', 'kdjs', 'kdjh', 'ac7c', 'as7s', 'ah7h', 'ad7d', 'ac5c', 'as5s', 'ah5h', 'ad5d', 'kc9c', 'ks9s', 'kh9h', 'kd9d', 'ac4c', 'as4s', 'ah4h', 'ad4d', 'ac6c', 'as6s', 'ah6h', 'ad6d', '5c5s', '5c5h', '5c5d', '5s5h', '5s5d', '5h5d', 'qc9c', 'qs9s', 'qh9h', 'qd9d', 'ac3c', 'as3s', 'ah3h', 'ad3d', 'jc9c', 'js9s', 'jh9h', 'jd9d', 'kcts', 'kcth', 'kctd', 'kstc', 'ksth', 'kstd', 'khtc', 'khts', 'khtd', 'kdtc', 'kdts', 'kdth', 'qcjs', 'qcjh', 'qcjd', 'qsjc', 'qsjh', 'qsjd', 'qhjc', 'qhjs', 'qhjd', 'qdjc', 'qdjs', 'qdjh', 'ac9s', 'ac9h', 'ac9d', 'as9c', 'as9h', 'as9d', 'ah9c', 'ah9s', 'ah9d', 'ad9c', 'ad9s', 'ad9h', 'tc9c', 'ts9s', 'th9h', 'td9d', 'kc8c', 'ks8s', 'kh8h', 'kd8d', 'ac2c', 'as2s', 'ah2h', 'ad2d', 'kc7c', 'ks7s', 'kh7h', 'kd7d', '4c4s', '4c4h', '4c4d', '4s4h', '4s4d', '4h4d', 'ac8s', 'ac8h', 'ac8d', 'as8c', 'as8h', 'as8d', 'ah8c', 'ah8s', 'ah8d', 'ad8c', 'ad8s', 'ad8h', 'qcts', 'qcth', 'qctd', 'qstc', 'qsth', 'qstd', 'qhtc', 'qhts', 'qhtd', 'qdtc', 'qdts', 'qdth', 'qc8c', 'qs8s', 'qh8h', 'qd8d', 'jcts', 'jcth', 'jctd', 'jstc', 'jsth', 'jstd', 'jhtc', 'jhts', 'jhtd', 'jdtc', 'jdts', 'jdth', 'jc8c', 'js8s', 'jh8h', 'jd8d', 'kc6c', 'ks6s', 'kh6h', 'kd6d', '9c8c', '9s8s', '9h8h', '9d8d', 'tc8c', 'ts8s', 'th8h', 'td8d', 'kc5c', 'ks5s', 'kh5h', 'kd5d', 'ac7s', 'ac7h', 'ac7d', 'as7c', 'as7h', 'as7d', 'ah7c', 'ah7s', 'ah7d', 'ad7c', 'ad7s', 'ad7h', 'kc4c', 'ks4s', 'kh4h', 'kd4d', 'kc9s', 'kc9h', 'kc9d', 'ks9c', 'ks9h', 'ks9d', 'kh9c', 'kh9s', 'kh9d', 'kd9c', 'kd9s', 'kd9h', 'ac5s', 'ac5h', 'ac5d', 'as5c', 'as5h', 'as5d', 'ah5c', 'ah5s', 'ah5d', 'ad5c', 'ad5s', 'ad5h', '3c3s', '3c3h', '3c3d', '3s3h', '3s3d', '3h3d', 'kc3c', 'ks3s', 'kh3h', 'kd3d', 'ac4s', 'ac4h', 'ac4d', 'as4c', 'as4h', 'as4d', 'ah4c', 'ah4s', 'ah4d', 'ad4c', 'ad4s', 'ad4h', 'qc9s', 'qc9h', 'qc9d', 'qs9c', 'qs9h', 'qs9d', 'qh9c', 'qh9s', 'qh9d', 'qd9c', 'qd9s', 'qd9h', '8c7c', '8s7s', '8h7h', '8d7d', 'qc7c', 'qs7s', 'qh7h', 'qd7d', 'tc7c', 'ts7s', 'th7h', 'td7d', 'qc6c', 'qs6s', 'qh6h', 'qd6d', 'kc2c', 'ks2s', 'kh2h', 'kd2d', 'jc7c', 'js7s', 'jh7h', 'jd7d', 'ac6s', 'ac6h', 'ac6d', 'as6c', 'as6h', 'as6d', 'ah6c', 'ah6s', 'ah6d', 'ad6c', 'ad6s', 'ad6h', '9c7c', '9s7s', '9h7h', '9d7d', 'qc5c', 'qs5s', 'qh5h', 'qd5d', 'ac3s', 'ac3h', 'ac3d', 'as3c', 'as3h', 'as3d', 'ah3c', 'ah3s', 'ah3d', 'ad3c', 'ad3s', 'ad3h', 'jc9s', 'jc9h', 'jc9d', 'js9c', 'js9h', 'js9d', 'jh9c', 'jh9s', 'jh9d', 'jd9c', 'jd9s', 'jd9h', 'tc9s', 'tc9h', 'tc9d', 'ts9c', 'ts9h', 'ts9d', 'th9c', 'th9s', 'th9d', 'td9c', 'td9s', 'td9h', '2c2s', '2c2h', '2c2d', '2s2h', '2s2d', '2h2d', 'kc8s', 'kc8h', 'kc8d', 'ks8c', 'ks8h', 'ks8d', 'kh8c', 'kh8s', 'kh8d', 'kd8c', 'kd8s', 'kd8h', 'ac2s', 'ac2h', 'ac2d', 'as2c', 'as2h', 'as2d', 'ah2c', 'ah2s', 'ah2d', 'ad2c', 'ad2s', 'ad2h', 'qc4c', 'qs4s', 'qh4h', 'qd4d', '7c6c', '7s6s', '7h6h', '7d6d', 'kc7s', 'kc7h', 'kc7d', 'ks7c', 'ks7h', 'ks7d', 'kh7c', 'kh7s', 'kh7d', 'kd7c', 'kd7s', 'kd7h', '8c6c', '8s6s', '8h6h', '8d6d', '9c6c', '9s6s', '9h6h', '9d6d', 'jc6c', 'js6s', 'jh6h', 'jd6d', 'jc5c', 'js5s', 'jh5h', 'jd5d', 'kc6s', 'kc6h', 'kc6d', 'ks6c', 'ks6h', 'ks6d', 'kh6c', 'kh6s', 'kh6d', 'kd6c', 'kd6s', 'kd6h', 'qc3c', 'qs3s', 'qh3h', 'qd3d', 'qc2c', 'qs2s', 'qh2h', 'qd2d', 'tc6c', 'ts6s', 'th6h', 'td6d', '6c5c', '6s5s', '6h5h', '6d5d', 'kc5s', 'kc5h', 'kc5d', 'ks5c', 'ks5h', 'ks5d', 'kh5c', 'kh5s', 'kh5d', 'kd5c', 'kd5s', 'kd5h', '7c5c', '7s5s', '7h5h', '7d5d', 'qc8s', 'qc8h', 'qc8d', 'qs8c', 'qs8h', 'qs8d', 'qh8c', 'qh8s', 'qh8d', 'qd8c', 'qd8s', 'qd8h', '5c4c', '5s4s', '5h4h', '5d4d', 'jc8s', 'jc8h', 'jc8d', 'js8c', 'js8h', 'js8d', 'jh8c', 'jh8s', 'jh8d', 'jd8c', 'jd8s', 'jd8h', 'jc4c', 'js4s', 'jh4h', 'jd4d', 'tc8s', 'tc8h', 'tc8d', 'ts8c', 'ts8h', 'ts8d', 'th8c', 'th8s', 'th8d', 'td8c', 'td8s', 'td8h', '9c8s', '9c8h', '9c8d', '9s8c', '9s8h', '9s8d', '9h8c', '9h8s', '9h8d', '9d8c', '9d8s', '9d8h', '8c5c', '8s5s', '8h5h', '8d5d', '9c5c', '9s5s', '9h5h', '9d5d', 'kc4s', 'kc4h', 'kc4d', 'ks4c', 'ks4h', 'ks4d', 'kh4c', 'kh4s', 'kh4d', 'kd4c', 'kd4s', 'kd4h', 'jc3c', 'js3s', 'jh3h', 'jd3d', '6c4c', '6s4s', '6h4h', '6d4d', 'tc4c', 'ts4s', 'th4h', 'td4d', 'tc5c', 'ts5s', 'th5h', 'td5d', '8c7s', '8c7h', '8c7d', '8s7c', '8s7h', '8s7d', '8h7c', '8h7s', '8h7d', '8d7c', '8d7s', '8d7h', 'qc7s', 'qc7h', 'qc7d', 'qs7c', 'qs7h', 'qs7d', 'qh7c', 'qh7s', 'qh7d', 'qd7c', 'qd7s', 'qd7h', 'kc3s', 'kc3h', 'kc3d', 'ks3c', 'ks3h', 'ks3d', 'kh3c', 'kh3s', 'kh3d', 'kd3c', 'kd3s', 'kd3h', 'jc2c', 'js2s', 'jh2h', 'jd2d', '7c4c', '7s4s', '7h4h', '7d4d', '9c7s', '9c7h', '9c7d', '9s7c', '9s7h', '9s7d', '9h7c', '9h7s', '9h7d', '9d7c', '9d7s', '9d7h', 'jc7s', 'jc7h', 'jc7d', 'js7c', 'js7h', 'js7d', 'jh7c', 'jh7s', 'jh7d', 'jd7c', 'jd7s', 'jd7h', '5c3c', '5s3s', '5h3h', '5d3d', 'qc6s', 'qc6h', 'qc6d', 'qs6c', 'qs6h', 'qs6d', 'qh6c', 'qh6s', 'qh6d', 'qd6c', 'qd6s', 'qd6h', 'tc3c', 'ts3s', 'th3h', 'td3d', 'kc2s', 'kc2h', 'kc2d', 'ks2c', 'ks2h', 'ks2d', 'kh2c', 'kh2s', 'kh2d', 'kd2c', 'kd2s', 'kd2h', '9c4c', '9s4s', '9h4h', '9d4d', 'tc7s', 'tc7h', 'tc7d', 'ts7c', 'ts7h', 'ts7d', 'th7c', 'th7s', 'th7d', 'td7c', 'td7s', 'td7h', '8c4c', '8s4s', '8h4h', '8d4d', '4c3c', '4s3s', '4h3h', '4d3d', '6c3c', '6s3s', '6h3h', '6d3d', 'qc5s', 'qc5h', 'qc5d', 'qs5c', 'qs5h', 'qs5d', 'qh5c', 'qh5s', 'qh5d', 'qd5c', 'qd5s', 'qd5h', '8c6s', '8c6h', '8c6d', '8s6c', '8s6h', '8s6d', '8h6c', '8h6s', '8h6d', '8d6c', '8d6s', '8d6h', 'tc2c', 'ts2s', 'th2h', 'td2d', '9c3c', '9s3s', '9h3h', '9d3d', '7c6s', '7c6h', '7c6d', '7s6c', '7s6h', '7s6d', '7h6c', '7h6s', '7h6d', '7d6c', '7d6s', '7d6h', 'qc4s', 'qc4h', 'qc4d', 'qs4c', 'qs4h', 'qs4d', 'qh4c', 'qh4s', 'qh4d', 'qd4c', 'qd4s', 'qd4h', '9c2c', '9s2s', '9h2h', '9d2d', '9c6s', '9c6h', '9c6d', '9s6c', '9s6h', '9s6d', '9h6c', '9h6s', '9h6d', '9d6c', '9d6s', '9d6h', '7c3c', '7s3s', '7h3h', '7d3d', 'jc6s', 'jc6h', 'jc6d', 'js6c', 'js6h', 'js6d', 'jh6c', 'jh6s', 'jh6d', 'jd6c', 'jd6s', 'jd6h', 'qc3s', 'qc3h', 'qc3d', 'qs3c', 'qs3h', 'qs3d', 'qh3c', 'qh3s', 'qh3d', 'qd3c', 'qd3s', 'qd3h', '5c2c', '5s2s', '5h2h', '5d2d', '6c5s', '6c5h', '6c5d', '6s5c', '6s5h', '6s5d', '6h5c', '6h5s', '6h5d', '6d5c', '6d5s', '6d5h', 'jc5s', 'jc5h', 'jc5d', 'js5c', 'js5h', 'js5d', 'jh5c', 'jh5s', 'jh5d', 'jd5c', 'jd5s', 'jd5h', 'tc6s', 'tc6h', 'tc6d', 'ts6c', 'ts6h', 'ts6d', 'th6c', 'th6s', 'th6d', 'td6c', 'td6s', 'td6h', '8c2c', '8s2s', '8h2h', '8d2d', '4c2c', '4s2s', '4h2h', '4d2d', '8c3c', '8s3s', '8h3h', '8d3d', 'qc2s', 'qc2h', 'qc2d', 'qs2c', 'qs2h', 'qs2d', 'qh2c', 'qh2s', 'qh2d', 'qd2c', 'qd2s', 'qd2h', '7c5s', '7c5h', '7c5d', '7s5c', '7s5h', '7s5d', '7h5c', '7h5s', '7h5d', '7d5c', '7d5s', '7d5h', '5c4s', '5c4h', '5c4d', '5s4c', '5s4h', '5s4d', '5h4c', '5h4s', '5h4d', '5d4c', '5d4s', '5d4h', 'jc4s', 'jc4h', 'jc4d', 'js4c', 'js4h', 'js4d', 'jh4c', 'jh4s', 'jh4d', 'jd4c', 'jd4s', 'jd4h', '6c2c', '6s2s', '6h2h', '6d2d', '8c5s', '8c5h', '8c5d', '8s5c', '8s5h', '8s5d', '8h5c', '8h5s', '8h5d', '8d5c', '8d5s', '8d5h', '3c2c', '3s2s', '3h2h', '3d2d', '9c5s', '9c5h', '9c5d', '9s5c', '9s5h', '9s5d', '9h5c', '9h5s', '9h5d', '9d5c', '9d5s', '9d5h', '7c2c', '7s2s', '7h2h', '7d2d', 'jc3s', 'jc3h', 'jc3d', 'js3c', 'js3h', 'js3d', 'jh3c', 'jh3s', 'jh3d', 'jd3c', 'jd3s', 'jd3h', 'tc5s', 'tc5h', 'tc5d', 'ts5c', 'ts5h', 'ts5d', 'th5c', 'th5s', 'th5d', 'td5c', 'td5s', 'td5h', 'tc4s', 'tc4h', 'tc4d', 'ts4c', 'ts4h', 'ts4d', 'th4c', 'th4s', 'th4d', 'td4c', 'td4s', 'td4h', '6c4s', '6c4h', '6c4d', '6s4c', '6s4h', '6s4d', '6h4c', '6h4s', '6h4d', '6d4c', '6d4s', '6d4h', 'jc2s', 'jc2h', 'jc2d', 'js2c', 'js2h', 'js2d', 'jh2c', 'jh2s', 'jh2d', 'jd2c', 'jd2s', 'jd2h', '5c3s', '5c3h', '5c3d', '5s3c', '5s3h', '5s3d', '5h3c', '5h3s', '5h3d', '5d3c', '5d3s', '5d3h', '7c4s', '7c4h', '7c4d', '7s4c', '7s4h', '7s4d', '7h4c', '7h4s', '7h4d', '7d4c', '7d4s', '7d4h', '8c4s', '8c4h', '8c4d', '8s4c', '8s4h', '8s4d', '8h4c', '8h4s', '8h4d', '8d4c', '8d4s', '8d4h', 'tc3s', 'tc3h', 'tc3d', 'ts3c', 'ts3h', 'ts3d', 'th3c', 'th3s', 'th3d', 'td3c', 'td3s', 'td3h', '4c3s', '4c3h', '4c3d', '4s3c', '4s3h', '4s3d', '4h3c', '4h3s', '4h3d', '4d3c', '4d3s', '4d3h', '9c4s', '9c4h', '9c4d', '9s4c', '9s4h', '9s4d', '9h4c', '9h4s', '9h4d', '9d4c', '9d4s', '9d4h', 'tc2s', 'tc2h', 'tc2d', 'ts2c', 'ts2h', 'ts2d', 'th2c', 'th2s', 'th2d', 'td2c', 'td2s', 'td2h', '9c3s', '9c3h', '9c3d', '9s3c', '9s3h', '9s3d', '9h3c', '9h3s', '9h3d', '9d3c', '9d3s', '9d3h', '6c3s', '6c3h', '6c3d', '6s3c', '6s3h', '6s3d', '6h3c', '6h3s', '6h3d', '6d3c', '6d3s', '6d3h', '9c2s', '9c2h', '9c2d', '9s2c', '9s2h', '9s2d', '9h2c', '9h2s', '9h2d', '9d2c', '9d2s', '9d2h', '7c3s', '7c3h', '7c3d', '7s3c', '7s3h', '7s3d', '7h3c', '7h3s', '7h3d', '7d3c', '7d3s', '7d3h', '5c2s', '5c2h', '5c2d', '5s2c', '5s2h', '5s2d', '5h2c', '5h2s', '5h2d', '5d2c', '5d2s', '5d2h', '4c2s', '4c2h', '4c2d', '4s2c', '4s2h', '4s2d', '4h2c', '4h2s', '4h2d', '4d2c', '4d2s', '4d2h', '8c3s', '8c3h', '8c3d', '8s3c', '8s3h', '8s3d', '8h3c', '8h3s', '8h3d', '8d3c', '8d3s', '8d3h', '8c2s', '8c2h', '8c2d', '8s2c', '8s2h', '8s2d', '8h2c', '8h2s', '8h2d', '8d2c', '8d2s', '8d2h', '6c2s', '6c2h', '6c2d', '6s2c', '6s2h', '6s2d', '6h2c', '6h2s', '6h2d', '6d2c', '6d2s', '6d2h', '3c2s', '3c2h', '3c2d', '3s2c', '3s2h', '3s2d', '3h2c', '3h2s', '3h2d', '3d2c', '3d2s', '3d2h', '7c2s', '7c2h', '7c2d', '7s2c', '7s2h', '7s2d', '7h2c', '7h2s', '7h2d', '7d2c', '7d2s', '7d2h'],
  orderedFiveCardHandIds: ['fourOfAKindPlus:royalFlush', 'fourOfAKindPlus:straightFlush', 'fourOfAKindPlus:fourOfAKind', 'fullHouse', 'flush:nut', 'flush:secondNut', 'flush:thirdNut', 'flush:weak', 'straight', 'threeOfAKind:topSet', 'threeOfAKind:secondSet', 'threeOfAKind:thirdSet', 'threeOfAKind:fourthSet', 'threeOfAKind:middleSet', 'threeOfAKind:bottomSet', 'threeOfAKind:trips', 'twoPair:usingTopBoardCard', 'twoPair:weak', 'pair:overpair', 'pair:tptk', 'pair:tpgk', 'pair:tpwk', 'flushDraw:nut', 'flushDraw:secondNut', 'flushDraw:thirdNut', 'flushDraw:weak', 'oesd', 'doubleGutshot', 'pair:ppUnderTp', 'pair:secondPair', 'pair:middlePair', 'pair:weakPair', 'gutshot', 'twoOvercards', 'oneOvercard', 'backdoorFlushDraw:nut', 'backdoorFlushDraw:secondNut', 'backdoorFlushDraw:thirdNut', 'backdoorFlushDraw:weak', 'backdoorStraightDraw']
});

/***/ }),

/***/ "vw0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__ = __webpack_require__("jEKO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component__ = __webpack_require__("GDE4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slider_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'five-card-hand-weight-modal',
  components: {
    'ppt-modal': __WEBPACK_IMPORTED_MODULE_0__components_utilities_modal__["a" /* default */],
    'vue-slider': __WEBPACK_IMPORTED_MODULE_1_vue_slider_component___default.a
  },
  props: ['fiveCardHand'],
  data: function data() {
    return {
      fiveCardHandParentWeight: 100,
      fiveCardHandLeafWeight: 100,
      vueSliderOptions: {
        min: 5,
        interval: 5
      }
    };
  },
  mounted: function mounted() {
    var self = this;

    $(this.$el).on('shown.bs.modal', function () {
      self.$nextTick(function () {
        var weight = void 0;

        if (self.fiveCardHand && self.fiveCardHand.hasExplicitWeight) {
          weight = self.fiveCardHand.weight;
        } else {
          weight = 100;
        }

        if (self.$refs.sliderParent) {
          self.$refs.sliderParent.refresh();
          self.$refs.sliderParent.setValue(weight);
        }

        if (self.$refs.sliderLeaf) {
          self.$refs.sliderLeaf.refresh();
          self.$refs.sliderLeaf.setValue(weight);
        }
      });
    });
  },
  methods: {
    applyExactWeightToFiveCardHand: function applyExactWeightToFiveCardHand(fiveCardHand, newWeight) {
      this.$emit('applyExactWeightToFiveCardHand', {
        fiveCardHand: fiveCardHand,
        newWeight: newWeight
      });
      $(this.$el).modal('hide');
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "vyb0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "w+g/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-sharable-url-button-container",attrs:{"data-title":_vm.tooltipValue,"data-toggle":"tooltip","data-placement":"top"}},[_c('button',{staticClass:"btn btn-default create-sharable-url-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('createSharableUrl')}}},[_vm._v("\n    "+_vm._s(_vm.text)+" "),_c('span',{staticClass:"glyphicon glyphicon-link"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w7C2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-bluff-river-steps"},[_c('div',[_c('h4',[_vm._v("Step "+_vm._s(6 + (_vm.state.players.numPlayers * 3))+": What is the river card?")]),_vm._v(" "),_c('river-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}}})],1),_vm._v(" "),_c('bluff-size-selector',{attrs:{"step":7 + (_vm.state.players.numPlayers * 3),"bluffSize":_vm.state.bluffSize,"authorized":_vm.authorized},on:{"setBluffSize":function($event){return _vm.$emit('setBluffSize', $event)}}}),_vm._v(" "),(_vm.showFoldEquityTable)?_c('fold-equity-table',{attrs:{"state":_vm.state,"playerStateIndex":3,"immediatelyProfitableBreakevenPercentage":_vm.$store.getters['guidedAnalysesBluffing/immediatelyProfitableBreakevenPercentage']},on:{"setProfitableBreakevenPercentage":function($event){return _vm.$emit('setProfitableBreakevenPercentage', $event)}}}):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.riverSet)?_c('div',_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('set-range-step',{key:player.id,attrs:{"textForStep":_vm.getTextForPlayerRangeStep(playerIndex),"player":player,"playerIndex":playerIndex,"playerStateIndex":3,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"storeModuleName":'guidedAnalysesBluffing',"authorized":_vm.authorized}},[(_vm.state.streetToBluff === 'river')?_c('river-selector',{attrs:{"slot":"boardCardsSelector","presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}},slot:"boardCardsSelector"}):_vm._e(),_vm._v(" "),_c('range-help-section',{attrs:{"slot":"rangeHelpSection","playerStateIndex":3,"streetToBluff":_vm.state.streetToBluff},slot:"rangeHelpSection"})],1)}),1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w9+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wKtO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wOxj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visual_vue__ = __webpack_require__("C4LL");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89162c16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visual_vue__ = __webpack_require__("yO/q");
function injectStyle (ssrContext) {
  __webpack_require__("YuiF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-89162c16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_visual_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89162c16_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_visual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wTCP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Email")]),_vm._v(": "+_vm._s(_vm.user.email))]),_vm._v(" "),(!_vm.sso)?_c('hr'):_vm._e(),_vm._v(" "),(!_vm.sso)?_c('p',[_c('router-link',{attrs:{"to":"/change-password"}},[_vm._v("Change password")])],1):_vm._e(),_vm._v(" "),(_vm.user.auth.includes('basic'))?_c('section',[_c('hr'),_vm._v(" "),_c('p',[_vm._v("You have purchased the basic version of Six Plus Hold’em. If you would like to upgrade to the premium plan for another $50, head over to the "),_c('router-link',{attrs:{"to":"/upgrade"}},[_vm._v("upgrade page")]),_vm._v(".")],1)]):_vm._e(),_vm._v(" "),(_vm.user.auth.includes('premium'))?_c('section',[_c('hr'),_vm._v(" "),_c('p',[_vm._v("You have purchased the premium version of Six Plus Hold’em.")])]):_vm._e(),_vm._v(" "),(_vm.user.auth.includes('short deck'))?_c('section',[_c('hr'),_vm._v(" "),_c('p',[_vm._v("You have purchased the short deck hit calculator.")])]):_vm._e(),_vm._v(" "),(!_vm.user.auth.includes('short deck') || !_vm.user.auth.includes('premium'))?_c('section',[_c('hr'),_vm._v(" "),(_vm.daysLeftOnFreeTrial > 0)?_c('section',[_c('p',[_c('strong',[_vm._v("Days left on free trial:")]),_vm._v(" "+_vm._s(_vm.daysLeftOnFreeTrial))]),_vm._v(" "),(!_vm.user.auth.includes('basic') && !_vm.user.auth.includes('premium'))?_c('p',[_vm._v("If you're ready to purchase, head over to the "),_c('router-link',{attrs:{"to":"/purchase"}},[_vm._v("purchase page")]),_vm._v(".")],1):_vm._e()]):_c('section',[_c('p',[_c('em',[_vm._v("\n        Your free trial is over.\n        "),(!_vm.user.auth.includes('basic') && !_vm.user.auth.includes('premium'))?_c('span',[_vm._v("You'll need to "),_c('router-link',{attrs:{"to":"/purchase"}},[_vm._v("purchase")]),_vm._v(" the basic or premium version to continue using Six Plus Hold’em.")],1):_vm._e()])])])]):_vm._e(),_vm._v(" "),(!_vm.user.auth.includes('short deck'))?_c('section',[_c('hr'),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/purchase-short-deck"}},[_vm._v("Purchase page")]),_vm._v(" for the short deck hit calculator.")],1)]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.user.emailOptIn)?_c('p',[_vm._v("\n    You are currently subscribed to receive infrequent emails.\n    "),_c('button',{staticClass:"btn btn-default btn-lg",attrs:{"disabled":_vm.requestPending},on:{"click":function($event){return _vm.unsubscribeFromEmail()}}},[_vm._v("\n      "+_vm._s(_vm.unsubscribeFromEmailText)+"\n    ")])]):_vm._e(),_vm._v(" "),(!_vm.user.emailOptIn)?_c('div',[_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('p',[_vm._v("No spam or other bullshit.")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default btn-lg",attrs:{"disabled":_vm.requestPending},on:{"click":function($event){return _vm.subscribeToEmail()}}},[_vm._v("\n      "+_vm._s(_vm.subscribeToEmailText)+"\n    ")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('saved-scenarios',{attrs:{"savedScenarios":_vm.user.savedScenarios}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-lg",attrs:{"disabled":_vm.requestPending},on:{"click":function($event){return _vm.deleteAccount()}}},[_vm._v("\n    "+_vm._s(_vm.deleteAccountText)+"\n  ")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Account")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("You have not subscribed to receive infrequent emails.")]),_vm._v(" It would be really cool if you did though. Some examples of the sorts of emails you'd get:")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Important new features")]),_vm._v(" "),_c('li',[_vm._v("\"What feature should I build next?\"-type questions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "wUZA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("FGQs");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd4ca09e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("P13r");
function injectStyle (ssrContext) {
  __webpack_require__("EwWu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd4ca09e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd4ca09e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "wWrn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hit_calculator_five_card_hands_section_insights_header_cell__ = __webpack_require__("GjlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_hit_calculator_five_card_hands_section_insights_table_cell__ = __webpack_require__("8/zq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_hit_calculator_five_card_hands_section_insights_initial_bet_size_button_group__ = __webpack_require__("fvjT");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hit-calculator-insights',
  components: {
    'header-cell': __WEBPACK_IMPORTED_MODULE_0__components_hit_calculator_five_card_hands_section_insights_header_cell__["a" /* default */],
    'table-cell': __WEBPACK_IMPORTED_MODULE_1__components_hit_calculator_five_card_hands_section_insights_table_cell__["a" /* default */],
    'initial-bet-size-button-group': __WEBPACK_IMPORTED_MODULE_2__components_hit_calculator_five_card_hands_section_insights_initial_bet_size_button_group__["a" /* default */]
  },
  props: ['hitPercentage', 'hitPercentageUpToDate'],
  data: function data() {
    return {
      initialBetSize: '1/2 pot',
      activeInsightSection: 'bluffing'
    };
  },
  methods: {
    isBluffProfitable: function isBluffProfitable(risk, reward) {
      var hasSimulationBeenRun = true; // TODO

      if (!hasSimulationBeenRun || !this.hitPercentageUpToDate) {
        return null;
      }

      var percentageOfTimeBluffWorks = 100 - Number(this.hitPercentage);
      var percentageOfTimeBluffNeedsToWork = this._getPercentageOfTimeBluffNeedsToWork(risk, reward);
      return percentageOfTimeBluffWorks > percentageOfTimeBluffNeedsToWork;
    },
    _getPercentageOfTimeBluffNeedsToWork: function _getPercentageOfTimeBluffNeedsToWork(risk, reward) {
      return risk / (risk + reward) * 100;
    },
    isRaiseProfitable: function isRaiseProfitable(timesInitialBet) {
      var hasSimulationBeenRun = true; // TODO

      if (!hasSimulationBeenRun || !this.hitPercentageUpToDate) {
        return null;
      }

      var percentageOfTimeRaiseWorks = 100 - Number(this.hitPercentage);
      var percentageOfTimeRaiseNeedsToWork = this.getPercentageOfTimeRaiseNeedsToWork(timesInitialBet);
      return percentageOfTimeRaiseWorks > percentageOfTimeRaiseNeedsToWork;
    },
    getPercentageOfTimeRaiseNeedsToWork: function getPercentageOfTimeRaiseNeedsToWork(timesInitialBet) {
      var initialBet = void 0;
      var risk = void 0;
      var reward = void 0;
      var raiseSize = void 0;

      if (this.initialBetSize === '1/2 pot') {
        initialBet = 0.5;
      } else if (this.initialBetSize === '3/4 pot') {
        initialBet = 0.75;
      } else if (this.initialBetSize === 'Full pot') {
        initialBet = 1;
      } else {
        throw new Error('initialBetSize has an invalid value: ', this.initialBetSize);
      }

      raiseSize = initialBet * timesInitialBet;
      risk = raiseSize - initialBet;
      reward = 1 + initialBet * 2;
      return (risk / (risk + reward) * 100).roundToTwoDecimalPlaces();
    }
  }
});

/***/ }),

/***/ "wceS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_future_streets_2_vue__ = __webpack_require__("1Cc/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3edd1646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_future_streets_2_vue__ = __webpack_require__("XkqR");
function injectStyle (ssrContext) {
  __webpack_require__("CvKd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3edd1646"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_future_streets_2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3edd1646_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_future_streets_2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wgL0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wu3j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_user_saved_scenarios_for_tool__ = __webpack_require__("E5VU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'saved-scenarios',
  props: ['savedScenarios'],
  components: {
    'saved-scenarios-for-tool': __WEBPACK_IMPORTED_MODULE_0__components_user_saved_scenarios_for_tool__["a" /* default */]
  },
  computed: {
    purchasedShortDeck: function purchasedShortDeck() {
      return this.$store.state.account.user.auth.includes('short deck');
    },
    pagesWithNoSavedScenarios: function pagesWithNoSavedScenarios() {
      var pagesWithNoSavedScenarios = [];

      if (this.purchasedShortDeck && this.savedScenarios.shortDeckEquityCalculator.length === 0) {
        pagesWithNoSavedScenarios.push('short deck equity calculator');
      }

      if (this.purchasedShortDeck && this.savedScenarios.shortDeckHitCalculator.length === 0) {
        pagesWithNoSavedScenarios.push('short deck hit calculator');
      }

      if (this.savedScenarios.equityCalculator.length === 0) {
        pagesWithNoSavedScenarios.push('equity calculator');
      }

      if (this.savedScenarios.hitCalculator.length === 0) {
        pagesWithNoSavedScenarios.push('hit calculator');
      }

      if (this.savedScenarios.equityMatrix.length === 0) {
        pagesWithNoSavedScenarios.push('equity matrix');
      }

      if (this.savedScenarios.rangeConstructor.length === 0) {
        pagesWithNoSavedScenarios.push('range constructor');
      }

      if (this.savedScenarios.shouldYouBluff.length === 0) {
        pagesWithNoSavedScenarios.push('should you bluff');
      }

      if (this.savedScenarios.shouldYouCall.length === 0) {
        pagesWithNoSavedScenarios.push('should you call');
      }

      if (this.savedScenarios.turnBluffBreakevenPercentage.length === 0) {
        pagesWithNoSavedScenarios.push('bluffing the turn breakeven percentage');
      }

      if (this.savedScenarios.threeBetCbetExplorer.length === 0) {
        pagesWithNoSavedScenarios.push('3bet-cbet explorer');
      }

      return pagesWithNoSavedScenarios;
    },
    noSavedScenariosText: function noSavedScenariosText() {
      var i = void 0;
      var noSavedScenariosText = 'The following pages don\'t have any saved scenarios: ';

      if (!this.purchasedShortDeck && this.pagesWithNoSavedScenarios.length === 8 || this.purchasedShortDeck && this.pagesWithNoSavedScenarios.length === 10) {
        return 'You haven\'t saved any scenarios.';
      }

      if (this.pagesWithNoSavedScenarios.length === 1) {
        noSavedScenariosText += this.pagesWithNoSavedScenarios[0] + '.';
        return noSavedScenariosText;
      }

      for (i = 0; i < this.pagesWithNoSavedScenarios.length - 1; i++) {
        noSavedScenariosText += this.pagesWithNoSavedScenarios[i] + ', ';
      }

      noSavedScenariosText += 'and ' + this.pagesWithNoSavedScenarios[i] + '.';
      return noSavedScenariosText;
    }
  }
});

/***/ }),

/***/ "x+YS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x4VW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_navbar__ = __webpack_require__("J56h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_sharable_url_modal__ = __webpack_require__("hu4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_save_scenario_modal__ = __webpack_require__("Nr+f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_share_url_service__ = __webpack_require__("yUUB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_utilities_utilities__ = __webpack_require__("g8te");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    'ppt-navbar': __WEBPACK_IMPORTED_MODULE_0__components_navbar__["a" /* default */],
    'ppt-footer': __WEBPACK_IMPORTED_MODULE_1__components_footer__["a" /* default */],
    'sharable-url-modal': __WEBPACK_IMPORTED_MODULE_2__components_sharable_url_modal__["a" /* default */],
    'save-scenario-modal': __WEBPACK_IMPORTED_MODULE_3__components_save_scenario_modal__["a" /* default */]
  },
  data: function data() {
    return {
      sharableUrl: {
        url: null,
        approximateWaitTime: null
      },
      saveScenarioVariables: {
        method: null,
        propertyName: null,
        state: null
      }
    };
  },
  computed: {
    onNarrowPage: function onNarrowPage() {
      return !!this.$route.meta.narrow;
    }
  },
  methods: {
    createSharableUrl: function createSharableUrl(payload) {
      var self = this;

      $(self.$el).find('.sharable-url-modal').modal();
      self.sharableUrl.url = '';
      self.approximateWaitTime = payload.approximateWaitTime ? payload.approximateWaitTime : null;
      __WEBPACK_IMPORTED_MODULE_4__services_share_url_service__["a" /* default */][payload.method](payload.state).then(function (response) {
        if (response.data.url) {
          self.sharableUrl.url = response.data.url;

          if (response.data.approximateWaitTime) {
            self.sharableUrl.approximateWaitTime = response.data.approximateWaitTime;
          }
        } else {
          alert('Didn\'t get url back from server.');
          throw new Error('Didn\'t get url back from server.');
        }
      }).catch(function () {
        alert('Problem trying to create the sharable URL.');
        throw new Error('Problem trying to create the sharable URL.');
      });
    },

    expandSaveScenarioModal: function expandSaveScenarioModal(payload) {
      $(this.$el).find('.save-scenario-modal').modal();
      this.saveScenarioVariables.method = payload.method;
      this.saveScenarioVariables.propertyName = payload.savedScenarioPropertyName;
      this.saveScenarioVariables.state = payload.state;
    },
    saveScenario: function saveScenario(title) {
      var self = this;
      var savedScenarioUrl = void 0;

      __WEBPACK_IMPORTED_MODULE_4__services_share_url_service__["a" /* default */][self.saveScenarioVariables.method](self.saveScenarioVariables.state).then(function getUrlForSavedScenario(response) {
        if (response.data.url) {
          return response.data.url;
        } else {
          alert('Problem trying to save the scenario.');
          throw new Error('Didn\'t get url back from server.');
        }
      }).then(function updateUserOnServer(url) {
        var newSavedScenarios = self._getNewSavedScenarios(title, url);
        var user = _.cloneDeep(self.$store.state.account.user);

        savedScenarioUrl = url;
        user.savedScenarios = newSavedScenarios;

        return self.$http.put("https://oddscalc.sixplusholdem.com/api" + '/user', { user: user });
      }).then(function updateUserOnClient(res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
        window.location.href = savedScenarioUrl;
      }).catch(function () {
        alert('Problem trying to save the scenario.');
        throw new Error('Problem trying to save the scenario.');
      });
    },
    _getNewSavedScenarios: function _getNewSavedScenarios(title, url) {
      var newSavedScenarios = _.cloneDeep(this.$store.state.account.user.savedScenarios);

      newSavedScenarios[this.saveScenarioVariables.propertyName].push({
        title: title,
        url: url
      });

      return newSavedScenarios;
    },
    updateScenario: function updateScenario(payload) {
      var storeState = __WEBPACK_IMPORTED_MODULE_4__services_share_url_service__["a" /* default */][payload.method](payload.state);

      this.$http.put("https://oddscalc.sixplusholdem.com/api" + '/update-sharable-url/' + this.$route.params.id, storeState).then(function () {
        alert('Successfully updated scenario.');
      }).catch(function () {
        alert('Error: unable to update scenario. Email contact@sixplusholdem.com for assistance.');
      });
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "xaqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'insights-header-cell',
  props: ['profitable']
});

/***/ }),

/***/ "xdGD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_final_conclusion_vue__ = __webpack_require__("KIUP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b9fcbc9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_final_conclusion_vue__ = __webpack_require__("mYmu");
function injectStyle (ssrContext) {
  __webpack_require__("Hjmd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b9fcbc9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_final_conclusion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b9fcbc9_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_final_conclusion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xfbN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quick-guide'
});

/***/ }),

/***/ "xfiN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xlOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_river_selector__ = __webpack_require__("alaU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_bluff_size_selector__ = __webpack_require__("+rnN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_conclusions_fold_equity_table__ = __webpack_require__("zFKT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__ = __webpack_require__("unvw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_bluff_help_range__ = __webpack_require__("PrIL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-bluff-river-steps',
  components: {
    'river-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_river_selector__["a" /* default */],
    'bluff-size-selector': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_bluff_bluff_size_selector__["a" /* default */],
    'fold-equity-table': __WEBPACK_IMPORTED_MODULE_2__components_guided_analyses_should_you_bluff_conclusions_fold_equity_table__["a" /* default */],
    'set-range-step': __WEBPACK_IMPORTED_MODULE_3__components_guided_analyses_set_range_step__["a" /* default */],
    'range-help-section': __WEBPACK_IMPORTED_MODULE_4__components_guided_analyses_should_you_bluff_help_range__["a" /* default */]
  },
  props: ['state', 'textWhenFiveCardHandPercentagesArentUpToDate', 'authorized'],
  computed: {
    showFoldEquityTable: function showFoldEquityTable() {
      return this.state.players.numPlayers === 1 && this.state.players.find(0).states[3].hitPercentageForDifferentRanges.length > 0 && this.state.streetToBluff === 'river' && this.state.presetCommunityCards.riverSet && !this.state.presetCommunityCards.pairedBoard;
    }
  },
  methods: {
    getTextForPlayerRangeStep: function getTextForPlayerRangeStep(playerIndex) {
      var numOpponents = this.state.players.numPlayers;

      if (this.state.streetToBluff === 'river') {
        if (numOpponents === 1) {
          return 'Step ' + (8 + numOpponents * 3 + playerIndex) + ': What do you think your opponent would continue with versus your ' + this.state.bluffSize + ' pot river bluff?';
        } else {
          return 'Step ' + (8 + numOpponents * 3 + playerIndex) + ': What do you think opponent #' + (playerIndex + 1) + ' would continue with versus your ' + this.state.bluffSize + ' pot river bluff?';
        }
      }
    }
  }
});

/***/ }),

/***/ "xlmv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_square__ = __webpack_require__("ZHcg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_constants__ = __webpack_require__("vjYN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'short-deck-grid-selector',
  components: {
    'grid-square': __WEBPACK_IMPORTED_MODULE_0__components_hand_range_grid_selector_grid_square__["a" /* default */]
  },
  props: ['generalHands', 'disabled', 'specificHandsNotAllowed', 'equityMatrix', 'requiredEquity', 'rangeConstructor'],
  data: function data() {
    var self = this;
    var data = {
      clickAndDragContext: null,
      altKeyPressed: false
    };

    $('body').on('mouseup', function () {
      if (self.$data && (self.$data.clickAndDragContext === 'adding' || self.$data.clickAndDragContext === 'removing')) {
        self.$emit('finishedClickAndDrag');
        self.$set(data, 'clickAndDragContext', null);
      }
    });

    $('body').keydown(function (event) {
      if (event.altKey) {
        self.$set(data, 'altKeyPressed', true);
      }
    }).keyup(function (event) {
      self.$set(data, 'altKeyPressed', false);
    });

    return data;
  },
  computed: {
    gridOfGeneralHands: function gridOfGeneralHands() {
      return __WEBPACK_IMPORTED_MODULE_2__services_constants__["a" /* default */].gridOfShortDeckGeneralHandStrings.map(function (rowOfGeneralHandStrings) {
        return this._getRowOfGeneralHands(rowOfGeneralHandStrings, this.generalHands);
      }, this);
    }
  },
  methods: {
    _getRowOfGeneralHands: function _getRowOfGeneralHands(rowOfGeneralHandStrings, generalHands) {
      return rowOfGeneralHandStrings.map(function (generalHandString) {
        return generalHands.find(generalHandString);
      });
    },
    selectGeneralHand: function selectGeneralHand(generalHandString) {
      this.$emit('selectGeneralHand', generalHandString);
      this.clickAndDragContext = 'adding';
    },
    deselectGeneralHand: function deselectGeneralHand(generalHandString) {
      this.$emit('deselectGeneralHand', generalHandString);
      this.clickAndDragContext = 'removing';
    },
    selectAscendingGeneralHands: function selectAscendingGeneralHands(generalHandStringOfGridSquareThatWasClicked) {
      var ascendingGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].hands.getAscendingGeneralHandStrings(generalHandStringOfGridSquareThatWasClicked);

      this.$emit('selectGeneralHands', ascendingGeneralHandStrings);
    },
    deselectAscendingGeneralHands: function deselectAscendingGeneralHands(generalHandStringOfGridSquareThatWasClicked) {
      var ascendingGeneralHandStrings = __WEBPACK_IMPORTED_MODULE_1__services_utilities_utilities__["a" /* default */].hands.getAscendingGeneralHandStrings(generalHandStringOfGridSquareThatWasClicked);

      this.$emit('deselectGeneralHands', ascendingGeneralHandStrings);
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("7t+N")))

/***/ }),

/***/ "xxe8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress five-card-hand-bar"},[_c('div',{staticClass:"progress-bar outer-bar",class:{
      'progress-bar-success': _vm.type === 'draws',
      'progress-bar-combo': _vm.type === 'combos',
    },style:('width: ' + _vm.width * _vm.percentageOfSpecificHandsThatAreSelectedAsDecimal + 'px')},[(_vm.probability >= 20 && _vm.percentagesOrCombos === 'percentages' && _vm.percentageOfSpecificHandsThatAreSelected > 35)?_c('span',{staticClass:"probability"},[_vm._v(_vm._s(_vm.probability)+"%")]):_vm._e(),_vm._v(" "),(_vm.probability >= 15 && _vm.percentagesOrCombos === 'combos' && _vm.percentageOfSpecificHandsThatAreSelected > 35)?_c('span',{staticClass:"num-combos"},[_vm._v(_vm._s(_vm.numCombos))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"progress-bar progress-bar-empty inner-bar",style:('width: ' + _vm.width * (1 - _vm.percentageOfSpecificHandsThatAreSelectedAsDecimal) + 'px')},[(_vm.probability >= 20 && _vm.percentagesOrCombos === 'percentages' && _vm.percentageOfSpecificHandsThatAreSelected <= 35)?_c('span',{staticClass:"probability"},[_vm._v(_vm._s(_vm.probability)+"%")]):_vm._e(),_vm._v(" "),(_vm.probability >= 15 && _vm.percentagesOrCombos === 'combos' && _vm.percentageOfSpecificHandsThatAreSelected <= 35)?_c('span',{staticClass:"num-combos"},[_vm._v(_vm._s(_vm.numCombos))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y2Mo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-call-flop-steps"},[_c('section',[_c('h4',[_vm._v("Step "+_vm._s(4 + _vm.state.players.numPlayers)+": What are the flop cards?")]),_vm._v(" "),_c('flop-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)},"setBoard":function($event){return _vm.$emit('setBoard', $event)}}})],1),_vm._v(" "),(_vm.state.streetToCall === 'flop' && _vm.state.presetCommunityCards.flopSet)?_c('section',[_c('pot-odds-selector',{attrs:{"numOpponents":_vm.state.players.numPlayers,"streetToCall":_vm.state.streetToCall,"potOdds":_vm.state.potOdds,"authorized":_vm.authorized},on:{"setPotOdds":function($event){return _vm.$emit('setPotOdds', $event)}}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.flopSet)?_c('section',_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('set-range-step',{key:player.key,attrs:{"textForStep":_vm.getTextForPlayerRangeStep(playerIndex),"player":player,"playerIndex":playerIndex,"playerStateIndex":1,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"storeModuleName":'guidedAnalysesCalling',"authorized":_vm.authorized}},[(_vm.state.streetToCall === 'flop')?_c('flop-selector',{staticClass:"board-cards-selector",attrs:{"slot":"boardCardsSelector","presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"popoverDirectionClass":'dropdown',"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)},"setBoard":function($event){return _vm.$emit('setBoard', $event)}},slot:"boardCardsSelector"}):_vm._e(),_vm._v(" "),_c('range-help-section',{attrs:{"slot":"rangeHelpSection","playerStateIndex":1,"streetToCall":_vm.state.streetToCall},slot:"rangeHelpSection"})],1)}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y6m+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-call-preflop-steps"},_vm._l((_vm.players._players),function(player,playerIndex){return _c('set-range-step',{key:player.id,ref:'setRangeStep-' + playerIndex,refInFor:true,attrs:{"textForStep":_vm.getTextForPlayerRangeStep(playerIndex),"player":player,"playerIndex":playerIndex,"playerStateIndex":0,"presetCommunityCards":_vm.presetCommunityCards,"storeModuleName":'guidedAnalysesCalling',"authorized":_vm.authorized}},[_c('range-help-section',{attrs:{"slot":"rangeHelpSection","playerStateIndex":0,"streetToCall":_vm.streetToCall},slot:"rangeHelpSection"})],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y8dE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("SoXG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578ed93c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("I4Dr");
function injectStyle (ssrContext) {
  __webpack_require__("EbGa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-578ed93c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578ed93c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yEoP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yO/q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"visual-settings settings"},[_vm._m(0),_vm._v(" "),_c('h3',[_vm._v("Grid square colors")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gridSquareColors),expression:"gridSquareColors"}],attrs:{"type":"radio","value":"multicolored"},domProps:{"checked":_vm._q(_vm.gridSquareColors,"multicolored")},on:{"change":function($event){_vm.gridSquareColors="multicolored"}}}),_vm._v("\n          Multicolored grid squares\n          "),_c('img',{attrs:{"src":"/static/settings/visual/multicolored-grid-squares.png"}}),_vm._v("\n          Advantages:\n          "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gridSquareColors),expression:"gridSquareColors"}],attrs:{"type":"radio","value":"green"},domProps:{"checked":_vm._q(_vm.gridSquareColors,"green")},on:{"change":function($event){_vm.gridSquareColors="green"}}}),_vm._v("\n          Green grid squares\n          "),_c('img',{attrs:{"src":"/static/settings/visual/green-grid-squares.png"}}),_vm._v("\n          Advantages:\n          "),_vm._m(2)])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Show number of combos in range?")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.areNumCombosInRangeVisible),expression:"areNumCombosInRangeVisible"}],attrs:{"type":"radio","value":"false"},domProps:{"checked":_vm._q(_vm.areNumCombosInRangeVisible,"false")},on:{"change":function($event){_vm.areNumCombosInRangeVisible="false"}}}),_vm._v("\n          Don't show number of combos in range\n          "),_c('img',{attrs:{"src":"/static/settings/visual/dont-show-num-combos-in-range.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.areNumCombosInRangeVisible),expression:"areNumCombosInRangeVisible"}],attrs:{"type":"radio","value":"true"},domProps:{"checked":_vm._q(_vm.areNumCombosInRangeVisible,"true")},on:{"change":function($event){_vm.areNumCombosInRangeVisible="true"}}}),_vm._v("\n          Show number of combos in range\n          "),_c('img',{attrs:{"src":"/static/settings/visual/show-num-combos-in-range.png"}})])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Setting hand weights")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingHandWeights),expression:"settingHandWeights"}],attrs:{"type":"radio","value":"verticalSetWeightToApplyToAddedHandsSliderBasic"},domProps:{"checked":_vm._q(_vm.settingHandWeights,"verticalSetWeightToApplyToAddedHandsSliderBasic")},on:{"change":function($event){_vm.settingHandWeights="verticalSetWeightToApplyToAddedHandsSliderBasic"}}}),_vm._v("\n          Vertical set weight to apply to added hands (basic)\n        ")])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingHandWeights),expression:"settingHandWeights"}],attrs:{"type":"radio","value":"verticalSetWeightToApplyToAddedHandsSliderWithSettings"},domProps:{"checked":_vm._q(_vm.settingHandWeights,"verticalSetWeightToApplyToAddedHandsSliderWithSettings")},on:{"change":function($event){_vm.settingHandWeights="verticalSetWeightToApplyToAddedHandsSliderWithSettings"}}}),_vm._v("\n          Vertical set weight to apply to added hands with settings\n        ")])]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.settingHandWeights),expression:"settingHandWeights"}],attrs:{"type":"radio","value":"setWeightToApplyToAddedHandsModal"},domProps:{"checked":_vm._q(_vm.settingHandWeights,"setWeightToApplyToAddedHandsModal")},on:{"change":function($event){_vm.settingHandWeights="setWeightToApplyToAddedHandsModal"}}}),_vm._v("\n          Set weight to apply to added hands modal\n        ")])]),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Visual")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Easily distinguish between suited, offsuit and paired hands")]),_vm._v(" "),_c('li',[_vm._v("More aesthetically pleasing?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Easily tell how many combos of the grid square are in range")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/SUGkNdLVo0M?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/NABjiewbPxY?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"embed-responsive embed-responsive-16by9"},[_c('iframe',{staticClass:"embed-responsive-item",attrs:{"width":"560","height":"315","src":"https://www.youtube.com/embed/g0G6bIToh_A?rel=0&showinfo=0","frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ySRE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Forgot your password? Enter your email below and you'll receive an email with instructions for setting a new one.")]),_vm._v(" "),_c('section',{staticClass:"form-group",class:{ 'has-error': (_vm.submitAttempted && _vm.emailErrorMessage) }},[_c('label',{staticClass:"control-label"},[_vm._v("\n      Email\n      "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"form-control input-lg",attrs:{"required":"","type":"email","autofocus":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),(_vm.submitAttempted && _vm.emailErrorMessage)?_c('p',{staticClass:"help-block"},[_vm._v("\n      "+_vm._s(_vm.emailErrorMessage)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg btn-block",on:{"click":function($event){$event.preventDefault();return _vm.submit()}}},[_vm._v("\n    Reset my password\n  ")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Forgot password")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yUUB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_player_Player__ = __webpack_require__("YxBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_hands_GeneralHands__ = __webpack_require__("udlG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);






/* harmony default export */ __webpack_exports__["a"] = ({
  createSharableEquityCalculatorURL: function createSharableEquityCalculatorURL(storeState) {
    var data = this._constructEquityCalculatorData(storeState);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post("https://oddscalc.sixplusholdem.com/api" + '/create-sharable-url', data);
  },
  createSharableHitCalculatorURL: function createSharableHitCalculatorURL(storeState) {
    var data = this._constructHitCalculatorData(storeState);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post("https://oddscalc.sixplusholdem.com/api" + '/create-sharable-url', data);
  },
  createSharableGuidedAnalysesBluffingURL: function createSharableGuidedAnalysesBluffingURL(storeState) {
    var data = this._constructGuidedAnalysesBluffingData(storeState);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post("https://oddscalc.sixplusholdem.com/api" + '/create-sharable-url', data);
  },
  createSharableGuidedAnalysesCallingURL: function createSharableGuidedAnalysesCallingURL(storeState) {
    var data = this._constructGuidedAnalysesCallingData(storeState);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post("https://oddscalc.sixplusholdem.com/api" + '/create-sharable-url', data);
  },
  createSharableRangeConstructorURL: function createSharableRangeConstructorURL(storeState) {
    var data = this._constructRangeConstructorData(storeState);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post("https://oddscalc.sixplusholdem.com/api" + '/create-sharable-url', data);
  },
  createSharableEquityMatrixURL: function createSharableEquityMatrixURL(storeState) {
    var data = this._constructEquityMatrixData(storeState);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post("https://oddscalc.sixplusholdem.com/api" + '/create-sharable-url', data);
  },
  createSharableTurnBluffBreakevenPercentageURL: function createSharableTurnBluffBreakevenPercentageURL(state) {
    var data = this._constructTurnBluffBreakevenPercentageData(state);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post("https://oddscalc.sixplusholdem.com/api" + '/create-sharable-url', data);
  },
  createSharableThreeBetCbetExplorerURL: function createSharableThreeBetCbetExplorerURL(storeState) {
    var data = this._constructThreeBetCbetExplorerData(storeState);

    return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].axios.post("https://oddscalc.sixplusholdem.com/api" + '/create-sharable-url', data);
  },
  _constructEquityCalculatorData: function _constructEquityCalculatorData(storeState) {
    var players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        equity: playerFromStore.states[0].equity,
        winPercentage: playerFromStore.states[0].winPercentage,
        tiePercentage: playerFromStore.states[0].tiePercentage,
        specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
        specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
        numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
        numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands
      });
    }, this);

    return {
      type: 'equity-calculator',
      storeState: {
        presetCommunityCards: storeState.presetCommunityCards,
        players: players
      }
    };
  },
  _constructHitCalculatorData: function _constructHitCalculatorData(storeState) {
    var players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        states: [{
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands,
          equity: playerFromStore.states[0].equity,
          winPercentage: playerFromStore.states[0].winPercentage,
          tiePercentage: playerFromStore.states[0].tiePercentage
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[1].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[1].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[1].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[1].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[1].fiveCardHands),
          equity: playerFromStore.states[1].equity,
          winPercentage: playerFromStore.states[1].winPercentage,
          tiePercentage: playerFromStore.states[1].tiePercentage
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[2].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[2].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[2].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[2].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[2].fiveCardHands),
          equity: playerFromStore.states[2].equity,
          winPercentage: playerFromStore.states[2].winPercentage,
          tiePercentage: playerFromStore.states[2].tiePercentage
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[3].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[3].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[3].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[3].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[3].fiveCardHands),
          equity: playerFromStore.states[3].equity,
          winPercentage: playerFromStore.states[3].winPercentage,
          tiePercentage: playerFromStore.states[3].tiePercentage
        }]
      });
    }, this);

    return {
      type: 'hit-calculator',
      storeState: {
        presetHoleCards: storeState.presetHoleCards,
        presetCommunityCards: storeState.presetCommunityCards,
        players: players
      }
    };
  },
  _constructGuidedAnalysesBluffingData: function _constructGuidedAnalysesBluffingData(storeState) {
    var players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        states: [{
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[1].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[1].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[1].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[1].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[1].fiveCardHands)
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[2].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[2].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[2].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[2].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[2].fiveCardHands)
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[3].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[3].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[3].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[3].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[3].fiveCardHands)
        }]
      });
    }, this);

    return {
      type: 'guided-analyses/should-you-bluff',
      storeState: {
        presetHoleCards: storeState.presetHoleCards,
        presetCommunityCards: storeState.presetCommunityCards,
        players: players,
        streetToBluff: storeState.streetToBluff,
        bluffSize: storeState.bluffSize,
        profitableBreakevenPercentage: storeState.profitableBreakevenPercentage
      }
    };
  },
  _constructGuidedAnalysesCallingData: function _constructGuidedAnalysesCallingData(storeState) {
    var players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        states: [{
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[1].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[1].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[1].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[1].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[1].fiveCardHands)
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[2].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[2].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[2].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[2].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[2].fiveCardHands)
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[3].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[3].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[3].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[3].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[3].fiveCardHands)
        }]
      });
    }, this);

    return {
      type: 'guided-analyses/should-you-call',
      storeState: {
        presetHoleCards: storeState.presetHoleCards,
        presetCommunityCards: storeState.presetCommunityCards,
        players: players,
        streetToCall: storeState.streetToCall,
        potOdds: storeState.potOdds,
        realOddsLHS: storeState.realOddsLHS,
        bettingCriteria: storeState.bettingCriteria
      }
    };
  },
  _constructRangeConstructorData: function _constructRangeConstructorData(storeState) {
    return {
      type: 'range-constructor',
      storeState: {
        generalHandStringColorMap: this.__getGeneralHandStringColorMap(storeState.generalHands),
        actions: storeState.actions
      }
    };
  },
  _constructEquityMatrixData: function _constructEquityMatrixData(storeState) {
    var players = [];
    var generalHandStringEquityMap = void 0;

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
        specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
        numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
        numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands
      });
    }, this);
    generalHandStringEquityMap = this.__getGeneralHandStringEquityMap(storeState.resultGeneralHands);

    return {
      type: 'equity-matrix',
      storeState: {
        requiredEquity: storeState.requiredEquity,
        presetCommunityCards: storeState.presetCommunityCards,
        players: players,
        generalHandStringEquityMap: generalHandStringEquityMap
      }
    };
  },
  _constructTurnBluffBreakevenPercentageData: function _constructTurnBluffBreakevenPercentageData(state) {
    return {
      type: 'breakeven-percentage-for-bluffing-the-turn',
      storeState: state
    };
  },
  _constructThreeBetCbetExplorerData: function _constructThreeBetCbetExplorerData(storeState) {
    var players = [];

    storeState.players.forEach(function (playerFromStore) {
      players.push({
        states: [{
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[0].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[0].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[0].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[0].generalHands.numberOfPossibleSpecificHands
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[1].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[1].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[1].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[1].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[1].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[1].fiveCardHands)
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[2].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[2].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[2].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[2].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[2].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[2].fiveCardHands)
        }, {
          specificHandsInRange: this.__getSpecificHandsInRange(playerFromStore.states[3].generalHands),
          specificHandStringsWithMaxPossibleWeightSet: this.__getSpecificHandStringsWithMaxPossibleWeightSet(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyAdded: this.__getSpecificHandStringsThatAreManuallyAdded(playerFromStore.states[3].generalHands),
          specificHandStringsThatAreManuallyRemoved: this.__getSpecificHandStringsThatAreManuallyRemoved(playerFromStore.states[3].generalHands),
          numberOfSpecificHandsInRange: playerFromStore.states[3].generalHands.numberOfSpecificHandsInRange,
          numberOfPossibleSpecificHands: playerFromStore.states[3].generalHands.numberOfPossibleSpecificHands,
          fiveCardHands: this.__constructFiveCardHandsForServer(playerFromStore.states[3].fiveCardHands)
        }]
      });
    }, this);

    return {
      type: 'three-bet-cbet-explorer',
      storeState: {
        players: players,
        presetCommunityCards: storeState.presetCommunityCards,
        openSize: storeState.openSize,
        threeBetSize: storeState.threeBetSize,
        numPlayersLeftToAct: storeState.numPlayersLeftToAct,
        averageFourBetPercentage: storeState.averageFourBetPercentage,
        cbetSize: storeState.cbetSize,
        continueVsCbetPercentage: storeState.continueVsCbetPercentage,
        hitPercentage: storeState.hitPercentage,
        firstStreetOfValuePercentage: storeState.firstStreetOfValuePercentage,
        secondStreetOfValuePercentage: storeState.secondStreetOfValuePercentage,
        thirdStreetOfValuePercentage: storeState.thirdStreetOfValuePercentage,
        alternativeEV: storeState.alternativeEV
      }
    };
  },
  __getSpecificHandsInRange: function __getSpecificHandsInRange(generalHands) {
    var specificHandsInRange = [];

    generalHands.forEachSpecificHandInRange(function (specificHand) {
      specificHandsInRange.push(specificHand.string + '-' + specificHand.weight);
    });

    return specificHandsInRange;
  },
  __getSpecificHandStringsWithMaxPossibleWeightSet: function __getSpecificHandStringsWithMaxPossibleWeightSet(generalHands) {
    var specificHandStringsWithMaxPossibleWeightSet = [];

    generalHands.forEachSpecificHand(function (specificHand) {
      if (specificHand.maxPossibleWeight < 100) {
        specificHandStringsWithMaxPossibleWeightSet.push(specificHand.string + '-' + specificHand.maxPossibleWeight);
      }
    });

    return specificHandStringsWithMaxPossibleWeightSet;
  },
  __getSpecificHandStringsThatAreManuallyAdded: function __getSpecificHandStringsThatAreManuallyAdded(generalHands) {
    var specificHandStringsThatAreManuallyAdded = [];

    generalHands.forEachPossibleSpecificHand(function (specificHand) {
      if (specificHand.manuallySet === 'added') {
        specificHandStringsThatAreManuallyAdded.push(specificHand.string);
      }
    });

    return specificHandStringsThatAreManuallyAdded;
  },
  __getSpecificHandStringsThatAreManuallyRemoved: function __getSpecificHandStringsThatAreManuallyRemoved(generalHands) {
    var specificHandStringsThatAreManuallyRemoved = [];

    generalHands.forEachPossibleSpecificHand(function (specificHand) {
      if (specificHand.manuallySet === 'removed') {
        specificHandStringsThatAreManuallyRemoved.push(specificHand.string);
      }
    });

    return specificHandStringsThatAreManuallyRemoved;
  },
  __constructFiveCardHandsForServer: function __constructFiveCardHandsForServer(fiveCardHands) {
    var fiveCardHandsForServer = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.cloneDeep(fiveCardHands);

    __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.forEachLeaf(fiveCardHandsForServer.madeHands.data, function (leaf) {
      delete leaf.id;
      delete leaf.text;
      delete leaf.fullText;
      delete leaf.inlineText;
      delete leaf.count;
      delete leaf.included;
      delete leaf._probability;
      delete leaf.level;
      delete leaf.madeHandDrawOrCombo;
      delete leaf.isAHit;
    });
    __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.forEachParent(fiveCardHandsForServer.madeHands.data, function (parent) {
      delete parent.id;
      delete parent.text;
      delete parent.fullText;
      delete parent.inlineText;
      delete parent.count;
      delete parent._probability;
      delete parent.level;
      delete parent.isAHit;
    });
    __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.forEachLeaf(fiveCardHandsForServer.draws.data, function (leaf) {
      delete leaf.id;
      delete leaf.text;
      delete leaf.fullText;
      delete leaf.inlineText;
      delete leaf.count;
      delete leaf.included;
      delete leaf._probability;
      delete leaf.level;
      delete leaf.madeHandDrawOrCombo;
      delete leaf.isAHit;
    });
    __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.forEachParent(fiveCardHandsForServer.draws.data, function (parent) {
      delete parent.id;
      delete parent.text;
      delete parent.fullText;
      delete parent.inlineText;
      delete parent.count;
      delete parent._probability;
      delete parent.level;
      delete parent.isAHit;
    });
    __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.forEachLeaf(fiveCardHandsForServer.combos.data, function (leaf) {
      delete leaf.id;
      delete leaf.text;
      delete leaf.fullText;
      delete leaf.inlineText;
      delete leaf.count;
      delete leaf.included;
      delete leaf._probability;
      delete leaf.level;
      delete leaf.madeHandDrawOrCombo;
      delete leaf.isAHit;
    });
    __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.forEachParent(fiveCardHandsForServer.combos.data, function (parent) {
      delete parent.id;
      delete parent.text;
      delete parent.fullText;
      delete parent.inlineText;
      delete parent.count;
      delete parent._probability;
      delete parent.level;
      delete parent.isAHit;
    });

    return fiveCardHandsForServer;
  },
  __getGeneralHandStringColorMap: function __getGeneralHandStringColorMap(generalHands) {
    var generalHandStringColorMap = {
      green: [],
      blue: [],
      red: [],
      yellow: [],
      orange: [],
      purple: [],
      brown: [],
      impossible: []
    };

    generalHands.forEach(function (generalHand) {
      if (generalHand.color === null) {
        return;
      }

      generalHandStringColorMap[generalHand.color].push(generalHand.string);
    });

    return generalHandStringColorMap;
  },
  __getGeneralHandStringEquityMap: function __getGeneralHandStringEquityMap(generalHands) {
    var generalHandStringEquityMap = {};

    generalHands.forEach(function (generalHand) {
      generalHandStringEquityMap[generalHand.string] = generalHand.equity;
    });

    return generalHandStringEquityMap;
  },
  setEquityCalculatorStoreState: function setEquityCalculatorStoreState(newStateFromServer, currentState) {
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setEquityCalculatorPlayers(newStateFromServer, currentState);
    this._setEquityCalculatorPlayersEquityWinAndTie(newStateFromServer, currentState);
  },
  _setPresetCommunityCards: function _setPresetCommunityCards(newStateFromServer, currentState) {
    currentState.presetCommunityCards.flop1 = newStateFromServer.presetCommunityCards.flop1 || null;
    currentState.presetCommunityCards.flop2 = newStateFromServer.presetCommunityCards.flop2 || null;
    currentState.presetCommunityCards.flop3 = newStateFromServer.presetCommunityCards.flop3 || null;
    currentState.presetCommunityCards.turn = newStateFromServer.presetCommunityCards.turn || null;
    currentState.presetCommunityCards.river = newStateFromServer.presetCommunityCards.river || null;
  },
  _setEquityCalculatorPlayers: function _setEquityCalculatorPlayers(newStateFromServer, currentState) {
    for (var i = 0; i < newStateFromServer.players.length; i++) {
      this.__setEquityCalculatorPlayer(newStateFromServer, currentState, i);
    }
  },
  __setEquityCalculatorPlayer: function __setEquityCalculatorPlayer(newStateFromServer, currentState, i) {
    var playerFromServer = newStateFromServer.players[i];
    var newPlayer = new __WEBPACK_IMPORTED_MODULE_1__services_player_Player__["a" /* default */]();

    this.___setGeneralHands(newPlayer.states[0].generalHands, Number(playerFromServer.numberOfSpecificHandsInRange), Number(playerFromServer.numberOfPossibleSpecificHands), playerFromServer.specificHandsInRange, playerFromServer.specificHandStringsWithMaxPossibleWeightSet);
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(currentState.players._players, i, newPlayer);
  },
  ___setGeneralHands: function ___setGeneralHands(newGeneralHands, numberOfSpecificHandsInRange, numberOfPossibleSpecificHands, specificHandsInRange, specificHandStringsWithMaxPossibleWeightSet, specificHandStringsThatAreManuallyAdded, specificHandStringsThatAreManuallyRemoved) {
    newGeneralHands.numberOfSpecificHandsInRange = numberOfSpecificHandsInRange;
    newGeneralHands.numberOfPossibleSpecificHands = numberOfPossibleSpecificHands;

    if (specificHandStringsWithMaxPossibleWeightSet) {
      this.____setMaxPossibleWeights(newGeneralHands, specificHandStringsWithMaxPossibleWeightSet);
    }

    this.____setWeights(newGeneralHands, specificHandsInRange);

    if (specificHandStringsThatAreManuallyAdded || specificHandStringsThatAreManuallyRemoved) {
      this.____setManuallySet(newGeneralHands, specificHandStringsThatAreManuallyAdded, specificHandStringsThatAreManuallyRemoved);
    }
  },
  ____setWeights: function ____setWeights(newGeneralHands, specificHandsInRange) {
    if (!specificHandsInRange) return; // if empty array, db field is empty rather than holding an empty array

    specificHandsInRange.forEach(function (specificHandInRange) {
      var split = specificHandInRange.split('-');
      var specificHandString = split[0];
      var weight = Number(split[1]);
      var newSpecificHand = newGeneralHands.find(specificHandString);

      newSpecificHand.weight = weight;
    });
  },
  ____setMaxPossibleWeights: function ____setMaxPossibleWeights(newGeneralHands, specificHandStringsWithMaxPossibleWeightSet) {
    newGeneralHands.forEachSpecificHand(function (newSpecificHand) {
      newSpecificHand.maxPossibleWeight = 100;
    });
    specificHandStringsWithMaxPossibleWeightSet.forEach(function (specificHandStringWithMaxPossibleWeight) {
      var split = specificHandStringWithMaxPossibleWeight.split('-');
      var specificHandString = split[0];
      var maxPossibleWeight = Number(split[1]);
      var newSpecificHand = newGeneralHands.find(specificHandString);

      newSpecificHand.maxPossibleWeight = maxPossibleWeight;
    });
  },
  ____setManuallySet: function ____setManuallySet(newGeneralHands, specificHandStringsThatAreManuallyAdded, specificHandStringsThatAreManuallyRemoved) {
    newGeneralHands.forEachSpecificHand(function (newSpecificHand, specificHandString) {
      if (specificHandStringsThatAreManuallyAdded && specificHandStringsThatAreManuallyAdded.includes(specificHandString)) {
        newSpecificHand.manuallySet = 'added';
      } else if (specificHandStringsThatAreManuallyRemoved && specificHandStringsThatAreManuallyRemoved.includes(specificHandString)) {
        newSpecificHand.manuallySet = 'removed';
      } else {
        newSpecificHand.manuallySet = false;
      }
    });
  },
  _setEquityCalculatorPlayersEquityWinAndTie: function _setEquityCalculatorPlayersEquityWinAndTie(newStateFromServer, currentState) {
    for (var i = 0; i < newStateFromServer.players.length; i++) {
      currentState.players.find(i).states[0].equity = newStateFromServer.players[i].equity;
      currentState.players.find(i).states[0].winPercentage = newStateFromServer.players[i].winPercentage;
      currentState.players.find(i).states[0].tiePercentage = newStateFromServer.players[i].tiePercentage;
    }
  },
  setHitCalculatorStoreState: function setHitCalculatorStoreState(newStateFromServer, currentState) {
    this._setPresetHoleCards(newStateFromServer, currentState);
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setHitCalculatorPlayers(newStateFromServer, currentState);
  },
  _setPresetHoleCards: function _setPresetHoleCards(newStateFromServer, currentState) {
    currentState.presetHoleCards.holeCardOne = newStateFromServer.presetHoleCards.holeCardOne;
    currentState.presetHoleCards.holeCardTwo = newStateFromServer.presetHoleCards.holeCardTwo;
  },
  _setHitCalculatorPlayers: function _setHitCalculatorPlayers(newStateFromServer, currentState) {
    for (var i = 0; i < newStateFromServer.players.length; i++) {
      this.__setHitCalculatorPlayer(newStateFromServer, currentState, i);
    }
  },
  __setHitCalculatorPlayer: function __setHitCalculatorPlayer(newStateFromServer, currentState, i) {
    var playerFromServer = newStateFromServer.players[i];
    var newPlayer = new __WEBPACK_IMPORTED_MODULE_1__services_player_Player__["a" /* default */]();

    for (var j = 0; j < newPlayer.states.length; j++) {
      this.___setPlayerState(newPlayer.states[j], playerFromServer.states[j]);
    }

    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(currentState.players._players, i, newPlayer);
  },
  ___setPlayerState: function ___setPlayerState(newPlayerState, playerFromServerState) {
    if (newPlayerState.name === 'afterPreflop') {
      this.___setGeneralHands(newPlayerState.generalHands, Number(playerFromServerState.numberOfSpecificHandsInRange), Number(playerFromServerState.numberOfPossibleSpecificHands), playerFromServerState.specificHandsInRange, playerFromServerState.specificHandStringsWithMaxPossibleWeightSet);
    } else {
      this.___setGeneralHands(newPlayerState.generalHands, Number(playerFromServerState.numberOfSpecificHandsInRange), Number(playerFromServerState.numberOfPossibleSpecificHands), playerFromServerState.specificHandsInRange, playerFromServerState.specificHandStringsWithMaxPossibleWeightSet, playerFromServerState.specificHandStringsThatAreManuallyAdded, playerFromServerState.specificHandStringsThatAreManuallyRemoved);
      this.____setFiveCardHands(newPlayerState.fiveCardHands, playerFromServerState.fiveCardHands);
    }

    newPlayerState.equity = playerFromServerState.equity;
    newPlayerState.winPercentage = playerFromServerState.winPercentage;
    newPlayerState.tiePercentage = playerFromServerState.tiePercentage;
  },
  ____setFiveCardHands: function ____setFiveCardHands(newFiveCardHands, fiveCardHandsFromServer) {
    this._____setFiveCardHandsCategory(newFiveCardHands.madeHands, fiveCardHandsFromServer.madeHands);
    this._____setFiveCardHandsCategory(newFiveCardHands.draws, fiveCardHandsFromServer.draws);
    this._____setFiveCardHandsCategory(newFiveCardHands.combos, fiveCardHandsFromServer.combos);
  },
  _____setFiveCardHandsCategory: function _____setFiveCardHandsCategory(newFiveCardHandsOfCategory, fiveCardHandsOfCategoryFromServer) {
    newFiveCardHandsOfCategory.forEachLeaf(function (newFiveCardHandLeaf, indexes) {
      var fiveCardHandLeafFromServer = __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(fiveCardHandsOfCategoryFromServer.data, indexes);

      newFiveCardHandLeaf.weight = Number(fiveCardHandLeafFromServer._weight);
    });
    newFiveCardHandsOfCategory.forEachParent(function (newMadeHandParent, indexes) {
      var madeHandParentFromServer = __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].general.getArrayItemFromArrayOfIndexes(fiveCardHandsOfCategoryFromServer.data, indexes);

      newMadeHandParent.collapsed = madeHandParentFromServer.collapsed === true;
    });
  },
  setGuidedAnalysesBluffingStoreState: function setGuidedAnalysesBluffingStoreState(newStateFromServer, currentState) {
    this._setPresetHoleCards(newStateFromServer, currentState);
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setGuidedAnalysesPlayers(newStateFromServer, currentState);
    currentState.streetToBluff = newStateFromServer.streetToBluff;
    currentState.bluffSize = newStateFromServer.bluffSize;
    currentState.profitableBreakevenPercentage = newStateFromServer.profitableBreakevenPercentage;
  },
  setGuidedAnalysesCallingStoreState: function setGuidedAnalysesCallingStoreState(newStateFromServer, currentState) {
    this._setPresetHoleCards(newStateFromServer, currentState);
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setGuidedAnalysesPlayers(newStateFromServer, currentState);
    currentState.streetToCall = newStateFromServer.streetToCall;
    currentState.potOdds = newStateFromServer.potOdds;
    currentState.realOddsLHS = newStateFromServer.realOddsLHS;
    this._setBettingCriteria(newStateFromServer, currentState);
  },
  _setGuidedAnalysesPlayers: function _setGuidedAnalysesPlayers(newStateFromServer, currentState) {
    for (var i = 0; i < newStateFromServer.players.length; i++) {
      this.__setGuidedAnalysesPlayer(newStateFromServer, currentState, i);
    }
  },
  __setGuidedAnalysesPlayer: function __setGuidedAnalysesPlayer(newStateFromServer, currentState, i) {
    var playerFromServer = newStateFromServer.players[i];
    var newPlayer = new __WEBPACK_IMPORTED_MODULE_1__services_player_Player__["a" /* default */]();

    for (var j = 0; j < newPlayer.states.length; j++) {
      this.___setPlayerState(newPlayer.states[j], playerFromServer.states[j]);
    }

    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(currentState.players._players, i, newPlayer);
  },
  _setBettingCriteria: function _setBettingCriteria(newStateFromServer, currentState) {
    if (!newStateFromServer.bettingCriteria) {
      return;
    }

    currentState.bettingCriteria = newStateFromServer.bettingCriteria;

    for (var flopTurnRiver in newStateFromServer.bettingCriteria) {
      for (var valueBetToBluffRatio in newStateFromServer.bettingCriteria[flopTurnRiver]) {
        newStateFromServer.bettingCriteria[flopTurnRiver][valueBetToBluffRatio].forEach(function (bettingCriterion) {
          if (bettingCriterion.equity === '') {
            bettingCriterion.equity = null;
          }
        });
      }
    }
  },
  setRangeConstructorStoreState: function setRangeConstructorStoreState(newStateFromServer, currentState) {
    currentState.actions = newStateFromServer.actions;
    this._setRangeConstructorGeneralHands(newStateFromServer, currentState);
  },
  _setRangeConstructorGeneralHands: function _setRangeConstructorGeneralHands(newStateFromServer, currentState) {
    var newGeneralHands = new __WEBPACK_IMPORTED_MODULE_2__services_hands_GeneralHands__["a" /* default */]();
    var generalHand = void 0;

    var _loop = function _loop(color) {
      newStateFromServer.generalHandStringColorMap[color].forEach(function (generalHandString) {
        generalHand = newGeneralHands.find(generalHandString);
        generalHand.color = color;
        generalHand.forEachSpecificHand(function (specificHand) {
          specificHand.weight = 100;
        });
      });
    };

    for (var color in newStateFromServer.generalHandStringColorMap) {
      _loop(color);
    }

    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].set(currentState, 'generalHands', newGeneralHands);
  },
  setEquityMatrixStoreState: function setEquityMatrixStoreState(newStateFromServer, currentState) {
    currentState.requiredEquity = newStateFromServer.requiredEquity;
    this._setPresetCommunityCards(newStateFromServer, currentState);
    this._setEquityCalculatorPlayers(newStateFromServer, currentState);
    this._setResultGeneralHands(newStateFromServer.generalHandStringEquityMap, currentState.resultGeneralHands);
  },
  _setResultGeneralHands: function _setResultGeneralHands(generalHandStringEquityMap, resultGeneralHands) {
    resultGeneralHands.forEach(function (generalHand) {
      generalHand.equity = generalHandStringEquityMap[generalHand.string];
    });
  },
  setThreeBetCbetStoreState: function setThreeBetCbetStoreState(newStateFromServer, currentState) {
    this._setGuidedAnalysesPlayers(newStateFromServer, currentState);
    this._setPresetCommunityCards(newStateFromServer, currentState);
    currentState.openSize = newStateFromServer.openSize;
    currentState.threeBetSize = newStateFromServer.threeBetSize;
    currentState.numPlayersLeftToAct = newStateFromServer.numPlayersLeftToAct;
    currentState.averageFourBetPercentage = newStateFromServer.averageFourBetPercentage;
    currentState.cbetSize = newStateFromServer.cbetSize;
    currentState.continueVsCbetPercentage = newStateFromServer.continueVsCbetPercentage;
    currentState.hitPercentage = newStateFromServer.hitPercentage;
    currentState.firstStreetOfValuePercentage = newStateFromServer.firstStreetOfValuePercentage;
    currentState.secondStreetOfValuePercentage = newStateFromServer.secondStreetOfValuePercentage;
    currentState.thirdStreetOfValuePercentage = newStateFromServer.thirdStreetOfValuePercentage;
    currentState.alternativeEV = newStateFromServer.alternativeEV;
  },
  setBreakevenPercentageForBluffingTheTurnStoreState: function setBreakevenPercentageForBluffingTheTurnStoreState(newStateFromServer, currentState) {
    currentState.turnPotSize = newStateFromServer.turnPotSize;
    currentState.turnBetSize = newStateFromServer.turnBetSize;
    currentState.numberOfOuts = newStateFromServer.numberOfOuts;
    currentState.percentageOfPotWonOnRiverWhenYouHitAnOut = newStateFromServer.percentageOfPotWonOnRiverWhenYouHitAnOut;
    currentState.numRiverCardsYoullBluff = newStateFromServer.numRiverCardsYoullBluff;
    currentState.riverBluffSize = newStateFromServer.riverBluffSize;
    currentState.probabilityOfGettingFoldOnRiver = newStateFromServer.probabilityOfGettingFoldOnRiver;
    currentState.position = newStateFromServer.position;
    currentState.probabilityThatOpponentBetsWhenYouCheck = newStateFromServer.probabilityThatOpponentBetsWhenYouCheck;
    currentState.checkCall = newStateFromServer.checkCall;
    currentState.opponentsTurnBetSize = newStateFromServer.opponentsTurnBetSize;
    currentState.percentageOfPotWonAfterCheckCall = newStateFromServer.percentageOfPotWonAfterCheckCall;
    currentState.percentageOfPotWonAfterTurnChecksThrough = newStateFromServer.percentageOfPotWonAfterTurnChecksThrough;
  }
});

/***/ }),

/***/ "yX2o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_table_vue__ = __webpack_require__("WjAE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34c09d34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_bet_cbet_explorer_table_vue__ = __webpack_require__("diNs");
function injectStyle (ssrContext) {
  __webpack_require__("Uqw6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34c09d34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_three_bet_cbet_explorer_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34c09d34_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_three_bet_cbet_explorer_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yYoB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors && _vm.errors.length > 0)?_c('section',{staticClass:"alert alert-danger"},[_c('button',{staticClass:"close",on:{"click":function($event){return _vm.$emit('clear')}}},[_c('span',[_vm._v("×")])]),_vm._v(" "),(_vm.errors.length === 1)?_c('p',[_c('strong',[_vm._v("Error: ")]),_vm._v(" "+_vm._s(_vm.errors[0])+"\n  ")]):_c('section',[_c('p',[_vm._v("Errors:")]),_vm._v(" "),_c('ul',_vm._l((_vm.errors),function(error){return _c('li',[_vm._v("\n        "+_vm._s(error)+"\n      ")])}),0)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ya+z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__ = __webpack_require__("0qOH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);






var GeneralHand = function () {
  function GeneralHand(generalHandString) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, GeneralHand);

    this.string = generalHandString;
    this.rankOne = generalHandString[0];
    this.rankTwo = generalHandString[1];
    this.displayString = this._getDisplayString();
    this.suitedOffsuitOrPair = this._getSuitedOffsuitOrPair();
    this.specificHands = this._getSpecificHands();
    this.matchesFiveCardHandHover = false;
    this.equity = null; // for equity matrix
    this.color = null; // for range constructor
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(GeneralHand, [{
    key: '_getDisplayString',


    // constructor helpers
    value: function _getDisplayString() {
      var displayString = this.rankOne.toUpperCase() + this.rankTwo.toUpperCase();

      if (this.string[2]) {
        displayString += this.string[2];
      }

      return displayString;
    }
  }, {
    key: '_getSuitedOffsuitOrPair',
    value: function _getSuitedOffsuitOrPair() {
      if (this.string[2] === 's') {
        return 'suited';
      } else if (this.string[2] === 'o') {
        return 'offsuit';
      } else {
        return 'pair';
      }
    }
  }, {
    key: '_getSpecificHands',
    value: function _getSpecificHands(generalHandString) {
      if (this.suitedOffsuitOrPair === 'suited') {
        return this.__getSpecificSuitedHands();
      } else if (this.suitedOffsuitOrPair === 'offsuit') {
        return this.__getSpecificOffsuitHands();
      } else if (this.suitedOffsuitOrPair === 'pair') {
        return this.__getSpecificPairHands();
      }
    }
  }, {
    key: '__getSpecificSuitedHands',
    value: function __getSpecificSuitedHands() {
      var specificSuitedHands = {
        cc: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'c' + this.rankTwo + 'c'),
        ss: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 's' + this.rankTwo + 's'),
        hh: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'h' + this.rankTwo + 'h'),
        dd: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'd' + this.rankTwo + 'd')
      };

      specificSuitedHands.cc.generalHand = this;
      specificSuitedHands.ss.generalHand = this;
      specificSuitedHands.hh.generalHand = this;
      specificSuitedHands.dd.generalHand = this;

      return specificSuitedHands;
    }
  }, {
    key: '__getSpecificOffsuitHands',
    value: function __getSpecificOffsuitHands() {
      var specificOffsuitHands = {
        cs: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'c' + this.rankTwo + 's'),
        ch: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'c' + this.rankTwo + 'h'),
        cd: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'c' + this.rankTwo + 'd'),
        sc: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 's' + this.rankTwo + 'c'),
        sh: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 's' + this.rankTwo + 'h'),
        sd: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 's' + this.rankTwo + 'd'),
        hc: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'h' + this.rankTwo + 'c'),
        hs: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'h' + this.rankTwo + 's'),
        hd: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'h' + this.rankTwo + 'd'),
        dc: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'd' + this.rankTwo + 'c'),
        ds: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'd' + this.rankTwo + 's'),
        dh: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'd' + this.rankTwo + 'h')
      };

      specificOffsuitHands.cs.generalHand = this;
      specificOffsuitHands.ch.generalHand = this;
      specificOffsuitHands.cd.generalHand = this;
      specificOffsuitHands.sc.generalHand = this;
      specificOffsuitHands.sh.generalHand = this;
      specificOffsuitHands.sd.generalHand = this;
      specificOffsuitHands.hc.generalHand = this;
      specificOffsuitHands.hs.generalHand = this;
      specificOffsuitHands.hd.generalHand = this;
      specificOffsuitHands.dc.generalHand = this;
      specificOffsuitHands.ds.generalHand = this;
      specificOffsuitHands.dh.generalHand = this;

      return specificOffsuitHands;
    }
  }, {
    key: '__getSpecificPairHands',
    value: function __getSpecificPairHands() {
      var specificPairHands = {
        cs: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'c' + this.rankTwo + 's'),
        ch: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'c' + this.rankTwo + 'h'),
        cd: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'c' + this.rankTwo + 'd'),
        sh: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 's' + this.rankTwo + 'h'),
        sd: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 's' + this.rankTwo + 'd'),
        hd: new __WEBPACK_IMPORTED_MODULE_2__services_hands_SpecificHand_js__["a" /* default */](this.rankOne + 'h' + this.rankTwo + 'd')
      };

      specificPairHands.cs.generalHand = this;
      specificPairHands.ch.generalHand = this;
      specificPairHands.cd.generalHand = this;
      specificPairHands.sh.generalHand = this;
      specificPairHands.sd.generalHand = this;
      specificPairHands.hd.generalHand = this;

      return specificPairHands;
    }
  }, {
    key: 'forEachSpecificHand',


    // iterators
    value: function forEachSpecificHand(cb, thisValue) {
      var returnValueOfCurrIteration = void 0;

      for (var specificHandSuits in this.specificHands) {
        returnValueOfCurrIteration = cb.call(thisValue, this.specificHands[specificHandSuits], specificHandSuits);

        if (returnValueOfCurrIteration === 'break') {
          break;
        }
      }
    }
  }, {
    key: 'forEachPossibleSpecificHand',
    value: function forEachPossibleSpecificHand(cb, thisValue) {
      this.forEachSpecificHand(function (specificHand, specificHandSuits) {
        if (specificHand.possible) {
          return cb.call(thisValue, specificHand, specificHandSuits);
        }
      });
    }
  }, {
    key: 'forEachSpecificHandInRange',
    value: function forEachSpecificHandInRange(cb, thisValue) {
      this.forEachSpecificHand(function (specificHand) {
        if (specificHand.possible && specificHand.inRange) {
          return cb.call(thisValue, specificHand);
        }
      });
    }

    // other

  }, {
    key: 'getSpecificHandStringsToSelect',
    value: function getSpecificHandStringsToSelect(combosToAdd) {
      var specificHandStringsToSelect = [];

      this.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.availableToSelect(combosToAdd)) {
          specificHandStringsToSelect.push(specificHand.string);
        }
      });

      return specificHandStringsToSelect;
    }
  }, {
    key: 'highlightIfMatchesSpecificHandStringList',
    value: function highlightIfMatchesSpecificHandStringList(specificHandStrings) {
      var matchesSpecificHandStringList = this._getWhetherMatchesSpecificHandStringsList(specificHandStrings);

      if (matchesSpecificHandStringList) {
        this.matchesFiveCardHandHover = true;
      }
    }
  }, {
    key: '_getWhetherMatchesSpecificHandStringsList',
    value: function _getWhetherMatchesSpecificHandStringsList(specificHandStrings) {
      var matchesSpecificHandStringList = false;

      this.forEachSpecificHand(function (specificHand) {
        if (specificHandStrings.includes(specificHand.string)) {
          matchesSpecificHandStringList = true;
          return 'break';
        }
      });

      return matchesSpecificHandStringList;
    }
  }, {
    key: 'possible',


    // getters
    get: function get() {
      var possible = false;

      this.forEachSpecificHand(function (specificHand) {
        if (specificHand.possible) {
          possible = true;
        }
      });

      return possible;
    }
  }, {
    key: 'numPossibleSpecificHands',
    get: function get() {
      var numPossibleSpecificHands = 0;

      this.forEachSpecificHand(function (specificHand) {
        if (specificHand.possible) {
          numPossibleSpecificHands++;
        }
      });

      return numPossibleSpecificHands;
    }
  }, {
    key: 'numPossibleSpecificHandsFromSuitedOffsuitOrPair',
    get: function get() {
      if (this.suitedOffsuitOrPair === 'suited') {
        return 4;
      } else if (this.suitedOffsuitOrPair === 'offsuit') {
        return 12;
      } else if (this.suitedOffsuitOrPair === 'pair') {
        return 6;
      }
    }
  }, {
    key: 'inRange',
    get: function get() {
      if (this.numSpecificHandsInRange === 0) {
        return false;
      } else if (this.numSpecificHandsInRange < this.numPossibleSpecificHands) {
        return 'partial';
      } else if (this.numSpecificHandsInRange === this.numPossibleSpecificHands) {
        return true;
      } else {
        throw new Error('Problem determining whether general hand is in range.');
      }
    }
  }, {
    key: 'numSpecificHandsInRange',
    get: function get() {
      var numSpecificHandsInRange = 0;

      this.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.inRange) {
          numSpecificHandsInRange++;
        }
      });

      return numSpecificHandsInRange;
    }
  }, {
    key: 'exactWeight',
    get: function get() {
      var uniqueWeightsOfSpecificHandsInRange = [];

      this.forEachSpecificHandInRange(function (specificHand) {
        if (!uniqueWeightsOfSpecificHandsInRange.includes(specificHand.weight)) {
          uniqueWeightsOfSpecificHandsInRange.push(specificHand.weight);
        }
      });

      if (uniqueWeightsOfSpecificHandsInRange.length === 1) {
        return uniqueWeightsOfSpecificHandsInRange[0];
      } else {
        return null;
      }
    }
  }, {
    key: 'averageWeight',
    get: function get() {
      var weightsOfSpecificHandsInRange = [];
      var averageWeight = void 0;

      if (this.numSpecificHandsInRange === 0) {
        throw new Error('Trying to get the average weight of a general hand that has no specific hands in range.');
      }

      this.forEachSpecificHandInRange(function (specificHand) {
        weightsOfSpecificHandsInRange.push(specificHand.weight);
      });

      averageWeight = __WEBPACK_IMPORTED_MODULE_4_lodash___default.a.mean(weightsOfSpecificHandsInRange).roundToNearestFive();

      return averageWeight;
    }
  }, {
    key: 'maxPossibleWeight',
    get: function get() {
      if (this.numPossibleSpecificHands === 0) {
        return 0;
      }

      var maxPossibleWeight = 100;

      this.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.maxPossibleWeight < maxPossibleWeight) {
          maxPossibleWeight = specificHand.maxPossibleWeight;
        }
      });

      return maxPossibleWeight;
    },


    // setters
    set: function set(value) {
      this.forEachSpecificHand(function (specificHand) {
        specificHand.maxPossibleWeight = value;
      });
    }
  }, {
    key: 'manuallySet',
    get: function get() {
      if (this.numSpecificHandsManuallySet === 0) {
        return false;
      } else if (this.numSpecificHandsManuallySet < this.numPossibleSpecificHands) {
        return 'partial';
      } else if (this.numSpecificHandsManuallySet === this.numPossibleSpecificHands) {
        return true;
      } else {
        throw new Error('Problem determining whether general hand is manually set.');
      }
    }
  }, {
    key: 'manuallyAdded',
    get: function get() {
      if (this.numSpecificHandsManuallyAdded === 0) {
        return false;
      } else if (this.numSpecificHandsManuallyAdded < this.numPossibleSpecificHands) {
        return 'partial';
      } else if (this.numSpecificHandsManuallyAdded === this.numPossibleSpecificHands) {
        return true;
      } else {
        throw new Error('Problem determining whether general hand is manually added.');
      }
    }
  }, {
    key: 'manuallyRemoved',
    get: function get() {
      if (this.numSpecificHandsManuallyRemoved === 0) {
        return false;
      } else if (this.numSpecificHandsManuallyRemoved < this.numPossibleSpecificHands) {
        return 'partial';
      } else if (this.numSpecificHandsManuallyRemoved === this.numPossibleSpecificHands) {
        return true;
      } else {
        throw new Error('Problem determining whether general hand is manually removed.');
      }
    }
  }, {
    key: 'numSpecificHandsManuallySet',
    get: function get() {
      var numSpecificHandsManuallySet = 0;

      this.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.manuallySet) {
          numSpecificHandsManuallySet++;
        }
      });

      return numSpecificHandsManuallySet;
    }
  }, {
    key: 'numSpecificHandsManuallyAdded',
    get: function get() {
      var numSpecificHandsManuallyAdded = 0;

      this.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.manuallyAdded) {
          numSpecificHandsManuallyAdded++;
        }
      });

      return numSpecificHandsManuallyAdded;
    }
  }, {
    key: 'numSpecificHandsManuallyRemoved',
    get: function get() {
      var numSpecificHandsManuallyRemoved = 0;

      this.forEachPossibleSpecificHand(function (specificHand) {
        if (specificHand.manuallyRemoved) {
          numSpecificHandsManuallyRemoved++;
        }
      });

      return numSpecificHandsManuallyRemoved;
    }
  }, {
    key: 'spaceBetweenRanks',
    get: function get() {
      return __WEBPACK_IMPORTED_MODULE_3__services_utilities_utilities__["a" /* default */].ranks.getSpaceBetweenRanks([this.rankOne, this.rankTwo]);
    }
  }, {
    key: 'weight',
    set: function set(newWeight) {
      this.forEachSpecificHand(function (specificHand) {
        specificHand.weight = newWeight;
      });
    }
  }]);

  return GeneralHand;
}();

/* harmony default export */ __webpack_exports__["a"] = (GeneralHand);
;

/***/ }),

/***/ "ycsu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"included-selectors-settings settings"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.slider),expression:"slider"}],attrs:{"type":"radio","value":"log double"},domProps:{"checked":_vm._q(_vm.slider,"log double")},on:{"change":function($event){_vm.slider="log double"}}}),_vm._v("\n          Log slider\n          "),_c('img',{attrs:{"src":"/static/settings/included-selectors/log-double-slider-selector.png"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.slider),expression:"slider"}],attrs:{"type":"radio","value":"double"},domProps:{"checked":_vm._q(_vm.slider,"double")},on:{"change":function($event){_vm.slider="double"}}}),_vm._v("\n          Double slider\n          "),_c('img',{attrs:{"src":"/static/settings/included-selectors/double-slider-selector.png"}})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"radio"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.slider),expression:"slider"}],attrs:{"type":"radio","value":"single"},domProps:{"checked":_vm._q(_vm.slider,"single")},on:{"change":function($event){_vm.slider="single"}}}),_vm._v("\n          Single slider\n          "),_c('img',{attrs:{"src":"/static/settings/included-selectors/single-slider-selector.png"}})])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.save()}}},[_vm._v("Save")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('h1',{staticClass:"page-header"},[_vm._v("Included selectors")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ygTN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ytjU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'table-cell',
  props: ['profitable']
});

/***/ }),

/***/ "z+K9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"grid-square-weight-bar",style:('width: ' + _vm.width + 'px')})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z1rl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ppt-modal',{staticClass:"grid-square-modal"},[_c('header',{attrs:{"slot":"header"},slot:"header"},[_c('button',{staticClass:"close",attrs:{"data-dismiss":"modal"}},[_c('span',[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v(_vm._s(_vm.generalHand.displayString))])]),_vm._v(" "),_c('section',{attrs:{"slot":"body"},slot:"body"},[_c('table',{staticClass:"specific-hands-grid"},_vm._l((_vm.specificHandsGrid),function(row){return _c('tr',_vm._l((row),function(specificHand){return _c('td',{class:{
            'specific-hand-in-range': specificHand && specificHand.possible && specificHand.inRange,
            'specific-hand-possible': specificHand && specificHand.possible,
          },on:{"click":function($event){return _vm.toggleSpecificHandInRange(specificHand)}}},[(specificHand && specificHand.possible)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.getHTMLForSuitIcons(specificHand.combo))}}):_vm._e(),_vm._v(" "),(specificHand && specificHand.possible)?_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":specificHand.inRange}}):_vm._e()])}),0)}),0),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.generalHand.maxPossibleWeight < 100)?_c('p',{staticClass:"text-muted"},[_vm._v("\n      Note: One or more combos have a max possible weight because of the weights given to these combos in the previous streets range. See "),_c('a',{attrs:{"href":"https://redchippoker.com/laws-hand-reading/"}},[_vm._v("the first law of hand reading")]),_vm._v(".\n    ")]):_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-hover specific-hands-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Combo")]),_vm._v(" "),_c('th',[_vm._v("In range")]),_vm._v(" "),_c('th',[_vm._v("Weight")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.generalHand.specificHands),function(specificHand,key,index){return (index === 0)?_c('tr',{key:'average-specific-hand-row-' + specificHand.string},[_c('td',[_vm._v("Average")]),_vm._v(" "),_c('td',[_vm._v("-")]),_vm._v(" "),_c('td',[(_vm.generalHand.possible && _vm.generalHand.inRange && _vm.generalHand.averageWeight > _vm.generalHand.maxPossibleWeight)?_c('div',[_c('p',[_vm._v("Average weight: "+_vm._s(_vm.generalHand.averageWeight))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_vm._v("Set the weight of all combos:")]),_vm._v(" "),_c('vue-slider',_vm._b({ref:"slider",refInFor:true,style:('width: ' + _vm.generalHand.maxPossibleWeight + '%'),attrs:{"value":_vm.generalHand.averageWeight,"max":_vm.generalHand.maxPossibleWeight},on:{"callback":function($event){return _vm.$emit('applyExactWeightToGeneralHand', { newWeight: $event, generalHandString: _vm.generalHand.string })}}},'vue-slider',_vm.sliderOptions,false))],1):(_vm.generalHand.possible && _vm.generalHand.inRange && _vm.generalHand.averageWeight <= _vm.generalHand.maxPossibleWeight)?_c('vue-slider',_vm._b({ref:"slider",refInFor:true,style:('width: ' + _vm.generalHand.maxPossibleWeight + '%'),attrs:{"value":_vm.generalHand.averageWeight,"max":_vm.generalHand.maxPossibleWeight},on:{"callback":function($event){return _vm.$emit('applyExactWeightToGeneralHand', { newWeight: $event, generalHandString: _vm.generalHand.string })}}},'vue-slider',_vm.sliderOptions,false)):_vm._e()],1)]):_vm._e()}),_vm._v(" "),_vm._l((_vm.generalHand.specificHands),function(specificHand){return (specificHand.possible)?_c('tr',{key:specificHand.string},[_c('td',{domProps:{"innerHTML":_vm._s(_vm.getHTMLForSuitIcons(specificHand.combo))}}),_vm._v(" "),_c('td',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":specificHand.inRange},on:{"change":function($event){return _vm.toggleSpecificHandInRange(specificHand)}}})]),_vm._v(" "),_c('td',[(specificHand.inRange)?_c('vue-slider',_vm._b({ref:"slider",refInFor:true,style:('width: ' + specificHand.maxPossibleWeight + '%'),attrs:{"value":specificHand.weight,"max":specificHand.maxPossibleWeight},on:{"callback":function($event){return _vm.$emit('setWeightOfSpecificHand', { newWeight: $event, specificHandString: specificHand.string })}}},'vue-slider',_vm.sliderOptions,false)):_vm._e()],1)]):_vm._e()})],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z2cd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"should-you-call-turn-steps"},[_c('div',[_c('h4',[_vm._v("Step "+_vm._s(5 + (_vm.state.players.numPlayers * 2))+": What is the turn card?")]),_vm._v(" "),_c('turn-selector',{attrs:{"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}}})],1),_vm._v(" "),(_vm.state.streetToCall === 'turn' && _vm.state.presetCommunityCards.turnSet)?_c('section',[_c('pot-odds-selector',{attrs:{"numOpponents":_vm.state.players.numPlayers,"streetToCall":_vm.state.streetToCall,"potOdds":_vm.state.potOdds,"authorized":_vm.authorized},on:{"setPotOdds":function($event){return _vm.$emit('setPotOdds', $event)}}})],1):_vm._e(),_vm._v(" "),(_vm.state.presetCommunityCards.turnSet)?_c('div',_vm._l((_vm.state.players._players),function(player,playerIndex){return _c('set-range-step',{key:player.id,attrs:{"textForStep":_vm.getTextForPlayerRangeStep(playerIndex),"player":player,"playerIndex":playerIndex,"playerStateIndex":2,"presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"textWhenFiveCardHandPercentagesArentUpToDate":_vm.textWhenFiveCardHandPercentagesArentUpToDate,"storeModuleName":'guidedAnalysesCalling',"authorized":_vm.authorized}},[(_vm.state.streetToCall === 'turn')?_c('turn-selector',{attrs:{"slot":"boardCardsSelector","presetCommunityCards":_vm.state.presetCommunityCards,"presetHoleCards":_vm.state.presetHoleCards,"disabled":!_vm.authorized},on:{"setIndividualPresetCommunityCard":function($event){return _vm.$emit('setIndividualPresetCommunityCard', $event)},"removePresetCommunityCard":function($event){return _vm.$emit('removePresetCommunityCard', $event)}},slot:"boardCardsSelector"}):_vm._e(),_vm._v(" "),_c('range-help-section',{attrs:{"slot":"rangeHelpSection","playerStateIndex":2,"streetToCall":_vm.state.streetToCall},slot:"rangeHelpSection"})],1)}),1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z4Oz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_summary_of_pokers_one_percent_vue__ = __webpack_require__("m62S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7afd3de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_summary_of_pokers_one_percent_vue__ = __webpack_require__("fVjW");
function injectStyle (ssrContext) {
  __webpack_require__("wgL0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a7afd3de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_summary_of_pokers_one_percent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7afd3de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_summary_of_pokers_one_percent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z7HJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "z7qe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_hit_calculator_five_card_hands_section_insights_header_cell__ = __webpack_require__("GjlZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_hit_calculator_five_card_hands_section_insights_table_cell__ = __webpack_require__("8/zq");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'equity-calculator-insights',
  components: {
    'header-cell': __WEBPACK_IMPORTED_MODULE_0__components_hit_calculator_five_card_hands_section_insights_header_cell__["a" /* default */],
    'table-cell': __WEBPACK_IMPORTED_MODULE_1__components_hit_calculator_five_card_hands_section_insights_table_cell__["a" /* default */]
  },
  props: ['equity', 'hasSimulationBeenRun'],
  methods: {
    isCallProfitable: function isCallProfitable(reward, risk) {
      if (!this.hasSimulationBeenRun) {
        return null;
      }

      var howOftenCallNeedsToWork = this._getHowOftenCallNeedsToWork(reward, risk);

      return this.equity > howOftenCallNeedsToWork;
    },
    _getHowOftenCallNeedsToWork: function _getHowOftenCallNeedsToWork(reward, risk) {
      return risk / (risk + reward) * 100;
    }
  }
});

/***/ }),

/***/ "zFKT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fold_equity_table_vue__ = __webpack_require__("pEaa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05de7355_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fold_equity_table_vue__ = __webpack_require__("1WQg");
function injectStyle (ssrContext) {
  __webpack_require__("4678")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-05de7355"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_fold_equity_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05de7355_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_fold_equity_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zIRu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-slider',_vm._b({ref:"vueSlider",staticClass:"horizontal-set-weight-to-apply-to-added-hands-basic",attrs:{"disabled":_vm.disabled},on:{"callback":function($event){return _vm.$emit('setWeightToApplyToAddedHands', _vm.weightToApplyToAddedHandsVModel)}},scopedSlots:_vm._u([{key:"tooltip",fn:function(ref){
var value = ref.value;
return _c('div',{staticClass:"vue-slider-tooltip"},[_vm._v("\n    Weight to apply to"),_c('br'),_vm._v("added hands: "),_c('strong',[_vm._v(_vm._s(value))])])}}]),model:{value:(_vm.weightToApplyToAddedHandsVModel),callback:function ($$v) {_vm.weightToApplyToAddedHandsVModel=$$v},expression:"weightToApplyToAddedHandsVModel"}},'vue-slider',_vm.sliderOptions,false))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zKTs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__ = __webpack_require__("RBWx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hole-cards-selector',
  components: {
    'individual-card-selector': __WEBPACK_IMPORTED_MODULE_0__components_controls_card_selection_individual_card_selector__["a" /* default */]
  },
  props: ['presetHoleCards', 'presetCommunityCards', 'popoverDirectionClass', 'disabled'],
  computed: {
    presetCards: function presetCards() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.union(this.presetHoleCards.array, this.presetCommunityCards.array);
    }
  },
  methods: {
    setPresetHoleCard: function setPresetHoleCard(payload, position) {
      this.$emit('setPresetHoleCard', {
        card: payload.card,
        position: position
      });

      if (position === 'holeCardOne') {
        this.$refs.holeCardTwo.toggle();
        payload.e.stopPropagation();
      }
    }
  }
});

/***/ }),

/***/ "zMC6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_sharable_url_button_vue__ = __webpack_require__("eVwm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7030270e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_sharable_url_button_vue__ = __webpack_require__("w+g/");
function injectStyle (ssrContext) {
  __webpack_require__("LQRi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7030270e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_create_sharable_url_button_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7030270e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_create_sharable_url_button_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zMxE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_controls_vue__ = __webpack_require__("tk+N");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ad56ca2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_controls_vue__ = __webpack_require__("0VI6");
function injectStyle (ssrContext) {
  __webpack_require__("kR2u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ad56ca2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_controls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ad56ca2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_controls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zRCK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__ = __webpack_require__("UJfa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa447880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__ = __webpack_require__("hd12");
function injectStyle (ssrContext) {
  __webpack_require__("tx6D")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa447880"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_about_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa447880_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_about_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zc1B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vertical_set_weight_to_apply_to_added_hands_vue__ = __webpack_require__("obUw");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f29ad33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vertical_set_weight_to_apply_to_added_hands_vue__ = __webpack_require__("4o60");
function injectStyle (ssrContext) {
  __webpack_require__("eqfO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f29ad33"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vertical_set_weight_to_apply_to_added_hands_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f29ad33_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_vertical_set_weight_to_apply_to_added_hands_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zdHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.includedSlider === 'log double')?_c('log-double-slider-selector',{ref:"logDoubleSlider",attrs:{"percentOfHandsInRangeNumberForDisplay":_vm.percentOfHandsInRangeNumberForDisplay,"numberOfSpecificHandsInRange":_vm.numberOfSpecificHandsInRange,"numberOfPossibleSpecificHands":_vm.numberOfPossibleSpecificHands,"disabled":_vm.disabled},on:{"setRangeToMatchDoubleSlider":function($event){return _vm.$emit('setRangeToMatchDoubleSlider', $event)}}}):_vm._e(),_vm._v(" "),(_vm.includedSlider === 'double')?_c('double-slider-selector',{ref:"doubleSlider",attrs:{"percentOfHandsInRangeNumberForDisplay":_vm.percentOfHandsInRangeNumberForDisplay,"numberOfSpecificHandsInRange":_vm.numberOfSpecificHandsInRange,"numberOfPossibleSpecificHands":_vm.numberOfPossibleSpecificHands,"disabled":_vm.disabled},on:{"setRangeToMatchDoubleSlider":function($event){return _vm.$emit('setRangeToMatchDoubleSlider', $event)}}}):_vm._e(),_vm._v(" "),(_vm.includedSlider === 'single')?_c('single-slider-selector',{attrs:{"percentOfHandsInRangeNumberForDisplay":_vm.percentOfHandsInRangeNumberForDisplay,"disabled":_vm.disabled},on:{"setRangeToMatchDoubleSlider":function($event){return _vm.$emit('setRangeToMatchDoubleSlider', $event)}}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ziD+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_utilities_expand_collapse__ = __webpack_require__("jRq9");
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-with-toggle',
  props: ['title', 'expanded'],
  components: {
    'expand-collapse': __WEBPACK_IMPORTED_MODULE_0__components_utilities_expand_collapse__["a" /* default */]
  }
});

/***/ }),

/***/ "zwxf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_hands_SpecificHand__ = __webpack_require__("0qOH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_constants__ = __webpack_require__("vjYN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__ = __webpack_require__("g8te");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);





/* harmony default export */ __webpack_exports__["a"] = ({
  inRangeWithFirstRank: function inRangeWithFirstRank(generalHands, firstRank) {
    var suitedGeneralHandsInRangeWithFirstRank = this._getSuitedGeneralHandsInRangeWithFirstRank(generalHands, firstRank);
    var groupsOfConsecutiveSuitedGeneralHands = this._getGroupsOfConsecutiveSuitedGeneralHands(suitedGeneralHandsInRangeWithFirstRank);
    var textFromSuitedGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveSuitedGeneralHands(groupsOfConsecutiveSuitedGeneralHands);

    return textFromSuitedGeneralHandsWithFirstRank;
  },
  manuallyAddedWithFirstRank: function manuallyAddedWithFirstRank(generalHands, firstRank) {
    var suitedGeneralHandsManuallyAddedWithFirstRank = this._getSuitedGeneralHandsManuallyAddedWithFirstRank(generalHands, firstRank);
    var groupsOfConsecutiveSuitedGeneralHands = this._getGroupsOfConsecutiveSuitedGeneralHands(suitedGeneralHandsManuallyAddedWithFirstRank);
    var textFromSuitedGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveSuitedGeneralHands(groupsOfConsecutiveSuitedGeneralHands);

    return textFromSuitedGeneralHandsWithFirstRank;
  },
  manuallyRemovedWithFirstRank: function manuallyRemovedWithFirstRank(generalHands, firstRank) {
    var suitedGeneralHandsManuallyRemovedWithFirstRank = this._getSuitedGeneralHandsManuallyRemovedWithFirstRank(generalHands, firstRank);
    var groupsOfConsecutiveSuitedGeneralHands = this._getGroupsOfConsecutiveSuitedGeneralHands(suitedGeneralHandsManuallyRemovedWithFirstRank);
    var textFromSuitedGeneralHandsWithFirstRank = this._getTextFromGroupsOfConsecutiveSuitedGeneralHands(groupsOfConsecutiveSuitedGeneralHands);

    return textFromSuitedGeneralHandsWithFirstRank;
  },
  _getSuitedGeneralHandsInRangeWithFirstRank: function _getSuitedGeneralHandsInRangeWithFirstRank(generalHands, firstRank) {
    var listOfSuitedGeneralHandsInRangeWithFirstRank = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.suited[firstRank].forEach(function (suitedGeneralHandWithFirstRankString) {
      var suitedGeneralHandWithFirstRank = generalHands.find(suitedGeneralHandWithFirstRankString);

      if (suitedGeneralHandWithFirstRank.inRange === true) {
        listOfSuitedGeneralHandsInRangeWithFirstRank.push(suitedGeneralHandWithFirstRank);
      } else if (suitedGeneralHandWithFirstRank.inRange === 'partial') {
        suitedGeneralHandWithFirstRank.forEachSpecificHandInRange(function (specificHand) {
          listOfSuitedGeneralHandsInRangeWithFirstRank.push(specificHand);
        });
      }
    });

    return listOfSuitedGeneralHandsInRangeWithFirstRank;
  },
  _getSuitedGeneralHandsManuallyAddedWithFirstRank: function _getSuitedGeneralHandsManuallyAddedWithFirstRank(generalHands, firstRank) {
    var listOfSuitedGeneralHandsManuallyAddedWithFirstRank = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.suited[firstRank].forEach(function (suitedGeneralHandWithFirstRankString) {
      var suitedGeneralHandWithFirstRank = generalHands.find(suitedGeneralHandWithFirstRankString);

      if (suitedGeneralHandWithFirstRank.manuallyAdded === true) {
        listOfSuitedGeneralHandsManuallyAddedWithFirstRank.push(suitedGeneralHandWithFirstRank);
      } else if (suitedGeneralHandWithFirstRank.manuallyAdded === 'partial') {
        suitedGeneralHandWithFirstRank.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyAdded) {
            listOfSuitedGeneralHandsManuallyAddedWithFirstRank.push(specificHand);
          }
        });
      }
    });

    return listOfSuitedGeneralHandsManuallyAddedWithFirstRank;
  },
  _getSuitedGeneralHandsManuallyRemovedWithFirstRank: function _getSuitedGeneralHandsManuallyRemovedWithFirstRank(generalHands, firstRank) {
    var listOfSuitedGeneralHandsManuallyRemovedWithFirstRank = [];

    __WEBPACK_IMPORTED_MODULE_1__services_constants__["a" /* default */].textSelectorLists.suited[firstRank].forEach(function (suitedGeneralHandWithFirstRankString) {
      var suitedGeneralHandWithFirstRank = generalHands.find(suitedGeneralHandWithFirstRankString);

      if (suitedGeneralHandWithFirstRank.manuallyRemoved === true) {
        listOfSuitedGeneralHandsManuallyRemovedWithFirstRank.push(suitedGeneralHandWithFirstRank);
      } else if (suitedGeneralHandWithFirstRank.manuallyRemoved === 'partial') {
        suitedGeneralHandWithFirstRank.forEachPossibleSpecificHand(function (specificHand) {
          if (specificHand.manuallyRemoved) {
            listOfSuitedGeneralHandsManuallyRemovedWithFirstRank.push(specificHand);
          }
        });
      }
    });

    return listOfSuitedGeneralHandsManuallyRemovedWithFirstRank;
  },
  _getGroupsOfConsecutiveSuitedGeneralHands: function _getGroupsOfConsecutiveSuitedGeneralHands(suitedGeneralHandsInRange) {
    var groupsOfConsecutiveSuitedGeneralHands = [];
    var currGroupOfConsecutiveSuitedGeneralHands = [];

    suitedGeneralHandsInRange.forEach(function (suitedGeneralHandInRange) {
      var suitedGeneralHandInRangeIsNextInOrder = this._isSuitedGeneralHandInRangeNextInOrder(suitedGeneralHandInRange, __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(currGroupOfConsecutiveSuitedGeneralHands));

      if (currGroupOfConsecutiveSuitedGeneralHands.length === 0 || suitedGeneralHandInRangeIsNextInOrder) {
        currGroupOfConsecutiveSuitedGeneralHands.push(suitedGeneralHandInRange);
      } else {
        groupsOfConsecutiveSuitedGeneralHands.push(currGroupOfConsecutiveSuitedGeneralHands);
        currGroupOfConsecutiveSuitedGeneralHands = [];
        currGroupOfConsecutiveSuitedGeneralHands.push(suitedGeneralHandInRange);
      }
    }, this);

    if (currGroupOfConsecutiveSuitedGeneralHands.length > 0) {
      groupsOfConsecutiveSuitedGeneralHands.push(currGroupOfConsecutiveSuitedGeneralHands);
    }

    return groupsOfConsecutiveSuitedGeneralHands;
  },
  _isSuitedGeneralHandInRangeNextInOrder: function _isSuitedGeneralHandInRangeNextInOrder(currSuitedGeneralHand, previousSuitedGeneralHand) {
    if (currSuitedGeneralHand instanceof __WEBPACK_IMPORTED_MODULE_0__services_hands_SpecificHand__["a" /* default */]) {
      return false;
    }

    if (!previousSuitedGeneralHand) {
      return true;
    }

    var currSuitedGeneralHandRank = currSuitedGeneralHand.rankTwo;
    var previousSuitedGeneralHandRank = previousSuitedGeneralHand.rankTwo;

    return __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(previousSuitedGeneralHandRank) === currSuitedGeneralHandRank;
  },
  _getTextFromGroupsOfConsecutiveSuitedGeneralHands: function _getTextFromGroupsOfConsecutiveSuitedGeneralHands(groupsOfConsecutiveSuitedGeneralHands) {
    var textFromGroupsOfConsecutiveSuitedGeneralHands = '';

    groupsOfConsecutiveSuitedGeneralHands.forEach(function (groupOfConsecutiveSuitedGeneralHands) {
      textFromGroupsOfConsecutiveSuitedGeneralHands += this._getTextFromGroupOfConsecutiveSuitedGeneralHands(groupOfConsecutiveSuitedGeneralHands) + ', ';
    }, this);

    return textFromGroupsOfConsecutiveSuitedGeneralHands;
  },
  _getTextFromGroupOfConsecutiveSuitedGeneralHands: function _getTextFromGroupOfConsecutiveSuitedGeneralHands(groupOfConsecutiveSuitedGeneralHands) {
    var firstSuitedGeneralHand = groupOfConsecutiveSuitedGeneralHands[0];
    var lastSuitedGeneralHand = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.last(groupOfConsecutiveSuitedGeneralHands);
    var biggestPossibleSecondRank = __WEBPACK_IMPORTED_MODULE_2__services_utilities_utilities__["a" /* default */].ranks.getRankOneLower(firstSuitedGeneralHand.rankOne);
    var secondRankOfFirstSuitedGeneralHand = firstSuitedGeneralHand.rankTwo;
    var secondRankOfLastSuitedGeneralHand = lastSuitedGeneralHand.rankTwo;

    if (groupOfConsecutiveSuitedGeneralHands.length === 1) {
      return firstSuitedGeneralHand.string;
    } else {
      return firstSuitedGeneralHand.string + '-' + lastSuitedGeneralHand.string;
    }
  }
});

/***/ }),

/***/ "zyuQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__ = __webpack_require__("T8TE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_help_reasoning_1__ = __webpack_require__("pmmr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'should-you-call-initial-conclusion',
  components: {
    'toggle-help-button': __WEBPACK_IMPORTED_MODULE_0__components_guided_analyses_help_toggle_help_button__["a" /* default */],
    'reasoning-help-section-1': __WEBPACK_IMPORTED_MODULE_1__components_guided_analyses_should_you_call_help_reasoning_1__["a" /* default */]
  },
  props: ['potOdds', 'equity', 'streetToCall', 'breakevenPercentageViaPotOdds'],
  data: function data() {
    return {
      helpAreaVisible: {
        reasoning: [false, false]
      }
    };
  },
  computed: {
    isCallProfitableBasedOnPotOdds: function isCallProfitableBasedOnPotOdds() {
      return this.equity > this.breakevenPercentageViaPotOdds;
    }
  },
  methods: {
    toggleHelp: function toggleHelp(type, index) {
      if (type === 'reasoning') {
        this.helpAreaVisible.reasoning[index] = !this.helpAreaVisible.reasoning[index];
      }

      this.$forceUpdate();
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.0997a72779921f20b11b.js